/* DO NOT EDIT THIS FILE!!!! This file is auto generated by npm run graphql:types */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: number; output: number };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: { input: string; output: string };
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: { input: string; output: string };
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: { input: any; output: any };
  /** Custom scalar that accepts either an Int or a String */
  IntOrString: { input: any; output: any };
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: { input: any; output: any };
  /**
   * Leverages the internal Python implementation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  UUID: { input: string; output: string };
};

export type AcceptInvitationMutation = {
  readonly __typename: "AcceptInvitationMutation";
  readonly invitation?: Maybe<InvitationNode>;
  readonly user?: Maybe<UserNode>;
};

/** An enumeration. */
export enum AccountToOrganizationMembershipStatus {
  Active = "active",
  Inactive = "inactive",
}

export type ActionItemArtifactNode = ArtifactInterface & {
  readonly __typename: "ActionItemArtifactNode";
  readonly actionItemState?: Maybe<Scalars["Int"]["output"]>;
  readonly activities: ArtifactActivityNodeConnection;
  readonly artifactType: ArtifactType;
  readonly assignableUsers?: Maybe<UserNodeConnection>;
  readonly assignee?: Maybe<UserNode>;
  readonly canDelete: PermissionNode;
  readonly canRead: PermissionNode;
  readonly canUpdate: PermissionNode;
  readonly commentCount?: Maybe<Scalars["Int"]["output"]>;
  readonly comments?: Maybe<CommentNodeConnection>;
  readonly completedAt?: Maybe<Scalars["DateTime"]["output"]>;
  readonly created: Scalars["DateTime"]["output"];
  readonly createdInMeeting?: Maybe<MeetingNode>;
  readonly creator?: Maybe<UserNode>;
  readonly description?: Maybe<Scalars["JSONString"]["output"]>;
  readonly dueDate?: Maybe<Scalars["Date"]["output"]>;
  readonly eventChannelName?: Maybe<Scalars["String"]["output"]>;
  readonly id: Scalars["Int"]["output"];
  readonly isComplete?: Maybe<Scalars["Boolean"]["output"]>;
  readonly isStale: Scalars["Boolean"]["output"];
  readonly organization?: Maybe<OrganizationNode>;
  readonly progress: Scalars["Float"]["output"];
  readonly relatedArtifacts?: Maybe<ArtifactToArtifactConnection>;
  readonly title?: Maybe<Scalars["String"]["output"]>;
  readonly topics?: Maybe<ArtifactToTopicConnection>;
  readonly updated?: Maybe<Scalars["DateTime"]["output"]>;
  readonly uuid?: Maybe<Scalars["String"]["output"]>;
  readonly websocketToken?: Maybe<Scalars["String"]["output"]>;
};

export type ActionItemArtifactNodeActivitiesArgs = {
  activityType?: InputMaybe<ArtifactActivityType>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ActionItemArtifactNodeAssignableUsersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type ActionItemArtifactNodeCommentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  artifactId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  isInlineComment?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  textUuid?: InputMaybe<Scalars["String"]["input"]>;
  topicId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ActionItemArtifactNodeRelatedArtifactsArgs = {
  actionItemAssignedToMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignees?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  actionItemDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  actionItemProgress?: InputMaybe<Scalars["Float"]["input"]>;
  actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemStates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  ancestorsOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  artifactTypes?: InputMaybe<ReadonlyArray<InputMaybe<ArtifactType>>>;
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  asUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  assignedToMembersOfOrganizationId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  completedActionItemsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedActionItemsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  createdByIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  createdInMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackSenders?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackState?: InputMaybe<FeedbackState>;
  feedbackStates?: InputMaybe<ReadonlyArray<InputMaybe<FeedbackState>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  goalCompetencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalContributors?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalInvolvingUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalParentIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalResponsibilityIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalScope?: InputMaybe<GoalScope>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalState?: InputMaybe<GoalState>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalStatus?: InputMaybe<GoalStatus>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalVisibility?: InputMaybe<GoalVisibility>;
  goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  groupBy?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  isStale?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValue?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionReceivedByMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ActionItemArtifactNodeTopicsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assignee?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasActionItems?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasArtifacts?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDecisions?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDocuments?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasGoals?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInFlowId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInMeetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<TopicState>;
  titleContains?: InputMaybe<Scalars["String"]["input"]>;
  topicIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type ActionItemState = {
  readonly __typename: "ActionItemState";
  readonly isComplete: Scalars["Boolean"]["output"];
  readonly isDefaultIncomplete: Scalars["Boolean"]["output"];
  readonly label: Scalars["String"]["output"];
  readonly value: Scalars["Int"]["output"];
};

/** An enumeration. */
export enum ActionLabel {
  KeepDoing = "keep_doing",
  ManagerAction = "manager_action",
  OpenNextMeetingWith = "open_next_meeting_with",
  SuggestedDiscussionTopic = "suggested_discussion_topic",
}

/** An enumeration. */
export enum ActionVariant {
  Default = "default",
  Green = "green",
}

export type AddBotToMeetingMutation = {
  readonly __typename: "AddBotToMeetingMutation";
  readonly meeting?: Maybe<MeetingNode>;
};

export type AddFavouriteArtifact = {
  readonly __typename: "AddFavouriteArtifact";
  readonly artifact?: Maybe<ArtifactInterface>;
  readonly user?: Maybe<UserNode>;
};

export type AddPreviousMeetingTopicsToCurrentMeetingMutation = {
  readonly __typename: "AddPreviousMeetingTopicsToCurrentMeetingMutation";
  readonly meeting?: Maybe<MeetingNode>;
};

export type AddTeamMemberMutation = {
  readonly __typename: "AddTeamMemberMutation";
  readonly team?: Maybe<TeamNode>;
  readonly user?: Maybe<UserNode>;
};

export type AddTemplateToMeetingMutation = {
  readonly __typename: "AddTemplateToMeetingMutation";
  readonly meeting?: Maybe<MeetingNode>;
  readonly meetingGroup?: Maybe<MeetingGroupNode>;
  readonly topicTemplate?: Maybe<TopicTemplateNode>;
};

export type AdditionalArtifactInput = {
  /** Set the state of an action item */
  readonly actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  /** The id of the assignee for an action item or goal artifact */
  readonly assigneeId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Children of the current goal */
  readonly childGoalIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  readonly competencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<RoleCompetencyInput>>
  >;
  readonly contributorIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  /** The current value of a goal */
  readonly currentValue?: InputMaybe<Scalars["Float"]["input"]>;
  /** The decision for a decision artifact */
  readonly decision?: InputMaybe<Scalars["String"]["input"]>;
  readonly decisionState?: InputMaybe<DecisionState>;
  readonly documentVisibility?: InputMaybe<DocumentVisibility>;
  /** The due date for an action item, goal artifact or asana task */
  readonly dueDate?: InputMaybe<Scalars["Date"]["input"]>;
  readonly feedbackAdminsCanView?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly feedbackCreatorCanView?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly feedbackMessage?: InputMaybe<Scalars["JSONString"]["input"]>;
  readonly feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  readonly feedbackRecipientsCanView?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly feedbackRecipientsManagersCanView?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** The id of the user will be providing the feedback */
  readonly feedbackSenderId?: InputMaybe<Scalars["Int"]["input"]>;
  readonly feedbackState?: InputMaybe<FeedbackState>;
  readonly goalKpiId?: InputMaybe<Scalars["Int"]["input"]>;
  readonly goalScope?: InputMaybe<GoalScope>;
  /** The status of a goal */
  readonly goalStatus?: InputMaybe<GoalStatus>;
  readonly goalVisibility?: InputMaybe<GoalVisibility>;
  /** Can only be used when creating a new goal */
  readonly keyResults?: InputMaybe<ReadonlyArray<InputMaybe<KeyResultInput>>>;
  /** Will use the latest measurement of the given KPI */
  readonly kpiId?: InputMaybe<Scalars["Int"]["input"]>;
  /** The id of the KPI measurement to display */
  readonly kpiMeasurementId?: InputMaybe<Scalars["Int"]["input"]>;
  readonly ownerIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  /** The id of a parent goal for this goal */
  readonly parentGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Set the progress of an action item or asana task */
  readonly progress?: InputMaybe<Scalars["Float"]["input"]>;
  readonly progressType?: InputMaybe<GoalProgressType>;
  /** The rating that is being collected for a rating artifact */
  readonly ratingId?: InputMaybe<Scalars["Int"]["input"]>;
  /** The id of the core value to be used for the recognition */
  readonly recognitionCoreValueId?: InputMaybe<Scalars["Int"]["input"]>;
  readonly recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  readonly recognitionVisibility?: InputMaybe<RecognitionVisibility>;
  /** The query string for a github issues artifact */
  readonly searchQuery?: InputMaybe<Scalars["String"]["input"]>;
  /** The start date for a goal */
  readonly startDate?: InputMaybe<Scalars["Date"]["input"]>;
  /** The start value of a goal */
  readonly startValue?: InputMaybe<Scalars["Float"]["input"]>;
  readonly state?: InputMaybe<GoalState>;
  /** The target value of a goal */
  readonly targetValue?: InputMaybe<Scalars["Float"]["input"]>;
  readonly teamIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  /** The URL of an Asana task */
  readonly url?: InputMaybe<Scalars["String"]["input"]>;
};

/** An enumeration. */
export enum AdoptionReportAttribute {
  Email = "email",
  LastSeen = "last_seen",
  ManagerEmail = "manager_email",
  ManagerName = "manager_name",
  Name = "name",
}

/** An enumeration. */
export enum AdoptionReportMetric {
  ActionItemsCreated = "action_items_created",
  AssessmentsAsTarget = "assessments_as_target",
  CareerGoalUpdates = "career_goal_updates",
  GoalUpdates = "goal_updates",
  GoalsCreated = "goals_created",
  OneononeMeetingsAsManager = "oneonone_meetings_as_manager",
  OneononeMeetingsAsParticipant = "oneonone_meetings_as_participant",
  RecognitionsGiven = "recognitions_given",
  RecognitionsReceived = "recognitions_received",
}

export type AlignGoalMutation = {
  readonly __typename: "AlignGoalMutation";
  readonly goal?: Maybe<ArtifactInterface>;
  readonly previousParentGoal?: Maybe<ArtifactInterface>;
};

export type AnswerCitationConnection = {
  readonly __typename: "AnswerCitationConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AnswerCitationEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `AnswerCitation` and its cursor. */
export type AnswerCitationEdge = {
  readonly __typename: "AnswerCitationEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<AnswerCitationNode>;
};

export type AnswerCitationNode = {
  readonly __typename: "AnswerCitationNode";
  readonly assessment?: Maybe<AssessmentNode>;
  readonly contextText?: Maybe<Scalars["String"]["output"]>;
  readonly date?: Maybe<Scalars["String"]["output"]>;
  readonly meeting?: Maybe<MeetingNode>;
  readonly sourceId: Scalars["String"]["output"];
  /** The service that provides this source. Such as topicflow, linear, merge_github, etc. */
  readonly sourceProvider: Scalars["String"]["output"];
  readonly sourceType: Scalars["String"]["output"];
  readonly title: Scalars["String"]["output"];
  readonly url: Scalars["String"]["output"];
};

export type ArchiveSkillMutation = {
  readonly __typename: "ArchiveSkillMutation";
  readonly skill?: Maybe<SkillNode>;
};

export type ArtifactActivityNode = DjangoNode &
  Node & {
    readonly __typename: "ArtifactActivityNode";
    readonly activityType: ArtifactActivityType;
    readonly actor?: Maybe<UserNode>;
    readonly artifact?: Maybe<ArtifactInterface>;
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly changedFields?: Maybe<
      ReadonlyArray<Maybe<ArtifactChangedFieldNode>>
    >;
    readonly created: Scalars["DateTime"]["output"];
    readonly id: Scalars["ID"]["output"];
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
  };

export type ArtifactActivityNodeConnection = {
  readonly __typename: "ArtifactActivityNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ArtifactActivityNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `ArtifactActivityNode` and its cursor. */
export type ArtifactActivityNodeEdge = {
  readonly __typename: "ArtifactActivityNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<ArtifactActivityNode>;
};

/** An enumeration. */
export enum ArtifactActivityType {
  ArtifactCreation = "artifact_creation",
  ArtifactUpdate = "artifact_update",
  CommentAdded = "comment_added",
  CompetencyConnected = "competency_connected",
  CompetencyDisconnected = "competency_disconnected",
  GoalCheckin = "goal_checkin",
  KeyResultAdded = "key_result_added",
  KeyResultRemoved = "key_result_removed",
  KeyResultUpdated = "key_result_updated",
  ReferencedFromArtifact = "referenced_from_artifact",
  ReferencedFromTopic = "referenced_from_topic",
}

export type ArtifactChangedFieldNode = {
  readonly __typename: "ArtifactChangedFieldNode";
  readonly changedFields?: Maybe<
    ReadonlyArray<Maybe<ArtifactChangedFieldNode>>
  >;
  readonly fieldName?: Maybe<Scalars["String"]["output"]>;
  readonly newValue?: Maybe<Scalars["String"]["output"]>;
  readonly newValueObject?: Maybe<ChangedFieldRelatedObjectUnion>;
  readonly previousValue?: Maybe<Scalars["String"]["output"]>;
  readonly previousValueObject?: Maybe<ChangedFieldRelatedObjectUnion>;
};

export type ArtifactConnection = {
  readonly __typename: "ArtifactConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ArtifactEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `Artifact` and its cursor. */
export type ArtifactEdge = {
  readonly __typename: "ArtifactEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<ArtifactInterface>;
};

export type ArtifactFilterInput = {
  readonly actionItemAssignedToMembersOfTeam?: InputMaybe<
    Scalars["Int"]["input"]
  >;
  readonly actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  readonly actionItemAssignees?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  readonly actionItemDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  readonly actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly actionItemProgress?: InputMaybe<Scalars["Float"]["input"]>;
  readonly actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  readonly actionItemStates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  readonly ancestorsOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  readonly artifactType?: InputMaybe<ArtifactType>;
  readonly artifactTypes?: InputMaybe<ReadonlyArray<InputMaybe<ArtifactType>>>;
  /** Filter artifacts to only ones that the given user id can see */
  readonly asUser?: InputMaybe<Scalars["Int"]["input"]>;
  /** Filter artifacts to only ones that the given user id can see */
  readonly asUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  readonly assignedToMembersOfOrganizationId?: InputMaybe<
    Scalars["Int"]["input"]
  >;
  /** Expects a flow id, and will filter to only include action items completed after the end time of the last meeting in that series */
  readonly completedActionItemsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  /** Expects a meeting group id, and will filter to only include action items completed after the end time of the last meeting in that series */
  readonly completedActionItemsForMeetingGroup?: InputMaybe<
    Scalars["Int"]["input"]
  >;
  /** Expects a flow id, and will filter to only include goals completed after the end time of the previous meeting in the series, or within the last 7 days, whichever is longer */
  readonly completedGoalsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  /** Expects a meeting group id, and will filter to only include goals completed after the end time of the previous meeting in the series, or within the last 7 days, whichever is longer */
  readonly completedGoalsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  readonly createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  /** Filter artifacts created by given user id */
  readonly createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  /** Filter artifacts created by given user ids */
  readonly createdByIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  readonly createdInMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  readonly excludeIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  readonly feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  readonly feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  readonly feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  readonly feedbackSenders?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  readonly feedbackState?: InputMaybe<FeedbackState>;
  readonly feedbackStates?: InputMaybe<
    ReadonlyArray<InputMaybe<FeedbackState>>
  >;
  readonly flowId?: InputMaybe<Scalars["Int"]["input"]>;
  readonly goalCompetencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  readonly goalContributors?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  readonly goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  readonly goalInvolvingUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  readonly goalOwners?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  readonly goalParentIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  readonly goalResponsibilityIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  readonly goalScope?: InputMaybe<GoalScope>;
  readonly goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  readonly goalState?: InputMaybe<GoalState>;
  readonly goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  readonly goalStatus?: InputMaybe<GoalStatus>;
  readonly goalTeams?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  readonly goalVisibility?: InputMaybe<GoalVisibility>;
  /** Expects a number indicating within how many days the goals have been completed. */
  readonly goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  readonly groupBy?: InputMaybe<Scalars["String"]["input"]>;
  readonly ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  readonly idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  readonly inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  readonly isStale?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  readonly meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  readonly orderBy?: InputMaybe<Scalars["String"]["input"]>;
  readonly orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  readonly orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  readonly organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  readonly recognitionCoreValue?: InputMaybe<Scalars["Int"]["input"]>;
  readonly recognitionReceivedByMembersOfTeam?: InputMaybe<
    Scalars["Int"]["input"]
  >;
  readonly recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  readonly recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  readonly relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  readonly search?: InputMaybe<Scalars["String"]["input"]>;
  /** Filters down to team objectives related to the given user */
  readonly teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ArtifactInterface = {
  readonly activities: ArtifactActivityNodeConnection;
  readonly artifactType: ArtifactType;
  readonly assignableUsers?: Maybe<UserNodeConnection>;
  readonly canDelete: PermissionNode;
  readonly canRead: PermissionNode;
  readonly canUpdate: PermissionNode;
  readonly commentCount?: Maybe<Scalars["Int"]["output"]>;
  readonly comments?: Maybe<CommentNodeConnection>;
  readonly created: Scalars["DateTime"]["output"];
  readonly createdInMeeting?: Maybe<MeetingNode>;
  readonly creator?: Maybe<UserNode>;
  readonly description?: Maybe<Scalars["JSONString"]["output"]>;
  readonly eventChannelName?: Maybe<Scalars["String"]["output"]>;
  readonly id: Scalars["Int"]["output"];
  readonly isStale: Scalars["Boolean"]["output"];
  readonly organization?: Maybe<OrganizationNode>;
  readonly relatedArtifacts?: Maybe<ArtifactToArtifactConnection>;
  readonly title?: Maybe<Scalars["String"]["output"]>;
  readonly topics?: Maybe<ArtifactToTopicConnection>;
  readonly updated?: Maybe<Scalars["DateTime"]["output"]>;
  readonly uuid?: Maybe<Scalars["String"]["output"]>;
  readonly websocketToken?: Maybe<Scalars["String"]["output"]>;
};

export type ArtifactInterfaceActivitiesArgs = {
  activityType?: InputMaybe<ArtifactActivityType>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ArtifactInterfaceAssignableUsersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type ArtifactInterfaceCommentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  artifactId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  isInlineComment?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  textUuid?: InputMaybe<Scalars["String"]["input"]>;
  topicId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ArtifactInterfaceRelatedArtifactsArgs = {
  actionItemAssignedToMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignees?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  actionItemDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  actionItemProgress?: InputMaybe<Scalars["Float"]["input"]>;
  actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemStates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  ancestorsOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  artifactTypes?: InputMaybe<ReadonlyArray<InputMaybe<ArtifactType>>>;
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  asUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  assignedToMembersOfOrganizationId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  completedActionItemsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedActionItemsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  createdByIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  createdInMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackSenders?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackState?: InputMaybe<FeedbackState>;
  feedbackStates?: InputMaybe<ReadonlyArray<InputMaybe<FeedbackState>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  goalCompetencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalContributors?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalInvolvingUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalParentIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalResponsibilityIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalScope?: InputMaybe<GoalScope>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalState?: InputMaybe<GoalState>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalStatus?: InputMaybe<GoalStatus>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalVisibility?: InputMaybe<GoalVisibility>;
  goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  groupBy?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  isStale?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValue?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionReceivedByMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ArtifactInterfaceTopicsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assignee?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasActionItems?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasArtifacts?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDecisions?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDocuments?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasGoals?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInFlowId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInMeetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<TopicState>;
  titleContains?: InputMaybe<Scalars["String"]["input"]>;
  topicIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type ArtifactToArtifactConnection = {
  readonly __typename: "ArtifactToArtifactConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ArtifactToArtifactEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `ArtifactToArtifact` and its cursor. */
export type ArtifactToArtifactEdge = {
  readonly __typename: "ArtifactToArtifactEdge";
  readonly connectionCreated?: Maybe<Scalars["DateTime"]["output"]>;
  readonly connectionCreator?: Maybe<UserNode>;
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<ArtifactInterface>;
};

export type ArtifactToTopicConnection = {
  readonly __typename: "ArtifactToTopicConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ArtifactToTopicEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `ArtifactToTopic` and its cursor. */
export type ArtifactToTopicEdge = {
  readonly __typename: "ArtifactToTopicEdge";
  readonly connectionCreated?: Maybe<Scalars["DateTime"]["output"]>;
  readonly connectionCreator?: Maybe<UserNode>;
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<TopicNode>;
};

/** An enumeration. */
export enum ArtifactType {
  ActionItem = "action_item",
  AsanaTask = "asana_task",
  Decision = "decision",
  Document = "document",
  Feedback = "feedback",
  GithubIssues = "github_issues",
  Goal = "goal",
  Kpi = "kpi",
  Rating = "rating",
  Recognition = "recognition",
}

export type AsanaTaskArtifactNode = ArtifactInterface & {
  readonly __typename: "AsanaTaskArtifactNode";
  readonly activities: ArtifactActivityNodeConnection;
  readonly artifactType: ArtifactType;
  readonly assignableUsers?: Maybe<UserNodeConnection>;
  readonly assignee?: Maybe<UserNode>;
  readonly canDelete: PermissionNode;
  readonly canRead: PermissionNode;
  readonly canUpdate: PermissionNode;
  readonly commentCount?: Maybe<Scalars["Int"]["output"]>;
  readonly comments?: Maybe<CommentNodeConnection>;
  readonly completedAt?: Maybe<Scalars["DateTime"]["output"]>;
  readonly created: Scalars["DateTime"]["output"];
  readonly createdInMeeting?: Maybe<MeetingNode>;
  readonly creator?: Maybe<UserNode>;
  readonly description?: Maybe<Scalars["JSONString"]["output"]>;
  readonly dueDate?: Maybe<Scalars["DateTime"]["output"]>;
  readonly eventChannelName?: Maybe<Scalars["String"]["output"]>;
  readonly id: Scalars["Int"]["output"];
  readonly isComplete?: Maybe<Scalars["Boolean"]["output"]>;
  readonly isStale: Scalars["Boolean"]["output"];
  readonly isSynced?: Maybe<Scalars["Boolean"]["output"]>;
  readonly organization?: Maybe<OrganizationNode>;
  readonly relatedArtifacts?: Maybe<ArtifactToArtifactConnection>;
  readonly title?: Maybe<Scalars["String"]["output"]>;
  readonly topics?: Maybe<ArtifactToTopicConnection>;
  readonly updated?: Maybe<Scalars["DateTime"]["output"]>;
  readonly uuid?: Maybe<Scalars["String"]["output"]>;
  readonly websocketToken?: Maybe<Scalars["String"]["output"]>;
};

export type AsanaTaskArtifactNodeActivitiesArgs = {
  activityType?: InputMaybe<ArtifactActivityType>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AsanaTaskArtifactNodeAssignableUsersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type AsanaTaskArtifactNodeCommentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  artifactId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  isInlineComment?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  textUuid?: InputMaybe<Scalars["String"]["input"]>;
  topicId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AsanaTaskArtifactNodeRelatedArtifactsArgs = {
  actionItemAssignedToMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignees?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  actionItemDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  actionItemProgress?: InputMaybe<Scalars["Float"]["input"]>;
  actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemStates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  ancestorsOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  artifactTypes?: InputMaybe<ReadonlyArray<InputMaybe<ArtifactType>>>;
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  asUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  assignedToMembersOfOrganizationId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  completedActionItemsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedActionItemsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  createdByIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  createdInMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackSenders?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackState?: InputMaybe<FeedbackState>;
  feedbackStates?: InputMaybe<ReadonlyArray<InputMaybe<FeedbackState>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  goalCompetencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalContributors?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalInvolvingUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalParentIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalResponsibilityIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalScope?: InputMaybe<GoalScope>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalState?: InputMaybe<GoalState>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalStatus?: InputMaybe<GoalStatus>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalVisibility?: InputMaybe<GoalVisibility>;
  goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  groupBy?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  isStale?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValue?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionReceivedByMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AsanaTaskArtifactNodeTopicsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assignee?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasActionItems?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasArtifacts?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDecisions?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDocuments?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasGoals?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInFlowId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInMeetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<TopicState>;
  titleContains?: InputMaybe<Scalars["String"]["input"]>;
  topicIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type AsanaTaskPreviewNode = {
  readonly __typename: "AsanaTaskPreviewNode";
  readonly artifact?: Maybe<AsanaTaskArtifactNode>;
  readonly title?: Maybe<Scalars["String"]["output"]>;
};

export type AssessmentAnswerCalibrationConnection = {
  readonly __typename: "AssessmentAnswerCalibrationConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AssessmentAnswerCalibrationEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `AssessmentAnswerCalibration` and its cursor. */
export type AssessmentAnswerCalibrationEdge = {
  readonly __typename: "AssessmentAnswerCalibrationEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<AssessmentAnswerCalibrationInterface>;
};

export type AssessmentAnswerCalibrationInterface = {
  readonly answerId?: Maybe<Scalars["Int"]["output"]>;
  readonly canDelete: PermissionNode;
  readonly canRead: PermissionNode;
  readonly canUpdate: PermissionNode;
  readonly comment?: Maybe<Scalars["JSONString"]["output"]>;
  readonly created: Scalars["DateTime"]["output"];
  readonly creator?: Maybe<UserNode>;
  readonly id: Scalars["Int"]["output"];
  readonly isPrecalibration: Scalars["Boolean"]["output"];
  readonly isSuggestion: Scalars["Boolean"]["output"];
  readonly question: AssessmentQuestionInterface;
  readonly target?: Maybe<UserNode>;
  readonly updated: Scalars["DateTime"]["output"];
};

export type AssessmentAnswerConnection = {
  readonly __typename: "AssessmentAnswerConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AssessmentAnswerEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `AssessmentAnswer` and its cursor. */
export type AssessmentAnswerEdge = {
  readonly __typename: "AssessmentAnswerEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<AssessmentAnswerInterface>;
};

export type AssessmentAnswerInterface = {
  readonly assessment: AssessmentNode;
  readonly calibrations: AssessmentAnswerCalibrationConnection;
  readonly canDelete: PermissionNode;
  readonly canRead: PermissionNode;
  readonly canUpdate: PermissionNode;
  readonly comment?: Maybe<Scalars["JSONString"]["output"]>;
  readonly created: Scalars["DateTime"]["output"];
  readonly hasCalibrationSuggestions: Scalars["Boolean"]["output"];
  readonly hasCalibrations: Scalars["Boolean"]["output"];
  readonly id: Scalars["Int"]["output"];
  readonly isLocked: Scalars["Boolean"]["output"];
  readonly question: AssessmentQuestionInterface;
  readonly questionId: Scalars["Int"]["output"];
  readonly responder?: Maybe<UserNode>;
  readonly updated: Scalars["DateTime"]["output"];
};

export type AssessmentAnswerInterfaceCalibrationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AssessmentDeliveryNode = DjangoNode &
  Node & {
    readonly __typename: "AssessmentDeliveryNode";
    readonly additionalQuestionSets?: Maybe<ExtraAssessmentQuestionSetsByAssessmentTypeNode>;
    readonly answers: AssessmentAnswerConnection;
    readonly calibrationAssessmentId?: Maybe<Scalars["Int"]["output"]>;
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly complianceProgram?: Maybe<ComplianceProgramNode>;
    readonly creator?: Maybe<UserNode>;
    readonly deliveryDatetime?: Maybe<Scalars["DateTime"]["output"]>;
    readonly dueDate?: Maybe<Scalars["Date"]["output"]>;
    readonly excludedAnswerIds: ReadonlyArray<Maybe<Scalars["Int"]["output"]>>;
    /** Answers grouped by (group_key, question_id) with privacy threshold applied. Returns empty answers list for groups below threshold but includes metadata. */
    readonly groupedAnswers?: Maybe<ReadonlyArray<Maybe<GroupedAnswersNode>>>;
    readonly id: Scalars["ID"]["output"];
    readonly lastSubmissionDatetime?: Maybe<Scalars["DateTime"]["output"]>;
    readonly mostRecentAnswers?: Maybe<
      ReadonlyArray<Maybe<MostRecentAssessmentAnswerNode>>
    >;
    readonly nominees: UserNodeConnection;
    readonly organization: OrganizationNode;
    readonly peerRespondersCount?: Maybe<Scalars["Int"]["output"]>;
    readonly periodEndDate?: Maybe<Scalars["Date"]["output"]>;
    readonly periodStartDate?: Maybe<Scalars["Date"]["output"]>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly relatedMeetings: MeetingNodeConnection;
    readonly state: AssessmentDeliveryState;
    readonly summary?: Maybe<Scalars["JSONString"]["output"]>;
    readonly target?: Maybe<UserNode>;
    readonly targetCurrentRoleIds: ReadonlyArray<
      Maybe<Scalars["Int"]["output"]>
    >;
    /** The position field of the target stored when the Program was published */
    readonly targetPosition?: Maybe<Scalars["String"]["output"]>;
    readonly undeliveredPeerAssessmentDeliveryId?: Maybe<
      Scalars["String"]["output"]
    >;
  };

export type AssessmentDeliveryNodeAnswersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  employeeStartDateRange?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
  >;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  locations?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  managerIdsFullTree?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type AssessmentDeliveryNodeGroupedAnswersArgs = {
  collapsedKeys?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
  >;
  employeeStartDateRange?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
  >;
  groupBy?: InputMaybe<EngagementSurveyReportGroupBy>;
  locations?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  managerIdsFullTree?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type AssessmentDeliveryNodeNomineesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type AssessmentDeliveryNodeRelatedMeetingsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  draft?: InputMaybe<Scalars["Boolean"]["input"]>;
  endDatetime?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  excludeMeetingGroupIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  fromMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  ignored?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFinalized?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFormalOneonone?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  minimumDateRange?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Decimal"]["input"]>;
  participantCount?: InputMaybe<Scalars["Int"]["input"]>;
  participants?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  startDatetime?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  status?: InputMaybe<EventStatus>;
  status_In?: InputMaybe<ReadonlyArray<InputMaybe<EventStatus>>>;
  subject?: InputMaybe<Scalars["Int"]["input"]>;
  templateId?: InputMaybe<Scalars["Int"]["input"]>;
  unscheduled?: InputMaybe<Scalars["Boolean"]["input"]>;
  usingRequiredTemplateOfValidPrograms?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
};

export type AssessmentDeliveryNodeConnection = {
  readonly __typename: "AssessmentDeliveryNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AssessmentDeliveryNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `AssessmentDeliveryNode` and its cursor. */
export type AssessmentDeliveryNodeEdge = {
  readonly __typename: "AssessmentDeliveryNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<AssessmentDeliveryNode>;
};

/** An enumeration. */
export enum AssessmentDeliveryState {
  AdminsAndMgrsOnly = "admins_and_mgrs_only",
  AwaitingAdminApproval = "awaiting_admin_approval",
  Calibrated = "calibrated",
  Delivered = "delivered",
  Draft = "draft",
}

/** An enumeration. */
export enum AssessmentGroupAnonymity {
  Anonymous = "anonymous",
  NotAnonymous = "not_anonymous",
  SemiAnonymous = "semi_anonymous",
}

export type AssessmentGroupConnection = {
  readonly __typename: "AssessmentGroupConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AssessmentGroupEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** An enumeration. */
export enum AssessmentGroupDelivery {
  AdminApproval = "admin_approval",
  Full = "full",
  None = "none",
  Partial = "partial",
}

/** A Relay edge containing a `AssessmentGroup` and its cursor. */
export type AssessmentGroupEdge = {
  readonly __typename: "AssessmentGroupEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<RoleBasedAssessmentGroupNode>;
};

export type AssessmentGroupNode = DjangoNode &
  Node & {
    readonly __typename: "AssessmentGroupNode";
    readonly archived: Scalars["Boolean"]["output"];
    readonly assessmentType: AssessmentType;
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator?: Maybe<UserNode>;
    readonly hasNpsQuestions: Scalars["Boolean"]["output"];
    readonly hasSelfAssessment: Scalars["Boolean"]["output"];
    readonly id: Scalars["ID"]["output"];
    readonly isOnlySelfAssessment: Scalars["Boolean"]["output"];
    readonly organization: OrganizationNode;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly sections: AssessmentGroupSectionNodeConnection;
    readonly talentIndicatorQuestionSettings?: Maybe<TalentIndicatorSettingsNode>;
    readonly title: Scalars["String"]["output"];
    readonly updated: Scalars["DateTime"]["output"];
  };

export type AssessmentGroupNodeSectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AssessmentGroupNodeConnection = {
  readonly __typename: "AssessmentGroupNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AssessmentGroupNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `AssessmentGroupNode` and its cursor. */
export type AssessmentGroupNodeEdge = {
  readonly __typename: "AssessmentGroupNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<AssessmentGroupNode>;
};

/** An enumeration. */
export enum AssessmentGroupProviders {
  Default = "default",
  ManagerSelect = "manager_select",
  SubjectSelect = "subject_select",
}

export type AssessmentGroupQuestionContainer = {
  readonly __typename: "AssessmentGroupQuestionContainer";
  readonly id: Scalars["ID"]["output"];
  readonly question: AssessmentQuestionInterface;
};

export type AssessmentGroupQuestionContainerConnection = {
  readonly __typename: "AssessmentGroupQuestionContainerConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AssessmentGroupQuestionContainerEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `AssessmentGroupQuestionContainer` and its cursor. */
export type AssessmentGroupQuestionContainerEdge = {
  readonly __typename: "AssessmentGroupQuestionContainerEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<AssessmentGroupQuestionContainer>;
};

export type AssessmentGroupQuestionInput = {
  readonly comment: AssessmentQuestionComment;
  readonly description?: InputMaybe<Scalars["String"]["input"]>;
  readonly endValue?: InputMaybe<Scalars["Int"]["input"]>;
  readonly id?: InputMaybe<Scalars["Int"]["input"]>;
  readonly labelDescriptions?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
  >;
  readonly labels?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
  >;
  readonly optionDescriptions?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
  >;
  readonly options?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
  >;
  readonly questionType: AssessmentQuestionType;
  readonly responseVisibility: AssessmentQuestionResponseVisibility;
  readonly responses: AssessmentQuestionResponses;
  readonly startValue?: InputMaybe<Scalars["Int"]["input"]>;
  readonly title: Scalars["String"]["input"];
};

export type AssessmentGroupSectionInput = {
  readonly description?: InputMaybe<Scalars["String"]["input"]>;
  readonly questionIds: ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>;
  readonly title?: InputMaybe<Scalars["String"]["input"]>;
};

export type AssessmentGroupSectionNode = AssessmentSectionInterface &
  DjangoNode &
  Node & {
    readonly __typename: "AssessmentGroupSectionNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly description?: Maybe<Scalars["JSONString"]["output"]>;
    readonly id: Scalars["ID"]["output"];
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly questions: AssessmentGroupQuestionContainerConnection;
    readonly subjectVisibility: AssessmentSectionSubjectVisibility;
    readonly title?: Maybe<Scalars["String"]["output"]>;
  };

export type AssessmentGroupSectionNodeQuestionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AssessmentGroupSectionNodeConnection = {
  readonly __typename: "AssessmentGroupSectionNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AssessmentGroupSectionNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `AssessmentGroupSectionNode` and its cursor. */
export type AssessmentGroupSectionNodeEdge = {
  readonly __typename: "AssessmentGroupSectionNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<AssessmentGroupSectionNode>;
};

export type AssessmentNode = DjangoNode &
  Node & {
    readonly __typename: "AssessmentNode";
    readonly additionalQuestionSets?: Maybe<ExtraAssessmentQuestionSetsByAssessmentTypeNode>;
    readonly answers: ReadonlyArray<Maybe<AssessmentAnswerInterface>>;
    readonly assessmentDelivery?: Maybe<AssessmentDeliveryNode>;
    /** The state of the assessment delivery even if user has not permission to view delivery */
    readonly assessmentDeliveryState?: Maybe<AssessmentDeliveryState>;
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly complianceProgram?: Maybe<ComplianceProgramNode>;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator?: Maybe<UserNode>;
    readonly dueDate?: Maybe<Scalars["Date"]["output"]>;
    readonly id: Scalars["ID"]["output"];
    readonly mostRecentAnswers?: Maybe<
      ReadonlyArray<Maybe<MostRecentAssessmentAnswerNode>>
    >;
    readonly organization: OrganizationNode;
    readonly otherParticipantsAnswers: AssessmentAnswerConnection;
    readonly periodEndDate?: Maybe<Scalars["Date"]["output"]>;
    readonly periodStartDate?: Maybe<Scalars["Date"]["output"]>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly relatedMeetings: MeetingNodeConnection;
    readonly responder?: Maybe<UserNode>;
    /** The average answer of all role based questions submitted by the manager during a performance review related to the target's current role */
    readonly roleAssessmentAvg?: Maybe<Scalars["Float"]["output"]>;
    /** The average answer of all role based questions submitted by the target during a performance review related to the target's current role */
    readonly selfRoleAssessmentAvg?: Maybe<Scalars["Float"]["output"]>;
    readonly state: AssessmentState;
    readonly submittedDatetime?: Maybe<Scalars["DateTime"]["output"]>;
    /** AI-generated suggested answers for text questions */
    readonly suggestedAnswers?: Maybe<SuggestedQuestionConnection>;
    readonly suggestedAnswersState?: Maybe<SuggestedAnswerState>;
    readonly target?: Maybe<UserNode>;
    readonly targetCurrentRoleIds: ReadonlyArray<
      Maybe<Scalars["Int"]["output"]>
    >;
    /** The position field of the target stored when the Program was published */
    readonly targetPosition?: Maybe<Scalars["String"]["output"]>;
    readonly template: AssessmentTemplateNode;
    readonly updated: Scalars["DateTime"]["output"];
  };

export type AssessmentNodeAnswersArgs = {
  questionType?: InputMaybe<ReadonlyArray<InputMaybe<AssessmentQuestionType>>>;
};

export type AssessmentNodeOtherParticipantsAnswersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AssessmentNodeRelatedMeetingsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  draft?: InputMaybe<Scalars["Boolean"]["input"]>;
  endDatetime?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  excludeMeetingGroupIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  fromMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  ignored?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFinalized?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFormalOneonone?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  minimumDateRange?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Decimal"]["input"]>;
  participantCount?: InputMaybe<Scalars["Int"]["input"]>;
  participants?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  startDatetime?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  status?: InputMaybe<EventStatus>;
  status_In?: InputMaybe<ReadonlyArray<InputMaybe<EventStatus>>>;
  subject?: InputMaybe<Scalars["Int"]["input"]>;
  templateId?: InputMaybe<Scalars["Int"]["input"]>;
  unscheduled?: InputMaybe<Scalars["Boolean"]["input"]>;
  usingRequiredTemplateOfValidPrograms?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
};

export type AssessmentNodeSuggestedAnswersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AssessmentNodeConnection = {
  readonly __typename: "AssessmentNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AssessmentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `AssessmentNode` and its cursor. */
export type AssessmentNodeEdge = {
  readonly __typename: "AssessmentNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<AssessmentNode>;
};

export type AssessmentNominationNode = DjangoNode &
  Node & {
    readonly __typename: "AssessmentNominationNode";
    readonly assessmentTemplate: AssessmentTemplateNode;
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly complianceProgram: ComplianceProgramNode;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator: UserNode;
    readonly id: Scalars["ID"]["output"];
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly responder: UserNode;
    readonly target: UserNode;
    readonly updated: Scalars["DateTime"]["output"];
  };

export type AssessmentNominationNodeConnection = {
  readonly __typename: "AssessmentNominationNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AssessmentNominationNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `AssessmentNominationNode` and its cursor. */
export type AssessmentNominationNodeEdge = {
  readonly __typename: "AssessmentNominationNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<AssessmentNominationNode>;
};

export type AssessmentOpenForNominationConnection = {
  readonly __typename: "AssessmentOpenForNominationConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AssessmentOpenForNominationEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `AssessmentOpenForNomination` and its cursor. */
export type AssessmentOpenForNominationEdge = {
  readonly __typename: "AssessmentOpenForNominationEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<AssessmentOpenForNominationNode>;
};

export type AssessmentOpenForNominationNode = {
  readonly __typename: "AssessmentOpenForNominationNode";
  readonly assessmentTemplate: AssessmentTemplateNode;
  readonly complianceProgram: ComplianceProgramNode;
  readonly id: Scalars["String"]["output"];
  readonly nominations: AssessmentNominationNodeConnection;
  /** Count of nominations (excluding self-nominations). Uses batched loading to avoid N+1 queries. */
  readonly nominationsCount: Scalars["Int"]["output"];
  readonly nominationsList: ReadonlyArray<AssessmentNominationNode>;
  readonly targetUser: UserNode;
};

export type AssessmentOpenForNominationNodeNominationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AssessmentQuestionAnswerInput = {
  readonly choices?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  readonly comment?: InputMaybe<Scalars["String"]["input"]>;
  readonly integerAnswer?: InputMaybe<Scalars["Int"]["input"]>;
  readonly questionId: Scalars["Int"]["input"];
  readonly textAnswer?: InputMaybe<Scalars["String"]["input"]>;
};

export type AssessmentQuestionCategoryNode = DjangoNode &
  Node & {
    readonly __typename: "AssessmentQuestionCategoryNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly id: Scalars["ID"]["output"];
    readonly organization: OrganizationNode;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly title: Scalars["String"]["output"];
  };

export type AssessmentQuestionCategoryNodeConnection = {
  readonly __typename: "AssessmentQuestionCategoryNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AssessmentQuestionCategoryNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `AssessmentQuestionCategoryNode` and its cursor. */
export type AssessmentQuestionCategoryNodeEdge = {
  readonly __typename: "AssessmentQuestionCategoryNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<AssessmentQuestionCategoryNode>;
};

/** An enumeration. */
export enum AssessmentQuestionComment {
  NoComment = "no_comment",
  Optional = "optional",
  Required = "required",
}

export type AssessmentQuestionConnection = {
  readonly __typename: "AssessmentQuestionConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AssessmentQuestionEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `AssessmentQuestion` and its cursor. */
export type AssessmentQuestionEdge = {
  readonly __typename: "AssessmentQuestionEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<AssessmentQuestionInterface>;
};

export type AssessmentQuestionInterface = {
  readonly answers: AssessmentAnswerConnection;
  readonly answersExist: Scalars["Boolean"]["output"];
  readonly archived: Scalars["Boolean"]["output"];
  readonly canDelete: PermissionNode;
  readonly canRead: PermissionNode;
  readonly canUpdate: PermissionNode;
  readonly categories: AssessmentQuestionCategoryNodeConnection;
  readonly comment: AssessmentQuestionComment;
  readonly created: Scalars["DateTime"]["output"];
  readonly creator?: Maybe<UserNode>;
  readonly description?: Maybe<Scalars["JSONString"]["output"]>;
  readonly id: Scalars["Int"]["output"];
  readonly isResponseMandatory: Scalars["Boolean"]["output"];
  readonly organization: OrganizationNode;
  readonly questionType: AssessmentQuestionType;
  readonly responseVisibility: AssessmentQuestionResponseVisibility;
  readonly responses: AssessmentQuestionResponses;
  readonly title: Scalars["String"]["output"];
  readonly updated: Scalars["DateTime"]["output"];
};

export type AssessmentQuestionInterfaceAnswersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AssessmentQuestionInterfaceCategoriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

/** An enumeration. */
export enum AssessmentQuestionResponseVisibility {
  All = "all",
  HiddenFromSubject = "hidden_from_subject",
}

/** An enumeration. */
export enum AssessmentQuestionResponses {
  Both = "both",
  ExcludeSelfAssessment = "exclude_self_assessment",
  SelfAssessmentOnly = "self_assessment_only",
}

/** An enumeration. */
export enum AssessmentQuestionType {
  Competency = "competency",
  CompetencyCriteria = "competency_criteria",
  IndividualGoal = "individual_goal",
  IndividualRecognitionCoreValue = "individual_recognition_core_value",
  Multichoice = "multichoice",
  Nps = "nps",
  OverallGoal = "overall_goal",
  OverallRecognitionCoreValue = "overall_recognition_core_value",
  Range = "range",
  Responsibility = "responsibility",
  TalentIndicator = "talent_indicator",
  Text = "text",
}

export type AssessmentSectionInterface = {
  readonly description?: Maybe<Scalars["JSONString"]["output"]>;
  readonly id: Scalars["ID"]["output"];
  readonly questions: AssessmentGroupQuestionContainerConnection;
  readonly subjectVisibility: AssessmentSectionSubjectVisibility;
  readonly title?: Maybe<Scalars["String"]["output"]>;
};

export type AssessmentSectionInterfaceQuestionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** An enumeration. */
export enum AssessmentSectionSubjectVisibility {
  AllQuestionsAreHidden = "all_questions_are_hidden",
  AllQuestionsAreVisible = "all_questions_are_visible",
  SomeQuestionsAreHidden = "some_questions_are_hidden",
  SomeQuestionsAreHiddenButSomeAreSubjectOnly = "some_questions_are_hidden_but_some_are_subject_only",
}

/** An enumeration. */
export enum AssessmentState {
  Draft = "draft",
  Submitted = "submitted",
}

export type AssessmentSubmissionNode = {
  readonly __typename: "AssessmentSubmissionNode";
  readonly canCalibrate?: Maybe<PermissionNode>;
  readonly completeCount: Scalars["Int"]["output"];
  readonly delivery?: Maybe<AssessmentDeliveryNode>;
  readonly pendingCount: Scalars["Int"]["output"];
  readonly status: ComplianceProgramParticipantStatus;
  readonly template?: Maybe<AssessmentTemplateNode>;
  readonly type: AssessmentSubmissionNodeType;
  readonly users: ReadonlyArray<UserNode>;
};

/** An enumeration. */
export enum AssessmentSubmissionNodeType {
  Calibration = "CALIBRATION",
  Delivery = "DELIVERY",
  ManagerAssessment = "MANAGER_ASSESSMENT",
  PeerAssessment = "PEER_ASSESSMENT",
  PeerNominations = "PEER_NOMINATIONS",
  SelfAssessment = "SELF_ASSESSMENT",
  UpwardAssessment = "UPWARD_ASSESSMENT",
}

export type AssessmentTemplateComplianceRequirement = {
  readonly anonymity?: InputMaybe<AssessmentGroupAnonymity>;
  readonly assessmentType: AssessmentType;
  readonly competencyAssessmentType?: InputMaybe<CompetencyAssessmentType>;
  readonly coreValueAssessmentResponses?: InputMaybe<AssessmentQuestionResponses>;
  readonly coreValueAssessmentScale?: InputMaybe<Scalars["Int"]["input"]>;
  readonly coreValueAssessmentScaleLabels?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
  >;
  readonly coreValueAssessmentScaleStartsAt?: InputMaybe<
    Scalars["Int"]["input"]
  >;
  readonly delivery?: InputMaybe<AssessmentGroupDelivery>;
  readonly enableCoreValueAssessments?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly enableGoalAssessments?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly enableRoleBasedAssessments?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly goalAssessmentResponses?: InputMaybe<AssessmentQuestionResponses>;
  readonly goalAssessmentScale?: InputMaybe<Scalars["Int"]["input"]>;
  readonly goalAssessmentScaleLabels?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
  >;
  readonly goalAssessmentScaleStartsAt?: InputMaybe<Scalars["Int"]["input"]>;
  readonly id?: InputMaybe<Scalars["Int"]["input"]>;
  readonly nextRoleCompetencyAssessmentType?: InputMaybe<CompetencyAssessmentType>;
  readonly providers?: InputMaybe<AssessmentGroupProviders>;
  readonly questionSetIds: ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>;
  readonly roleBasedAssessmentScale?: InputMaybe<Scalars["Int"]["input"]>;
  readonly roleBasedAssessmentScaleLabels?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
  >;
  readonly roleBasedAssessmentScaleStartsAt?: InputMaybe<
    Scalars["Int"]["input"]
  >;
  readonly roleBasedAssessmentsAssessNextRole?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  readonly roleBasedAssessmentsSelfAssessNextRole?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  readonly talentIndicatorConfig?: InputMaybe<TalentIndicatorConfigInput>;
};

export type AssessmentTemplateNode = DjangoNode &
  Node & {
    readonly __typename: "AssessmentTemplateNode";
    readonly additionalQuestions: ReadonlyArray<
      Maybe<AssessmentQuestionInterface>
    >;
    readonly anonymity: AssessmentGroupAnonymity;
    readonly assessmentType: AssessmentType;
    readonly assessments: AssessmentNodeConnection;
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly competencyAssessmentType: CompetencyAssessmentType;
    readonly coreValueAssessmentResponses: AssessmentQuestionResponses;
    /** The number of options in the range question scales associated with core values */
    readonly coreValueAssessmentScale: Scalars["Int"]["output"];
    readonly coreValueAssessmentScaleLabels: ReadonlyArray<
      Maybe<Scalars["String"]["output"]>
    >;
    /** The starting value of the options in the range question scales associated with core values */
    readonly coreValueAssessmentScaleStartsAt: Scalars["Int"]["output"];
    readonly created: Scalars["DateTime"]["output"];
    readonly creator?: Maybe<UserNode>;
    readonly delivery: AssessmentGroupDelivery;
    readonly enableCoreValueAssessments: Scalars["Boolean"]["output"];
    readonly enableGoalAssessments: Scalars["Boolean"]["output"];
    readonly enableRoleBasedAssessments: Scalars["Boolean"]["output"];
    readonly goalAssessmentResponses: AssessmentQuestionResponses;
    /** The number of options in the range question scales associated with goals */
    readonly goalAssessmentScale: Scalars["Int"]["output"];
    readonly goalAssessmentScaleLabels: ReadonlyArray<
      Maybe<Scalars["String"]["output"]>
    >;
    /** The starting value of the options in the range question scales associated with goals */
    readonly goalAssessmentScaleStartsAt: Scalars["Int"]["output"];
    readonly hasSelfAssessment: Scalars["Boolean"]["output"];
    readonly id: Scalars["ID"]["output"];
    readonly isOnlySelfAssessment: Scalars["Boolean"]["output"];
    readonly nextRoleCompetencyAssessmentType: CompetencyAssessmentType;
    readonly organization: OrganizationNode;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly providers: AssessmentGroupProviders;
    readonly questionSets: AssessmentGroupNodeConnection;
    /** The number of options in the range question scales associated with role competencies/responsibilities */
    readonly roleBasedAssessmentScale: Scalars["Int"]["output"];
    readonly roleBasedAssessmentScaleLabels: ReadonlyArray<
      Maybe<Scalars["String"]["output"]>
    >;
    /** The starting value of the options in the range question scales associated with role competencies/responsibilities */
    readonly roleBasedAssessmentScaleStartsAt: Scalars["Int"]["output"];
    readonly roleBasedAssessmentsAssessNextRole: Scalars["Boolean"]["output"];
    /** Whether during self assessment, the next role is assessed, if available */
    readonly roleBasedAssessmentsSelfAssessNextRole: Scalars["Boolean"]["output"];
    readonly updated: Scalars["DateTime"]["output"];
  };

export type AssessmentTemplateNodeAssessmentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assessmentType?: InputMaybe<AssessmentType>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  responderId?: InputMaybe<Scalars["Int"]["input"]>;
  selfAssessment?: InputMaybe<Scalars["Boolean"]["input"]>;
  state?: InputMaybe<AssessmentState>;
  targetId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AssessmentTemplateNodeQuestionSetsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  archived?: InputMaybe<Scalars["Boolean"]["input"]>;
  assessmentType?: InputMaybe<AssessmentType>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** An enumeration. */
export enum AssessmentType {
  EngagementSurvey = "engagement_survey",
  Manager = "manager",
  Peer = "peer",
  Performance = "performance",
}

export type AssociateArtifactWithTopicOrArtifactMutation = {
  readonly __typename: "AssociateArtifactWithTopicOrArtifactMutation";
  readonly artifact?: Maybe<ArtifactInterface>;
  readonly otherArtifact?: Maybe<ArtifactInterface>;
  readonly topic?: Maybe<TopicNode>;
};

export type AttendeeInput = {
  readonly email: Scalars["String"]["input"];
  readonly role?: InputMaybe<AttendeeRole>;
};

/** An enumeration. */
export enum AttendeeRole {
  Optional = "optional",
  Required = "required",
  Resource = "resource",
}

/** An enumeration. */
export enum AttendeeStatus {
  Accepted = "accepted",
  Declined = "declined",
  NotResponded = "not_responded",
  Tentative = "tentative",
}

/** Type for available Merge.dev integrations from their API */
export type AvailableMergeIntegrationType = {
  readonly __typename: "AvailableMergeIntegrationType";
  readonly categories: ReadonlyArray<Maybe<Scalars["String"]["output"]>>;
  readonly color?: Maybe<Scalars["String"]["output"]>;
  readonly image?: Maybe<Scalars["String"]["output"]>;
  readonly name: Scalars["String"]["output"];
  readonly slug: Scalars["String"]["output"];
  readonly squareImage?: Maybe<Scalars["String"]["output"]>;
};

export type AvailableTeamsNotificationChannel = {
  readonly __typename: "AvailableTeamsNotificationChannel";
  readonly channelId: Scalars["String"]["output"];
  readonly channelName: Scalars["String"]["output"];
  readonly teamId: Scalars["String"]["output"];
  readonly teamName: Scalars["String"]["output"];
};

export type AverageAssessmentAnswersByProgramNode = {
  readonly __typename: "AverageAssessmentAnswersByProgramNode";
  readonly averageAnswer: Scalars["Float"]["output"];
  readonly maxRange: Scalars["Int"]["output"];
  readonly minRange: Scalars["Int"]["output"];
  readonly program: ComplianceProgramNode;
  readonly submittedDatetime: Scalars["DateTime"]["output"];
};

export type BackfillSlackDataMutation = {
  readonly __typename: "BackfillSlackDataMutation";
  readonly organization?: Maybe<OrganizationNode>;
};

/** Contains only common fields, so it can be used in other unions (like SearchUnion) */
export type BaseArtifactNode = DjangoNode &
  Node & {
    readonly __typename: "BaseArtifactNode";
    readonly artifactType: ArtifactType;
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly created?: Maybe<Scalars["DateTime"]["output"]>;
    readonly creator?: Maybe<UserNode>;
    readonly id: Scalars["ID"]["output"];
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly specificArtifact?: Maybe<ArtifactInterface>;
    readonly title: Scalars["String"]["output"];
    readonly topics?: Maybe<TopicNodeConnection>;
    readonly updated?: Maybe<Scalars["DateTime"]["output"]>;
  };

/** Contains only common fields, so it can be used in other unions (like SearchUnion) */
export type BaseArtifactNodeTopicsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assignee?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasActionItems?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasArtifacts?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDecisions?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDocuments?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasGoals?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInFlowId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInMeetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<TopicState>;
  titleContains?: InputMaybe<Scalars["String"]["input"]>;
  topicIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type BasicFeedbackArtifactNode = DjangoNode &
  Node & {
    readonly __typename: "BasicFeedbackArtifactNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator?: Maybe<UserNode>;
    readonly feedbackArtifact?: Maybe<FeedbackArtifactNode>;
    readonly feedbackState: FeedbackState;
    readonly id: Scalars["ID"]["output"];
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly recipients?: Maybe<UserNodeConnection>;
    readonly sender?: Maybe<UserNode>;
    readonly title?: Maybe<Scalars["String"]["output"]>;
  };

export type BasicFeedbackArtifactNodeRecipientsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type BasicFeedbackArtifactNodeConnection = {
  readonly __typename: "BasicFeedbackArtifactNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<BasicFeedbackArtifactNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `BasicFeedbackArtifactNode` and its cursor. */
export type BasicFeedbackArtifactNodeEdge = {
  readonly __typename: "BasicFeedbackArtifactNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<BasicFeedbackArtifactNode>;
};

export type BasicGoalArtifactNode = DjangoNode &
  Node & {
    readonly __typename: "BasicGoalArtifactNode";
    readonly artifactType: ArtifactType;
    readonly canDelete: PermissionNode;
    readonly canRead: PermissionNode;
    readonly canUpdate: PermissionNode;
    readonly contributorCount?: Maybe<Scalars["Int"]["output"]>;
    readonly contributors?: Maybe<UserNodeConnection>;
    readonly contributorsList: ReadonlyArray<Maybe<UserNode>>;
    readonly created: Scalars["DateTime"]["output"];
    readonly currentValue: Scalars["Float"]["output"];
    readonly dueDate?: Maybe<Scalars["Date"]["output"]>;
    readonly firstOwner?: Maybe<UserNode>;
    readonly goalArtifact?: Maybe<GoalArtifactNode>;
    readonly goalVisibility: GoalVisibility;
    readonly id: Scalars["ID"]["output"];
    readonly isStale: Scalars["Boolean"]["output"];
    readonly ownerCount?: Maybe<Scalars["Int"]["output"]>;
    readonly owners?: Maybe<UserNodeConnection>;
    readonly ownersList: ReadonlyArray<Maybe<UserNode>>;
    readonly parentGoalId?: Maybe<Scalars["Int"]["output"]>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly progress: Scalars["Float"]["output"];
    readonly progressType: GoalProgressType;
    readonly scope: GoalScope;
    readonly startDate?: Maybe<Scalars["Date"]["output"]>;
    readonly startValue: Scalars["Float"]["output"];
    readonly state: GoalState;
    readonly status: GoalStatus;
    readonly targetValue: Scalars["Float"]["output"];
    readonly updated: Scalars["DateTime"]["output"];
  };

export type BasicGoalArtifactNodeContributorsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type BasicGoalArtifactNodeOwnersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type BasicGoalArtifactNodeConnection = {
  readonly __typename: "BasicGoalArtifactNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<BasicGoalArtifactNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `BasicGoalArtifactNode` and its cursor. */
export type BasicGoalArtifactNodeEdge = {
  readonly __typename: "BasicGoalArtifactNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<BasicGoalArtifactNode>;
};

export type BasicMeetingNode = DjangoNode &
  Node & {
    readonly __typename: "BasicMeetingNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead: PermissionNode;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly endDatetime?: Maybe<Scalars["DateTime"]["output"]>;
    readonly freebusyOnly?: Maybe<Scalars["Boolean"]["output"]>;
    readonly id: Scalars["ID"]["output"];
    readonly isCurrentUserParticipant: Scalars["Boolean"]["output"];
    readonly meeting?: Maybe<MeetingNode>;
    readonly meetingGroupId: Scalars["Int"]["output"];
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly startDatetime?: Maybe<Scalars["DateTime"]["output"]>;
    readonly title?: Maybe<Scalars["String"]["output"]>;
  };

export type BasicMeetingNodeConnection = {
  readonly __typename: "BasicMeetingNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<BasicMeetingNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `BasicMeetingNode` and its cursor. */
export type BasicMeetingNodeEdge = {
  readonly __typename: "BasicMeetingNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<BasicMeetingNode>;
};

export type BasicUserNode = DjangoNode &
  Node & {
    readonly __typename: "BasicUserNode";
    readonly avatar?: Maybe<Scalars["String"]["output"]>;
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly email: Scalars["String"]["output"];
    readonly firstName: Scalars["String"]["output"];
    readonly id: Scalars["ID"]["output"];
    readonly lastName: Scalars["String"]["output"];
    readonly legalFirstName?: Maybe<Scalars["String"]["output"]>;
    readonly name: Scalars["String"]["output"];
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly status?: Maybe<UserStatus>;
    /** Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only. */
    readonly username: Scalars["String"]["output"];
  };

export type BatchAssessmentDeliveriesActionMutation = {
  readonly __typename: "BatchAssessmentDeliveriesActionMutation";
  readonly assessmentDeliveries: ReadonlyArray<Maybe<AssessmentDeliveryNode>>;
  readonly reportRows: PerformanceReviewReportRowConnection;
};

export type BatchAssessmentDeliveriesActionMutationReportRowsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** An enumeration. */
export enum BatchCalibrationAction {
  ApproveAll = "approve_all",
  ApproveCalibrated = "approve_calibrated",
  MarkAsCalibrated = "mark_as_calibrated",
}

export type BotParticipationDetailsNode = {
  readonly __typename: "BotParticipationDetailsNode";
  readonly joinBecauseOfParticipants: ReadonlyArray<UserNode>;
  readonly reason: MeetingBotJoinReason;
  readonly willBotJoin: Scalars["Boolean"]["output"];
};

export type CalendarMeetingGroupNode = DjangoNode &
  Node & {
    readonly __typename: "CalendarMeetingGroupNode";
    readonly allowAdminVisibility?: Maybe<Scalars["Boolean"]["output"]>;
    readonly artifacts?: Maybe<ArtifactConnection>;
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator: UserNode;
    readonly description: Scalars["String"]["output"];
    readonly draft: Scalars["Boolean"]["output"];
    readonly hasTemplate?: Maybe<Scalars["Boolean"]["output"]>;
    readonly id: Scalars["ID"]["output"];
    readonly meetings?: Maybe<MeetingNodeConnection>;
    readonly onlineConference?: Maybe<OnlineConference>;
    readonly organization?: Maybe<OrganizationNode>;
    readonly organizer?: Maybe<UserNode>;
    readonly participants?: Maybe<MeetingParticipantConnection>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly recurrenceParameters?: Maybe<FrequencyNode>;
    readonly recurrenceRule?: Maybe<Scalars["String"]["output"]>;
    readonly syncCredentials?: Maybe<UserSyncCredentialsNode>;
    readonly templateSeries?: Maybe<TemplateSeriesNodeConnection>;
    readonly title?: Maybe<Scalars["String"]["output"]>;
    readonly topics?: Maybe<TopicNodeConnection>;
    readonly zoom?: Maybe<ZoomMeetingNode>;
  };

export type CalendarMeetingGroupNodeArtifactsArgs = {
  actionItemAssignedToMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignees?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  actionItemDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  actionItemProgress?: InputMaybe<Scalars["Float"]["input"]>;
  actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemStates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  ancestorsOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  artifactTypes?: InputMaybe<ReadonlyArray<InputMaybe<ArtifactType>>>;
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  asUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  assignedToMembersOfOrganizationId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  completedActionItemsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedActionItemsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  createdByIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  createdInMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackSenders?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackState?: InputMaybe<FeedbackState>;
  feedbackStates?: InputMaybe<ReadonlyArray<InputMaybe<FeedbackState>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  goalCompetencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalContributors?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalInvolvingUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalParentIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalResponsibilityIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalScope?: InputMaybe<GoalScope>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalState?: InputMaybe<GoalState>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalStatus?: InputMaybe<GoalStatus>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalVisibility?: InputMaybe<GoalVisibility>;
  goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  groupBy?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  isStale?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValue?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionReceivedByMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CalendarMeetingGroupNodeMeetingsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  draft?: InputMaybe<Scalars["Boolean"]["input"]>;
  endDatetime?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  excludeMeetingGroupIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  fromMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  ignored?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFinalized?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFormalOneonone?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  minimumDateRange?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Decimal"]["input"]>;
  participantCount?: InputMaybe<Scalars["Int"]["input"]>;
  participants?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  startDatetime?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  status?: InputMaybe<EventStatus>;
  status_In?: InputMaybe<ReadonlyArray<InputMaybe<EventStatus>>>;
  subject?: InputMaybe<Scalars["Int"]["input"]>;
  templateId?: InputMaybe<Scalars["Int"]["input"]>;
  unscheduled?: InputMaybe<Scalars["Boolean"]["input"]>;
  usingRequiredTemplateOfValidPrograms?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
};

export type CalendarMeetingGroupNodeParticipantsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type CalendarMeetingGroupNodeTemplateSeriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CalendarMeetingGroupNodeTopicsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assignee?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasActionItems?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasArtifacts?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDecisions?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDocuments?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasGoals?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInFlowId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInMeetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<TopicState>;
  titleContains?: InputMaybe<Scalars["String"]["input"]>;
  topicIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type CalendarMeetingGroupNodeConnection = {
  readonly __typename: "CalendarMeetingGroupNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CalendarMeetingGroupNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `CalendarMeetingGroupNode` and its cursor. */
export type CalendarMeetingGroupNodeEdge = {
  readonly __typename: "CalendarMeetingGroupNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<CalendarMeetingGroupNode>;
};

export type CalibrationGroupNode = DjangoNode &
  Node & {
    readonly __typename: "CalibrationGroupNode";
    readonly approvers?: Maybe<ReadonlyArray<Maybe<UserNode>>>;
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly complianceProgram: ComplianceProgramNode;
    readonly id: Scalars["ID"]["output"];
    readonly managers?: Maybe<ReadonlyArray<Maybe<UserNode>>>;
    readonly name: Scalars["String"]["output"];
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly users?: Maybe<ReadonlyArray<Maybe<UserNode>>>;
  };

export type CalibrationGroupNodeConnection = {
  readonly __typename: "CalibrationGroupNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CalibrationGroupNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `CalibrationGroupNode` and its cursor. */
export type CalibrationGroupNodeEdge = {
  readonly __typename: "CalibrationGroupNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<CalibrationGroupNode>;
};

/** Stop the active Ask AI generation without touching chat messages. */
export type CancelChatbotSessionMutation = {
  readonly __typename: "CancelChatbotSessionMutation";
  readonly chatSession?: Maybe<ChatSessionNode>;
};

export type CancelMeetingMutation = {
  readonly __typename: "CancelMeetingMutation";
  readonly meeting?: Maybe<MeetingNode>;
};

export type CareerTrackNode = DjangoNode &
  Node & {
    readonly __typename: "CareerTrackNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly id: Scalars["ID"]["output"];
    readonly organization?: Maybe<OrganizationNode>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly roles: CareerTrackRoleNodeConnection;
    readonly team?: Maybe<TeamNode>;
    readonly title: Scalars["String"]["output"];
  };

export type CareerTrackNodeRolesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CareerTrackNodeConnection = {
  readonly __typename: "CareerTrackNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CareerTrackNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `CareerTrackNode` and its cursor. */
export type CareerTrackNodeEdge = {
  readonly __typename: "CareerTrackNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<CareerTrackNode>;
};

export type CareerTrackRoleInput = {
  readonly assignToUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  readonly id?: InputMaybe<Scalars["Int"]["input"]>;
  readonly level?: InputMaybe<Scalars["Int"]["input"]>;
  readonly responsibilities?: InputMaybe<
    ReadonlyArray<InputMaybe<RoleResponsibilityInput>>
  >;
  readonly roleSpecificCriteria?: InputMaybe<
    ReadonlyArray<InputMaybe<CompetencyCriteriaInput>>
  >;
  readonly roleType?: InputMaybe<CareerTrackRoleType>;
  readonly title?: InputMaybe<Scalars["String"]["input"]>;
};

export type CareerTrackRoleNode = DjangoNode &
  Node & {
    readonly __typename: "CareerTrackRoleNode";
    readonly assignedUsers: UserNodeConnection;
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly careerTrack: CareerTrackNode;
    readonly competencies: CompetencyConnection;
    readonly developmentGoals?: Maybe<GoalArtifactConnection>;
    readonly id: Scalars["ID"]["output"];
    readonly level: Scalars["Int"]["output"];
    readonly nextRole?: Maybe<CareerTrackRoleNode>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly responsibilities: CareerTrackRoleResponsibilityNodeConnection;
    readonly responsibilityAverageAssessmentAnswersByProgram: ReadonlyArray<
      Maybe<AverageAssessmentAnswersByProgramNode>
    >;
    readonly roleType: CareerTrackRoleType;
    readonly title: Scalars["String"]["output"];
  };

export type CareerTrackRoleNodeAssignedUsersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type CareerTrackRoleNodeCompetenciesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CareerTrackRoleNodeDevelopmentGoalsArgs = {
  actionItemAssignedToMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignees?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  actionItemDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  actionItemProgress?: InputMaybe<Scalars["Float"]["input"]>;
  actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemStates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  ancestorsOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  artifactTypes?: InputMaybe<ReadonlyArray<InputMaybe<ArtifactType>>>;
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  asUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  assignedToMembersOfOrganizationId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  completedActionItemsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedActionItemsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  createdByIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  createdInMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackSenders?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackState?: InputMaybe<FeedbackState>;
  feedbackStates?: InputMaybe<ReadonlyArray<InputMaybe<FeedbackState>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  goalCompetencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalContributors?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalInvolvingUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalParentIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalResponsibilityIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalScope?: InputMaybe<GoalScope>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalState?: InputMaybe<GoalState>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalStatus?: InputMaybe<GoalStatus>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalVisibility?: InputMaybe<GoalVisibility>;
  goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  groupBy?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  isStale?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValue?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionReceivedByMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CareerTrackRoleNodeResponsibilitiesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CareerTrackRoleNodeResponsibilityAverageAssessmentAnswersByProgramArgs =
  {
    targetId: Scalars["Int"]["input"];
  };

export type CareerTrackRoleNodeConnection = {
  readonly __typename: "CareerTrackRoleNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CareerTrackRoleNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `CareerTrackRoleNode` and its cursor. */
export type CareerTrackRoleNodeEdge = {
  readonly __typename: "CareerTrackRoleNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<CareerTrackRoleNode>;
};

export type CareerTrackRoleResponsibilityNode = DjangoNode &
  Node & {
    readonly __typename: "CareerTrackRoleResponsibilityNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly content: Scalars["JSONString"]["output"];
    readonly id: Scalars["ID"]["output"];
    readonly ordinal: Scalars["Int"]["output"];
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly role: CareerTrackRoleNode;
  };

export type CareerTrackRoleResponsibilityNodeConnection = {
  readonly __typename: "CareerTrackRoleResponsibilityNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CareerTrackRoleResponsibilityNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `CareerTrackRoleResponsibilityNode` and its cursor. */
export type CareerTrackRoleResponsibilityNodeEdge = {
  readonly __typename: "CareerTrackRoleResponsibilityNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<CareerTrackRoleResponsibilityNode>;
};

/** An enumeration. */
export enum CareerTrackRoleType {
  Ic = "ic",
  Management = "management",
}

export type ChangeBotRecordingStatusMutation = {
  readonly __typename: "ChangeBotRecordingStatusMutation";
  readonly meeting?: Maybe<MeetingNode>;
};

export type ChangedFieldRelatedObjectUnion =
  | BaseArtifactNode
  | CareerTrackRoleNode
  | CommentNode
  | CompetencyNode
  | KeyResultNode
  | TopicNode
  | UserNode;

export type ChatMessageConnection = {
  readonly __typename: "ChatMessageConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ChatMessageEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `ChatMessage` and its cursor. */
export type ChatMessageEdge = {
  readonly __typename: "ChatMessageEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<ChatMessageNode>;
};

export type ChatMessageNode = {
  readonly __typename: "ChatMessageNode";
  readonly autogenerated?: Maybe<Scalars["Boolean"]["output"]>;
  readonly content: Scalars["String"]["output"];
  readonly contextEndDate?: Maybe<Scalars["Date"]["output"]>;
  readonly contextMeetings?: Maybe<MeetingNodeConnection>;
  readonly contextStartDate?: Maybe<Scalars["Date"]["output"]>;
  readonly createdArtifact?: Maybe<ArtifactInterface>;
  readonly error?: Maybe<Scalars["Boolean"]["output"]>;
  readonly id: Scalars["String"]["output"];
  readonly imageUrls: ReadonlyArray<Scalars["String"]["output"]>;
  readonly isStreaming?: Maybe<Scalars["Boolean"]["output"]>;
  readonly role: ChatbotRoleEnum;
  readonly toolCalls?: Maybe<ReadonlyArray<Maybe<ChatToolCallNode>>>;
};

export type ChatMessageNodeContextMeetingsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  draft?: InputMaybe<Scalars["Boolean"]["input"]>;
  endDatetime?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  excludeMeetingGroupIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  fromMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  ignored?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFinalized?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFormalOneonone?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  minimumDateRange?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Decimal"]["input"]>;
  participantCount?: InputMaybe<Scalars["Int"]["input"]>;
  participants?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  startDatetime?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  status?: InputMaybe<EventStatus>;
  status_In?: InputMaybe<ReadonlyArray<InputMaybe<EventStatus>>>;
  subject?: InputMaybe<Scalars["Int"]["input"]>;
  templateId?: InputMaybe<Scalars["Int"]["input"]>;
  unscheduled?: InputMaybe<Scalars["Boolean"]["input"]>;
  usingRequiredTemplateOfValidPrograms?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
};

export type ChatSessionMessageReactionConnection = {
  readonly __typename: "ChatSessionMessageReactionConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ChatSessionMessageReactionEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `ChatSessionMessageReaction` and its cursor. */
export type ChatSessionMessageReactionEdge = {
  readonly __typename: "ChatSessionMessageReactionEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<ChatSessionMessageReactionNode>;
};

export type ChatSessionMessageReactionNode = DjangoNode &
  Node & {
    readonly __typename: "ChatSessionMessageReactionNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly comment?: Maybe<Scalars["String"]["output"]>;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator?: Maybe<UserNode>;
    readonly id: Scalars["ID"]["output"];
    readonly messageId: Scalars["String"]["output"];
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly reactionType: ChatSessionReactionType;
    readonly updated: Scalars["DateTime"]["output"];
  };

export type ChatSessionNode = DjangoNode &
  Node & {
    readonly __typename: "ChatSessionNode";
    readonly assessment?: Maybe<AssessmentNode>;
    readonly assessmentId?: Maybe<Scalars["Int"]["output"]>;
    readonly assessmentQuestion?: Maybe<AssessmentQuestionInterface>;
    readonly assessmentQuestionId?: Maybe<Scalars["Int"]["output"]>;
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator?: Maybe<UserNode>;
    readonly id: Scalars["ID"]["output"];
    readonly isIncognito: Scalars["Boolean"]["output"];
    readonly meeting?: Maybe<MeetingNode>;
    readonly messages: ChatMessageConnection;
    readonly pinnedAt?: Maybe<Scalars["DateTime"]["output"]>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly reactions: ChatSessionMessageReactionConnection;
    readonly title?: Maybe<Scalars["String"]["output"]>;
    readonly updated?: Maybe<Scalars["DateTime"]["output"]>;
  };

export type ChatSessionNodeMessagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  role?: InputMaybe<Scalars["String"]["input"]>;
};

export type ChatSessionNodeReactionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ChatSessionNodeConnection = {
  readonly __typename: "ChatSessionNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ChatSessionNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `ChatSessionNode` and its cursor. */
export type ChatSessionNodeEdge = {
  readonly __typename: "ChatSessionNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<ChatSessionNode>;
};

/** An enumeration. */
export enum ChatSessionReactionType {
  ThumbsDown = "thumbs_down",
  ThumbsUp = "thumbs_up",
}

export type ChatToolCallNode = {
  readonly __typename: "ChatToolCallNode";
  readonly arguments?: Maybe<Scalars["String"]["output"]>;
  readonly output?: Maybe<Scalars["String"]["output"]>;
  readonly resultCount?: Maybe<Scalars["Int"]["output"]>;
  readonly toolName: Scalars["String"]["output"];
};

export enum ChatbotRoleEnum {
  Assistant = "assistant",
  System = "system",
  User = "user",
}

export type ChatbotSkillType = {
  readonly __typename: "ChatbotSkillType";
  readonly description: Scalars["String"]["output"];
  readonly name: Scalars["String"]["output"];
};

export type ClickupTaskNode = InfoCardInterface & {
  readonly __typename: "ClickupTaskNode";
  readonly assignees: ReadonlyArray<Maybe<ExternalProfileNode>>;
  readonly closedAt?: Maybe<Scalars["DateTime"]["output"]>;
  readonly created: Scalars["DateTime"]["output"];
  readonly description?: Maybe<Scalars["String"]["output"]>;
  readonly id: Scalars["ID"]["output"];
  readonly providerName?: Maybe<Scalars["String"]["output"]>;
  readonly status?: Maybe<InfoTaskStatus>;
  readonly title: Scalars["String"]["output"];
  readonly url: Scalars["String"]["output"];
};

export type CoachingActionNode = {
  readonly __typename: "CoachingActionNode";
  readonly label?: Maybe<ActionLabel>;
  readonly text?: Maybe<Scalars["String"]["output"]>;
  readonly variant?: Maybe<ActionVariant>;
};

export type CoachingAgendaItemNode = {
  readonly __typename: "CoachingAgendaItemNode";
  readonly opener?: Maybe<Scalars["String"]["output"]>;
  readonly tags?: Maybe<ReadonlyArray<Maybe<Scalars["String"]["output"]>>>;
  readonly topic?: Maybe<Scalars["String"]["output"]>;
};

export type CoachingAgendaNode = {
  readonly __typename: "CoachingAgendaNode";
  readonly nextMeeting?: Maybe<ReadonlyArray<Maybe<CoachingAgendaItemNode>>>;
  readonly phasedPlan?: Maybe<ReadonlyArray<Maybe<CoachingPhasedMeetingNode>>>;
};

export type CoachingDashboardItemNode = {
  readonly __typename: "CoachingDashboardItemNode";
  readonly detail?: Maybe<Scalars["String"]["output"]>;
  readonly dimension?: Maybe<Scalars["String"]["output"]>;
  readonly status?: Maybe<DimensionStatus>;
  readonly statusLabel?: Maybe<Scalars["String"]["output"]>;
};

export type CoachingDataCountsNode = {
  readonly __typename: "CoachingDataCountsNode";
  readonly checkins?: Maybe<Scalars["Int"]["output"]>;
  readonly goals?: Maybe<Scalars["Int"]["output"]>;
  readonly meetings?: Maybe<Scalars["Int"]["output"]>;
  readonly recognitions?: Maybe<Scalars["Int"]["output"]>;
  readonly workSummaries?: Maybe<Scalars["Int"]["output"]>;
};

export type CoachingDimensionNode = {
  readonly __typename: "CoachingDimensionNode";
  readonly insights?: Maybe<ReadonlyArray<Maybe<CoachingInsightNode>>>;
  readonly name?: Maybe<Scalars["String"]["output"]>;
  readonly status?: Maybe<DimensionStatus>;
};

export type CoachingEvidenceNode = {
  readonly __typename: "CoachingEvidenceNode";
  readonly sourceRef?: Maybe<Scalars["String"]["output"]>;
  readonly sourceTitle?: Maybe<Scalars["String"]["output"]>;
  readonly sourceUrl?: Maybe<Scalars["String"]["output"]>;
  readonly text?: Maybe<Scalars["String"]["output"]>;
};

export type CoachingInsightNode = {
  readonly __typename: "CoachingInsightNode";
  readonly action?: Maybe<CoachingActionNode>;
  readonly body?: Maybe<Scalars["String"]["output"]>;
  readonly evidence?: Maybe<ReadonlyArray<Maybe<CoachingEvidenceNode>>>;
  readonly priority?: Maybe<InsightPriority>;
  readonly title?: Maybe<Scalars["String"]["output"]>;
  readonly topics?: Maybe<CoachingInsightTopicNode>;
};

export type CoachingInsightTopicNode = {
  readonly __typename: "CoachingInsightTopicNode";
  readonly notes?: Maybe<ReadonlyArray<Maybe<Scalars["String"]["output"]>>>;
  readonly title?: Maybe<Scalars["String"]["output"]>;
};

export type CoachingMetaNode = {
  readonly __typename: "CoachingMetaNode";
  readonly dataCounts?: Maybe<CoachingDataCountsNode>;
  readonly generated?: Maybe<Scalars["String"]["output"]>;
  readonly manager?: Maybe<CoachingMetaUserNode>;
  readonly period?: Maybe<CoachingPeriodNode>;
  readonly report?: Maybe<CoachingMetaReportNode>;
};

export type CoachingMetaReportNode = {
  readonly __typename: "CoachingMetaReportNode";
  readonly firstName?: Maybe<Scalars["String"]["output"]>;
  readonly name?: Maybe<Scalars["String"]["output"]>;
  readonly role?: Maybe<Scalars["String"]["output"]>;
  readonly tenure?: Maybe<Scalars["String"]["output"]>;
};

export type CoachingMetaUserNode = {
  readonly __typename: "CoachingMetaUserNode";
  readonly firstName?: Maybe<Scalars["String"]["output"]>;
  readonly name?: Maybe<Scalars["String"]["output"]>;
};

export type CoachingPeriodNode = {
  readonly __typename: "CoachingPeriodNode";
  readonly end?: Maybe<Scalars["String"]["output"]>;
  readonly start?: Maybe<Scalars["String"]["output"]>;
};

export type CoachingPhasedMeetingNode = {
  readonly __typename: "CoachingPhasedMeetingNode";
  readonly meeting?: Maybe<Scalars["String"]["output"]>;
  readonly theme?: Maybe<Scalars["String"]["output"]>;
  readonly topics?: Maybe<ReadonlyArray<Maybe<Scalars["String"]["output"]>>>;
};

export type CoachingReportNode = DjangoNode &
  Node & {
    readonly __typename: "CoachingReportNode";
    readonly agenda?: Maybe<CoachingAgendaNode>;
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly created: Scalars["DateTime"]["output"];
    readonly dashboard?: Maybe<ReadonlyArray<Maybe<CoachingDashboardItemNode>>>;
    readonly dimensions?: Maybe<ReadonlyArray<Maybe<CoachingDimensionNode>>>;
    readonly id: Scalars["ID"]["output"];
    readonly manager: UserNode;
    readonly meta?: Maybe<CoachingMetaNode>;
    readonly modified: Scalars["DateTime"]["output"];
    readonly organization: OrganizationNode;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly reportEndDate: Scalars["Date"]["output"];
    readonly reportStartDate: Scalars["Date"]["output"];
    readonly sources?: Maybe<ReadonlyArray<Maybe<CoachingSourceNode>>>;
    readonly subject: UserNode;
  };

export type CoachingSourceNode = {
  readonly __typename: "CoachingSourceNode";
  readonly sourceRef?: Maybe<Scalars["String"]["output"]>;
  readonly sourceUrl?: Maybe<Scalars["String"]["output"]>;
  readonly title?: Maybe<Scalars["String"]["output"]>;
  readonly type?: Maybe<SourceType>;
};

export type CommentNode = DjangoNode &
  Node & {
    readonly __typename: "CommentNode";
    readonly artifact?: Maybe<ArtifactInterface>;
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly comment?: Maybe<Scalars["JSONString"]["output"]>;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator?: Maybe<UserNode>;
    readonly deleted?: Maybe<Scalars["Boolean"]["output"]>;
    readonly id: Scalars["ID"]["output"];
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly textUuid?: Maybe<Scalars["String"]["output"]>;
    readonly topic?: Maybe<TopicNode>;
  };

export type CommentNodeConnection = {
  readonly __typename: "CommentNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `CommentNode` and its cursor. */
export type CommentNodeEdge = {
  readonly __typename: "CommentNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommentNode>;
};

/** An enumeration. */
export enum CompetencyAppliesTo {
  AllRoles = "all_roles",
  SomeRoles = "some_roles",
}

export type CompetencyAssessmentAnswerNode = AssessmentAnswerInterface & {
  readonly __typename: "CompetencyAssessmentAnswerNode";
  readonly assessment: AssessmentNode;
  readonly calibrations: AssessmentAnswerCalibrationConnection;
  readonly canDelete: PermissionNode;
  readonly canRead: PermissionNode;
  readonly canUpdate: PermissionNode;
  readonly comment?: Maybe<Scalars["JSONString"]["output"]>;
  readonly created: Scalars["DateTime"]["output"];
  readonly hasCalibrationSuggestions: Scalars["Boolean"]["output"];
  readonly hasCalibrations: Scalars["Boolean"]["output"];
  readonly id: Scalars["Int"]["output"];
  readonly integerAnswer?: Maybe<Scalars["Int"]["output"]>;
  readonly isLocked: Scalars["Boolean"]["output"];
  readonly question: AssessmentQuestionInterface;
  readonly questionId: Scalars["Int"]["output"];
  readonly responder?: Maybe<UserNode>;
  readonly roleId: Scalars["Int"]["output"];
  readonly updated: Scalars["DateTime"]["output"];
};

export type CompetencyAssessmentAnswerNodeCalibrationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CompetencyAssessmentQuestionNode = AssessmentQuestionInterface & {
  readonly __typename: "CompetencyAssessmentQuestionNode";
  readonly answers: AssessmentAnswerConnection;
  readonly answersExist: Scalars["Boolean"]["output"];
  readonly archived: Scalars["Boolean"]["output"];
  readonly canDelete: PermissionNode;
  readonly canRead: PermissionNode;
  readonly canUpdate: PermissionNode;
  readonly categories: AssessmentQuestionCategoryNodeConnection;
  readonly comment: AssessmentQuestionComment;
  readonly competency: CompetencyNode;
  readonly created: Scalars["DateTime"]["output"];
  readonly creator?: Maybe<UserNode>;
  readonly description?: Maybe<Scalars["JSONString"]["output"]>;
  readonly endValue: Scalars["Int"]["output"];
  readonly id: Scalars["Int"]["output"];
  readonly isResponseMandatory: Scalars["Boolean"]["output"];
  readonly labelDescriptions: ReadonlyArray<Maybe<Scalars["String"]["output"]>>;
  readonly labels: ReadonlyArray<Maybe<Scalars["String"]["output"]>>;
  readonly organization: OrganizationNode;
  readonly questionType: AssessmentQuestionType;
  readonly responseVisibility: AssessmentQuestionResponseVisibility;
  readonly responses: AssessmentQuestionResponses;
  readonly role: CareerTrackRoleNode;
  readonly startValue: Scalars["Int"]["output"];
  readonly title: Scalars["String"]["output"];
  readonly updated: Scalars["DateTime"]["output"];
};

export type CompetencyAssessmentQuestionNodeAnswersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CompetencyAssessmentQuestionNodeCategoriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

/** An enumeration. */
export enum CompetencyAssessmentType {
  CriteriaCombined = "criteria_combined",
  IndividualCriteria = "individual_criteria",
}

export type CompetencyConnection = {
  readonly __typename: "CompetencyConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CompetencyEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

export type CompetencyCriteriaAssessmentAnswerNode =
  AssessmentAnswerInterface & {
    readonly __typename: "CompetencyCriteriaAssessmentAnswerNode";
    readonly assessment: AssessmentNode;
    readonly calibrations: AssessmentAnswerCalibrationConnection;
    readonly canDelete: PermissionNode;
    readonly canRead: PermissionNode;
    readonly canUpdate: PermissionNode;
    readonly comment?: Maybe<Scalars["JSONString"]["output"]>;
    readonly created: Scalars["DateTime"]["output"];
    readonly hasCalibrationSuggestions: Scalars["Boolean"]["output"];
    readonly hasCalibrations: Scalars["Boolean"]["output"];
    readonly id: Scalars["Int"]["output"];
    readonly integerAnswer?: Maybe<Scalars["Int"]["output"]>;
    readonly isLocked: Scalars["Boolean"]["output"];
    readonly question: AssessmentQuestionInterface;
    readonly questionId: Scalars["Int"]["output"];
    readonly responder?: Maybe<UserNode>;
    readonly roleId: Scalars["Int"]["output"];
    readonly updated: Scalars["DateTime"]["output"];
  };

export type CompetencyCriteriaAssessmentAnswerNodeCalibrationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CompetencyCriteriaAssessmentQuestionNode =
  AssessmentQuestionInterface & {
    readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
    readonly answers: AssessmentAnswerConnection;
    readonly answersExist: Scalars["Boolean"]["output"];
    readonly archived: Scalars["Boolean"]["output"];
    readonly canDelete: PermissionNode;
    readonly canRead: PermissionNode;
    readonly canUpdate: PermissionNode;
    readonly categories: AssessmentQuestionCategoryNodeConnection;
    readonly comment: AssessmentQuestionComment;
    readonly competencyCriteria: CompetencyCriteriaNode;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator?: Maybe<UserNode>;
    readonly description?: Maybe<Scalars["JSONString"]["output"]>;
    readonly endValue: Scalars["Int"]["output"];
    readonly id: Scalars["Int"]["output"];
    readonly isResponseMandatory: Scalars["Boolean"]["output"];
    readonly labelDescriptions: ReadonlyArray<
      Maybe<Scalars["String"]["output"]>
    >;
    readonly labels: ReadonlyArray<Maybe<Scalars["String"]["output"]>>;
    readonly organization: OrganizationNode;
    readonly questionType: AssessmentQuestionType;
    readonly responseVisibility: AssessmentQuestionResponseVisibility;
    readonly responses: AssessmentQuestionResponses;
    readonly role: CareerTrackRoleNode;
    readonly startValue: Scalars["Int"]["output"];
    readonly title: Scalars["String"]["output"];
    readonly updated: Scalars["DateTime"]["output"];
  };

export type CompetencyCriteriaAssessmentQuestionNodeAnswersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CompetencyCriteriaAssessmentQuestionNodeCategoriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CompetencyCriteriaConnection = {
  readonly __typename: "CompetencyCriteriaConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CompetencyCriteriaEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `CompetencyCriteria` and its cursor. */
export type CompetencyCriteriaEdge = {
  readonly __typename: "CompetencyCriteriaEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<CompetencyCriteriaNode>;
};

export type CompetencyCriteriaInput = {
  readonly competencyId?: InputMaybe<Scalars["Int"]["input"]>;
  readonly content?: InputMaybe<Scalars["String"]["input"]>;
  readonly id?: InputMaybe<Scalars["Int"]["input"]>;
  readonly level?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CompetencyCriteriaNode = {
  readonly __typename: "CompetencyCriteriaNode";
  readonly competency: CompetencyNode;
  readonly content: Scalars["JSONString"]["output"];
  readonly id: Scalars["Int"]["output"];
  readonly level: Scalars["Int"]["output"];
  readonly pk: Scalars["Int"]["output"];
};

/** An enumeration. */
export enum CompetencyCriteriaUniqueness {
  DifferentForEachRole = "different_for_each_role",
  SameAcrossRoles = "same_across_roles",
}

/** A Relay edge containing a `Competency` and its cursor. */
export type CompetencyEdge = {
  readonly __typename: "CompetencyEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<CompetencyNode>;
};

export type CompetencyNode = {
  readonly __typename: "CompetencyNode";
  readonly appliesTo: CompetencyAppliesTo;
  readonly appliesToCareerTracks: CareerTrackNodeConnection;
  readonly appliesToIcRoles: Scalars["Boolean"]["output"];
  readonly appliesToManagementRoles: Scalars["Boolean"]["output"];
  readonly appliesToTeams: TeamNodeConnection;
  readonly averageAssessmentAnswersByProgram: ReadonlyArray<
    Maybe<AverageAssessmentAnswersByProgramNode>
  >;
  readonly criteria: CompetencyCriteriaConnection;
  readonly criteriaUniqueness: CompetencyCriteriaUniqueness;
  readonly description: Scalars["JSONString"]["output"];
  readonly developmentGoals?: Maybe<GoalArtifactConnection>;
  readonly id: Scalars["ID"]["output"];
  readonly pk: Scalars["Int"]["output"];
  readonly title: Scalars["String"]["output"];
};

export type CompetencyNodeAppliesToCareerTracksArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CompetencyNodeAppliesToTeamsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organization?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  title_Startswith?: InputMaybe<Scalars["String"]["input"]>;
};

export type CompetencyNodeAverageAssessmentAnswersByProgramArgs = {
  roleId: Scalars["Int"]["input"];
  targetId: Scalars["Int"]["input"];
};

export type CompetencyNodeCriteriaArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CompetencyNodeDevelopmentGoalsArgs = {
  actionItemAssignedToMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignees?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  actionItemDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  actionItemProgress?: InputMaybe<Scalars["Float"]["input"]>;
  actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemStates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  ancestorsOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  artifactTypes?: InputMaybe<ReadonlyArray<InputMaybe<ArtifactType>>>;
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  asUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  assignedToMembersOfOrganizationId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  completedActionItemsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedActionItemsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  createdByIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  createdInMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackSenders?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackState?: InputMaybe<FeedbackState>;
  feedbackStates?: InputMaybe<ReadonlyArray<InputMaybe<FeedbackState>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  goalCompetencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalContributors?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalInvolvingUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalParentIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalResponsibilityIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalScope?: InputMaybe<GoalScope>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalState?: InputMaybe<GoalState>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalStatus?: InputMaybe<GoalStatus>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalVisibility?: InputMaybe<GoalVisibility>;
  goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  groupBy?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  isStale?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValue?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionReceivedByMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
};

/** An enumeration. */
export enum ComplianceProgramAppliesTo {
  CreatorDirectReports = "creator_direct_reports",
  CreatorManagementTree = "creator_management_tree",
  Departments = "departments",
  Ics = "ics",
  Managers = "managers",
  Organization = "organization",
  ReportsTo = "reports_to",
  Users = "users",
}

/** An enumeration. */
export enum ComplianceProgramCalibrationStatus {
  Calibrated = "calibrated",
  NotStarted = "not_started",
}

/** An enumeration. */
export enum ComplianceProgramCalibrationType {
  Off = "off",
  PostCalibration = "post_calibration",
  PreCalibration = "pre_calibration",
}

export type ComplianceProgramNode = DjangoNode &
  Node & {
    readonly __typename: "ComplianceProgramNode";
    readonly applicableUsers: UserNodeConnection;
    readonly appliesTo: ComplianceProgramAppliesTo;
    readonly appliesToManagers: UserNodeConnection;
    readonly appliesToTeams: TeamNodeConnection;
    readonly appliesToUsers: UserNodeConnection;
    readonly assessmentDeliveries: AssessmentDeliveryNodeConnection;
    readonly assessmentSubmissions: ReadonlyArray<
      Maybe<AssessmentSubmissionNode>
    >;
    readonly assessments: AssessmentNodeConnection;
    readonly assessmentsOpenForNominations: AssessmentOpenForNominationConnection;
    readonly availableAppliesToUpdates?: Maybe<ProgramAppliesToUpdatesNode>;
    readonly calibration: ComplianceProgramCalibrationType;
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canReadDetails: PermissionNode;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator?: Maybe<UserNode>;
    readonly dueDate?: Maybe<Scalars["Date"]["output"]>;
    readonly engagementSurveyReport?: Maybe<EngagementSurveyReportNode>;
    readonly engagementSurveyTemplate?: Maybe<AssessmentTemplateNode>;
    readonly excludedHireDateAfter?: Maybe<Scalars["Date"]["output"]>;
    readonly excludedUsers: UserNodeConnection;
    readonly hasAccessToAppliesToUsers: Scalars["Boolean"]["output"];
    readonly id: Scalars["ID"]["output"];
    readonly managerAssessmentTemplate?: Maybe<AssessmentTemplateNode>;
    readonly managerEffectivenessReport: ManagerEffectivenessReportConnection;
    readonly matchingOneonones?: Maybe<MeetingNodeConnection>;
    readonly nominationsForUser: AssessmentNominationNodeConnection;
    readonly ongoing: Scalars["Boolean"]["output"];
    readonly participantStatus: ParticipantStatusConnection;
    readonly peerAssessmentTemplate?: Maybe<AssessmentTemplateNode>;
    readonly performanceAssessmentTemplate?: Maybe<AssessmentTemplateNode>;
    readonly performanceReportRows: PerformanceReviewReportRowConnection;
    readonly periodEndDate?: Maybe<Scalars["Date"]["output"]>;
    readonly periodStartDate?: Maybe<Scalars["Date"]["output"]>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly recurrence: ComplianceProgramRecurrence;
    readonly requiredTopicTemplates: TopicTemplateNodeConnection;
    readonly scheduledReminders: ComplianceProgramScheduledReminderNodeConnection;
    readonly startDate?: Maybe<Scalars["Date"]["output"]>;
    readonly startDateDueDateOffset: Scalars["Int"]["output"];
    readonly startDateOffset: Scalars["Int"]["output"];
    readonly startDatePeriodEndOffset: Scalars["Int"]["output"];
    readonly startDatePeriodStartOffset: Scalars["Int"]["output"];
    readonly state: ComplianceProgramState;
    readonly steps: ReadonlyArray<Maybe<ComplianceProgramStepConfigNode>>;
    readonly title: Scalars["String"]["output"];
    readonly updated: Scalars["DateTime"]["output"];
    readonly usersMissingAssessment: MissingAssessmentConnection;
  };

export type ComplianceProgramNodeApplicableUsersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type ComplianceProgramNodeAppliesToManagersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type ComplianceProgramNodeAppliesToTeamsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organization?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  title_Startswith?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComplianceProgramNodeAppliesToUsersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type ComplianceProgramNodeAssessmentDeliveriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  complianceProgramId?: InputMaybe<Scalars["Int"]["input"]>;
  creatorId?: InputMaybe<Scalars["Int"]["input"]>;
  excludedProgramIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  state_In?: InputMaybe<ReadonlyArray<InputMaybe<AssessmentDeliveryState>>>;
  targetId?: InputMaybe<Scalars["Int"]["input"]>;
  targetIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type ComplianceProgramNodeAssessmentSubmissionsArgs = {
  targetId: Scalars["Int"]["input"];
};

export type ComplianceProgramNodeAssessmentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assessmentType?: InputMaybe<AssessmentType>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  responderId?: InputMaybe<Scalars["Int"]["input"]>;
  selfAssessment?: InputMaybe<Scalars["Boolean"]["input"]>;
  state?: InputMaybe<AssessmentState>;
  targetId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ComplianceProgramNodeAssessmentsOpenForNominationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  targetId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ComplianceProgramNodeEngagementSurveyReportArgs = {
  collapsedKeys?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
  >;
  employeeStartDateRange?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
  >;
  groupBy: EngagementSurveyReportGroupBy;
  locations?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  managerIdsFullTree?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type ComplianceProgramNodeExcludedUsersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type ComplianceProgramNodeManagerEffectivenessReportArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ComplianceProgramNodeMatchingOneononesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  draft?: InputMaybe<Scalars["Boolean"]["input"]>;
  endDatetime?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  excludeMeetingGroupIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  fromMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  ignored?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFinalized?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFormalOneonone?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  minimumDateRange?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Decimal"]["input"]>;
  participantCount?: InputMaybe<Scalars["Int"]["input"]>;
  participants?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  startDatetime?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  status?: InputMaybe<EventStatus>;
  status_In?: InputMaybe<ReadonlyArray<InputMaybe<EventStatus>>>;
  subject?: InputMaybe<Scalars["Int"]["input"]>;
  templateId?: InputMaybe<Scalars["Int"]["input"]>;
  unscheduled?: InputMaybe<Scalars["Boolean"]["input"]>;
  usingRequiredTemplateOfValidPrograms?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
};

export type ComplianceProgramNodeNominationsForUserArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ComplianceProgramNodeParticipantStatusArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ComplianceProgramNodePerformanceReportRowsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ComplianceProgramNodeRequiredTopicTemplatesArgs = {
  adhocTemplate?: InputMaybe<Scalars["Boolean"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  globalTemplate?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasRequirements?: InputMaybe<Scalars["Boolean"]["input"]>;
  includesRatingId?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  publicTemplate?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ComplianceProgramNodeScheduledRemindersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ComplianceProgramNodeUsersMissingAssessmentArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  targetId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ComplianceProgramNodeConnection = {
  readonly __typename: "ComplianceProgramNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ComplianceProgramNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `ComplianceProgramNode` and its cursor. */
export type ComplianceProgramNodeEdge = {
  readonly __typename: "ComplianceProgramNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<ComplianceProgramNode>;
};

/** An enumeration. */
export enum ComplianceProgramNotificationPreference {
  Email = "email",
  Slack = "slack",
  Teams = "teams",
}

/** An enumeration. */
export enum ComplianceProgramParticipantStatus {
  Complete = "complete",
  InProgress = "in_progress",
  NotApplicable = "not_applicable",
  NotStarted = "not_started",
}

/** An enumeration. */
export enum ComplianceProgramRecurrence {
  Monthly = "monthly",
  None = "none",
  Quarterly = "quarterly",
  Yearly = "yearly",
}

export type ComplianceProgramReportingViewNode = DjangoNode &
  Node & {
    readonly __typename: "ComplianceProgramReportingViewNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly id: Scalars["ID"]["output"];
    readonly name?: Maybe<Scalars["String"]["output"]>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly viewOptions: Scalars["JSONString"]["output"];
  };

export type ComplianceProgramReportingViewNodeConnection = {
  readonly __typename: "ComplianceProgramReportingViewNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ComplianceProgramReportingViewNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `ComplianceProgramReportingViewNode` and its cursor. */
export type ComplianceProgramReportingViewNodeEdge = {
  readonly __typename: "ComplianceProgramReportingViewNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<ComplianceProgramReportingViewNode>;
};

export type ComplianceProgramScheduledReminderNode = DjangoNode &
  Node & {
    readonly __typename: "ComplianceProgramScheduledReminderNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly complianceProgram: ComplianceProgramNode;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator: UserNode;
    /** The number of days after the program start date to send the reminder */
    readonly daysAfterStartDate: Scalars["Int"]["output"];
    readonly emailNotification: Scalars["Boolean"]["output"];
    readonly engagementSurvey: Scalars["Boolean"]["output"];
    readonly id: Scalars["ID"]["output"];
    readonly managerAssessment: Scalars["Boolean"]["output"];
    readonly message: Scalars["String"]["output"];
    readonly nominations: Scalars["Boolean"]["output"];
    readonly oneonone: Scalars["Boolean"]["output"];
    readonly peerAssessment: Scalars["Boolean"]["output"];
    readonly performanceAssessment: Scalars["Boolean"]["output"];
    readonly performanceSelfAssessment: Scalars["Boolean"]["output"];
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly remindedUsersCount: Scalars["Int"]["output"];
    /** The datetime when the reminder was sent and does not need to be sent anymore */
    readonly sentDatetime?: Maybe<Scalars["DateTime"]["output"]>;
    readonly slackNotification: Scalars["Boolean"]["output"];
    readonly teamsNotification: Scalars["Boolean"]["output"];
    readonly updated: Scalars["DateTime"]["output"];
  };

export type ComplianceProgramScheduledReminderNodeConnection = {
  readonly __typename: "ComplianceProgramScheduledReminderNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<
    Maybe<ComplianceProgramScheduledReminderNodeEdge>
  >;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `ComplianceProgramScheduledReminderNode` and its cursor. */
export type ComplianceProgramScheduledReminderNodeEdge = {
  readonly __typename: "ComplianceProgramScheduledReminderNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<ComplianceProgramScheduledReminderNode>;
};

/** An enumeration. */
export enum ComplianceProgramState {
  Draft = "draft",
  Paused = "paused",
  Published = "published",
}

/**
 *
 *     Defines the possible steps of a compliance program.
 *     Steps are different than AssessmentTypes since 1 AssessmentType may contain several steps,
 *     e.g. AssessmentType.performance = self, downward, calibrations, delivery
 *     The order of steps is implied by the enum value (1-9) and corresponds to
 *     the step ordering defined in the frontend program form.
 *
 */
export enum ComplianceProgramStep {
  Delivery = "delivery",
  DownwardReview = "downward_review",
  EngagementSurvey = "engagement_survey",
  OneOnOne = "one_on_one",
  PeerNomination = "peer_nomination",
  PeerReview = "peer_review",
  PostCalibration = "post_calibration",
  PreCalibration = "pre_calibration",
  SelfReview = "self_review",
  UpwardReview = "upward_review",
}

export type ComplianceProgramStepConfigNode = DjangoNode &
  Node & {
    readonly __typename: "ComplianceProgramStepConfigNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly dueDateOffset: Scalars["Int"]["output"];
    readonly id: Scalars["ID"]["output"];
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly step: ComplianceProgramStep;
  };

export type ComplianceProgramStepInput = {
  readonly dueDateOffset: Scalars["Int"]["input"];
  readonly step: ComplianceProgramStep;
};

export type ComplianceReportUserConnection = {
  readonly __typename: "ComplianceReportUserConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ComplianceReportUserEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `ComplianceReportUser` and its cursor. */
export type ComplianceReportUserEdge = {
  readonly __typename: "ComplianceReportUserEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<ComplianceReportUserNode>;
};

export type ComplianceReportUserNode = {
  readonly __typename: "ComplianceReportUserNode";
  readonly manager?: Maybe<UserNode>;
  readonly matchedMeeting?: Maybe<MeetingInfoNode>;
  readonly user?: Maybe<UserNode>;
};

export type ConvertSuggestedTopicToTopicMutation = {
  readonly __typename: "ConvertSuggestedTopicToTopicMutation";
  readonly meeting?: Maybe<MeetingNode>;
  readonly topic?: Maybe<TopicNode>;
};

export type CopyTopicsToMeetingMutation = {
  readonly __typename: "CopyTopicsToMeetingMutation";
  readonly copiedTopics?: Maybe<ReadonlyArray<Maybe<TopicNode>>>;
  readonly meeting?: Maybe<MeetingNode>;
};

/** An enumeration. */
export enum CoreUserSyncCredentialsByOrgDefaultEventVisibilityChoices {
  /** default */
  A_1 = "A_1",
  /** freebusy */
  A_2 = "A_2",
  /** public */
  A_3 = "A_3",
  /** hidden */
  A_4 = "A_4",
}

export type CreateAssessmentAnswerCalibration = {
  readonly __typename: "CreateAssessmentAnswerCalibration";
  readonly answer?: Maybe<AssessmentAnswerInterface>;
  readonly answerCalibration: AssessmentAnswerCalibrationInterface;
};

export type CreateChatbotMessageReactionMutation = {
  readonly __typename: "CreateChatbotMessageReactionMutation";
  readonly chatSession?: Maybe<ChatSessionNode>;
  readonly reaction?: Maybe<ChatSessionMessageReactionNode>;
};

export type CreateComplianceProgramScheduledReminderMutation = {
  readonly __typename: "CreateComplianceProgramScheduledReminderMutation";
  readonly complianceProgram?: Maybe<ComplianceProgramNode>;
  readonly reminder?: Maybe<ComplianceProgramScheduledReminderNode>;
};

export type CreateFeedbackRequestsMutation = {
  readonly __typename: "CreateFeedbackRequestsMutation";
  readonly feedbackArtifacts?: Maybe<
    ReadonlyArray<Maybe<FeedbackArtifactNode>>
  >;
};

export type CreateGoalCheckinMutation = {
  readonly __typename: "CreateGoalCheckinMutation";
  readonly checkinActivity?: Maybe<ArtifactActivityNode>;
  readonly goal?: Maybe<GoalArtifactNode>;
};

export type CreateInvitationsMutation = {
  readonly __typename: "CreateInvitationsMutation";
  readonly invitationErrors?: Maybe<ReadonlyArray<Maybe<InviteError>>>;
  readonly invitations?: Maybe<ReadonlyArray<Maybe<InvitationNode>>>;
};

/** Create a Magic Link token for Merge.dev integration for a specific integration */
export type CreateMergeLinkToken = {
  readonly __typename: "CreateMergeLinkToken";
  readonly endUserOriginId?: Maybe<Scalars["String"]["output"]>;
  readonly error?: Maybe<Scalars["String"]["output"]>;
  readonly integrationName?: Maybe<Scalars["String"]["output"]>;
  readonly linkToken?: Maybe<Scalars["String"]["output"]>;
  readonly success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type CreateOrUpdateArtifactMutation = {
  readonly __typename: "CreateOrUpdateArtifactMutation";
  readonly artifact?: Maybe<ArtifactInterface>;
  readonly topic?: Maybe<TopicNode>;
};

export type CreateOrUpdateAssessmentGroupMutation = {
  readonly __typename: "CreateOrUpdateAssessmentGroupMutation";
  readonly assessmentGroup?: Maybe<AssessmentGroupNode>;
};

export type CreateOrUpdateAssessmentMutation = {
  readonly __typename: "CreateOrUpdateAssessmentMutation";
  readonly assessment: AssessmentNode;
};

export type CreateOrUpdateAssessmentQuestionMutation = {
  readonly __typename: "CreateOrUpdateAssessmentQuestionMutation";
  readonly question?: Maybe<AssessmentQuestionInterface>;
};

export type CreateOrUpdateCalibrationGroupMutation = {
  readonly __typename: "CreateOrUpdateCalibrationGroupMutation";
  readonly calibrationGroup: CalibrationGroupNode;
};

export type CreateOrUpdateCareerTrackMutation = {
  readonly __typename: "CreateOrUpdateCareerTrackMutation";
  readonly careerTrack?: Maybe<CareerTrackNode>;
};

export type CreateOrUpdateCommentMutation = {
  readonly __typename: "CreateOrUpdateCommentMutation";
  readonly artifact?: Maybe<ArtifactInterface>;
  readonly comment?: Maybe<CommentNode>;
  readonly topic?: Maybe<TopicNode>;
};

export type CreateOrUpdateCompetencyMutation = {
  readonly __typename: "CreateOrUpdateCompetencyMutation";
  readonly competency?: Maybe<CompetencyNode>;
};

export type CreateOrUpdateComplianceProgramMutation = {
  readonly __typename: "CreateOrUpdateComplianceProgramMutation";
  readonly complianceProgram?: Maybe<ComplianceProgramNode>;
};

export type CreateOrUpdateComplianceProgramReportingViewMutation = {
  readonly __typename: "CreateOrUpdateComplianceProgramReportingViewMutation";
  readonly complianceProgramReportingView: ComplianceProgramReportingViewNode;
};

export type CreateOrUpdateCoreValueMutation = {
  readonly __typename: "CreateOrUpdateCoreValueMutation";
  readonly coreValue?: Maybe<RecognitionCoreValueNode>;
};

export type CreateOrUpdateExplorerBookmarkMutation = {
  readonly __typename: "CreateOrUpdateExplorerBookmarkMutation";
  readonly explorerBookmark?: Maybe<ExplorerFilterBookmarkNode>;
  readonly user?: Maybe<UserNode>;
};

export type CreateOrUpdateFavouritesGroupMutation = {
  readonly __typename: "CreateOrUpdateFavouritesGroupMutation";
  readonly favouritesGroup?: Maybe<FavouritesGroupNode>;
};

export type CreateOrUpdateFlowMutation = {
  readonly __typename: "CreateOrUpdateFlowMutation";
  readonly flow?: Maybe<FlowNode>;
};

export type CreateOrUpdateFullAssessmentGroupMutation = {
  readonly __typename: "CreateOrUpdateFullAssessmentGroupMutation";
  readonly assessmentGroup?: Maybe<AssessmentGroupNode>;
};

export type CreateOrUpdateKpi = {
  readonly __typename: "CreateOrUpdateKPI";
  readonly kpi?: Maybe<KpiNode>;
};

export type CreateOrUpdateKpiGroupMutation = {
  readonly __typename: "CreateOrUpdateKPIGroupMutation";
  readonly kpiGroup?: Maybe<KpiGroupNode>;
};

export type CreateOrUpdateKpiMeasurementMutation = {
  readonly __typename: "CreateOrUpdateKPIMeasurementMutation";
  readonly kpi?: Maybe<KpiNode>;
  readonly kpiMeasurement?: Maybe<KpiMeasurementNode>;
};

export type CreateOrUpdateKvItemMutation = {
  readonly __typename: "CreateOrUpdateKVItemMutation";
  readonly kvItem?: Maybe<UserKvItemNode>;
  readonly user?: Maybe<UserNode>;
};

export type CreateOrUpdateKeyResultMutation = {
  readonly __typename: "CreateOrUpdateKeyResultMutation";
  readonly goal?: Maybe<GoalArtifactNode>;
  readonly keyResult?: Maybe<KeyResultNode>;
};

export type CreateOrUpdateMeetingInExternalCalendarMutation = {
  readonly __typename: "CreateOrUpdateMeetingInExternalCalendarMutation";
  readonly calendarMeetingGroup?: Maybe<CalendarMeetingGroupNode>;
  /** The created meeting, or the first meeting in the recurring series */
  readonly meeting?: Maybe<MeetingNode>;
  readonly meetingGroup?: Maybe<MeetingGroupNode>;
};

export type CreateOrUpdateOrganizationMutation = {
  readonly __typename: "CreateOrUpdateOrganizationMutation";
  readonly organization?: Maybe<OrganizationNode>;
};

export type CreateOrUpdatePerformanceAssessmentChartLabel = {
  readonly __typename: "CreateOrUpdatePerformanceAssessmentChartLabel";
  readonly performanceAssessmentChartLabels: ReadonlyArray<
    Maybe<PerformanceAssessmentChartLabelNode>
  >;
};

export type CreateOrUpdateRatingAnswerMutation = {
  readonly __typename: "CreateOrUpdateRatingAnswerMutation";
  readonly ratingAnswer?: Maybe<RatingAnswerNode>;
  readonly ratingRequirement?: Maybe<MeetingRatingRequirementNode>;
};

export type CreateOrUpdateRatingMutation = {
  readonly __typename: "CreateOrUpdateRatingMutation";
  readonly rating?: Maybe<RatingNode>;
};

export type CreateOrUpdateSkillMutation = {
  readonly __typename: "CreateOrUpdateSkillMutation";
  readonly skill?: Maybe<SkillNode>;
};

export type CreateOrUpdateSlackNotificationForChannelMutation = {
  readonly __typename: "CreateOrUpdateSlackNotificationForChannelMutation";
  readonly notificationSettings?: Maybe<SlackNotificationForChannelNode>;
  readonly organization?: Maybe<OrganizationNode>;
};

export type CreateOrUpdateSlackNotificationsForMeetingGroup = {
  readonly __typename: "CreateOrUpdateSlackNotificationsForMeetingGroup";
  readonly meetingGroup?: Maybe<MeetingGroupNode>;
  readonly notification?: Maybe<SlackNotificationConnectionNode>;
};

export type CreateOrUpdateTeamMutation = {
  readonly __typename: "CreateOrUpdateTeamMutation";
  readonly team?: Maybe<TeamNode>;
};

export type CreateOrUpdateTeamsNotificationForChannelMutation = {
  readonly __typename: "CreateOrUpdateTeamsNotificationForChannelMutation";
  readonly notificationSettings?: Maybe<TeamsNotificationForChannelNode>;
  readonly organization?: Maybe<OrganizationNode>;
};

export type CreateOrUpdateTemplateRequirementsMutation = {
  readonly __typename: "CreateOrUpdateTemplateRequirementsMutation";
  readonly template?: Maybe<TopicTemplateNode>;
};

export type CreateOrUpdateTemplateSeriesForMeetingMutation = {
  readonly __typename: "CreateOrUpdateTemplateSeriesForMeetingMutation";
  readonly templateSeries?: Maybe<TemplateSeriesNode>;
};

export type CreateOrUpdateTopicMutation = {
  readonly __typename: "CreateOrUpdateTopicMutation";
  readonly meeting?: Maybe<MeetingNode>;
  readonly topic?: Maybe<TopicNode>;
  readonly topicTemplate?: Maybe<TopicTemplateNode>;
};

export type CreateOrUpdateTopicTemplateCategoryMutation = {
  readonly __typename: "CreateOrUpdateTopicTemplateCategoryMutation";
  readonly topicTemplateCategory?: Maybe<TemplateCategoryNode>;
};

export type CreateOrUpdateTopicTemplateMutation = {
  readonly __typename: "CreateOrUpdateTopicTemplateMutation";
  readonly topicTemplate?: Maybe<TopicTemplateNode>;
};

export type CreateOrUpdateWorkflowMutation = {
  readonly __typename: "CreateOrUpdateWorkflowMutation";
  readonly workflow?: Maybe<WorkflowNode>;
};

export type CreatePrivateNoteMutation = {
  readonly __typename: "CreatePrivateNoteMutation";
  readonly privateNote?: Maybe<PrivateNoteNode>;
};

export type CreateRoutineMutation = {
  readonly __typename: "CreateRoutineMutation";
  readonly routine?: Maybe<RoutineNode>;
};

export type CreateTemplateFromMeetingMutation = {
  readonly __typename: "CreateTemplateFromMeetingMutation";
  readonly meeting?: Maybe<MeetingNode>;
  readonly topicTemplate?: Maybe<TopicTemplateNode>;
};

export type DecisionArtifactNode = ArtifactInterface & {
  readonly __typename: "DecisionArtifactNode";
  readonly activities: ArtifactActivityNodeConnection;
  readonly artifactType: ArtifactType;
  readonly assignableUsers?: Maybe<UserNodeConnection>;
  readonly canDelete: PermissionNode;
  readonly canRead: PermissionNode;
  readonly canUpdate: PermissionNode;
  readonly commentCount?: Maybe<Scalars["Int"]["output"]>;
  readonly comments?: Maybe<CommentNodeConnection>;
  readonly created: Scalars["DateTime"]["output"];
  readonly createdInMeeting?: Maybe<MeetingNode>;
  readonly creator?: Maybe<UserNode>;
  readonly decision: Scalars["String"]["output"];
  readonly decisionState?: Maybe<DecisionState>;
  readonly description?: Maybe<Scalars["JSONString"]["output"]>;
  readonly eventChannelName?: Maybe<Scalars["String"]["output"]>;
  readonly id: Scalars["Int"]["output"];
  readonly isDraft?: Maybe<Scalars["Boolean"]["output"]>;
  readonly isStale: Scalars["Boolean"]["output"];
  readonly organization?: Maybe<OrganizationNode>;
  readonly relatedArtifacts?: Maybe<ArtifactToArtifactConnection>;
  readonly title?: Maybe<Scalars["String"]["output"]>;
  readonly topics?: Maybe<ArtifactToTopicConnection>;
  readonly updated?: Maybe<Scalars["DateTime"]["output"]>;
  readonly uuid?: Maybe<Scalars["String"]["output"]>;
  readonly websocketToken?: Maybe<Scalars["String"]["output"]>;
};

export type DecisionArtifactNodeActivitiesArgs = {
  activityType?: InputMaybe<ArtifactActivityType>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type DecisionArtifactNodeAssignableUsersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type DecisionArtifactNodeCommentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  artifactId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  isInlineComment?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  textUuid?: InputMaybe<Scalars["String"]["input"]>;
  topicId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type DecisionArtifactNodeRelatedArtifactsArgs = {
  actionItemAssignedToMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignees?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  actionItemDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  actionItemProgress?: InputMaybe<Scalars["Float"]["input"]>;
  actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemStates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  ancestorsOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  artifactTypes?: InputMaybe<ReadonlyArray<InputMaybe<ArtifactType>>>;
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  asUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  assignedToMembersOfOrganizationId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  completedActionItemsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedActionItemsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  createdByIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  createdInMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackSenders?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackState?: InputMaybe<FeedbackState>;
  feedbackStates?: InputMaybe<ReadonlyArray<InputMaybe<FeedbackState>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  goalCompetencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalContributors?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalInvolvingUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalParentIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalResponsibilityIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalScope?: InputMaybe<GoalScope>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalState?: InputMaybe<GoalState>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalStatus?: InputMaybe<GoalStatus>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalVisibility?: InputMaybe<GoalVisibility>;
  goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  groupBy?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  isStale?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValue?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionReceivedByMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type DecisionArtifactNodeTopicsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assignee?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasActionItems?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasArtifacts?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDecisions?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDocuments?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasGoals?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInFlowId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInMeetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<TopicState>;
  titleContains?: InputMaybe<Scalars["String"]["input"]>;
  topicIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

/** An enumeration. */
export enum DecisionState {
  Decided = "decided",
  Draft = "draft",
}

export type DeleteArtifactMutation = {
  readonly __typename: "DeleteArtifactMutation";
  readonly artifact?: Maybe<ArtifactInterface>;
};

export type DeleteAssessmentAnswerMutation = {
  readonly __typename: "DeleteAssessmentAnswerMutation";
  readonly ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DeleteAssessmentGroupMutation = {
  readonly __typename: "DeleteAssessmentGroupMutation";
  readonly ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DeleteAssessmentQuestionMutation = {
  readonly __typename: "DeleteAssessmentQuestionMutation";
  readonly ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DeleteCalibrationGroupMutation = {
  readonly __typename: "DeleteCalibrationGroupMutation";
  readonly ok: Scalars["Boolean"]["output"];
};

export type DeleteCareerTrackMutation = {
  readonly __typename: "DeleteCareerTrackMutation";
  readonly ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DeleteChatSessionMutation = {
  readonly __typename: "DeleteChatSessionMutation";
  readonly id?: Maybe<Scalars["Int"]["output"]>;
  readonly ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DeleteCommentMutation = {
  readonly __typename: "DeleteCommentMutation";
  readonly artifact?: Maybe<ArtifactInterface>;
  readonly topic?: Maybe<TopicNode>;
};

export type DeleteCompetencyMutation = {
  readonly __typename: "DeleteCompetencyMutation";
  readonly ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DeleteComplianceProgramMutation = {
  readonly __typename: "DeleteComplianceProgramMutation";
  readonly organization?: Maybe<OrganizationNode>;
};

export type DeleteComplianceProgramReportingViewMutation = {
  readonly __typename: "DeleteComplianceProgramReportingViewMutation";
  readonly ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DeleteComplianceProgramScheduledReminderMutation = {
  readonly __typename: "DeleteComplianceProgramScheduledReminderMutation";
  readonly complianceProgram?: Maybe<ComplianceProgramNode>;
};

export type DeleteCoreValueMutation = {
  readonly __typename: "DeleteCoreValueMutation";
  readonly ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DeleteExplorerBookmark = {
  readonly __typename: "DeleteExplorerBookmark";
  readonly user?: Maybe<UserNode>;
};

export type DeleteFavouritesGroupMutation = {
  readonly __typename: "DeleteFavouritesGroupMutation";
  readonly user?: Maybe<UserNode>;
};

export type DeleteFlowMutation = {
  readonly __typename: "DeleteFlowMutation";
  readonly flow?: Maybe<FlowNode>;
};

export type DeleteKpi = {
  readonly __typename: "DeleteKPI";
  readonly ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DeleteKpiGroupMutation = {
  readonly __typename: "DeleteKPIGroupMutation";
  readonly kpiGroup?: Maybe<KpiGroupNode>;
};

export type DeleteKpiIntegrationMutation = {
  readonly __typename: "DeleteKPIIntegrationMutation";
  readonly kpi?: Maybe<KpiNode>;
};

export type DeleteKpiMeasurement = {
  readonly __typename: "DeleteKPIMeasurement";
  readonly ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DeleteKeyResultMutation = {
  readonly __typename: "DeleteKeyResultMutation";
  readonly goal?: Maybe<GoalArtifactNode>;
  readonly keyResult?: Maybe<KeyResultNode>;
};

export type DeleteMeetingMutation = {
  readonly __typename: "DeleteMeetingMutation";
  readonly meeting?: Maybe<MeetingNode>;
};

export type DeleteMeetingTranscriptsMutation = {
  readonly __typename: "DeleteMeetingTranscriptsMutation";
  readonly meeting?: Maybe<MeetingNode>;
};

export type DeleteMeetingVideoRecordingMutation = {
  readonly __typename: "DeleteMeetingVideoRecordingMutation";
  readonly meeting?: Maybe<MeetingNode>;
};

export type DeletePrivateNoteMutation = {
  readonly __typename: "DeletePrivateNoteMutation";
  readonly deletedPrivateNoteId?: Maybe<Scalars["Int"]["output"]>;
};

export type DeleteRatingMutation = {
  readonly __typename: "DeleteRatingMutation";
  readonly ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DeleteRoutineMutation = {
  readonly __typename: "DeleteRoutineMutation";
  readonly ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DeleteSlackNotificationForChannelMutation = {
  readonly __typename: "DeleteSlackNotificationForChannelMutation";
  readonly organization?: Maybe<OrganizationNode>;
};

export type DeleteSlackNotificationsForMeetingGroup = {
  readonly __typename: "DeleteSlackNotificationsForMeetingGroup";
  readonly meetingGroup?: Maybe<MeetingGroupNode>;
  readonly ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DeleteTeamMutation = {
  readonly __typename: "DeleteTeamMutation";
  readonly team?: Maybe<TeamNode>;
};

export type DeleteTeamsNotificationForChannelMutation = {
  readonly __typename: "DeleteTeamsNotificationForChannelMutation";
  readonly organization?: Maybe<OrganizationNode>;
};

export type DeleteTopicMutation = {
  readonly __typename: "DeleteTopicMutation";
  readonly ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DeleteTopicTemplateCategoryMutation = {
  readonly __typename: "DeleteTopicTemplateCategoryMutation";
  readonly ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DeleteTopicTemplateMutation = {
  readonly __typename: "DeleteTopicTemplateMutation";
  readonly topicTemplate?: Maybe<TopicTemplateNode>;
};

export type DeleteWorkflowMutation = {
  readonly __typename: "DeleteWorkflowMutation";
  readonly ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** An enumeration. */
export enum DimensionStatus {
  Alert = "alert",
  Critical = "critical",
  Good = "good",
  Warn = "warn",
}

export type DirectorySyncNode = {
  readonly __typename: "DirectorySyncNode";
  readonly id?: Maybe<Scalars["String"]["output"]>;
  readonly lastSyncEnd?: Maybe<Scalars["DateTime"]["output"]>;
  readonly lastSyncStart?: Maybe<Scalars["DateTime"]["output"]>;
  readonly name?: Maybe<Scalars["String"]["output"]>;
  readonly state?: Maybe<Scalars["String"]["output"]>;
  readonly type?: Maybe<Scalars["String"]["output"]>;
};

export type DismissInsightMutation = {
  readonly __typename: "DismissInsightMutation";
  readonly user?: Maybe<UserNode>;
};

export type DjangoNode = {
  readonly canDelete?: Maybe<PermissionNode>;
  readonly canRead?: Maybe<PermissionNode>;
  readonly canUpdate?: Maybe<PermissionNode>;
  readonly id: Scalars["ID"]["output"];
  readonly pk?: Maybe<Scalars["Int"]["output"]>;
};

export type DocumentArtifactNode = ArtifactInterface & {
  readonly __typename: "DocumentArtifactNode";
  readonly activities: ArtifactActivityNodeConnection;
  readonly artifactType: ArtifactType;
  readonly assignableUsers?: Maybe<UserNodeConnection>;
  readonly canDelete: PermissionNode;
  readonly canRead: PermissionNode;
  readonly canUpdate: PermissionNode;
  readonly commentCount?: Maybe<Scalars["Int"]["output"]>;
  readonly comments?: Maybe<CommentNodeConnection>;
  readonly created: Scalars["DateTime"]["output"];
  readonly createdInMeeting?: Maybe<MeetingNode>;
  readonly creator?: Maybe<UserNode>;
  readonly description?: Maybe<Scalars["JSONString"]["output"]>;
  readonly documentVisibility?: Maybe<DocumentVisibility>;
  readonly eventChannelName?: Maybe<Scalars["String"]["output"]>;
  readonly id: Scalars["Int"]["output"];
  readonly isStale: Scalars["Boolean"]["output"];
  readonly organization?: Maybe<OrganizationNode>;
  readonly relatedArtifacts?: Maybe<ArtifactToArtifactConnection>;
  readonly title?: Maybe<Scalars["String"]["output"]>;
  readonly topics?: Maybe<ArtifactToTopicConnection>;
  readonly updated?: Maybe<Scalars["DateTime"]["output"]>;
  readonly uuid?: Maybe<Scalars["String"]["output"]>;
  readonly websocketToken?: Maybe<Scalars["String"]["output"]>;
};

export type DocumentArtifactNodeActivitiesArgs = {
  activityType?: InputMaybe<ArtifactActivityType>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type DocumentArtifactNodeAssignableUsersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type DocumentArtifactNodeCommentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  artifactId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  isInlineComment?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  textUuid?: InputMaybe<Scalars["String"]["input"]>;
  topicId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type DocumentArtifactNodeRelatedArtifactsArgs = {
  actionItemAssignedToMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignees?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  actionItemDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  actionItemProgress?: InputMaybe<Scalars["Float"]["input"]>;
  actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemStates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  ancestorsOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  artifactTypes?: InputMaybe<ReadonlyArray<InputMaybe<ArtifactType>>>;
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  asUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  assignedToMembersOfOrganizationId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  completedActionItemsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedActionItemsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  createdByIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  createdInMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackSenders?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackState?: InputMaybe<FeedbackState>;
  feedbackStates?: InputMaybe<ReadonlyArray<InputMaybe<FeedbackState>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  goalCompetencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalContributors?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalInvolvingUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalParentIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalResponsibilityIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalScope?: InputMaybe<GoalScope>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalState?: InputMaybe<GoalState>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalStatus?: InputMaybe<GoalStatus>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalVisibility?: InputMaybe<GoalVisibility>;
  goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  groupBy?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  isStale?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValue?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionReceivedByMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type DocumentArtifactNodeTopicsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assignee?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasActionItems?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasArtifacts?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDecisions?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDocuments?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasGoals?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInFlowId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInMeetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<TopicState>;
  titleContains?: InputMaybe<Scalars["String"]["input"]>;
  topicIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

/** An enumeration. */
export enum DocumentVisibility {
  Private = "private",
  Public = "public",
}

export type DuplicateGoalMutation = {
  readonly __typename: "DuplicateGoalMutation";
  readonly duplicatedGoal?: Maybe<ArtifactInterface>;
};

export type EditSuggestedAssessmentResponseMutation = {
  readonly __typename: "EditSuggestedAssessmentResponseMutation";
  readonly chatSession?: Maybe<ChatSessionNode>;
};

export type Email1on1NudgeMutation = {
  readonly __typename: "Email1on1NudgeMutation";
  readonly manager?: Maybe<UserNode>;
  readonly report?: Maybe<UserNode>;
  readonly topicTemplate?: Maybe<TopicTemplateNode>;
};

export type EmailAssessmentReminderMutation = {
  readonly __typename: "EmailAssessmentReminderMutation";
  readonly complianceProgram?: Maybe<ComplianceProgramNode>;
};

export type EmailMeetingInvitesMutation = {
  readonly __typename: "EmailMeetingInvitesMutation";
  readonly invitationErrors?: Maybe<ReadonlyArray<Maybe<InviteError>>>;
  readonly meeting?: Maybe<MeetingNode>;
  readonly recipients?: Maybe<ReadonlyArray<Maybe<UserNode>>>;
};

export type EmailMeetingNotesMutation = {
  readonly __typename: "EmailMeetingNotesMutation";
  readonly meeting?: Maybe<MeetingNode>;
  readonly recipients?: Maybe<ReadonlyArray<Maybe<UserNode>>>;
};

export type EmailOneOnOneReminderMutation = {
  readonly __typename: "EmailOneOnOneReminderMutation";
  readonly complianceProgram?: Maybe<ComplianceProgramNode>;
};

/** An enumeration. */
export enum EmailPreference {
  DailySummaryEmails = "daily_summary_emails",
  NoNotificationEmails = "no_notification_emails",
  NotificationEmails = "notification_emails",
}

/** An enumeration. */
export enum EngagementSurveyReportGroupBy {
  CareerTrack = "CAREER_TRACK",
  IsManager = "IS_MANAGER",
  Location = "LOCATION",
  Manager = "MANAGER",
  ManagerFullRollup = "MANAGER_FULL_ROLLUP",
  None = "NONE",
  Team = "TEAM",
}

export type EngagementSurveyReportNode = {
  readonly __typename: "EngagementSurveyReportNode";
  readonly npsQuestionRows: EngagementSurveyReportRowConnection;
  readonly rangeQuestionRows: EngagementSurveyReportRowConnection;
  readonly responders: EngagementSurveyReportRespondersConnection;
};

export type EngagementSurveyReportNodeNpsQuestionRowsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type EngagementSurveyReportNodeRangeQuestionRowsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type EngagementSurveyReportNodeRespondersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type EngagementSurveyReportRespondersConnection = {
  readonly __typename: "EngagementSurveyReportRespondersConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<EngagementSurveyReportRespondersEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `EngagementSurveyReportResponders` and its cursor. */
export type EngagementSurveyReportRespondersEdge = {
  readonly __typename: "EngagementSurveyReportRespondersEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<EngagementSurveyReportRespondersNode>;
};

export type EngagementSurveyReportRespondersNode = {
  readonly __typename: "EngagementSurveyReportRespondersNode";
  readonly careerTrack?: Maybe<CareerTrackNode>;
  readonly isCollapsed: Scalars["Boolean"]["output"];
  readonly isHidden: Scalars["Boolean"]["output"];
  readonly isManager?: Maybe<Scalars["Boolean"]["output"]>;
  readonly location?: Maybe<Scalars["String"]["output"]>;
  readonly manager?: Maybe<UserNode>;
  readonly responderCount: Scalars["Int"]["output"];
  readonly rollupType: EngagementSurveyRollupType;
  readonly team?: Maybe<TeamNode>;
  readonly totalResponders: Scalars["Int"]["output"];
};

export type EngagementSurveyReportRollupConnection = {
  readonly __typename: "EngagementSurveyReportRollupConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<EngagementSurveyReportRollupEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `EngagementSurveyReportRollup` and its cursor. */
export type EngagementSurveyReportRollupEdge = {
  readonly __typename: "EngagementSurveyReportRollupEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<EngagementSurveyReportRollupNode>;
};

export type EngagementSurveyReportRollupNode = {
  readonly __typename: "EngagementSurveyReportRollupNode";
  readonly careerTrack?: Maybe<CareerTrackNode>;
  readonly isManager?: Maybe<Scalars["Boolean"]["output"]>;
  readonly location?: Maybe<Scalars["String"]["output"]>;
  readonly manager?: Maybe<UserNode>;
  readonly rollupType: EngagementSurveyRollupType;
  readonly team?: Maybe<TeamNode>;
  readonly value: Scalars["Float"]["output"];
};

export type EngagementSurveyReportRowConnection = {
  readonly __typename: "EngagementSurveyReportRowConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<EngagementSurveyReportRowEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `EngagementSurveyReportRow` and its cursor. */
export type EngagementSurveyReportRowEdge = {
  readonly __typename: "EngagementSurveyReportRowEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<EngagementSurveyReportRowNode>;
};

export type EngagementSurveyReportRowNode = {
  readonly __typename: "EngagementSurveyReportRowNode";
  readonly question: AssessmentQuestionInterface;
  readonly rollups: EngagementSurveyReportRollupConnection;
  readonly title: Scalars["String"]["output"];
};

export type EngagementSurveyReportRowNodeRollupsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** An enumeration. */
export enum EngagementSurveyRollupType {
  CareerTrack = "CAREER_TRACK",
  Collapsed = "COLLAPSED",
  IsManager = "IS_MANAGER",
  Location = "LOCATION",
  Manager = "MANAGER",
  Organization = "ORGANIZATION",
  Team = "TEAM",
  Uncategorized = "UNCATEGORIZED",
}

export type EventColours = {
  readonly __typename: "EventColours";
  readonly background?: Maybe<Scalars["String"]["output"]>;
  readonly foreground?: Maybe<Scalars["String"]["output"]>;
};

/** An enumeration. */
export enum EventDescriptionLinkSetting {
  Always = "always",
  MeetingsWithTopics = "meetings_with_topics",
  Never = "never",
}

/** An enumeration. */
export enum EventStatus {
  Cancelled = "cancelled",
  Confirmed = "confirmed",
  Tentative = "tentative",
}

/** Exchange public token for account token after Magic Link completion */
export type ExchangeMergePublicToken = {
  readonly __typename: "ExchangeMergePublicToken";
  readonly error?: Maybe<Scalars["String"]["output"]>;
  readonly integration?: Maybe<MergeDevIntegrationNode>;
  readonly success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ExplorerFilterBookmarkNode = DjangoNode &
  Node & {
    readonly __typename: "ExplorerFilterBookmarkNode";
    readonly canDelete: PermissionNode;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate: PermissionNode;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator?: Maybe<UserNode>;
    readonly filters: Scalars["String"]["output"];
    readonly id: Scalars["ID"]["output"];
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly private: Scalars["Boolean"]["output"];
    readonly title: Scalars["String"]["output"];
    readonly updated: Scalars["DateTime"]["output"];
  };

export type ExplorerFilterBookmarkNodeConnection = {
  readonly __typename: "ExplorerFilterBookmarkNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ExplorerFilterBookmarkNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `ExplorerFilterBookmarkNode` and its cursor. */
export type ExplorerFilterBookmarkNodeEdge = {
  readonly __typename: "ExplorerFilterBookmarkNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<ExplorerFilterBookmarkNode>;
};

export type ExportComplianceProgramEngagementSurveyHeatmapToCsv = {
  readonly __typename: "ExportComplianceProgramEngagementSurveyHeatmapToCSV";
  readonly complianceProgram?: Maybe<ComplianceProgramNode>;
};

export type ExportComplianceProgramEngagementSurveyToCsv = {
  readonly __typename: "ExportComplianceProgramEngagementSurveyToCSV";
  readonly complianceProgram?: Maybe<ComplianceProgramNode>;
};

export type ExportComplianceProgramPerformanceAssessmentToCsv = {
  readonly __typename: "ExportComplianceProgramPerformanceAssessmentToCSV";
  readonly complianceProgram?: Maybe<ComplianceProgramNode>;
};

export type ExportComplianceProgramToCsv = {
  readonly __typename: "ExportComplianceProgramToCSV";
  readonly complianceProgram?: Maybe<ComplianceProgramNode>;
};

export type ExternalProfileNode = {
  readonly __typename: "ExternalProfileNode";
  readonly url?: Maybe<Scalars["String"]["output"]>;
  readonly username?: Maybe<Scalars["String"]["output"]>;
};

export type ExtraAssessmentQuestionSetsByAssessmentTypeNode = {
  readonly __typename: "ExtraAssessmentQuestionSetsByAssessmentTypeNode";
  readonly manager?: Maybe<AssessmentGroupConnection>;
  readonly peer?: Maybe<AssessmentGroupConnection>;
  readonly performance?: Maybe<AssessmentGroupConnection>;
};

export type ExtraAssessmentQuestionSetsByAssessmentTypeNodeManagerArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ExtraAssessmentQuestionSetsByAssessmentTypeNodePeerArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ExtraAssessmentQuestionSetsByAssessmentTypeNodePerformanceArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type FavouritesGroupNode = DjangoNode &
  Node & {
    readonly __typename: "FavouritesGroupNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly id: Scalars["ID"]["output"];
    readonly owner?: Maybe<UserNode>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly users?: Maybe<UserNodeConnection>;
  };

export type FavouritesGroupNodeUsersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type FavouritesGroupNodeConnection = {
  readonly __typename: "FavouritesGroupNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<FavouritesGroupNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `FavouritesGroupNode` and its cursor. */
export type FavouritesGroupNodeEdge = {
  readonly __typename: "FavouritesGroupNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<FavouritesGroupNode>;
};

export type FeedNode = {
  readonly __typename: "FeedNode";
  readonly action?: Maybe<Scalars["String"]["output"]>;
  readonly actionTimestamp?: Maybe<Scalars["DateTime"]["output"]>;
  readonly actor?: Maybe<UserNode>;
  readonly object?: Maybe<FeedObjectUnion>;
};

export type FeedObjectUnion = CommentNode | TopicNode;

export type FeedbackArtifactNode = ArtifactInterface & {
  readonly __typename: "FeedbackArtifactNode";
  readonly activities: ArtifactActivityNodeConnection;
  readonly adminsCanView: Scalars["Boolean"]["output"];
  readonly artifactType: ArtifactType;
  readonly assignableUsers?: Maybe<UserNodeConnection>;
  readonly canDelete: PermissionNode;
  readonly canRead: PermissionNode;
  readonly canUpdate: PermissionNode;
  readonly commentCount?: Maybe<Scalars["Int"]["output"]>;
  readonly comments?: Maybe<CommentNodeConnection>;
  readonly created: Scalars["DateTime"]["output"];
  readonly createdInMeeting?: Maybe<MeetingNode>;
  readonly creator?: Maybe<UserNode>;
  readonly creatorCanView: Scalars["Boolean"]["output"];
  readonly description?: Maybe<Scalars["JSONString"]["output"]>;
  readonly eventChannelName?: Maybe<Scalars["String"]["output"]>;
  readonly feedbackState: FeedbackState;
  readonly id: Scalars["Int"]["output"];
  readonly isStale: Scalars["Boolean"]["output"];
  readonly message?: Maybe<Scalars["JSONString"]["output"]>;
  readonly organization?: Maybe<OrganizationNode>;
  readonly recipients: UserNodeConnection;
  readonly recipientsCanView: Scalars["Boolean"]["output"];
  readonly recipientsManagersCanView: Scalars["Boolean"]["output"];
  readonly relatedArtifacts?: Maybe<ArtifactToArtifactConnection>;
  readonly sender: UserNode;
  readonly title?: Maybe<Scalars["String"]["output"]>;
  readonly topics?: Maybe<ArtifactToTopicConnection>;
  readonly updated?: Maybe<Scalars["DateTime"]["output"]>;
  readonly uuid?: Maybe<Scalars["String"]["output"]>;
  readonly websocketToken?: Maybe<Scalars["String"]["output"]>;
};

export type FeedbackArtifactNodeActivitiesArgs = {
  activityType?: InputMaybe<ArtifactActivityType>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type FeedbackArtifactNodeAssignableUsersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type FeedbackArtifactNodeCommentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  artifactId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  isInlineComment?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  textUuid?: InputMaybe<Scalars["String"]["input"]>;
  topicId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type FeedbackArtifactNodeRecipientsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type FeedbackArtifactNodeRelatedArtifactsArgs = {
  actionItemAssignedToMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignees?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  actionItemDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  actionItemProgress?: InputMaybe<Scalars["Float"]["input"]>;
  actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemStates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  ancestorsOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  artifactTypes?: InputMaybe<ReadonlyArray<InputMaybe<ArtifactType>>>;
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  asUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  assignedToMembersOfOrganizationId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  completedActionItemsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedActionItemsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  createdByIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  createdInMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackSenders?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackState?: InputMaybe<FeedbackState>;
  feedbackStates?: InputMaybe<ReadonlyArray<InputMaybe<FeedbackState>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  goalCompetencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalContributors?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalInvolvingUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalParentIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalResponsibilityIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalScope?: InputMaybe<GoalScope>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalState?: InputMaybe<GoalState>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalStatus?: InputMaybe<GoalStatus>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalVisibility?: InputMaybe<GoalVisibility>;
  goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  groupBy?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  isStale?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValue?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionReceivedByMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type FeedbackArtifactNodeTopicsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assignee?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasActionItems?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasArtifacts?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDecisions?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDocuments?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasGoals?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInFlowId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInMeetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<TopicState>;
  titleContains?: InputMaybe<Scalars["String"]["input"]>;
  topicIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

/** An enumeration. */
export enum FeedbackState {
  Draft = "draft",
  Requested = "requested",
  Sent = "sent",
}

/** An enumeration. */
export enum FinalizePermissions {
  AdminsOnly = "admins_only",
  AllParticipants = "all_participants",
  FacilitatorsAndAdmins = "facilitators_and_admins",
  ManagersAndAdmins = "managers_and_admins",
}

export type FlowNode = DjangoNode &
  Node & {
    readonly __typename: "FlowNode";
    readonly artifacts?: Maybe<ArtifactConnection>;
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly creator?: Maybe<UserNode>;
    readonly goals?: Maybe<ArtifactConnection>;
    readonly id: Scalars["ID"]["output"];
    readonly meetingGroups?: Maybe<MeetingGroupNodeConnection>;
    readonly meetings?: Maybe<MeetingNodeConnection>;
    readonly organization?: Maybe<OrganizationNode>;
    readonly participantCount?: Maybe<Scalars["Int"]["output"]>;
    readonly participantEmailPatterns?: Maybe<Scalars["JSONString"]["output"]>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly public: Scalars["Boolean"]["output"];
    readonly title: Scalars["String"]["output"];
  };

export type FlowNodeArtifactsArgs = {
  actionItemAssignedToMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignees?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  actionItemDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  actionItemProgress?: InputMaybe<Scalars["Float"]["input"]>;
  actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemStates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  ancestorsOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  artifactTypes?: InputMaybe<ReadonlyArray<InputMaybe<ArtifactType>>>;
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  asUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  assignedToMembersOfOrganizationId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  completedActionItemsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedActionItemsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  createdByIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  createdInMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackSenders?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackState?: InputMaybe<FeedbackState>;
  feedbackStates?: InputMaybe<ReadonlyArray<InputMaybe<FeedbackState>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  goalCompetencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalContributors?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalInvolvingUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalParentIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalResponsibilityIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalScope?: InputMaybe<GoalScope>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalState?: InputMaybe<GoalState>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalStatus?: InputMaybe<GoalStatus>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalVisibility?: InputMaybe<GoalVisibility>;
  goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  groupBy?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  isStale?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValue?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionReceivedByMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type FlowNodeGoalsArgs = {
  actionItemAssignedToMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignees?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  actionItemDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  actionItemProgress?: InputMaybe<Scalars["Float"]["input"]>;
  actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemStates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  ancestorsOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  artifactTypes?: InputMaybe<ReadonlyArray<InputMaybe<ArtifactType>>>;
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  asUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  assignedToMembersOfOrganizationId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  completedActionItemsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedActionItemsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  createdByIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  createdInMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackSenders?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackState?: InputMaybe<FeedbackState>;
  feedbackStates?: InputMaybe<ReadonlyArray<InputMaybe<FeedbackState>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  goalCompetencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalContributors?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalInvolvingUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalParentIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalResponsibilityIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalScope?: InputMaybe<GoalScope>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalState?: InputMaybe<GoalState>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalStatus?: InputMaybe<GoalStatus>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalVisibility?: InputMaybe<GoalVisibility>;
  goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  groupBy?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  isStale?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValue?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionReceivedByMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type FlowNodeMeetingGroupsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type FlowNodeMeetingsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  draft?: InputMaybe<Scalars["Boolean"]["input"]>;
  endDatetime?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  excludeMeetingGroupIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  fromMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  ignored?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFinalized?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFormalOneonone?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  minimumDateRange?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Decimal"]["input"]>;
  participantCount?: InputMaybe<Scalars["Int"]["input"]>;
  participants?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  startDatetime?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  status?: InputMaybe<EventStatus>;
  status_In?: InputMaybe<ReadonlyArray<InputMaybe<EventStatus>>>;
  subject?: InputMaybe<Scalars["Int"]["input"]>;
  templateId?: InputMaybe<Scalars["Int"]["input"]>;
  unscheduled?: InputMaybe<Scalars["Boolean"]["input"]>;
  usingRequiredTemplateOfValidPrograms?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
};

export type FlowNodeConnection = {
  readonly __typename: "FlowNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<FlowNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `FlowNode` and its cursor. */
export type FlowNodeEdge = {
  readonly __typename: "FlowNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<FlowNode>;
};

export type ForkPlatformSkillMutation = {
  readonly __typename: "ForkPlatformSkillMutation";
  readonly skill?: Maybe<SkillNode>;
};

export enum FrequencyEnum {
  Daily = "daily",
  Monthly = "monthly",
  Weekly = "weekly",
  Yearly = "yearly",
}

export type FrequencyInput = {
  /** The month(s) that the event should repeat on */
  readonly byMonth?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  /** The day(s) of month that the event should repeat on */
  readonly byMonthDay?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  /** An integer (or integers) corresponding to the nth occurrence of the rule inside the frequency period. For example, a bysetpos of -1 if combined with a MONTHLY frequency, and a byweekday of (MO, TU, WE, TH, FR), will result in the last work day of every month */
  readonly bySetPos?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  /** The day(s) of the week the event should repeat on (monday = 0, tuesday = 1, etc...) */
  readonly byWeekDay?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  /** The day(s) of the year that the event should repeat on */
  readonly byYearDay?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  /** How many instances of the recurring event should exist */
  readonly count?: InputMaybe<Scalars["Int"]["input"]>;
  readonly frequency: FrequencyEnum;
  /** How often to do the thing. For example, if frequency was monthly,and interval was 2, that would mean once every two months */
  readonly interval: Scalars["Int"]["input"];
};

export type FrequencyNode = {
  readonly __typename: "FrequencyNode";
  readonly byMonth?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]["output"]>>>;
  /** The day of month that the event should repeat on */
  readonly byMonthDay?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]["output"]>>>;
  /** An integer corresponding to the nth occurrence of the rule inside the frequency period. For example, a bysetpos of -1 if combined with a MONTHLY frequency, and a byweekday of (MO, TU, WE, TH, FR), will result in the last work day of every month */
  readonly bySetPos?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]["output"]>>>;
  /** The day of the week the event should repeat on (monday = 0, tuesday = 1, etc...) */
  readonly byWeekDay?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]["output"]>>>;
  /** The day of the year that the event should repeat on */
  readonly byYearDay?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]["output"]>>>;
  readonly count?: Maybe<Scalars["Int"]["output"]>;
  readonly frequency: FrequencyEnum;
  /** How often to do the thing. For example, if frequency was monthly,and interval was 2, that would mean once every two months */
  readonly interval: Scalars["Int"]["output"];
};

export type FullAssessmentGroupSectionInput = {
  readonly description?: InputMaybe<Scalars["String"]["input"]>;
  readonly questions: ReadonlyArray<InputMaybe<AssessmentGroupQuestionInput>>;
  readonly title?: InputMaybe<Scalars["String"]["input"]>;
};

export type GenerateReviewAnswers = {
  readonly __typename: "GenerateReviewAnswers";
  readonly success?: Maybe<Scalars["Boolean"]["output"]>;
  readonly suggestedAnswers?: Maybe<SuggestedQuestionConnection>;
};

export type GenerateReviewAnswersSuggestedAnswersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type GetOrCreateChatbotSession = {
  readonly __typename: "GetOrCreateChatbotSession";
  readonly chatSession?: Maybe<ChatSessionNode>;
};

/** An enumeration. */
export enum GithubIntegrationMetricType {
  ClosedIssues = "closed_issues",
  ClosedPrs = "closed_prs",
  CreatedIssues = "created_issues",
  CreatedPrs = "created_prs",
  OpenIssues = "open_issues",
  OpenPrs = "open_prs",
}

/** An enumeration. */
export enum GithubIntegrationTimeBucket {
  Last_7Days = "last_7_days",
  Last_31Days = "last_31_days",
}

export type GithubIssueNode = InfoCardInterface & {
  readonly __typename: "GithubIssueNode";
  readonly assignees: ReadonlyArray<Maybe<ExternalProfileNode>>;
  readonly closedAt?: Maybe<Scalars["DateTime"]["output"]>;
  readonly created: Scalars["DateTime"]["output"];
  readonly description?: Maybe<Scalars["String"]["output"]>;
  readonly githubCursor?: Maybe<Scalars["String"]["output"]>;
  readonly id: Scalars["ID"]["output"];
  readonly isMerged?: Maybe<Scalars["Boolean"]["output"]>;
  readonly providerName?: Maybe<Scalars["String"]["output"]>;
  readonly repository?: Maybe<Scalars["String"]["output"]>;
  readonly repositoryOwner?: Maybe<Scalars["String"]["output"]>;
  readonly status?: Maybe<InfoTaskStatus>;
  readonly title: Scalars["String"]["output"];
  readonly url: Scalars["String"]["output"];
};

export type GithubIssuesArtifactNode = ArtifactInterface & {
  readonly __typename: "GithubIssuesArtifactNode";
  readonly activities: ArtifactActivityNodeConnection;
  readonly artifactType: ArtifactType;
  readonly assignableUsers?: Maybe<UserNodeConnection>;
  readonly canDelete: PermissionNode;
  readonly canRead: PermissionNode;
  readonly canUpdate: PermissionNode;
  readonly commentCount?: Maybe<Scalars["Int"]["output"]>;
  readonly comments?: Maybe<CommentNodeConnection>;
  readonly created: Scalars["DateTime"]["output"];
  readonly createdInMeeting?: Maybe<MeetingNode>;
  readonly creator?: Maybe<UserNode>;
  readonly description?: Maybe<Scalars["JSONString"]["output"]>;
  readonly eventChannelName?: Maybe<Scalars["String"]["output"]>;
  readonly id: Scalars["Int"]["output"];
  readonly isStale: Scalars["Boolean"]["output"];
  readonly issues?: Maybe<ReadonlyArray<Maybe<GithubIssueNode>>>;
  readonly organization?: Maybe<OrganizationNode>;
  readonly relatedArtifacts?: Maybe<ArtifactToArtifactConnection>;
  readonly searchQuery?: Maybe<Scalars["String"]["output"]>;
  readonly title?: Maybe<Scalars["String"]["output"]>;
  readonly topics?: Maybe<ArtifactToTopicConnection>;
  readonly updated?: Maybe<Scalars["DateTime"]["output"]>;
  readonly uuid?: Maybe<Scalars["String"]["output"]>;
  readonly websocketToken?: Maybe<Scalars["String"]["output"]>;
};

export type GithubIssuesArtifactNodeActivitiesArgs = {
  activityType?: InputMaybe<ArtifactActivityType>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type GithubIssuesArtifactNodeAssignableUsersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type GithubIssuesArtifactNodeCommentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  artifactId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  isInlineComment?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  textUuid?: InputMaybe<Scalars["String"]["input"]>;
  topicId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type GithubIssuesArtifactNodeIssuesArgs = {
  first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type GithubIssuesArtifactNodeRelatedArtifactsArgs = {
  actionItemAssignedToMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignees?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  actionItemDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  actionItemProgress?: InputMaybe<Scalars["Float"]["input"]>;
  actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemStates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  ancestorsOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  artifactTypes?: InputMaybe<ReadonlyArray<InputMaybe<ArtifactType>>>;
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  asUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  assignedToMembersOfOrganizationId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  completedActionItemsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedActionItemsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  createdByIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  createdInMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackSenders?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackState?: InputMaybe<FeedbackState>;
  feedbackStates?: InputMaybe<ReadonlyArray<InputMaybe<FeedbackState>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  goalCompetencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalContributors?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalInvolvingUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalParentIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalResponsibilityIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalScope?: InputMaybe<GoalScope>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalState?: InputMaybe<GoalState>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalStatus?: InputMaybe<GoalStatus>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalVisibility?: InputMaybe<GoalVisibility>;
  goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  groupBy?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  isStale?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValue?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionReceivedByMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type GithubIssuesArtifactNodeTopicsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assignee?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasActionItems?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasArtifacts?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDecisions?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDocuments?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasGoals?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInFlowId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInMeetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<TopicState>;
  titleContains?: InputMaybe<Scalars["String"]["input"]>;
  topicIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type GithubKpiIntegrationInput = {
  readonly metricType?: InputMaybe<GithubIntegrationMetricType>;
  /** The user or organization */
  readonly owner?: InputMaybe<Scalars["String"]["input"]>;
  /** The name of the repository */
  readonly repository?: InputMaybe<Scalars["String"]["input"]>;
  readonly timeBucket?: InputMaybe<GithubIntegrationTimeBucket>;
};

export type GithubKpiIntegrationNode = KpiIntegrationInterface & {
  readonly __typename: "GithubKPIIntegrationNode";
  readonly created?: Maybe<Scalars["DateTime"]["output"]>;
  readonly creator?: Maybe<UserNode>;
  readonly id: Scalars["Int"]["output"];
  readonly integrationType?: Maybe<KpiIntegrationType>;
  readonly kpi?: Maybe<KpiNode>;
  readonly metricType?: Maybe<GithubIntegrationMetricType>;
  readonly organizationIntegrationConnection?: Maybe<OrganizationIntegrationNode>;
  /** GitHub user or organization */
  readonly owner: Scalars["String"]["output"];
  /** GitHub repository */
  readonly repository: Scalars["String"]["output"];
  readonly timeBucket?: Maybe<GithubIntegrationTimeBucket>;
  readonly updated?: Maybe<Scalars["DateTime"]["output"]>;
};

export type GoalArtifactConnection = {
  readonly __typename: "GoalArtifactConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<GoalArtifactEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `GoalArtifact` and its cursor. */
export type GoalArtifactEdge = {
  readonly __typename: "GoalArtifactEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<GoalArtifactNode>;
};

export type GoalArtifactNode = ArtifactInterface & {
  readonly __typename: "GoalArtifactNode";
  readonly activities: ArtifactActivityNodeConnection;
  readonly ancestorGoals?: Maybe<GoalArtifactConnection>;
  readonly artifactType: ArtifactType;
  readonly assignableUsers?: Maybe<UserNodeConnection>;
  readonly basicChildGoals?: Maybe<BasicGoalArtifactNodeConnection>;
  readonly canDelete: PermissionNode;
  readonly canRead: PermissionNode;
  readonly canUpdate: PermissionNode;
  readonly childGoals?: Maybe<GoalArtifactConnection>;
  readonly commentCount?: Maybe<Scalars["Int"]["output"]>;
  readonly comments?: Maybe<CommentNodeConnection>;
  readonly competencyRelations: GoalArtifactToCompetencyM2MNodeConnection;
  readonly contributorCount?: Maybe<Scalars["Int"]["output"]>;
  readonly contributors?: Maybe<UserNodeConnection>;
  readonly contributorsList: ReadonlyArray<Maybe<UserNode>>;
  readonly created: Scalars["DateTime"]["output"];
  readonly createdInMeeting?: Maybe<MeetingNode>;
  readonly creator?: Maybe<UserNode>;
  readonly currentUserIsOwner?: Maybe<Scalars["Boolean"]["output"]>;
  readonly currentValue: Scalars["Float"]["output"];
  readonly description?: Maybe<Scalars["JSONString"]["output"]>;
  readonly dueDate?: Maybe<Scalars["Date"]["output"]>;
  readonly eventChannelName?: Maybe<Scalars["String"]["output"]>;
  readonly firstOwner?: Maybe<UserNode>;
  readonly goalVisibility: GoalVisibility;
  readonly id: Scalars["Int"]["output"];
  readonly isStale: Scalars["Boolean"]["output"];
  readonly keyResults: KeyResultNodeConnection;
  readonly keyResultsList: ReadonlyArray<Maybe<KeyResultNode>>;
  readonly kpi?: Maybe<KpiNode>;
  readonly organization?: Maybe<OrganizationNode>;
  readonly ownerCount?: Maybe<Scalars["Int"]["output"]>;
  readonly owners?: Maybe<UserNodeConnection>;
  readonly ownersList: ReadonlyArray<Maybe<UserNode>>;
  readonly parentGoal?: Maybe<GoalArtifactNode>;
  readonly parentGoalId?: Maybe<Scalars["Int"]["output"]>;
  readonly progress: Scalars["Float"]["output"];
  readonly progressType: GoalProgressType;
  readonly relatedArtifacts?: Maybe<ArtifactToArtifactConnection>;
  readonly responsibilities?: Maybe<CareerTrackRoleResponsibilityNodeConnection>;
  readonly roles?: Maybe<CareerTrackRoleNodeConnection>;
  readonly scope: GoalScope;
  readonly startDate?: Maybe<Scalars["Date"]["output"]>;
  readonly startValue: Scalars["Float"]["output"];
  readonly state: GoalState;
  readonly status: GoalStatus;
  readonly targetValue: Scalars["Float"]["output"];
  readonly teams?: Maybe<TeamNodeConnection>;
  readonly teamsList: ReadonlyArray<Maybe<TeamNode>>;
  readonly title?: Maybe<Scalars["String"]["output"]>;
  readonly topLevelGoal?: Maybe<GoalArtifactNode>;
  readonly topics?: Maybe<ArtifactToTopicConnection>;
  readonly updated?: Maybe<Scalars["DateTime"]["output"]>;
  readonly uuid?: Maybe<Scalars["String"]["output"]>;
  readonly websocketToken?: Maybe<Scalars["String"]["output"]>;
};

export type GoalArtifactNodeActivitiesArgs = {
  activityType?: InputMaybe<ArtifactActivityType>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type GoalArtifactNodeAncestorGoalsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type GoalArtifactNodeAssignableUsersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type GoalArtifactNodeBasicChildGoalsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
};

export type GoalArtifactNodeChildGoalsArgs = {
  actionItemAssignedToMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignees?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  actionItemDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  actionItemProgress?: InputMaybe<Scalars["Float"]["input"]>;
  actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemStates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  ancestorsOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  artifactTypes?: InputMaybe<ReadonlyArray<InputMaybe<ArtifactType>>>;
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  asUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  assignedToMembersOfOrganizationId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  completedActionItemsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedActionItemsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  createdByIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  createdInMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackSenders?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackState?: InputMaybe<FeedbackState>;
  feedbackStates?: InputMaybe<ReadonlyArray<InputMaybe<FeedbackState>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  goalCompetencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalContributors?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalInvolvingUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalParentIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalResponsibilityIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalScope?: InputMaybe<GoalScope>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalState?: InputMaybe<GoalState>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalStatus?: InputMaybe<GoalStatus>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalVisibility?: InputMaybe<GoalVisibility>;
  goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  groupBy?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  isStale?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValue?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionReceivedByMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type GoalArtifactNodeCommentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  artifactId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  isInlineComment?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  textUuid?: InputMaybe<Scalars["String"]["input"]>;
  topicId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type GoalArtifactNodeCompetencyRelationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  roleId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type GoalArtifactNodeContributorsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type GoalArtifactNodeKeyResultsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type GoalArtifactNodeOwnersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type GoalArtifactNodeRelatedArtifactsArgs = {
  actionItemAssignedToMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignees?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  actionItemDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  actionItemProgress?: InputMaybe<Scalars["Float"]["input"]>;
  actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemStates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  ancestorsOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  artifactTypes?: InputMaybe<ReadonlyArray<InputMaybe<ArtifactType>>>;
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  asUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  assignedToMembersOfOrganizationId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  completedActionItemsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedActionItemsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  createdByIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  createdInMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackSenders?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackState?: InputMaybe<FeedbackState>;
  feedbackStates?: InputMaybe<ReadonlyArray<InputMaybe<FeedbackState>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  goalCompetencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalContributors?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalInvolvingUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalParentIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalResponsibilityIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalScope?: InputMaybe<GoalScope>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalState?: InputMaybe<GoalState>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalStatus?: InputMaybe<GoalStatus>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalVisibility?: InputMaybe<GoalVisibility>;
  goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  groupBy?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  isStale?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValue?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionReceivedByMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type GoalArtifactNodeResponsibilitiesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type GoalArtifactNodeRolesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type GoalArtifactNodeTeamsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organization?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  title_Startswith?: InputMaybe<Scalars["String"]["input"]>;
};

export type GoalArtifactNodeTopicsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assignee?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasActionItems?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasArtifacts?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDecisions?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDocuments?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasGoals?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInFlowId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInMeetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<TopicState>;
  titleContains?: InputMaybe<Scalars["String"]["input"]>;
  topicIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type GoalArtifactToCompetencyM2MNode = DjangoNode &
  Node & {
    readonly __typename: "GoalArtifactToCompetencyM2MNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly competency: CompetencyNode;
    readonly competencyId: Scalars["Int"]["output"];
    readonly id: Scalars["ID"]["output"];
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly role?: Maybe<CareerTrackRoleNode>;
    readonly roleId?: Maybe<Scalars["Int"]["output"]>;
  };

export type GoalArtifactToCompetencyM2MNodeConnection = {
  readonly __typename: "GoalArtifactToCompetencyM2MNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<GoalArtifactToCompetencyM2MNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `GoalArtifactToCompetencyM2MNode` and its cursor. */
export type GoalArtifactToCompetencyM2MNodeEdge = {
  readonly __typename: "GoalArtifactToCompetencyM2MNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<GoalArtifactToCompetencyM2MNode>;
};

export type GoalCheckinKeyResultInput = {
  readonly currentValue: Scalars["Float"]["input"];
  readonly keyResultId: Scalars["Int"]["input"];
};

/** An enumeration. */
export enum GoalProgressType {
  AlignedAverage = "aligned_average",
  Boolean = "boolean",
  Currency = "currency",
  Numeric = "numeric",
  Percentage = "percentage",
}

/** An enumeration. */
export enum GoalScope {
  Career = "career",
  Development = "development",
  Organization = "organization",
  Personal = "personal",
  Team = "team",
}

/** An enumeration. */
export enum GoalState {
  Closed = "closed",
  Draft = "draft",
  Open = "open",
}

/** An enumeration. */
export enum GoalStatus {
  AtRisk = "at_risk",
  None = "none",
  OffTrack = "off_track",
  OnTrack = "on_track",
}

/** An enumeration. */
export enum GoalVisibility {
  Private = "private",
  Public = "public",
}

export type GoogleSheetsKpiIntegrationInput = {
  readonly bottomRowFromColumn?: InputMaybe<Scalars["String"]["input"]>;
  readonly cellId?: InputMaybe<Scalars["String"]["input"]>;
  readonly rightmostColumnFromRow?: InputMaybe<Scalars["String"]["input"]>;
  readonly spreadsheetId?: InputMaybe<Scalars["String"]["input"]>;
};

export type GoogleSheetsKpiIntegrationNode = KpiIntegrationInterface & {
  readonly __typename: "GoogleSheetsKPIIntegrationNode";
  readonly bottomRowFromColumn?: Maybe<Scalars["String"]["output"]>;
  readonly cellId?: Maybe<Scalars["String"]["output"]>;
  readonly created?: Maybe<Scalars["DateTime"]["output"]>;
  readonly creator?: Maybe<UserNode>;
  readonly credentials?: Maybe<UserSyncCredentialsNode>;
  readonly id: Scalars["Int"]["output"];
  readonly integrationType?: Maybe<KpiIntegrationType>;
  readonly kpi?: Maybe<KpiNode>;
  readonly organizationIntegrationConnection?: Maybe<OrganizationIntegrationNode>;
  readonly rightmostColumnFromRow?: Maybe<Scalars["String"]["output"]>;
  readonly spreadsheetId: Scalars["String"]["output"];
  readonly updated?: Maybe<Scalars["DateTime"]["output"]>;
};

/** Represents answers grouped by (group_key, question_id) with privacy threshold applied. */
export type GroupedAnswersNode = {
  readonly __typename: "GroupedAnswersNode";
  readonly answerIds: ReadonlyArray<Maybe<Scalars["Int"]["output"]>>;
  readonly groupKey: Scalars["String"]["output"];
  readonly groupLabel: Scalars["String"]["output"];
  /** Whether this group is collapsed (in the collapsed_keys list) */
  readonly isCollapsed: Scalars["Boolean"]["output"];
  /** Whether this group is hidden due to privacy threshold */
  readonly isHidden: Scalars["Boolean"]["output"];
  /** Total number of comments in this group for this question, even if below threshold */
  readonly numberComments: Scalars["Int"]["output"];
  /** Total number of responders in this group for this question, even if below threshold */
  readonly numberResponders: Scalars["Int"]["output"];
  readonly questionId: Scalars["Int"]["output"];
  readonly rollupType: EngagementSurveyRollupType;
};

export type HubspotDealNode = InfoCardInterface & {
  readonly __typename: "HubspotDealNode";
  readonly amount?: Maybe<Scalars["Float"]["output"]>;
  readonly assignees: ReadonlyArray<Maybe<ExternalProfileNode>>;
  readonly closedAt?: Maybe<Scalars["DateTime"]["output"]>;
  readonly closedWon?: Maybe<Scalars["Boolean"]["output"]>;
  readonly created: Scalars["DateTime"]["output"];
  readonly description?: Maybe<Scalars["String"]["output"]>;
  readonly id: Scalars["ID"]["output"];
  readonly providerName?: Maybe<Scalars["String"]["output"]>;
  readonly stageId?: Maybe<Scalars["String"]["output"]>;
  readonly stageName?: Maybe<Scalars["String"]["output"]>;
  readonly status?: Maybe<InfoTaskStatus>;
  readonly title: Scalars["String"]["output"];
  readonly url: Scalars["String"]["output"];
};

/** An enumeration. */
export enum HubspotIntegrationMetricType {
  DealAmountSum = "deal_amount_sum",
  DealCount = "deal_count",
}

/** An enumeration. */
export enum HubspotIntegrationTimeBucket {
  AllTime = "all_time",
  Last_7Days = "last_7_days",
  Last_31Days = "last_31_days",
  ThisQuarter = "this_quarter",
  ThisYear = "this_year",
}

export type HubspotKpiIntegrationInput = {
  readonly dealStageId?: InputMaybe<Scalars["String"]["input"]>;
  readonly metricType?: InputMaybe<HubspotIntegrationMetricType>;
  readonly timeBucket?: InputMaybe<HubspotIntegrationTimeBucket>;
};

export type HubspotKpiIntegrationNode = KpiIntegrationInterface & {
  readonly __typename: "HubspotKPIIntegrationNode";
  readonly created?: Maybe<Scalars["DateTime"]["output"]>;
  readonly creator?: Maybe<UserNode>;
  readonly dealStageId?: Maybe<Scalars["String"]["output"]>;
  readonly id: Scalars["Int"]["output"];
  readonly integrationType?: Maybe<KpiIntegrationType>;
  readonly kpi?: Maybe<KpiNode>;
  readonly metricType?: Maybe<HubspotIntegrationMetricType>;
  readonly organizationIntegrationConnection?: Maybe<OrganizationIntegrationNode>;
  readonly timeBucket?: Maybe<HubspotIntegrationTimeBucket>;
  readonly updated?: Maybe<Scalars["DateTime"]["output"]>;
};

export type HubspotStageConnection = {
  readonly __typename: "HubspotStageConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<HubspotStageEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `HubspotStage` and its cursor. */
export type HubspotStageEdge = {
  readonly __typename: "HubspotStageEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<HubspotStageNode>;
};

export type HubspotStageNode = {
  readonly __typename: "HubspotStageNode";
  readonly id: Scalars["ID"]["output"];
  readonly pipelineId?: Maybe<Scalars["Int"]["output"]>;
  readonly pipelineName?: Maybe<Scalars["String"]["output"]>;
  readonly stageName?: Maybe<Scalars["String"]["output"]>;
};

export type IgnoreMeetingMutation = {
  readonly __typename: "IgnoreMeetingMutation";
  readonly meeting?: Maybe<MeetingNode>;
  readonly meetingGroup?: Maybe<MeetingGroupNode>;
};

/** What the import will do for a given date: create a new 1-on-1, update an existing one, or skip it. */
export enum ImportMeetingAction {
  Create = "CREATE",
  Skip = "SKIP",
  Update = "UPDATE",
}

export type ImportOneononeMeetingInput = {
  readonly date: Scalars["Date"]["input"];
  readonly topics: ReadonlyArray<InputMaybe<ImportOneononeTopicInput>>;
};

/**
 * Phase 2 of the bulk 1-on-1 import: commit the (possibly edited) structured plan. No AI and no
 * date parsing happen here -- the preview step already did that.
 */
export type ImportOneononeNotesMutation = {
  readonly __typename: "ImportOneononeNotesMutation";
  /** Created and updated meetings, newest-first */
  readonly meetings?: Maybe<ReadonlyArray<Maybe<MeetingNode>>>;
  /** Dates skipped because they are in the future */
  readonly skippedDates?: Maybe<
    ReadonlyArray<Maybe<Scalars["Date"]["output"]>>
  >;
};

export type ImportOneononeTopicInput = {
  /** Topic notes in markdown */
  readonly notes: Scalars["String"]["input"];
  readonly title: Scalars["String"]["input"];
};

export type IndividualGoalAssessmentAnswerNode = AssessmentAnswerInterface & {
  readonly __typename: "IndividualGoalAssessmentAnswerNode";
  readonly assessment: AssessmentNode;
  readonly calibrations: AssessmentAnswerCalibrationConnection;
  readonly canDelete: PermissionNode;
  readonly canRead: PermissionNode;
  readonly canUpdate: PermissionNode;
  readonly comment?: Maybe<Scalars["JSONString"]["output"]>;
  readonly created: Scalars["DateTime"]["output"];
  readonly hasCalibrationSuggestions: Scalars["Boolean"]["output"];
  readonly hasCalibrations: Scalars["Boolean"]["output"];
  readonly id: Scalars["Int"]["output"];
  readonly integerAnswer?: Maybe<Scalars["Int"]["output"]>;
  readonly isLocked: Scalars["Boolean"]["output"];
  readonly question: AssessmentQuestionInterface;
  readonly questionId: Scalars["Int"]["output"];
  readonly responder?: Maybe<UserNode>;
  readonly updated: Scalars["DateTime"]["output"];
};

export type IndividualGoalAssessmentAnswerNodeCalibrationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type IndividualGoalAssessmentQuestionNode =
  AssessmentQuestionInterface & {
    readonly __typename: "IndividualGoalAssessmentQuestionNode";
    readonly answers: AssessmentAnswerConnection;
    readonly answersExist: Scalars["Boolean"]["output"];
    readonly archived: Scalars["Boolean"]["output"];
    readonly canDelete: PermissionNode;
    readonly canRead: PermissionNode;
    readonly canUpdate: PermissionNode;
    readonly categories: AssessmentQuestionCategoryNodeConnection;
    readonly comment: AssessmentQuestionComment;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator?: Maybe<UserNode>;
    readonly description?: Maybe<Scalars["JSONString"]["output"]>;
    readonly endValue: Scalars["Int"]["output"];
    readonly goal?: Maybe<GoalArtifactNode>;
    readonly id: Scalars["Int"]["output"];
    readonly isResponseMandatory: Scalars["Boolean"]["output"];
    readonly labelDescriptions: ReadonlyArray<
      Maybe<Scalars["String"]["output"]>
    >;
    readonly labels: ReadonlyArray<Maybe<Scalars["String"]["output"]>>;
    readonly organization: OrganizationNode;
    readonly questionType: AssessmentQuestionType;
    readonly responseVisibility: AssessmentQuestionResponseVisibility;
    readonly responses: AssessmentQuestionResponses;
    readonly startValue: Scalars["Int"]["output"];
    readonly title: Scalars["String"]["output"];
    readonly updated: Scalars["DateTime"]["output"];
  };

export type IndividualGoalAssessmentQuestionNodeAnswersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type IndividualGoalAssessmentQuestionNodeCategoriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type IndividualNoteNode = DjangoNode &
  Node & {
    readonly __typename: "IndividualNoteNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator: UserNode;
    readonly enabled: Scalars["Boolean"]["output"];
    readonly hidden: Scalars["Boolean"]["output"];
    readonly id: Scalars["ID"]["output"];
    readonly notes?: Maybe<Scalars["JSONString"]["output"]>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
  };

export type IndividualNoteNodeConnection = {
  readonly __typename: "IndividualNoteNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<IndividualNoteNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `IndividualNoteNode` and its cursor. */
export type IndividualNoteNodeEdge = {
  readonly __typename: "IndividualNoteNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<IndividualNoteNode>;
};

export type IndividualRecognitionCoreValueAssessmentAnswerNode =
  AssessmentAnswerInterface & {
    readonly __typename: "IndividualRecognitionCoreValueAssessmentAnswerNode";
    readonly assessment: AssessmentNode;
    readonly calibrations: AssessmentAnswerCalibrationConnection;
    readonly canDelete: PermissionNode;
    readonly canRead: PermissionNode;
    readonly canUpdate: PermissionNode;
    readonly comment?: Maybe<Scalars["JSONString"]["output"]>;
    readonly created: Scalars["DateTime"]["output"];
    readonly hasCalibrationSuggestions: Scalars["Boolean"]["output"];
    readonly hasCalibrations: Scalars["Boolean"]["output"];
    readonly id: Scalars["Int"]["output"];
    readonly integerAnswer?: Maybe<Scalars["Int"]["output"]>;
    readonly isLocked: Scalars["Boolean"]["output"];
    readonly question: AssessmentQuestionInterface;
    readonly questionId: Scalars["Int"]["output"];
    readonly responder?: Maybe<UserNode>;
    readonly updated: Scalars["DateTime"]["output"];
  };

export type IndividualRecognitionCoreValueAssessmentAnswerNodeCalibrationsArgs =
  {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
  };

export type IndividualRecognitionCoreValueAssessmentQuestionNode =
  AssessmentQuestionInterface & {
    readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
    readonly answers: AssessmentAnswerConnection;
    readonly answersExist: Scalars["Boolean"]["output"];
    readonly archived: Scalars["Boolean"]["output"];
    readonly canDelete: PermissionNode;
    readonly canRead: PermissionNode;
    readonly canUpdate: PermissionNode;
    readonly categories: AssessmentQuestionCategoryNodeConnection;
    readonly comment: AssessmentQuestionComment;
    readonly coreValue?: Maybe<RecognitionCoreValueNode>;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator?: Maybe<UserNode>;
    readonly description?: Maybe<Scalars["JSONString"]["output"]>;
    readonly endValue: Scalars["Int"]["output"];
    readonly id: Scalars["Int"]["output"];
    readonly isResponseMandatory: Scalars["Boolean"]["output"];
    readonly labelDescriptions: ReadonlyArray<
      Maybe<Scalars["String"]["output"]>
    >;
    readonly labels: ReadonlyArray<Maybe<Scalars["String"]["output"]>>;
    readonly organization: OrganizationNode;
    readonly questionType: AssessmentQuestionType;
    readonly responseVisibility: AssessmentQuestionResponseVisibility;
    readonly responses: AssessmentQuestionResponses;
    readonly startValue: Scalars["Int"]["output"];
    readonly title: Scalars["String"]["output"];
    readonly updated: Scalars["DateTime"]["output"];
  };

export type IndividualRecognitionCoreValueAssessmentQuestionNodeAnswersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type IndividualRecognitionCoreValueAssessmentQuestionNodeCategoriesArgs =
  {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
  };

export type InfoCardConnection = {
  readonly __typename: "InfoCardConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<InfoCardEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `InfoCard` and its cursor. */
export type InfoCardEdge = {
  readonly __typename: "InfoCardEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<InfoCardInterface>;
};

export type InfoCardInterface = {
  readonly assignees: ReadonlyArray<Maybe<ExternalProfileNode>>;
  readonly closedAt?: Maybe<Scalars["DateTime"]["output"]>;
  readonly created: Scalars["DateTime"]["output"];
  readonly description?: Maybe<Scalars["String"]["output"]>;
  readonly id: Scalars["ID"]["output"];
  readonly providerName?: Maybe<Scalars["String"]["output"]>;
  readonly status?: Maybe<InfoTaskStatus>;
  readonly title: Scalars["String"]["output"];
  readonly url: Scalars["String"]["output"];
};

/** An enumeration. */
export enum InfoTaskStatus {
  Closed = "closed",
  Open = "open",
}

export type InsightConnection = {
  readonly __typename: "InsightConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<InsightEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `Insight` and its cursor. */
export type InsightEdge = {
  readonly __typename: "InsightEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<InsightNode>;
};

export type InsightNode = {
  readonly __typename: "InsightNode";
  readonly artifact?: Maybe<ArtifactInterface>;
  readonly assessmentGroup?: Maybe<AssessmentGroupNode>;
  readonly assessmentTemplate?: Maybe<AssessmentTemplateNode>;
  readonly complianceProgram?: Maybe<ComplianceProgramNode>;
  readonly id: Scalars["ID"]["output"];
  readonly manager?: Maybe<UserNode>;
  readonly report?: Maybe<UserNode>;
  readonly targetUsers: UserNodeConnection;
  readonly templateRequirement?: Maybe<TemplateRequirementNode>;
  readonly type: InsightType;
};

export type InsightNodeTargetUsersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

/** An enumeration. */
export enum InsightPriority {
  High = "high",
  Low = "low",
  Medium = "medium",
  Positive = "positive",
}

/** An enumeration. */
export enum InsightType {
  CompleteAssessment = "COMPLETE_ASSESSMENT",
  CompleteSurvey = "COMPLETE_SURVEY",
  FeedbackRequest = "FEEDBACK_REQUEST",
  MissingManager = "MISSING_MANAGER",
  NominatePeers = "NOMINATE_PEERS",
  Nudge_1On1 = "NUDGE_1ON1",
  OfftrackGoal = "OFFTRACK_GOAL",
  RequiredTemplate = "REQUIRED_TEMPLATE",
  Schedule_1On1 = "SCHEDULE_1ON1",
  StaleGoal = "STALE_GOAL",
}

/** An enumeration. */
export enum IntegrationTypes {
  Clickup = "clickup",
  Hubspot = "hubspot",
  Jira = "jira",
  Linear = "linear",
  ReadAi = "read_ai",
  Rippling = "rippling",
  Salesforce = "salesforce",
  Teams = "teams",
  Youtrack = "youtrack",
}

export type InvitationInput = {
  readonly favourite?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly firstName?: InputMaybe<Scalars["String"]["input"]>;
  readonly inviteMessage: Scalars["String"]["input"];
  readonly inviteeEmail: Scalars["String"]["input"];
  readonly lastName?: InputMaybe<Scalars["String"]["input"]>;
  readonly organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  readonly relationships?: InputMaybe<
    ReadonlyArray<InputMaybe<RelationshipInput>>
  >;
  readonly role: OrganizationRole;
  readonly sendEmail?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly skipIfActive?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InvitationNode = DjangoNode &
  Node & {
    readonly __typename: "InvitationNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly created: Scalars["DateTime"]["output"];
    readonly id: Scalars["ID"]["output"];
    readonly inviteKey: Scalars["String"]["output"];
    readonly inviteMessage: Scalars["String"]["output"];
    readonly inviteeEmail: Scalars["String"]["output"];
    readonly inviterName?: Maybe<Scalars["String"]["output"]>;
    readonly organizationId?: Maybe<Scalars["Int"]["output"]>;
    readonly organizationMemberCount?: Maybe<Scalars["Int"]["output"]>;
    readonly organizationName?: Maybe<Scalars["String"]["output"]>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly role?: Maybe<OrganizationRole>;
    readonly status?: Maybe<InvitationStatus>;
  };

export type InvitationNodeConnection = {
  readonly __typename: "InvitationNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<InvitationNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `InvitationNode` and its cursor. */
export type InvitationNodeEdge = {
  readonly __typename: "InvitationNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<InvitationNode>;
};

/** An enumeration. */
export enum InvitationStatus {
  Accepted = "accepted",
  Pending = "pending",
}

export type InviteError = {
  readonly __typename: "InviteError";
  readonly inviteeEmail?: Maybe<Scalars["String"]["output"]>;
  readonly message?: Maybe<Scalars["String"]["output"]>;
};

export type JiraIssueNode = InfoCardInterface & {
  readonly __typename: "JiraIssueNode";
  readonly assignees: ReadonlyArray<Maybe<ExternalProfileNode>>;
  readonly closedAt?: Maybe<Scalars["DateTime"]["output"]>;
  readonly created: Scalars["DateTime"]["output"];
  readonly description?: Maybe<Scalars["String"]["output"]>;
  readonly id: Scalars["ID"]["output"];
  readonly providerName?: Maybe<Scalars["String"]["output"]>;
  readonly status?: Maybe<InfoTaskStatus>;
  readonly title: Scalars["String"]["output"];
  readonly url: Scalars["String"]["output"];
};

export type JoinOrganizationMutation = {
  readonly __typename: "JoinOrganizationMutation";
  readonly organization?: Maybe<OrganizationNode>;
  readonly user?: Maybe<UserNode>;
};

export type KpiArtifactNode = ArtifactInterface & {
  readonly __typename: "KPIArtifactNode";
  readonly activities: ArtifactActivityNodeConnection;
  readonly artifactType: ArtifactType;
  readonly assignableUsers?: Maybe<UserNodeConnection>;
  readonly canDelete: PermissionNode;
  readonly canRead: PermissionNode;
  readonly canUpdate: PermissionNode;
  readonly commentCount?: Maybe<Scalars["Int"]["output"]>;
  readonly comments?: Maybe<CommentNodeConnection>;
  readonly created: Scalars["DateTime"]["output"];
  readonly createdInMeeting?: Maybe<MeetingNode>;
  readonly creator?: Maybe<UserNode>;
  readonly description?: Maybe<Scalars["JSONString"]["output"]>;
  readonly eventChannelName?: Maybe<Scalars["String"]["output"]>;
  readonly id: Scalars["Int"]["output"];
  readonly isStale: Scalars["Boolean"]["output"];
  readonly kpi?: Maybe<KpiNode>;
  readonly measurement?: Maybe<KpiMeasurementNode>;
  readonly organization?: Maybe<OrganizationNode>;
  readonly relatedArtifacts?: Maybe<ArtifactToArtifactConnection>;
  readonly title?: Maybe<Scalars["String"]["output"]>;
  readonly topics?: Maybe<ArtifactToTopicConnection>;
  readonly updated?: Maybe<Scalars["DateTime"]["output"]>;
  readonly uuid?: Maybe<Scalars["String"]["output"]>;
  readonly websocketToken?: Maybe<Scalars["String"]["output"]>;
};

export type KpiArtifactNodeActivitiesArgs = {
  activityType?: InputMaybe<ArtifactActivityType>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type KpiArtifactNodeAssignableUsersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type KpiArtifactNodeCommentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  artifactId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  isInlineComment?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  textUuid?: InputMaybe<Scalars["String"]["input"]>;
  topicId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type KpiArtifactNodeRelatedArtifactsArgs = {
  actionItemAssignedToMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignees?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  actionItemDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  actionItemProgress?: InputMaybe<Scalars["Float"]["input"]>;
  actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemStates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  ancestorsOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  artifactTypes?: InputMaybe<ReadonlyArray<InputMaybe<ArtifactType>>>;
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  asUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  assignedToMembersOfOrganizationId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  completedActionItemsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedActionItemsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  createdByIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  createdInMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackSenders?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackState?: InputMaybe<FeedbackState>;
  feedbackStates?: InputMaybe<ReadonlyArray<InputMaybe<FeedbackState>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  goalCompetencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalContributors?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalInvolvingUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalParentIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalResponsibilityIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalScope?: InputMaybe<GoalScope>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalState?: InputMaybe<GoalState>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalStatus?: InputMaybe<GoalStatus>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalVisibility?: InputMaybe<GoalVisibility>;
  goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  groupBy?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  isStale?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValue?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionReceivedByMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type KpiArtifactNodeTopicsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assignee?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasActionItems?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasArtifacts?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDecisions?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDocuments?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasGoals?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInFlowId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInMeetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<TopicState>;
  titleContains?: InputMaybe<Scalars["String"]["input"]>;
  topicIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type KpiGroupNode = DjangoNode &
  Node & {
    readonly __typename: "KPIGroupNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly creator?: Maybe<UserNode>;
    readonly id: Scalars["ID"]["output"];
    readonly kpis?: Maybe<KpiNodeConnection>;
    readonly organization?: Maybe<OrganizationNode>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly title: Scalars["String"]["output"];
  };

export type KpiGroupNodeKpisArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  group?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type KpiGroupNodeConnection = {
  readonly __typename: "KPIGroupNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<KpiGroupNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `KPIGroupNode` and its cursor. */
export type KpiGroupNodeEdge = {
  readonly __typename: "KPIGroupNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<KpiGroupNode>;
};

export type KpiIntegrationConnection = {
  readonly __typename: "KPIIntegrationConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<KpiIntegrationEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `KPIIntegration` and its cursor. */
export type KpiIntegrationEdge = {
  readonly __typename: "KPIIntegrationEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<KpiIntegrationInterface>;
};

export type KpiIntegrationInput = {
  readonly github?: InputMaybe<GithubKpiIntegrationInput>;
  readonly googleSheets?: InputMaybe<GoogleSheetsKpiIntegrationInput>;
  readonly hubspot?: InputMaybe<HubspotKpiIntegrationInput>;
  /** If an integration already exists and is being updated, provide the id */
  readonly integrationId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Required if a new integration is being created */
  readonly integrationType?: InputMaybe<KpiIntegrationType>;
  /** Optionally specify which integration connection to use */
  readonly organizationIntegrationConnectionId?: InputMaybe<
    Scalars["Int"]["input"]
  >;
  readonly salesforce?: InputMaybe<SalesforceKpiIntegrationInput>;
  readonly topicflow?: InputMaybe<TopicflowKpiIntegrationInput>;
};

export type KpiIntegrationInterface = {
  readonly created?: Maybe<Scalars["DateTime"]["output"]>;
  readonly creator?: Maybe<UserNode>;
  readonly id: Scalars["Int"]["output"];
  readonly integrationType?: Maybe<KpiIntegrationType>;
  readonly kpi?: Maybe<KpiNode>;
  readonly organizationIntegrationConnection?: Maybe<OrganizationIntegrationNode>;
  readonly updated?: Maybe<Scalars["DateTime"]["output"]>;
};

/** An enumeration. */
export enum KpiIntegrationType {
  Github = "github",
  Googlesheets = "googlesheets",
  Hubspot = "hubspot",
  Salesforce = "salesforce",
  Topicflow = "topicflow",
}

export type KpiMeasurementNode = DjangoNode &
  Node & {
    readonly __typename: "KPIMeasurementNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator?: Maybe<UserNode>;
    readonly id: Scalars["ID"]["output"];
    readonly kpi?: Maybe<KpiNode>;
    readonly measurement: Scalars["Float"]["output"];
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    /** The timestamp for the measurement itself, not just when it was created in Topicflow */
    readonly timestamp: Scalars["DateTime"]["output"];
  };

export type KpiMeasurementNodeConnection = {
  readonly __typename: "KPIMeasurementNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<KpiMeasurementNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `KPIMeasurementNode` and its cursor. */
export type KpiMeasurementNodeEdge = {
  readonly __typename: "KPIMeasurementNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<KpiMeasurementNode>;
};

export type KpiNode = DjangoNode &
  Node & {
    readonly __typename: "KPINode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate: PermissionNode;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator?: Maybe<UserNode>;
    readonly currentMeasurement?: Maybe<KpiMeasurementNode>;
    readonly defaultSummaryMethod: KpiSummaryMethod;
    readonly defaultSummaryPeriod: KpiSummaryPeriod;
    readonly description?: Maybe<Scalars["JSONString"]["output"]>;
    readonly groups?: Maybe<KpiGroupNodeConnection>;
    readonly id: Scalars["ID"]["output"];
    readonly integration?: Maybe<KpiIntegrationInterface>;
    readonly integrations?: Maybe<KpiIntegrationConnection>;
    readonly linkedGoals?: Maybe<GoalArtifactConnection>;
    readonly linkedKeyResults?: Maybe<KeyResultNodeConnection>;
    readonly measurementForDate?: Maybe<KpiMeasurementNode>;
    readonly measurements?: Maybe<KpiMeasurementNodeConnection>;
    readonly organization?: Maybe<OrganizationNode>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly summarizedMeasurements: SummarizedMeasurementsConnection;
    readonly targetCondition: KpiTargetCondition;
    readonly targetType: KpiTargetType;
    readonly targetValue?: Maybe<Scalars["Float"]["output"]>;
    readonly teams?: Maybe<TeamNodeConnection>;
    readonly title: Scalars["String"]["output"];
    readonly updateKey: Scalars["String"]["output"];
    readonly updateUrl: Scalars["String"]["output"];
    readonly visibility: KpiVisibility;
  };

export type KpiNodeGroupsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type KpiNodeIntegrationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type KpiNodeLinkedGoalsArgs = {
  actionItemAssignedToMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignees?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  actionItemDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  actionItemProgress?: InputMaybe<Scalars["Float"]["input"]>;
  actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemStates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  ancestorsOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  artifactTypes?: InputMaybe<ReadonlyArray<InputMaybe<ArtifactType>>>;
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  asUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  assignedToMembersOfOrganizationId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  completedActionItemsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedActionItemsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  createdByIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  createdInMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackSenders?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackState?: InputMaybe<FeedbackState>;
  feedbackStates?: InputMaybe<ReadonlyArray<InputMaybe<FeedbackState>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  goalCompetencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalContributors?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalInvolvingUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalParentIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalResponsibilityIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalScope?: InputMaybe<GoalScope>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalState?: InputMaybe<GoalState>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalStatus?: InputMaybe<GoalStatus>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalVisibility?: InputMaybe<GoalVisibility>;
  goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  groupBy?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  isStale?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValue?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionReceivedByMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type KpiNodeLinkedKeyResultsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type KpiNodeMeasurementForDateArgs = {
  forDate: Scalars["Date"]["input"];
};

export type KpiNodeMeasurementsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
};

export type KpiNodeSummarizedMeasurementsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  summaryMethod?: InputMaybe<KpiSummaryMethod>;
  summaryPeriod?: InputMaybe<KpiSummaryPeriod>;
};

export type KpiNodeTeamsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organization?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  title_Startswith?: InputMaybe<Scalars["String"]["input"]>;
};

export type KpiNodeConnection = {
  readonly __typename: "KPINodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<KpiNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `KPINode` and its cursor. */
export type KpiNodeEdge = {
  readonly __typename: "KPINodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<KpiNode>;
};

/** An enumeration. */
export enum KpiSummaryMethod {
  Average = "average",
  LastValue = "last_value",
  Sum = "sum",
}

/** An enumeration. */
export enum KpiSummaryPeriod {
  Daily = "daily",
  Monthly = "monthly",
  Weekly = "weekly",
}

/** An enumeration. */
export enum KpiTargetCondition {
  GreaterThan = "greater_than",
  GreaterThanOrEqualTo = "greater_than_or_equal_to",
  LessThan = "less_than",
  LessThanOrEqualTo = "less_than_or_equal_to",
}

/** An enumeration. */
export enum KpiTargetType {
  Growth = "growth",
  Value = "value",
}

/** An enumeration. */
export enum KpiVisibility {
  Org = "org",
  Personal = "personal",
  Teams = "teams",
}

export type KeyResultInput = {
  readonly assigneeId?: InputMaybe<Scalars["Int"]["input"]>;
  readonly currentValue?: InputMaybe<Scalars["Float"]["input"]>;
  readonly description?: InputMaybe<Scalars["String"]["input"]>;
  readonly kpiId?: InputMaybe<Scalars["Int"]["input"]>;
  readonly progressType?: InputMaybe<GoalProgressType>;
  readonly startValue?: InputMaybe<Scalars["Float"]["input"]>;
  readonly targetValue?: InputMaybe<Scalars["Float"]["input"]>;
  readonly title?: InputMaybe<Scalars["String"]["input"]>;
};

export type KeyResultNode = DjangoNode &
  Node & {
    readonly __typename: "KeyResultNode";
    readonly assignee?: Maybe<UserNode>;
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly currentValue: Scalars["Float"]["output"];
    readonly description: Scalars["String"]["output"];
    readonly goal?: Maybe<GoalArtifactNode>;
    readonly id: Scalars["ID"]["output"];
    readonly kpi?: Maybe<KpiNode>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly progressType: GoalProgressType;
    readonly startValue: Scalars["Float"]["output"];
    readonly targetValue: Scalars["Float"]["output"];
    readonly title: Scalars["String"]["output"];
  };

export type KeyResultNodeConnection = {
  readonly __typename: "KeyResultNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<KeyResultNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `KeyResultNode` and its cursor. */
export type KeyResultNodeEdge = {
  readonly __typename: "KeyResultNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<KeyResultNode>;
};

export type LinearIssueNode = InfoCardInterface & {
  readonly __typename: "LinearIssueNode";
  readonly assignees: ReadonlyArray<Maybe<ExternalProfileNode>>;
  readonly closedAt?: Maybe<Scalars["DateTime"]["output"]>;
  readonly created: Scalars["DateTime"]["output"];
  readonly description?: Maybe<Scalars["String"]["output"]>;
  readonly id: Scalars["ID"]["output"];
  readonly providerName?: Maybe<Scalars["String"]["output"]>;
  readonly status?: Maybe<InfoTaskStatus>;
  readonly title: Scalars["String"]["output"];
  readonly url: Scalars["String"]["output"];
  readonly workflowState?: Maybe<Scalars["String"]["output"]>;
};

export type LinearProjectNode = InfoCardInterface & {
  readonly __typename: "LinearProjectNode";
  readonly assignees: ReadonlyArray<Maybe<ExternalProfileNode>>;
  readonly closedAt?: Maybe<Scalars["DateTime"]["output"]>;
  readonly created: Scalars["DateTime"]["output"];
  readonly description?: Maybe<Scalars["String"]["output"]>;
  readonly id: Scalars["ID"]["output"];
  readonly lead?: Maybe<ExternalProfileNode>;
  readonly members: ReadonlyArray<Maybe<ExternalProfileNode>>;
  readonly providerName?: Maybe<Scalars["String"]["output"]>;
  readonly startDate?: Maybe<Scalars["Date"]["output"]>;
  readonly status?: Maybe<InfoTaskStatus>;
  readonly targetDate?: Maybe<Scalars["Date"]["output"]>;
  readonly title: Scalars["String"]["output"];
  readonly url: Scalars["String"]["output"];
};

export type LinkCalendarToOrganizationMutation = {
  readonly __typename: "LinkCalendarToOrganizationMutation";
  readonly organization?: Maybe<OrganizationNode>;
  readonly syncCredentials?: Maybe<UserSyncCredentialsNode>;
  readonly user?: Maybe<UserNode>;
};

export type LinkCreatedArtifactToChatMessageMutation = {
  readonly __typename: "LinkCreatedArtifactToChatMessageMutation";
  readonly chatSession?: Maybe<ChatSessionNode>;
};

export type ManagerEffectivenessReportConnection = {
  readonly __typename: "ManagerEffectivenessReportConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ManagerEffectivenessReportEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `ManagerEffectivenessReport` and its cursor. */
export type ManagerEffectivenessReportEdge = {
  readonly __typename: "ManagerEffectivenessReportEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<ManagerEffectivenessReportRowNode>;
};

export type ManagerEffectivenessReportQuestionConnection = {
  readonly __typename: "ManagerEffectivenessReportQuestionConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ManagerEffectivenessReportQuestionEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `ManagerEffectivenessReportQuestion` and its cursor. */
export type ManagerEffectivenessReportQuestionEdge = {
  readonly __typename: "ManagerEffectivenessReportQuestionEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<ManagerEffectivenessReportQuestionNode>;
};

export type ManagerEffectivenessReportQuestionNode = {
  readonly __typename: "ManagerEffectivenessReportQuestionNode";
  readonly avgAnswer?: Maybe<Scalars["Float"]["output"]>;
  readonly question: AssessmentQuestionInterface;
};

export type ManagerEffectivenessReportRowNode = {
  readonly __typename: "ManagerEffectivenessReportRowNode";
  readonly assessmentDelivery?: Maybe<AssessmentDeliveryNode>;
  readonly assessments: AssessmentNodeConnection;
  readonly manager: UserNode;
  readonly questions: ManagerEffectivenessReportQuestionConnection;
};

export type ManagerEffectivenessReportRowNodeAssessmentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assessmentType?: InputMaybe<AssessmentType>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  responderId?: InputMaybe<Scalars["Int"]["input"]>;
  selfAssessment?: InputMaybe<Scalars["Boolean"]["input"]>;
  state?: InputMaybe<AssessmentState>;
  targetId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ManagerEffectivenessReportRowNodeQuestionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ManagerInsightConnection = {
  readonly __typename: "ManagerInsightConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ManagerInsightEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `ManagerInsight` and its cursor. */
export type ManagerInsightEdge = {
  readonly __typename: "ManagerInsightEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<ManagerInsightNode>;
};

export type ManagerInsightNode = {
  readonly __typename: "ManagerInsightNode";
  readonly coachingInsight?: Maybe<CoachingInsightNode>;
  readonly coachingReportId?: Maybe<Scalars["Int"]["output"]>;
  readonly description?: Maybe<Scalars["String"]["output"]>;
  readonly forUser: UserNode;
  readonly insightType: ManagerInsightType;
  readonly relatedMeeting?: Maybe<MeetingNode>;
  readonly relatedUrl?: Maybe<Scalars["String"]["output"]>;
  readonly suggestedArtifactTitle?: Maybe<Scalars["String"]["output"]>;
  readonly suggestedCoreValue?: Maybe<RecognitionCoreValueNode>;
  readonly title: Scalars["String"]["output"];
};

/** An enumeration. */
export enum ManagerInsightType {
  DiscussionTopic = "discussion_topic",
  Feedback = "feedback",
  Recognition = "recognition",
}

export type MarkMeetingTopicsAsDiscussedMutation = {
  readonly __typename: "MarkMeetingTopicsAsDiscussedMutation";
  readonly meeting?: Maybe<MeetingNode>;
};

export type MarkPreviousMeetingTopicsAsDiscussedMutation = {
  readonly __typename: "MarkPreviousMeetingTopicsAsDiscussedMutation";
  readonly meeting?: Maybe<MeetingNode>;
};

/**
 * Flag that the current manager has done (or dismissed) the initial onboarding first-screen for
 * a direct report, so the profile stops auto-showing it. The manager can still re-run it anytime.
 */
export type MarkReportOnboardedMutation = {
  readonly __typename: "MarkReportOnboardedMutation";
  readonly user?: Maybe<UserNode>;
};

/** An enumeration. */
export enum MeetingAgendaEmailPreference {
  Always = "always",
  Never = "never",
  WhenAgendaExists = "when_agenda_exists",
  WhenOrganizer = "when_organizer",
}

/** An enumeration. */
export enum MeetingBotJoinReason {
  MeetingFlagDisabled = "meeting_flag_disabled",
  MeetingFlagEnabled = "meeting_flag_enabled",
  NoParticipantsWithSettingEnabled = "no_participants_with_setting_enabled",
  OrgSettingDisabled = "org_setting_disabled",
  ParticipantSettingEnabled = "participant_setting_enabled",
}

/** An enumeration. */
export enum MeetingBotSetting {
  AlwaysJoin = "always_join",
  NeverJoin = "never_join",
  UseParticipantsSetting = "use_participants_setting",
}

export enum MeetingEditTypeEnum {
  AllEvents = "all_events",
  SingleEvent = "single_event",
  ThisEventAndFuture = "this_event_and_future",
}

export type MeetingGroupNode = DjangoNode &
  Node & {
    readonly __typename: "MeetingGroupNode";
    readonly addTranscriptionBotToMeetingsByDefault: Scalars["Boolean"]["output"];
    readonly allowAdminVisibility: Scalars["Boolean"]["output"];
    readonly allowExternalViewers: Scalars["Boolean"]["output"];
    readonly allowManagementTreeVisibility: Scalars["Boolean"]["output"];
    readonly allowOrgVisibility: Scalars["Boolean"]["output"];
    readonly artifacts?: Maybe<ArtifactConnection>;
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator?: Maybe<UserNode>;
    readonly description?: Maybe<Scalars["String"]["output"]>;
    readonly detectedOneononeBannerDismissed: Scalars["Boolean"]["output"];
    readonly facilitator?: Maybe<UserNode>;
    readonly goals?: Maybe<ArtifactConnection>;
    readonly hasTemplate?: Maybe<Scalars["Boolean"]["output"]>;
    readonly id: Scalars["ID"]["output"];
    readonly isFormalOneonone: Scalars["Boolean"]["output"];
    readonly meetingBotSetting?: Maybe<MeetingBotSetting>;
    readonly meetings?: Maybe<MeetingNodeConnection>;
    readonly onlineConference: OnlineConference;
    readonly organization?: Maybe<OrganizationNode>;
    readonly participants: MeetingParticipantConnection;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly recurrenceParameters?: Maybe<FrequencyNode>;
    readonly recurrenceRule?: Maybe<Scalars["String"]["output"]>;
    readonly slackNotifications?: Maybe<SlackNotificationConnectionNodeConnection>;
    readonly syncCredentials?: Maybe<UserSyncCredentialsNode>;
    readonly templateSeries?: Maybe<TemplateSeriesNodeConnection>;
    readonly title: Scalars["String"]["output"];
    readonly topicTemplate?: Maybe<TopicTemplateNode>;
    readonly transcribeMeetingsByDefault?: Maybe<Scalars["Boolean"]["output"]>;
  };

export type MeetingGroupNodeArtifactsArgs = {
  actionItemAssignedToMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignees?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  actionItemDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  actionItemProgress?: InputMaybe<Scalars["Float"]["input"]>;
  actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemStates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  ancestorsOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  artifactTypes?: InputMaybe<ReadonlyArray<InputMaybe<ArtifactType>>>;
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  asUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  assignedToMembersOfOrganizationId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  completedActionItemsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedActionItemsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  createdByIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  createdInMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackSenders?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackState?: InputMaybe<FeedbackState>;
  feedbackStates?: InputMaybe<ReadonlyArray<InputMaybe<FeedbackState>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  goalCompetencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalContributors?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalInvolvingUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalParentIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalResponsibilityIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalScope?: InputMaybe<GoalScope>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalState?: InputMaybe<GoalState>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalStatus?: InputMaybe<GoalStatus>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalVisibility?: InputMaybe<GoalVisibility>;
  goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  groupBy?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  isStale?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValue?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionReceivedByMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MeetingGroupNodeGoalsArgs = {
  actionItemAssignedToMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignees?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  actionItemDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  actionItemProgress?: InputMaybe<Scalars["Float"]["input"]>;
  actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemStates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  ancestorsOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  artifactTypes?: InputMaybe<ReadonlyArray<InputMaybe<ArtifactType>>>;
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  asUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  assignedToMembersOfOrganizationId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  completedActionItemsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedActionItemsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  createdByIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  createdInMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackSenders?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackState?: InputMaybe<FeedbackState>;
  feedbackStates?: InputMaybe<ReadonlyArray<InputMaybe<FeedbackState>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  goalCompetencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalContributors?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalInvolvingUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalParentIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalResponsibilityIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalScope?: InputMaybe<GoalScope>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalState?: InputMaybe<GoalState>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalStatus?: InputMaybe<GoalStatus>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalVisibility?: InputMaybe<GoalVisibility>;
  goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  groupBy?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  isStale?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValue?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionReceivedByMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MeetingGroupNodeMeetingsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  draft?: InputMaybe<Scalars["Boolean"]["input"]>;
  endDatetime?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  excludeMeetingGroupIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  fromMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  ignored?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFinalized?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFormalOneonone?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  minimumDateRange?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Decimal"]["input"]>;
  participantCount?: InputMaybe<Scalars["Int"]["input"]>;
  participants?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  startDatetime?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  status?: InputMaybe<EventStatus>;
  status_In?: InputMaybe<ReadonlyArray<InputMaybe<EventStatus>>>;
  subject?: InputMaybe<Scalars["Int"]["input"]>;
  templateId?: InputMaybe<Scalars["Int"]["input"]>;
  unscheduled?: InputMaybe<Scalars["Boolean"]["input"]>;
  usingRequiredTemplateOfValidPrograms?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
};

export type MeetingGroupNodeParticipantsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type MeetingGroupNodeSlackNotificationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MeetingGroupNodeTemplateSeriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MeetingGroupNodeConnection = {
  readonly __typename: "MeetingGroupNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<MeetingGroupNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `MeetingGroupNode` and its cursor. */
export type MeetingGroupNodeEdge = {
  readonly __typename: "MeetingGroupNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<MeetingGroupNode>;
};

/**
 * A data type which contains some info that all admins can see, as well as a reference to the actual meeting (for
 * which permissions are checked)
 */
export type MeetingInfoNode = {
  readonly __typename: "MeetingInfoNode";
  readonly id?: Maybe<Scalars["Int"]["output"]>;
  readonly meeting?: Maybe<MeetingNode>;
  readonly startDatetime?: Maybe<Scalars["DateTime"]["output"]>;
};

export type MeetingInterface = {
  readonly startDate?: Maybe<Scalars["Date"]["output"]>;
};

export type MeetingNode = DjangoNode &
  MeetingInterface &
  Node & {
    readonly __typename: "MeetingNode";
    readonly activeComplianceProgramsWithUnmetTopicTemplates: ComplianceProgramNodeConnection;
    readonly allowExternalViewers?: Maybe<Scalars["Boolean"]["output"]>;
    readonly artifacts?: Maybe<ArtifactConnection>;
    readonly assessmentDeliveriesMatching1on1Template: AssessmentDeliveryNodeConnection;
    readonly autocompleteTopics?: Maybe<TitleAutocompleteConnection>;
    readonly botIsRecording: Scalars["Boolean"]["output"];
    readonly botIsWaitingToJoinMeeting: Scalars["Boolean"]["output"];
    readonly botParticipationDetails: BotParticipationDetailsNode;
    readonly botStatus?: Maybe<RecallBotStatus>;
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canFinalize: PermissionNode;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly colours?: Maybe<EventColours>;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator?: Maybe<UserNode>;
    readonly description?: Maybe<Scalars["String"]["output"]>;
    readonly draft: Scalars["Boolean"]["output"];
    readonly effectiveAllowExternalViewers?: Maybe<
      Scalars["Boolean"]["output"]
    >;
    readonly endDatetime?: Maybe<Scalars["DateTime"]["output"]>;
    readonly externalUrl?: Maybe<Scalars["String"]["output"]>;
    readonly externalViewers?: Maybe<UserNodeConnection>;
    readonly finalizedAt?: Maybe<Scalars["DateTime"]["output"]>;
    readonly finalizedBy?: Maybe<UserNode>;
    readonly flows?: Maybe<FlowNodeConnection>;
    readonly generatedSuggestedTopics?: Maybe<SuggestedTopicNodeConnection>;
    readonly hasBotInMeeting: Scalars["Boolean"]["output"];
    readonly hasExternalParticipants?: Maybe<Scalars["Boolean"]["output"]>;
    readonly hasIncompleteMandatoryTopics: Scalars["Boolean"]["output"];
    readonly hasPreviousMeetings?: Maybe<Scalars["Boolean"]["output"]>;
    readonly hasPreviousMeetingsWithTopics?: Maybe<
      Scalars["Boolean"]["output"]
    >;
    readonly hasTranscript?: Maybe<Scalars["Boolean"]["output"]>;
    readonly id: Scalars["ID"]["output"];
    readonly ignored: Scalars["Boolean"]["output"];
    readonly insights: InsightConnection;
    readonly isFinalized: Scalars["Boolean"]["output"];
    readonly isFirstInstanceInSeries?: Maybe<Scalars["Boolean"]["output"]>;
    readonly isLocked: Scalars["Boolean"]["output"];
    readonly isManagerAndReportOneonone: Scalars["Boolean"]["output"];
    readonly isRecurring: Scalars["Boolean"]["output"];
    readonly isSubmitted: Scalars["Boolean"]["output"];
    readonly kvItems?: Maybe<UserKvItemNodeConnection>;
    readonly meetingGroup?: Maybe<MeetingGroupNode>;
    readonly meetingGroupId: Scalars["Int"]["output"];
    readonly notesSummary?: Maybe<Scalars["String"]["output"]>;
    readonly organization?: Maybe<OrganizationNode>;
    readonly organizer?: Maybe<UserNode>;
    readonly participants?: Maybe<MeetingParticipantConnection>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly previousMeeting?: Maybe<MeetingNode>;
    readonly ratingRequirements?: Maybe<MeetingRatingRequirementNodeConnection>;
    readonly recentlyCompletedAssessmentDeliveries: AssessmentDeliveryNodeConnection;
    readonly recentlyCompletedAssessments: AssessmentNodeConnection;
    readonly relatedAssessments: AssessmentNodeConnection;
    readonly startDate?: Maybe<Scalars["Date"]["output"]>;
    readonly startDatetime?: Maybe<Scalars["DateTime"]["output"]>;
    readonly status?: Maybe<EventStatus>;
    readonly subject?: Maybe<UserNode>;
    readonly suggestedTemplates?: Maybe<TopicTemplateNodeConnection>;
    readonly suggestedTopics?: Maybe<TopicNodeConnection>;
    readonly title?: Maybe<Scalars["String"]["output"]>;
    readonly topics?: Maybe<TopicNodeConnection>;
    readonly transcript?: Maybe<MeetingTranscriptNode>;
    readonly transcriptionStatus?: Maybe<Scalars["Boolean"]["output"]>;
    readonly undiscussedPreviousMeetingTopics?: Maybe<
      ReadonlyArray<Maybe<TopicNode>>
    >;
    readonly videoConferenceType?: Maybe<OnlineVideoConference>;
    readonly videoConferenceUrl?: Maybe<Scalars["String"]["output"]>;
    readonly websocketToken?: Maybe<Scalars["String"]["output"]>;
    readonly writableSharingUrl?: Maybe<Scalars["String"]["output"]>;
  };

export type MeetingNodeActiveComplianceProgramsWithUnmetTopicTemplatesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  applicableUser?: InputMaybe<Scalars["Int"]["input"]>;
  assessmentType?: InputMaybe<AssessmentType>;
  assessmentTypes?: InputMaybe<ReadonlyArray<InputMaybe<AssessmentType>>>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  dueDate?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate_Gt?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate_Gte?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate_Lt?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate_Lte?: InputMaybe<Scalars["Date"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  onlyActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<ComplianceProgramState>;
  state_In?: InputMaybe<ReadonlyArray<InputMaybe<ComplianceProgramState>>>;
};

export type MeetingNodeArtifactsArgs = {
  actionItemAssignedToMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignees?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  actionItemDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  actionItemProgress?: InputMaybe<Scalars["Float"]["input"]>;
  actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemStates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  ancestorsOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  artifactTypes?: InputMaybe<ReadonlyArray<InputMaybe<ArtifactType>>>;
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  asUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  assignedToMembersOfOrganizationId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  completedActionItemsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedActionItemsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  createdByIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  createdInMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackSenders?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackState?: InputMaybe<FeedbackState>;
  feedbackStates?: InputMaybe<ReadonlyArray<InputMaybe<FeedbackState>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  goalCompetencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalContributors?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalInvolvingUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalParentIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalResponsibilityIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalScope?: InputMaybe<GoalScope>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalState?: InputMaybe<GoalState>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalStatus?: InputMaybe<GoalStatus>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalVisibility?: InputMaybe<GoalVisibility>;
  goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  groupBy?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  isStale?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValue?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionReceivedByMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MeetingNodeAssessmentDeliveriesMatching1on1TemplateArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  complianceProgramId?: InputMaybe<Scalars["Int"]["input"]>;
  creatorId?: InputMaybe<Scalars["Int"]["input"]>;
  excludedProgramIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  state_In?: InputMaybe<ReadonlyArray<InputMaybe<AssessmentDeliveryState>>>;
  targetId?: InputMaybe<Scalars["Int"]["input"]>;
  targetIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type MeetingNodeAutocompleteTopicsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  searchTerm: Scalars["String"]["input"];
};

export type MeetingNodeExternalViewersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type MeetingNodeFlowsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MeetingNodeGeneratedSuggestedTopicsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hidden?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MeetingNodeInsightsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MeetingNodeKvItemsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  key_Startswith?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MeetingNodeParticipantsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type MeetingNodeRatingRequirementsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MeetingNodeRecentlyCompletedAssessmentDeliveriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  complianceProgramId?: InputMaybe<Scalars["Int"]["input"]>;
  creatorId?: InputMaybe<Scalars["Int"]["input"]>;
  excludedProgramIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  state_In?: InputMaybe<ReadonlyArray<InputMaybe<AssessmentDeliveryState>>>;
  targetId?: InputMaybe<Scalars["Int"]["input"]>;
  targetIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type MeetingNodeRecentlyCompletedAssessmentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assessmentType?: InputMaybe<AssessmentType>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  responderId?: InputMaybe<Scalars["Int"]["input"]>;
  selfAssessment?: InputMaybe<Scalars["Boolean"]["input"]>;
  state?: InputMaybe<AssessmentState>;
  targetId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MeetingNodeRelatedAssessmentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assessmentType?: InputMaybe<AssessmentType>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  responderId?: InputMaybe<Scalars["Int"]["input"]>;
  selfAssessment?: InputMaybe<Scalars["Boolean"]["input"]>;
  state?: InputMaybe<AssessmentState>;
  targetId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MeetingNodeSuggestedTemplatesArgs = {
  adhocTemplate?: InputMaybe<Scalars["Boolean"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  globalTemplate?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasRequirements?: InputMaybe<Scalars["Boolean"]["input"]>;
  includesRatingId?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  publicTemplate?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MeetingNodeSuggestedTopicsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assignee?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasActionItems?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasArtifacts?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDecisions?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDocuments?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasGoals?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInFlowId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInMeetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<TopicState>;
  titleContains?: InputMaybe<Scalars["String"]["input"]>;
  topicIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type MeetingNodeTopicsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assignee?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasActionItems?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasArtifacts?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDecisions?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDocuments?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasGoals?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInFlowId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInMeetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<TopicState>;
  titleContains?: InputMaybe<Scalars["String"]["input"]>;
  topicIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type MeetingNodeConnection = {
  readonly __typename: "MeetingNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<MeetingNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `MeetingNode` and its cursor. */
export type MeetingNodeEdge = {
  readonly __typename: "MeetingNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<MeetingNode>;
};

export type MeetingParticipantConnection = {
  readonly __typename: "MeetingParticipantConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<MeetingParticipantEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `MeetingParticipant` and its cursor. */
export type MeetingParticipantEdge = {
  readonly __typename: "MeetingParticipantEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<MeetingParticipantNode>;
};

export type MeetingParticipantNode = {
  readonly __typename: "MeetingParticipantNode";
  readonly id?: Maybe<Scalars["String"]["output"]>;
  readonly participantEmail?: Maybe<Scalars["String"]["output"]>;
  readonly role?: Maybe<AttendeeRole>;
  readonly status?: Maybe<AttendeeStatus>;
  readonly user?: Maybe<BasicUserNode>;
};

export type MeetingRatingRequirementNode = DjangoNode &
  Node & {
    readonly __typename: "MeetingRatingRequirementNode";
    readonly allowAdminVisibility: Scalars["Boolean"]["output"];
    readonly allowManagerAnswers: Scalars["Boolean"]["output"];
    readonly allowManagerVisibility: Scalars["Boolean"]["output"];
    readonly allowMeetingParticipantAnswers: Scalars["Boolean"]["output"];
    readonly allowMeetingParticipantVisibility: Scalars["Boolean"]["output"];
    readonly allowOrganizationVisibility: Scalars["Boolean"]["output"];
    readonly allowReportAnswers: Scalars["Boolean"]["output"];
    readonly allowReportVisibility: Scalars["Boolean"]["output"];
    readonly canAnswer?: Maybe<Scalars["Boolean"]["output"]>;
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly canViewAnswers?: Maybe<Scalars["Boolean"]["output"]>;
    readonly creator?: Maybe<UserNode>;
    readonly id: Scalars["ID"]["output"];
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly rating?: Maybe<RatingNode>;
    readonly ratingArtifact?: Maybe<RatingArtifactNode>;
  };

export type MeetingRatingRequirementNodeConnection = {
  readonly __typename: "MeetingRatingRequirementNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<MeetingRatingRequirementNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `MeetingRatingRequirementNode` and its cursor. */
export type MeetingRatingRequirementNodeEdge = {
  readonly __typename: "MeetingRatingRequirementNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<MeetingRatingRequirementNode>;
};

/** An enumeration. */
export enum MeetingSummaryEmailPreference {
  Always = "always",
  None = "none",
  WhenDeclined = "when_declined",
}

export type MeetingTranscriptMessageNode = {
  readonly __typename: "MeetingTranscriptMessageNode";
  readonly created?: Maybe<Scalars["Float"]["output"]>;
  readonly messageId?: Maybe<Scalars["String"]["output"]>;
  readonly speaker?: Maybe<Scalars["String"]["output"]>;
  readonly startTimestamp?: Maybe<Scalars["Float"]["output"]>;
  readonly text: Scalars["String"]["output"];
};

export type MeetingTranscriptNode = DjangoNode &
  Node & {
    readonly __typename: "MeetingTranscriptNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canSaveVideoRecording?: Maybe<Scalars["Boolean"]["output"]>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator?: Maybe<UserNode>;
    readonly highlightCategories?: Maybe<TranscriptHighlightCategoryConnection>;
    readonly highlightList?: Maybe<TranscriptHighlightConnection>;
    readonly highlights?: Maybe<Scalars["String"]["output"]>;
    readonly id: Scalars["ID"]["output"];
    readonly lastChunkSummarizationIndex: Scalars["Int"]["output"];
    readonly lastChunkSummarizationTime?: Maybe<Scalars["DateTime"]["output"]>;
    readonly longSummary?: Maybe<Scalars["String"]["output"]>;
    readonly meeting?: Maybe<MeetingNode>;
    readonly orderedTranscriptData?: Maybe<
      ReadonlyArray<Maybe<MeetingTranscriptMessageNode>>
    >;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly recallVideoRecording?: Maybe<Scalars["String"]["output"]>;
    readonly suggestedArtifacts?: Maybe<SuggestedArtifactNodeConnection>;
    readonly summary?: Maybe<Scalars["String"]["output"]>;
    readonly updated: Scalars["DateTime"]["output"];
    readonly userMapping?: Maybe<Scalars["JSONString"]["output"]>;
    readonly videoRecording?: Maybe<Scalars["String"]["output"]>;
    readonly videoRecordingAvailableUntil?: Maybe<
      Scalars["DateTime"]["output"]
    >;
  };

export type MeetingTranscriptNodeHighlightCategoriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MeetingTranscriptNodeHighlightListArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MeetingTranscriptNodeSuggestedArtifactsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hidden?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MeetingWithRelevantSectionsNode = {
  readonly __typename: "MeetingWithRelevantSectionsNode";
  readonly meeting?: Maybe<MeetingNode>;
  readonly relevantSections?: Maybe<ReadonlyArray<Maybe<RelevantSectionNode>>>;
};

export type MeetingsByManagerReportConnection = {
  readonly __typename: "MeetingsByManagerReportConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<MeetingsByManagerReportEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `MeetingsByManagerReport` and its cursor. */
export type MeetingsByManagerReportEdge = {
  readonly __typename: "MeetingsByManagerReportEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<MeetingsByManagerReportNode>;
};

export type MeetingsByManagerReportNode = {
  readonly __typename: "MeetingsByManagerReportNode";
  readonly id?: Maybe<Scalars["Int"]["output"]>;
  readonly manager?: Maybe<UserNode>;
  readonly organization?: Maybe<OrganizationNode>;
  readonly reports?: Maybe<UserReportConnection>;
};

export type MeetingsByManagerReportNodeReportsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Should be fulfilled by the merge_tf.MergeCollection model */
export type MergeCollectionNode = InfoCardInterface & {
  readonly __typename: "MergeCollectionNode";
  readonly assignees: ReadonlyArray<Maybe<ExternalProfileNode>>;
  readonly closedAt?: Maybe<Scalars["DateTime"]["output"]>;
  readonly collectionType?: Maybe<Scalars["String"]["output"]>;
  readonly created: Scalars["DateTime"]["output"];
  readonly description?: Maybe<Scalars["String"]["output"]>;
  readonly displayId?: Maybe<Scalars["String"]["output"]>;
  readonly id: Scalars["ID"]["output"];
  readonly integrationName?: Maybe<Scalars["String"]["output"]>;
  readonly providerName?: Maybe<Scalars["String"]["output"]>;
  readonly status?: Maybe<InfoTaskStatus>;
  readonly title: Scalars["String"]["output"];
  readonly url: Scalars["String"]["output"];
};

export type MergeDevIntegrationNode = {
  readonly __typename: "MergeDevIntegrationNode";
  readonly category: Scalars["String"]["output"];
  readonly createdAt: Scalars["DateTime"]["output"];
  readonly fullImageUrl: Scalars["String"]["output"];
  readonly iconUrl: Scalars["String"]["output"];
  readonly id: Scalars["ID"]["output"];
  readonly integrationDisplayName: Scalars["String"]["output"];
  readonly integrationName?: Maybe<Scalars["String"]["output"]>;
  readonly updatedAt: Scalars["DateTime"]["output"];
};

export type MergeIntegrationMetadata = {
  readonly __typename: "MergeIntegrationMetadata";
  /** Category of the integration (e.g. ATS, CRM, etc.) */
  readonly category: Scalars["String"]["output"];
  /** Full display name of the integration (Github, Linear, Hub Spot) */
  readonly displayName: Scalars["String"]["output"];
  /** URL to the integration's icon image */
  readonly iconUrl: Scalars["String"]["output"];
  /** URL to the integration's full image */
  readonly imageUrl: Scalars["String"]["output"];
  /** Merge dev slug name (linear, github, hubspot) */
  readonly name: Scalars["String"]["output"];
  /** Provider string in format merge_{name} */
  readonly sourceProvider: Scalars["String"]["output"];
};

/** Should be fulfilled by the merge_tf.MergeOpportunity model */
export type MergeOpportunityNode = InfoCardInterface & {
  readonly __typename: "MergeOpportunityNode";
  readonly amount?: Maybe<Scalars["Float"]["output"]>;
  readonly assignees: ReadonlyArray<Maybe<ExternalProfileNode>>;
  readonly closedAt?: Maybe<Scalars["DateTime"]["output"]>;
  readonly created: Scalars["DateTime"]["output"];
  readonly description?: Maybe<Scalars["String"]["output"]>;
  readonly displayId?: Maybe<Scalars["String"]["output"]>;
  readonly id: Scalars["ID"]["output"];
  readonly integrationName?: Maybe<Scalars["String"]["output"]>;
  readonly owner?: Maybe<Scalars["String"]["output"]>;
  readonly providerName?: Maybe<Scalars["String"]["output"]>;
  readonly stage?: Maybe<Scalars["String"]["output"]>;
  readonly status?: Maybe<InfoTaskStatus>;
  readonly title: Scalars["String"]["output"];
  readonly url: Scalars["String"]["output"];
};

/** Should be fulfilled by the merge_tf.MergeTicket model */
export type MergeTicketNode = InfoCardInterface & {
  readonly __typename: "MergeTicketNode";
  readonly assignees: ReadonlyArray<Maybe<ExternalProfileNode>>;
  readonly closedAt?: Maybe<Scalars["DateTime"]["output"]>;
  readonly created: Scalars["DateTime"]["output"];
  readonly description?: Maybe<Scalars["String"]["output"]>;
  readonly displayId?: Maybe<Scalars["String"]["output"]>;
  readonly id: Scalars["ID"]["output"];
  readonly integrationName?: Maybe<Scalars["String"]["output"]>;
  readonly providerName?: Maybe<Scalars["String"]["output"]>;
  readonly status?: Maybe<InfoTaskStatus>;
  readonly title: Scalars["String"]["output"];
  readonly url: Scalars["String"]["output"];
};

export type MissingAssessmentConnection = {
  readonly __typename: "MissingAssessmentConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<MissingAssessmentEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `MissingAssessment` and its cursor. */
export type MissingAssessmentEdge = {
  readonly __typename: "MissingAssessmentEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<MissingAssessmentNode>;
};

export type MissingAssessmentNode = {
  readonly __typename: "MissingAssessmentNode";
  readonly assessmentTemplate: AssessmentTemplateNode;
  readonly assessmentTemplateId?: Maybe<Scalars["Int"]["output"]>;
  readonly dueDate: Scalars["Date"]["output"];
  readonly responder: UserNode;
  readonly target?: Maybe<UserNode>;
};

export type MostRecentAssessmentAnswerNode = {
  readonly __typename: "MostRecentAssessmentAnswerNode";
  readonly integerAnswer: Scalars["Int"]["output"];
  readonly questionId: Scalars["Int"]["output"];
  readonly questionType: AssessmentQuestionType;
  readonly submitted: Scalars["DateTime"]["output"];
};

export type MultiChoiceAssessmentAnswerNode = AssessmentAnswerInterface & {
  readonly __typename: "MultiChoiceAssessmentAnswerNode";
  readonly assessment: AssessmentNode;
  readonly calibrations: AssessmentAnswerCalibrationConnection;
  readonly canDelete: PermissionNode;
  readonly canRead: PermissionNode;
  readonly canUpdate: PermissionNode;
  readonly choices: ReadonlyArray<Maybe<Scalars["Int"]["output"]>>;
  readonly comment?: Maybe<Scalars["JSONString"]["output"]>;
  readonly created: Scalars["DateTime"]["output"];
  readonly hasCalibrationSuggestions: Scalars["Boolean"]["output"];
  readonly hasCalibrations: Scalars["Boolean"]["output"];
  readonly id: Scalars["Int"]["output"];
  readonly isLocked: Scalars["Boolean"]["output"];
  readonly question: AssessmentQuestionInterface;
  readonly questionId: Scalars["Int"]["output"];
  readonly responder?: Maybe<UserNode>;
  readonly updated: Scalars["DateTime"]["output"];
};

export type MultiChoiceAssessmentAnswerNodeCalibrationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MultiChoiceAssessmentQuestionNode = AssessmentQuestionInterface & {
  readonly __typename: "MultiChoiceAssessmentQuestionNode";
  readonly answers: AssessmentAnswerConnection;
  readonly answersExist: Scalars["Boolean"]["output"];
  readonly archived: Scalars["Boolean"]["output"];
  readonly canDelete: PermissionNode;
  readonly canRead: PermissionNode;
  readonly canUpdate: PermissionNode;
  readonly categories: AssessmentQuestionCategoryNodeConnection;
  readonly comment: AssessmentQuestionComment;
  readonly created: Scalars["DateTime"]["output"];
  readonly creator?: Maybe<UserNode>;
  readonly description?: Maybe<Scalars["JSONString"]["output"]>;
  readonly id: Scalars["Int"]["output"];
  readonly isResponseMandatory: Scalars["Boolean"]["output"];
  readonly optionDescriptions: ReadonlyArray<
    Maybe<Scalars["String"]["output"]>
  >;
  readonly options: ReadonlyArray<Maybe<Scalars["String"]["output"]>>;
  readonly organization: OrganizationNode;
  readonly questionType: AssessmentQuestionType;
  readonly responseVisibility: AssessmentQuestionResponseVisibility;
  readonly responses: AssessmentQuestionResponses;
  readonly title: Scalars["String"]["output"];
  readonly updated: Scalars["DateTime"]["output"];
};

export type MultiChoiceAssessmentQuestionNodeAnswersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MultiChoiceAssessmentQuestionNodeCategoriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type Mutation = {
  readonly __typename: "Mutation";
  readonly acceptInvitation?: Maybe<AcceptInvitationMutation>;
  readonly addBotToMeeting?: Maybe<AddBotToMeetingMutation>;
  readonly addFavouriteArtifact?: Maybe<AddFavouriteArtifact>;
  readonly addPreviousMeetingTopicsToCurrentMeeting?: Maybe<AddPreviousMeetingTopicsToCurrentMeetingMutation>;
  readonly addTeamMember?: Maybe<AddTeamMemberMutation>;
  readonly addTemplateToMeeting?: Maybe<AddTemplateToMeetingMutation>;
  readonly alignGoal?: Maybe<AlignGoalMutation>;
  readonly archiveSkill?: Maybe<ArchiveSkillMutation>;
  readonly associateArtifactWithTopicOrArtifact?: Maybe<AssociateArtifactWithTopicOrArtifactMutation>;
  readonly backfillSlackData?: Maybe<BackfillSlackDataMutation>;
  readonly batchAssessmentDeliveryAction: BatchAssessmentDeliveriesActionMutation;
  /** Stop the active Ask AI generation without touching chat messages. */
  readonly cancelChatbotSession?: Maybe<CancelChatbotSessionMutation>;
  readonly cancelMeeting?: Maybe<CancelMeetingMutation>;
  readonly changeBotRecordingStatus?: Maybe<ChangeBotRecordingStatusMutation>;
  readonly convertSuggestedTopicToTopic?: Maybe<ConvertSuggestedTopicToTopicMutation>;
  readonly copyTopicsToMeeting?: Maybe<CopyTopicsToMeetingMutation>;
  readonly createAssessmentAnswerCalibration: CreateAssessmentAnswerCalibration;
  readonly createChatbotMessageReaction?: Maybe<CreateChatbotMessageReactionMutation>;
  readonly createComplianceProgramScheduledReminder?: Maybe<CreateComplianceProgramScheduledReminderMutation>;
  readonly createFeedbackRequests?: Maybe<CreateFeedbackRequestsMutation>;
  readonly createGoalCheckin?: Maybe<CreateGoalCheckinMutation>;
  readonly createInvitations?: Maybe<CreateInvitationsMutation>;
  /** Create a Magic Link token for Merge.dev integration for a specific integration */
  readonly createMergeLinkToken?: Maybe<CreateMergeLinkToken>;
  readonly createOrUpdateArtifact?: Maybe<CreateOrUpdateArtifactMutation>;
  readonly createOrUpdateAssessment: CreateOrUpdateAssessmentMutation;
  readonly createOrUpdateAssessmentGroup?: Maybe<CreateOrUpdateAssessmentGroupMutation>;
  readonly createOrUpdateAssessmentQuestion?: Maybe<CreateOrUpdateAssessmentQuestionMutation>;
  readonly createOrUpdateCalibrationGroup?: Maybe<CreateOrUpdateCalibrationGroupMutation>;
  readonly createOrUpdateCareerTrack?: Maybe<CreateOrUpdateCareerTrackMutation>;
  readonly createOrUpdateComment?: Maybe<CreateOrUpdateCommentMutation>;
  readonly createOrUpdateCompetency?: Maybe<CreateOrUpdateCompetencyMutation>;
  readonly createOrUpdateComplianceProgram?: Maybe<CreateOrUpdateComplianceProgramMutation>;
  readonly createOrUpdateComplianceProgramReportingView?: Maybe<CreateOrUpdateComplianceProgramReportingViewMutation>;
  readonly createOrUpdateCoreValue?: Maybe<CreateOrUpdateCoreValueMutation>;
  readonly createOrUpdateExplorerBookmark?: Maybe<CreateOrUpdateExplorerBookmarkMutation>;
  readonly createOrUpdateFavouritesGroup?: Maybe<CreateOrUpdateFavouritesGroupMutation>;
  readonly createOrUpdateFlow?: Maybe<CreateOrUpdateFlowMutation>;
  readonly createOrUpdateFullAssessmentGroup?: Maybe<CreateOrUpdateFullAssessmentGroupMutation>;
  readonly createOrUpdateKeyResult?: Maybe<CreateOrUpdateKeyResultMutation>;
  readonly createOrUpdateKpi?: Maybe<CreateOrUpdateKpi>;
  readonly createOrUpdateKpiGroup?: Maybe<CreateOrUpdateKpiGroupMutation>;
  readonly createOrUpdateKpiMeasurement?: Maybe<CreateOrUpdateKpiMeasurementMutation>;
  readonly createOrUpdateKvItem?: Maybe<CreateOrUpdateKvItemMutation>;
  readonly createOrUpdateMeetingInExternalCalendar?: Maybe<CreateOrUpdateMeetingInExternalCalendarMutation>;
  readonly createOrUpdateOrganization?: Maybe<CreateOrUpdateOrganizationMutation>;
  readonly createOrUpdatePerformanceAssessmentChartLabel: CreateOrUpdatePerformanceAssessmentChartLabel;
  readonly createOrUpdateRating?: Maybe<CreateOrUpdateRatingMutation>;
  readonly createOrUpdateRatingAnswer?: Maybe<CreateOrUpdateRatingAnswerMutation>;
  readonly createOrUpdateSkill?: Maybe<CreateOrUpdateSkillMutation>;
  readonly createOrUpdateSlackNotificationForChannel?: Maybe<CreateOrUpdateSlackNotificationForChannelMutation>;
  readonly createOrUpdateSlackNotificationsForMeetingGroup?: Maybe<CreateOrUpdateSlackNotificationsForMeetingGroup>;
  readonly createOrUpdateTeam?: Maybe<CreateOrUpdateTeamMutation>;
  readonly createOrUpdateTeamsNotificationForChannel?: Maybe<CreateOrUpdateTeamsNotificationForChannelMutation>;
  readonly createOrUpdateTemplateRequirements?: Maybe<CreateOrUpdateTemplateRequirementsMutation>;
  readonly createOrUpdateTemplateSeriesForMeeting?: Maybe<CreateOrUpdateTemplateSeriesForMeetingMutation>;
  readonly createOrUpdateTopic?: Maybe<CreateOrUpdateTopicMutation>;
  readonly createOrUpdateTopicTemplate?: Maybe<CreateOrUpdateTopicTemplateMutation>;
  readonly createOrUpdateTopicTemplateCategory?: Maybe<CreateOrUpdateTopicTemplateCategoryMutation>;
  readonly createOrUpdateWorkflow?: Maybe<CreateOrUpdateWorkflowMutation>;
  readonly createPrivateNote?: Maybe<CreatePrivateNoteMutation>;
  readonly createRoutine?: Maybe<CreateRoutineMutation>;
  readonly createTemplateFromMeeting?: Maybe<CreateTemplateFromMeetingMutation>;
  readonly deleteArtifact?: Maybe<DeleteArtifactMutation>;
  readonly deleteAssessmentAnswer: DeleteAssessmentAnswerMutation;
  readonly deleteAssessmentGroup?: Maybe<DeleteAssessmentGroupMutation>;
  readonly deleteAssessmentQuestion?: Maybe<DeleteAssessmentQuestionMutation>;
  readonly deleteCalibrationGroup?: Maybe<DeleteCalibrationGroupMutation>;
  readonly deleteCareerTrack?: Maybe<DeleteCareerTrackMutation>;
  readonly deleteChatSession?: Maybe<DeleteChatSessionMutation>;
  readonly deleteComment?: Maybe<DeleteCommentMutation>;
  readonly deleteCompetency?: Maybe<DeleteCompetencyMutation>;
  readonly deleteComplianceProgram?: Maybe<DeleteComplianceProgramMutation>;
  readonly deleteComplianceProgramReportingView?: Maybe<DeleteComplianceProgramReportingViewMutation>;
  readonly deleteComplianceProgramScheduledReminder?: Maybe<DeleteComplianceProgramScheduledReminderMutation>;
  readonly deleteCoreValue?: Maybe<DeleteCoreValueMutation>;
  readonly deleteExplorerBookmark?: Maybe<DeleteExplorerBookmark>;
  readonly deleteFavouritesGroup?: Maybe<DeleteFavouritesGroupMutation>;
  readonly deleteFlow?: Maybe<DeleteFlowMutation>;
  readonly deleteKeyResult?: Maybe<DeleteKeyResultMutation>;
  readonly deleteKpi?: Maybe<DeleteKpi>;
  readonly deleteKpiGroup?: Maybe<DeleteKpiGroupMutation>;
  readonly deleteKpiIntegration?: Maybe<DeleteKpiIntegrationMutation>;
  readonly deleteKpiMeasurement?: Maybe<DeleteKpiMeasurement>;
  readonly deleteMeeting?: Maybe<DeleteMeetingMutation>;
  readonly deleteMeetingTranscripts?: Maybe<DeleteMeetingTranscriptsMutation>;
  readonly deleteMeetingVideoRecording?: Maybe<DeleteMeetingVideoRecordingMutation>;
  readonly deletePrivateNote?: Maybe<DeletePrivateNoteMutation>;
  readonly deleteRating?: Maybe<DeleteRatingMutation>;
  readonly deleteRoutine?: Maybe<DeleteRoutineMutation>;
  readonly deleteSlackNotificationForChannel?: Maybe<DeleteSlackNotificationForChannelMutation>;
  readonly deleteSlackNotificationsForMeetingGroup?: Maybe<DeleteSlackNotificationsForMeetingGroup>;
  readonly deleteTeam?: Maybe<DeleteTeamMutation>;
  readonly deleteTeamsNotificationForChannel?: Maybe<DeleteTeamsNotificationForChannelMutation>;
  readonly deleteTopic?: Maybe<DeleteTopicMutation>;
  readonly deleteTopicTemplate?: Maybe<DeleteTopicTemplateMutation>;
  readonly deleteTopicTemplateCategory?: Maybe<DeleteTopicTemplateCategoryMutation>;
  readonly deleteWorkflow?: Maybe<DeleteWorkflowMutation>;
  readonly dismissInsight?: Maybe<DismissInsightMutation>;
  readonly duplicateGoal?: Maybe<DuplicateGoalMutation>;
  readonly editSuggestedAssessmentResponse?: Maybe<EditSuggestedAssessmentResponseMutation>;
  readonly email1on1Nudge?: Maybe<Email1on1NudgeMutation>;
  readonly emailAssessmentReminder?: Maybe<EmailAssessmentReminderMutation>;
  readonly emailMeetingInvites?: Maybe<EmailMeetingInvitesMutation>;
  readonly emailMeetingNotes?: Maybe<EmailMeetingNotesMutation>;
  readonly emailOneononeReminder?: Maybe<EmailOneOnOneReminderMutation>;
  /** Exchange public token for account token after Magic Link completion */
  readonly exchangeMergePublicToken?: Maybe<ExchangeMergePublicToken>;
  readonly exportComplianceProgramEngagementSurveyHeatmapToCsv?: Maybe<ExportComplianceProgramEngagementSurveyHeatmapToCsv>;
  readonly exportComplianceProgramEngagementSurveyToCsv?: Maybe<ExportComplianceProgramEngagementSurveyToCsv>;
  readonly exportComplianceProgramPerformanceAssessmentToCsv?: Maybe<ExportComplianceProgramPerformanceAssessmentToCsv>;
  readonly exportComplianceProgramToCsv?: Maybe<ExportComplianceProgramToCsv>;
  readonly forkPlatformSkill?: Maybe<ForkPlatformSkillMutation>;
  readonly generateReviewAnswers: GenerateReviewAnswers;
  readonly getOrCreateChatbotSession?: Maybe<GetOrCreateChatbotSession>;
  readonly ignoreMeeting?: Maybe<IgnoreMeetingMutation>;
  /**
   * Phase 2 of the bulk 1-on-1 import: commit the (possibly edited) structured plan. No AI and no
   * date parsing happen here -- the preview step already did that.
   */
  readonly importOneononeNotes?: Maybe<ImportOneononeNotesMutation>;
  readonly joinOrganization?: Maybe<JoinOrganizationMutation>;
  readonly linkCalendarToOrganization?: Maybe<LinkCalendarToOrganizationMutation>;
  readonly linkCreatedArtifactToChatMessage?: Maybe<LinkCreatedArtifactToChatMessageMutation>;
  readonly markMeetingTopicsAsDiscussed?: Maybe<MarkMeetingTopicsAsDiscussedMutation>;
  readonly markPreviousMeetingTopicsAsDiscussed?: Maybe<MarkPreviousMeetingTopicsAsDiscussedMutation>;
  /**
   * Flag that the current manager has done (or dismissed) the initial onboarding first-screen for
   * a direct report, so the profile stops auto-showing it. The manager can still re-run it anytime.
   */
  readonly markReportOnboarded?: Maybe<MarkReportOnboardedMutation>;
  readonly prepareFileUpload?: Maybe<PrepareFileUploadMutation>;
  /**
   * Phase 1 of the bulk 1-on-1 import: parse + AI-split + classify, WITHOUT writing anything.
   *
   * Returns an editable plan the frontend renders; the edited plan is sent to importOneononeNotes.
   */
  readonly previewImportOneononeNotes?: Maybe<PreviewImportOneononeNotesMutation>;
  readonly regenerateQuestionAnswer: RegenerateQuestionAnswer;
  /** Create a new Magic Link token for re-linking an existing Merge.dev integration */
  readonly relinkMergeDevIntegration?: Maybe<RelinkMergeDevIntegration>;
  readonly removeAsanaIntegration?: Maybe<RemoveAsanaIntegrationMutation>;
  readonly removeBotFromMeeting?: Maybe<RemoveBotFromMeetingMutation>;
  readonly removeClickupIntegration?: Maybe<RemoveClickupIntegrationMutation>;
  readonly removeFavouriteArtifact?: Maybe<RemoveFavouriteArtifact>;
  readonly removeGithubIntegration?: Maybe<RemoveGitHubIntegrationMutation>;
  readonly removeHubspotIntegration?: Maybe<RemoveHubspotIntegrationMutation>;
  readonly removeIntegrationCredentials?: Maybe<RemoveIntegrationCredentialsMutation>;
  readonly removeJiraIntegration?: Maybe<RemoveJiraIntegrationMutation>;
  /** Remove a specific Merge.dev integration */
  readonly removeMergeDevIntegration?: Maybe<RemoveMergeDevIntegration>;
  readonly removeOrgGithubIntegration?: Maybe<RemoveOrganizationGitHubIntegrationMutation>;
  readonly removePersonalTranscriptSyncCredential?: Maybe<RemovePersonalTranscriptSyncCredentialMutation>;
  readonly removeReadAiIntegration?: Maybe<RemoveReadAiIntegrationMutation>;
  readonly removeSalesforceIntegration?: Maybe<RemoveSalesforceIntegrationMutation>;
  readonly removeSlackIntegration?: Maybe<RemoveSlackIntegrationMutation>;
  readonly removeTeamMember?: Maybe<RemoveTeamMemberMutation>;
  readonly removeTeamsIntegration?: Maybe<RemoveTeamsIntegrationMutation>;
  readonly removeTemplateSeriesFromMeeting?: Maybe<RemoveTemplateSeriesFromMeetingMutation>;
  readonly removeUserFromOrganization?: Maybe<RemoveUserFromOrganizationMutation>;
  readonly removeYoutrackIntegration?: Maybe<RemoveYouTrackIntegrationMutation>;
  readonly removeZoomIntegration?: Maybe<RemoveZoomIntegrationMutation>;
  readonly reopenAssessment: ReopenAssessmentMutation;
  readonly reorderArtifact?: Maybe<ReorderArtifactMutation>;
  readonly reorderTopic?: Maybe<ReorderTopicMutation>;
  readonly requestExport?: Maybe<RequestExportMutation>;
  readonly retryChatbotSession?: Maybe<RetryChatbotSessionMutation>;
  readonly saveMeetingVideoRecording?: Maybe<SaveMeetingVideoRecordingMutation>;
  readonly savePersonalTranscriptSyncCredential?: Maybe<SavePersonalTranscriptSyncCredentialMutation>;
  readonly searchCsvExport?: Maybe<SearchCsvExportMutation>;
  readonly sendMessageToChatbot?: Maybe<SendMessageToChatbotMutation>;
  readonly sendPhoneNumberVerificationCode?: Maybe<SendPhoneNumberVerificationCodeMutation>;
  readonly sendProgramReminder?: Maybe<SendProgramReminderMutation>;
  readonly sendRoutineTest?: Maybe<SendRoutineTestMutation>;
  readonly setAssessmentNominations?: Maybe<SetAssessmentNominationsMutation>;
  readonly setFavouriteGroups?: Maybe<SetFavouriteGroupsMutation>;
  readonly setMeetingAgendaAsTemplate?: Maybe<SetMeetingAgendaAsTemplateMutation>;
  readonly setMeetingLocked?: Maybe<SetMeetingLockedMutation>;
  readonly setRelationship?: Maybe<SetRelationshipMutation>;
  readonly setRelationships?: Maybe<SetRelationshipsMutation>;
  readonly startCalendarSync?: Maybe<StartCalendarSyncMutation>;
  readonly submitOneonone?: Maybe<SubmitOneOnOneMutation>;
  readonly syncComplianceProgramUsers?: Maybe<SyncComplianceProgramUsersMutation>;
  readonly syncWithHris?: Maybe<SyncWithHrisMutation>;
  readonly toggleIndividualNoteVisibility?: Maybe<ToggleIndividualNoteVisibilityMutation>;
  readonly unlinkIntegrationFromOrganization?: Maybe<UnlinkIntegrationFromOrganizationMutation>;
  readonly updateAccountOnboarding?: Maybe<UpdateAccountOnboardingMutation>;
  readonly updateAiBrainConsolidated?: Maybe<UpdateAiBrainConsolidatedMutation>;
  readonly updateAssessmentDelivery: UpdateAssessmentDeliveryMutation;
  readonly updateAttendanceStatus?: Maybe<UpdateAttendanceStatusMutation>;
  readonly updateChatSession?: Maybe<UpdateChatSessionMutation>;
  readonly updateComplianceProgramCalibrationStatus?: Maybe<UpdateComplianceProgramCalibrationStatusMutation>;
  readonly updateMeeting?: Maybe<UpdateMeetingMutation>;
  readonly updateMeetingFinalizationStatus?: Maybe<UpdateMeetingFinalizationStatus>;
  readonly updateMeetingGroup?: Maybe<UpdateMeetingGroupMutation>;
  readonly updateMeetingTranscript?: Maybe<UpdateMeetingTranscriptMutation>;
  readonly updateMeetingTranscriptionStatus?: Maybe<UpdateMeetingTranscriptionStatusMutation>;
  readonly updateOrganizationMembership?: Maybe<UpdateOrganizationMembershipMutation>;
  readonly updateRoutine?: Maybe<UpdateRoutineMutation>;
  readonly updateSlackOrgSettings?: Maybe<UpdateSlackOrgSettingsMutation>;
  readonly updateSuggestedArtifact?: Maybe<UpdateSuggestedArtifactMutation>;
  readonly updateSuggestedTopic?: Maybe<UpdateSuggestedTopicMutation>;
  readonly updateTalentIndicator?: Maybe<UpdateTalentIndicatorMutation>;
  readonly updateTopicDiscussionNotes?: Maybe<UpdateTopicDiscussionNotesMutation>;
  readonly updateUser?: Maybe<UpdateUserMutation>;
  readonly updateWorkHistory?: Maybe<UpdateWorkHistoryMutation>;
  readonly verifyPhoneNumber?: Maybe<VerifyPhoneNumberMutation>;
};

export type MutationAcceptInvitationArgs = {
  invitationId: Scalars["Int"]["input"];
};

export type MutationAddBotToMeetingArgs = {
  meetingId: Scalars["Int"]["input"];
};

export type MutationAddFavouriteArtifactArgs = {
  artifactId: Scalars["Int"]["input"];
};

export type MutationAddPreviousMeetingTopicsToCurrentMeetingArgs = {
  meetingId: Scalars["Int"]["input"];
  position?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationAddTeamMemberArgs = {
  teamId: Scalars["Int"]["input"];
  userId: Scalars["Int"]["input"];
};

export type MutationAddTemplateToMeetingArgs = {
  allowAdminVisibility?: InputMaybe<Scalars["Boolean"]["input"]>;
  allowManagementTreeVisibility?: InputMaybe<Scalars["Boolean"]["input"]>;
  allowOrgVisibility?: InputMaybe<Scalars["Boolean"]["input"]>;
  clearExistingTopics?: InputMaybe<Scalars["Boolean"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  setAsSeriesTemplate: Scalars["Boolean"]["input"];
  topicTemplateId: Scalars["Int"]["input"];
};

export type MutationAlignGoalArgs = {
  goalId: Scalars["Int"]["input"];
  parentGoalId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationArchiveSkillArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationAssociateArtifactWithTopicOrArtifactArgs = {
  artifactId: Scalars["Int"]["input"];
  otherArtifactId?: InputMaybe<Scalars["Int"]["input"]>;
  topicId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationBackfillSlackDataArgs = {
  organizationId: Scalars["Int"]["input"];
  startDate: Scalars["String"]["input"];
};

export type MutationBatchAssessmentDeliveryActionArgs = {
  action: BatchCalibrationAction;
  complianceProgramId: Scalars["Int"]["input"];
  organizationId: Scalars["Int"]["input"];
  targetIds: ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>;
};

export type MutationCancelChatbotSessionArgs = {
  chatSessionId: Scalars["Int"]["input"];
};

export type MutationCancelMeetingArgs = {
  editType: MeetingEditTypeEnum;
  meetingId: Scalars["Int"]["input"];
};

export type MutationChangeBotRecordingStatusArgs = {
  isRecording: Scalars["Boolean"]["input"];
  meetingId: Scalars["Int"]["input"];
};

export type MutationConvertSuggestedTopicToTopicArgs = {
  suggestedTopicId: Scalars["Int"]["input"];
};

export type MutationCopyTopicsToMeetingArgs = {
  meetingId: Scalars["Int"]["input"];
  topicIds: ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>;
};

export type MutationCreateAssessmentAnswerCalibrationArgs = {
  answerId?: InputMaybe<Scalars["Int"]["input"]>;
  comment?: InputMaybe<Scalars["String"]["input"]>;
  complianceProgramId: Scalars["Int"]["input"];
  integerAnswer?: InputMaybe<Scalars["Int"]["input"]>;
  isPrecalibration: Scalars["Boolean"]["input"];
  isSuggestion: Scalars["Boolean"]["input"];
  questionId: Scalars["Int"]["input"];
  targetId: Scalars["Int"]["input"];
  templateId: Scalars["Int"]["input"];
};

export type MutationCreateChatbotMessageReactionArgs = {
  chatSessionId: Scalars["Int"]["input"];
  comment?: InputMaybe<Scalars["String"]["input"]>;
  messageId: Scalars["String"]["input"];
  reactionType: ChatSessionReactionType;
};

export type MutationCreateComplianceProgramScheduledReminderArgs = {
  complianceProgramId: Scalars["Int"]["input"];
  daysAfterStartDate: Scalars["Int"]["input"];
  emailNotification: Scalars["Boolean"]["input"];
  engagementSurvey: Scalars["Boolean"]["input"];
  managerAssessment: Scalars["Boolean"]["input"];
  message?: InputMaybe<Scalars["String"]["input"]>;
  nominations: Scalars["Boolean"]["input"];
  oneonone: Scalars["Boolean"]["input"];
  peerAssessment: Scalars["Boolean"]["input"];
  performanceAssessment: Scalars["Boolean"]["input"];
  performanceSelfAssessment: Scalars["Boolean"]["input"];
  sendNow?: InputMaybe<Scalars["Boolean"]["input"]>;
  slackNotification: Scalars["Boolean"]["input"];
  teamsNotification?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationCreateFeedbackRequestsArgs = {
  description?: InputMaybe<Scalars["JSONString"]["input"]>;
  feedbackAdminsCanView?: InputMaybe<Scalars["Boolean"]["input"]>;
  feedbackCreatorCanView?: InputMaybe<Scalars["Boolean"]["input"]>;
  feedbackRecipients: ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>;
  feedbackRecipientsCanView?: InputMaybe<Scalars["Boolean"]["input"]>;
  feedbackRecipientsManagersCanView?: InputMaybe<Scalars["Boolean"]["input"]>;
  feedbackSenderIds: ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>;
  feedbackState?: InputMaybe<FeedbackState>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId: Scalars["Int"]["input"];
  relatedArtifactId?: InputMaybe<Scalars["Int"]["input"]>;
  title: Scalars["String"]["input"];
  topicId?: InputMaybe<Scalars["Int"]["input"]>;
  uuid?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateGoalCheckinArgs = {
  comment?: InputMaybe<Scalars["JSONString"]["input"]>;
  currentValue?: InputMaybe<Scalars["Float"]["input"]>;
  goalId: Scalars["Int"]["input"];
  goalStatus?: InputMaybe<GoalStatus>;
  keyResults?: InputMaybe<ReadonlyArray<InputMaybe<GoalCheckinKeyResultInput>>>;
};

export type MutationCreateInvitationsArgs = {
  invitationRequests: ReadonlyArray<InputMaybe<InvitationInput>>;
};

export type MutationCreateMergeLinkTokenArgs = {
  category: Scalars["String"]["input"];
  integrationSlug: Scalars["String"]["input"];
};

export type MutationCreateOrUpdateArtifactArgs = {
  additionalFields?: InputMaybe<AdditionalArtifactInput>;
  artifactId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  description?: InputMaybe<Scalars["JSONString"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  relatedArtifactId?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  topicId?: InputMaybe<Scalars["Int"]["input"]>;
  uuid?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateOrUpdateAssessmentArgs = {
  answers?: InputMaybe<
    ReadonlyArray<InputMaybe<AssessmentQuestionAnswerInput>>
  >;
  assessmentId?: InputMaybe<Scalars["Int"]["input"]>;
  assessmentTemplateId: Scalars["Int"]["input"];
  complianceProgramId?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  state?: InputMaybe<AssessmentState>;
  targetId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationCreateOrUpdateAssessmentGroupArgs = {
  archived?: InputMaybe<Scalars["Boolean"]["input"]>;
  assessmentGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  sections?: InputMaybe<ReadonlyArray<InputMaybe<AssessmentGroupSectionInput>>>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateOrUpdateAssessmentQuestionArgs = {
  archived?: InputMaybe<Scalars["Boolean"]["input"]>;
  categories?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
  >;
  comment?: InputMaybe<AssessmentQuestionComment>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  endValue?: InputMaybe<Scalars["Int"]["input"]>;
  labelDescriptions?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
  >;
  labels?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
  optionDescriptions?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
  >;
  options?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  questionId?: InputMaybe<Scalars["Int"]["input"]>;
  questionType?: InputMaybe<AssessmentQuestionType>;
  responseVisibility?: InputMaybe<AssessmentQuestionResponseVisibility>;
  responses?: InputMaybe<AssessmentQuestionResponses>;
  startValue?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateOrUpdateCalibrationGroupArgs = {
  approverIds: ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>;
  complianceProgramId: Scalars["Int"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds: ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>;
  name: Scalars["String"]["input"];
  userIds: ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>;
};

export type MutationCreateOrUpdateCareerTrackArgs = {
  additionalCompetencies?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  careerTrackId?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  roles?: InputMaybe<ReadonlyArray<InputMaybe<CareerTrackRoleInput>>>;
  teamId?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateOrUpdateCommentArgs = {
  artifactId?: InputMaybe<Scalars["Int"]["input"]>;
  comment: Scalars["String"]["input"];
  commentId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  textUuid?: InputMaybe<Scalars["String"]["input"]>;
  topicId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationCreateOrUpdateCompetencyArgs = {
  appliesTo?: InputMaybe<CompetencyAppliesTo>;
  appliesToCareerTracks?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  appliesToIcRoles?: InputMaybe<Scalars["Boolean"]["input"]>;
  appliesToManagementRoles?: InputMaybe<Scalars["Boolean"]["input"]>;
  appliesToTeams?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  competencyId?: InputMaybe<Scalars["Int"]["input"]>;
  criteria?: InputMaybe<ReadonlyArray<InputMaybe<CompetencyCriteriaInput>>>;
  criteriaUniqueness?: InputMaybe<CompetencyCriteriaUniqueness>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateOrUpdateComplianceProgramArgs = {
  appliesTo?: InputMaybe<ComplianceProgramAppliesTo>;
  appliesToManagers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  appliesToTeams?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  appliesToUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  assessmentTemplates?: InputMaybe<
    ReadonlyArray<InputMaybe<AssessmentTemplateComplianceRequirement>>
  >;
  calibration?: InputMaybe<ComplianceProgramCalibrationType>;
  complianceProgramId?: InputMaybe<Scalars["Int"]["input"]>;
  dueDate?: InputMaybe<Scalars["Date"]["input"]>;
  excludedHireDateAfter?: InputMaybe<Scalars["Date"]["input"]>;
  excludedUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  ongoing?: InputMaybe<Scalars["Boolean"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  periodEndDate?: InputMaybe<Scalars["Date"]["input"]>;
  periodStartDate?: InputMaybe<Scalars["Date"]["input"]>;
  recurrence?: InputMaybe<ComplianceProgramRecurrence>;
  removeExcludedHireDateAfter?: InputMaybe<Scalars["Boolean"]["input"]>;
  scheduledReminders?: InputMaybe<
    ReadonlyArray<InputMaybe<ProgramScheduledReminderInput>>
  >;
  startDate?: InputMaybe<Scalars["Date"]["input"]>;
  startDateDueDateOffset?: InputMaybe<Scalars["Int"]["input"]>;
  startDateOffset?: InputMaybe<Scalars["Int"]["input"]>;
  startDatePeriodEndOffset?: InputMaybe<Scalars["Int"]["input"]>;
  startDatePeriodStartOffset?: InputMaybe<Scalars["Int"]["input"]>;
  state?: InputMaybe<ComplianceProgramState>;
  steps?: InputMaybe<ReadonlyArray<InputMaybe<ComplianceProgramStepInput>>>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  topicTemplates?: InputMaybe<
    ReadonlyArray<InputMaybe<TopicTemplateComplianceRequirement>>
  >;
};

export type MutationCreateOrUpdateComplianceProgramReportingViewArgs = {
  assessmentType: AssessmentType;
  complianceProgramId: Scalars["Int"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
  name: Scalars["String"]["input"];
  viewOptions: Scalars["String"]["input"];
};

export type MutationCreateOrUpdateCoreValueArgs = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  emoji?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  image?: InputMaybe<Scalars["String"]["input"]>;
  organizationId: Scalars["Int"]["input"];
  status?: InputMaybe<RecognitionCoreValueStatus>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateOrUpdateExplorerBookmarkArgs = {
  explorerBookmarkId?: InputMaybe<Scalars["Int"]["input"]>;
  filters?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  private?: InputMaybe<Scalars["Boolean"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateOrUpdateFavouritesGroupArgs = {
  favouritesGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  userIds: ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>;
};

export type MutationCreateOrUpdateFlowArgs = {
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  participantCount?: InputMaybe<Scalars["Int"]["input"]>;
  participantEmailPatterns?: InputMaybe<Scalars["String"]["input"]>;
  public?: InputMaybe<Scalars["Boolean"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateOrUpdateFullAssessmentGroupArgs = {
  assessmentGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  assessmentType?: InputMaybe<AssessmentType>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  sections: ReadonlyArray<InputMaybe<FullAssessmentGroupSectionInput>>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateOrUpdateKeyResultArgs = {
  assigneeId?: InputMaybe<Scalars["Int"]["input"]>;
  currentValue?: InputMaybe<Scalars["Float"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  goalId?: InputMaybe<Scalars["Int"]["input"]>;
  keyResultId?: InputMaybe<Scalars["Int"]["input"]>;
  kpiId?: InputMaybe<Scalars["Int"]["input"]>;
  progressType?: InputMaybe<GoalProgressType>;
  startValue?: InputMaybe<Scalars["Float"]["input"]>;
  targetValue?: InputMaybe<Scalars["Float"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateOrUpdateKpiArgs = {
  defaultSummaryMethod?: InputMaybe<KpiSummaryMethod>;
  defaultSummaryPeriod?: InputMaybe<KpiSummaryPeriod>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  groupIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  integration?: InputMaybe<KpiIntegrationInput>;
  kpiId?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  targetCondition?: InputMaybe<KpiTargetCondition>;
  targetType?: InputMaybe<KpiTargetType>;
  targetValue?: InputMaybe<Scalars["Float"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  visibility?: InputMaybe<KpiVisibility>;
};

export type MutationCreateOrUpdateKpiGroupArgs = {
  kpiGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  kpiIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateOrUpdateKpiMeasurementArgs = {
  kpiId?: InputMaybe<Scalars["Int"]["input"]>;
  kpiMeasurementId?: InputMaybe<Scalars["Int"]["input"]>;
  measurement: Scalars["Float"]["input"];
  timestamp?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type MutationCreateOrUpdateKvItemArgs = {
  key: Scalars["String"]["input"];
  value: Scalars["JSONString"]["input"];
};

export type MutationCreateOrUpdateMeetingInExternalCalendarArgs = {
  addTranscriptionBotToMeetingsByDefault?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  attendees: ReadonlyArray<InputMaybe<AttendeeInput>>;
  credentialsId?: InputMaybe<Scalars["Int"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  editType?: InputMaybe<MeetingEditTypeEnum>;
  endDatetime?: InputMaybe<Scalars["DateTime"]["input"]>;
  endTimezone?: InputMaybe<Scalars["String"]["input"]>;
  facilitatorId?: InputMaybe<Scalars["Int"]["input"]>;
  isFormalOneonone?: InputMaybe<Scalars["Boolean"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  onlineConference: OnlineConference;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  publish: Scalars["Boolean"]["input"];
  recurrence?: InputMaybe<FrequencyInput>;
  startDatetime?: InputMaybe<Scalars["DateTime"]["input"]>;
  startTimezone?: InputMaybe<Scalars["String"]["input"]>;
  templateId?: InputMaybe<Scalars["Int"]["input"]>;
  title: Scalars["String"]["input"];
};

export type MutationCreateOrUpdateOrganizationArgs = {
  aiGuidelines?: InputMaybe<Scalars["String"]["input"]>;
  anthropicApiKey?: InputMaybe<Scalars["String"]["input"]>;
  associatedDomainName?: InputMaybe<Scalars["String"]["input"]>;
  competencyLabel?: InputMaybe<Scalars["String"]["input"]>;
  conversationLabel?: InputMaybe<Scalars["String"]["input"]>;
  defaultGoalState?: InputMaybe<GoalState>;
  developmentLabel?: InputMaybe<Scalars["String"]["input"]>;
  enableMeetingBot?: InputMaybe<Scalars["Boolean"]["input"]>;
  enableMeetingSummarization?: InputMaybe<Scalars["Boolean"]["input"]>;
  expectationLabel?: InputMaybe<Scalars["String"]["input"]>;
  featureFlags?: InputMaybe<OrganizationFeatureFlagsInput>;
  fellowApiDomain?: InputMaybe<Scalars["String"]["input"]>;
  fellowApiKey?: InputMaybe<Scalars["String"]["input"]>;
  fellowTranscriptSyncEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  goalLabel?: InputMaybe<Scalars["String"]["input"]>;
  membershipSetting?: InputMaybe<OrganizationMembershipSetting>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  orgLabel?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  quarterStartMonth?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionLabel?: InputMaybe<Scalars["String"]["input"]>;
  reviewLabel?: InputMaybe<Scalars["String"]["input"]>;
  teamLabel?: InputMaybe<Scalars["String"]["input"]>;
  transcribeMeetingsByDefault?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationCreateOrUpdatePerformanceAssessmentChartLabelArgs = {
  labels: ReadonlyArray<InputMaybe<PerformanceAssessmentChartLabelInput>>;
  organizationId: Scalars["Int"]["input"];
};

export type MutationCreateOrUpdateRatingArgs = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  endValue?: InputMaybe<Scalars["Int"]["input"]>;
  labels?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  ratingId?: InputMaybe<Scalars["Int"]["input"]>;
  startValue?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateOrUpdateRatingAnswerArgs = {
  integerAnswer: Scalars["Int"]["input"];
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingRatingRequirementId?: InputMaybe<Scalars["Int"]["input"]>;
  ratingAnswerId?: InputMaybe<Scalars["Int"]["input"]>;
  ratingArtifactId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationCreateOrUpdateSkillArgs = {
  body: Scalars["String"]["input"];
  description: Scalars["String"]["input"];
  forkFromSlug?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  name: Scalars["String"]["input"];
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationCreateOrUpdateSlackNotificationForChannelArgs = {
  channel?: InputMaybe<Scalars["String"]["input"]>;
  goalCheckins?: InputMaybe<Scalars["Boolean"]["input"]>;
  notificationId?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitions?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationCreateOrUpdateSlackNotificationsForMeetingGroupArgs = {
  channel?: InputMaybe<Scalars["String"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  notificationId?: InputMaybe<Scalars["Int"]["input"]>;
  sendEmptyAgendaReminder?: InputMaybe<Scalars["Boolean"]["input"]>;
  sendPreparationNotification?: InputMaybe<Scalars["Boolean"]["input"]>;
  sendSummaryNotification?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationCreateOrUpdateTeamArgs = {
  members?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  teamId?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateOrUpdateTeamsNotificationForChannelArgs = {
  channelId?: InputMaybe<Scalars["String"]["input"]>;
  goalCheckins?: InputMaybe<Scalars["Boolean"]["input"]>;
  notificationId?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitions?: InputMaybe<Scalars["Boolean"]["input"]>;
  teamId?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateOrUpdateTemplateRequirementsArgs = {
  hasRequirements: Scalars["Boolean"]["input"];
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  templateId: Scalars["Int"]["input"];
};

export type MutationCreateOrUpdateTemplateSeriesForMeetingArgs = {
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  ratings?: InputMaybe<ReadonlyArray<InputMaybe<TemplateRatingInput>>>;
  templateId?: InputMaybe<Scalars["Int"]["input"]>;
  templateSeriesId?: InputMaybe<Scalars["Int"]["input"]>;
  topics?: InputMaybe<ReadonlyArray<InputMaybe<TemplateTopicInput>>>;
};

export type MutationCreateOrUpdateTopicArgs = {
  afterTopicId?: InputMaybe<Scalars["Int"]["input"]>;
  assignee?: InputMaybe<Scalars["Int"]["input"]>;
  beforeTopicId?: InputMaybe<Scalars["Int"]["input"]>;
  defaultFacilitatorNotes?: InputMaybe<Scalars["String"]["input"]>;
  defaultSubjectNotes?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  discussionNotes?: InputMaybe<Scalars["JSONString"]["input"]>;
  includesIndividualNotes?: InputMaybe<Scalars["Boolean"]["input"]>;
  includesSharedNotes?: InputMaybe<Scalars["Boolean"]["input"]>;
  individualNotes?: InputMaybe<Scalars["JSONString"]["input"]>;
  isMandatory?: InputMaybe<Scalars["Boolean"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  state?: InputMaybe<TopicState>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  topicId?: InputMaybe<Scalars["Int"]["input"]>;
  topicTemplateId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationCreateOrUpdateTopicTemplateArgs = {
  allowAdminVisibility?: InputMaybe<Scalars["Boolean"]["input"]>;
  allowManagementTreeVisibility?: InputMaybe<Scalars["Boolean"]["input"]>;
  allowOrgVisibility?: InputMaybe<Scalars["Boolean"]["input"]>;
  categories?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  finalizePermissions?: InputMaybe<FinalizePermissions>;
  managerInstructions?: InputMaybe<Scalars["String"]["input"]>;
  oneononeTemplate?: InputMaybe<Scalars["Boolean"]["input"]>;
  organization?: InputMaybe<Scalars["Int"]["input"]>;
  publicTemplate?: InputMaybe<Scalars["Boolean"]["input"]>;
  ratings?: InputMaybe<ReadonlyArray<InputMaybe<TemplateRatingInput>>>;
  reportInstructions?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  topicTemplateId?: InputMaybe<Scalars["Int"]["input"]>;
  topics?: InputMaybe<ReadonlyArray<InputMaybe<TemplateTopicInput>>>;
};

export type MutationCreateOrUpdateTopicTemplateCategoryArgs = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  ordinal?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  topicTemplateCategoryId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationCreateOrUpdateWorkflowArgs = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  state?: InputMaybe<WorkflowState>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  workflowId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationCreatePrivateNoteArgs = {
  notes: Scalars["JSONString"]["input"];
  profileId: Scalars["Int"]["input"];
};

export type MutationCreateRoutineArgs = {
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  skillId?: InputMaybe<Scalars["String"]["input"]>;
  skillSlug: Scalars["String"]["input"];
  triggerConfig: Scalars["JSONString"]["input"];
  triggerType: Scalars["String"]["input"];
};

export type MutationCreateTemplateFromMeetingArgs = {
  meetingId: Scalars["Int"]["input"];
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationDeleteArtifactArgs = {
  artifactId: Scalars["Int"]["input"];
};

export type MutationDeleteAssessmentAnswerArgs = {
  assessmentId?: InputMaybe<Scalars["Int"]["input"]>;
  questionIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type MutationDeleteAssessmentGroupArgs = {
  assessmentGroupId: Scalars["Int"]["input"];
};

export type MutationDeleteAssessmentQuestionArgs = {
  assessmentQuestionId: Scalars["Int"]["input"];
};

export type MutationDeleteCalibrationGroupArgs = {
  id: Scalars["Int"]["input"];
};

export type MutationDeleteCareerTrackArgs = {
  careerTrackId: Scalars["Int"]["input"];
};

export type MutationDeleteChatSessionArgs = {
  id: Scalars["Int"]["input"];
};

export type MutationDeleteCommentArgs = {
  commentId: Scalars["Int"]["input"];
};

export type MutationDeleteCompetencyArgs = {
  competencyId: Scalars["Int"]["input"];
};

export type MutationDeleteComplianceProgramArgs = {
  complianceProgramId: Scalars["Int"]["input"];
};

export type MutationDeleteComplianceProgramReportingViewArgs = {
  id: Scalars["Int"]["input"];
};

export type MutationDeleteComplianceProgramScheduledReminderArgs = {
  reminderId: Scalars["Int"]["input"];
};

export type MutationDeleteCoreValueArgs = {
  coreValueId: Scalars["Int"]["input"];
};

export type MutationDeleteExplorerBookmarkArgs = {
  explorerBookmarkId: Scalars["Int"]["input"];
};

export type MutationDeleteFavouritesGroupArgs = {
  favouritesGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  removeAll?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationDeleteFlowArgs = {
  flowId: Scalars["Int"]["input"];
};

export type MutationDeleteKeyResultArgs = {
  keyResultId: Scalars["Int"]["input"];
};

export type MutationDeleteKpiArgs = {
  kpiId: Scalars["Int"]["input"];
};

export type MutationDeleteKpiGroupArgs = {
  kpiGroupId: Scalars["Int"]["input"];
};

export type MutationDeleteKpiIntegrationArgs = {
  integrationId: Scalars["Int"]["input"];
};

export type MutationDeleteKpiMeasurementArgs = {
  measurementId: Scalars["Int"]["input"];
};

export type MutationDeleteMeetingArgs = {
  meetingId: Scalars["Int"]["input"];
};

export type MutationDeleteMeetingTranscriptsArgs = {
  meetingId: Scalars["Int"]["input"];
};

export type MutationDeleteMeetingVideoRecordingArgs = {
  meetingId: Scalars["Int"]["input"];
};

export type MutationDeletePrivateNoteArgs = {
  privateNoteId: Scalars["Int"]["input"];
};

export type MutationDeleteRatingArgs = {
  ratingId: Scalars["Int"]["input"];
};

export type MutationDeleteRoutineArgs = {
  id: Scalars["UUID"]["input"];
};

export type MutationDeleteSlackNotificationForChannelArgs = {
  notificationId: Scalars["Int"]["input"];
};

export type MutationDeleteSlackNotificationsForMeetingGroupArgs = {
  notificationId: Scalars["Int"]["input"];
};

export type MutationDeleteTeamArgs = {
  teamId: Scalars["Int"]["input"];
};

export type MutationDeleteTeamsNotificationForChannelArgs = {
  notificationId: Scalars["Int"]["input"];
};

export type MutationDeleteTopicArgs = {
  topicId: Scalars["Int"]["input"];
};

export type MutationDeleteTopicTemplateArgs = {
  topicTemplateId: Scalars["Int"]["input"];
};

export type MutationDeleteTopicTemplateCategoryArgs = {
  topicTemplateCategoryId: Scalars["Int"]["input"];
};

export type MutationDeleteWorkflowArgs = {
  workflowId: Scalars["Int"]["input"];
};

export type MutationDismissInsightArgs = {
  artifactId?: InputMaybe<Scalars["Int"]["input"]>;
  assessmentGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  complianceProgramId?: InputMaybe<Scalars["Int"]["input"]>;
  managerId?: InputMaybe<Scalars["Int"]["input"]>;
  reportId?: InputMaybe<Scalars["Int"]["input"]>;
  templateRequirementId?: InputMaybe<Scalars["Int"]["input"]>;
  type: InsightType;
  userId: Scalars["Int"]["input"];
};

export type MutationDuplicateGoalArgs = {
  dueDate: Scalars["Date"]["input"];
  duplicateKeyResults?: InputMaybe<Scalars["Boolean"]["input"]>;
  goalId: Scalars["Int"]["input"];
  parentGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  resetProgress?: InputMaybe<Scalars["Boolean"]["input"]>;
  startDate: Scalars["Date"]["input"];
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationEditSuggestedAssessmentResponseArgs = {
  chatSessionId: Scalars["Int"]["input"];
  messageId: Scalars["String"]["input"];
  suggestionId: Scalars["String"]["input"];
};

export type MutationEmail1on1NudgeArgs = {
  managerId: Scalars["Int"]["input"];
  reportId: Scalars["Int"]["input"];
  topicTemplateId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationEmailAssessmentReminderArgs = {
  complianceProgramId: Scalars["Int"]["input"];
};

export type MutationEmailMeetingInvitesArgs = {
  meetingId: Scalars["Int"]["input"];
  message?: InputMaybe<Scalars["String"]["input"]>;
  recipientEmails: ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>;
};

export type MutationEmailMeetingNotesArgs = {
  meetingId: Scalars["Int"]["input"];
  message?: InputMaybe<Scalars["String"]["input"]>;
  recipientEmails: ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>;
};

export type MutationEmailOneononeReminderArgs = {
  complianceProgramId: Scalars["Int"]["input"];
};

export type MutationExchangeMergePublicTokenArgs = {
  endUserOriginId: Scalars["String"]["input"];
  publicToken: Scalars["String"]["input"];
};

export type MutationExportComplianceProgramEngagementSurveyHeatmapToCsvArgs = {
  collapsedKeys?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
  >;
  complianceProgramId: Scalars["Int"]["input"];
  employeeStartDateRange?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
  >;
  groupBy: EngagementSurveyReportGroupBy;
  locations?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  managerIdsFullTree?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type MutationExportComplianceProgramEngagementSurveyToCsvArgs = {
  complianceProgramId: Scalars["Int"]["input"];
  groupBy?: InputMaybe<EngagementSurveyReportGroupBy>;
};

export type MutationExportComplianceProgramPerformanceAssessmentToCsvArgs = {
  answerFilters?: InputMaybe<
    ReadonlyArray<InputMaybe<PerformanceAssessmentAnswerFilter>>
  >;
  careerTrackIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  complianceProgramId: Scalars["Int"]["input"];
  enrollmentDateFilter?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  matchAny?: InputMaybe<Scalars["Boolean"]["input"]>;
  reportToIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  roleIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  roleLevels?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  talentIndicatorFilters?: InputMaybe<
    ReadonlyArray<
      InputMaybe<ReadonlyArray<InputMaybe<PerformanceAssessmentAnswerFilter>>>
    >
  >;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  userIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type MutationExportComplianceProgramToCsvArgs = {
  complianceProgramId: Scalars["Int"]["input"];
};

export type MutationForkPlatformSkillArgs = {
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  slug: Scalars["String"]["input"];
};

export type MutationGenerateReviewAnswersArgs = {
  assessmentId: Scalars["ID"]["input"];
};

export type MutationGetOrCreateChatbotSessionArgs = {
  assessmentId?: InputMaybe<Scalars["Int"]["input"]>;
  assessmentQuestionId?: InputMaybe<Scalars["Int"]["input"]>;
  seedWithSuggestedAssessmentAnswer?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationIgnoreMeetingArgs = {
  ignore: Scalars["Boolean"]["input"];
  meetingId: Scalars["Int"]["input"];
};

export type MutationImportOneononeNotesArgs = {
  meetings: ReadonlyArray<InputMaybe<ImportOneononeMeetingInput>>;
  reportUserId: Scalars["Int"]["input"];
  timezone?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationJoinOrganizationArgs = {
  organizationId: Scalars["Int"]["input"];
};

export type MutationLinkCalendarToOrganizationArgs = {
  credentialsId: Scalars["Int"]["input"];
  organizationId: Scalars["Int"]["input"];
};

export type MutationLinkCreatedArtifactToChatMessageArgs = {
  artifactId: Scalars["Int"]["input"];
  chatSessionId: Scalars["Int"]["input"];
  messageId: Scalars["String"]["input"];
};

export type MutationMarkMeetingTopicsAsDiscussedArgs = {
  meetingId: Scalars["Int"]["input"];
};

export type MutationMarkPreviousMeetingTopicsAsDiscussedArgs = {
  meetingId: Scalars["Int"]["input"];
};

export type MutationMarkReportOnboardedArgs = {
  reportId: Scalars["Int"]["input"];
};

export type MutationPrepareFileUploadArgs = {
  artifactId?: InputMaybe<Scalars["Int"]["input"]>;
  contentType?: InputMaybe<Scalars["String"]["input"]>;
  filename: Scalars["String"]["input"];
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValueId?: InputMaybe<Scalars["Int"]["input"]>;
  topicId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationPreviewImportOneononeNotesArgs = {
  notes: Scalars["String"]["input"];
  reportUserId: Scalars["Int"]["input"];
  timezone?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationRegenerateQuestionAnswerArgs = {
  assessmentId: Scalars["Int"]["input"];
  questionId: Scalars["Int"]["input"];
};

export type MutationRelinkMergeDevIntegrationArgs = {
  integrationId: Scalars["Int"]["input"];
};

export type MutationRemoveBotFromMeetingArgs = {
  meetingId: Scalars["Int"]["input"];
};

export type MutationRemoveFavouriteArtifactArgs = {
  artifactId: Scalars["Int"]["input"];
};

export type MutationRemoveIntegrationCredentialsArgs = {
  credentialsId: Scalars["Int"]["input"];
};

export type MutationRemoveMergeDevIntegrationArgs = {
  integrationId: Scalars["Int"]["input"];
};

export type MutationRemoveOrgGithubIntegrationArgs = {
  organizationId: Scalars["Int"]["input"];
};

export type MutationRemovePersonalTranscriptSyncCredentialArgs = {
  provider: PersonalTranscriptSyncCredentialProviderEnum;
};

export type MutationRemoveSlackIntegrationArgs = {
  organizationId: Scalars["Int"]["input"];
};

export type MutationRemoveTeamMemberArgs = {
  teamId: Scalars["Int"]["input"];
  userId: Scalars["Int"]["input"];
};

export type MutationRemoveTeamsIntegrationArgs = {
  organizationId: Scalars["Int"]["input"];
};

export type MutationRemoveTemplateSeriesFromMeetingArgs = {
  meetingGroupId: Scalars["Int"]["input"];
};

export type MutationRemoveUserFromOrganizationArgs = {
  orgId: Scalars["Int"]["input"];
  userToRemoveId: Scalars["Int"]["input"];
};

export type MutationRemoveYoutrackIntegrationArgs = {
  organizationId: Scalars["Int"]["input"];
};

export type MutationReopenAssessmentArgs = {
  assessmentIds: ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>;
};

export type MutationReorderArtifactArgs = {
  afterArtifactId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactId: Scalars["Int"]["input"];
  beforeArtifactId?: InputMaybe<Scalars["Int"]["input"]>;
  contextId: Scalars["Int"]["input"];
  contextType: Scalars["String"]["input"];
};

export type MutationReorderTopicArgs = {
  afterTopicId?: InputMaybe<Scalars["Int"]["input"]>;
  beforeTopicId?: InputMaybe<Scalars["Int"]["input"]>;
  topicId: Scalars["Int"]["input"];
};

export type MutationRetryChatbotSessionArgs = {
  chatSessionId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationSaveMeetingVideoRecordingArgs = {
  meetingId: Scalars["Int"]["input"];
};

export type MutationSavePersonalTranscriptSyncCredentialArgs = {
  apiKey: Scalars["String"]["input"];
  provider: PersonalTranscriptSyncCredentialProviderEnum;
};

export type MutationSearchCsvExportArgs = {
  options?: InputMaybe<SearchOptions>;
  searchTerm: Scalars["String"]["input"];
};

export type MutationSendMessageToChatbotArgs = {
  assessmentId?: InputMaybe<Scalars["Int"]["input"]>;
  assessmentQuestionId?: InputMaybe<Scalars["Int"]["input"]>;
  chatSessionId?: InputMaybe<Scalars["Int"]["input"]>;
  imageUrls?: InputMaybe<ReadonlyArray<Scalars["String"]["input"]>>;
  isIncognito?: InputMaybe<Scalars["Boolean"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  message: Scalars["String"]["input"];
  messageId?: InputMaybe<Scalars["String"]["input"]>;
  skillId?: InputMaybe<Scalars["String"]["input"]>;
  systemContextMessage?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationSendPhoneNumberVerificationCodeArgs = {
  organizationId: Scalars["Int"]["input"];
};

export type MutationSendProgramReminderArgs = {
  complianceProgramId: Scalars["Int"]["input"];
  emailNotification: Scalars["Boolean"]["input"];
  engagementSurveyStatusUserIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  managerAssessmentStatusUserIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  managerSelfAssessmentStatusUserIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  message?: InputMaybe<Scalars["String"]["input"]>;
  nominationsUserIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  oneononeStatusUserIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  peerAssessmentStatusUserIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  peerSelfAssessmentStatusUserIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  performanceAssessmentStatusUserIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  performanceSelfAssessmentStatusUserIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  slackNotification: Scalars["Boolean"]["input"];
  teamsNotification?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationSendRoutineTestArgs = {
  routineId: Scalars["UUID"]["input"];
};

export type MutationSetAssessmentNominationsArgs = {
  assessmentTemplateId: Scalars["Int"]["input"];
  complianceProgramId: Scalars["Int"]["input"];
  responderIds: ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>;
  targetId: Scalars["Int"]["input"];
};

export type MutationSetFavouriteGroupsArgs = {
  userIds: ReadonlyArray<
    InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>
  >;
};

export type MutationSetMeetingAgendaAsTemplateArgs = {
  meetingId: Scalars["Int"]["input"];
};

export type MutationSetMeetingLockedArgs = {
  isLocked: Scalars["Boolean"]["input"];
  meetingId: Scalars["Int"]["input"];
};

export type MutationSetRelationshipArgs = {
  clearRelationship?: InputMaybe<Scalars["Boolean"]["input"]>;
  isPrimaryRelationship?: InputMaybe<Scalars["Boolean"]["input"]>;
  meetingFrequency?: InputMaybe<FrequencyInput>;
  organizationId: Scalars["Int"]["input"];
  otherUserId: Scalars["Int"]["input"];
  relationshipType?: InputMaybe<RelationshipType>;
  userId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationSetRelationshipsArgs = {
  organizationId: Scalars["Int"]["input"];
  rebuildManagementTree?: InputMaybe<Scalars["Boolean"]["input"]>;
  relationships?: InputMaybe<ReadonlyArray<InputMaybe<RelationshipInput>>>;
  userId: Scalars["Int"]["input"];
};

export type MutationStartCalendarSyncArgs = {
  fullSync?: InputMaybe<Scalars["Boolean"]["input"]>;
  syncCredentialsId: Scalars["Int"]["input"];
};

export type MutationSubmitOneononeArgs = {
  meetingId: Scalars["Int"]["input"];
  unhideIndividualNotes?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationSyncComplianceProgramUsersArgs = {
  complianceProgramId: Scalars["Int"]["input"];
};

export type MutationSyncWithHrisArgs = {
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  organizationId: Scalars["Int"]["input"];
};

export type MutationToggleIndividualNoteVisibilityArgs = {
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  hidden?: InputMaybe<Scalars["Boolean"]["input"]>;
  notes?: InputMaybe<Scalars["JSONString"]["input"]>;
  topicIds: ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>;
};

export type MutationUnlinkIntegrationFromOrganizationArgs = {
  organizationIntegrationId: Scalars["Int"]["input"];
};

export type MutationUpdateAccountOnboardingArgs = {
  accountSetupData: Scalars["JSONString"]["input"];
};

export type MutationUpdateAiBrainConsolidatedArgs = {
  content: Scalars["String"]["input"];
};

export type MutationUpdateAssessmentDeliveryArgs = {
  assessmentDeliveryId: Scalars["Int"]["input"];
  excludedAnswerIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  state?: InputMaybe<AssessmentDeliveryState>;
  summary?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateAttendanceStatusArgs = {
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  status: AttendeeStatus;
};

export type MutationUpdateChatSessionArgs = {
  id: Scalars["Int"]["input"];
  pinned?: InputMaybe<Scalars["Boolean"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateComplianceProgramCalibrationStatusArgs = {
  complianceProgramId: Scalars["Int"]["input"];
  status: ComplianceProgramCalibrationStatus;
  targetId: Scalars["Int"]["input"];
};

export type MutationUpdateMeetingArgs = {
  allowExternalViewers?: InputMaybe<Scalars["Boolean"]["input"]>;
  clearAllowExternalViewers?: InputMaybe<Scalars["Boolean"]["input"]>;
  meetingId: Scalars["Int"]["input"];
};

export type MutationUpdateMeetingFinalizationStatusArgs = {
  isFinalized: Scalars["Boolean"]["input"];
  meetingId: Scalars["Int"]["input"];
};

export type MutationUpdateMeetingGroupArgs = {
  addTranscriptionBotToMeetingsByDefault?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  allowAdminVisibility?: InputMaybe<Scalars["Boolean"]["input"]>;
  allowExternalViewers?: InputMaybe<Scalars["Boolean"]["input"]>;
  allowManagementTreeVisibility?: InputMaybe<Scalars["Boolean"]["input"]>;
  allowOrgVisibility?: InputMaybe<Scalars["Boolean"]["input"]>;
  detectedOneononeBannerDismissed?: InputMaybe<Scalars["Boolean"]["input"]>;
  facilitatorId?: InputMaybe<Scalars["Int"]["input"]>;
  isFormalOneonone?: InputMaybe<Scalars["Boolean"]["input"]>;
  meetingBotSetting?: InputMaybe<MeetingBotSetting>;
  meetingGroupId: Scalars["Int"]["input"];
  transcribeMeetingsByDefault?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationUpdateMeetingTranscriptArgs = {
  meetingId: Scalars["Int"]["input"];
  removeMessageIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
  >;
  transcriptData?: InputMaybe<Scalars["JSONString"]["input"]>;
  userMapping?: InputMaybe<Scalars["JSONString"]["input"]>;
};

export type MutationUpdateMeetingTranscriptionStatusArgs = {
  meetingId: Scalars["Int"]["input"];
  transcriptionStatus: Scalars["Boolean"]["input"];
};

export type MutationUpdateOrganizationMembershipArgs = {
  employeeId?: InputMaybe<Scalars["String"]["input"]>;
  jobLevel?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  membershipStatus?: InputMaybe<AccountToOrganizationMembershipStatus>;
  organizationId: Scalars["Int"]["input"];
  position?: InputMaybe<Scalars["String"]["input"]>;
  role?: InputMaybe<OrganizationRole>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
  userId: Scalars["Int"]["input"];
};

export type MutationUpdateRoutineArgs = {
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  id: Scalars["UUID"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  skillId?: InputMaybe<Scalars["String"]["input"]>;
  skillSlug?: InputMaybe<Scalars["String"]["input"]>;
  triggerConfig?: InputMaybe<Scalars["JSONString"]["input"]>;
  triggerType?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateSlackOrgSettingsArgs = {
  channelConfigurations?: InputMaybe<
    ReadonlyArray<InputMaybe<SlackChannelConfigurationInput>>
  >;
  indexMessages?: InputMaybe<Scalars["Boolean"]["input"]>;
  indexNewChannelsByDefault?: InputMaybe<Scalars["Boolean"]["input"]>;
  organizationId: Scalars["Int"]["input"];
};

export type MutationUpdateSuggestedArtifactArgs = {
  hidden?: InputMaybe<Scalars["Boolean"]["input"]>;
  suggestedArtifactId: Scalars["Int"]["input"];
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateSuggestedTopicArgs = {
  hidden?: InputMaybe<Scalars["Boolean"]["input"]>;
  suggestedTopicId: Scalars["Int"]["input"];
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateTalentIndicatorArgs = {
  customName?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  labelDescriptions?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
  >;
  labels?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
  organizationId: Scalars["Int"]["input"];
  questionTitle?: InputMaybe<Scalars["String"]["input"]>;
  scale?: InputMaybe<Scalars["Int"]["input"]>;
  scaleStartsAt?: InputMaybe<Scalars["Int"]["input"]>;
  talentIndicatorType: TalentIndicatorType;
};

export type MutationUpdateTopicDiscussionNotesArgs = {
  discussionNotes?: InputMaybe<Scalars["JSONString"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  topicId: Scalars["Int"]["input"];
};

export type MutationUpdateUserArgs = {
  aiGuidelines?: InputMaybe<Scalars["String"]["input"]>;
  dailyBriefEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  dailyBriefHour?: InputMaybe<Scalars["Int"]["input"]>;
  emailPreference?: InputMaybe<EmailPreference>;
  enableDailyCommitmentEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
  enableDailySummaryEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
  enableDraftReminderEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
  eventLinkInDescriptionPreference?: InputMaybe<EventDescriptionLinkSetting>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  meetingBotPreference?: InputMaybe<UserMeetingBotPreference>;
  meetingPrepEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  meetingPrepLeadTimeMinutes?: InputMaybe<Scalars["Int"]["input"]>;
  meetingPrepOneononeOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  meetingPreparationEmailPreference?: InputMaybe<MeetingAgendaEmailPreference>;
  meetingSummaryEmailPreference?: InputMaybe<MeetingSummaryEmailPreference>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  primaryEmailAddress?: InputMaybe<Scalars["String"]["input"]>;
  programAdminNotificationDownwardSubmitted?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  programNotificationPreference?: InputMaybe<ComplianceProgramNotificationPreference>;
  showPersonalMeetings?: InputMaybe<Scalars["Boolean"]["input"]>;
  surveyNotificationPreference?: InputMaybe<ComplianceProgramNotificationPreference>;
  timezone?: InputMaybe<Scalars["String"]["input"]>;
  uiPreferenceCache?: InputMaybe<Scalars["JSONString"]["input"]>;
  videoRecordingPreference?: InputMaybe<UserVideoRecordingPreference>;
};

export type MutationUpdateWorkHistoryArgs = {
  data: WorkHistorySummaryInput;
  workHistorySummaryId: Scalars["Int"]["input"];
};

export type MutationVerifyPhoneNumberArgs = {
  code: Scalars["String"]["input"];
  organizationId: Scalars["Int"]["input"];
};

/** An object with an ID */
export type Node = {
  /** The ID of the object */
  readonly id: Scalars["ID"]["output"];
};

/** An enumeration. */
export enum NotesRequirement {
  AllParticipants = "all_participants",
  NotRequired = "not_required",
  OneParticipant = "one_participant",
}

/** An enumeration. */
export enum NpsAnswerValue {
  Detractor = "DETRACTOR",
  Passive = "PASSIVE",
  Promoter = "PROMOTER",
}

export type NpsAssessmentAnswerNode = AssessmentAnswerInterface & {
  readonly __typename: "NpsAssessmentAnswerNode";
  readonly assessment: AssessmentNode;
  readonly calibrations: AssessmentAnswerCalibrationConnection;
  readonly canDelete: PermissionNode;
  readonly canRead: PermissionNode;
  readonly canUpdate: PermissionNode;
  readonly comment?: Maybe<Scalars["JSONString"]["output"]>;
  readonly created: Scalars["DateTime"]["output"];
  readonly hasCalibrationSuggestions: Scalars["Boolean"]["output"];
  readonly hasCalibrations: Scalars["Boolean"]["output"];
  readonly id: Scalars["Int"]["output"];
  readonly integerAnswer?: Maybe<Scalars["Int"]["output"]>;
  readonly isLocked: Scalars["Boolean"]["output"];
  readonly npsValue?: Maybe<NpsAnswerValue>;
  readonly question: AssessmentQuestionInterface;
  readonly questionId: Scalars["Int"]["output"];
  readonly responder?: Maybe<UserNode>;
  readonly updated: Scalars["DateTime"]["output"];
};

export type NpsAssessmentAnswerNodeCalibrationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type NpsAssessmentQuestionNode = AssessmentQuestionInterface & {
  readonly __typename: "NpsAssessmentQuestionNode";
  readonly answers: AssessmentAnswerConnection;
  readonly answersExist: Scalars["Boolean"]["output"];
  readonly archived: Scalars["Boolean"]["output"];
  readonly canDelete: PermissionNode;
  readonly canRead: PermissionNode;
  readonly canUpdate: PermissionNode;
  readonly categories: AssessmentQuestionCategoryNodeConnection;
  readonly comment: AssessmentQuestionComment;
  readonly created: Scalars["DateTime"]["output"];
  readonly creator?: Maybe<UserNode>;
  readonly description?: Maybe<Scalars["JSONString"]["output"]>;
  readonly id: Scalars["Int"]["output"];
  readonly isResponseMandatory: Scalars["Boolean"]["output"];
  readonly organization: OrganizationNode;
  readonly questionType: AssessmentQuestionType;
  readonly responseVisibility: AssessmentQuestionResponseVisibility;
  readonly responses: AssessmentQuestionResponses;
  readonly title: Scalars["String"]["output"];
  readonly updated: Scalars["DateTime"]["output"];
};

export type NpsAssessmentQuestionNodeAnswersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type NpsAssessmentQuestionNodeCategoriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

/** An enumeration. */
export enum OnlineConference {
  Native = "native",
  None = "none",
  Zoom = "zoom",
}

/** An enumeration. */
export enum OnlineVideoConference {
  Aroundco = "aroundco",
  Google = "google",
  None = "none",
  Teams = "teams",
  Whereby = "whereby",
  Zoom = "zoom",
}

export type OrganizationFeatureFlags = {
  readonly __typename: "OrganizationFeatureFlags";
  readonly actionItems?: Maybe<Scalars["Boolean"]["output"]>;
  readonly askAi?: Maybe<Scalars["Boolean"]["output"]>;
  readonly decisions?: Maybe<Scalars["Boolean"]["output"]>;
  readonly documents?: Maybe<Scalars["Boolean"]["output"]>;
  readonly explorer?: Maybe<Scalars["Boolean"]["output"]>;
  readonly feedbacks?: Maybe<Scalars["Boolean"]["output"]>;
  readonly goals?: Maybe<Scalars["Boolean"]["output"]>;
  readonly homepageMyConnections?: Maybe<Scalars["Boolean"]["output"]>;
  readonly homepageMyConnectionsPeers?: Maybe<Scalars["Boolean"]["output"]>;
  readonly kpis?: Maybe<Scalars["Boolean"]["output"]>;
  readonly meetings?: Maybe<Scalars["Boolean"]["output"]>;
  readonly profilePage?: Maybe<Scalars["Boolean"]["output"]>;
  readonly recognitions?: Maybe<Scalars["Boolean"]["output"]>;
  readonly reviewContextGeneration?: Maybe<Scalars["Boolean"]["output"]>;
  readonly workHistory?: Maybe<Scalars["Boolean"]["output"]>;
};

export type OrganizationFeatureFlagsInput = {
  readonly actionItems?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly askAi?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly decisions?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly documents?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly explorer?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly feedbacks?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly goals?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly homepageMyConnections?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly homepageMyConnectionsPeers?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly kpis?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly meetings?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly profilePage?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly recognitions?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly reviewContextGeneration?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly workHistory?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type OrganizationInfoNode = {
  readonly __typename: "OrganizationInfoNode";
  readonly organizationId?: Maybe<Scalars["Int"]["output"]>;
  readonly organizationMemberCount?: Maybe<Scalars["Int"]["output"]>;
  readonly organizationName?: Maybe<Scalars["String"]["output"]>;
};

export type OrganizationIntegrationNode = DjangoNode &
  Node & {
    readonly __typename: "OrganizationIntegrationNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator: UserNode;
    readonly id: Scalars["ID"]["output"];
    readonly integrationType: IntegrationTypes;
    readonly lastSyncedAt?: Maybe<Scalars["DateTime"]["output"]>;
    readonly organization: OrganizationNode;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly socialAuth: UserSocialAuthNode;
    readonly updated: Scalars["DateTime"]["output"];
  };

export type OrganizationIntegrationNodeConnection = {
  readonly __typename: "OrganizationIntegrationNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<OrganizationIntegrationNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `OrganizationIntegrationNode` and its cursor. */
export type OrganizationIntegrationNodeEdge = {
  readonly __typename: "OrganizationIntegrationNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<OrganizationIntegrationNode>;
};

/** An enumeration. */
export enum OrganizationMembershipSetting {
  AnyoneWithValidDomain = "anyone_with_valid_domain",
  ManualInvitesOnly = "manual_invites_only",
}

export type OrganizationNode = DjangoNode &
  Node & {
    readonly __typename: "OrganizationNode";
    readonly actionItemStates: ReadonlyArray<Maybe<ActionItemState>>;
    /** Guidelines for AI chatbot responses at the organization level */
    readonly aiGuidelines: Scalars["String"]["output"];
    readonly availableLocations: ReadonlyArray<
      Maybe<Scalars["String"]["output"]>
    >;
    readonly availableTeamsNotificationChannels: ReadonlyArray<
      Maybe<AvailableTeamsNotificationChannel>
    >;
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly competencyLabel: Scalars["String"]["output"];
    readonly compliancePrograms?: Maybe<ComplianceProgramNodeConnection>;
    readonly conversationLabel: Scalars["String"]["output"];
    readonly coreValues?: Maybe<RecognitionCoreValueNodeConnection>;
    readonly daysLeftOnTrial?: Maybe<Scalars["Int"]["output"]>;
    readonly defaultGoalState?: Maybe<GoalState>;
    readonly developmentLabel: Scalars["String"]["output"];
    readonly directorySync?: Maybe<DirectorySyncNode>;
    readonly domains?: Maybe<ReadonlyArray<Maybe<Scalars["String"]["output"]>>>;
    readonly effectivePricingTier?: Maybe<PricingTier>;
    readonly enableMeetingBot: Scalars["Boolean"]["output"];
    readonly enableMeetingSummarization: Scalars["Boolean"]["output"];
    readonly expectationLabel: Scalars["String"]["output"];
    readonly featureFlags: OrganizationFeatureFlags;
    readonly fellowApiDomain?: Maybe<Scalars["String"]["output"]>;
    readonly goalLabel: Scalars["String"]["output"];
    readonly hasAnthropicApiKey?: Maybe<Scalars["Boolean"]["output"]>;
    readonly hasCareerFramework?: Maybe<Scalars["Boolean"]["output"]>;
    readonly hasFellowTranscriptSyncConnection?: Maybe<
      Scalars["Boolean"]["output"]
    >;
    readonly hasGithubInstallation?: Maybe<Scalars["Boolean"]["output"]>;
    readonly hasSlackConnection?: Maybe<Scalars["Boolean"]["output"]>;
    readonly hasTeamsInstallation?: Maybe<Scalars["Boolean"]["output"]>;
    readonly hasTeamsNotificationConnection?: Maybe<
      Scalars["Boolean"]["output"]
    >;
    readonly hasTeamsTranscriptConnection?: Maybe<Scalars["Boolean"]["output"]>;
    readonly hasYoutrackIntegration?: Maybe<Scalars["Boolean"]["output"]>;
    readonly id: Scalars["ID"]["output"];
    readonly integrations: OrganizationIntegrationNodeConnection;
    readonly keyResultLabel: Scalars["String"]["output"];
    readonly maxCareerTrackRoleLevel: Scalars["Int"]["output"];
    readonly members: UserMemberNodeConnection;
    readonly membershipSetting?: Maybe<OrganizationMembershipSetting>;
    readonly mergeIntegrationsMetadata: ReadonlyArray<
      Maybe<MergeIntegrationMetadata>
    >;
    readonly name: Scalars["String"]["output"];
    readonly oneononeLabel: Scalars["String"]["output"];
    readonly orgLabel: Scalars["String"]["output"];
    readonly personal?: Maybe<Scalars["Boolean"]["output"]>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly pricingTier?: Maybe<PricingTier>;
    readonly pricingTierValidUntil?: Maybe<Scalars["DateTime"]["output"]>;
    readonly publicSlackChannels?: Maybe<SlackChannelConnection>;
    readonly quarterStartMonth: Scalars["Int"]["output"];
    readonly recognitionLabel: Scalars["String"]["output"];
    readonly recognitionStats?: Maybe<RecognitionStatsNode>;
    readonly reviewLabel: Scalars["String"]["output"];
    readonly slackIndexingConfiguration?: Maybe<SlackIndexingConfigurationNode>;
    readonly slackNotifications?: Maybe<SlackNotificationForChannelNodeConnection>;
    readonly teamLabel: Scalars["String"]["output"];
    readonly teams?: Maybe<TeamNodeConnection>;
    readonly teamsNotifications?: Maybe<TeamsNotificationForChannelNodeConnection>;
    readonly topicChannelName?: Maybe<Scalars["String"]["output"]>;
    readonly transcribeMeetingsByDefault?: Maybe<Scalars["Boolean"]["output"]>;
    readonly userMembership?: Maybe<UserMemberNode>;
    readonly userRelationships?: Maybe<RelationshipNodeConnection>;
    readonly workflows?: Maybe<WorkflowNodeConnection>;
    readonly youtrackLastSync?: Maybe<Scalars["DateTime"]["output"]>;
    readonly youtrackUrl?: Maybe<Scalars["String"]["output"]>;
  };

export type OrganizationNodeComplianceProgramsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  applicableUser?: InputMaybe<Scalars["Int"]["input"]>;
  assessmentType?: InputMaybe<AssessmentType>;
  assessmentTypes?: InputMaybe<ReadonlyArray<InputMaybe<AssessmentType>>>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  dueDate?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate_Gt?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate_Gte?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate_Lt?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate_Lte?: InputMaybe<Scalars["Date"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  onlyActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<ComplianceProgramState>;
  state_In?: InputMaybe<ReadonlyArray<InputMaybe<ComplianceProgramState>>>;
};

export type OrganizationNodeCoreValuesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<RecognitionCoreValueStatus>;
};

export type OrganizationNodeIntegrationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  integrationType?: InputMaybe<IntegrationTypes>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OrganizationNodeMembersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeUserId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeUserIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManager?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  isAdmin?: InputMaybe<Scalars["Boolean"]["input"]>;
  isGlobalAdmin?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerId?: InputMaybe<Scalars["Int"]["input"]>;
  membershipStatus?: InputMaybe<AccountToOrganizationMembershipStatus>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamId?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["Int"]["input"]>;
  userIsActive?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type OrganizationNodePublicSlackChannelsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OrganizationNodeRecognitionStatsArgs = {
  coreValueId?: InputMaybe<Scalars["Int"]["input"]>;
  endDate?: InputMaybe<Scalars["Date"]["input"]>;
  recipientId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionReceivedByMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  startDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type OrganizationNodeSlackNotificationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OrganizationNodeTeamsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organization?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  title_Startswith?: InputMaybe<Scalars["String"]["input"]>;
};

export type OrganizationNodeTeamsNotificationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OrganizationNodeUserMembershipArgs = {
  userId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OrganizationNodeUserRelationshipsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  primaryRelationshipType?: InputMaybe<RelationshipType>;
  primaryUser?: InputMaybe<Scalars["ID"]["input"]>;
  secondaryUser?: InputMaybe<Scalars["ID"]["input"]>;
  userId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OrganizationNodeWorkflowsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OrganizationNodeConnection = {
  readonly __typename: "OrganizationNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<OrganizationNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `OrganizationNode` and its cursor. */
export type OrganizationNodeEdge = {
  readonly __typename: "OrganizationNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<OrganizationNode>;
};

/** An enumeration. */
export enum OrganizationRole {
  Administrator = "administrator",
  GlobalAdmin = "global_admin",
  ItAdmin = "it_admin",
  Member = "member",
  PeopleAdmin = "people_admin",
}

export type OverallGoalAssessmentAnswerNode = AssessmentAnswerInterface & {
  readonly __typename: "OverallGoalAssessmentAnswerNode";
  readonly assessment: AssessmentNode;
  readonly calibrations: AssessmentAnswerCalibrationConnection;
  readonly canDelete: PermissionNode;
  readonly canRead: PermissionNode;
  readonly canUpdate: PermissionNode;
  readonly comment?: Maybe<Scalars["JSONString"]["output"]>;
  readonly created: Scalars["DateTime"]["output"];
  readonly hasCalibrationSuggestions: Scalars["Boolean"]["output"];
  readonly hasCalibrations: Scalars["Boolean"]["output"];
  readonly id: Scalars["Int"]["output"];
  readonly integerAnswer?: Maybe<Scalars["Int"]["output"]>;
  readonly isLocked: Scalars["Boolean"]["output"];
  readonly question: AssessmentQuestionInterface;
  readonly questionId: Scalars["Int"]["output"];
  readonly responder?: Maybe<UserNode>;
  readonly updated: Scalars["DateTime"]["output"];
};

export type OverallGoalAssessmentAnswerNodeCalibrationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OverallGoalAssessmentQuestionNode = AssessmentQuestionInterface & {
  readonly __typename: "OverallGoalAssessmentQuestionNode";
  readonly answers: AssessmentAnswerConnection;
  readonly answersExist: Scalars["Boolean"]["output"];
  readonly archived: Scalars["Boolean"]["output"];
  readonly canDelete: PermissionNode;
  readonly canRead: PermissionNode;
  readonly canUpdate: PermissionNode;
  readonly categories: AssessmentQuestionCategoryNodeConnection;
  readonly comment: AssessmentQuestionComment;
  readonly created: Scalars["DateTime"]["output"];
  readonly creator?: Maybe<UserNode>;
  readonly description?: Maybe<Scalars["JSONString"]["output"]>;
  readonly endValue: Scalars["Int"]["output"];
  readonly id: Scalars["Int"]["output"];
  readonly isResponseMandatory: Scalars["Boolean"]["output"];
  readonly labelDescriptions: ReadonlyArray<Maybe<Scalars["String"]["output"]>>;
  readonly labels: ReadonlyArray<Maybe<Scalars["String"]["output"]>>;
  readonly organization: OrganizationNode;
  readonly questionType: AssessmentQuestionType;
  readonly responseVisibility: AssessmentQuestionResponseVisibility;
  readonly responses: AssessmentQuestionResponses;
  readonly startValue: Scalars["Int"]["output"];
  readonly title: Scalars["String"]["output"];
  readonly updated: Scalars["DateTime"]["output"];
};

export type OverallGoalAssessmentQuestionNodeAnswersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OverallGoalAssessmentQuestionNodeCategoriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OverallRecognitionCoreValueAssessmentAnswerNode =
  AssessmentAnswerInterface & {
    readonly __typename: "OverallRecognitionCoreValueAssessmentAnswerNode";
    readonly assessment: AssessmentNode;
    readonly calibrations: AssessmentAnswerCalibrationConnection;
    readonly canDelete: PermissionNode;
    readonly canRead: PermissionNode;
    readonly canUpdate: PermissionNode;
    readonly comment?: Maybe<Scalars["JSONString"]["output"]>;
    readonly created: Scalars["DateTime"]["output"];
    readonly hasCalibrationSuggestions: Scalars["Boolean"]["output"];
    readonly hasCalibrations: Scalars["Boolean"]["output"];
    readonly id: Scalars["Int"]["output"];
    readonly integerAnswer?: Maybe<Scalars["Int"]["output"]>;
    readonly isLocked: Scalars["Boolean"]["output"];
    readonly question: AssessmentQuestionInterface;
    readonly questionId: Scalars["Int"]["output"];
    readonly responder?: Maybe<UserNode>;
    readonly updated: Scalars["DateTime"]["output"];
  };

export type OverallRecognitionCoreValueAssessmentAnswerNodeCalibrationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OverallRecognitionCoreValueAssessmentQuestionNode =
  AssessmentQuestionInterface & {
    readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
    readonly answers: AssessmentAnswerConnection;
    readonly answersExist: Scalars["Boolean"]["output"];
    readonly archived: Scalars["Boolean"]["output"];
    readonly canDelete: PermissionNode;
    readonly canRead: PermissionNode;
    readonly canUpdate: PermissionNode;
    readonly categories: AssessmentQuestionCategoryNodeConnection;
    readonly comment: AssessmentQuestionComment;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator?: Maybe<UserNode>;
    readonly description?: Maybe<Scalars["JSONString"]["output"]>;
    readonly endValue: Scalars["Int"]["output"];
    readonly id: Scalars["Int"]["output"];
    readonly isResponseMandatory: Scalars["Boolean"]["output"];
    readonly labelDescriptions: ReadonlyArray<
      Maybe<Scalars["String"]["output"]>
    >;
    readonly labels: ReadonlyArray<Maybe<Scalars["String"]["output"]>>;
    readonly organization: OrganizationNode;
    readonly questionType: AssessmentQuestionType;
    readonly responseVisibility: AssessmentQuestionResponseVisibility;
    readonly responses: AssessmentQuestionResponses;
    readonly startValue: Scalars["Int"]["output"];
    readonly title: Scalars["String"]["output"];
    readonly updated: Scalars["DateTime"]["output"];
  };

export type OverallRecognitionCoreValueAssessmentQuestionNodeAnswersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OverallRecognitionCoreValueAssessmentQuestionNodeCategoriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  readonly __typename: "PageInfo";
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars["String"]["output"]>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars["Boolean"]["output"];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars["Boolean"]["output"];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars["String"]["output"]>;
};

export type PaidFeaturesNode = {
  readonly __typename: "PaidFeaturesNode";
  readonly canCreateGoals?: Maybe<Scalars["Boolean"]["output"]>;
  readonly canCreateGroupGoals?: Maybe<Scalars["Boolean"]["output"]>;
  readonly canCreateOrgTemplates?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ParticipantStatusConnection = {
  readonly __typename: "ParticipantStatusConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ParticipantStatusEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `ParticipantStatus` and its cursor. */
export type ParticipantStatusEdge = {
  readonly __typename: "ParticipantStatusEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<ParticipantStatusNode>;
};

export type ParticipantStatusNode = {
  readonly __typename: "ParticipantStatusNode";
  readonly calibrationStatus: ComplianceProgramParticipantStatus;
  readonly deliveryStatus: ComplianceProgramParticipantStatus;
  readonly engagementSurveyStatus: ComplianceProgramParticipantStatus;
  readonly managerAssessmentStatus: ComplianceProgramParticipantStatus;
  readonly managerSelfAssessmentStatus: ComplianceProgramParticipantStatus;
  readonly meeting?: Maybe<MeetingNode>;
  readonly oneononeStatus: ComplianceProgramParticipantStatus;
  readonly peerAssessmentStatus: ComplianceProgramParticipantStatus;
  readonly peerSelfAssessmentStatus: ComplianceProgramParticipantStatus;
  readonly performanceAssessmentStatus: ComplianceProgramParticipantStatus;
  readonly performanceSelfAssessmentStatus: ComplianceProgramParticipantStatus;
  readonly user: UserNode;
};

export type PerformanceAssessmentAnswerFilter = {
  readonly integerAnswer: Scalars["Int"]["input"];
  readonly questionId: Scalars["Int"]["input"];
};

export type PerformanceAssessmentChartLabelInput = {
  readonly id?: InputMaybe<Scalars["Int"]["input"]>;
  readonly label: Scalars["String"]["input"];
  readonly questionOneId: Scalars["Int"]["input"];
  readonly questionOneIntegerAnswer: Scalars["Int"]["input"];
  readonly questionTwoId?: InputMaybe<Scalars["Int"]["input"]>;
  readonly questionTwoIntegerAnswer?: InputMaybe<Scalars["Int"]["input"]>;
};

export type PerformanceAssessmentChartLabelNode = DjangoNode &
  Node & {
    readonly __typename: "PerformanceAssessmentChartLabelNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly id: Scalars["ID"]["output"];
    readonly label: Scalars["String"]["output"];
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly questionOne: AssessmentQuestionInterface;
    readonly questionOneIntegerAnswer: Scalars["Int"]["output"];
    readonly questionTwo?: Maybe<AssessmentQuestionInterface>;
    readonly questionTwoIntegerAnswer?: Maybe<Scalars["Int"]["output"]>;
  };

export type PerformanceAssessmentChartLabelNodeConnection = {
  readonly __typename: "PerformanceAssessmentChartLabelNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<PerformanceAssessmentChartLabelNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `PerformanceAssessmentChartLabelNode` and its cursor. */
export type PerformanceAssessmentChartLabelNodeEdge = {
  readonly __typename: "PerformanceAssessmentChartLabelNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<PerformanceAssessmentChartLabelNode>;
};

export type PerformanceReviewReportRowConnection = {
  readonly __typename: "PerformanceReviewReportRowConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<PerformanceReviewReportRowEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `PerformanceReviewReportRow` and its cursor. */
export type PerformanceReviewReportRowEdge = {
  readonly __typename: "PerformanceReviewReportRowEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<PerformanceReviewReportRowNode>;
};

export type PerformanceReviewReportRowNode = {
  readonly __typename: "PerformanceReviewReportRowNode";
  readonly assessment?: Maybe<AssessmentNode>;
  readonly calibrationStatus: ComplianceProgramCalibrationStatus;
  readonly canCalibrateAnswer: PermissionNode;
  readonly canSuggestAnswer: PermissionNode;
  readonly complianceProgramId: Scalars["Int"]["output"];
  readonly id: Scalars["Int"]["output"];
  readonly position?: Maybe<Scalars["String"]["output"]>;
  readonly roles: ReadonlyArray<CareerTrackRoleNode>;
  readonly targetAddedToProgramOn?: Maybe<Scalars["DateTime"]["output"]>;
  readonly user: UserNode;
};

export type PermissionNode = {
  readonly __typename: "PermissionNode";
  readonly permission: Scalars["Boolean"]["output"];
  readonly reason: Scalars["String"]["output"];
};

export enum PersonalTranscriptSyncCredentialProviderEnum {
  Fireflies = "fireflies",
  Granola = "granola",
}

/** A single date's planned outcome in a preview. Resolved from a PlannedImportMeeting dataclass. */
export type PlannedImportMeetingNode = {
  readonly __typename: "PlannedImportMeetingNode";
  readonly action: ImportMeetingAction;
  readonly date: Scalars["Date"]["output"];
  /** The matched existing 1-on-1, if any */
  readonly existingMeeting?: Maybe<MeetingNode>;
  readonly topics?: Maybe<ReadonlyArray<Maybe<PlannedImportTopicNode>>>;
};

/** A topic the import plans to add for a date. Resolved from the (title, notes) dataclass. */
export type PlannedImportTopicNode = {
  readonly __typename: "PlannedImportTopicNode";
  /** Topic notes in markdown */
  readonly notes?: Maybe<Scalars["String"]["output"]>;
  readonly title?: Maybe<Scalars["String"]["output"]>;
};

export type PlatformSkillType = {
  readonly __typename: "PlatformSkillType";
  readonly body: Scalars["String"]["output"];
  readonly canArchive: Scalars["Boolean"]["output"];
  readonly canEdit: Scalars["Boolean"]["output"];
  readonly description: Scalars["String"]["output"];
  readonly id: Scalars["String"]["output"];
  readonly isScheduled: Scalars["Boolean"]["output"];
  readonly name: Scalars["String"]["output"];
  readonly overridesSource: SkillOverrideSourceEnum;
  readonly scheduleKind?: Maybe<ScheduleKindEnum>;
  readonly shadowedCount: Scalars["Int"]["output"];
  readonly slug: Scalars["String"]["output"];
  readonly visibility: SkillVisibilityEnum;
};

export type PrepareFileUploadMutation = {
  readonly __typename: "PrepareFileUploadMutation";
  readonly artifact?: Maybe<ArtifactInterface>;
  /** The URL to upload the file to */
  readonly fileUploadUrl?: Maybe<Scalars["String"]["output"]>;
  /** The URL that will return the file to a user */
  readonly fileViewingUrl?: Maybe<Scalars["String"]["output"]>;
  readonly organization?: Maybe<OrganizationNode>;
  readonly recognitionCoreValue?: Maybe<RecognitionCoreValueNode>;
  readonly topic?: Maybe<TopicNode>;
};

/**
 * Phase 1 of the bulk 1-on-1 import: parse + AI-split + classify, WITHOUT writing anything.
 *
 * Returns an editable plan the frontend renders; the edited plan is sent to importOneononeNotes.
 */
export type PreviewImportOneononeNotesMutation = {
  readonly __typename: "PreviewImportOneononeNotesMutation";
  /** The per-date import plan, in document order */
  readonly plan?: Maybe<ReadonlyArray<Maybe<PlannedImportMeetingNode>>>;
};

/** An enumeration. */
export enum PricingTier {
  Free = "free",
  Pro = "pro",
  Ultimate = "ultimate",
}

export type PrivateNoteNode = DjangoNode &
  Node & {
    readonly __typename: "PrivateNoteNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator?: Maybe<UserNode>;
    readonly id: Scalars["ID"]["output"];
    readonly notes?: Maybe<Scalars["JSONString"]["output"]>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly profile: UserNode;
    readonly updated: Scalars["DateTime"]["output"];
  };

export type PrivateNoteNodeConnection = {
  readonly __typename: "PrivateNoteNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<PrivateNoteNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `PrivateNoteNode` and its cursor. */
export type PrivateNoteNodeEdge = {
  readonly __typename: "PrivateNoteNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<PrivateNoteNode>;
};

/** One summary line — an insight or an activity — with the sources it draws on. */
export type ProfileSummaryLineNode = {
  readonly __typename: "ProfileSummaryLineNode";
  readonly id: Scalars["String"]["output"];
  readonly sources: ReadonlyArray<ProfileSummarySourceNode>;
  readonly text: Scalars["String"]["output"];
};

/** A single raw activity that a summary line draws on (rendered as a chip). */
export type ProfileSummarySourceNode = {
  readonly __typename: "ProfileSummarySourceNode";
  readonly detail?: Maybe<Scalars["String"]["output"]>;
  readonly id: Scalars["String"]["output"];
  readonly isExternal: Scalars["Boolean"]["output"];
  readonly provider: Scalars["String"]["output"];
  readonly timestamp?: Maybe<Scalars["String"]["output"]>;
  readonly title: Scalars["String"]["output"];
  readonly type: Scalars["String"]["output"];
  readonly url?: Maybe<Scalars["String"]["output"]>;
};

export type ProfileWeeklySummaryNode = {
  readonly __typename: "ProfileWeeklySummaryNode";
  readonly activity: ReadonlyArray<ProfileSummaryLineNode>;
  readonly insights: ReadonlyArray<ProfileSummaryLineNode>;
  readonly subjectName: Scalars["String"]["output"];
  readonly weekEnd: Scalars["Date"]["output"];
  readonly weekOffset: Scalars["Int"]["output"];
  readonly weekStart: Scalars["Date"]["output"];
};

export type ProgramAppliesToUpdatesNode = {
  readonly __typename: "ProgramAppliesToUpdatesNode";
  readonly hasUpdates: Scalars["Boolean"]["output"];
  readonly rolesToChange: ReadonlyArray<RoleChangeUserNode>;
  readonly usersToAdd: ReadonlyArray<UserNode>;
  readonly usersToRemove: ReadonlyArray<UserNode>;
};

export type ProgramScheduledReminderInput = {
  readonly daysAfterStartDate: Scalars["Int"]["input"];
  readonly emailNotification: Scalars["Boolean"]["input"];
  readonly engagementSurvey: Scalars["Boolean"]["input"];
  readonly id?: InputMaybe<Scalars["Int"]["input"]>;
  readonly managerAssessment: Scalars["Boolean"]["input"];
  readonly message?: InputMaybe<Scalars["String"]["input"]>;
  readonly nominations: Scalars["Boolean"]["input"];
  readonly oneonone: Scalars["Boolean"]["input"];
  readonly peerAssessment: Scalars["Boolean"]["input"];
  readonly performanceAssessment: Scalars["Boolean"]["input"];
  readonly performanceSelfAssessment: Scalars["Boolean"]["input"];
  readonly slackNotification: Scalars["Boolean"]["input"];
  readonly teamsNotification?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type Query = {
  readonly __typename: "Query";
  readonly adoptionReport: ReportResponseNode;
  readonly aiSkillsOverview: ReadonlyArray<SearchSkillResult>;
  readonly allCalibrationGroups: CalibrationGroupNodeConnection;
  readonly artifact: ArtifactInterface;
  readonly artifacts?: Maybe<ArtifactConnection>;
  readonly asanaTaskPreview?: Maybe<AsanaTaskPreviewNode>;
  readonly askAiCitationSources: ReadonlyArray<AnswerCitationNode>;
  readonly assessment?: Maybe<AssessmentNode>;
  readonly assessmentAnswer?: Maybe<AssessmentAnswerInterface>;
  readonly assessmentCalibrations?: Maybe<AssessmentAnswerCalibrationConnection>;
  readonly assessmentDeliveries: AssessmentDeliveryNodeConnection;
  readonly assessmentDelivery?: Maybe<AssessmentDeliveryNode>;
  readonly assessmentGroup?: Maybe<AssessmentGroupNode>;
  readonly assessmentGroups: AssessmentGroupNodeConnection;
  readonly assessmentQuestion?: Maybe<AssessmentQuestionInterface>;
  readonly assessmentQuestionCategories: AssessmentQuestionCategoryNodeConnection;
  readonly assessmentQuestions?: Maybe<AssessmentQuestionConnection>;
  readonly assessments: AssessmentNodeConnection;
  readonly assessmentsOpenForNominations: AssessmentOpenForNominationConnection;
  readonly assignableUsers?: Maybe<UserNodeConnection>;
  /** List of all available Topicflow enabled Merge.dev integrations */
  readonly availableMergeIntegrations: ReadonlyArray<
    Maybe<AvailableMergeIntegrationType>
  >;
  readonly basicGoal: BasicGoalArtifactNode;
  /** Reveal goals that user should be aware of if aligned to their goal but that don't provide sensitive informations */
  readonly basicGoals?: Maybe<BasicGoalArtifactNodeConnection>;
  readonly calendar?: Maybe<BasicMeetingNodeConnection>;
  readonly calibrationGroups: CalibrationGroupNodeConnection;
  readonly careerRole?: Maybe<CareerTrackRoleNode>;
  readonly careerRoles: CareerTrackRoleNodeConnection;
  readonly careerTrack?: Maybe<CareerTrackNode>;
  readonly careerTracks: CareerTrackNodeConnection;
  readonly chatSession?: Maybe<ChatSessionNode>;
  readonly chatSessions?: Maybe<ChatSessionNodeConnection>;
  readonly coachingReport?: Maybe<CoachingReportNode>;
  readonly comment?: Maybe<CommentNode>;
  readonly comments?: Maybe<CommentNodeConnection>;
  readonly competencies: CompetencyConnection;
  readonly competency?: Maybe<CompetencyNode>;
  readonly complianceProgram?: Maybe<ComplianceProgramNode>;
  readonly complianceProgramReportingViews: ComplianceProgramReportingViewNodeConnection;
  readonly compliancePrograms: ComplianceProgramNodeConnection;
  readonly detailedCompliancePrograms: ComplianceProgramNodeConnection;
  readonly engagementSurveyDeliveries: AssessmentDeliveryNodeConnection;
  readonly feed?: Maybe<ReadonlyArray<Maybe<FeedNode>>>;
  readonly flow?: Maybe<FlowNode>;
  readonly flows?: Maybe<FlowNodeConnection>;
  readonly githubSearch?: Maybe<InfoCardConnection>;
  readonly goalsForUser?: Maybe<GoalArtifactConnection>;
  readonly hubspotPipelineStages?: Maybe<HubspotStageConnection>;
  /** Past note-less, transcript-less formal 1-on-1s the current user can fill via import */
  readonly importOneononeCandidates?: Maybe<ReadonlyArray<Maybe<MeetingNode>>>;
  readonly invitation?: Maybe<InvitationNode>;
  readonly jiraSearch?: Maybe<InfoCardConnection>;
  readonly kpi?: Maybe<KpiNode>;
  readonly kpiGroup?: Maybe<KpiGroupNode>;
  readonly kpiGroups?: Maybe<KpiGroupNodeConnection>;
  readonly kpis?: Maybe<KpiNodeConnection>;
  readonly loggedIn?: Maybe<Scalars["Boolean"]["output"]>;
  readonly me?: Maybe<UserNode>;
  readonly meeting?: Maybe<MeetingNode>;
  readonly meetingGroup?: Maybe<MeetingGroupNode>;
  readonly meetingGroups?: Maybe<MeetingGroupNodeConnection>;
  readonly meetings?: Maybe<MeetingNodeConnection>;
  readonly meetingsByManagerReport?: Maybe<MeetingsByManagerReportConnection>;
  readonly mergeDevIntegrations: ReadonlyArray<Maybe<MergeDevIntegrationNode>>;
  readonly mySkills: ReadonlyArray<SkillNode>;
  readonly organization?: Maybe<OrganizationNode>;
  /** Feedback requests that have been sent to someone else and not yet answered */
  readonly pendingFeedbackRequests?: Maybe<BasicFeedbackArtifactNodeConnection>;
  readonly performanceAssessmentChartLabels: PerformanceAssessmentChartLabelNodeConnection;
  readonly platformSkills: ReadonlyArray<PlatformSkillType>;
  readonly profileWeeklySummary?: Maybe<ProfileWeeklySummaryNode>;
  readonly rating?: Maybe<RatingNode>;
  readonly ratings?: Maybe<RatingNodeConnection>;
  readonly relationshipWithUser?: Maybe<RelationshipNode>;
  readonly routines: ReadonlyArray<RoutineNode>;
  readonly search?: Maybe<SearchConnection>;
  readonly searchSkills: ReadonlyArray<SearchSkillResult>;
  readonly skills: ReadonlyArray<ChatbotSkillType>;
  readonly slackNotificationsForOrg?: Maybe<SlackNotificationForChannelNodeConnection>;
  readonly talentIndicators: TalentIndicatorNodeConnection;
  readonly team?: Maybe<TeamNode>;
  readonly teams: TeamNodeConnection;
  readonly topic?: Maybe<TopicNode>;
  readonly topicTemplate?: Maybe<TopicTemplateNode>;
  readonly topicTemplateCategories: TemplateCategoryNodeConnection;
  readonly topicTemplateCategory?: Maybe<TemplateCategoryNode>;
  readonly topicTemplates?: Maybe<TopicTemplateNodeConnection>;
  readonly topics?: Maybe<TopicNodeConnection>;
  readonly trendReport: ReadonlyArray<Maybe<ReportingChartNode>>;
  readonly unmetManagerEffectivenessCompliancePrograms: ComplianceProgramNodeConnection;
  readonly unmetPeerAssessmentCompliancePrograms: ComplianceProgramNodeConnection;
  readonly unmetPerformanceAssessmentCompliancePrograms: ComplianceProgramNodeConnection;
  readonly urlToInfoCard: InfoCardInterface;
  readonly user?: Maybe<UserNode>;
  readonly users: UserNodeConnection;
  readonly workHistory?: Maybe<WorkHistorySummaryNode>;
  readonly workflow?: Maybe<WorkflowNode>;
  readonly workflows?: Maybe<WorkflowNodeConnection>;
  readonly workspaceSkills: ReadonlyArray<SkillNode>;
};

export type QueryAdoptionReportArgs = {
  attributes: ReadonlyArray<InputMaybe<AdoptionReportAttribute>>;
  filters: ReadonlyArray<InputMaybe<ReportFilterInput>>;
  metrics: ReadonlyArray<InputMaybe<AdoptionReportMetric>>;
  organizationId: Scalars["Int"]["input"];
};

export type QueryAiSkillsOverviewArgs = {
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryAllCalibrationGroupsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filterByCompletion?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  onlyValidPrograms?: InputMaybe<Scalars["Boolean"]["input"]>;
  organizationId: Scalars["Int"]["input"];
};

export type QueryArtifactArgs = {
  artifactId: Scalars["Int"]["input"];
};

export type QueryArtifactsArgs = {
  actionItemAssignedToMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignees?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  actionItemDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  actionItemProgress?: InputMaybe<Scalars["Float"]["input"]>;
  actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemStates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  ancestorsOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  artifactTypes?: InputMaybe<ReadonlyArray<InputMaybe<ArtifactType>>>;
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  asUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  assignedToMembersOfOrganizationId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  completedActionItemsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedActionItemsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  createdByIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  createdInMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackSenders?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackState?: InputMaybe<FeedbackState>;
  feedbackStates?: InputMaybe<ReadonlyArray<InputMaybe<FeedbackState>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  goalCompetencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalContributors?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalInvolvingUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalParentIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalResponsibilityIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalScope?: InputMaybe<GoalScope>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalState?: InputMaybe<GoalState>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalStatus?: InputMaybe<GoalStatus>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalVisibility?: InputMaybe<GoalVisibility>;
  goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  groupBy?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  isStale?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValue?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionReceivedByMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryAsanaTaskPreviewArgs = {
  url: Scalars["String"]["input"];
};

export type QueryAskAiCitationSourcesArgs = {
  chatSessionId: Scalars["Int"]["input"];
  sourceIds: ReadonlyArray<Scalars["String"]["input"]>;
};

export type QueryAssessmentArgs = {
  assessmentId: Scalars["Int"]["input"];
};

export type QueryAssessmentAnswerArgs = {
  answerId: Scalars["Int"]["input"];
};

export type QueryAssessmentCalibrationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  complianceProgramId: Scalars["Int"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  isPrecalibration?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  targetId?: InputMaybe<Scalars["Int"]["input"]>;
  templateId: Scalars["Int"]["input"];
};

export type QueryAssessmentDeliveriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  complianceProgramId?: InputMaybe<Scalars["Int"]["input"]>;
  creatorId?: InputMaybe<Scalars["Int"]["input"]>;
  excludedProgramIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  state_In?: InputMaybe<ReadonlyArray<InputMaybe<AssessmentDeliveryState>>>;
  targetId?: InputMaybe<Scalars["Int"]["input"]>;
  targetIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type QueryAssessmentDeliveryArgs = {
  id: Scalars["IntOrString"]["input"];
};

export type QueryAssessmentGroupArgs = {
  assessmentGroupId: Scalars["Int"]["input"];
};

export type QueryAssessmentGroupsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  archived?: InputMaybe<Scalars["Boolean"]["input"]>;
  assessmentType?: InputMaybe<AssessmentType>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryAssessmentQuestionArgs = {
  questionId: Scalars["Int"]["input"];
};

export type QueryAssessmentQuestionCategoriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryAssessmentQuestionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  archived?: InputMaybe<Scalars["Boolean"]["input"]>;
  assessmentType?: InputMaybe<AssessmentType>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  category?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryAssessmentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assessmentType?: InputMaybe<AssessmentType>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  responderId?: InputMaybe<Scalars["Int"]["input"]>;
  selfAssessment?: InputMaybe<Scalars["Boolean"]["input"]>;
  state?: InputMaybe<AssessmentState>;
  targetId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryAssessmentsOpenForNominationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  complianceProgramId?: InputMaybe<Scalars["Int"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  targetId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryAssignableUsersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  artifactId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  topicId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryBasicGoalArgs = {
  artifactId: Scalars["Int"]["input"];
};

export type QueryBasicGoalsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryCalendarArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  draft?: InputMaybe<Scalars["Boolean"]["input"]>;
  endDatetime?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  excludeMeetingGroupIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  forUserId: Scalars["Int"]["input"];
  fromMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  ignored?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFinalized?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFormalOneonone?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  minimumDateRange?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Decimal"]["input"]>;
  participantCount?: InputMaybe<Scalars["Int"]["input"]>;
  participants?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  startDatetime?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  status?: InputMaybe<EventStatus>;
  status_In?: InputMaybe<ReadonlyArray<InputMaybe<EventStatus>>>;
  subject?: InputMaybe<Scalars["Int"]["input"]>;
  templateId?: InputMaybe<Scalars["Int"]["input"]>;
  unscheduled?: InputMaybe<Scalars["Boolean"]["input"]>;
  usingRequiredTemplateOfValidPrograms?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
};

export type QueryCalibrationGroupsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  complianceProgramId: Scalars["Int"]["input"];
  filterByCompletion?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  onlyValidPrograms?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryCareerRoleArgs = {
  id: Scalars["Int"]["input"];
};

export type QueryCareerRolesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId: Scalars["Int"]["input"];
};

export type QueryCareerTrackArgs = {
  id: Scalars["Int"]["input"];
};

export type QueryCareerTracksArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId: Scalars["Int"]["input"];
  teamId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryChatSessionArgs = {
  chatSessionId: Scalars["Int"]["input"];
};

export type QueryChatSessionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assessmentId?: InputMaybe<Scalars["Int"]["input"]>;
  assessmentQuestionId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  routineId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryCoachingReportArgs = {
  managerId: Scalars["Int"]["input"];
  subjectId: Scalars["Int"]["input"];
};

export type QueryCommentArgs = {
  commentId: Scalars["Int"]["input"];
};

export type QueryCommentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  artifactId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  isInlineComment?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  textUuid?: InputMaybe<Scalars["String"]["input"]>;
  topicId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryCompetenciesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId: Scalars["Int"]["input"];
};

export type QueryCompetencyArgs = {
  id: Scalars["Int"]["input"];
  roleId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryComplianceProgramArgs = {
  pk: Scalars["Int"]["input"];
};

export type QueryComplianceProgramReportingViewsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assessmentType: AssessmentType;
  before?: InputMaybe<Scalars["String"]["input"]>;
  complianceProgramId: Scalars["Int"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryComplianceProgramsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  applicableUser?: InputMaybe<Scalars["Int"]["input"]>;
  assessmentType?: InputMaybe<AssessmentType>;
  assessmentTypes?: InputMaybe<ReadonlyArray<InputMaybe<AssessmentType>>>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  dueDate?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate_Gt?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate_Gte?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate_Lt?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate_Lte?: InputMaybe<Scalars["Date"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  onlyActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<ComplianceProgramState>;
  state_In?: InputMaybe<ReadonlyArray<InputMaybe<ComplianceProgramState>>>;
};

export type QueryDetailedComplianceProgramsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  applicableUser?: InputMaybe<Scalars["Int"]["input"]>;
  assessmentType?: InputMaybe<AssessmentType>;
  assessmentTypes?: InputMaybe<ReadonlyArray<InputMaybe<AssessmentType>>>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  dueDate?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate_Gt?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate_Gte?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate_Lt?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate_Lte?: InputMaybe<Scalars["Date"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  onlyActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<ComplianceProgramState>;
  state_In?: InputMaybe<ReadonlyArray<InputMaybe<ComplianceProgramState>>>;
};

export type QueryEngagementSurveyDeliveriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  complianceProgramId?: InputMaybe<Scalars["Int"]["input"]>;
  creatorId?: InputMaybe<Scalars["Int"]["input"]>;
  excludedProgramIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  state_In?: InputMaybe<ReadonlyArray<InputMaybe<AssessmentDeliveryState>>>;
  targetId?: InputMaybe<Scalars["Int"]["input"]>;
  targetIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type QueryFeedArgs = {
  afterDatetime?: InputMaybe<Scalars["DateTime"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryFlowArgs = {
  flowId: Scalars["Int"]["input"];
};

export type QueryFlowsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGithubSearchArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  searchQuery: Scalars["String"]["input"];
};

export type QueryGoalsForUserArgs = {
  actionItemAssignedToMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignees?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  actionItemDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  actionItemProgress?: InputMaybe<Scalars["Float"]["input"]>;
  actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemStates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  ancestorsOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  artifactTypes?: InputMaybe<ReadonlyArray<InputMaybe<ArtifactType>>>;
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  asUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  assignedToMembersOfOrganizationId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  completedActionItemsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedActionItemsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  createdByIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  createdInMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackSenders?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackState?: InputMaybe<FeedbackState>;
  feedbackStates?: InputMaybe<ReadonlyArray<InputMaybe<FeedbackState>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  forUserId: Scalars["Int"]["input"];
  goalCompetencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalContributors?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalInvolvingUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalParentIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalResponsibilityIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalScope?: InputMaybe<GoalScope>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalState?: InputMaybe<GoalState>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalStatus?: InputMaybe<GoalStatus>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalVisibility?: InputMaybe<GoalVisibility>;
  goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  groupBy?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  isStale?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValue?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionReceivedByMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryHubspotPipelineStagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  forceRefresh?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryImportOneononeCandidatesArgs = {
  reportUserId: Scalars["Int"]["input"];
};

export type QueryInvitationArgs = {
  inviteKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryJiraSearchArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  jqlQuery: Scalars["String"]["input"];
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryKpiArgs = {
  kpiId: Scalars["Int"]["input"];
};

export type QueryKpiGroupArgs = {
  kpiGroupId: Scalars["Int"]["input"];
};

export type QueryKpiGroupsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryKpisArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  group?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryMeetingArgs = {
  afterMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  beforeMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  googleMeetUrl?: InputMaybe<Scalars["String"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryMeetingGroupArgs = {
  meetingGroupId: Scalars["Int"]["input"];
};

export type QueryMeetingGroupsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryMeetingsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  draft?: InputMaybe<Scalars["Boolean"]["input"]>;
  endDatetime?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  excludeMeetingGroupIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  fromMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  ignored?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFinalized?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFormalOneonone?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  minimumDateRange?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Decimal"]["input"]>;
  participantCount?: InputMaybe<Scalars["Int"]["input"]>;
  participants?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  startDatetime?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  status?: InputMaybe<EventStatus>;
  status_In?: InputMaybe<ReadonlyArray<InputMaybe<EventStatus>>>;
  subject?: InputMaybe<Scalars["Int"]["input"]>;
  templateId?: InputMaybe<Scalars["Int"]["input"]>;
  unscheduled?: InputMaybe<Scalars["Boolean"]["input"]>;
  usingRequiredTemplateOfValidPrograms?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
};

export type QueryMeetingsByManagerReportArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  personId?: InputMaybe<Scalars["Int"]["input"]>;
  templateId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryMergeDevIntegrationsArgs = {
  organizationId: Scalars["Int"]["input"];
};

export type QueryOrganizationArgs = {
  pk?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryPendingFeedbackRequestsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  createdByReportsOfUserId?: InputMaybe<Scalars["Int"]["input"]>;
  creatorId?: InputMaybe<Scalars["Int"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  recipientId?: InputMaybe<Scalars["Int"]["input"]>;
  recipientsOfManagerId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryPerformanceAssessmentChartLabelsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  questionIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type QueryPlatformSkillsArgs = {
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryProfileWeeklySummaryArgs = {
  userId: Scalars["Int"]["input"];
  weekOffset?: Scalars["Int"]["input"];
};

export type QueryRatingArgs = {
  ratingId: Scalars["Int"]["input"];
};

export type QueryRatingsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryRelationshipWithUserArgs = {
  organizationId: Scalars["Int"]["input"];
  otherUserId: Scalars["Int"]["input"];
};

export type QuerySearchArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  options?: InputMaybe<SearchOptions>;
  searchTerm: Scalars["String"]["input"];
};

export type QuerySearchSkillsArgs = {
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QuerySlackNotificationsForOrgArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId: Scalars["Int"]["input"];
};

export type QueryTalentIndicatorsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId: Scalars["Int"]["input"];
};

export type QueryTeamArgs = {
  teamId: Scalars["Int"]["input"];
};

export type QueryTeamsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organization?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  title_Startswith?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryTopicArgs = {
  topicId: Scalars["Int"]["input"];
};

export type QueryTopicTemplateArgs = {
  topicTemplateId: Scalars["Int"]["input"];
};

export type QueryTopicTemplateCategoriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  title_Contains?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryTopicTemplateCategoryArgs = {
  categoryId: Scalars["Int"]["input"];
};

export type QueryTopicTemplatesArgs = {
  adhocTemplate?: InputMaybe<Scalars["Boolean"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  globalTemplate?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasRequirements?: InputMaybe<Scalars["Boolean"]["input"]>;
  includesRatingId?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  publicTemplate?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryTopicsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assignee?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasActionItems?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasArtifacts?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDecisions?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDocuments?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasGoals?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInFlowId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInMeetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<TopicState>;
  titleContains?: InputMaybe<Scalars["String"]["input"]>;
  topicIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type QueryTrendReportArgs = {
  endDate?: InputMaybe<Scalars["Date"]["input"]>;
  groupBy?: InputMaybe<TrendReportGroupBy>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  organizationId: Scalars["Int"]["input"];
  reportType: TrendReportType;
  startDate?: InputMaybe<Scalars["Date"]["input"]>;
  talentIndicatorId: Scalars["Int"]["input"];
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type QueryUnmetManagerEffectivenessComplianceProgramsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  applicableUser?: InputMaybe<Scalars["Int"]["input"]>;
  assessmentType?: InputMaybe<AssessmentType>;
  assessmentTypes?: InputMaybe<ReadonlyArray<InputMaybe<AssessmentType>>>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  dueDate?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate_Gt?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate_Gte?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate_Lt?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate_Lte?: InputMaybe<Scalars["Date"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  onlyActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<ComplianceProgramState>;
  state_In?: InputMaybe<ReadonlyArray<InputMaybe<ComplianceProgramState>>>;
};

export type QueryUnmetPeerAssessmentComplianceProgramsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  applicableUser?: InputMaybe<Scalars["Int"]["input"]>;
  assessmentType?: InputMaybe<AssessmentType>;
  assessmentTypes?: InputMaybe<ReadonlyArray<InputMaybe<AssessmentType>>>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  dueDate?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate_Gt?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate_Gte?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate_Lt?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate_Lte?: InputMaybe<Scalars["Date"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  onlyActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<ComplianceProgramState>;
  state_In?: InputMaybe<ReadonlyArray<InputMaybe<ComplianceProgramState>>>;
};

export type QueryUnmetPerformanceAssessmentComplianceProgramsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  applicableUser?: InputMaybe<Scalars["Int"]["input"]>;
  assessmentType?: InputMaybe<AssessmentType>;
  assessmentTypes?: InputMaybe<ReadonlyArray<InputMaybe<AssessmentType>>>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  dueDate?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate_Gt?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate_Gte?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate_Lt?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate_Lte?: InputMaybe<Scalars["Date"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  onlyActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<ComplianceProgramState>;
  state_In?: InputMaybe<ReadonlyArray<InputMaybe<ComplianceProgramState>>>;
};

export type QueryUrlToInfoCardArgs = {
  forceRefresh?: InputMaybe<Scalars["Boolean"]["input"]>;
  url: Scalars["String"]["input"];
};

export type QueryUserArgs = {
  userId: Scalars["Int"]["input"];
};

export type QueryUsersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  includeDeactivated?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type QueryWorkHistoryArgs = {
  end: Scalars["Date"]["input"];
  forceDateFilter?: InputMaybe<Scalars["Boolean"]["input"]>;
  generateIfMissing?: InputMaybe<Scalars["Boolean"]["input"]>;
  organizationId: Scalars["Int"]["input"];
  start: Scalars["Date"]["input"];
  userId: Scalars["Int"]["input"];
};

export type QueryWorkflowArgs = {
  workflowId: Scalars["Int"]["input"];
};

export type QueryWorkflowsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryWorkspaceSkillsArgs = {
  organizationId: Scalars["Int"]["input"];
};

export type RangeAssessmentAnswerCalibrationNode =
  AssessmentAnswerCalibrationInterface & {
    readonly __typename: "RangeAssessmentAnswerCalibrationNode";
    readonly answerId?: Maybe<Scalars["Int"]["output"]>;
    readonly canDelete: PermissionNode;
    readonly canRead: PermissionNode;
    readonly canUpdate: PermissionNode;
    readonly comment?: Maybe<Scalars["JSONString"]["output"]>;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator?: Maybe<UserNode>;
    readonly id: Scalars["Int"]["output"];
    readonly integerAnswer?: Maybe<Scalars["Int"]["output"]>;
    readonly isPrecalibration: Scalars["Boolean"]["output"];
    readonly isSuggestion: Scalars["Boolean"]["output"];
    readonly prevIntegerAnswer?: Maybe<Scalars["Int"]["output"]>;
    readonly question: AssessmentQuestionInterface;
    readonly target?: Maybe<UserNode>;
    readonly updated: Scalars["DateTime"]["output"];
  };

export type RangeAssessmentAnswerNode = AssessmentAnswerInterface & {
  readonly __typename: "RangeAssessmentAnswerNode";
  readonly assessment: AssessmentNode;
  readonly calibrations: AssessmentAnswerCalibrationConnection;
  readonly canDelete: PermissionNode;
  readonly canRead: PermissionNode;
  readonly canUpdate: PermissionNode;
  readonly comment?: Maybe<Scalars["JSONString"]["output"]>;
  readonly created: Scalars["DateTime"]["output"];
  readonly hasCalibrationSuggestions: Scalars["Boolean"]["output"];
  readonly hasCalibrations: Scalars["Boolean"]["output"];
  readonly id: Scalars["Int"]["output"];
  readonly integerAnswer?: Maybe<Scalars["Int"]["output"]>;
  readonly isLocked: Scalars["Boolean"]["output"];
  readonly question: AssessmentQuestionInterface;
  readonly questionId: Scalars["Int"]["output"];
  readonly responder?: Maybe<UserNode>;
  readonly updated: Scalars["DateTime"]["output"];
};

export type RangeAssessmentAnswerNodeCalibrationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RangeAssessmentQuestionNode = AssessmentQuestionInterface & {
  readonly __typename: "RangeAssessmentQuestionNode";
  readonly answers: AssessmentAnswerConnection;
  readonly answersExist: Scalars["Boolean"]["output"];
  readonly archived: Scalars["Boolean"]["output"];
  readonly canDelete: PermissionNode;
  readonly canRead: PermissionNode;
  readonly canUpdate: PermissionNode;
  readonly categories: AssessmentQuestionCategoryNodeConnection;
  readonly comment: AssessmentQuestionComment;
  readonly created: Scalars["DateTime"]["output"];
  readonly creator?: Maybe<UserNode>;
  readonly description?: Maybe<Scalars["JSONString"]["output"]>;
  readonly endValue: Scalars["Int"]["output"];
  readonly id: Scalars["Int"]["output"];
  readonly isResponseMandatory: Scalars["Boolean"]["output"];
  readonly labelDescriptions: ReadonlyArray<Maybe<Scalars["String"]["output"]>>;
  readonly labels: ReadonlyArray<Maybe<Scalars["String"]["output"]>>;
  readonly organization: OrganizationNode;
  readonly questionType: AssessmentQuestionType;
  readonly responseVisibility: AssessmentQuestionResponseVisibility;
  readonly responses: AssessmentQuestionResponses;
  readonly startValue: Scalars["Int"]["output"];
  readonly title: Scalars["String"]["output"];
  readonly updated: Scalars["DateTime"]["output"];
};

export type RangeAssessmentQuestionNodeAnswersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RangeAssessmentQuestionNodeCategoriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RatingAnswerNode = DjangoNode &
  Node & {
    readonly __typename: "RatingAnswerNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly created: Scalars["DateTime"]["output"];
    readonly createdFromArtifact?: Maybe<RatingArtifactNode>;
    readonly createdInMeeting?: Maybe<MeetingNode>;
    readonly creator: UserNode;
    readonly id: Scalars["ID"]["output"];
    readonly integerAnswer: Scalars["Int"]["output"];
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly rating?: Maybe<RatingNode>;
    readonly updated: Scalars["DateTime"]["output"];
  };

export type RatingAnswerNodeConnection = {
  readonly __typename: "RatingAnswerNodeConnection";
  readonly averageRating?: Maybe<Scalars["Float"]["output"]>;
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<RatingAnswerNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `RatingAnswerNode` and its cursor. */
export type RatingAnswerNodeEdge = {
  readonly __typename: "RatingAnswerNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<RatingAnswerNode>;
};

export type RatingArtifactNode = ArtifactInterface & {
  readonly __typename: "RatingArtifactNode";
  readonly activities: ArtifactActivityNodeConnection;
  readonly answers?: Maybe<RatingAnswerNodeConnection>;
  readonly artifactType: ArtifactType;
  readonly assignableUsers?: Maybe<UserNodeConnection>;
  readonly canAnswer?: Maybe<Scalars["Boolean"]["output"]>;
  readonly canDelete: PermissionNode;
  readonly canRead: PermissionNode;
  readonly canUpdate: PermissionNode;
  readonly canViewAnswers?: Maybe<Scalars["Boolean"]["output"]>;
  readonly commentCount?: Maybe<Scalars["Int"]["output"]>;
  readonly comments?: Maybe<CommentNodeConnection>;
  readonly created: Scalars["DateTime"]["output"];
  readonly createdInMeeting?: Maybe<MeetingNode>;
  readonly creator?: Maybe<UserNode>;
  readonly description?: Maybe<Scalars["JSONString"]["output"]>;
  readonly eventChannelName?: Maybe<Scalars["String"]["output"]>;
  readonly id: Scalars["Int"]["output"];
  readonly isStale: Scalars["Boolean"]["output"];
  readonly organization?: Maybe<OrganizationNode>;
  readonly rating?: Maybe<RatingNode>;
  readonly relatedArtifacts?: Maybe<ArtifactToArtifactConnection>;
  readonly title?: Maybe<Scalars["String"]["output"]>;
  readonly topics?: Maybe<ArtifactToTopicConnection>;
  readonly updated?: Maybe<Scalars["DateTime"]["output"]>;
  readonly uuid?: Maybe<Scalars["String"]["output"]>;
  readonly websocketToken?: Maybe<Scalars["String"]["output"]>;
};

export type RatingArtifactNodeActivitiesArgs = {
  activityType?: InputMaybe<ArtifactActivityType>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RatingArtifactNodeAnswersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  creator?: InputMaybe<Scalars["Int"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
};

export type RatingArtifactNodeAssignableUsersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type RatingArtifactNodeCommentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  artifactId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  isInlineComment?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  textUuid?: InputMaybe<Scalars["String"]["input"]>;
  topicId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RatingArtifactNodeRelatedArtifactsArgs = {
  actionItemAssignedToMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignees?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  actionItemDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  actionItemProgress?: InputMaybe<Scalars["Float"]["input"]>;
  actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemStates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  ancestorsOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  artifactTypes?: InputMaybe<ReadonlyArray<InputMaybe<ArtifactType>>>;
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  asUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  assignedToMembersOfOrganizationId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  completedActionItemsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedActionItemsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  createdByIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  createdInMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackSenders?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackState?: InputMaybe<FeedbackState>;
  feedbackStates?: InputMaybe<ReadonlyArray<InputMaybe<FeedbackState>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  goalCompetencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalContributors?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalInvolvingUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalParentIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalResponsibilityIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalScope?: InputMaybe<GoalScope>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalState?: InputMaybe<GoalState>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalStatus?: InputMaybe<GoalStatus>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalVisibility?: InputMaybe<GoalVisibility>;
  goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  groupBy?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  isStale?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValue?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionReceivedByMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RatingArtifactNodeTopicsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assignee?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasActionItems?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasArtifacts?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDecisions?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDocuments?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasGoals?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInFlowId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInMeetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<TopicState>;
  titleContains?: InputMaybe<Scalars["String"]["input"]>;
  topicIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type RatingNode = DjangoNode &
  Node & {
    readonly __typename: "RatingNode";
    readonly answers?: Maybe<RatingAnswerNodeConnection>;
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator?: Maybe<UserNode>;
    readonly description: Scalars["JSONString"]["output"];
    readonly endValue: Scalars["Int"]["output"];
    readonly id: Scalars["ID"]["output"];
    readonly labels: ReadonlyArray<Maybe<Scalars["String"]["output"]>>;
    readonly organization?: Maybe<OrganizationNode>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly startValue: Scalars["Int"]["output"];
    readonly title: Scalars["String"]["output"];
    readonly updated: Scalars["DateTime"]["output"];
  };

export type RatingNodeAnswersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  creator?: InputMaybe<Scalars["Int"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
};

export type RatingNodeConnection = {
  readonly __typename: "RatingNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<RatingNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `RatingNode` and its cursor. */
export type RatingNodeEdge = {
  readonly __typename: "RatingNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<RatingNode>;
};

/** An enumeration. */
export enum RecallBotStatus {
  Done = "done",
  GeneratingSummary = "generating_summary",
  InMeeting = "in_meeting",
  JoiningMeeting = "joining_meeting",
  NotInMeeting = "not_in_meeting",
  Scheduled = "scheduled",
}

export type RecognitionArtifactNode = ArtifactInterface & {
  readonly __typename: "RecognitionArtifactNode";
  readonly activities: ArtifactActivityNodeConnection;
  readonly artifactType: ArtifactType;
  readonly assignableUsers?: Maybe<UserNodeConnection>;
  readonly canDelete: PermissionNode;
  readonly canRead: PermissionNode;
  readonly canUpdate: PermissionNode;
  readonly commentCount?: Maybe<Scalars["Int"]["output"]>;
  readonly comments?: Maybe<CommentNodeConnection>;
  readonly created: Scalars["DateTime"]["output"];
  readonly createdInMeeting?: Maybe<MeetingNode>;
  readonly creator?: Maybe<UserNode>;
  readonly description?: Maybe<Scalars["JSONString"]["output"]>;
  readonly eventChannelName?: Maybe<Scalars["String"]["output"]>;
  readonly id: Scalars["Int"]["output"];
  readonly isStale: Scalars["Boolean"]["output"];
  readonly organization?: Maybe<OrganizationNode>;
  readonly recipients?: Maybe<UserNodeConnection>;
  readonly recognitionCoreValue?: Maybe<RecognitionCoreValueNode>;
  readonly recognitionVisibility: RecognitionVisibility;
  readonly relatedArtifacts?: Maybe<ArtifactToArtifactConnection>;
  readonly title?: Maybe<Scalars["String"]["output"]>;
  readonly topics?: Maybe<ArtifactToTopicConnection>;
  readonly updated?: Maybe<Scalars["DateTime"]["output"]>;
  readonly uuid?: Maybe<Scalars["String"]["output"]>;
  readonly websocketToken?: Maybe<Scalars["String"]["output"]>;
};

export type RecognitionArtifactNodeActivitiesArgs = {
  activityType?: InputMaybe<ArtifactActivityType>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RecognitionArtifactNodeAssignableUsersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type RecognitionArtifactNodeCommentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  artifactId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  isInlineComment?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  textUuid?: InputMaybe<Scalars["String"]["input"]>;
  topicId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RecognitionArtifactNodeRecipientsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type RecognitionArtifactNodeRelatedArtifactsArgs = {
  actionItemAssignedToMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignees?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  actionItemDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  actionItemProgress?: InputMaybe<Scalars["Float"]["input"]>;
  actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemStates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  ancestorsOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  artifactTypes?: InputMaybe<ReadonlyArray<InputMaybe<ArtifactType>>>;
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  asUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  assignedToMembersOfOrganizationId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  completedActionItemsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedActionItemsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  createdByIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  createdInMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackSenders?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackState?: InputMaybe<FeedbackState>;
  feedbackStates?: InputMaybe<ReadonlyArray<InputMaybe<FeedbackState>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  goalCompetencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalContributors?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalInvolvingUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalParentIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalResponsibilityIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalScope?: InputMaybe<GoalScope>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalState?: InputMaybe<GoalState>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalStatus?: InputMaybe<GoalStatus>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalVisibility?: InputMaybe<GoalVisibility>;
  goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  groupBy?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  isStale?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValue?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionReceivedByMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RecognitionArtifactNodeTopicsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assignee?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasActionItems?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasArtifacts?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDecisions?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDocuments?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasGoals?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInFlowId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInMeetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<TopicState>;
  titleContains?: InputMaybe<Scalars["String"]["input"]>;
  topicIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type RecognitionCoreValueNode = DjangoNode &
  Node & {
    readonly __typename: "RecognitionCoreValueNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly description: Scalars["String"]["output"];
    readonly emoji?: Maybe<Scalars["String"]["output"]>;
    readonly id: Scalars["ID"]["output"];
    readonly image?: Maybe<Scalars["String"]["output"]>;
    readonly organization?: Maybe<OrganizationNode>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly recognitions?: Maybe<ArtifactConnection>;
    readonly status?: Maybe<RecognitionCoreValueStatus>;
    readonly title: Scalars["String"]["output"];
  };

export type RecognitionCoreValueNodeRecognitionsArgs = {
  actionItemAssignedToMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignees?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  actionItemDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  actionItemProgress?: InputMaybe<Scalars["Float"]["input"]>;
  actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemStates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  ancestorsOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  artifactTypes?: InputMaybe<ReadonlyArray<InputMaybe<ArtifactType>>>;
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  asUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  assignedToMembersOfOrganizationId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  completedActionItemsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedActionItemsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  createdByIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  createdInMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackSenders?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackState?: InputMaybe<FeedbackState>;
  feedbackStates?: InputMaybe<ReadonlyArray<InputMaybe<FeedbackState>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  goalCompetencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalContributors?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalInvolvingUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalParentIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalResponsibilityIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalScope?: InputMaybe<GoalScope>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalState?: InputMaybe<GoalState>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalStatus?: InputMaybe<GoalStatus>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalVisibility?: InputMaybe<GoalVisibility>;
  goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  groupBy?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  isStale?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValue?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionReceivedByMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RecognitionCoreValueNodeConnection = {
  readonly __typename: "RecognitionCoreValueNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<RecognitionCoreValueNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `RecognitionCoreValueNode` and its cursor. */
export type RecognitionCoreValueNodeEdge = {
  readonly __typename: "RecognitionCoreValueNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<RecognitionCoreValueNode>;
};

/** An enumeration. */
export enum RecognitionCoreValueStatus {
  Active = "active",
  Inactive = "inactive",
}

export type RecognitionStatsNode = {
  readonly __typename: "RecognitionStatsNode";
  readonly recognitionCount?: Maybe<Scalars["Int"]["output"]>;
  readonly userWhoGaveMostRecognition?: Maybe<UserNode>;
  readonly userWhoGaveMostRecognitionCount?: Maybe<Scalars["Int"]["output"]>;
  readonly userWhoReceivedMostRecognition?: Maybe<UserNode>;
  readonly userWhoReceivedMostRecognitionCount?: Maybe<
    Scalars["Int"]["output"]
  >;
};

/** An enumeration. */
export enum RecognitionVisibility {
  Private = "private",
  Public = "public",
}

export type RegenerateQuestionAnswer = {
  readonly __typename: "RegenerateQuestionAnswer";
  readonly assessment?: Maybe<AssessmentNode>;
  readonly success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type RelationshipConnection = {
  readonly __typename: "RelationshipConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<RelationshipEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `Relationship` and its cursor. */
export type RelationshipEdge = {
  readonly __typename: "RelationshipEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<RelationshipNode>;
};

export type RelationshipInput = {
  readonly firstName?: InputMaybe<Scalars["String"]["input"]>;
  readonly lastName?: InputMaybe<Scalars["String"]["input"]>;
  readonly otherUserId: Scalars["Int"]["input"];
  readonly relationshipType: RelationshipType;
};

export type RelationshipNode = DjangoNode &
  Node & {
    readonly __typename: "RelationshipNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator?: Maybe<UserNode>;
    readonly id: Scalars["ID"]["output"];
    readonly isPrimaryRelationship: Scalars["Boolean"]["output"];
    readonly lastUpdatedBy?: Maybe<UserNode>;
    readonly meetingFrequency?: Maybe<FrequencyNode>;
    readonly organization?: Maybe<OrganizationNode>;
    readonly otherUser?: Maybe<UserNode>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly primaryRelationshipType?: Maybe<RelationshipType>;
    readonly primaryUser?: Maybe<UserNode>;
    readonly relationshipWithOtherUser?: Maybe<RelationshipType>;
    readonly secondaryUser?: Maybe<UserNode>;
    readonly updated: Scalars["DateTime"]["output"];
  };

export type RelationshipNodeOtherUserArgs = {
  forUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RelationshipNodeRelationshipWithOtherUserArgs = {
  forUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RelationshipNodeConnection = {
  readonly __typename: "RelationshipNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<RelationshipNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `RelationshipNode` and its cursor. */
export type RelationshipNodeEdge = {
  readonly __typename: "RelationshipNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<RelationshipNode>;
};

/** An enumeration. */
export enum RelationshipType {
  ManagedBy = "managed_by",
  Manages = "manages",
  MentoredBy = "mentored_by",
  Mentors = "mentors",
}

export type RelevantSectionNode = {
  readonly __typename: "RelevantSectionNode";
  readonly sectionId?: Maybe<Scalars["Int"]["output"]>;
  readonly sectionType?: Maybe<SectionDelimiterType>;
};

/** Create a new Magic Link token for re-linking an existing Merge.dev integration */
export type RelinkMergeDevIntegration = {
  readonly __typename: "RelinkMergeDevIntegration";
  readonly endUserOriginId?: Maybe<Scalars["String"]["output"]>;
  readonly error?: Maybe<Scalars["String"]["output"]>;
  readonly integrationName?: Maybe<Scalars["String"]["output"]>;
  readonly linkToken?: Maybe<Scalars["String"]["output"]>;
  readonly success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type RemoveAsanaIntegrationMutation = {
  readonly __typename: "RemoveAsanaIntegrationMutation";
  readonly user?: Maybe<UserNode>;
};

export type RemoveBotFromMeetingMutation = {
  readonly __typename: "RemoveBotFromMeetingMutation";
  readonly meeting?: Maybe<MeetingNode>;
};

export type RemoveClickupIntegrationMutation = {
  readonly __typename: "RemoveClickupIntegrationMutation";
  readonly user?: Maybe<UserNode>;
};

export type RemoveFavouriteArtifact = {
  readonly __typename: "RemoveFavouriteArtifact";
  readonly artifact?: Maybe<ArtifactInterface>;
  readonly user?: Maybe<UserNode>;
};

export type RemoveGitHubIntegrationMutation = {
  readonly __typename: "RemoveGitHubIntegrationMutation";
  readonly user?: Maybe<UserNode>;
};

export type RemoveHubspotIntegrationMutation = {
  readonly __typename: "RemoveHubspotIntegrationMutation";
  readonly user?: Maybe<UserNode>;
};

export type RemoveIntegrationCredentialsMutation = {
  readonly __typename: "RemoveIntegrationCredentialsMutation";
  readonly user?: Maybe<UserNode>;
};

export type RemoveJiraIntegrationMutation = {
  readonly __typename: "RemoveJiraIntegrationMutation";
  readonly user?: Maybe<UserNode>;
};

/** Remove a specific Merge.dev integration */
export type RemoveMergeDevIntegration = {
  readonly __typename: "RemoveMergeDevIntegration";
  readonly error?: Maybe<Scalars["String"]["output"]>;
  readonly success: Scalars["Boolean"]["output"];
};

export type RemoveOrganizationGitHubIntegrationMutation = {
  readonly __typename: "RemoveOrganizationGitHubIntegrationMutation";
  readonly organization?: Maybe<OrganizationNode>;
};

export type RemovePersonalTranscriptSyncCredentialMutation = {
  readonly __typename: "RemovePersonalTranscriptSyncCredentialMutation";
  readonly user?: Maybe<UserNode>;
};

export type RemoveReadAiIntegrationMutation = {
  readonly __typename: "RemoveReadAiIntegrationMutation";
  readonly user?: Maybe<UserNode>;
};

export type RemoveSalesforceIntegrationMutation = {
  readonly __typename: "RemoveSalesforceIntegrationMutation";
  readonly user?: Maybe<UserNode>;
};

export type RemoveSlackIntegrationMutation = {
  readonly __typename: "RemoveSlackIntegrationMutation";
  readonly organization?: Maybe<OrganizationNode>;
};

export type RemoveTeamMemberMutation = {
  readonly __typename: "RemoveTeamMemberMutation";
  readonly team?: Maybe<TeamNode>;
  readonly user?: Maybe<UserNode>;
};

export type RemoveTeamsIntegrationMutation = {
  readonly __typename: "RemoveTeamsIntegrationMutation";
  readonly organization?: Maybe<OrganizationNode>;
};

export type RemoveTemplateSeriesFromMeetingMutation = {
  readonly __typename: "RemoveTemplateSeriesFromMeetingMutation";
  readonly meetingGroup?: Maybe<MeetingGroupNode>;
};

export type RemoveUserFromOrganizationMutation = {
  readonly __typename: "RemoveUserFromOrganizationMutation";
  readonly org?: Maybe<OrganizationNode>;
  readonly userToRemove?: Maybe<UserNode>;
};

export type RemoveYouTrackIntegrationMutation = {
  readonly __typename: "RemoveYouTrackIntegrationMutation";
  readonly organization?: Maybe<OrganizationNode>;
};

export type RemoveZoomIntegrationMutation = {
  readonly __typename: "RemoveZoomIntegrationMutation";
  readonly user?: Maybe<UserNode>;
};

export type ReopenAssessmentMutation = {
  readonly __typename: "ReopenAssessmentMutation";
  readonly assessments: ReadonlyArray<Maybe<AssessmentNode>>;
  readonly reportRows: PerformanceReviewReportRowConnection;
};

export type ReopenAssessmentMutationReportRowsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ReorderArtifactMutation = {
  readonly __typename: "ReorderArtifactMutation";
  readonly artifact?: Maybe<BaseArtifactNode>;
};

export type ReorderTopicMutation = {
  readonly __typename: "ReorderTopicMutation";
  readonly afterTopic?: Maybe<TopicNode>;
  readonly beforeTopic?: Maybe<TopicNode>;
  readonly meeting?: Maybe<MeetingNode>;
  readonly topic?: Maybe<TopicNode>;
};

export type ReportFilterInput = {
  readonly type: ReportFilterType;
  readonly values: ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>;
};

/** An enumeration. */
export enum ReportFilterType {
  DateRange = "date_range",
  TeamId = "team_id",
  UserId = "user_id",
}

export type ReportResponseNode = {
  readonly __typename: "ReportResponseNode";
  readonly data: ReadonlyArray<Maybe<ReportResponseRowNode>>;
  readonly totalValues: ReadonlyArray<Maybe<Scalars["Float"]["output"]>>;
};

export type ReportResponseRowNode = {
  readonly __typename: "ReportResponseRowNode";
  readonly attributeValues: ReadonlyArray<Maybe<Scalars["String"]["output"]>>;
  readonly metricValues: ReadonlyArray<Maybe<Scalars["Float"]["output"]>>;
};

export type ReportingChartDataNode = {
  readonly __typename: "ReportingChartDataNode";
  readonly count: Scalars["Int"]["output"];
  readonly key: Scalars["String"]["output"];
  readonly value: Scalars["Float"]["output"];
};

export type ReportingChartNode = {
  readonly __typename: "ReportingChartNode";
  readonly data: ReadonlyArray<Maybe<ReportingChartDataNode>>;
  readonly name: Scalars["String"]["output"];
};

/** An enumeration. */
export enum ReportingPredictionDirection {
  SubjectManagedByOther = "subject_managed_by_other",
  SubjectManagesOther = "subject_manages_other",
}

/** An enumeration. */
export enum ReportingPredictionStatus {
  Complete = "complete",
  Failed = "failed",
  NotStarted = "not_started",
  Queued = "queued",
  Running = "running",
  Skipped = "skipped",
}

export type RequestExportMutation = {
  readonly __typename: "RequestExportMutation";
  readonly user?: Maybe<UserNode>;
};

export type ResponsibilityAssessmentAnswerNode = AssessmentAnswerInterface & {
  readonly __typename: "ResponsibilityAssessmentAnswerNode";
  readonly assessment: AssessmentNode;
  readonly calibrations: AssessmentAnswerCalibrationConnection;
  readonly canDelete: PermissionNode;
  readonly canRead: PermissionNode;
  readonly canUpdate: PermissionNode;
  readonly comment?: Maybe<Scalars["JSONString"]["output"]>;
  readonly created: Scalars["DateTime"]["output"];
  readonly hasCalibrationSuggestions: Scalars["Boolean"]["output"];
  readonly hasCalibrations: Scalars["Boolean"]["output"];
  readonly id: Scalars["Int"]["output"];
  readonly integerAnswer?: Maybe<Scalars["Int"]["output"]>;
  readonly isLocked: Scalars["Boolean"]["output"];
  readonly question: AssessmentQuestionInterface;
  readonly questionId: Scalars["Int"]["output"];
  readonly responder?: Maybe<UserNode>;
  readonly roleId: Scalars["Int"]["output"];
  readonly updated: Scalars["DateTime"]["output"];
};

export type ResponsibilityAssessmentAnswerNodeCalibrationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ResponsibilityAssessmentQuestionNode =
  AssessmentQuestionInterface & {
    readonly __typename: "ResponsibilityAssessmentQuestionNode";
    readonly answers: AssessmentAnswerConnection;
    readonly answersExist: Scalars["Boolean"]["output"];
    readonly archived: Scalars["Boolean"]["output"];
    readonly canDelete: PermissionNode;
    readonly canRead: PermissionNode;
    readonly canUpdate: PermissionNode;
    readonly categories: AssessmentQuestionCategoryNodeConnection;
    readonly comment: AssessmentQuestionComment;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator?: Maybe<UserNode>;
    readonly description?: Maybe<Scalars["JSONString"]["output"]>;
    readonly endValue: Scalars["Int"]["output"];
    readonly id: Scalars["Int"]["output"];
    readonly isResponseMandatory: Scalars["Boolean"]["output"];
    readonly labelDescriptions: ReadonlyArray<
      Maybe<Scalars["String"]["output"]>
    >;
    readonly labels: ReadonlyArray<Maybe<Scalars["String"]["output"]>>;
    readonly organization: OrganizationNode;
    readonly questionType: AssessmentQuestionType;
    readonly responseVisibility: AssessmentQuestionResponseVisibility;
    readonly responses: AssessmentQuestionResponses;
    readonly responsibility?: Maybe<CareerTrackRoleResponsibilityNode>;
    readonly startValue: Scalars["Int"]["output"];
    readonly title: Scalars["String"]["output"];
    readonly updated: Scalars["DateTime"]["output"];
  };

export type ResponsibilityAssessmentQuestionNodeAnswersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ResponsibilityAssessmentQuestionNodeCategoriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RetryChatbotSessionMutation = {
  readonly __typename: "RetryChatbotSessionMutation";
  readonly chatSession?: Maybe<ChatSessionNode>;
};

export type RoleBasedAssessmentGroupNode = {
  readonly __typename: "RoleBasedAssessmentGroupNode";
  readonly id: Scalars["ID"]["output"];
  readonly sections?: Maybe<VirtualAssessmentSectionConnection>;
  readonly title?: Maybe<Scalars["String"]["output"]>;
};

export type RoleBasedAssessmentGroupNodeSectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RoleChangeUserNode = {
  readonly __typename: "RoleChangeUserNode";
  readonly oldRoles: ReadonlyArray<CareerTrackRoleNode>;
  readonly user: UserNode;
};

export type RoleCompetencyInput = {
  readonly competencyId: Scalars["Int"]["input"];
  readonly roleId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RoleResponsibilityInput = {
  readonly content?: InputMaybe<Scalars["String"]["input"]>;
  readonly id?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RoutineNode = {
  readonly __typename: "RoutineNode";
  readonly created: Scalars["DateTime"]["output"];
  readonly enabled: Scalars["Boolean"]["output"];
  readonly id: Scalars["UUID"]["output"];
  readonly name: Scalars["String"]["output"];
  readonly selectedMeetingGroups: ReadonlyArray<RoutineSelectedMeetingGroupType>;
  readonly skillExists: Scalars["Boolean"]["output"];
  readonly skillId: Scalars["String"]["output"];
  readonly skillSlug: Scalars["String"]["output"];
  readonly triggerConfig: Scalars["JSONString"]["output"];
  readonly triggerType: Scalars["String"]["output"];
  readonly updated: Scalars["DateTime"]["output"];
};

export type RoutineSelectedMeetingGroupType = {
  readonly __typename: "RoutineSelectedMeetingGroupType";
  readonly id: Scalars["Int"]["output"];
  readonly title?: Maybe<Scalars["String"]["output"]>;
};

export type SalesforceKpiIntegrationInput = {
  readonly kpiFieldName?: InputMaybe<Scalars["String"]["input"]>;
  readonly soqlQuery?: InputMaybe<Scalars["String"]["input"]>;
};

export type SalesforceKpiIntegrationNode = KpiIntegrationInterface & {
  readonly __typename: "SalesforceKPIIntegrationNode";
  readonly created?: Maybe<Scalars["DateTime"]["output"]>;
  readonly creator?: Maybe<UserNode>;
  readonly id: Scalars["Int"]["output"];
  readonly integrationType?: Maybe<KpiIntegrationType>;
  readonly kpi?: Maybe<KpiNode>;
  readonly kpiFieldName: Scalars["String"]["output"];
  readonly organizationIntegrationConnection?: Maybe<OrganizationIntegrationNode>;
  readonly soqlQuery: Scalars["String"]["output"];
  readonly updated?: Maybe<Scalars["DateTime"]["output"]>;
};

export type SalesforceOpportunityNode = InfoCardInterface & {
  readonly __typename: "SalesforceOpportunityNode";
  readonly amount?: Maybe<Scalars["Float"]["output"]>;
  readonly assignees: ReadonlyArray<Maybe<ExternalProfileNode>>;
  readonly closedAt?: Maybe<Scalars["DateTime"]["output"]>;
  readonly created: Scalars["DateTime"]["output"];
  readonly description?: Maybe<Scalars["String"]["output"]>;
  readonly id: Scalars["ID"]["output"];
  readonly providerName?: Maybe<Scalars["String"]["output"]>;
  readonly status?: Maybe<InfoTaskStatus>;
  readonly title: Scalars["String"]["output"];
  readonly url: Scalars["String"]["output"];
};

export type SaveMeetingVideoRecordingMutation = {
  readonly __typename: "SaveMeetingVideoRecordingMutation";
  readonly meeting?: Maybe<MeetingNode>;
};

export type SavePersonalTranscriptSyncCredentialMutation = {
  readonly __typename: "SavePersonalTranscriptSyncCredentialMutation";
  readonly user?: Maybe<UserNode>;
};

export enum ScheduleKindEnum {
  DailyBrief = "DAILY_BRIEF",
  MeetingPrep = "MEETING_PREP",
}

export type SearchCsvExportMutation = {
  readonly __typename: "SearchCSVExportMutation";
  readonly user?: Maybe<UserNode>;
};

export type SearchConnection = {
  readonly __typename: "SearchConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<SearchEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `Search` and its cursor. */
export type SearchEdge = {
  readonly __typename: "SearchEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<SearchUnion>;
};

export type SearchOptions = {
  readonly artifactFilters?: InputMaybe<ArtifactFilterInput>;
  /** Constrains results to items associated with the specified flow */
  readonly flowId?: InputMaybe<Scalars["Int"]["input"]>;
  /** By default, github searches will be restricted to repos in the organization linked to Topicflow */
  readonly githubSearchEverywhere?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter hubspot deals by their stage id */
  readonly hubspotStageId?: InputMaybe<Scalars["String"]["input"]>;
  /** Constrain results to items associated with the specified meeting group */
  readonly meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Constrains results to items associated with draft or non-draft meetings */
  readonly meetingIsDraft?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly meetingIsFormalOneonone?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly meetingParticipantCount?: InputMaybe<Scalars["Int"]["input"]>;
  readonly meetingParticipants?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  readonly meetingsAfterDatetime?: InputMaybe<Scalars["DateTime"]["input"]>;
  readonly meetingsBeforeDatetime?: InputMaybe<Scalars["DateTime"]["input"]>;
  readonly resultTypes?: InputMaybe<SearchResultTypes>;
};

export type SearchResultTypes = {
  readonly artifacts?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly comments?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly flows?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly githubIssues?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly hubspotDeals?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly jiraIssues?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly meetings?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly topics?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly users?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly youtrackIssues?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SearchSkillResult = PlatformSkillType | SkillNode;

export type SearchUnion =
  | BaseArtifactNode
  | CommentNode
  | FlowNode
  | GithubIssueNode
  | HubspotDealNode
  | JiraIssueNode
  | MeetingWithRelevantSectionsNode
  | TopicNode
  | UserNode
  | YouTrackIssueNode;

/** An enumeration. */
export enum SectionDelimiterType {
  ActionItem = "action_item",
  Decision = "decision",
  Goal = "goal",
  MeetingMetadata = "meeting_metadata",
  Topic = "topic",
}

export type SendMessageToChatbotMutation = {
  readonly __typename: "SendMessageToChatbotMutation";
  readonly chatSession?: Maybe<ChatSessionNode>;
};

export type SendPhoneNumberVerificationCodeMutation = {
  readonly __typename: "SendPhoneNumberVerificationCodeMutation";
  readonly membership?: Maybe<UserMemberNode>;
};

export type SendProgramReminderMutation = {
  readonly __typename: "SendProgramReminderMutation";
  readonly complianceProgram?: Maybe<ComplianceProgramNode>;
};

export type SendRoutineTestMutation = {
  readonly __typename: "SendRoutineTestMutation";
  readonly ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type SetAssessmentNominationsMutation = {
  readonly __typename: "SetAssessmentNominationsMutation";
  readonly assessmentOpenForNomination?: Maybe<AssessmentOpenForNominationNode>;
  readonly assessmentTemplate?: Maybe<AssessmentGroupNode>;
  readonly complianceProgram?: Maybe<ComplianceProgramNode>;
};

export type SetFavouriteGroupsMutation = {
  readonly __typename: "SetFavouriteGroupsMutation";
  readonly me?: Maybe<UserNode>;
};

export type SetMeetingAgendaAsTemplateMutation = {
  readonly __typename: "SetMeetingAgendaAsTemplateMutation";
  readonly meeting?: Maybe<MeetingNode>;
};

export type SetMeetingLockedMutation = {
  readonly __typename: "SetMeetingLockedMutation";
  /** The modified meeting */
  readonly meeting?: Maybe<MeetingNode>;
};

export type SetRelationshipMutation = {
  readonly __typename: "SetRelationshipMutation";
  readonly relationship?: Maybe<RelationshipNode>;
  readonly user?: Maybe<UserNode>;
};

export type SetRelationshipsMutation = {
  readonly __typename: "SetRelationshipsMutation";
  readonly me?: Maybe<UserNode>;
  readonly relationships?: Maybe<RelationshipConnection>;
};

export type SetRelationshipsMutationRelationshipsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type SkillNode = {
  readonly __typename: "SkillNode";
  readonly archivedAt?: Maybe<Scalars["DateTime"]["output"]>;
  readonly body: Scalars["String"]["output"];
  readonly canArchive: Scalars["Boolean"]["output"];
  readonly canEdit: Scalars["Boolean"]["output"];
  readonly created: Scalars["DateTime"]["output"];
  readonly creator?: Maybe<UserNode>;
  readonly description: Scalars["String"]["output"];
  readonly id: Scalars["UUID"]["output"];
  readonly isScheduled: Scalars["Boolean"]["output"];
  readonly name: Scalars["String"]["output"];
  readonly organization?: Maybe<OrganizationNode>;
  readonly overridesSource: SkillOverrideSourceEnum;
  readonly scheduleKind?: Maybe<ScheduleKindEnum>;
  readonly shadowedCount: Scalars["Int"]["output"];
  readonly slug: Scalars["String"]["output"];
  readonly updated: Scalars["DateTime"]["output"];
  readonly updatedBy?: Maybe<UserNode>;
  readonly visibility: SkillVisibilityEnum;
};

export enum SkillOverrideSourceEnum {
  None = "NONE",
  Platform = "PLATFORM",
  Workspace = "WORKSPACE",
}

export enum SkillVisibilityEnum {
  Personal = "PERSONAL",
  Platform = "PLATFORM",
  Workspace = "WORKSPACE",
}

export type SlackChannelConfigurationInput = {
  readonly channelId: Scalars["String"]["input"];
  readonly shouldIndex: Scalars["Boolean"]["input"];
};

export type SlackChannelConfigurationNode = {
  readonly __typename: "SlackChannelConfigurationNode";
  readonly firstIndexedTs?: Maybe<Scalars["DateTime"]["output"]>;
  readonly id: Scalars["String"]["output"];
  readonly lastIndexedTs?: Maybe<Scalars["DateTime"]["output"]>;
  readonly name: Scalars["String"]["output"];
  readonly shouldIndex: Scalars["Boolean"]["output"];
};

export type SlackChannelConnection = {
  readonly __typename: "SlackChannelConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<SlackChannelEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `SlackChannel` and its cursor. */
export type SlackChannelEdge = {
  readonly __typename: "SlackChannelEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<SlackChannelNode>;
};

export type SlackChannelNode = {
  readonly __typename: "SlackChannelNode";
  readonly id?: Maybe<Scalars["String"]["output"]>;
  readonly name?: Maybe<Scalars["String"]["output"]>;
};

export type SlackIndexingConfigurationNode = {
  readonly __typename: "SlackIndexingConfigurationNode";
  readonly channels: ReadonlyArray<Maybe<SlackChannelConfigurationNode>>;
  readonly hasBotContextPermissions: Scalars["Boolean"]["output"];
  readonly hasBotPermissions: Scalars["Boolean"]["output"];
  readonly hasDataIngestionPermissions: Scalars["Boolean"]["output"];
  readonly hasNotificationPermissions: Scalars["Boolean"]["output"];
  readonly indexMessages: Scalars["Boolean"]["output"];
  readonly indexNewChannelsByDefault: Scalars["Boolean"]["output"];
};

export type SlackNotificationConnectionNode = DjangoNode &
  Node & {
    readonly __typename: "SlackNotificationConnectionNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly channel: Scalars["String"]["output"];
    readonly id: Scalars["ID"]["output"];
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly sendEmptyAgendaReminder: Scalars["Boolean"]["output"];
    readonly sendPreparationNotification: Scalars["Boolean"]["output"];
    readonly sendSummaryNotification: Scalars["Boolean"]["output"];
  };

export type SlackNotificationConnectionNodeConnection = {
  readonly __typename: "SlackNotificationConnectionNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<SlackNotificationConnectionNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `SlackNotificationConnectionNode` and its cursor. */
export type SlackNotificationConnectionNodeEdge = {
  readonly __typename: "SlackNotificationConnectionNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<SlackNotificationConnectionNode>;
};

export type SlackNotificationForChannelNode = DjangoNode &
  Node & {
    readonly __typename: "SlackNotificationForChannelNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly channel: Scalars["String"]["output"];
    readonly goalCheckins: Scalars["Boolean"]["output"];
    readonly id: Scalars["ID"]["output"];
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly recognitions: Scalars["Boolean"]["output"];
  };

export type SlackNotificationForChannelNodeConnection = {
  readonly __typename: "SlackNotificationForChannelNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<SlackNotificationForChannelNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `SlackNotificationForChannelNode` and its cursor. */
export type SlackNotificationForChannelNodeEdge = {
  readonly __typename: "SlackNotificationForChannelNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<SlackNotificationForChannelNode>;
};

/** An enumeration. */
export enum SourceType {
  ActionItem = "action_item",
  AssessmentDelivery = "assessment_delivery",
  Checkin = "checkin",
  Feedback = "feedback",
  Goal = "goal",
  Meeting = "meeting",
  Recognition = "recognition",
  WorkSummary = "work_summary",
}

export type StartCalendarSyncMutation = {
  readonly __typename: "StartCalendarSyncMutation";
  readonly user?: Maybe<UserNode>;
};

export type SubmitOneOnOneMutation = {
  readonly __typename: "SubmitOneOnOneMutation";
  readonly meeting?: Maybe<MeetingNode>;
};

/** An enumeration. */
export enum SuggestedAnswerState {
  Generated = "generated",
  NotGenerated = "not_generated",
}

export type SuggestedArtifactNode = DjangoNode &
  Node & {
    readonly __typename: "SuggestedArtifactNode";
    readonly artifactType?: Maybe<ArtifactType>;
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly created: Scalars["DateTime"]["output"];
    readonly description?: Maybe<Scalars["String"]["output"]>;
    readonly hidden: Scalars["Boolean"]["output"];
    readonly id: Scalars["ID"]["output"];
    readonly meeting?: Maybe<MeetingNode>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly suggestedAssignee?: Maybe<UserNode>;
    readonly title: Scalars["String"]["output"];
    readonly transcript?: Maybe<MeetingTranscriptNode>;
    readonly transcriptContext?: Maybe<Scalars["String"]["output"]>;
    readonly updated: Scalars["DateTime"]["output"];
  };

export type SuggestedArtifactNodeConnection = {
  readonly __typename: "SuggestedArtifactNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<SuggestedArtifactNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `SuggestedArtifactNode` and its cursor. */
export type SuggestedArtifactNodeEdge = {
  readonly __typename: "SuggestedArtifactNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<SuggestedArtifactNode>;
};

export type SuggestedMeetingNode = MeetingInterface &
  Node & {
    readonly __typename: "SuggestedMeetingNode";
    /** The ID of the object */
    readonly id: Scalars["ID"]["output"];
    readonly startDate?: Maybe<Scalars["Date"]["output"]>;
  };

export type SuggestedQuestionConnection = {
  readonly __typename: "SuggestedQuestionConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<SuggestedQuestionEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `SuggestedQuestion` and its cursor. */
export type SuggestedQuestionEdge = {
  readonly __typename: "SuggestedQuestionEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<SuggestedQuestionNode>;
};

export type SuggestedQuestionNode = {
  readonly __typename: "SuggestedQuestionNode";
  readonly questionId?: Maybe<Scalars["ID"]["output"]>;
  readonly questionText?: Maybe<Scalars["String"]["output"]>;
  readonly suggestions?: Maybe<SuggestionItemConnection>;
};

export type SuggestedQuestionNodeSuggestionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type SuggestedTopicNode = DjangoNode &
  Node & {
    readonly __typename: "SuggestedTopicNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly created: Scalars["DateTime"]["output"];
    readonly hidden: Scalars["Boolean"]["output"];
    readonly id: Scalars["ID"]["output"];
    readonly meeting?: Maybe<MeetingNode>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly title: Scalars["String"]["output"];
    readonly topic?: Maybe<TopicNode>;
    readonly updated: Scalars["DateTime"]["output"];
  };

export type SuggestedTopicNodeConnection = {
  readonly __typename: "SuggestedTopicNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<SuggestedTopicNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `SuggestedTopicNode` and its cursor. */
export type SuggestedTopicNodeEdge = {
  readonly __typename: "SuggestedTopicNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<SuggestedTopicNode>;
};

export type SuggestionItemConnection = {
  readonly __typename: "SuggestionItemConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<SuggestionItemEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `SuggestionItem` and its cursor. */
export type SuggestionItemEdge = {
  readonly __typename: "SuggestionItemEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<SuggestionItemNode>;
};

export type SuggestionItemNode = {
  readonly __typename: "SuggestionItemNode";
  readonly citations?: Maybe<AnswerCitationConnection>;
  readonly text: Scalars["String"]["output"];
  readonly title: Scalars["String"]["output"];
};

export type SuggestionItemNodeCitationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type SummarizedMeasurements = {
  readonly __typename: "SummarizedMeasurements";
  readonly aggregateMeasurement?: Maybe<Scalars["Float"]["output"]>;
  readonly aggregateMeasurementId?: Maybe<Scalars["String"]["output"]>;
  readonly date?: Maybe<Scalars["Date"]["output"]>;
};

export type SummarizedMeasurementsConnection = {
  readonly __typename: "SummarizedMeasurementsConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<SummarizedMeasurementsEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `SummarizedMeasurements` and its cursor. */
export type SummarizedMeasurementsEdge = {
  readonly __typename: "SummarizedMeasurementsEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<SummarizedMeasurements>;
};

export type SyncComplianceProgramUsersMutation = {
  readonly __typename: "SyncComplianceProgramUsersMutation";
  readonly complianceProgram: ComplianceProgramNode;
};

export enum SyncCredentialsTypeEnum {
  Github = "github",
  GoogleCalendar = "google_calendar",
  OutlookCalendar = "outlook_calendar",
  Zoom = "zoom",
}

export type SyncWithHrisMutation = {
  readonly __typename: "SyncWithHRISMutation";
  readonly organization?: Maybe<OrganizationNode>;
};

export type TalentIndicatorAssessmentAnswerCalibrationNode =
  AssessmentAnswerCalibrationInterface & {
    readonly __typename: "TalentIndicatorAssessmentAnswerCalibrationNode";
    readonly answerId?: Maybe<Scalars["Int"]["output"]>;
    readonly canDelete: PermissionNode;
    readonly canRead: PermissionNode;
    readonly canUpdate: PermissionNode;
    readonly comment?: Maybe<Scalars["JSONString"]["output"]>;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator?: Maybe<UserNode>;
    readonly id: Scalars["Int"]["output"];
    readonly integerAnswer?: Maybe<Scalars["Int"]["output"]>;
    readonly isPrecalibration: Scalars["Boolean"]["output"];
    readonly isSuggestion: Scalars["Boolean"]["output"];
    readonly prevIntegerAnswer?: Maybe<Scalars["Int"]["output"]>;
    readonly question: AssessmentQuestionInterface;
    readonly target?: Maybe<UserNode>;
    readonly updated: Scalars["DateTime"]["output"];
  };

export type TalentIndicatorAssessmentAnswerNode = AssessmentAnswerInterface & {
  readonly __typename: "TalentIndicatorAssessmentAnswerNode";
  readonly assessment: AssessmentNode;
  readonly calibrations: AssessmentAnswerCalibrationConnection;
  readonly canDelete: PermissionNode;
  readonly canRead: PermissionNode;
  readonly canUpdate: PermissionNode;
  readonly comment?: Maybe<Scalars["JSONString"]["output"]>;
  readonly created: Scalars["DateTime"]["output"];
  readonly hasCalibrationSuggestions: Scalars["Boolean"]["output"];
  readonly hasCalibrations: Scalars["Boolean"]["output"];
  readonly id: Scalars["Int"]["output"];
  readonly integerAnswer?: Maybe<Scalars["Int"]["output"]>;
  readonly isLocked: Scalars["Boolean"]["output"];
  readonly question: AssessmentQuestionInterface;
  readonly questionId: Scalars["Int"]["output"];
  readonly responder?: Maybe<UserNode>;
  readonly updated: Scalars["DateTime"]["output"];
};

export type TalentIndicatorAssessmentAnswerNodeCalibrationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type TalentIndicatorAssessmentQuestionNode =
  AssessmentQuestionInterface & {
    readonly __typename: "TalentIndicatorAssessmentQuestionNode";
    readonly answers: AssessmentAnswerConnection;
    readonly answersExist: Scalars["Boolean"]["output"];
    readonly archived: Scalars["Boolean"]["output"];
    readonly canDelete: PermissionNode;
    readonly canRead: PermissionNode;
    readonly canUpdate: PermissionNode;
    readonly categories: AssessmentQuestionCategoryNodeConnection;
    readonly comment: AssessmentQuestionComment;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator?: Maybe<UserNode>;
    readonly description?: Maybe<Scalars["JSONString"]["output"]>;
    readonly endValue: Scalars["Int"]["output"];
    readonly id: Scalars["Int"]["output"];
    readonly isResponseMandatory: Scalars["Boolean"]["output"];
    readonly labelDescriptions: ReadonlyArray<
      Maybe<Scalars["String"]["output"]>
    >;
    readonly labels: ReadonlyArray<Maybe<Scalars["String"]["output"]>>;
    readonly organization: OrganizationNode;
    readonly questionType: AssessmentQuestionType;
    readonly responseVisibility: AssessmentQuestionResponseVisibility;
    readonly responses: AssessmentQuestionResponses;
    readonly startValue: Scalars["Int"]["output"];
    readonly talentIndicator?: Maybe<TalentIndicatorNode>;
    readonly title: Scalars["String"]["output"];
    readonly updated: Scalars["DateTime"]["output"];
  };

export type TalentIndicatorAssessmentQuestionNodeAnswersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type TalentIndicatorAssessmentQuestionNodeCategoriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type TalentIndicatorConfigInput = {
  readonly description?: InputMaybe<Scalars["String"]["input"]>;
  readonly talentIndicators: ReadonlyArray<InputMaybe<TalentIndicatorInput>>;
  readonly title?: InputMaybe<Scalars["String"]["input"]>;
};

export type TalentIndicatorInput = {
  readonly comment: AssessmentQuestionComment;
  readonly description?: InputMaybe<Scalars["String"]["input"]>;
  readonly responseVisibility: AssessmentQuestionResponseVisibility;
  readonly responses: AssessmentQuestionResponses;
  readonly talentIndicatorId: Scalars["Int"]["input"];
};

export type TalentIndicatorNode = DjangoNode &
  Node & {
    readonly __typename: "TalentIndicatorNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly customName?: Maybe<Scalars["String"]["output"]>;
    readonly description: Scalars["JSONString"]["output"];
    readonly hasAssessmentQuestions: Scalars["Boolean"]["output"];
    readonly hasLockedLabels: Scalars["Boolean"]["output"];
    readonly id: Scalars["ID"]["output"];
    readonly isManagerIndicator: Scalars["Boolean"]["output"];
    readonly labelDescriptions: ReadonlyArray<
      Maybe<Scalars["String"]["output"]>
    >;
    readonly labels: ReadonlyArray<Maybe<Scalars["String"]["output"]>>;
    readonly name: Scalars["String"]["output"];
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly questionTitle?: Maybe<Scalars["String"]["output"]>;
    readonly scale: Scalars["Int"]["output"];
    readonly scaleStartsAt: Scalars["Int"]["output"];
    readonly talentIndicatorType: TalentIndicatorType;
  };

export type TalentIndicatorNodeConnection = {
  readonly __typename: "TalentIndicatorNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TalentIndicatorNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `TalentIndicatorNode` and its cursor. */
export type TalentIndicatorNodeEdge = {
  readonly __typename: "TalentIndicatorNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<TalentIndicatorNode>;
};

export type TalentIndicatorQuestionSettingsNode = {
  readonly __typename: "TalentIndicatorQuestionSettingsNode";
  readonly comment: AssessmentQuestionComment;
  readonly description?: Maybe<Scalars["String"]["output"]>;
  readonly responseVisibility: AssessmentQuestionResponseVisibility;
  readonly responses: AssessmentQuestionResponses;
  readonly talentIndicatorId: Scalars["Int"]["output"];
};

export type TalentIndicatorSettingsNode = {
  readonly __typename: "TalentIndicatorSettingsNode";
  readonly description?: Maybe<Scalars["JSONString"]["output"]>;
  readonly talentIndicators: ReadonlyArray<
    Maybe<TalentIndicatorQuestionSettingsNode>
  >;
  readonly title?: Maybe<Scalars["String"]["output"]>;
};

/** An enumeration. */
export enum TalentIndicatorType {
  Bonus = "bonus",
  Career = "career",
  Culture = "culture",
  Decisions = "decisions",
  Delegation = "delegation",
  DepartureImpact = "departure_impact",
  Expectations = "expectations",
  Feedback = "feedback",
  FlightRisk = "flight_risk",
  Goals = "goals",
  Inclusivity = "inclusivity",
  Performance = "performance",
  Potential = "potential",
  Productivity = "productivity",
  Promotion = "promotion",
  Visibility = "visibility",
}

export type TeamNode = DjangoNode &
  Node & {
    readonly __typename: "TeamNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator?: Maybe<UserNode>;
    readonly id: Scalars["ID"]["output"];
    readonly kpis?: Maybe<KpiNodeConnection>;
    readonly members?: Maybe<UserNodeConnection>;
    readonly organization?: Maybe<OrganizationNode>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly teamGoals?: Maybe<ArtifactConnection>;
    readonly title: Scalars["String"]["output"];
    readonly updated: Scalars["DateTime"]["output"];
  };

export type TeamNodeKpisArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  group?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type TeamNodeMembersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type TeamNodeTeamGoalsArgs = {
  actionItemAssignedToMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignees?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  actionItemDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  actionItemProgress?: InputMaybe<Scalars["Float"]["input"]>;
  actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemStates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  ancestorsOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  artifactTypes?: InputMaybe<ReadonlyArray<InputMaybe<ArtifactType>>>;
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  asUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  assignedToMembersOfOrganizationId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  completedActionItemsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedActionItemsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  createdByIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  createdInMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackSenders?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackState?: InputMaybe<FeedbackState>;
  feedbackStates?: InputMaybe<ReadonlyArray<InputMaybe<FeedbackState>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  goalCompetencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalContributors?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalInvolvingUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalParentIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalResponsibilityIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalScope?: InputMaybe<GoalScope>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalState?: InputMaybe<GoalState>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalStatus?: InputMaybe<GoalStatus>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalVisibility?: InputMaybe<GoalVisibility>;
  goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  groupBy?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  isStale?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValue?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionReceivedByMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type TeamNodeConnection = {
  readonly __typename: "TeamNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TeamNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `TeamNode` and its cursor. */
export type TeamNodeEdge = {
  readonly __typename: "TeamNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<TeamNode>;
};

export type TeamsNotificationForChannelNode = DjangoNode &
  Node & {
    readonly __typename: "TeamsNotificationForChannelNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly channelId: Scalars["String"]["output"];
    readonly channelName: Scalars["String"]["output"];
    readonly goalCheckins: Scalars["Boolean"]["output"];
    readonly id: Scalars["ID"]["output"];
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly recognitions: Scalars["Boolean"]["output"];
    readonly teamId: Scalars["String"]["output"];
    readonly teamName: Scalars["String"]["output"];
  };

export type TeamsNotificationForChannelNodeConnection = {
  readonly __typename: "TeamsNotificationForChannelNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TeamsNotificationForChannelNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `TeamsNotificationForChannelNode` and its cursor. */
export type TeamsNotificationForChannelNodeEdge = {
  readonly __typename: "TeamsNotificationForChannelNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<TeamsNotificationForChannelNode>;
};

export type TemplateCategoryNode = DjangoNode &
  Node & {
    readonly __typename: "TemplateCategoryNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly creator?: Maybe<UserNode>;
    readonly id: Scalars["ID"]["output"];
    readonly ordinal?: Maybe<Scalars["Int"]["output"]>;
    readonly organization?: Maybe<OrganizationNode>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly title: Scalars["String"]["output"];
  };

export type TemplateCategoryNodeConnection = {
  readonly __typename: "TemplateCategoryNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TemplateCategoryNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `TemplateCategoryNode` and its cursor. */
export type TemplateCategoryNodeEdge = {
  readonly __typename: "TemplateCategoryNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<TemplateCategoryNode>;
};

export type TemplateRatingInput = {
  readonly allowAdminVisibility?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly allowManagerAnswers?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly allowManagerVisibility?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly allowMeetingParticipantAnswers?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  readonly allowMeetingParticipantVisibility?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  readonly allowOrganizationVisibility?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  readonly allowReportAnswers?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly allowReportVisibility?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly ratingId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type TemplateRatingRequirementNode = DjangoNode &
  Node & {
    readonly __typename: "TemplateRatingRequirementNode";
    readonly allowAdminVisibility: Scalars["Boolean"]["output"];
    readonly allowManagerAnswers: Scalars["Boolean"]["output"];
    readonly allowManagerVisibility: Scalars["Boolean"]["output"];
    readonly allowMeetingParticipantAnswers: Scalars["Boolean"]["output"];
    readonly allowMeetingParticipantVisibility: Scalars["Boolean"]["output"];
    readonly allowOrganizationVisibility: Scalars["Boolean"]["output"];
    readonly allowReportAnswers: Scalars["Boolean"]["output"];
    readonly allowReportVisibility: Scalars["Boolean"]["output"];
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly creator?: Maybe<UserNode>;
    readonly id: Scalars["ID"]["output"];
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly rating?: Maybe<RatingNode>;
  };

export type TemplateRatingRequirementNodeConnection = {
  readonly __typename: "TemplateRatingRequirementNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TemplateRatingRequirementNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `TemplateRatingRequirementNode` and its cursor. */
export type TemplateRatingRequirementNodeEdge = {
  readonly __typename: "TemplateRatingRequirementNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<TemplateRatingRequirementNode>;
};

export type TemplateRequirementComplianceReportConnection = {
  readonly __typename: "TemplateRequirementComplianceReportConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TemplateRequirementComplianceReportEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `TemplateRequirementComplianceReport` and its cursor. */
export type TemplateRequirementComplianceReportEdge = {
  readonly __typename: "TemplateRequirementComplianceReportEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<TemplateRequirementComplianceReportNode>;
};

export type TemplateRequirementComplianceReportNode = {
  readonly __typename: "TemplateRequirementComplianceReportNode";
  readonly id?: Maybe<Scalars["Int"]["output"]>;
  readonly manager?: Maybe<UserNode>;
  readonly organization?: Maybe<OrganizationNode>;
  readonly reports?: Maybe<ComplianceReportUserConnection>;
};

export type TemplateRequirementComplianceReportNodeReportsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type TemplateRequirementNode = DjangoNode &
  Node & {
    readonly __typename: "TemplateRequirementNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly complianceReport?: Maybe<TemplateRequirementComplianceReportConnection>;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator: UserNode;
    readonly deleted: Scalars["Boolean"]["output"];
    readonly deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
    readonly deletedBy?: Maybe<UserNode>;
    readonly id: Scalars["ID"]["output"];
    readonly organization?: Maybe<OrganizationNode>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly template: TopicTemplateNode;
    readonly topicTemplate?: Maybe<TopicTemplateNode>;
    readonly updated: Scalars["DateTime"]["output"];
  };

export type TemplateRequirementNodeComplianceReportArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["Date"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  personId?: InputMaybe<Scalars["Int"]["input"]>;
  startDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type TemplateRequirementNodeConnection = {
  readonly __typename: "TemplateRequirementNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TemplateRequirementNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `TemplateRequirementNode` and its cursor. */
export type TemplateRequirementNodeEdge = {
  readonly __typename: "TemplateRequirementNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<TemplateRequirementNode>;
};

export type TemplateSeriesNode = DjangoNode &
  Node & {
    readonly __typename: "TemplateSeriesNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly description: Scalars["String"]["output"];
    readonly id: Scalars["ID"]["output"];
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly title: Scalars["String"]["output"];
    readonly topicTemplates?: Maybe<TemplateSeriesToTopicTemplatesNodeConnection>;
  };

export type TemplateSeriesNodeTopicTemplatesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type TemplateSeriesNodeConnection = {
  readonly __typename: "TemplateSeriesNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TemplateSeriesNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `TemplateSeriesNode` and its cursor. */
export type TemplateSeriesNodeEdge = {
  readonly __typename: "TemplateSeriesNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<TemplateSeriesNode>;
};

export type TemplateSeriesToTopicTemplatesNode = DjangoNode &
  Node & {
    readonly __typename: "TemplateSeriesToTopicTemplatesNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    /** This template should be used every X meeting instances */
    readonly frequency: Scalars["Int"]["output"];
    readonly id: Scalars["ID"]["output"];
    /** This template should be used every X meeting instances, starting at this offset */
    readonly offset: Scalars["Int"]["output"];
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly topicTemplate?: Maybe<TopicTemplateNode>;
  };

export type TemplateSeriesToTopicTemplatesNodeConnection = {
  readonly __typename: "TemplateSeriesToTopicTemplatesNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TemplateSeriesToTopicTemplatesNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `TemplateSeriesToTopicTemplatesNode` and its cursor. */
export type TemplateSeriesToTopicTemplatesNodeEdge = {
  readonly __typename: "TemplateSeriesToTopicTemplatesNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<TemplateSeriesToTopicTemplatesNode>;
};

export type TemplateTopicInput = {
  readonly defaultFacilitatorNotes?: InputMaybe<Scalars["String"]["input"]>;
  readonly defaultSubjectNotes?: InputMaybe<Scalars["String"]["input"]>;
  readonly description?: InputMaybe<Scalars["String"]["input"]>;
  readonly discussionNotes?: InputMaybe<Scalars["String"]["input"]>;
  readonly id?: InputMaybe<Scalars["Int"]["input"]>;
  readonly includesIndividualNotes?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly includesSharedNotes?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly isMandatory?: InputMaybe<Scalars["Boolean"]["input"]>;
  readonly notesRequirement?: InputMaybe<NotesRequirement>;
  readonly title: Scalars["String"]["input"];
};

export type TextAssessmentAnswerNode = AssessmentAnswerInterface & {
  readonly __typename: "TextAssessmentAnswerNode";
  readonly assessment: AssessmentNode;
  readonly calibrations: AssessmentAnswerCalibrationConnection;
  readonly canDelete: PermissionNode;
  readonly canRead: PermissionNode;
  readonly canUpdate: PermissionNode;
  readonly comment?: Maybe<Scalars["JSONString"]["output"]>;
  readonly created: Scalars["DateTime"]["output"];
  readonly hasCalibrationSuggestions: Scalars["Boolean"]["output"];
  readonly hasCalibrations: Scalars["Boolean"]["output"];
  readonly id: Scalars["Int"]["output"];
  readonly inferredSources?: Maybe<AnswerCitationConnection>;
  readonly isLocked: Scalars["Boolean"]["output"];
  readonly question: AssessmentQuestionInterface;
  readonly questionId: Scalars["Int"]["output"];
  readonly responder?: Maybe<UserNode>;
  readonly textAnswer?: Maybe<Scalars["JSONString"]["output"]>;
  readonly updated: Scalars["DateTime"]["output"];
};

export type TextAssessmentAnswerNodeCalibrationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type TextAssessmentAnswerNodeInferredSourcesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type TextAssessmentQuestionNode = AssessmentQuestionInterface & {
  readonly __typename: "TextAssessmentQuestionNode";
  readonly answers: AssessmentAnswerConnection;
  readonly answersExist: Scalars["Boolean"]["output"];
  readonly archived: Scalars["Boolean"]["output"];
  readonly canDelete: PermissionNode;
  readonly canRead: PermissionNode;
  readonly canUpdate: PermissionNode;
  readonly categories: AssessmentQuestionCategoryNodeConnection;
  readonly comment: AssessmentQuestionComment;
  readonly created: Scalars["DateTime"]["output"];
  readonly creator?: Maybe<UserNode>;
  readonly description?: Maybe<Scalars["JSONString"]["output"]>;
  readonly id: Scalars["Int"]["output"];
  readonly isResponseMandatory: Scalars["Boolean"]["output"];
  readonly organization: OrganizationNode;
  readonly questionType: AssessmentQuestionType;
  readonly responseVisibility: AssessmentQuestionResponseVisibility;
  readonly responses: AssessmentQuestionResponses;
  readonly title: Scalars["String"]["output"];
  readonly updated: Scalars["DateTime"]["output"];
};

export type TextAssessmentQuestionNodeAnswersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type TextAssessmentQuestionNodeCategoriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type TitleAutocompleteConnection = {
  readonly __typename: "TitleAutocompleteConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TitleAutocompleteEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `TitleAutocomplete` and its cursor. */
export type TitleAutocompleteEdge = {
  readonly __typename: "TitleAutocompleteEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<Scalars["String"]["output"]>;
};

export type ToggleIndividualNoteVisibilityMutation = {
  readonly __typename: "ToggleIndividualNoteVisibilityMutation";
  readonly individualNotes?: Maybe<IndividualNoteNodeConnection>;
  readonly topics?: Maybe<TopicNodeConnection>;
};

export type ToggleIndividualNoteVisibilityMutationIndividualNotesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  creator?: InputMaybe<Scalars["Int"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  topicId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ToggleIndividualNoteVisibilityMutationTopicsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assignee?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasActionItems?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasArtifacts?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDecisions?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDocuments?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasGoals?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInFlowId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInMeetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<TopicState>;
  titleContains?: InputMaybe<Scalars["String"]["input"]>;
  topicIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type TopicNode = DjangoNode &
  Node & {
    readonly __typename: "TopicNode";
    readonly artifacts?: Maybe<ArtifactConnection>;
    readonly assignee?: Maybe<UserNode>;
    readonly canDelete: PermissionNode;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate: PermissionNode;
    readonly clientId?: Maybe<Scalars["Int"]["output"]>;
    readonly commentCount?: Maybe<Scalars["Int"]["output"]>;
    readonly comments?: Maybe<CommentNodeConnection>;
    readonly copiedFrom?: Maybe<TopicNode>;
    readonly created: Scalars["DateTime"]["output"];
    readonly creator?: Maybe<UserNode>;
    readonly defaultFacilitatorNotes?: Maybe<Scalars["JSONString"]["output"]>;
    readonly defaultSubjectNotes?: Maybe<Scalars["JSONString"]["output"]>;
    readonly description?: Maybe<Scalars["String"]["output"]>;
    readonly discussionNotes?: Maybe<Scalars["JSONString"]["output"]>;
    readonly eventChannelName?: Maybe<Scalars["String"]["output"]>;
    readonly hasNotes: Scalars["Boolean"]["output"];
    readonly id: Scalars["ID"]["output"];
    readonly includesIndividualNotes: Scalars["Boolean"]["output"];
    readonly includesIndividualNotesForCurrentUser: Scalars["Boolean"]["output"];
    readonly includesSharedNotes: Scalars["Boolean"]["output"];
    readonly individualNotes?: Maybe<IndividualNoteNodeConnection>;
    readonly isMandatory: Scalars["Boolean"]["output"];
    readonly linkedTemplateTopic?: Maybe<TopicNode>;
    readonly meeting?: Maybe<MeetingNode>;
    readonly notesRequirement: NotesRequirement;
    readonly organization?: Maybe<OrganizationNode>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    /** The most recent linked topic within this meeting series */
    readonly previousTopic?: Maybe<TopicNode>;
    readonly relatedTopics?: Maybe<TopicNodeConnection>;
    readonly relatedTopicsCount?: Maybe<Scalars["Int"]["output"]>;
    readonly relatedTopicsForSidebar?: Maybe<TopicNodeConnection>;
    readonly state?: Maybe<TopicState>;
    readonly title: Scalars["String"]["output"];
    readonly topicTemplate?: Maybe<TopicTemplateNode>;
    readonly topicTemplateId?: Maybe<Scalars["Int"]["output"]>;
    readonly updated: Scalars["DateTime"]["output"];
  };

export type TopicNodeArtifactsArgs = {
  actionItemAssignedToMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignees?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  actionItemDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  actionItemProgress?: InputMaybe<Scalars["Float"]["input"]>;
  actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemStates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  ancestorsOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  artifactTypes?: InputMaybe<ReadonlyArray<InputMaybe<ArtifactType>>>;
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  asUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  assignedToMembersOfOrganizationId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  completedActionItemsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedActionItemsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  createdByIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  createdInMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackSenders?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackState?: InputMaybe<FeedbackState>;
  feedbackStates?: InputMaybe<ReadonlyArray<InputMaybe<FeedbackState>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  goalCompetencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalContributors?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalInvolvingUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalParentIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalResponsibilityIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalScope?: InputMaybe<GoalScope>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalState?: InputMaybe<GoalState>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalStatus?: InputMaybe<GoalStatus>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalVisibility?: InputMaybe<GoalVisibility>;
  goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  groupBy?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  isStale?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValue?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionReceivedByMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type TopicNodeCommentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  artifactId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  isInlineComment?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  textUuid?: InputMaybe<Scalars["String"]["input"]>;
  topicId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type TopicNodeCopiedFromArgs = {
  hasMeeting?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type TopicNodeIndividualNotesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  creator?: InputMaybe<Scalars["Int"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  topicId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type TopicNodeRelatedTopicsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assignee?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasActionItems?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasArtifacts?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDecisions?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDocuments?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasGoals?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInFlowId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInMeetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<TopicState>;
  titleContains?: InputMaybe<Scalars["String"]["input"]>;
  topicIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type TopicNodeRelatedTopicsCountArgs = {
  meetingInMeetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type TopicNodeRelatedTopicsForSidebarArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assignee?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasActionItems?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasArtifacts?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDecisions?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasDocuments?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasGoals?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInFlowId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingInMeetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<TopicState>;
  titleContains?: InputMaybe<Scalars["String"]["input"]>;
  topicIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type TopicNodeConnection = {
  readonly __typename: "TopicNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TopicNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `TopicNode` and its cursor. */
export type TopicNodeEdge = {
  readonly __typename: "TopicNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<TopicNode>;
};

/** An enumeration. */
export enum TopicState {
  ClosedToDiscussion = "closed_to_discussion",
  Open = "open",
}

export type TopicTemplateComplianceRequirement = {
  readonly id: Scalars["Int"]["input"];
};

export type TopicTemplateNode = DjangoNode &
  Node & {
    readonly __typename: "TopicTemplateNode";
    /** if True, will enable the corresponding flag on any MeetingGroups the template is applied to */
    readonly allowAdminVisibility: Scalars["Boolean"]["output"];
    /** if True, will enable the corresponding flag on any MeetingGroups the template is applied to */
    readonly allowManagementTreeVisibility: Scalars["Boolean"]["output"];
    /** if True, will enable the corresponding flag on any MeetingGroups the template is applied to */
    readonly allowOrgVisibility: Scalars["Boolean"]["output"];
    readonly canDelete: PermissionNode;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate: PermissionNode;
    readonly canUpdateRequirements: Scalars["Boolean"]["output"];
    readonly categories?: Maybe<TemplateCategoryNodeConnection>;
    readonly categoriesList: ReadonlyArray<Maybe<TemplateCategoryNode>>;
    readonly creator?: Maybe<UserNode>;
    readonly description: Scalars["String"]["output"];
    readonly finalizePermissions: FinalizePermissions;
    /** If true, this template is available to all users and organizations. */
    readonly globalTemplate: Scalars["Boolean"]["output"];
    /** Indicates whether this is a required template for at least some users */
    readonly hasRequirements?: Maybe<Scalars["Boolean"]["output"]>;
    readonly id: Scalars["ID"]["output"];
    readonly managerInstructions: Scalars["String"]["output"];
    /** If true, this template was created for a meeting series */
    readonly meetingTemplate: Scalars["Boolean"]["output"];
    readonly oneononeTemplate: Scalars["Boolean"]["output"];
    readonly organization?: Maybe<OrganizationNode>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly publicTemplate: Scalars["Boolean"]["output"];
    readonly ratingRequirements?: Maybe<TemplateRatingRequirementNodeConnection>;
    readonly reportInstructions: Scalars["String"]["output"];
    readonly requirements?: Maybe<TemplateRequirementNodeConnection>;
    readonly title: Scalars["String"]["output"];
    readonly topics?: Maybe<TopicNodeConnection>;
    readonly topicsList: ReadonlyArray<Maybe<TopicNode>>;
    readonly websocketToken?: Maybe<Scalars["String"]["output"]>;
  };

export type TopicTemplateNodeCategoriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type TopicTemplateNodeRatingRequirementsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type TopicTemplateNodeRequirementsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type TopicTemplateNodeTopicsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type TopicTemplateNodeConnection = {
  readonly __typename: "TopicTemplateNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TopicTemplateNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `TopicTemplateNode` and its cursor. */
export type TopicTemplateNodeEdge = {
  readonly __typename: "TopicTemplateNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<TopicTemplateNode>;
};

/** An enumeration. */
export enum TopicflowIntegrationMetricType {
  ActionItemsCreated = "action_items_created",
  DecisionsCreated = "decisions_created",
  GoalsCreated = "goals_created",
  HoursOfMeetings = "hours_of_meetings",
  NumberOfMeetings = "number_of_meetings",
}

/** An enumeration. */
export enum TopicflowIntegrationTimeBucket {
  Daily = "daily",
  Monthly = "monthly",
  Weekly = "weekly",
}

/** An enumeration. */
export enum TopicflowIntegrationValue {
  AverageOverPeriods = "average_over_periods",
  AveragePerUser = "average_per_user",
  LastTimePeriod = "last_time_period",
}

export type TopicflowKpiIntegrationInput = {
  readonly metricType?: InputMaybe<TopicflowIntegrationMetricType>;
  readonly timeBucket?: InputMaybe<TopicflowIntegrationTimeBucket>;
  /** Only relevant when topicflow_value == average_over_periods */
  readonly timePeriodsForAvgValue?: InputMaybe<Scalars["Int"]["input"]>;
  /** Can be set to GRAPHQL_NONE to include the whole org */
  readonly userId?: InputMaybe<Scalars["Int"]["input"]>;
  readonly value?: InputMaybe<TopicflowIntegrationValue>;
};

export type TopicflowKpiIntegrationNode = KpiIntegrationInterface & {
  readonly __typename: "TopicflowKPIIntegrationNode";
  readonly created?: Maybe<Scalars["DateTime"]["output"]>;
  readonly creator?: Maybe<UserNode>;
  readonly id: Scalars["Int"]["output"];
  readonly integrationType?: Maybe<KpiIntegrationType>;
  readonly kpi?: Maybe<KpiNode>;
  readonly metricType?: Maybe<TopicflowIntegrationMetricType>;
  readonly organizationIntegrationConnection?: Maybe<OrganizationIntegrationNode>;
  readonly timeBucket?: Maybe<TopicflowIntegrationTimeBucket>;
  readonly timePeriodsForAvgValue?: Maybe<Scalars["Int"]["output"]>;
  readonly updated?: Maybe<Scalars["DateTime"]["output"]>;
  readonly user?: Maybe<UserNode>;
  readonly value?: Maybe<TopicflowIntegrationValue>;
};

export type TranscriptHighlightCategoryConnection = {
  readonly __typename: "TranscriptHighlightCategoryConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TranscriptHighlightCategoryEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `TranscriptHighlightCategory` and its cursor. */
export type TranscriptHighlightCategoryEdge = {
  readonly __typename: "TranscriptHighlightCategoryEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<TranscriptHighlightCategoryNode>;
};

export type TranscriptHighlightCategoryNode = {
  readonly __typename: "TranscriptHighlightCategoryNode";
  readonly categoryTitle?: Maybe<Scalars["String"]["output"]>;
  readonly highlights?: Maybe<TranscriptHighlightConnection>;
  readonly id?: Maybe<Scalars["String"]["output"]>;
};

export type TranscriptHighlightCategoryNodeHighlightsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type TranscriptHighlightConnection = {
  readonly __typename: "TranscriptHighlightConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TranscriptHighlightEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `TranscriptHighlight` and its cursor. */
export type TranscriptHighlightEdge = {
  readonly __typename: "TranscriptHighlightEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<TranscriptHighlightNode>;
};

export type TranscriptHighlightNode = {
  readonly __typename: "TranscriptHighlightNode";
  readonly highlight?: Maybe<Scalars["String"]["output"]>;
  readonly id?: Maybe<Scalars["String"]["output"]>;
};

/** An enumeration. */
export enum TrendReportGroupBy {
  Manager = "manager",
  Organization = "organization",
  Team = "team",
}

/** An enumeration. */
export enum TrendReportType {
  Average = "average",
  Distribution = "distribution",
}

export type UnlinkIntegrationFromOrganizationMutation = {
  readonly __typename: "UnlinkIntegrationFromOrganizationMutation";
  readonly organization?: Maybe<OrganizationNode>;
};

export type UpdateAccountOnboardingMutation = {
  readonly __typename: "UpdateAccountOnboardingMutation";
  readonly user?: Maybe<UserNode>;
};

export type UpdateAiBrainConsolidatedMutation = {
  readonly __typename: "UpdateAiBrainConsolidatedMutation";
  readonly aiBrain?: Maybe<UserBrainNode>;
};

export type UpdateAssessmentDeliveryMutation = {
  readonly __typename: "UpdateAssessmentDeliveryMutation";
  readonly assessmentDelivery: AssessmentDeliveryNode;
};

export type UpdateAttendanceStatusMutation = {
  readonly __typename: "UpdateAttendanceStatusMutation";
  readonly meeting?: Maybe<MeetingNode>;
  readonly meetingGroup?: Maybe<MeetingGroupNode>;
};

export type UpdateChatSessionMutation = {
  readonly __typename: "UpdateChatSessionMutation";
  readonly chatSession?: Maybe<ChatSessionNode>;
};

export type UpdateComplianceProgramCalibrationStatusMutation = {
  readonly __typename: "UpdateComplianceProgramCalibrationStatusMutation";
  readonly reportRow: PerformanceReviewReportRowNode;
};

export type UpdateMeetingFinalizationStatus = {
  readonly __typename: "UpdateMeetingFinalizationStatus";
  readonly meeting?: Maybe<MeetingNode>;
};

export type UpdateMeetingGroupMutation = {
  readonly __typename: "UpdateMeetingGroupMutation";
  readonly meetingGroup?: Maybe<MeetingGroupNode>;
};

export type UpdateMeetingMutation = {
  readonly __typename: "UpdateMeetingMutation";
  readonly meeting?: Maybe<MeetingNode>;
};

export type UpdateMeetingTranscriptMutation = {
  readonly __typename: "UpdateMeetingTranscriptMutation";
  readonly meeting?: Maybe<MeetingNode>;
};

export type UpdateMeetingTranscriptionStatusMutation = {
  readonly __typename: "UpdateMeetingTranscriptionStatusMutation";
  readonly meeting?: Maybe<MeetingNode>;
};

export type UpdateOrganizationMembershipMutation = {
  readonly __typename: "UpdateOrganizationMembershipMutation";
  readonly member?: Maybe<UserMemberNode>;
};

export type UpdateRoutineMutation = {
  readonly __typename: "UpdateRoutineMutation";
  readonly routine?: Maybe<RoutineNode>;
};

export type UpdateSlackOrgSettingsMutation = {
  readonly __typename: "UpdateSlackOrgSettingsMutation";
  readonly organization?: Maybe<OrganizationNode>;
};

export type UpdateSuggestedArtifactMutation = {
  readonly __typename: "UpdateSuggestedArtifactMutation";
  readonly suggestedArtifact?: Maybe<SuggestedArtifactNode>;
};

export type UpdateSuggestedTopicMutation = {
  readonly __typename: "UpdateSuggestedTopicMutation";
  readonly meeting?: Maybe<MeetingNode>;
  readonly suggestedTopic?: Maybe<SuggestedTopicNode>;
};

export type UpdateTalentIndicatorMutation = {
  readonly __typename: "UpdateTalentIndicatorMutation";
  readonly talentIndicator: TalentIndicatorNode;
};

export type UpdateTopicDiscussionNotesMutation = {
  readonly __typename: "UpdateTopicDiscussionNotesMutation";
  readonly topic?: Maybe<TopicNode>;
};

export type UpdateUserMutation = {
  readonly __typename: "UpdateUserMutation";
  readonly user?: Maybe<UserNode>;
};

export type UpdateWorkHistoryMutation = {
  readonly __typename: "UpdateWorkHistoryMutation";
  readonly workHistorySummary?: Maybe<WorkHistorySummaryNode>;
};

export type UserBrainNode = Node & {
  readonly __typename: "UserBrainNode";
  readonly consolidated: Scalars["String"]["output"];
  /** The ID of the object */
  readonly id: Scalars["ID"]["output"];
  readonly lastDreamAt?: Maybe<Scalars["DateTime"]["output"]>;
  readonly lastLiveUpdateAt?: Maybe<Scalars["DateTime"]["output"]>;
  readonly liveNotes: Scalars["String"]["output"];
  readonly updated: Scalars["DateTime"]["output"];
};

export type UserKvItemNode = DjangoNode &
  Node & {
    readonly __typename: "UserKVItemNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly id: Scalars["ID"]["output"];
    readonly key?: Maybe<Scalars["String"]["output"]>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly value?: Maybe<Scalars["JSONString"]["output"]>;
  };

export type UserKvItemNodeConnection = {
  readonly __typename: "UserKVItemNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<UserKvItemNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `UserKVItemNode` and its cursor. */
export type UserKvItemNodeEdge = {
  readonly __typename: "UserKVItemNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<UserKvItemNode>;
};

/** An enumeration. */
export enum UserLastSeen {
  Lte_1Month = "LTE_1_MONTH",
  Lte_1Year = "LTE_1_YEAR",
  Lte_2Month = "LTE_2_MONTH",
  Lte_3Month = "LTE_3_MONTH",
  Lte_7Days = "LTE_7_DAYS",
  Lte_24Hours = "LTE_24_HOURS",
  Never = "NEVER",
  NotRecently = "NOT_RECENTLY",
}

/** An enumeration. */
export enum UserMeetingBotPreference {
  UseMeetingSetting = "use_meeting_setting",
  WhenOrganizer = "when_organizer",
  WhenParticipating = "when_participating",
}

export type UserMemberNode = DjangoNode &
  Node & {
    readonly __typename: "UserMemberNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly employeeId?: Maybe<Scalars["String"]["output"]>;
    readonly id: Scalars["ID"]["output"];
    readonly jobLevel?: Maybe<Scalars["String"]["output"]>;
    readonly location?: Maybe<Scalars["String"]["output"]>;
    readonly membershipStatus?: Maybe<AccountToOrganizationMembershipStatus>;
    readonly organization: OrganizationNode;
    readonly phoneNumber?: Maybe<Scalars["String"]["output"]>;
    readonly phoneNumberVerified: Scalars["Boolean"]["output"];
    readonly phoneNumberVerifiedAt?: Maybe<Scalars["DateTime"]["output"]>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly position?: Maybe<Scalars["String"]["output"]>;
    readonly role?: Maybe<OrganizationRole>;
    readonly startDate?: Maybe<Scalars["Date"]["output"]>;
    readonly user?: Maybe<UserNode>;
  };

export type UserMemberNodeConnection = {
  readonly __typename: "UserMemberNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<UserMemberNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `UserMemberNode` and its cursor. */
export type UserMemberNodeEdge = {
  readonly __typename: "UserMemberNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<UserMemberNode>;
};

export type UserNode = DjangoNode &
  Node & {
    readonly __typename: "UserNode";
    readonly activeAssessmentNominationCount: Scalars["Int"]["output"];
    readonly activities?: Maybe<ArtifactActivityNodeConnection>;
    readonly aiBrain?: Maybe<UserBrainNode>;
    /** Personal guidelines for AI chatbot responses */
    readonly aiGuidelines: Scalars["String"]["output"];
    readonly artifacts?: Maybe<ArtifactConnection>;
    readonly avatar?: Maybe<Scalars["String"]["output"]>;
    /** Cached calendar-insight sentence used as the homepage status when there is no daily work-history summary */
    readonly calendarInsightStatus?: Maybe<Scalars["String"]["output"]>;
    readonly calendarIsSyncingForFirstTime?: Maybe<
      Scalars["Boolean"]["output"]
    >;
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly currentRoles: ReadonlyArray<CareerTrackRoleNode>;
    readonly dailyBriefEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    readonly dailyBriefHour?: Maybe<Scalars["Int"]["output"]>;
    readonly directReports: UserNodeConnection;
    readonly email: Scalars["String"]["output"];
    readonly emailPreference?: Maybe<EmailPreference>;
    readonly emails: ReadonlyArray<Scalars["String"]["output"]>;
    readonly emailsWithNonFreeDomains?: Maybe<
      ReadonlyArray<Maybe<Scalars["String"]["output"]>>
    >;
    readonly enableDailyCommitmentEmails?: Maybe<Scalars["Boolean"]["output"]>;
    readonly enableDailySummaryEmails?: Maybe<Scalars["Boolean"]["output"]>;
    readonly enableDraftReminderEmails?: Maybe<Scalars["Boolean"]["output"]>;
    readonly eventLinkInDescriptionPreference?: Maybe<EventDescriptionLinkSetting>;
    readonly explorerBookmarks?: Maybe<ExplorerFilterBookmarkNodeConnection>;
    readonly favouriteArtifacts: ArtifactConnection;
    readonly favouritesGroups?: Maybe<FavouritesGroupNodeConnection>;
    readonly firstName: Scalars["String"]["output"];
    readonly futureRoles: ReadonlyArray<CareerTrackRoleNode>;
    readonly hasAsanaAuth?: Maybe<Scalars["Boolean"]["output"]>;
    readonly hasCalendarSyncError?: Maybe<Scalars["Boolean"]["output"]>;
    readonly hasClickupAuth?: Maybe<Scalars["Boolean"]["output"]>;
    readonly hasFirefliesPersonalApiToken?: Maybe<Scalars["Boolean"]["output"]>;
    readonly hasGithubAuth?: Maybe<Scalars["Boolean"]["output"]>;
    readonly hasGoogleCalAuth?: Maybe<Scalars["Boolean"]["output"]>;
    readonly hasGoogleSheetsAuth?: Maybe<Scalars["Boolean"]["output"]>;
    readonly hasGranolaPersonalApiToken?: Maybe<Scalars["Boolean"]["output"]>;
    readonly hasHubspotAuth?: Maybe<Scalars["Boolean"]["output"]>;
    readonly hasJiraAuth?: Maybe<Scalars["Boolean"]["output"]>;
    readonly hasOrgWithTooManyUsers?: Maybe<Scalars["Boolean"]["output"]>;
    readonly hasOutlookCalAuth?: Maybe<Scalars["Boolean"]["output"]>;
    readonly hasReadAiAuth?: Maybe<Scalars["Boolean"]["output"]>;
    readonly hasSalesforceAuth?: Maybe<Scalars["Boolean"]["output"]>;
    readonly hasSyncedCalendar?: Maybe<Scalars["Boolean"]["output"]>;
    readonly hasZoomAuth?: Maybe<Scalars["Boolean"]["output"]>;
    /** Cached one-line manager-facing status shown on the homepage, derived from the report's rolling 7-day work history */
    readonly homepageStatus?: Maybe<Scalars["String"]["output"]>;
    readonly id: Scalars["ID"]["output"];
    readonly insights?: Maybe<InsightConnection>;
    readonly invitations?: Maybe<InvitationNodeConnection>;
    /** Whether this user is in the management tree of the current user */
    readonly isInCurrentUserManagementTree: Scalars["Boolean"]["output"];
    /** Whether this user is in the reporting tree of the current user */
    readonly isInCurrentUserReportingTree: Scalars["Boolean"]["output"];
    readonly kvItems?: Maybe<UserKvItemNodeConnection>;
    readonly lastName: Scalars["String"]["output"];
    readonly lastSeenStr?: Maybe<UserLastSeen>;
    readonly legalFirstName?: Maybe<Scalars["String"]["output"]>;
    readonly managerInsights?: Maybe<ManagerInsightConnection>;
    readonly managers: UserNodeConnection;
    readonly managersList: ReadonlyArray<UserNode>;
    readonly meetingBotPreference?: Maybe<UserMeetingBotPreference>;
    readonly meetingPrepEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    readonly meetingPrepLeadTimeMinutes?: Maybe<Scalars["Int"]["output"]>;
    readonly meetingPrepOneononeOnly?: Maybe<Scalars["Boolean"]["output"]>;
    readonly meetingPreparationEmailPreference?: Maybe<MeetingAgendaEmailPreference>;
    readonly meetingSummaryEmailPreference?: Maybe<MeetingSummaryEmailPreference>;
    readonly meetings?: Maybe<MeetingNodeConnection>;
    readonly membershipStatus?: Maybe<AccountToOrganizationMembershipStatus>;
    readonly mostRecentlyReceivedRecognition?: Maybe<RecognitionArtifactNode>;
    readonly name: Scalars["String"]["output"];
    readonly onboardingData?: Maybe<Scalars["JSONString"]["output"]>;
    readonly onlyUserInOrg?: Maybe<Scalars["Boolean"]["output"]>;
    readonly organizationSpecificInfo?: Maybe<UserMemberNode>;
    readonly organizations: OrganizationNodeConnection;
    readonly organizationsAvailableToJoin?: Maybe<
      ReadonlyArray<Maybe<OrganizationInfoNode>>
    >;
    readonly ownedGoals?: Maybe<ArtifactConnection>;
    readonly paidFeatures: PaidFeaturesNode;
    readonly pastRoles: ReadonlyArray<CareerTrackRoleNode>;
    readonly peers: UserNodeConnection;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly primaryManager?: Maybe<UserNode>;
    readonly privateNotes?: Maybe<PrivateNoteNodeConnection>;
    readonly programAdminNotificationDownwardSubmitted?: Maybe<
      Scalars["Boolean"]["output"]
    >;
    readonly programNotificationPreference?: Maybe<ComplianceProgramNotificationPreference>;
    readonly pusherChannelName?: Maybe<Scalars["String"]["output"]>;
    readonly relationshipWithUser?: Maybe<RelationshipNode>;
    readonly relationships?: Maybe<RelationshipNodeConnection>;
    readonly reportingPredictions?: Maybe<UserReportingPredictionResultNode>;
    readonly reportingTreeIds: ReadonlyArray<Maybe<Scalars["Int"]["output"]>>;
    readonly showPersonalMeetings?: Maybe<Scalars["Boolean"]["output"]>;
    readonly status?: Maybe<UserStatus>;
    readonly surveyNotificationPreference?: Maybe<ComplianceProgramNotificationPreference>;
    readonly syncCredentials?: Maybe<UserSyncCredentialsNodeConnection>;
    readonly teams?: Maybe<TeamNodeConnection>;
    readonly teamsList: ReadonlyArray<TeamNode>;
    readonly timezone?: Maybe<Scalars["String"]["output"]>;
    readonly tiptapAiJwt?: Maybe<Scalars["String"]["output"]>;
    readonly uiPreferenceCache?: Maybe<Scalars["JSONString"]["output"]>;
    /** Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only. */
    readonly username: Scalars["String"]["output"];
    readonly videoRecordingPreference?: Maybe<UserVideoRecordingPreference>;
  };

export type UserNodeActivitiesArgs = {
  activityType?: InputMaybe<ArtifactActivityType>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  createdAfter?: InputMaybe<Scalars["DateTime"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UserNodeArtifactsArgs = {
  actionItemAssignedToMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignees?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  actionItemDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  actionItemProgress?: InputMaybe<Scalars["Float"]["input"]>;
  actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemStates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  ancestorsOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  artifactTypes?: InputMaybe<ReadonlyArray<InputMaybe<ArtifactType>>>;
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  asUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  assignedToMembersOfOrganizationId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  completedActionItemsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedActionItemsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  createdByIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  createdInMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackSenders?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackState?: InputMaybe<FeedbackState>;
  feedbackStates?: InputMaybe<ReadonlyArray<InputMaybe<FeedbackState>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  goalCompetencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalContributors?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalInvolvingUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalParentIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalResponsibilityIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalScope?: InputMaybe<GoalScope>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalState?: InputMaybe<GoalState>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalStatus?: InputMaybe<GoalStatus>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalVisibility?: InputMaybe<GoalVisibility>;
  goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  groupBy?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  isStale?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValue?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionReceivedByMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UserNodeAvatarArgs = {
  height?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UserNodeDirectReportsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type UserNodeExplorerBookmarksArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  private?: InputMaybe<Scalars["Boolean"]["input"]>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  title_Iexact?: InputMaybe<Scalars["String"]["input"]>;
};

export type UserNodeFavouriteArtifactsArgs = {
  actionItemAssignedToMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignees?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  actionItemDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  actionItemProgress?: InputMaybe<Scalars["Float"]["input"]>;
  actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemStates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  ancestorsOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  artifactTypes?: InputMaybe<ReadonlyArray<InputMaybe<ArtifactType>>>;
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  asUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  assignedToMembersOfOrganizationId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  completedActionItemsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedActionItemsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  createdByIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  createdInMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackSenders?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackState?: InputMaybe<FeedbackState>;
  feedbackStates?: InputMaybe<ReadonlyArray<InputMaybe<FeedbackState>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  goalCompetencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalContributors?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalInvolvingUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalParentIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalResponsibilityIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalScope?: InputMaybe<GoalScope>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalState?: InputMaybe<GoalState>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalStatus?: InputMaybe<GoalStatus>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalVisibility?: InputMaybe<GoalVisibility>;
  goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  groupBy?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  isStale?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValue?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionReceivedByMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UserNodeFavouritesGroupsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UserNodeInsightsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UserNodeInvitationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<InvitationStatus>;
};

export type UserNodeKvItemsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  key_Startswith?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UserNodeManagerInsightsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UserNodeManagersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type UserNodeMeetingsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  draft?: InputMaybe<Scalars["Boolean"]["input"]>;
  endDatetime?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDatetime_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  excludeMeetingGroupIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  fromMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  ignored?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFinalized?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFormalOneonone?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  minimumDateRange?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Decimal"]["input"]>;
  participantCount?: InputMaybe<Scalars["Int"]["input"]>;
  participants?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  startDatetime?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  status?: InputMaybe<EventStatus>;
  status_In?: InputMaybe<ReadonlyArray<InputMaybe<EventStatus>>>;
  subject?: InputMaybe<Scalars["Int"]["input"]>;
  templateId?: InputMaybe<Scalars["Int"]["input"]>;
  unscheduled?: InputMaybe<Scalars["Boolean"]["input"]>;
  usingRequiredTemplateOfValidPrograms?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
};

export type UserNodeMembershipStatusArgs = {
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UserNodeOrganizationSpecificInfoArgs = {
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UserNodeOrganizationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  personal?: InputMaybe<Scalars["Boolean"]["input"]>;
  userIsAdmin?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UserNodeOwnedGoalsArgs = {
  actionItemAssignedToMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemAssignees?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  actionItemDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  actionItemProgress?: InputMaybe<Scalars["Float"]["input"]>;
  actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemStates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  ancestorsOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  artifactTypes?: InputMaybe<ReadonlyArray<InputMaybe<ArtifactType>>>;
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  asUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  assignedToMembersOfOrganizationId?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  completedActionItemsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedActionItemsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForFlow?: InputMaybe<Scalars["Int"]["input"]>;
  completedGoalsForMeetingGroup?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  createdByIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  createdInMeetingId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackSenders?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  feedbackState?: InputMaybe<FeedbackState>;
  feedbackStates?: InputMaybe<ReadonlyArray<InputMaybe<FeedbackState>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  goalCompetencyIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalContributors?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalDueBetweenDates?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
  >;
  goalInvolvingUsers?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalOwners?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalParentIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalResponsibilityIds?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  goalScope?: InputMaybe<GoalScope>;
  goalScopes?: InputMaybe<ReadonlyArray<InputMaybe<GoalScope>>>;
  goalState?: InputMaybe<GoalState>;
  goalStates?: InputMaybe<ReadonlyArray<InputMaybe<GoalState>>>;
  goalStatus?: InputMaybe<GoalStatus>;
  goalTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  goalVisibility?: InputMaybe<GoalVisibility>;
  goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  groupBy?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  idsToMergeInApolloCache?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  isStale?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValue?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionReceivedByMembersOfTeam?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipients?: InputMaybe<
    ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
  >;
  relatedToTopic?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UserNodePeersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  hasNoManagerInOrg?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActiveOrInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  managerIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  reportIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type UserNodePrivateNotesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
};

export type UserNodeRelationshipWithUserArgs = {
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  otherUserId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UserNodeRelationshipsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  primaryRelationshipType?: InputMaybe<RelationshipType>;
  primaryUser?: InputMaybe<Scalars["ID"]["input"]>;
  secondaryUser?: InputMaybe<Scalars["ID"]["input"]>;
};

export type UserNodeReportingPredictionsArgs = {
  organizationId: Scalars["Int"]["input"];
};

export type UserNodeSyncCredentialsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UserNodeTeamsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  organization?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  title_Startswith?: InputMaybe<Scalars["String"]["input"]>;
};

export type UserNodeConnection = {
  readonly __typename: "UserNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<UserNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `UserNode` and its cursor. */
export type UserNodeEdge = {
  readonly __typename: "UserNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<UserNode>;
};

export type UserReportConnection = {
  readonly __typename: "UserReportConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<UserReportEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `UserReport` and its cursor. */
export type UserReportEdge = {
  readonly __typename: "UserReportEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<UserReportNode>;
};

export type UserReportNode = {
  readonly __typename: "UserReportNode";
  readonly lastMeeting?: Maybe<MeetingInfoNode>;
  readonly manager?: Maybe<UserNode>;
  readonly nextMeeting?: Maybe<MeetingInfoNode>;
  readonly user?: Maybe<UserNode>;
};

export type UserReportingPredictionNode = {
  readonly __typename: "UserReportingPredictionNode";
  readonly confidence: Scalars["Float"]["output"];
  readonly evidence: Scalars["JSONString"]["output"];
  readonly otherUser: BasicUserNode;
  readonly predictedDirection: ReportingPredictionDirection;
  readonly scoredAt: Scalars["DateTime"]["output"];
  readonly subjectUser: BasicUserNode;
};

export type UserReportingPredictionResultNode = {
  readonly __typename: "UserReportingPredictionResultNode";
  readonly expiresAt?: Maybe<Scalars["DateTime"]["output"]>;
  readonly generatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  readonly predictions: ReadonlyArray<UserReportingPredictionNode>;
  readonly status: ReportingPredictionStatus;
};

export type UserSocialAuthNode = DjangoNode &
  Node & {
    readonly __typename: "UserSocialAuthNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly extraData: Scalars["JSONString"]["output"];
    readonly id: Scalars["ID"]["output"];
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly uid: Scalars["String"]["output"];
  };

/** An enumeration. */
export enum UserStatus {
  Active = "active",
  Demo = "demo",
  Inactive = "inactive",
  Invited = "invited",
}

export type UserSyncCredentialsNode = DjangoNode &
  Node & {
    readonly __typename: "UserSyncCredentialsNode";
    readonly calendarSyncMetadata: Scalars["JSONString"]["output"];
    /** for draft meetings, the credentials to use when creating the meeting */
    readonly calendarmeetinggroupSet: CalendarMeetingGroupNodeConnection;
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly credentials: UserSocialAuthNode;
    readonly credentialsUid?: Maybe<Scalars["String"]["output"]>;
    readonly defaultEventVisibility: CoreUserSyncCredentialsByOrgDefaultEventVisibilityChoices;
    readonly googlesheetskpiintegrationSet: ReadonlyArray<GoogleSheetsKpiIntegrationNode>;
    readonly hasCalendarWriteCredentials?: Maybe<Scalars["Boolean"]["output"]>;
    readonly hasValidCalendarCredentials?: Maybe<Scalars["Boolean"]["output"]>;
    readonly id: Scalars["ID"]["output"];
    readonly lastCalendarSyncEnd?: Maybe<Scalars["DateTime"]["output"]>;
    readonly lastCalendarSyncStart?: Maybe<Scalars["DateTime"]["output"]>;
    readonly lastFullSync?: Maybe<Scalars["DateTime"]["output"]>;
    readonly organization?: Maybe<OrganizationNode>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly provider?: Maybe<SyncCredentialsTypeEnum>;
    readonly user?: Maybe<UserNode>;
    readonly webhookExpiration?: Maybe<Scalars["DateTime"]["output"]>;
    readonly webhookId?: Maybe<Scalars["String"]["output"]>;
  };

export type UserSyncCredentialsNodeCalendarmeetinggroupSetArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  draft?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  ignored?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId?: InputMaybe<Scalars["Decimal"]["input"]>;
};

export type UserSyncCredentialsNodeConnection = {
  readonly __typename: "UserSyncCredentialsNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<UserSyncCredentialsNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `UserSyncCredentialsNode` and its cursor. */
export type UserSyncCredentialsNodeEdge = {
  readonly __typename: "UserSyncCredentialsNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<UserSyncCredentialsNode>;
};

/** An enumeration. */
export enum UserVideoRecordingPreference {
  Never = "never",
  WhenOrganizer = "when_organizer",
  WhenParticipating = "when_participating",
}

export type VerifyPhoneNumberMutation = {
  readonly __typename: "VerifyPhoneNumberMutation";
  readonly membership?: Maybe<UserMemberNode>;
};

export type VirtualAssessmentSectionConnection = {
  readonly __typename: "VirtualAssessmentSectionConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<VirtualAssessmentSectionEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `VirtualAssessmentSection` and its cursor. */
export type VirtualAssessmentSectionEdge = {
  readonly __typename: "VirtualAssessmentSectionEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<VirtualAssessmentSectionNode>;
};

export type VirtualAssessmentSectionNode = AssessmentSectionInterface & {
  readonly __typename: "VirtualAssessmentSectionNode";
  readonly description?: Maybe<Scalars["JSONString"]["output"]>;
  readonly id: Scalars["ID"]["output"];
  readonly questions: AssessmentGroupQuestionContainerConnection;
  readonly subjectVisibility: AssessmentSectionSubjectVisibility;
  readonly title?: Maybe<Scalars["String"]["output"]>;
};

export type VirtualAssessmentSectionNodeQuestionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type WorkHistoryCollaborationConnection = {
  readonly __typename: "WorkHistoryCollaborationConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<WorkHistoryCollaborationEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `WorkHistoryCollaboration` and its cursor. */
export type WorkHistoryCollaborationEdge = {
  readonly __typename: "WorkHistoryCollaborationEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<WorkHistoryCollaborationNode>;
};

export type WorkHistoryCollaborationNode = {
  readonly __typename: "WorkHistoryCollaborationNode";
  readonly collaborationCount: Scalars["Int"]["output"];
  readonly user?: Maybe<UserNode>;
};

export type WorkHistorySummaryInput = {
  readonly sections?: InputMaybe<
    ReadonlyArray<InputMaybe<WorkHistorySummarySectionInput>>
  >;
  readonly summary?: InputMaybe<Scalars["String"]["input"]>;
};

export type WorkHistorySummaryNode = DjangoNode &
  Node & {
    readonly __typename: "WorkHistorySummaryNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly collaborators: WorkHistoryCollaborationConnection;
    readonly created: Scalars["DateTime"]["output"];
    readonly externalEventData: Scalars["JSONString"]["output"];
    readonly externalEventDataSummaries: Scalars["JSONString"]["output"];
    readonly id: Scalars["ID"]["output"];
    readonly meetingCount: Scalars["Int"]["output"];
    readonly meetingTimeHours: Scalars["Float"]["output"];
    /** Place for summary subject to override the AI generated content */
    readonly modifiedSummary?: Maybe<Scalars["String"]["output"]>;
    readonly organization?: Maybe<OrganizationNode>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly sections: WorkHistorySummarySectionNodeConnection;
    readonly subject?: Maybe<UserNode>;
    readonly summary: Scalars["String"]["output"];
    /** Inclusive end date of the data summarized, includes all data up until midnight the next day */
    readonly summaryEndDate: Scalars["Date"]["output"];
    /** The start date of the data summarized, includes all data starting at midnight that day */
    readonly summaryStartDate: Scalars["Date"]["output"];
  };

export type WorkHistorySummaryNodeCollaboratorsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type WorkHistorySummaryNodeSectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type WorkHistorySummarySectionInput = {
  readonly content: Scalars["String"]["input"];
  readonly hidden: Scalars["Boolean"]["input"];
  readonly id?: InputMaybe<Scalars["Int"]["input"]>;
  readonly title: Scalars["String"]["input"];
};

export type WorkHistorySummarySectionNode = DjangoNode &
  Node & {
    readonly __typename: "WorkHistorySummarySectionNode";
    readonly aiGenerated: Scalars["Boolean"]["output"];
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly content: Scalars["String"]["output"];
    readonly hidden: Scalars["Boolean"]["output"];
    readonly id: Scalars["ID"]["output"];
    /** Place for summary subject to override the AI generated content */
    readonly modifiedContent?: Maybe<Scalars["String"]["output"]>;
    /** Place for summary subject to override the AI generated content */
    readonly modifiedTitle?: Maybe<Scalars["String"]["output"]>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly title: Scalars["String"]["output"];
  };

export type WorkHistorySummarySectionNodeConnection = {
  readonly __typename: "WorkHistorySummarySectionNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<WorkHistorySummarySectionNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `WorkHistorySummarySectionNode` and its cursor. */
export type WorkHistorySummarySectionNodeEdge = {
  readonly __typename: "WorkHistorySummarySectionNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<WorkHistorySummarySectionNode>;
};

export type WorkflowNode = DjangoNode &
  Node & {
    readonly __typename: "WorkflowNode";
    readonly canDelete?: Maybe<PermissionNode>;
    readonly canRead?: Maybe<PermissionNode>;
    readonly canUpdate?: Maybe<PermissionNode>;
    readonly created?: Maybe<Scalars["DateTime"]["output"]>;
    readonly creator?: Maybe<UserNode>;
    readonly description?: Maybe<Scalars["String"]["output"]>;
    readonly id: Scalars["ID"]["output"];
    readonly organization?: Maybe<OrganizationNode>;
    readonly pk?: Maybe<Scalars["Int"]["output"]>;
    readonly state?: Maybe<WorkflowState>;
    readonly title?: Maybe<Scalars["String"]["output"]>;
    readonly updated?: Maybe<Scalars["DateTime"]["output"]>;
  };

export type WorkflowNodeConnection = {
  readonly __typename: "WorkflowNodeConnection";
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<WorkflowNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars["Int"]["output"];
};

/** A Relay edge containing a `WorkflowNode` and its cursor. */
export type WorkflowNodeEdge = {
  readonly __typename: "WorkflowNodeEdge";
  /** A cursor for use in pagination */
  readonly cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  readonly node?: Maybe<WorkflowNode>;
};

/** An enumeration. */
export enum WorkflowState {
  Active = "active",
  Disabled = "disabled",
}

export type YouTrackIssueNode = InfoCardInterface & {
  readonly __typename: "YouTrackIssueNode";
  readonly assignees: ReadonlyArray<Maybe<ExternalProfileNode>>;
  readonly closedAt?: Maybe<Scalars["DateTime"]["output"]>;
  readonly created: Scalars["DateTime"]["output"];
  readonly description?: Maybe<Scalars["String"]["output"]>;
  readonly id: Scalars["ID"]["output"];
  readonly issueType?: Maybe<Scalars["String"]["output"]>;
  readonly providerName?: Maybe<Scalars["String"]["output"]>;
  readonly reporter?: Maybe<ExternalProfileNode>;
  readonly resolved?: Maybe<Scalars["DateTime"]["output"]>;
  readonly status?: Maybe<InfoTaskStatus>;
  readonly title: Scalars["String"]["output"];
  readonly updated?: Maybe<Scalars["DateTime"]["output"]>;
  readonly updater?: Maybe<ExternalProfileNode>;
  readonly url: Scalars["String"]["output"];
};

export type YouTrackProjectNode = InfoCardInterface & {
  readonly __typename: "YouTrackProjectNode";
  readonly archived?: Maybe<Scalars["Boolean"]["output"]>;
  readonly assignees: ReadonlyArray<Maybe<ExternalProfileNode>>;
  readonly closedAt?: Maybe<Scalars["DateTime"]["output"]>;
  readonly created: Scalars["DateTime"]["output"];
  readonly createdBy?: Maybe<ExternalProfileNode>;
  readonly description?: Maybe<Scalars["String"]["output"]>;
  readonly iconUrl?: Maybe<Scalars["String"]["output"]>;
  readonly id: Scalars["ID"]["output"];
  readonly leader?: Maybe<ExternalProfileNode>;
  readonly name?: Maybe<Scalars["String"]["output"]>;
  readonly providerName?: Maybe<Scalars["String"]["output"]>;
  readonly shortName?: Maybe<Scalars["String"]["output"]>;
  readonly status?: Maybe<InfoTaskStatus>;
  readonly teamId?: Maybe<Scalars["String"]["output"]>;
  readonly teamName?: Maybe<Scalars["String"]["output"]>;
  readonly title: Scalars["String"]["output"];
  readonly url: Scalars["String"]["output"];
};

export type ZoomMeetingNode = {
  readonly __typename: "ZoomMeetingNode";
  readonly joinUrl?: Maybe<Scalars["String"]["output"]>;
  readonly meetingId?: Maybe<Scalars["Int"]["output"]>;
};

export type AiBrainFieldsFragment = {
  readonly __typename: "UserBrainNode";
  readonly id: number;
  readonly consolidated: string;
  readonly liveNotes: string;
  readonly lastDreamAt?: string | null;
  readonly lastLiveUpdateAt?: string | null;
  readonly updated: string;
};

export type GetAiBrainQueryVariables = Exact<{ [key: string]: never }>;

export type GetAiBrainQuery = {
  readonly __typename: "Query";
  readonly me?: {
    readonly __typename: "UserNode";
    readonly aiBrain?: {
      readonly __typename: "UserBrainNode";
      readonly id: number;
      readonly consolidated: string;
      readonly liveNotes: string;
      readonly lastDreamAt?: string | null;
      readonly lastLiveUpdateAt?: string | null;
      readonly updated: string;
    } | null;
  } | null;
};

export type UpdateAiBrainMutationVariables = Exact<{
  content: Scalars["String"]["input"];
}>;

export type UpdateAiBrainMutation = {
  readonly __typename: "Mutation";
  readonly updateAiBrainConsolidated?: {
    readonly __typename: "UpdateAiBrainConsolidatedMutation";
    readonly aiBrain?: {
      readonly __typename: "UserBrainNode";
      readonly id: number;
      readonly consolidated: string;
      readonly liveNotes: string;
      readonly lastDreamAt?: string | null;
      readonly lastLiveUpdateAt?: string | null;
      readonly updated: string;
    } | null;
  } | null;
};

export type AiSkillsOverviewQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type AiSkillsOverviewQuery = {
  readonly __typename: "Query";
  readonly aiSkillsOverview: ReadonlyArray<
    | {
        readonly __typename: "PlatformSkillType";
        readonly name: string;
        readonly slug: string;
        readonly description: string;
        readonly body: string;
        readonly visibility: SkillVisibilityEnum;
        readonly canEdit: boolean;
        readonly canArchive: boolean;
        readonly isScheduled: boolean;
        readonly platformId: string;
      }
    | {
        readonly __typename: "SkillNode";
        readonly id: string;
        readonly name: string;
        readonly slug: string;
        readonly description: string;
        readonly body: string;
        readonly visibility: SkillVisibilityEnum;
        readonly canEdit: boolean;
        readonly canArchive: boolean;
        readonly isScheduled: boolean;
      }
  >;
};

export type AskAiArchiveSkillMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type AskAiArchiveSkillMutation = {
  readonly __typename: "Mutation";
  readonly archiveSkill?: {
    readonly __typename: "ArchiveSkillMutation";
    readonly skill?: {
      readonly __typename: "SkillNode";
      readonly id: string;
      readonly archivedAt?: string | null;
    } | null;
  } | null;
};

export type AskAiCreateOrUpdateSkillMutationVariables = Exact<{
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  name: Scalars["String"]["input"];
  description: Scalars["String"]["input"];
  body: Scalars["String"]["input"];
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  forkFromSlug?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type AskAiCreateOrUpdateSkillMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateSkill?: {
    readonly __typename: "CreateOrUpdateSkillMutation";
    readonly skill?: {
      readonly __typename: "SkillNode";
      readonly id: string;
      readonly name: string;
      readonly slug: string;
      readonly description: string;
      readonly body: string;
      readonly updated: string;
    } | null;
  } | null;
};

export type AskAiCreateRoutineMutationVariables = Exact<{
  skillId?: InputMaybe<Scalars["String"]["input"]>;
  skillSlug: Scalars["String"]["input"];
  triggerType: Scalars["String"]["input"];
  triggerConfig: Scalars["JSONString"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type AskAiCreateRoutineMutation = {
  readonly __typename: "Mutation";
  readonly createRoutine?: {
    readonly __typename: "CreateRoutineMutation";
    readonly routine?: {
      readonly __typename: "RoutineNode";
      readonly id: string;
      readonly name: string;
      readonly skillId: string;
      readonly skillSlug: string;
      readonly enabled: boolean;
      readonly triggerType: string;
      readonly triggerConfig: any;
      readonly skillExists: boolean;
      readonly selectedMeetingGroups: ReadonlyArray<{
        readonly __typename: "RoutineSelectedMeetingGroupType";
        readonly id: number;
        readonly title?: string | null;
      }>;
    } | null;
  } | null;
};

export type AskAiDeleteRoutineMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type AskAiDeleteRoutineMutation = {
  readonly __typename: "Mutation";
  readonly deleteRoutine?: {
    readonly __typename: "DeleteRoutineMutation";
    readonly ok?: boolean | null;
  } | null;
};

export type GetAccountQueryVariables = Exact<{ [key: string]: never }>;

export type GetAccountQuery = {
  readonly __typename: "Query";
  readonly me?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly email: string;
    readonly name: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly emailPreference?: EmailPreference | null;
    readonly meetingSummaryEmailPreference?: MeetingSummaryEmailPreference | null;
    readonly programNotificationPreference?: ComplianceProgramNotificationPreference | null;
    readonly surveyNotificationPreference?: ComplianceProgramNotificationPreference | null;
    readonly programAdminNotificationDownwardSubmitted?: boolean | null;
    readonly timezone?: string | null;
    readonly meetingPreparationEmailPreference?: MeetingAgendaEmailPreference | null;
    readonly meetingBotPreference?: UserMeetingBotPreference | null;
    readonly videoRecordingPreference?: UserVideoRecordingPreference | null;
    readonly showPersonalMeetings?: boolean | null;
    readonly enableDailySummaryEmails?: boolean | null;
    readonly enableDailyCommitmentEmails?: boolean | null;
    readonly enableDraftReminderEmails?: boolean | null;
    readonly dailyBriefEnabled?: boolean | null;
    readonly dailyBriefHour?: number | null;
    readonly meetingPrepEnabled?: boolean | null;
    readonly meetingPrepLeadTimeMinutes?: number | null;
    readonly meetingPrepOneononeOnly?: boolean | null;
    readonly aiGuidelines: string;
    readonly emails: ReadonlyArray<string>;
    readonly hasAsanaAuth?: boolean | null;
    readonly hasZoomAuth?: boolean | null;
    readonly hasGithubAuth?: boolean | null;
    readonly hasJiraAuth?: boolean | null;
    readonly hasClickupAuth?: boolean | null;
    readonly hasSalesforceAuth?: boolean | null;
    readonly hasHubspotAuth?: boolean | null;
    readonly hasReadAiAuth?: boolean | null;
    readonly hasGranolaPersonalApiToken?: boolean | null;
    readonly hasFirefliesPersonalApiToken?: boolean | null;
    readonly organizations: {
      readonly __typename: "OrganizationNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "OrganizationNodeEdge";
        readonly node?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
          readonly name: string;
          readonly personal?: boolean | null;
          readonly hasSlackConnection?: boolean | null;
          readonly hasTeamsInstallation?: boolean | null;
          readonly hasTeamsNotificationConnection?: boolean | null;
          readonly userMembership?: {
            readonly __typename: "UserMemberNode";
            readonly id: number;
            readonly position?: string | null;
            readonly phoneNumber?: string | null;
            readonly phoneNumberVerified: boolean;
            readonly phoneNumberVerifiedAt?: string | null;
          } | null;
          readonly directorySync?: {
            readonly __typename: "DirectorySyncNode";
            readonly id?: string | null;
            readonly state?: string | null;
            readonly type?: string | null;
            readonly name?: string | null;
          } | null;
          readonly members: {
            readonly __typename: "UserMemberNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "UserMemberNodeEdge";
              readonly node?: {
                readonly __typename: "UserMemberNode";
                readonly id: number;
                readonly user?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly name: string;
                  readonly avatar?: string | null;
                } | null;
              } | null;
            } | null>;
          };
        } | null;
      } | null>;
    };
    readonly managers: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null>;
    };
    readonly relationships?: {
      readonly __typename: "RelationshipNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "RelationshipNodeEdge";
        readonly node?: {
          readonly __typename: "RelationshipNode";
          readonly id: number;
          readonly relationshipWithOtherUser?: RelationshipType | null;
          readonly organization?: {
            readonly __typename: "OrganizationNode";
            readonly id: number;
          } | null;
          readonly otherUser?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
        } | null;
      } | null>;
    } | null;
    readonly teams?: {
      readonly __typename: "TeamNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "TeamNodeEdge";
        readonly node?: {
          readonly __typename: "TeamNode";
          readonly id: number;
          readonly title: string;
          readonly organization?: {
            readonly __typename: "OrganizationNode";
            readonly id: number;
          } | null;
        } | null;
      } | null>;
    } | null;
    readonly organizationsAvailableToJoin?: ReadonlyArray<{
      readonly __typename: "OrganizationInfoNode";
      readonly organizationId?: number | null;
      readonly organizationName?: string | null;
      readonly organizationMemberCount?: number | null;
    } | null> | null;
    readonly syncCredentials?: {
      readonly __typename: "UserSyncCredentialsNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserSyncCredentialsNodeEdge";
        readonly node?: {
          readonly __typename: "UserSyncCredentialsNode";
          readonly id: number;
          readonly provider?: SyncCredentialsTypeEnum | null;
          readonly lastCalendarSyncStart?: string | null;
          readonly lastCalendarSyncEnd?: string | null;
          readonly hasValidCalendarCredentials?: boolean | null;
          readonly hasCalendarWriteCredentials?: boolean | null;
          readonly credentialsUid?: string | null;
          readonly organization?: {
            readonly __typename: "OrganizationNode";
            readonly id: number;
            readonly name: string;
            readonly personal?: boolean | null;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type JoinOrganizationMutationMutationVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
}>;

export type JoinOrganizationMutationMutation = {
  readonly __typename: "Mutation";
  readonly joinOrganization?: {
    readonly __typename: "JoinOrganizationMutation";
    readonly user?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly syncCredentials?: {
        readonly __typename: "UserSyncCredentialsNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "UserSyncCredentialsNodeEdge";
          readonly node?: {
            readonly __typename: "UserSyncCredentialsNode";
            readonly id: number;
            readonly provider?: SyncCredentialsTypeEnum | null;
            readonly lastCalendarSyncStart?: string | null;
            readonly lastCalendarSyncEnd?: string | null;
            readonly hasValidCalendarCredentials?: boolean | null;
            readonly hasCalendarWriteCredentials?: boolean | null;
            readonly credentialsUid?: string | null;
            readonly organization?: {
              readonly __typename: "OrganizationNode";
              readonly id: number;
              readonly name: string;
              readonly personal?: boolean | null;
            } | null;
          } | null;
        } | null>;
      } | null;
      readonly organizationsAvailableToJoin?: ReadonlyArray<{
        readonly __typename: "OrganizationInfoNode";
        readonly organizationId?: number | null;
        readonly organizationName?: string | null;
        readonly organizationMemberCount?: number | null;
      } | null> | null;
      readonly organizations: {
        readonly __typename: "OrganizationNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "OrganizationNodeEdge";
          readonly node?: {
            readonly __typename: "OrganizationNode";
            readonly id: number;
            readonly name: string;
            readonly personal?: boolean | null;
            readonly hasSlackConnection?: boolean | null;
            readonly hasTeamsInstallation?: boolean | null;
            readonly hasTeamsNotificationConnection?: boolean | null;
            readonly userMembership?: {
              readonly __typename: "UserMemberNode";
              readonly id: number;
              readonly position?: string | null;
              readonly phoneNumber?: string | null;
              readonly phoneNumberVerified: boolean;
              readonly phoneNumberVerifiedAt?: string | null;
            } | null;
            readonly directorySync?: {
              readonly __typename: "DirectorySyncNode";
              readonly id?: string | null;
              readonly state?: string | null;
              readonly type?: string | null;
              readonly name?: string | null;
            } | null;
            readonly members: {
              readonly __typename: "UserMemberNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "UserMemberNodeEdge";
                readonly node?: {
                  readonly __typename: "UserMemberNode";
                  readonly id: number;
                  readonly user?: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly name: string;
                    readonly avatar?: string | null;
                  } | null;
                } | null;
              } | null>;
            };
          } | null;
        } | null>;
      };
    } | null;
  } | null;
};

export type LinkCalendarToOrganizationMutationMutationVariables = Exact<{
  credentialsId: Scalars["Int"]["input"];
  organizationId: Scalars["Int"]["input"];
}>;

export type LinkCalendarToOrganizationMutationMutation = {
  readonly __typename: "Mutation";
  readonly linkCalendarToOrganization?: {
    readonly __typename: "LinkCalendarToOrganizationMutation";
    readonly user?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly syncCredentials?: {
        readonly __typename: "UserSyncCredentialsNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "UserSyncCredentialsNodeEdge";
          readonly node?: {
            readonly __typename: "UserSyncCredentialsNode";
            readonly id: number;
            readonly provider?: SyncCredentialsTypeEnum | null;
            readonly lastCalendarSyncStart?: string | null;
            readonly lastCalendarSyncEnd?: string | null;
            readonly hasValidCalendarCredentials?: boolean | null;
            readonly hasCalendarWriteCredentials?: boolean | null;
            readonly credentialsUid?: string | null;
            readonly organization?: {
              readonly __typename: "OrganizationNode";
              readonly id: number;
              readonly name: string;
              readonly personal?: boolean | null;
            } | null;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type MySkillsQueryVariables = Exact<{ [key: string]: never }>;

export type MySkillsQuery = {
  readonly __typename: "Query";
  readonly mySkills: ReadonlyArray<{
    readonly __typename: "SkillNode";
    readonly id: string;
    readonly name: string;
    readonly slug: string;
    readonly description: string;
    readonly body: string;
    readonly visibility: SkillVisibilityEnum;
    readonly canEdit: boolean;
    readonly canArchive: boolean;
    readonly updated: string;
    readonly created: string;
  }>;
};

export type AccountOrganizationFragmentFragment = {
  readonly __typename: "OrganizationNode";
  readonly id: number;
  readonly name: string;
  readonly personal?: boolean | null;
  readonly hasSlackConnection?: boolean | null;
  readonly hasTeamsInstallation?: boolean | null;
  readonly hasTeamsNotificationConnection?: boolean | null;
  readonly userMembership?: {
    readonly __typename: "UserMemberNode";
    readonly id: number;
    readonly position?: string | null;
    readonly phoneNumber?: string | null;
    readonly phoneNumberVerified: boolean;
    readonly phoneNumberVerifiedAt?: string | null;
  } | null;
  readonly directorySync?: {
    readonly __typename: "DirectorySyncNode";
    readonly id?: string | null;
    readonly state?: string | null;
    readonly type?: string | null;
    readonly name?: string | null;
  } | null;
  readonly members: {
    readonly __typename: "UserMemberNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "UserMemberNodeEdge";
      readonly node?: {
        readonly __typename: "UserMemberNode";
        readonly id: number;
        readonly user?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null;
    } | null>;
  };
};

export type RemoveAsanaIntegrationMutationMutationVariables = Exact<{
  [key: string]: never;
}>;

export type RemoveAsanaIntegrationMutationMutation = {
  readonly __typename: "Mutation";
  readonly removeAsanaIntegration?: {
    readonly __typename: "RemoveAsanaIntegrationMutation";
    readonly user?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly hasAsanaAuth?: boolean | null;
    } | null;
  } | null;
};

export type RemoveClickupIntegrationMutationMutationVariables = Exact<{
  [key: string]: never;
}>;

export type RemoveClickupIntegrationMutationMutation = {
  readonly __typename: "Mutation";
  readonly removeClickupIntegration?: {
    readonly __typename: "RemoveClickupIntegrationMutation";
    readonly user?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly hasClickupAuth?: boolean | null;
    } | null;
  } | null;
};

export type RemoveGitHubIntegrationMutationMutationVariables = Exact<{
  [key: string]: never;
}>;

export type RemoveGitHubIntegrationMutationMutation = {
  readonly __typename: "Mutation";
  readonly removeGithubIntegration?: {
    readonly __typename: "RemoveGitHubIntegrationMutation";
    readonly user?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly hasGithubAuth?: boolean | null;
    } | null;
  } | null;
};

export type RemoveHubspotIntegrationMutationMutationVariables = Exact<{
  [key: string]: never;
}>;

export type RemoveHubspotIntegrationMutationMutation = {
  readonly __typename: "Mutation";
  readonly removeHubspotIntegration?: {
    readonly __typename: "RemoveHubspotIntegrationMutation";
    readonly user?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly hasHubspotAuth?: boolean | null;
    } | null;
  } | null;
};

export type RemoveIntegrationCredentialsMutationMutationVariables = Exact<{
  credentialsId: Scalars["Int"]["input"];
}>;

export type RemoveIntegrationCredentialsMutationMutation = {
  readonly __typename: "Mutation";
  readonly removeIntegrationCredentials?: {
    readonly __typename: "RemoveIntegrationCredentialsMutation";
    readonly user?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly syncCredentials?: {
        readonly __typename: "UserSyncCredentialsNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "UserSyncCredentialsNodeEdge";
          readonly node?: {
            readonly __typename: "UserSyncCredentialsNode";
            readonly id: number;
            readonly provider?: SyncCredentialsTypeEnum | null;
            readonly lastCalendarSyncStart?: string | null;
            readonly lastCalendarSyncEnd?: string | null;
            readonly hasValidCalendarCredentials?: boolean | null;
            readonly hasCalendarWriteCredentials?: boolean | null;
            readonly credentialsUid?: string | null;
            readonly organization?: {
              readonly __typename: "OrganizationNode";
              readonly id: number;
              readonly name: string;
              readonly personal?: boolean | null;
            } | null;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type RemoveJiraIntegrationMutationMutationVariables = Exact<{
  [key: string]: never;
}>;

export type RemoveJiraIntegrationMutationMutation = {
  readonly __typename: "Mutation";
  readonly removeJiraIntegration?: {
    readonly __typename: "RemoveJiraIntegrationMutation";
    readonly user?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly hasJiraAuth?: boolean | null;
    } | null;
  } | null;
};

export type RemovePersonalTranscriptSyncCredentialMutationMutationVariables =
  Exact<{
    provider: PersonalTranscriptSyncCredentialProviderEnum;
  }>;

export type RemovePersonalTranscriptSyncCredentialMutationMutation = {
  readonly __typename: "Mutation";
  readonly removePersonalTranscriptSyncCredential?: {
    readonly __typename: "RemovePersonalTranscriptSyncCredentialMutation";
    readonly user?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly hasGranolaPersonalApiToken?: boolean | null;
      readonly hasFirefliesPersonalApiToken?: boolean | null;
    } | null;
  } | null;
};

export type RemoveReadAiIntegrationMutationMutationVariables = Exact<{
  [key: string]: never;
}>;

export type RemoveReadAiIntegrationMutationMutation = {
  readonly __typename: "Mutation";
  readonly removeReadAiIntegration?: {
    readonly __typename: "RemoveReadAiIntegrationMutation";
    readonly user?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly hasReadAiAuth?: boolean | null;
    } | null;
  } | null;
};

export type RemoveSalesforceIntegrationMutationMutationVariables = Exact<{
  [key: string]: never;
}>;

export type RemoveSalesforceIntegrationMutationMutation = {
  readonly __typename: "Mutation";
  readonly removeSalesforceIntegration?: {
    readonly __typename: "RemoveSalesforceIntegrationMutation";
    readonly user?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly hasSalesforceAuth?: boolean | null;
    } | null;
  } | null;
};

export type RemoveZoomIntegrationMutationMutationVariables = Exact<{
  [key: string]: never;
}>;

export type RemoveZoomIntegrationMutationMutation = {
  readonly __typename: "Mutation";
  readonly removeZoomIntegration?: {
    readonly __typename: "RemoveZoomIntegrationMutation";
    readonly user?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly hasZoomAuth?: boolean | null;
    } | null;
  } | null;
};

export type RequestExportMutationMutationVariables = Exact<{
  [key: string]: never;
}>;

export type RequestExportMutationMutation = {
  readonly __typename: "Mutation";
  readonly requestExport?: {
    readonly __typename: "RequestExportMutation";
    readonly user?: {
      readonly __typename: "UserNode";
      readonly email: string;
    } | null;
  } | null;
};

export type RoutineMeetingGroupsQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  search?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type RoutineMeetingGroupsQuery = {
  readonly __typename: "Query";
  readonly meetingGroups?: {
    readonly __typename: "MeetingGroupNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "MeetingGroupNodeEdge";
      readonly node?: {
        readonly __typename: "MeetingGroupNode";
        readonly id: number;
        readonly title: string;
        readonly isFormalOneonone: boolean;
        readonly recurrenceRule?: string | null;
      } | null;
    } | null>;
  } | null;
};

export type RoutineSessionsQueryVariables = Exact<{
  routineId: Scalars["String"]["input"];
  first: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type RoutineSessionsQuery = {
  readonly __typename: "Query";
  readonly chatSessions?: {
    readonly __typename: "ChatSessionNodeConnection";
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly hasNextPage: boolean;
      readonly endCursor?: string | null;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "ChatSessionNodeEdge";
      readonly node?: {
        readonly __typename: "ChatSessionNode";
        readonly id: number;
        readonly created: string;
      } | null;
    } | null>;
  } | null;
};

export type RoutineSkillOptionsQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
}>;

export type RoutineSkillOptionsQuery = {
  readonly __typename: "Query";
  readonly mySkills: ReadonlyArray<{
    readonly __typename: "SkillNode";
    readonly id: string;
    readonly name: string;
    readonly slug: string;
    readonly description: string;
  }>;
  readonly platformSkills: ReadonlyArray<{
    readonly __typename: "PlatformSkillType";
    readonly id: string;
    readonly name: string;
    readonly slug: string;
    readonly description: string;
  }>;
  readonly workspaceSkills: ReadonlyArray<{
    readonly __typename: "SkillNode";
    readonly id: string;
    readonly name: string;
    readonly slug: string;
    readonly description: string;
  }>;
};

export type RoutinesQueryVariables = Exact<{ [key: string]: never }>;

export type RoutinesQuery = {
  readonly __typename: "Query";
  readonly routines: ReadonlyArray<{
    readonly __typename: "RoutineNode";
    readonly id: string;
    readonly name: string;
    readonly skillId: string;
    readonly skillSlug: string;
    readonly enabled: boolean;
    readonly triggerType: string;
    readonly triggerConfig: any;
    readonly skillExists: boolean;
    readonly selectedMeetingGroups: ReadonlyArray<{
      readonly __typename: "RoutineSelectedMeetingGroupType";
      readonly id: number;
      readonly title?: string | null;
    }>;
  }>;
};

export type SavePersonalTranscriptSyncCredentialMutationMutationVariables =
  Exact<{
    provider: PersonalTranscriptSyncCredentialProviderEnum;
    apiKey: Scalars["String"]["input"];
  }>;

export type SavePersonalTranscriptSyncCredentialMutationMutation = {
  readonly __typename: "Mutation";
  readonly savePersonalTranscriptSyncCredential?: {
    readonly __typename: "SavePersonalTranscriptSyncCredentialMutation";
    readonly user?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly hasGranolaPersonalApiToken?: boolean | null;
      readonly hasFirefliesPersonalApiToken?: boolean | null;
    } | null;
  } | null;
};

export type SendAccountPhoneNumberVerificationCodeMutationVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
}>;

export type SendAccountPhoneNumberVerificationCodeMutation = {
  readonly __typename: "Mutation";
  readonly sendPhoneNumberVerificationCode?: {
    readonly __typename: "SendPhoneNumberVerificationCodeMutation";
    readonly membership?: {
      readonly __typename: "UserMemberNode";
      readonly id: number;
      readonly phoneNumber?: string | null;
      readonly phoneNumberVerified: boolean;
      readonly phoneNumberVerifiedAt?: string | null;
    } | null;
  } | null;
};

export type AskAiSendRoutineTestMutationVariables = Exact<{
  routineId: Scalars["UUID"]["input"];
}>;

export type AskAiSendRoutineTestMutation = {
  readonly __typename: "Mutation";
  readonly sendRoutineTest?: {
    readonly __typename: "SendRoutineTestMutation";
    readonly ok?: boolean | null;
  } | null;
};

export type SetRelationshipMutationFromAccountMutationVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  clearRelationship?: InputMaybe<Scalars["Boolean"]["input"]>;
  isPrimaryRelationship?: InputMaybe<Scalars["Boolean"]["input"]>;
  otherUserId: Scalars["Int"]["input"];
  userId?: InputMaybe<Scalars["Int"]["input"]>;
  relationshipType?: InputMaybe<RelationshipType>;
}>;

export type SetRelationshipMutationFromAccountMutation = {
  readonly __typename: "Mutation";
  readonly setRelationship?: {
    readonly __typename: "SetRelationshipMutation";
    readonly user?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly primaryManager?: {
        readonly __typename: "UserNode";
        readonly id: number;
      } | null;
      readonly relationships?: {
        readonly __typename: "RelationshipNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "RelationshipNodeEdge";
          readonly node?: {
            readonly __typename: "RelationshipNode";
            readonly id: number;
            readonly relationshipWithOtherUser?: RelationshipType | null;
            readonly organization?: {
              readonly __typename: "OrganizationNode";
              readonly id: number;
            } | null;
            readonly otherUser?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly primaryManager?: {
                readonly __typename: "UserNode";
                readonly id: number;
              } | null;
            } | null;
          } | null;
        } | null>;
      } | null;
      readonly managers: {
        readonly __typename: "UserNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "UserNodeEdge";
          readonly node?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
            readonly primaryManager?: {
              readonly __typename: "UserNode";
              readonly id: number;
            } | null;
          } | null;
        } | null>;
      };
    } | null;
  } | null;
};

export type StartCalendarSyncMutationMutationVariables = Exact<{
  syncCredentialsId: Scalars["Int"]["input"];
  fullSync?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type StartCalendarSyncMutationMutation = {
  readonly __typename: "Mutation";
  readonly startCalendarSync?: {
    readonly __typename: "StartCalendarSyncMutation";
    readonly user?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly syncCredentials?: {
        readonly __typename: "UserSyncCredentialsNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "UserSyncCredentialsNodeEdge";
          readonly node?: {
            readonly __typename: "UserSyncCredentialsNode";
            readonly id: number;
            readonly provider?: SyncCredentialsTypeEnum | null;
            readonly lastCalendarSyncStart?: string | null;
            readonly lastCalendarSyncEnd?: string | null;
            readonly hasValidCalendarCredentials?: boolean | null;
            readonly hasCalendarWriteCredentials?: boolean | null;
            readonly credentialsUid?: string | null;
            readonly organization?: {
              readonly __typename: "OrganizationNode";
              readonly id: number;
              readonly name: string;
              readonly personal?: boolean | null;
            } | null;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type AccountSyncCredentialFragmentFragment = {
  readonly __typename: "UserSyncCredentialsNode";
  readonly id: number;
  readonly provider?: SyncCredentialsTypeEnum | null;
  readonly lastCalendarSyncStart?: string | null;
  readonly lastCalendarSyncEnd?: string | null;
  readonly hasValidCalendarCredentials?: boolean | null;
  readonly hasCalendarWriteCredentials?: boolean | null;
  readonly credentialsUid?: string | null;
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
    readonly name: string;
    readonly personal?: boolean | null;
  } | null;
};

export type UpdateOrganizationMembershipMutationMutationVariables = Exact<{
  userId: Scalars["Int"]["input"];
  organizationId: Scalars["Int"]["input"];
  position?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type UpdateOrganizationMembershipMutationMutation = {
  readonly __typename: "Mutation";
  readonly updateOrganizationMembership?: {
    readonly __typename: "UpdateOrganizationMembershipMutation";
    readonly member?: {
      readonly __typename: "UserMemberNode";
      readonly id: number;
      readonly position?: string | null;
    } | null;
  } | null;
};

export type AskAiUpdateRoutineMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
  skillId?: InputMaybe<Scalars["String"]["input"]>;
  skillSlug?: InputMaybe<Scalars["String"]["input"]>;
  triggerType?: InputMaybe<Scalars["String"]["input"]>;
  triggerConfig?: InputMaybe<Scalars["JSONString"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type AskAiUpdateRoutineMutation = {
  readonly __typename: "Mutation";
  readonly updateRoutine?: {
    readonly __typename: "UpdateRoutineMutation";
    readonly routine?: {
      readonly __typename: "RoutineNode";
      readonly id: string;
      readonly name: string;
      readonly skillId: string;
      readonly skillSlug: string;
      readonly enabled: boolean;
      readonly triggerType: string;
      readonly triggerConfig: any;
      readonly skillExists: boolean;
      readonly selectedMeetingGroups: ReadonlyArray<{
        readonly __typename: "RoutineSelectedMeetingGroupType";
        readonly id: number;
        readonly title?: string | null;
      }>;
    } | null;
  } | null;
};

export type UpdateUserSettingsMutationVariables = Exact<{
  userId: Scalars["Int"]["input"];
  phoneNumberOrganizationId?: InputMaybe<Scalars["Int"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  primaryEmailAddress?: InputMaybe<Scalars["String"]["input"]>;
  emailPreference?: InputMaybe<EmailPreference>;
  meetingSummaryEmailPreference?: InputMaybe<MeetingSummaryEmailPreference>;
  programNotificationPreference?: InputMaybe<ComplianceProgramNotificationPreference>;
  surveyNotificationPreference?: InputMaybe<ComplianceProgramNotificationPreference>;
  programAdminNotificationDownwardSubmitted?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  timezone?: InputMaybe<Scalars["String"]["input"]>;
  meetingPreparationEmailPreference?: InputMaybe<MeetingAgendaEmailPreference>;
  enableDailySummaryEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
  enableDraftReminderEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
  enableDailyCommitmentEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
  eventLinkInDescriptionPreference?: InputMaybe<EventDescriptionLinkSetting>;
  meetingBotPreference?: InputMaybe<UserMeetingBotPreference>;
  aiGuidelines?: InputMaybe<Scalars["String"]["input"]>;
  videoRecordingPreference?: InputMaybe<UserVideoRecordingPreference>;
  dailyBriefEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  dailyBriefHour?: InputMaybe<Scalars["Int"]["input"]>;
  meetingPrepEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  meetingPrepLeadTimeMinutes?: InputMaybe<Scalars["Int"]["input"]>;
  meetingPrepOneononeOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  showPersonalMeetings?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type UpdateUserSettingsMutation = {
  readonly __typename: "Mutation";
  readonly updateUser?: {
    readonly __typename: "UpdateUserMutation";
    readonly user?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly firstName: string;
      readonly lastName: string;
      readonly emailPreference?: EmailPreference | null;
      readonly email: string;
      readonly meetingSummaryEmailPreference?: MeetingSummaryEmailPreference | null;
      readonly programNotificationPreference?: ComplianceProgramNotificationPreference | null;
      readonly surveyNotificationPreference?: ComplianceProgramNotificationPreference | null;
      readonly programAdminNotificationDownwardSubmitted?: boolean | null;
      readonly meetingPreparationEmailPreference?: MeetingAgendaEmailPreference | null;
      readonly enableDailySummaryEmails?: boolean | null;
      readonly enableDailyCommitmentEmails?: boolean | null;
      readonly enableDraftReminderEmails?: boolean | null;
      readonly timezone?: string | null;
      readonly eventLinkInDescriptionPreference?: EventDescriptionLinkSetting | null;
      readonly meetingBotPreference?: UserMeetingBotPreference | null;
      readonly aiGuidelines: string;
      readonly videoRecordingPreference?: UserVideoRecordingPreference | null;
      readonly dailyBriefEnabled?: boolean | null;
      readonly dailyBriefHour?: number | null;
      readonly meetingPrepEnabled?: boolean | null;
      readonly meetingPrepLeadTimeMinutes?: number | null;
      readonly meetingPrepOneononeOnly?: boolean | null;
      readonly showPersonalMeetings?: boolean | null;
    } | null;
  } | null;
};

export type UpdateUserNamesMutationVariables = Exact<{
  userId: Scalars["Int"]["input"];
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type UpdateUserNamesMutation = {
  readonly __typename: "Mutation";
  readonly updateUser?: {
    readonly __typename: "UpdateUserMutation";
    readonly user?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly firstName: string;
      readonly lastName: string;
    } | null;
  } | null;
};

export type VerifyAccountPhoneNumberMutationVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  code: Scalars["String"]["input"];
}>;

export type VerifyAccountPhoneNumberMutation = {
  readonly __typename: "Mutation";
  readonly verifyPhoneNumber?: {
    readonly __typename: "VerifyPhoneNumberMutation";
    readonly membership?: {
      readonly __typename: "UserMemberNode";
      readonly id: number;
      readonly phoneNumber?: string | null;
      readonly phoneNumberVerified: boolean;
      readonly phoneNumberVerifiedAt?: string | null;
    } | null;
  } | null;
};

type ActionItemCollapsibleFragment_ActionItemArtifactNode_Fragment = {
  readonly __typename: "ActionItemArtifactNode";
  readonly isComplete?: boolean | null;
  readonly actionItemState?: number | null;
  readonly dueDate?: string | null;
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly created: string;
  readonly assignee?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly avatar?: string | null;
    readonly name: string;
  } | null;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
};

type ActionItemCollapsibleFragment_AsanaTaskArtifactNode_Fragment = {
  readonly __typename: "AsanaTaskArtifactNode";
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly created: string;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
};

type ActionItemCollapsibleFragment_DecisionArtifactNode_Fragment = {
  readonly __typename: "DecisionArtifactNode";
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly created: string;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
};

type ActionItemCollapsibleFragment_DocumentArtifactNode_Fragment = {
  readonly __typename: "DocumentArtifactNode";
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly created: string;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
};

type ActionItemCollapsibleFragment_FeedbackArtifactNode_Fragment = {
  readonly __typename: "FeedbackArtifactNode";
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly created: string;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
};

type ActionItemCollapsibleFragment_GithubIssuesArtifactNode_Fragment = {
  readonly __typename: "GithubIssuesArtifactNode";
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly created: string;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
};

type ActionItemCollapsibleFragment_GoalArtifactNode_Fragment = {
  readonly __typename: "GoalArtifactNode";
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly created: string;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
};

type ActionItemCollapsibleFragment_KpiArtifactNode_Fragment = {
  readonly __typename: "KPIArtifactNode";
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly created: string;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
};

type ActionItemCollapsibleFragment_RatingArtifactNode_Fragment = {
  readonly __typename: "RatingArtifactNode";
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly created: string;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
};

type ActionItemCollapsibleFragment_RecognitionArtifactNode_Fragment = {
  readonly __typename: "RecognitionArtifactNode";
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly created: string;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
};

export type ActionItemCollapsibleFragmentFragment =
  | ActionItemCollapsibleFragment_ActionItemArtifactNode_Fragment
  | ActionItemCollapsibleFragment_AsanaTaskArtifactNode_Fragment
  | ActionItemCollapsibleFragment_DecisionArtifactNode_Fragment
  | ActionItemCollapsibleFragment_DocumentArtifactNode_Fragment
  | ActionItemCollapsibleFragment_FeedbackArtifactNode_Fragment
  | ActionItemCollapsibleFragment_GithubIssuesArtifactNode_Fragment
  | ActionItemCollapsibleFragment_GoalArtifactNode_Fragment
  | ActionItemCollapsibleFragment_KpiArtifactNode_Fragment
  | ActionItemCollapsibleFragment_RatingArtifactNode_Fragment
  | ActionItemCollapsibleFragment_RecognitionArtifactNode_Fragment;

export type GetActionItemsCollapsibleQueryQueryVariables = Exact<{
  actionItemState?: InputMaybe<Scalars["Int"]["input"]>;
  fetchData: Scalars["Boolean"]["input"];
  assigneeId?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  assigneeIds?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderContextType?: InputMaybe<Scalars["String"]["input"]>;
  orderContextId?: InputMaybe<Scalars["Int"]["input"]>;
  first: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetActionItemsCollapsibleQueryQuery = {
  readonly __typename: "Query";
  readonly artifacts?: {
    readonly __typename: "ArtifactConnection";
    readonly totalCount: number;
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly hasNextPage: boolean;
      readonly endCursor?: string | null;
    };
    readonly edges?: ReadonlyArray<{
      readonly __typename: "ArtifactEdge";
      readonly cursor: string;
      readonly node?:
        | {
            readonly __typename: "ActionItemArtifactNode";
            readonly isComplete?: boolean | null;
            readonly actionItemState?: number | null;
            readonly dueDate?: string | null;
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
            readonly created: string;
            readonly assignee?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly avatar?: string | null;
              readonly name: string;
            } | null;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly organization?: {
              readonly __typename: "OrganizationNode";
              readonly id: number;
            } | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "AsanaTaskArtifactNode";
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
            readonly created: string;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly organization?: {
              readonly __typename: "OrganizationNode";
              readonly id: number;
            } | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "DecisionArtifactNode";
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
            readonly created: string;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly organization?: {
              readonly __typename: "OrganizationNode";
              readonly id: number;
            } | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "DocumentArtifactNode";
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
            readonly created: string;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly organization?: {
              readonly __typename: "OrganizationNode";
              readonly id: number;
            } | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "FeedbackArtifactNode";
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
            readonly created: string;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly organization?: {
              readonly __typename: "OrganizationNode";
              readonly id: number;
            } | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "GithubIssuesArtifactNode";
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
            readonly created: string;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly organization?: {
              readonly __typename: "OrganizationNode";
              readonly id: number;
            } | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "GoalArtifactNode";
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
            readonly created: string;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly organization?: {
              readonly __typename: "OrganizationNode";
              readonly id: number;
            } | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "KPIArtifactNode";
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
            readonly created: string;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly organization?: {
              readonly __typename: "OrganizationNode";
              readonly id: number;
            } | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "RatingArtifactNode";
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
            readonly created: string;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly organization?: {
              readonly __typename: "OrganizationNode";
              readonly id: number;
            } | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "RecognitionArtifactNode";
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
            readonly created: string;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly organization?: {
              readonly __typename: "OrganizationNode";
              readonly id: number;
            } | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | null;
    } | null>;
  } | null;
};

export type UpcomingMeetingFragment = {
  readonly __typename: "MeetingNode";
  readonly id: number;
  readonly title?: string | null;
  readonly startDatetime?: string | null;
  readonly endDatetime?: string | null;
  readonly meetingGroupId: number;
  readonly draft: boolean;
  readonly isLocked: boolean;
  readonly isFinalized: boolean;
};

export type GetUpcomingMeetingsQueryVariables = Exact<{
  startDatetimeAfter?: InputMaybe<Scalars["DateTime"]["input"]>;
  participants?: InputMaybe<
    ReadonlyArray<Scalars["Int"]["input"]> | Scalars["Int"]["input"]
  >;
  isFormalOneonone?: InputMaybe<Scalars["Boolean"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetUpcomingMeetingsQuery = {
  readonly __typename: "Query";
  readonly meetings?: {
    readonly __typename: "MeetingNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "MeetingNodeEdge";
      readonly node?: {
        readonly __typename: "MeetingNode";
        readonly id: number;
        readonly title?: string | null;
        readonly startDatetime?: string | null;
        readonly endDatetime?: string | null;
        readonly meetingGroupId: number;
        readonly draft: boolean;
        readonly isLocked: boolean;
        readonly isFinalized: boolean;
      } | null;
    } | null>;
  } | null;
};

type CreatedArtifactFragment_ActionItemArtifactNode_Fragment = {
  readonly __typename: "ActionItemArtifactNode";
  readonly title?: string | null;
  readonly actionItemState?: number | null;
  readonly isComplete?: boolean | null;
  readonly dueDate?: string | null;
  readonly artifactType: ArtifactType;
  readonly id: number;
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly assignee?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly avatar?: string | null;
    readonly name: string;
  } | null;
};

type CreatedArtifactFragment_AsanaTaskArtifactNode_Fragment = {
  readonly __typename: "AsanaTaskArtifactNode";
  readonly artifactType: ArtifactType;
  readonly id: number;
  readonly title?: string | null;
};

type CreatedArtifactFragment_DecisionArtifactNode_Fragment = {
  readonly __typename: "DecisionArtifactNode";
  readonly decision: string;
  readonly artifactType: ArtifactType;
  readonly id: number;
  readonly title?: string | null;
};

type CreatedArtifactFragment_DocumentArtifactNode_Fragment = {
  readonly __typename: "DocumentArtifactNode";
  readonly artifactType: ArtifactType;
  readonly id: number;
  readonly title?: string | null;
};

type CreatedArtifactFragment_FeedbackArtifactNode_Fragment = {
  readonly __typename: "FeedbackArtifactNode";
  readonly artifactType: ArtifactType;
  readonly id: number;
  readonly title?: string | null;
  readonly recipientsCanView: boolean;
  readonly recipientsManagersCanView: boolean;
  readonly adminsCanView: boolean;
  readonly creatorCanView: boolean;
  readonly feedbackState: FeedbackState;
  readonly message?: any | null;
  readonly created: string;
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
  readonly feedbackRecipients: {
    readonly __typename: "UserNodeConnection";
    readonly totalCount: number;
    readonly edges: ReadonlyArray<{
      readonly __typename: "UserNodeEdge";
      readonly node?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly avatar?: string | null;
        readonly name: string;
      } | null;
    } | null>;
  };
  readonly sender: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly avatar?: string | null;
    readonly name: string;
  };
};

type CreatedArtifactFragment_GithubIssuesArtifactNode_Fragment = {
  readonly __typename: "GithubIssuesArtifactNode";
  readonly artifactType: ArtifactType;
  readonly id: number;
  readonly title?: string | null;
};

type CreatedArtifactFragment_GoalArtifactNode_Fragment = {
  readonly __typename: "GoalArtifactNode";
  readonly scope: GoalScope;
  readonly parentGoalId?: number | null;
  readonly artifactType: ArtifactType;
  readonly id: number;
  readonly title?: string | null;
  readonly goalState: GoalState;
  readonly parentGoal?: {
    readonly __typename: "GoalArtifactNode";
    readonly id: number;
    readonly childGoals?: {
      readonly __typename: "GoalArtifactConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "GoalArtifactEdge";
        readonly node?: {
          readonly __typename: "GoalArtifactNode";
          readonly id: number;
        } | null;
      } | null>;
    } | null;
  } | null;
  readonly childGoals?: {
    readonly __typename: "GoalArtifactConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "GoalArtifactEdge";
      readonly node?: {
        readonly __typename: "GoalArtifactNode";
        readonly id: number;
      } | null;
    } | null>;
  } | null;
};

type CreatedArtifactFragment_KpiArtifactNode_Fragment = {
  readonly __typename: "KPIArtifactNode";
  readonly artifactType: ArtifactType;
  readonly id: number;
  readonly title?: string | null;
};

type CreatedArtifactFragment_RatingArtifactNode_Fragment = {
  readonly __typename: "RatingArtifactNode";
  readonly artifactType: ArtifactType;
  readonly id: number;
  readonly title?: string | null;
};

type CreatedArtifactFragment_RecognitionArtifactNode_Fragment = {
  readonly __typename: "RecognitionArtifactNode";
  readonly artifactType: ArtifactType;
  readonly id: number;
  readonly title?: string | null;
  readonly created: string;
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
  readonly recipients?: {
    readonly __typename: "UserNodeConnection";
    readonly totalCount: number;
    readonly edges: ReadonlyArray<{
      readonly __typename: "UserNodeEdge";
      readonly node?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      } | null;
    } | null>;
  } | null;
  readonly recognitionCoreValue?: {
    readonly __typename: "RecognitionCoreValueNode";
    readonly id: number;
    readonly title: string;
    readonly description: string;
    readonly emoji?: string | null;
    readonly image?: string | null;
  } | null;
};

export type CreatedArtifactFragmentFragment =
  | CreatedArtifactFragment_ActionItemArtifactNode_Fragment
  | CreatedArtifactFragment_AsanaTaskArtifactNode_Fragment
  | CreatedArtifactFragment_DecisionArtifactNode_Fragment
  | CreatedArtifactFragment_DocumentArtifactNode_Fragment
  | CreatedArtifactFragment_FeedbackArtifactNode_Fragment
  | CreatedArtifactFragment_GithubIssuesArtifactNode_Fragment
  | CreatedArtifactFragment_GoalArtifactNode_Fragment
  | CreatedArtifactFragment_KpiArtifactNode_Fragment
  | CreatedArtifactFragment_RatingArtifactNode_Fragment
  | CreatedArtifactFragment_RecognitionArtifactNode_Fragment;

export type CreateArtifactMutationMutationVariables = Exact<{
  artifactType: ArtifactType;
  title: Scalars["String"]["input"];
  description?: InputMaybe<Scalars["JSONString"]["input"]>;
  organizationId: Scalars["Int"]["input"];
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  additionalFields?: InputMaybe<AdditionalArtifactInput>;
}>;

export type CreateArtifactMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateArtifact?: {
    readonly __typename: "CreateOrUpdateArtifactMutation";
    readonly artifact?:
      | {
          readonly __typename: "ActionItemArtifactNode";
          readonly title?: string | null;
          readonly actionItemState?: number | null;
          readonly isComplete?: boolean | null;
          readonly dueDate?: string | null;
          readonly artifactType: ArtifactType;
          readonly id: number;
          readonly organization?: {
            readonly __typename: "OrganizationNode";
            readonly id: number;
          } | null;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly assignee?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly avatar?: string | null;
            readonly name: string;
          } | null;
        }
      | {
          readonly __typename: "AsanaTaskArtifactNode";
          readonly artifactType: ArtifactType;
          readonly id: number;
          readonly title?: string | null;
        }
      | {
          readonly __typename: "DecisionArtifactNode";
          readonly decision: string;
          readonly artifactType: ArtifactType;
          readonly id: number;
          readonly title?: string | null;
        }
      | {
          readonly __typename: "DocumentArtifactNode";
          readonly artifactType: ArtifactType;
          readonly id: number;
          readonly title?: string | null;
        }
      | {
          readonly __typename: "FeedbackArtifactNode";
          readonly artifactType: ArtifactType;
          readonly id: number;
          readonly title?: string | null;
          readonly recipientsCanView: boolean;
          readonly recipientsManagersCanView: boolean;
          readonly adminsCanView: boolean;
          readonly creatorCanView: boolean;
          readonly feedbackState: FeedbackState;
          readonly message?: any | null;
          readonly created: string;
          readonly creator?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
          readonly feedbackRecipients: {
            readonly __typename: "UserNodeConnection";
            readonly totalCount: number;
            readonly edges: ReadonlyArray<{
              readonly __typename: "UserNodeEdge";
              readonly node?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly avatar?: string | null;
                readonly name: string;
              } | null;
            } | null>;
          };
          readonly sender: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly avatar?: string | null;
            readonly name: string;
          };
        }
      | {
          readonly __typename: "GithubIssuesArtifactNode";
          readonly artifactType: ArtifactType;
          readonly id: number;
          readonly title?: string | null;
        }
      | {
          readonly __typename: "GoalArtifactNode";
          readonly scope: GoalScope;
          readonly parentGoalId?: number | null;
          readonly artifactType: ArtifactType;
          readonly id: number;
          readonly title?: string | null;
          readonly goalState: GoalState;
          readonly parentGoal?: {
            readonly __typename: "GoalArtifactNode";
            readonly id: number;
            readonly childGoals?: {
              readonly __typename: "GoalArtifactConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "GoalArtifactEdge";
                readonly node?: {
                  readonly __typename: "GoalArtifactNode";
                  readonly id: number;
                } | null;
              } | null>;
            } | null;
          } | null;
          readonly childGoals?: {
            readonly __typename: "GoalArtifactConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "GoalArtifactEdge";
              readonly node?: {
                readonly __typename: "GoalArtifactNode";
                readonly id: number;
              } | null;
            } | null>;
          } | null;
        }
      | {
          readonly __typename: "KPIArtifactNode";
          readonly artifactType: ArtifactType;
          readonly id: number;
          readonly title?: string | null;
        }
      | {
          readonly __typename: "RatingArtifactNode";
          readonly artifactType: ArtifactType;
          readonly id: number;
          readonly title?: string | null;
        }
      | {
          readonly __typename: "RecognitionArtifactNode";
          readonly artifactType: ArtifactType;
          readonly id: number;
          readonly title?: string | null;
          readonly created: string;
          readonly creator?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
          readonly recipients?: {
            readonly __typename: "UserNodeConnection";
            readonly totalCount: number;
            readonly edges: ReadonlyArray<{
              readonly __typename: "UserNodeEdge";
              readonly node?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            } | null>;
          } | null;
          readonly recognitionCoreValue?: {
            readonly __typename: "RecognitionCoreValueNode";
            readonly id: number;
            readonly title: string;
            readonly description: string;
            readonly emoji?: string | null;
            readonly image?: string | null;
          } | null;
        }
      | null;
  } | null;
};

export type CreateFeedbackRequestsMutationMutationVariables = Exact<{
  title: Scalars["String"]["input"];
  description?: InputMaybe<Scalars["JSONString"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId: Scalars["Int"]["input"];
  feedbackAdminsCanView?: InputMaybe<Scalars["Boolean"]["input"]>;
  feedbackCreatorCanView?: InputMaybe<Scalars["Boolean"]["input"]>;
  feedbackRecipientsCanView?: InputMaybe<Scalars["Boolean"]["input"]>;
  feedbackRecipientsManagersCanView?: InputMaybe<Scalars["Boolean"]["input"]>;
  feedbackState?: InputMaybe<FeedbackState>;
  feedbackRecipients:
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>;
  feedbackSenderIds:
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>;
}>;

export type CreateFeedbackRequestsMutationMutation = {
  readonly __typename: "Mutation";
  readonly createFeedbackRequests?: {
    readonly __typename: "CreateFeedbackRequestsMutation";
    readonly feedbackArtifacts?: ReadonlyArray<{
      readonly __typename: "FeedbackArtifactNode";
      readonly id: number;
      readonly artifactType: ArtifactType;
      readonly title?: string | null;
      readonly recipientsCanView: boolean;
      readonly recipientsManagersCanView: boolean;
      readonly adminsCanView: boolean;
      readonly creatorCanView: boolean;
      readonly feedbackState: FeedbackState;
      readonly message?: any | null;
      readonly created: string;
      readonly creator?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      } | null;
      readonly feedbackRecipients: {
        readonly __typename: "UserNodeConnection";
        readonly totalCount: number;
        readonly edges: ReadonlyArray<{
          readonly __typename: "UserNodeEdge";
          readonly node?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly avatar?: string | null;
            readonly name: string;
          } | null;
        } | null>;
      };
      readonly sender: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly avatar?: string | null;
        readonly name: string;
      };
    } | null> | null;
  } | null;
};

export type GetFullscreenArtifactQueryQueryVariables = Exact<{
  artifactId: Scalars["Int"]["input"];
}>;

export type GetFullscreenArtifactQueryQuery = {
  readonly __typename: "Query";
  readonly artifact:
    | {
        readonly __typename: "ActionItemArtifactNode";
        readonly id: number;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly websocketToken?: string | null;
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
      }
    | {
        readonly __typename: "AsanaTaskArtifactNode";
        readonly id: number;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly websocketToken?: string | null;
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
      }
    | {
        readonly __typename: "DecisionArtifactNode";
        readonly id: number;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly websocketToken?: string | null;
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
      }
    | {
        readonly __typename: "DocumentArtifactNode";
        readonly id: number;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly websocketToken?: string | null;
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
      }
    | {
        readonly __typename: "FeedbackArtifactNode";
        readonly id: number;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly websocketToken?: string | null;
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
      }
    | {
        readonly __typename: "GithubIssuesArtifactNode";
        readonly id: number;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly websocketToken?: string | null;
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
      }
    | {
        readonly __typename: "GoalArtifactNode";
        readonly id: number;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly websocketToken?: string | null;
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
      }
    | {
        readonly __typename: "KPIArtifactNode";
        readonly id: number;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly websocketToken?: string | null;
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
      }
    | {
        readonly __typename: "RatingArtifactNode";
        readonly id: number;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly websocketToken?: string | null;
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
      }
    | {
        readonly __typename: "RecognitionArtifactNode";
        readonly id: number;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly websocketToken?: string | null;
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
      };
};

export type AddFavouriteArtifactMutationMutationVariables = Exact<{
  artifactId: Scalars["Int"]["input"];
}>;

export type AddFavouriteArtifactMutationMutation = {
  readonly __typename: "Mutation";
  readonly addFavouriteArtifact?: {
    readonly __typename: "AddFavouriteArtifact";
    readonly artifact?:
      | { readonly __typename: "ActionItemArtifactNode"; readonly id: number }
      | { readonly __typename: "AsanaTaskArtifactNode"; readonly id: number }
      | { readonly __typename: "DecisionArtifactNode"; readonly id: number }
      | { readonly __typename: "DocumentArtifactNode"; readonly id: number }
      | { readonly __typename: "FeedbackArtifactNode"; readonly id: number }
      | { readonly __typename: "GithubIssuesArtifactNode"; readonly id: number }
      | { readonly __typename: "GoalArtifactNode"; readonly id: number }
      | { readonly __typename: "KPIArtifactNode"; readonly id: number }
      | { readonly __typename: "RatingArtifactNode"; readonly id: number }
      | { readonly __typename: "RecognitionArtifactNode"; readonly id: number }
      | null;
    readonly user?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly favouriteArtifacts: {
        readonly __typename: "ArtifactConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "ArtifactEdge";
          readonly node?:
            | {
                readonly __typename: "ActionItemArtifactNode";
                readonly id: number;
              }
            | {
                readonly __typename: "AsanaTaskArtifactNode";
                readonly id: number;
              }
            | {
                readonly __typename: "DecisionArtifactNode";
                readonly id: number;
              }
            | {
                readonly __typename: "DocumentArtifactNode";
                readonly id: number;
              }
            | {
                readonly __typename: "FeedbackArtifactNode";
                readonly id: number;
              }
            | {
                readonly __typename: "GithubIssuesArtifactNode";
                readonly id: number;
              }
            | { readonly __typename: "GoalArtifactNode"; readonly id: number }
            | { readonly __typename: "KPIArtifactNode"; readonly id: number }
            | { readonly __typename: "RatingArtifactNode"; readonly id: number }
            | {
                readonly __typename: "RecognitionArtifactNode";
                readonly id: number;
              }
            | null;
        } | null>;
      };
    } | null;
  } | null;
};

export type AlignGoalMutationMutationVariables = Exact<{
  goalId: Scalars["Int"]["input"];
  parentGoalId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type AlignGoalMutationMutation = {
  readonly __typename: "Mutation";
  readonly alignGoal?: {
    readonly __typename: "AlignGoalMutation";
    readonly goal?:
      | { readonly __typename: "ActionItemArtifactNode"; readonly id: number }
      | { readonly __typename: "AsanaTaskArtifactNode"; readonly id: number }
      | { readonly __typename: "DecisionArtifactNode"; readonly id: number }
      | { readonly __typename: "DocumentArtifactNode"; readonly id: number }
      | { readonly __typename: "FeedbackArtifactNode"; readonly id: number }
      | { readonly __typename: "GithubIssuesArtifactNode"; readonly id: number }
      | {
          readonly __typename: "GoalArtifactNode";
          readonly id: number;
          readonly basicChildGoals?: {
            readonly __typename: "BasicGoalArtifactNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "BasicGoalArtifactNodeEdge";
              readonly node?: {
                readonly __typename: "BasicGoalArtifactNode";
                readonly id: number;
              } | null;
            } | null>;
          } | null;
          readonly parentGoal?: {
            readonly __typename: "GoalArtifactNode";
            readonly id: number;
            readonly basicChildGoals?: {
              readonly __typename: "BasicGoalArtifactNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "BasicGoalArtifactNodeEdge";
                readonly node?: {
                  readonly __typename: "BasicGoalArtifactNode";
                  readonly id: number;
                } | null;
              } | null>;
            } | null;
          } | null;
        }
      | { readonly __typename: "KPIArtifactNode"; readonly id: number }
      | { readonly __typename: "RatingArtifactNode"; readonly id: number }
      | { readonly __typename: "RecognitionArtifactNode"; readonly id: number }
      | null;
    readonly previousParentGoal?:
      | { readonly __typename: "ActionItemArtifactNode"; readonly id: number }
      | { readonly __typename: "AsanaTaskArtifactNode"; readonly id: number }
      | { readonly __typename: "DecisionArtifactNode"; readonly id: number }
      | { readonly __typename: "DocumentArtifactNode"; readonly id: number }
      | { readonly __typename: "FeedbackArtifactNode"; readonly id: number }
      | { readonly __typename: "GithubIssuesArtifactNode"; readonly id: number }
      | {
          readonly __typename: "GoalArtifactNode";
          readonly id: number;
          readonly basicChildGoals?: {
            readonly __typename: "BasicGoalArtifactNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "BasicGoalArtifactNodeEdge";
              readonly node?: {
                readonly __typename: "BasicGoalArtifactNode";
                readonly id: number;
              } | null;
            } | null>;
          } | null;
          readonly parentGoal?: {
            readonly __typename: "GoalArtifactNode";
            readonly id: number;
          } | null;
        }
      | { readonly __typename: "KPIArtifactNode"; readonly id: number }
      | { readonly __typename: "RatingArtifactNode"; readonly id: number }
      | { readonly __typename: "RecognitionArtifactNode"; readonly id: number }
      | null;
  } | null;
};

export type DeleteGoalKeyResultsMutationVariables = Exact<{
  keyResultId: Scalars["Int"]["input"];
}>;

export type DeleteGoalKeyResultsMutation = {
  readonly __typename: "Mutation";
  readonly deleteKeyResult?: {
    readonly __typename: "DeleteKeyResultMutation";
    readonly keyResult?: {
      readonly __typename: "KeyResultNode";
      readonly id: number;
      readonly title: string;
      readonly startValue: number;
      readonly currentValue: number;
      readonly targetValue: number;
      readonly progressType: GoalProgressType;
      readonly kpi?: {
        readonly __typename: "KPINode";
        readonly id: number;
        readonly title: string;
        readonly currentMeasurement?: {
          readonly __typename: "KPIMeasurementNode";
          readonly id: number;
          readonly measurement: number;
        } | null;
      } | null;
      readonly canUpdate?: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
      } | null;
      readonly assignee?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
        readonly email: string;
      } | null;
    } | null;
    readonly goal?: {
      readonly __typename: "GoalArtifactNode";
      readonly id: number;
      readonly keyResults: {
        readonly __typename: "KeyResultNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "KeyResultNodeEdge";
          readonly node?: {
            readonly __typename: "KeyResultNode";
            readonly id: number;
          } | null;
        } | null>;
      };
    } | null;
  } | null;
};

export type ActivityCommentFragmentFragment = {
  readonly __typename: "CommentNode";
  readonly id: number;
  readonly comment?: any | null;
  readonly deleted?: boolean | null;
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
};

export type ArtifactActivityFragmentFragment = {
  readonly __typename: "ArtifactActivityNode";
  readonly id: number;
  readonly created: string;
  readonly activityType: ArtifactActivityType;
  readonly canDelete?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  } | null;
  readonly canUpdate?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  } | null;
  readonly actor?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
  readonly changedFields?: ReadonlyArray<{
    readonly __typename: "ArtifactChangedFieldNode";
    readonly fieldName?: string | null;
    readonly previousValue?: string | null;
    readonly newValue?: string | null;
    readonly changedFields?: ReadonlyArray<{
      readonly __typename: "ArtifactChangedFieldNode";
      readonly newValue?: string | null;
      readonly previousValue?: string | null;
      readonly fieldName?: string | null;
    } | null> | null;
    readonly newValueObject?:
      | {
          readonly __typename: "BaseArtifactNode";
          readonly id: number;
          readonly title: string;
          readonly artifactType: ArtifactType;
        }
      | {
          readonly __typename: "CareerTrackRoleNode";
          readonly id: number;
          readonly title: string;
        }
      | {
          readonly __typename: "CommentNode";
          readonly id: number;
          readonly comment?: any | null;
          readonly deleted?: boolean | null;
          readonly creator?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
        }
      | {
          readonly __typename: "CompetencyNode";
          readonly id: number;
          readonly title: string;
        }
      | {
          readonly __typename: "KeyResultNode";
          readonly id: number;
          readonly title: string;
        }
      | {
          readonly __typename: "TopicNode";
          readonly id: number;
          readonly title: string;
          readonly meeting?: {
            readonly __typename: "MeetingNode";
            readonly id: number;
            readonly title?: string | null;
            readonly meetingGroupId: number;
          } | null;
        }
      | {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        }
      | null;
    readonly previousValueObject?:
      | {
          readonly __typename: "BaseArtifactNode";
          readonly id: number;
          readonly title: string;
          readonly artifactType: ArtifactType;
        }
      | {
          readonly __typename: "CareerTrackRoleNode";
          readonly id: number;
          readonly title: string;
        }
      | { readonly __typename: "CommentNode" }
      | {
          readonly __typename: "CompetencyNode";
          readonly id: number;
          readonly title: string;
        }
      | {
          readonly __typename: "KeyResultNode";
          readonly id: number;
          readonly title: string;
        }
      | {
          readonly __typename: "TopicNode";
          readonly id: number;
          readonly title: string;
          readonly meeting?: {
            readonly __typename: "MeetingNode";
            readonly id: number;
            readonly title?: string | null;
            readonly meetingGroupId: number;
          } | null;
        }
      | {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        }
      | null;
  } | null> | null;
};

export type GetArtifactActivitiesQueryQueryVariables = Exact<{
  artifactId: Scalars["Int"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetArtifactActivitiesQueryQuery = {
  readonly __typename: "Query";
  readonly artifact:
    | {
        readonly __typename: "ActionItemArtifactNode";
        readonly id: number;
        readonly activities: {
          readonly __typename: "ArtifactActivityNodeConnection";
          readonly totalCount: number;
          readonly pageInfo: {
            readonly __typename: "PageInfo";
            readonly hasNextPage: boolean;
            readonly endCursor?: string | null;
          };
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactActivityNodeEdge";
            readonly node?: {
              readonly __typename: "ArtifactActivityNode";
              readonly id: number;
              readonly created: string;
              readonly activityType: ArtifactActivityType;
              readonly canDelete?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
                readonly reason: string;
              } | null;
              readonly canUpdate?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
                readonly reason: string;
              } | null;
              readonly actor?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly changedFields?: ReadonlyArray<{
                readonly __typename: "ArtifactChangedFieldNode";
                readonly fieldName?: string | null;
                readonly previousValue?: string | null;
                readonly newValue?: string | null;
                readonly changedFields?: ReadonlyArray<{
                  readonly __typename: "ArtifactChangedFieldNode";
                  readonly newValue?: string | null;
                  readonly previousValue?: string | null;
                  readonly fieldName?: string | null;
                } | null> | null;
                readonly newValueObject?:
                  | {
                      readonly __typename: "BaseArtifactNode";
                      readonly id: number;
                      readonly title: string;
                      readonly artifactType: ArtifactType;
                    }
                  | {
                      readonly __typename: "CareerTrackRoleNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "CommentNode";
                      readonly id: number;
                      readonly comment?: any | null;
                      readonly deleted?: boolean | null;
                      readonly creator?: {
                        readonly __typename: "UserNode";
                        readonly id: number;
                        readonly name: string;
                        readonly avatar?: string | null;
                      } | null;
                    }
                  | {
                      readonly __typename: "CompetencyNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "KeyResultNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "TopicNode";
                      readonly id: number;
                      readonly title: string;
                      readonly meeting?: {
                        readonly __typename: "MeetingNode";
                        readonly id: number;
                        readonly title?: string | null;
                        readonly meetingGroupId: number;
                      } | null;
                    }
                  | {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    }
                  | null;
                readonly previousValueObject?:
                  | {
                      readonly __typename: "BaseArtifactNode";
                      readonly id: number;
                      readonly title: string;
                      readonly artifactType: ArtifactType;
                    }
                  | {
                      readonly __typename: "CareerTrackRoleNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | { readonly __typename: "CommentNode" }
                  | {
                      readonly __typename: "CompetencyNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "KeyResultNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "TopicNode";
                      readonly id: number;
                      readonly title: string;
                      readonly meeting?: {
                        readonly __typename: "MeetingNode";
                        readonly id: number;
                        readonly title?: string | null;
                        readonly meetingGroupId: number;
                      } | null;
                    }
                  | {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    }
                  | null;
              } | null> | null;
            } | null;
          } | null>;
        };
      }
    | {
        readonly __typename: "AsanaTaskArtifactNode";
        readonly id: number;
        readonly activities: {
          readonly __typename: "ArtifactActivityNodeConnection";
          readonly totalCount: number;
          readonly pageInfo: {
            readonly __typename: "PageInfo";
            readonly hasNextPage: boolean;
            readonly endCursor?: string | null;
          };
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactActivityNodeEdge";
            readonly node?: {
              readonly __typename: "ArtifactActivityNode";
              readonly id: number;
              readonly created: string;
              readonly activityType: ArtifactActivityType;
              readonly canDelete?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
                readonly reason: string;
              } | null;
              readonly canUpdate?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
                readonly reason: string;
              } | null;
              readonly actor?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly changedFields?: ReadonlyArray<{
                readonly __typename: "ArtifactChangedFieldNode";
                readonly fieldName?: string | null;
                readonly previousValue?: string | null;
                readonly newValue?: string | null;
                readonly changedFields?: ReadonlyArray<{
                  readonly __typename: "ArtifactChangedFieldNode";
                  readonly newValue?: string | null;
                  readonly previousValue?: string | null;
                  readonly fieldName?: string | null;
                } | null> | null;
                readonly newValueObject?:
                  | {
                      readonly __typename: "BaseArtifactNode";
                      readonly id: number;
                      readonly title: string;
                      readonly artifactType: ArtifactType;
                    }
                  | {
                      readonly __typename: "CareerTrackRoleNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "CommentNode";
                      readonly id: number;
                      readonly comment?: any | null;
                      readonly deleted?: boolean | null;
                      readonly creator?: {
                        readonly __typename: "UserNode";
                        readonly id: number;
                        readonly name: string;
                        readonly avatar?: string | null;
                      } | null;
                    }
                  | {
                      readonly __typename: "CompetencyNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "KeyResultNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "TopicNode";
                      readonly id: number;
                      readonly title: string;
                      readonly meeting?: {
                        readonly __typename: "MeetingNode";
                        readonly id: number;
                        readonly title?: string | null;
                        readonly meetingGroupId: number;
                      } | null;
                    }
                  | {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    }
                  | null;
                readonly previousValueObject?:
                  | {
                      readonly __typename: "BaseArtifactNode";
                      readonly id: number;
                      readonly title: string;
                      readonly artifactType: ArtifactType;
                    }
                  | {
                      readonly __typename: "CareerTrackRoleNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | { readonly __typename: "CommentNode" }
                  | {
                      readonly __typename: "CompetencyNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "KeyResultNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "TopicNode";
                      readonly id: number;
                      readonly title: string;
                      readonly meeting?: {
                        readonly __typename: "MeetingNode";
                        readonly id: number;
                        readonly title?: string | null;
                        readonly meetingGroupId: number;
                      } | null;
                    }
                  | {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    }
                  | null;
              } | null> | null;
            } | null;
          } | null>;
        };
      }
    | {
        readonly __typename: "DecisionArtifactNode";
        readonly id: number;
        readonly activities: {
          readonly __typename: "ArtifactActivityNodeConnection";
          readonly totalCount: number;
          readonly pageInfo: {
            readonly __typename: "PageInfo";
            readonly hasNextPage: boolean;
            readonly endCursor?: string | null;
          };
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactActivityNodeEdge";
            readonly node?: {
              readonly __typename: "ArtifactActivityNode";
              readonly id: number;
              readonly created: string;
              readonly activityType: ArtifactActivityType;
              readonly canDelete?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
                readonly reason: string;
              } | null;
              readonly canUpdate?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
                readonly reason: string;
              } | null;
              readonly actor?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly changedFields?: ReadonlyArray<{
                readonly __typename: "ArtifactChangedFieldNode";
                readonly fieldName?: string | null;
                readonly previousValue?: string | null;
                readonly newValue?: string | null;
                readonly changedFields?: ReadonlyArray<{
                  readonly __typename: "ArtifactChangedFieldNode";
                  readonly newValue?: string | null;
                  readonly previousValue?: string | null;
                  readonly fieldName?: string | null;
                } | null> | null;
                readonly newValueObject?:
                  | {
                      readonly __typename: "BaseArtifactNode";
                      readonly id: number;
                      readonly title: string;
                      readonly artifactType: ArtifactType;
                    }
                  | {
                      readonly __typename: "CareerTrackRoleNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "CommentNode";
                      readonly id: number;
                      readonly comment?: any | null;
                      readonly deleted?: boolean | null;
                      readonly creator?: {
                        readonly __typename: "UserNode";
                        readonly id: number;
                        readonly name: string;
                        readonly avatar?: string | null;
                      } | null;
                    }
                  | {
                      readonly __typename: "CompetencyNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "KeyResultNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "TopicNode";
                      readonly id: number;
                      readonly title: string;
                      readonly meeting?: {
                        readonly __typename: "MeetingNode";
                        readonly id: number;
                        readonly title?: string | null;
                        readonly meetingGroupId: number;
                      } | null;
                    }
                  | {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    }
                  | null;
                readonly previousValueObject?:
                  | {
                      readonly __typename: "BaseArtifactNode";
                      readonly id: number;
                      readonly title: string;
                      readonly artifactType: ArtifactType;
                    }
                  | {
                      readonly __typename: "CareerTrackRoleNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | { readonly __typename: "CommentNode" }
                  | {
                      readonly __typename: "CompetencyNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "KeyResultNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "TopicNode";
                      readonly id: number;
                      readonly title: string;
                      readonly meeting?: {
                        readonly __typename: "MeetingNode";
                        readonly id: number;
                        readonly title?: string | null;
                        readonly meetingGroupId: number;
                      } | null;
                    }
                  | {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    }
                  | null;
              } | null> | null;
            } | null;
          } | null>;
        };
      }
    | {
        readonly __typename: "DocumentArtifactNode";
        readonly id: number;
        readonly activities: {
          readonly __typename: "ArtifactActivityNodeConnection";
          readonly totalCount: number;
          readonly pageInfo: {
            readonly __typename: "PageInfo";
            readonly hasNextPage: boolean;
            readonly endCursor?: string | null;
          };
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactActivityNodeEdge";
            readonly node?: {
              readonly __typename: "ArtifactActivityNode";
              readonly id: number;
              readonly created: string;
              readonly activityType: ArtifactActivityType;
              readonly canDelete?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
                readonly reason: string;
              } | null;
              readonly canUpdate?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
                readonly reason: string;
              } | null;
              readonly actor?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly changedFields?: ReadonlyArray<{
                readonly __typename: "ArtifactChangedFieldNode";
                readonly fieldName?: string | null;
                readonly previousValue?: string | null;
                readonly newValue?: string | null;
                readonly changedFields?: ReadonlyArray<{
                  readonly __typename: "ArtifactChangedFieldNode";
                  readonly newValue?: string | null;
                  readonly previousValue?: string | null;
                  readonly fieldName?: string | null;
                } | null> | null;
                readonly newValueObject?:
                  | {
                      readonly __typename: "BaseArtifactNode";
                      readonly id: number;
                      readonly title: string;
                      readonly artifactType: ArtifactType;
                    }
                  | {
                      readonly __typename: "CareerTrackRoleNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "CommentNode";
                      readonly id: number;
                      readonly comment?: any | null;
                      readonly deleted?: boolean | null;
                      readonly creator?: {
                        readonly __typename: "UserNode";
                        readonly id: number;
                        readonly name: string;
                        readonly avatar?: string | null;
                      } | null;
                    }
                  | {
                      readonly __typename: "CompetencyNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "KeyResultNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "TopicNode";
                      readonly id: number;
                      readonly title: string;
                      readonly meeting?: {
                        readonly __typename: "MeetingNode";
                        readonly id: number;
                        readonly title?: string | null;
                        readonly meetingGroupId: number;
                      } | null;
                    }
                  | {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    }
                  | null;
                readonly previousValueObject?:
                  | {
                      readonly __typename: "BaseArtifactNode";
                      readonly id: number;
                      readonly title: string;
                      readonly artifactType: ArtifactType;
                    }
                  | {
                      readonly __typename: "CareerTrackRoleNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | { readonly __typename: "CommentNode" }
                  | {
                      readonly __typename: "CompetencyNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "KeyResultNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "TopicNode";
                      readonly id: number;
                      readonly title: string;
                      readonly meeting?: {
                        readonly __typename: "MeetingNode";
                        readonly id: number;
                        readonly title?: string | null;
                        readonly meetingGroupId: number;
                      } | null;
                    }
                  | {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    }
                  | null;
              } | null> | null;
            } | null;
          } | null>;
        };
      }
    | {
        readonly __typename: "FeedbackArtifactNode";
        readonly id: number;
        readonly activities: {
          readonly __typename: "ArtifactActivityNodeConnection";
          readonly totalCount: number;
          readonly pageInfo: {
            readonly __typename: "PageInfo";
            readonly hasNextPage: boolean;
            readonly endCursor?: string | null;
          };
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactActivityNodeEdge";
            readonly node?: {
              readonly __typename: "ArtifactActivityNode";
              readonly id: number;
              readonly created: string;
              readonly activityType: ArtifactActivityType;
              readonly canDelete?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
                readonly reason: string;
              } | null;
              readonly canUpdate?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
                readonly reason: string;
              } | null;
              readonly actor?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly changedFields?: ReadonlyArray<{
                readonly __typename: "ArtifactChangedFieldNode";
                readonly fieldName?: string | null;
                readonly previousValue?: string | null;
                readonly newValue?: string | null;
                readonly changedFields?: ReadonlyArray<{
                  readonly __typename: "ArtifactChangedFieldNode";
                  readonly newValue?: string | null;
                  readonly previousValue?: string | null;
                  readonly fieldName?: string | null;
                } | null> | null;
                readonly newValueObject?:
                  | {
                      readonly __typename: "BaseArtifactNode";
                      readonly id: number;
                      readonly title: string;
                      readonly artifactType: ArtifactType;
                    }
                  | {
                      readonly __typename: "CareerTrackRoleNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "CommentNode";
                      readonly id: number;
                      readonly comment?: any | null;
                      readonly deleted?: boolean | null;
                      readonly creator?: {
                        readonly __typename: "UserNode";
                        readonly id: number;
                        readonly name: string;
                        readonly avatar?: string | null;
                      } | null;
                    }
                  | {
                      readonly __typename: "CompetencyNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "KeyResultNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "TopicNode";
                      readonly id: number;
                      readonly title: string;
                      readonly meeting?: {
                        readonly __typename: "MeetingNode";
                        readonly id: number;
                        readonly title?: string | null;
                        readonly meetingGroupId: number;
                      } | null;
                    }
                  | {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    }
                  | null;
                readonly previousValueObject?:
                  | {
                      readonly __typename: "BaseArtifactNode";
                      readonly id: number;
                      readonly title: string;
                      readonly artifactType: ArtifactType;
                    }
                  | {
                      readonly __typename: "CareerTrackRoleNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | { readonly __typename: "CommentNode" }
                  | {
                      readonly __typename: "CompetencyNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "KeyResultNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "TopicNode";
                      readonly id: number;
                      readonly title: string;
                      readonly meeting?: {
                        readonly __typename: "MeetingNode";
                        readonly id: number;
                        readonly title?: string | null;
                        readonly meetingGroupId: number;
                      } | null;
                    }
                  | {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    }
                  | null;
              } | null> | null;
            } | null;
          } | null>;
        };
      }
    | {
        readonly __typename: "GithubIssuesArtifactNode";
        readonly id: number;
        readonly activities: {
          readonly __typename: "ArtifactActivityNodeConnection";
          readonly totalCount: number;
          readonly pageInfo: {
            readonly __typename: "PageInfo";
            readonly hasNextPage: boolean;
            readonly endCursor?: string | null;
          };
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactActivityNodeEdge";
            readonly node?: {
              readonly __typename: "ArtifactActivityNode";
              readonly id: number;
              readonly created: string;
              readonly activityType: ArtifactActivityType;
              readonly canDelete?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
                readonly reason: string;
              } | null;
              readonly canUpdate?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
                readonly reason: string;
              } | null;
              readonly actor?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly changedFields?: ReadonlyArray<{
                readonly __typename: "ArtifactChangedFieldNode";
                readonly fieldName?: string | null;
                readonly previousValue?: string | null;
                readonly newValue?: string | null;
                readonly changedFields?: ReadonlyArray<{
                  readonly __typename: "ArtifactChangedFieldNode";
                  readonly newValue?: string | null;
                  readonly previousValue?: string | null;
                  readonly fieldName?: string | null;
                } | null> | null;
                readonly newValueObject?:
                  | {
                      readonly __typename: "BaseArtifactNode";
                      readonly id: number;
                      readonly title: string;
                      readonly artifactType: ArtifactType;
                    }
                  | {
                      readonly __typename: "CareerTrackRoleNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "CommentNode";
                      readonly id: number;
                      readonly comment?: any | null;
                      readonly deleted?: boolean | null;
                      readonly creator?: {
                        readonly __typename: "UserNode";
                        readonly id: number;
                        readonly name: string;
                        readonly avatar?: string | null;
                      } | null;
                    }
                  | {
                      readonly __typename: "CompetencyNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "KeyResultNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "TopicNode";
                      readonly id: number;
                      readonly title: string;
                      readonly meeting?: {
                        readonly __typename: "MeetingNode";
                        readonly id: number;
                        readonly title?: string | null;
                        readonly meetingGroupId: number;
                      } | null;
                    }
                  | {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    }
                  | null;
                readonly previousValueObject?:
                  | {
                      readonly __typename: "BaseArtifactNode";
                      readonly id: number;
                      readonly title: string;
                      readonly artifactType: ArtifactType;
                    }
                  | {
                      readonly __typename: "CareerTrackRoleNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | { readonly __typename: "CommentNode" }
                  | {
                      readonly __typename: "CompetencyNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "KeyResultNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "TopicNode";
                      readonly id: number;
                      readonly title: string;
                      readonly meeting?: {
                        readonly __typename: "MeetingNode";
                        readonly id: number;
                        readonly title?: string | null;
                        readonly meetingGroupId: number;
                      } | null;
                    }
                  | {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    }
                  | null;
              } | null> | null;
            } | null;
          } | null>;
        };
      }
    | {
        readonly __typename: "GoalArtifactNode";
        readonly id: number;
        readonly activities: {
          readonly __typename: "ArtifactActivityNodeConnection";
          readonly totalCount: number;
          readonly pageInfo: {
            readonly __typename: "PageInfo";
            readonly hasNextPage: boolean;
            readonly endCursor?: string | null;
          };
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactActivityNodeEdge";
            readonly node?: {
              readonly __typename: "ArtifactActivityNode";
              readonly id: number;
              readonly created: string;
              readonly activityType: ArtifactActivityType;
              readonly canDelete?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
                readonly reason: string;
              } | null;
              readonly canUpdate?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
                readonly reason: string;
              } | null;
              readonly actor?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly changedFields?: ReadonlyArray<{
                readonly __typename: "ArtifactChangedFieldNode";
                readonly fieldName?: string | null;
                readonly previousValue?: string | null;
                readonly newValue?: string | null;
                readonly changedFields?: ReadonlyArray<{
                  readonly __typename: "ArtifactChangedFieldNode";
                  readonly newValue?: string | null;
                  readonly previousValue?: string | null;
                  readonly fieldName?: string | null;
                } | null> | null;
                readonly newValueObject?:
                  | {
                      readonly __typename: "BaseArtifactNode";
                      readonly id: number;
                      readonly title: string;
                      readonly artifactType: ArtifactType;
                    }
                  | {
                      readonly __typename: "CareerTrackRoleNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "CommentNode";
                      readonly id: number;
                      readonly comment?: any | null;
                      readonly deleted?: boolean | null;
                      readonly creator?: {
                        readonly __typename: "UserNode";
                        readonly id: number;
                        readonly name: string;
                        readonly avatar?: string | null;
                      } | null;
                    }
                  | {
                      readonly __typename: "CompetencyNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "KeyResultNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "TopicNode";
                      readonly id: number;
                      readonly title: string;
                      readonly meeting?: {
                        readonly __typename: "MeetingNode";
                        readonly id: number;
                        readonly title?: string | null;
                        readonly meetingGroupId: number;
                      } | null;
                    }
                  | {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    }
                  | null;
                readonly previousValueObject?:
                  | {
                      readonly __typename: "BaseArtifactNode";
                      readonly id: number;
                      readonly title: string;
                      readonly artifactType: ArtifactType;
                    }
                  | {
                      readonly __typename: "CareerTrackRoleNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | { readonly __typename: "CommentNode" }
                  | {
                      readonly __typename: "CompetencyNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "KeyResultNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "TopicNode";
                      readonly id: number;
                      readonly title: string;
                      readonly meeting?: {
                        readonly __typename: "MeetingNode";
                        readonly id: number;
                        readonly title?: string | null;
                        readonly meetingGroupId: number;
                      } | null;
                    }
                  | {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    }
                  | null;
              } | null> | null;
            } | null;
          } | null>;
        };
      }
    | {
        readonly __typename: "KPIArtifactNode";
        readonly id: number;
        readonly activities: {
          readonly __typename: "ArtifactActivityNodeConnection";
          readonly totalCount: number;
          readonly pageInfo: {
            readonly __typename: "PageInfo";
            readonly hasNextPage: boolean;
            readonly endCursor?: string | null;
          };
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactActivityNodeEdge";
            readonly node?: {
              readonly __typename: "ArtifactActivityNode";
              readonly id: number;
              readonly created: string;
              readonly activityType: ArtifactActivityType;
              readonly canDelete?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
                readonly reason: string;
              } | null;
              readonly canUpdate?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
                readonly reason: string;
              } | null;
              readonly actor?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly changedFields?: ReadonlyArray<{
                readonly __typename: "ArtifactChangedFieldNode";
                readonly fieldName?: string | null;
                readonly previousValue?: string | null;
                readonly newValue?: string | null;
                readonly changedFields?: ReadonlyArray<{
                  readonly __typename: "ArtifactChangedFieldNode";
                  readonly newValue?: string | null;
                  readonly previousValue?: string | null;
                  readonly fieldName?: string | null;
                } | null> | null;
                readonly newValueObject?:
                  | {
                      readonly __typename: "BaseArtifactNode";
                      readonly id: number;
                      readonly title: string;
                      readonly artifactType: ArtifactType;
                    }
                  | {
                      readonly __typename: "CareerTrackRoleNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "CommentNode";
                      readonly id: number;
                      readonly comment?: any | null;
                      readonly deleted?: boolean | null;
                      readonly creator?: {
                        readonly __typename: "UserNode";
                        readonly id: number;
                        readonly name: string;
                        readonly avatar?: string | null;
                      } | null;
                    }
                  | {
                      readonly __typename: "CompetencyNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "KeyResultNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "TopicNode";
                      readonly id: number;
                      readonly title: string;
                      readonly meeting?: {
                        readonly __typename: "MeetingNode";
                        readonly id: number;
                        readonly title?: string | null;
                        readonly meetingGroupId: number;
                      } | null;
                    }
                  | {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    }
                  | null;
                readonly previousValueObject?:
                  | {
                      readonly __typename: "BaseArtifactNode";
                      readonly id: number;
                      readonly title: string;
                      readonly artifactType: ArtifactType;
                    }
                  | {
                      readonly __typename: "CareerTrackRoleNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | { readonly __typename: "CommentNode" }
                  | {
                      readonly __typename: "CompetencyNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "KeyResultNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "TopicNode";
                      readonly id: number;
                      readonly title: string;
                      readonly meeting?: {
                        readonly __typename: "MeetingNode";
                        readonly id: number;
                        readonly title?: string | null;
                        readonly meetingGroupId: number;
                      } | null;
                    }
                  | {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    }
                  | null;
              } | null> | null;
            } | null;
          } | null>;
        };
      }
    | {
        readonly __typename: "RatingArtifactNode";
        readonly id: number;
        readonly activities: {
          readonly __typename: "ArtifactActivityNodeConnection";
          readonly totalCount: number;
          readonly pageInfo: {
            readonly __typename: "PageInfo";
            readonly hasNextPage: boolean;
            readonly endCursor?: string | null;
          };
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactActivityNodeEdge";
            readonly node?: {
              readonly __typename: "ArtifactActivityNode";
              readonly id: number;
              readonly created: string;
              readonly activityType: ArtifactActivityType;
              readonly canDelete?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
                readonly reason: string;
              } | null;
              readonly canUpdate?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
                readonly reason: string;
              } | null;
              readonly actor?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly changedFields?: ReadonlyArray<{
                readonly __typename: "ArtifactChangedFieldNode";
                readonly fieldName?: string | null;
                readonly previousValue?: string | null;
                readonly newValue?: string | null;
                readonly changedFields?: ReadonlyArray<{
                  readonly __typename: "ArtifactChangedFieldNode";
                  readonly newValue?: string | null;
                  readonly previousValue?: string | null;
                  readonly fieldName?: string | null;
                } | null> | null;
                readonly newValueObject?:
                  | {
                      readonly __typename: "BaseArtifactNode";
                      readonly id: number;
                      readonly title: string;
                      readonly artifactType: ArtifactType;
                    }
                  | {
                      readonly __typename: "CareerTrackRoleNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "CommentNode";
                      readonly id: number;
                      readonly comment?: any | null;
                      readonly deleted?: boolean | null;
                      readonly creator?: {
                        readonly __typename: "UserNode";
                        readonly id: number;
                        readonly name: string;
                        readonly avatar?: string | null;
                      } | null;
                    }
                  | {
                      readonly __typename: "CompetencyNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "KeyResultNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "TopicNode";
                      readonly id: number;
                      readonly title: string;
                      readonly meeting?: {
                        readonly __typename: "MeetingNode";
                        readonly id: number;
                        readonly title?: string | null;
                        readonly meetingGroupId: number;
                      } | null;
                    }
                  | {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    }
                  | null;
                readonly previousValueObject?:
                  | {
                      readonly __typename: "BaseArtifactNode";
                      readonly id: number;
                      readonly title: string;
                      readonly artifactType: ArtifactType;
                    }
                  | {
                      readonly __typename: "CareerTrackRoleNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | { readonly __typename: "CommentNode" }
                  | {
                      readonly __typename: "CompetencyNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "KeyResultNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "TopicNode";
                      readonly id: number;
                      readonly title: string;
                      readonly meeting?: {
                        readonly __typename: "MeetingNode";
                        readonly id: number;
                        readonly title?: string | null;
                        readonly meetingGroupId: number;
                      } | null;
                    }
                  | {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    }
                  | null;
              } | null> | null;
            } | null;
          } | null>;
        };
      }
    | {
        readonly __typename: "RecognitionArtifactNode";
        readonly id: number;
        readonly activities: {
          readonly __typename: "ArtifactActivityNodeConnection";
          readonly totalCount: number;
          readonly pageInfo: {
            readonly __typename: "PageInfo";
            readonly hasNextPage: boolean;
            readonly endCursor?: string | null;
          };
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactActivityNodeEdge";
            readonly node?: {
              readonly __typename: "ArtifactActivityNode";
              readonly id: number;
              readonly created: string;
              readonly activityType: ArtifactActivityType;
              readonly canDelete?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
                readonly reason: string;
              } | null;
              readonly canUpdate?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
                readonly reason: string;
              } | null;
              readonly actor?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly changedFields?: ReadonlyArray<{
                readonly __typename: "ArtifactChangedFieldNode";
                readonly fieldName?: string | null;
                readonly previousValue?: string | null;
                readonly newValue?: string | null;
                readonly changedFields?: ReadonlyArray<{
                  readonly __typename: "ArtifactChangedFieldNode";
                  readonly newValue?: string | null;
                  readonly previousValue?: string | null;
                  readonly fieldName?: string | null;
                } | null> | null;
                readonly newValueObject?:
                  | {
                      readonly __typename: "BaseArtifactNode";
                      readonly id: number;
                      readonly title: string;
                      readonly artifactType: ArtifactType;
                    }
                  | {
                      readonly __typename: "CareerTrackRoleNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "CommentNode";
                      readonly id: number;
                      readonly comment?: any | null;
                      readonly deleted?: boolean | null;
                      readonly creator?: {
                        readonly __typename: "UserNode";
                        readonly id: number;
                        readonly name: string;
                        readonly avatar?: string | null;
                      } | null;
                    }
                  | {
                      readonly __typename: "CompetencyNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "KeyResultNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "TopicNode";
                      readonly id: number;
                      readonly title: string;
                      readonly meeting?: {
                        readonly __typename: "MeetingNode";
                        readonly id: number;
                        readonly title?: string | null;
                        readonly meetingGroupId: number;
                      } | null;
                    }
                  | {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    }
                  | null;
                readonly previousValueObject?:
                  | {
                      readonly __typename: "BaseArtifactNode";
                      readonly id: number;
                      readonly title: string;
                      readonly artifactType: ArtifactType;
                    }
                  | {
                      readonly __typename: "CareerTrackRoleNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | { readonly __typename: "CommentNode" }
                  | {
                      readonly __typename: "CompetencyNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "KeyResultNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "TopicNode";
                      readonly id: number;
                      readonly title: string;
                      readonly meeting?: {
                        readonly __typename: "MeetingNode";
                        readonly id: number;
                        readonly title?: string | null;
                        readonly meetingGroupId: number;
                      } | null;
                    }
                  | {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    }
                  | null;
              } | null> | null;
            } | null;
          } | null>;
        };
      };
};

export type GoalArtifactSidebarFragmentFragment = {
  readonly __typename: "GoalArtifactNode";
  readonly id: number;
  readonly parentGoalId?: number | null;
  readonly artifactType: ArtifactType;
  readonly startValue: number;
  readonly currentValue: number;
  readonly targetValue: number;
  readonly progress: number;
  readonly progressType: GoalProgressType;
  readonly dueDate?: string | null;
  readonly startDate?: string | null;
  readonly state: GoalState;
  readonly status: GoalStatus;
  readonly scope: GoalScope;
  readonly goalVisibility: GoalVisibility;
  readonly created: string;
  readonly ownerCount?: number | null;
  readonly contributorCount?: number | null;
  readonly isStale: boolean;
  readonly title?: string | null;
  readonly updated?: string | null;
  readonly basicChildGoals?: {
    readonly __typename: "BasicGoalArtifactNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "BasicGoalArtifactNodeEdge";
      readonly node?: {
        readonly __typename: "BasicGoalArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly startValue: number;
        readonly currentValue: number;
        readonly targetValue: number;
        readonly progress: number;
        readonly progressType: GoalProgressType;
        readonly dueDate?: string | null;
        readonly startDate?: string | null;
        readonly state: GoalState;
        readonly status: GoalStatus;
        readonly scope: GoalScope;
        readonly goalVisibility: GoalVisibility;
        readonly created: string;
        readonly parentGoalId?: number | null;
        readonly ownerCount?: number | null;
        readonly contributorCount?: number | null;
        readonly isStale: boolean;
        readonly firstOwner?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly avatar?: string | null;
          readonly name: string;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canRead: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly goalArtifact?: {
          readonly __typename: "GoalArtifactNode";
          readonly id: number;
          readonly title?: string | null;
        } | null;
      } | null;
    } | null>;
  } | null;
  readonly parentGoal?: {
    readonly __typename: "GoalArtifactNode";
    readonly id: number;
    readonly artifactType: ArtifactType;
    readonly title?: string | null;
    readonly updated?: string | null;
    readonly created: string;
    readonly state: GoalState;
    readonly scope: GoalScope;
    readonly ownerCount?: number | null;
    readonly dueDate?: string | null;
    readonly goalVisibility: GoalVisibility;
    readonly status: GoalStatus;
    readonly progress: number;
    readonly progressType: GoalProgressType;
    readonly currentValue: number;
    readonly startValue: number;
    readonly targetValue: number;
    readonly isStale: boolean;
    readonly parentGoalId?: number | null;
    readonly canUpdate: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    };
    readonly canDelete: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    };
    readonly creator?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly avatar?: string | null;
    } | null;
    readonly firstOwner?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly avatar?: string | null;
    } | null;
    readonly owners?: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null>;
    } | null;
  } | null;
  readonly topLevelGoal?: {
    readonly __typename: "GoalArtifactNode";
    readonly id: number;
    readonly artifactType: ArtifactType;
    readonly title?: string | null;
    readonly updated?: string | null;
    readonly created: string;
    readonly state: GoalState;
    readonly scope: GoalScope;
    readonly ownerCount?: number | null;
    readonly dueDate?: string | null;
    readonly goalVisibility: GoalVisibility;
    readonly status: GoalStatus;
    readonly progress: number;
    readonly progressType: GoalProgressType;
    readonly currentValue: number;
    readonly startValue: number;
    readonly targetValue: number;
    readonly isStale: boolean;
    readonly parentGoalId?: number | null;
    readonly canUpdate: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    };
    readonly canDelete: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    };
    readonly creator?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly avatar?: string | null;
    } | null;
    readonly firstOwner?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly avatar?: string | null;
    } | null;
    readonly owners?: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null>;
    } | null;
  } | null;
  readonly kpi?: {
    readonly __typename: "KPINode";
    readonly id: number;
    readonly title: string;
    readonly currentMeasurement?: {
      readonly __typename: "KPIMeasurementNode";
      readonly id: number;
      readonly measurement: number;
    } | null;
  } | null;
  readonly owners?: {
    readonly __typename: "UserNodeConnection";
    readonly totalCount: number;
    readonly edges: ReadonlyArray<{
      readonly __typename: "UserNodeEdge";
      readonly node?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly avatar?: string | null;
        readonly name: string;
      } | null;
    } | null>;
  } | null;
  readonly contributors?: {
    readonly __typename: "UserNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "UserNodeEdge";
      readonly node?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly avatar?: string | null;
        readonly name: string;
      } | null;
    } | null>;
  } | null;
  readonly keyResults: {
    readonly __typename: "KeyResultNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "KeyResultNodeEdge";
      readonly node?: {
        readonly __typename: "KeyResultNode";
        readonly id: number;
        readonly title: string;
        readonly startValue: number;
        readonly currentValue: number;
        readonly targetValue: number;
        readonly progressType: GoalProgressType;
        readonly kpi?: {
          readonly __typename: "KPINode";
          readonly id: number;
          readonly title: string;
          readonly currentMeasurement?: {
            readonly __typename: "KPIMeasurementNode";
            readonly id: number;
            readonly measurement: number;
          } | null;
        } | null;
        readonly canUpdate?: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        } | null;
        readonly assignee?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
          readonly email: string;
        } | null;
      } | null;
    } | null>;
  };
  readonly firstOwner?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly avatar?: string | null;
    readonly name: string;
  } | null;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canRead: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
  readonly teams?: {
    readonly __typename: "TeamNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "TeamNodeEdge";
      readonly node?: {
        readonly __typename: "TeamNode";
        readonly id: number;
        readonly title: string;
      } | null;
    } | null>;
  } | null;
};

export type GetArtifactSidebarQueryQueryVariables = Exact<{
  artifactId: Scalars["Int"]["input"];
  keyResultLimit: Scalars["Int"]["input"];
}>;

export type GetArtifactSidebarQueryQuery = {
  readonly __typename: "Query";
  readonly artifact:
    | {
        readonly __typename: "ActionItemArtifactNode";
        readonly isComplete?: boolean | null;
        readonly actionItemState?: number | null;
        readonly dueDate?: string | null;
        readonly id: number;
        readonly title?: string | null;
        readonly description?: any | null;
        readonly artifactType: ArtifactType;
        readonly created: string;
        readonly updated?: string | null;
        readonly websocketToken?: string | null;
        readonly assignee?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly avatar?: string | null;
          readonly name: string;
        } | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canRead: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
        readonly topics?: {
          readonly __typename: "ArtifactToTopicConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactToTopicEdge";
            readonly connectionCreated?: string | null;
            readonly connectionCreator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
            } | null;
            readonly node?: {
              readonly __typename: "TopicNode";
              readonly id: number;
              readonly title: string;
              readonly meeting?: {
                readonly __typename: "MeetingNode";
                readonly id: number;
                readonly meetingGroupId: number;
              } | null;
            } | null;
          } | null>;
        } | null;
        readonly relatedArtifacts?: {
          readonly __typename: "ArtifactToArtifactConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactToArtifactEdge";
            readonly connectionCreated?: string | null;
            readonly connectionCreator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
            } | null;
            readonly node?:
              | {
                  readonly __typename: "ActionItemArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "AsanaTaskArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "DecisionArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "DocumentArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "FeedbackArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "GithubIssuesArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "GoalArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "KPIArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "RatingArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "RecognitionArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | null;
          } | null>;
        } | null;
      }
    | {
        readonly __typename: "AsanaTaskArtifactNode";
        readonly id: number;
        readonly title?: string | null;
        readonly description?: any | null;
        readonly artifactType: ArtifactType;
        readonly created: string;
        readonly updated?: string | null;
        readonly websocketToken?: string | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canRead: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
        readonly topics?: {
          readonly __typename: "ArtifactToTopicConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactToTopicEdge";
            readonly connectionCreated?: string | null;
            readonly connectionCreator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
            } | null;
            readonly node?: {
              readonly __typename: "TopicNode";
              readonly id: number;
              readonly title: string;
              readonly meeting?: {
                readonly __typename: "MeetingNode";
                readonly id: number;
                readonly meetingGroupId: number;
              } | null;
            } | null;
          } | null>;
        } | null;
        readonly relatedArtifacts?: {
          readonly __typename: "ArtifactToArtifactConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactToArtifactEdge";
            readonly connectionCreated?: string | null;
            readonly connectionCreator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
            } | null;
            readonly node?:
              | {
                  readonly __typename: "ActionItemArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "AsanaTaskArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "DecisionArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "DocumentArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "FeedbackArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "GithubIssuesArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "GoalArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "KPIArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "RatingArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "RecognitionArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | null;
          } | null>;
        } | null;
      }
    | {
        readonly __typename: "DecisionArtifactNode";
        readonly decision: string;
        readonly decisionState?: DecisionState | null;
        readonly isDraft?: boolean | null;
        readonly id: number;
        readonly title?: string | null;
        readonly description?: any | null;
        readonly artifactType: ArtifactType;
        readonly created: string;
        readonly updated?: string | null;
        readonly websocketToken?: string | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canRead: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
        readonly topics?: {
          readonly __typename: "ArtifactToTopicConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactToTopicEdge";
            readonly connectionCreated?: string | null;
            readonly connectionCreator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
            } | null;
            readonly node?: {
              readonly __typename: "TopicNode";
              readonly id: number;
              readonly title: string;
              readonly meeting?: {
                readonly __typename: "MeetingNode";
                readonly id: number;
                readonly meetingGroupId: number;
              } | null;
            } | null;
          } | null>;
        } | null;
        readonly relatedArtifacts?: {
          readonly __typename: "ArtifactToArtifactConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactToArtifactEdge";
            readonly connectionCreated?: string | null;
            readonly connectionCreator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
            } | null;
            readonly node?:
              | {
                  readonly __typename: "ActionItemArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "AsanaTaskArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "DecisionArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "DocumentArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "FeedbackArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "GithubIssuesArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "GoalArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "KPIArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "RatingArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "RecognitionArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | null;
          } | null>;
        } | null;
      }
    | {
        readonly __typename: "DocumentArtifactNode";
        readonly documentVisibility?: DocumentVisibility | null;
        readonly id: number;
        readonly title?: string | null;
        readonly description?: any | null;
        readonly artifactType: ArtifactType;
        readonly created: string;
        readonly updated?: string | null;
        readonly websocketToken?: string | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canRead: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
        readonly topics?: {
          readonly __typename: "ArtifactToTopicConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactToTopicEdge";
            readonly connectionCreated?: string | null;
            readonly connectionCreator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
            } | null;
            readonly node?: {
              readonly __typename: "TopicNode";
              readonly id: number;
              readonly title: string;
              readonly meeting?: {
                readonly __typename: "MeetingNode";
                readonly id: number;
                readonly meetingGroupId: number;
              } | null;
            } | null;
          } | null>;
        } | null;
        readonly relatedArtifacts?: {
          readonly __typename: "ArtifactToArtifactConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactToArtifactEdge";
            readonly connectionCreated?: string | null;
            readonly connectionCreator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
            } | null;
            readonly node?:
              | {
                  readonly __typename: "ActionItemArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "AsanaTaskArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "DecisionArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "DocumentArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "FeedbackArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "GithubIssuesArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "GoalArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "KPIArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "RatingArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "RecognitionArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | null;
          } | null>;
        } | null;
      }
    | {
        readonly __typename: "FeedbackArtifactNode";
        readonly id: number;
        readonly title?: string | null;
        readonly description?: any | null;
        readonly artifactType: ArtifactType;
        readonly created: string;
        readonly updated?: string | null;
        readonly websocketToken?: string | null;
        readonly recipientsCanView: boolean;
        readonly recipientsManagersCanView: boolean;
        readonly adminsCanView: boolean;
        readonly creatorCanView: boolean;
        readonly feedbackState: FeedbackState;
        readonly message?: any | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canRead: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
        readonly topics?: {
          readonly __typename: "ArtifactToTopicConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactToTopicEdge";
            readonly connectionCreated?: string | null;
            readonly connectionCreator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
            } | null;
            readonly node?: {
              readonly __typename: "TopicNode";
              readonly id: number;
              readonly title: string;
              readonly meeting?: {
                readonly __typename: "MeetingNode";
                readonly id: number;
                readonly meetingGroupId: number;
              } | null;
            } | null;
          } | null>;
        } | null;
        readonly relatedArtifacts?: {
          readonly __typename: "ArtifactToArtifactConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactToArtifactEdge";
            readonly connectionCreated?: string | null;
            readonly connectionCreator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
            } | null;
            readonly node?:
              | {
                  readonly __typename: "ActionItemArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "AsanaTaskArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "DecisionArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "DocumentArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "FeedbackArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "GithubIssuesArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "GoalArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "KPIArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "RatingArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "RecognitionArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | null;
          } | null>;
        } | null;
        readonly feedbackRecipients: {
          readonly __typename: "UserNodeConnection";
          readonly totalCount: number;
          readonly edges: ReadonlyArray<{
            readonly __typename: "UserNodeEdge";
            readonly node?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly avatar?: string | null;
              readonly name: string;
            } | null;
          } | null>;
        };
        readonly sender: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly avatar?: string | null;
          readonly name: string;
        };
      }
    | {
        readonly __typename: "GithubIssuesArtifactNode";
        readonly id: number;
        readonly title?: string | null;
        readonly description?: any | null;
        readonly artifactType: ArtifactType;
        readonly created: string;
        readonly updated?: string | null;
        readonly websocketToken?: string | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canRead: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
        readonly topics?: {
          readonly __typename: "ArtifactToTopicConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactToTopicEdge";
            readonly connectionCreated?: string | null;
            readonly connectionCreator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
            } | null;
            readonly node?: {
              readonly __typename: "TopicNode";
              readonly id: number;
              readonly title: string;
              readonly meeting?: {
                readonly __typename: "MeetingNode";
                readonly id: number;
                readonly meetingGroupId: number;
              } | null;
            } | null;
          } | null>;
        } | null;
        readonly relatedArtifacts?: {
          readonly __typename: "ArtifactToArtifactConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactToArtifactEdge";
            readonly connectionCreated?: string | null;
            readonly connectionCreator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
            } | null;
            readonly node?:
              | {
                  readonly __typename: "ActionItemArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "AsanaTaskArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "DecisionArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "DocumentArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "FeedbackArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "GithubIssuesArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "GoalArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "KPIArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "RatingArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "RecognitionArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | null;
          } | null>;
        } | null;
      }
    | {
        readonly __typename: "GoalArtifactNode";
        readonly id: number;
        readonly title?: string | null;
        readonly description?: any | null;
        readonly artifactType: ArtifactType;
        readonly created: string;
        readonly updated?: string | null;
        readonly websocketToken?: string | null;
        readonly parentGoalId?: number | null;
        readonly startValue: number;
        readonly currentValue: number;
        readonly targetValue: number;
        readonly progress: number;
        readonly progressType: GoalProgressType;
        readonly dueDate?: string | null;
        readonly startDate?: string | null;
        readonly state: GoalState;
        readonly status: GoalStatus;
        readonly scope: GoalScope;
        readonly goalVisibility: GoalVisibility;
        readonly ownerCount?: number | null;
        readonly contributorCount?: number | null;
        readonly isStale: boolean;
        readonly owners?: {
          readonly __typename: "UserNodeConnection";
          readonly totalCount: number;
          readonly edges: ReadonlyArray<{
            readonly __typename: "UserNodeEdge";
            readonly node?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          } | null>;
        } | null;
        readonly contributors?: {
          readonly __typename: "UserNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "UserNodeEdge";
            readonly node?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          } | null>;
        } | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canRead: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
        readonly topics?: {
          readonly __typename: "ArtifactToTopicConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactToTopicEdge";
            readonly connectionCreated?: string | null;
            readonly connectionCreator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
            } | null;
            readonly node?: {
              readonly __typename: "TopicNode";
              readonly id: number;
              readonly title: string;
              readonly meeting?: {
                readonly __typename: "MeetingNode";
                readonly id: number;
                readonly meetingGroupId: number;
              } | null;
            } | null;
          } | null>;
        } | null;
        readonly relatedArtifacts?: {
          readonly __typename: "ArtifactToArtifactConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactToArtifactEdge";
            readonly connectionCreated?: string | null;
            readonly connectionCreator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
            } | null;
            readonly node?:
              | {
                  readonly __typename: "ActionItemArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "AsanaTaskArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "DecisionArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "DocumentArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "FeedbackArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "GithubIssuesArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "GoalArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "KPIArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "RatingArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "RecognitionArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | null;
          } | null>;
        } | null;
        readonly basicChildGoals?: {
          readonly __typename: "BasicGoalArtifactNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "BasicGoalArtifactNodeEdge";
            readonly node?: {
              readonly __typename: "BasicGoalArtifactNode";
              readonly id: number;
              readonly artifactType: ArtifactType;
              readonly startValue: number;
              readonly currentValue: number;
              readonly targetValue: number;
              readonly progress: number;
              readonly progressType: GoalProgressType;
              readonly dueDate?: string | null;
              readonly startDate?: string | null;
              readonly state: GoalState;
              readonly status: GoalStatus;
              readonly scope: GoalScope;
              readonly goalVisibility: GoalVisibility;
              readonly created: string;
              readonly parentGoalId?: number | null;
              readonly ownerCount?: number | null;
              readonly contributorCount?: number | null;
              readonly isStale: boolean;
              readonly firstOwner?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly avatar?: string | null;
                readonly name: string;
              } | null;
              readonly canDelete: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
              readonly canUpdate: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
              readonly canRead: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
              readonly goalArtifact?: {
                readonly __typename: "GoalArtifactNode";
                readonly id: number;
                readonly title?: string | null;
              } | null;
            } | null;
          } | null>;
        } | null;
        readonly parentGoal?: {
          readonly __typename: "GoalArtifactNode";
          readonly id: number;
          readonly artifactType: ArtifactType;
          readonly title?: string | null;
          readonly updated?: string | null;
          readonly created: string;
          readonly state: GoalState;
          readonly scope: GoalScope;
          readonly ownerCount?: number | null;
          readonly dueDate?: string | null;
          readonly goalVisibility: GoalVisibility;
          readonly status: GoalStatus;
          readonly progress: number;
          readonly progressType: GoalProgressType;
          readonly currentValue: number;
          readonly startValue: number;
          readonly targetValue: number;
          readonly isStale: boolean;
          readonly parentGoalId?: number | null;
          readonly canUpdate: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly creator?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
          readonly firstOwner?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
          readonly owners?: {
            readonly __typename: "UserNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "UserNodeEdge";
              readonly node?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            } | null>;
          } | null;
        } | null;
        readonly topLevelGoal?: {
          readonly __typename: "GoalArtifactNode";
          readonly id: number;
          readonly artifactType: ArtifactType;
          readonly title?: string | null;
          readonly updated?: string | null;
          readonly created: string;
          readonly state: GoalState;
          readonly scope: GoalScope;
          readonly ownerCount?: number | null;
          readonly dueDate?: string | null;
          readonly goalVisibility: GoalVisibility;
          readonly status: GoalStatus;
          readonly progress: number;
          readonly progressType: GoalProgressType;
          readonly currentValue: number;
          readonly startValue: number;
          readonly targetValue: number;
          readonly isStale: boolean;
          readonly parentGoalId?: number | null;
          readonly canUpdate: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly creator?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
          readonly firstOwner?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
          readonly owners?: {
            readonly __typename: "UserNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "UserNodeEdge";
              readonly node?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            } | null>;
          } | null;
        } | null;
        readonly kpi?: {
          readonly __typename: "KPINode";
          readonly id: number;
          readonly title: string;
          readonly currentMeasurement?: {
            readonly __typename: "KPIMeasurementNode";
            readonly id: number;
            readonly measurement: number;
          } | null;
        } | null;
        readonly keyResults: {
          readonly __typename: "KeyResultNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "KeyResultNodeEdge";
            readonly node?: {
              readonly __typename: "KeyResultNode";
              readonly id: number;
              readonly title: string;
              readonly startValue: number;
              readonly currentValue: number;
              readonly targetValue: number;
              readonly progressType: GoalProgressType;
              readonly kpi?: {
                readonly __typename: "KPINode";
                readonly id: number;
                readonly title: string;
                readonly currentMeasurement?: {
                  readonly __typename: "KPIMeasurementNode";
                  readonly id: number;
                  readonly measurement: number;
                } | null;
              } | null;
              readonly canUpdate?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              } | null;
              readonly assignee?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
                readonly email: string;
              } | null;
            } | null;
          } | null>;
        };
        readonly firstOwner?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly avatar?: string | null;
          readonly name: string;
        } | null;
        readonly teams?: {
          readonly __typename: "TeamNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "TeamNodeEdge";
            readonly node?: {
              readonly __typename: "TeamNode";
              readonly id: number;
              readonly title: string;
            } | null;
          } | null>;
        } | null;
      }
    | {
        readonly __typename: "KPIArtifactNode";
        readonly id: number;
        readonly title?: string | null;
        readonly description?: any | null;
        readonly artifactType: ArtifactType;
        readonly created: string;
        readonly updated?: string | null;
        readonly websocketToken?: string | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canRead: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
        readonly topics?: {
          readonly __typename: "ArtifactToTopicConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactToTopicEdge";
            readonly connectionCreated?: string | null;
            readonly connectionCreator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
            } | null;
            readonly node?: {
              readonly __typename: "TopicNode";
              readonly id: number;
              readonly title: string;
              readonly meeting?: {
                readonly __typename: "MeetingNode";
                readonly id: number;
                readonly meetingGroupId: number;
              } | null;
            } | null;
          } | null>;
        } | null;
        readonly relatedArtifacts?: {
          readonly __typename: "ArtifactToArtifactConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactToArtifactEdge";
            readonly connectionCreated?: string | null;
            readonly connectionCreator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
            } | null;
            readonly node?:
              | {
                  readonly __typename: "ActionItemArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "AsanaTaskArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "DecisionArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "DocumentArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "FeedbackArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "GithubIssuesArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "GoalArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "KPIArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "RatingArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "RecognitionArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | null;
          } | null>;
        } | null;
      }
    | {
        readonly __typename: "RatingArtifactNode";
        readonly canAnswer?: boolean | null;
        readonly canViewAnswers?: boolean | null;
        readonly id: number;
        readonly title?: string | null;
        readonly description?: any | null;
        readonly artifactType: ArtifactType;
        readonly created: string;
        readonly updated?: string | null;
        readonly websocketToken?: string | null;
        readonly rating?: {
          readonly __typename: "RatingNode";
          readonly id: number;
          readonly title: string;
          readonly description: any;
          readonly startValue: number;
          readonly endValue: number;
          readonly labels: ReadonlyArray<string | null>;
        } | null;
        readonly createdInMeeting?: {
          readonly __typename: "MeetingNode";
          readonly id: number;
          readonly meetingGroupId: number;
        } | null;
        readonly answers?: {
          readonly __typename: "RatingAnswerNodeConnection";
          readonly totalCount?: number | null;
          readonly edges: ReadonlyArray<{
            readonly __typename: "RatingAnswerNodeEdge";
            readonly node?: {
              readonly __typename: "RatingAnswerNode";
              readonly id: number;
              readonly integerAnswer: number;
              readonly creator: {
                readonly __typename: "UserNode";
                readonly id: number;
              };
            } | null;
          } | null>;
        } | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canRead: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
        readonly topics?: {
          readonly __typename: "ArtifactToTopicConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactToTopicEdge";
            readonly connectionCreated?: string | null;
            readonly connectionCreator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
            } | null;
            readonly node?: {
              readonly __typename: "TopicNode";
              readonly id: number;
              readonly title: string;
              readonly meeting?: {
                readonly __typename: "MeetingNode";
                readonly id: number;
                readonly meetingGroupId: number;
              } | null;
            } | null;
          } | null>;
        } | null;
        readonly relatedArtifacts?: {
          readonly __typename: "ArtifactToArtifactConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactToArtifactEdge";
            readonly connectionCreated?: string | null;
            readonly connectionCreator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
            } | null;
            readonly node?:
              | {
                  readonly __typename: "ActionItemArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "AsanaTaskArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "DecisionArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "DocumentArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "FeedbackArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "GithubIssuesArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "GoalArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "KPIArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "RatingArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "RecognitionArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | null;
          } | null>;
        } | null;
      }
    | {
        readonly __typename: "RecognitionArtifactNode";
        readonly id: number;
        readonly title?: string | null;
        readonly description?: any | null;
        readonly artifactType: ArtifactType;
        readonly created: string;
        readonly updated?: string | null;
        readonly websocketToken?: string | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canRead: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
        readonly topics?: {
          readonly __typename: "ArtifactToTopicConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactToTopicEdge";
            readonly connectionCreated?: string | null;
            readonly connectionCreator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
            } | null;
            readonly node?: {
              readonly __typename: "TopicNode";
              readonly id: number;
              readonly title: string;
              readonly meeting?: {
                readonly __typename: "MeetingNode";
                readonly id: number;
                readonly meetingGroupId: number;
              } | null;
            } | null;
          } | null>;
        } | null;
        readonly relatedArtifacts?: {
          readonly __typename: "ArtifactToArtifactConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactToArtifactEdge";
            readonly connectionCreated?: string | null;
            readonly connectionCreator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
            } | null;
            readonly node?:
              | {
                  readonly __typename: "ActionItemArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "AsanaTaskArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "DecisionArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "DocumentArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "FeedbackArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "GithubIssuesArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "GoalArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "KPIArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "RatingArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "RecognitionArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | null;
          } | null>;
        } | null;
        readonly recipients?: {
          readonly __typename: "UserNodeConnection";
          readonly totalCount: number;
          readonly edges: ReadonlyArray<{
            readonly __typename: "UserNodeEdge";
            readonly node?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          } | null>;
        } | null;
        readonly recognitionCoreValue?: {
          readonly __typename: "RecognitionCoreValueNode";
          readonly id: number;
          readonly title: string;
          readonly description: string;
          readonly emoji?: string | null;
          readonly image?: string | null;
        } | null;
      };
};

export type GetDataForGrowthConnectionPickerQueryQueryVariables = Exact<{
  userId: Scalars["Int"]["input"];
}>;

export type GetDataForGrowthConnectionPickerQueryQuery = {
  readonly __typename: "Query";
  readonly user?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly currentRoles: ReadonlyArray<{
      readonly __typename: "CareerTrackRoleNode";
      readonly id: number;
      readonly title: string;
      readonly nextRole?: {
        readonly __typename: "CareerTrackRoleNode";
        readonly id: number;
        readonly title: string;
        readonly level: number;
      } | null;
      readonly responsibilities: {
        readonly __typename: "CareerTrackRoleResponsibilityNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "CareerTrackRoleResponsibilityNodeEdge";
          readonly node?: {
            readonly __typename: "CareerTrackRoleResponsibilityNode";
            readonly id: number;
            readonly content: any;
          } | null;
        } | null>;
      };
      readonly competencies: {
        readonly __typename: "CompetencyConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "CompetencyEdge";
          readonly node?: {
            readonly __typename: "CompetencyNode";
            readonly id: number;
            readonly title: string;
          } | null;
        } | null>;
      };
    }>;
  } | null;
};

export type GoalCompetencyFragmentFragment = {
  readonly __typename: "CompetencyNode";
  readonly id: number;
  readonly title: string;
};

export type GoalRoleFragmentFragment = {
  readonly __typename: "CareerTrackRoleNode";
  readonly id: number;
  readonly title: string;
  readonly level: number;
  readonly careerTrack: {
    readonly __typename: "CareerTrackNode";
    readonly id: number;
    readonly title: string;
  };
};

export type GoalOwnerRoleCompetencyFragmentFragment = {
  readonly __typename: "GoalArtifactToCompetencyM2MNode";
  readonly id: number;
  readonly role?: {
    readonly __typename: "CareerTrackRoleNode";
    readonly id: number;
    readonly title: string;
    readonly level: number;
    readonly careerTrack: {
      readonly __typename: "CareerTrackNode";
      readonly id: number;
      readonly title: string;
    };
  } | null;
  readonly competency: {
    readonly __typename: "CompetencyNode";
    readonly id: number;
    readonly title: string;
  };
};

export type GoalCompentenciesWithRoleFragmentFragment = {
  readonly __typename: "GoalArtifactNode";
  readonly competencyRelations: {
    readonly __typename: "GoalArtifactToCompetencyM2MNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "GoalArtifactToCompetencyM2MNodeEdge";
      readonly node?: {
        readonly __typename: "GoalArtifactToCompetencyM2MNode";
        readonly id: number;
        readonly role?: {
          readonly __typename: "CareerTrackRoleNode";
          readonly id: number;
          readonly title: string;
          readonly level: number;
          readonly careerTrack: {
            readonly __typename: "CareerTrackNode";
            readonly id: number;
            readonly title: string;
          };
        } | null;
        readonly competency: {
          readonly __typename: "CompetencyNode";
          readonly id: number;
          readonly title: string;
        };
      } | null;
    } | null>;
  };
};

export type GoalOwnerRoleFragmentFragment = {
  readonly __typename: "CareerTrackRoleNode";
  readonly id: number;
  readonly title: string;
  readonly level: number;
  readonly careerTrack: {
    readonly __typename: "CareerTrackNode";
    readonly id: number;
    readonly title: string;
  };
  readonly competencies: {
    readonly __typename: "CompetencyConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "CompetencyEdge";
      readonly node?: {
        readonly __typename: "CompetencyNode";
        readonly id: number;
        readonly title: string;
      } | null;
    } | null>;
  };
};

export type GetGoalGrowthConnectionsQueryQueryVariables = Exact<{
  artifactId: Scalars["Int"]["input"];
  userId: Scalars["Int"]["input"];
}>;

export type GetGoalGrowthConnectionsQueryQuery = {
  readonly __typename: "Query";
  readonly artifact:
    | { readonly __typename: "ActionItemArtifactNode"; readonly id: number }
    | { readonly __typename: "AsanaTaskArtifactNode"; readonly id: number }
    | { readonly __typename: "DecisionArtifactNode"; readonly id: number }
    | { readonly __typename: "DocumentArtifactNode"; readonly id: number }
    | { readonly __typename: "FeedbackArtifactNode"; readonly id: number }
    | { readonly __typename: "GithubIssuesArtifactNode"; readonly id: number }
    | {
        readonly __typename: "GoalArtifactNode";
        readonly id: number;
        readonly competencyRelations: {
          readonly __typename: "GoalArtifactToCompetencyM2MNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "GoalArtifactToCompetencyM2MNodeEdge";
            readonly node?: {
              readonly __typename: "GoalArtifactToCompetencyM2MNode";
              readonly id: number;
              readonly role?: {
                readonly __typename: "CareerTrackRoleNode";
                readonly id: number;
                readonly title: string;
                readonly level: number;
                readonly careerTrack: {
                  readonly __typename: "CareerTrackNode";
                  readonly id: number;
                  readonly title: string;
                };
              } | null;
              readonly competency: {
                readonly __typename: "CompetencyNode";
                readonly id: number;
                readonly title: string;
              };
            } | null;
          } | null>;
        };
      }
    | { readonly __typename: "KPIArtifactNode"; readonly id: number }
    | { readonly __typename: "RatingArtifactNode"; readonly id: number }
    | { readonly __typename: "RecognitionArtifactNode"; readonly id: number };
  readonly user?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly currentRoles: ReadonlyArray<{
      readonly __typename: "CareerTrackRoleNode";
      readonly id: number;
      readonly title: string;
      readonly level: number;
      readonly careerTrack: {
        readonly __typename: "CareerTrackNode";
        readonly id: number;
        readonly title: string;
      };
      readonly competencies: {
        readonly __typename: "CompetencyConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "CompetencyEdge";
          readonly node?: {
            readonly __typename: "CompetencyNode";
            readonly id: number;
            readonly title: string;
          } | null;
        } | null>;
      };
    }>;
  } | null;
};

export type GetKpisToConnectToKrQueryQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetKpisToConnectToKrQueryQuery = {
  readonly __typename: "Query";
  readonly kpis?: {
    readonly __typename: "KPINodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "KPINodeEdge";
      readonly node?: {
        readonly __typename: "KPINode";
        readonly id: number;
        readonly title: string;
        readonly visibility: KpiVisibility;
        readonly currentMeasurement?: {
          readonly __typename: "KPIMeasurementNode";
          readonly id: number;
          readonly measurement: number;
        } | null;
        readonly measurements?: {
          readonly __typename: "KPIMeasurementNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "KPIMeasurementNodeEdge";
            readonly node?: {
              readonly __typename: "KPIMeasurementNode";
              readonly id: number;
              readonly measurement: number;
              readonly timestamp: string;
            } | null;
          } | null>;
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type GoalTeamsFragmentFragment = {
  readonly __typename: "GoalArtifactNode";
  readonly teams?: {
    readonly __typename: "TeamNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "TeamNodeEdge";
      readonly node?: {
        readonly __typename: "TeamNode";
        readonly id: number;
        readonly title: string;
      } | null;
    } | null>;
  } | null;
};

export type ManageGoalKeyResultMutationVariables = Exact<{
  keyResultId?: InputMaybe<Scalars["Int"]["input"]>;
  goalId?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  startValue?: InputMaybe<Scalars["Float"]["input"]>;
  targetValue?: InputMaybe<Scalars["Float"]["input"]>;
  progressType?: InputMaybe<GoalProgressType>;
  assigneeId?: InputMaybe<Scalars["Int"]["input"]>;
  kpiId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type ManageGoalKeyResultMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateKeyResult?: {
    readonly __typename: "CreateOrUpdateKeyResultMutation";
    readonly keyResult?: {
      readonly __typename: "KeyResultNode";
      readonly id: number;
      readonly title: string;
      readonly startValue: number;
      readonly currentValue: number;
      readonly targetValue: number;
      readonly progressType: GoalProgressType;
      readonly kpi?: {
        readonly __typename: "KPINode";
        readonly id: number;
        readonly title: string;
        readonly currentMeasurement?: {
          readonly __typename: "KPIMeasurementNode";
          readonly id: number;
          readonly measurement: number;
        } | null;
      } | null;
      readonly canUpdate?: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
      } | null;
      readonly assignee?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
        readonly email: string;
      } | null;
    } | null;
    readonly goal?: {
      readonly __typename: "GoalArtifactNode";
      readonly id: number;
      readonly contributors?: {
        readonly __typename: "UserNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "UserNodeEdge";
          readonly node?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
        } | null>;
      } | null;
      readonly keyResults: {
        readonly __typename: "KeyResultNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "KeyResultNodeEdge";
          readonly node?: {
            readonly __typename: "KeyResultNode";
            readonly id: number;
          } | null;
        } | null>;
      };
    } | null;
  } | null;
};

export type RemoveFavouriteArtifactMutationMutationVariables = Exact<{
  artifactId: Scalars["Int"]["input"];
}>;

export type RemoveFavouriteArtifactMutationMutation = {
  readonly __typename: "Mutation";
  readonly removeFavouriteArtifact?: {
    readonly __typename: "RemoveFavouriteArtifact";
    readonly artifact?:
      | { readonly __typename: "ActionItemArtifactNode"; readonly id: number }
      | { readonly __typename: "AsanaTaskArtifactNode"; readonly id: number }
      | { readonly __typename: "DecisionArtifactNode"; readonly id: number }
      | { readonly __typename: "DocumentArtifactNode"; readonly id: number }
      | { readonly __typename: "FeedbackArtifactNode"; readonly id: number }
      | { readonly __typename: "GithubIssuesArtifactNode"; readonly id: number }
      | { readonly __typename: "GoalArtifactNode"; readonly id: number }
      | { readonly __typename: "KPIArtifactNode"; readonly id: number }
      | { readonly __typename: "RatingArtifactNode"; readonly id: number }
      | { readonly __typename: "RecognitionArtifactNode"; readonly id: number }
      | null;
    readonly user?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly favouriteArtifacts: {
        readonly __typename: "ArtifactConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "ArtifactEdge";
          readonly node?:
            | {
                readonly __typename: "ActionItemArtifactNode";
                readonly id: number;
              }
            | {
                readonly __typename: "AsanaTaskArtifactNode";
                readonly id: number;
              }
            | {
                readonly __typename: "DecisionArtifactNode";
                readonly id: number;
              }
            | {
                readonly __typename: "DocumentArtifactNode";
                readonly id: number;
              }
            | {
                readonly __typename: "FeedbackArtifactNode";
                readonly id: number;
              }
            | {
                readonly __typename: "GithubIssuesArtifactNode";
                readonly id: number;
              }
            | { readonly __typename: "GoalArtifactNode"; readonly id: number }
            | { readonly __typename: "KPIArtifactNode"; readonly id: number }
            | { readonly __typename: "RatingArtifactNode"; readonly id: number }
            | {
                readonly __typename: "RecognitionArtifactNode";
                readonly id: number;
              }
            | null;
        } | null>;
      };
    } | null;
  } | null;
};

export type SearchGoalsToAlignQueryQueryVariables = Exact<{
  excludeIds:
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>;
  goalScopes: ReadonlyArray<InputMaybe<GoalScope>> | InputMaybe<GoalScope>;
  goalParentIds?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  search: Scalars["String"]["input"];
}>;

export type SearchGoalsToAlignQueryQuery = {
  readonly __typename: "Query";
  readonly artifacts?: {
    readonly __typename: "ArtifactConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "ArtifactEdge";
      readonly node?:
        | { readonly __typename: "ActionItemArtifactNode"; readonly id: number }
        | { readonly __typename: "AsanaTaskArtifactNode"; readonly id: number }
        | { readonly __typename: "DecisionArtifactNode"; readonly id: number }
        | { readonly __typename: "DocumentArtifactNode"; readonly id: number }
        | { readonly __typename: "FeedbackArtifactNode"; readonly id: number }
        | {
            readonly __typename: "GithubIssuesArtifactNode";
            readonly id: number;
          }
        | {
            readonly __typename: "GoalArtifactNode";
            readonly title?: string | null;
            readonly scope: GoalScope;
            readonly state: GoalState;
            readonly id: number;
          }
        | { readonly __typename: "KPIArtifactNode"; readonly id: number }
        | { readonly __typename: "RatingArtifactNode"; readonly id: number }
        | {
            readonly __typename: "RecognitionArtifactNode";
            readonly id: number;
          }
        | null;
    } | null>;
  } | null;
};

export type UpdateArtifactTitleMutationMutationVariables = Exact<{
  artifactId: Scalars["Int"]["input"];
  title?: InputMaybe<Scalars["String"]["input"]>;
  additionalFields?: InputMaybe<AdditionalArtifactInput>;
}>;

export type UpdateArtifactTitleMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateArtifact?: {
    readonly __typename: "CreateOrUpdateArtifactMutation";
    readonly artifact?:
      | {
          readonly __typename: "ActionItemArtifactNode";
          readonly id: number;
          readonly title?: string | null;
        }
      | {
          readonly __typename: "AsanaTaskArtifactNode";
          readonly id: number;
          readonly title?: string | null;
        }
      | {
          readonly __typename: "DecisionArtifactNode";
          readonly decision: string;
          readonly id: number;
          readonly title?: string | null;
        }
      | {
          readonly __typename: "DocumentArtifactNode";
          readonly id: number;
          readonly title?: string | null;
        }
      | {
          readonly __typename: "FeedbackArtifactNode";
          readonly id: number;
          readonly title?: string | null;
        }
      | {
          readonly __typename: "GithubIssuesArtifactNode";
          readonly id: number;
          readonly title?: string | null;
        }
      | {
          readonly __typename: "GoalArtifactNode";
          readonly id: number;
          readonly title?: string | null;
        }
      | {
          readonly __typename: "KPIArtifactNode";
          readonly id: number;
          readonly title?: string | null;
        }
      | {
          readonly __typename: "RatingArtifactNode";
          readonly id: number;
          readonly title?: string | null;
        }
      | {
          readonly __typename: "RecognitionArtifactNode";
          readonly id: number;
          readonly title?: string | null;
        }
      | null;
  } | null;
};

export type UpdateGoalGrowthConnectionsMutationMutationVariables = Exact<{
  artifactId: Scalars["Int"]["input"];
  additionalFields?: InputMaybe<AdditionalArtifactInput>;
}>;

export type UpdateGoalGrowthConnectionsMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateArtifact?: {
    readonly __typename: "CreateOrUpdateArtifactMutation";
    readonly artifact?:
      | { readonly __typename: "ActionItemArtifactNode"; readonly id: number }
      | { readonly __typename: "AsanaTaskArtifactNode"; readonly id: number }
      | { readonly __typename: "DecisionArtifactNode"; readonly id: number }
      | { readonly __typename: "DocumentArtifactNode"; readonly id: number }
      | { readonly __typename: "FeedbackArtifactNode"; readonly id: number }
      | { readonly __typename: "GithubIssuesArtifactNode"; readonly id: number }
      | {
          readonly __typename: "GoalArtifactNode";
          readonly id: number;
          readonly competencyRelations: {
            readonly __typename: "GoalArtifactToCompetencyM2MNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "GoalArtifactToCompetencyM2MNodeEdge";
              readonly node?: {
                readonly __typename: "GoalArtifactToCompetencyM2MNode";
                readonly id: number;
                readonly role?: {
                  readonly __typename: "CareerTrackRoleNode";
                  readonly id: number;
                  readonly title: string;
                  readonly level: number;
                  readonly careerTrack: {
                    readonly __typename: "CareerTrackNode";
                    readonly id: number;
                    readonly title: string;
                  };
                } | null;
                readonly competency: {
                  readonly __typename: "CompetencyNode";
                  readonly id: number;
                  readonly title: string;
                };
              } | null;
            } | null>;
          };
        }
      | { readonly __typename: "KPIArtifactNode"; readonly id: number }
      | { readonly __typename: "RatingArtifactNode"; readonly id: number }
      | { readonly __typename: "RecognitionArtifactNode"; readonly id: number }
      | null;
  } | null;
};

export type UpdateSidebarArtifactMutationMutationVariables = Exact<{
  artifactId: Scalars["Int"]["input"];
  title?: InputMaybe<Scalars["String"]["input"]>;
  additionalFields?: InputMaybe<AdditionalArtifactInput>;
  keyResultLimit?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type UpdateSidebarArtifactMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateArtifact?: {
    readonly __typename: "CreateOrUpdateArtifactMutation";
    readonly artifact?:
      | {
          readonly __typename: "ActionItemArtifactNode";
          readonly isComplete?: boolean | null;
          readonly dueDate?: string | null;
          readonly id: number;
          readonly title?: string | null;
          readonly artifactType: ArtifactType;
          readonly assignee?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly avatar?: string | null;
            readonly name: string;
          } | null;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
        }
      | {
          readonly __typename: "AsanaTaskArtifactNode";
          readonly id: number;
          readonly title?: string | null;
          readonly artifactType: ArtifactType;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
        }
      | {
          readonly __typename: "DecisionArtifactNode";
          readonly decision: string;
          readonly decisionState?: DecisionState | null;
          readonly isDraft?: boolean | null;
          readonly id: number;
          readonly title?: string | null;
          readonly artifactType: ArtifactType;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
        }
      | {
          readonly __typename: "DocumentArtifactNode";
          readonly id: number;
          readonly title?: string | null;
          readonly artifactType: ArtifactType;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
        }
      | {
          readonly __typename: "FeedbackArtifactNode";
          readonly id: number;
          readonly title?: string | null;
          readonly artifactType: ArtifactType;
          readonly recipientsCanView: boolean;
          readonly recipientsManagersCanView: boolean;
          readonly adminsCanView: boolean;
          readonly creatorCanView: boolean;
          readonly feedbackState: FeedbackState;
          readonly message?: any | null;
          readonly created: string;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly creator?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
          readonly feedbackRecipients: {
            readonly __typename: "UserNodeConnection";
            readonly totalCount: number;
            readonly edges: ReadonlyArray<{
              readonly __typename: "UserNodeEdge";
              readonly node?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly avatar?: string | null;
                readonly name: string;
              } | null;
            } | null>;
          };
          readonly sender: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly avatar?: string | null;
            readonly name: string;
          };
        }
      | {
          readonly __typename: "GithubIssuesArtifactNode";
          readonly id: number;
          readonly title?: string | null;
          readonly artifactType: ArtifactType;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
        }
      | {
          readonly __typename: "GoalArtifactNode";
          readonly id: number;
          readonly title?: string | null;
          readonly artifactType: ArtifactType;
          readonly parentGoalId?: number | null;
          readonly startValue: number;
          readonly currentValue: number;
          readonly targetValue: number;
          readonly progress: number;
          readonly progressType: GoalProgressType;
          readonly dueDate?: string | null;
          readonly startDate?: string | null;
          readonly state: GoalState;
          readonly status: GoalStatus;
          readonly scope: GoalScope;
          readonly goalVisibility: GoalVisibility;
          readonly created: string;
          readonly ownerCount?: number | null;
          readonly contributorCount?: number | null;
          readonly isStale: boolean;
          readonly updated?: string | null;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly basicChildGoals?: {
            readonly __typename: "BasicGoalArtifactNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "BasicGoalArtifactNodeEdge";
              readonly node?: {
                readonly __typename: "BasicGoalArtifactNode";
                readonly id: number;
                readonly artifactType: ArtifactType;
                readonly startValue: number;
                readonly currentValue: number;
                readonly targetValue: number;
                readonly progress: number;
                readonly progressType: GoalProgressType;
                readonly dueDate?: string | null;
                readonly startDate?: string | null;
                readonly state: GoalState;
                readonly status: GoalStatus;
                readonly scope: GoalScope;
                readonly goalVisibility: GoalVisibility;
                readonly created: string;
                readonly parentGoalId?: number | null;
                readonly ownerCount?: number | null;
                readonly contributorCount?: number | null;
                readonly isStale: boolean;
                readonly firstOwner?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly avatar?: string | null;
                  readonly name: string;
                } | null;
                readonly canDelete: {
                  readonly __typename: "PermissionNode";
                  readonly permission: boolean;
                };
                readonly canUpdate: {
                  readonly __typename: "PermissionNode";
                  readonly permission: boolean;
                };
                readonly canRead: {
                  readonly __typename: "PermissionNode";
                  readonly permission: boolean;
                };
                readonly goalArtifact?: {
                  readonly __typename: "GoalArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                } | null;
              } | null;
            } | null>;
          } | null;
          readonly parentGoal?: {
            readonly __typename: "GoalArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly updated?: string | null;
            readonly created: string;
            readonly state: GoalState;
            readonly scope: GoalScope;
            readonly ownerCount?: number | null;
            readonly dueDate?: string | null;
            readonly goalVisibility: GoalVisibility;
            readonly status: GoalStatus;
            readonly progress: number;
            readonly progressType: GoalProgressType;
            readonly currentValue: number;
            readonly startValue: number;
            readonly targetValue: number;
            readonly isStale: boolean;
            readonly parentGoalId?: number | null;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
            readonly firstOwner?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
            readonly owners?: {
              readonly __typename: "UserNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "UserNodeEdge";
                readonly node?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly name: string;
                  readonly avatar?: string | null;
                } | null;
              } | null>;
            } | null;
          } | null;
          readonly topLevelGoal?: {
            readonly __typename: "GoalArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly updated?: string | null;
            readonly created: string;
            readonly state: GoalState;
            readonly scope: GoalScope;
            readonly ownerCount?: number | null;
            readonly dueDate?: string | null;
            readonly goalVisibility: GoalVisibility;
            readonly status: GoalStatus;
            readonly progress: number;
            readonly progressType: GoalProgressType;
            readonly currentValue: number;
            readonly startValue: number;
            readonly targetValue: number;
            readonly isStale: boolean;
            readonly parentGoalId?: number | null;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
            readonly firstOwner?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
            readonly owners?: {
              readonly __typename: "UserNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "UserNodeEdge";
                readonly node?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly name: string;
                  readonly avatar?: string | null;
                } | null;
              } | null>;
            } | null;
          } | null;
          readonly kpi?: {
            readonly __typename: "KPINode";
            readonly id: number;
            readonly title: string;
            readonly currentMeasurement?: {
              readonly __typename: "KPIMeasurementNode";
              readonly id: number;
              readonly measurement: number;
            } | null;
          } | null;
          readonly owners?: {
            readonly __typename: "UserNodeConnection";
            readonly totalCount: number;
            readonly edges: ReadonlyArray<{
              readonly __typename: "UserNodeEdge";
              readonly node?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly avatar?: string | null;
                readonly name: string;
              } | null;
            } | null>;
          } | null;
          readonly contributors?: {
            readonly __typename: "UserNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "UserNodeEdge";
              readonly node?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly avatar?: string | null;
                readonly name: string;
              } | null;
            } | null>;
          } | null;
          readonly keyResults: {
            readonly __typename: "KeyResultNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "KeyResultNodeEdge";
              readonly node?: {
                readonly __typename: "KeyResultNode";
                readonly id: number;
                readonly title: string;
                readonly startValue: number;
                readonly currentValue: number;
                readonly targetValue: number;
                readonly progressType: GoalProgressType;
                readonly kpi?: {
                  readonly __typename: "KPINode";
                  readonly id: number;
                  readonly title: string;
                  readonly currentMeasurement?: {
                    readonly __typename: "KPIMeasurementNode";
                    readonly id: number;
                    readonly measurement: number;
                  } | null;
                } | null;
                readonly canUpdate?: {
                  readonly __typename: "PermissionNode";
                  readonly permission: boolean;
                } | null;
                readonly assignee?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly name: string;
                  readonly avatar?: string | null;
                  readonly email: string;
                } | null;
              } | null;
            } | null>;
          };
          readonly firstOwner?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly avatar?: string | null;
            readonly name: string;
          } | null;
          readonly canUpdate: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canRead: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly creator?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
          readonly teams?: {
            readonly __typename: "TeamNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "TeamNodeEdge";
              readonly node?: {
                readonly __typename: "TeamNode";
                readonly id: number;
                readonly title: string;
              } | null;
            } | null>;
          } | null;
        }
      | {
          readonly __typename: "KPIArtifactNode";
          readonly id: number;
          readonly title?: string | null;
          readonly artifactType: ArtifactType;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
        }
      | {
          readonly __typename: "RatingArtifactNode";
          readonly id: number;
          readonly title?: string | null;
          readonly artifactType: ArtifactType;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
        }
      | {
          readonly __typename: "RecognitionArtifactNode";
          readonly id: number;
          readonly title?: string | null;
          readonly artifactType: ArtifactType;
          readonly created: string;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly creator?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
          readonly recipients?: {
            readonly __typename: "UserNodeConnection";
            readonly totalCount: number;
            readonly edges: ReadonlyArray<{
              readonly __typename: "UserNodeEdge";
              readonly node?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            } | null>;
          } | null;
          readonly recognitionCoreValue?: {
            readonly __typename: "RecognitionCoreValueNode";
            readonly id: number;
            readonly title: string;
            readonly description: string;
            readonly emoji?: string | null;
            readonly image?: string | null;
          } | null;
        }
      | null;
  } | null;
};

export type GoalArtifactComponentFragmentFragment = {
  readonly __typename: "GoalArtifactNode";
  readonly id: number;
  readonly artifactType: ArtifactType;
  readonly title?: string | null;
  readonly updated?: string | null;
  readonly state: GoalState;
  readonly created: string;
  readonly scope: GoalScope;
  readonly ownerCount?: number | null;
  readonly dueDate?: string | null;
  readonly goalVisibility: GoalVisibility;
  readonly status: GoalStatus;
  readonly progress: number;
  readonly progressType: GoalProgressType;
  readonly currentValue: number;
  readonly startValue: number;
  readonly targetValue: number;
  readonly isStale: boolean;
  readonly parentGoalId?: number | null;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
  readonly firstOwner?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
  readonly owners?: {
    readonly __typename: "UserNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "UserNodeEdge";
      readonly node?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      } | null;
    } | null>;
  } | null;
};

export type BasicGoalArtifactComponentFragmentFragment = {
  readonly __typename: "BasicGoalArtifactNode";
  readonly id: number;
  readonly artifactType: ArtifactType;
  readonly startValue: number;
  readonly currentValue: number;
  readonly targetValue: number;
  readonly progress: number;
  readonly progressType: GoalProgressType;
  readonly dueDate?: string | null;
  readonly startDate?: string | null;
  readonly state: GoalState;
  readonly status: GoalStatus;
  readonly scope: GoalScope;
  readonly goalVisibility: GoalVisibility;
  readonly created: string;
  readonly parentGoalId?: number | null;
  readonly ownerCount?: number | null;
  readonly contributorCount?: number | null;
  readonly isStale: boolean;
  readonly firstOwner?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly avatar?: string | null;
    readonly name: string;
  } | null;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canRead: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly goalArtifact?: {
    readonly __typename: "GoalArtifactNode";
    readonly id: number;
    readonly title?: string | null;
  } | null;
};

export type RecognitionArtifactComponentFragmentFragment = {
  readonly __typename: "RecognitionArtifactNode";
  readonly recognitionCoreValue?: {
    readonly __typename: "RecognitionCoreValueNode";
    readonly id: number;
    readonly title: string;
    readonly emoji?: string | null;
    readonly image?: string | null;
  } | null;
  readonly recipients?: {
    readonly __typename: "UserNodeConnection";
    readonly totalCount: number;
    readonly edges: ReadonlyArray<{
      readonly __typename: "UserNodeEdge";
      readonly node?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      } | null;
    } | null>;
  } | null;
};

type ArtifactComponentFragment_ActionItemArtifactNode_Fragment = {
  readonly __typename: "ActionItemArtifactNode";
  readonly isComplete?: boolean | null;
  readonly id: number;
  readonly artifactType: ArtifactType;
  readonly title?: string | null;
  readonly updated?: string | null;
  readonly created: string;
  readonly assignee?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
};

type ArtifactComponentFragment_AsanaTaskArtifactNode_Fragment = {
  readonly __typename: "AsanaTaskArtifactNode";
  readonly id: number;
  readonly artifactType: ArtifactType;
  readonly title?: string | null;
  readonly updated?: string | null;
  readonly created: string;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
};

type ArtifactComponentFragment_DecisionArtifactNode_Fragment = {
  readonly __typename: "DecisionArtifactNode";
  readonly decision: string;
  readonly decisionState?: DecisionState | null;
  readonly isDraft?: boolean | null;
  readonly id: number;
  readonly artifactType: ArtifactType;
  readonly title?: string | null;
  readonly updated?: string | null;
  readonly created: string;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
};

type ArtifactComponentFragment_DocumentArtifactNode_Fragment = {
  readonly __typename: "DocumentArtifactNode";
  readonly id: number;
  readonly artifactType: ArtifactType;
  readonly title?: string | null;
  readonly updated?: string | null;
  readonly created: string;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
};

type ArtifactComponentFragment_FeedbackArtifactNode_Fragment = {
  readonly __typename: "FeedbackArtifactNode";
  readonly id: number;
  readonly artifactType: ArtifactType;
  readonly title?: string | null;
  readonly updated?: string | null;
  readonly created: string;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
};

type ArtifactComponentFragment_GithubIssuesArtifactNode_Fragment = {
  readonly __typename: "GithubIssuesArtifactNode";
  readonly id: number;
  readonly artifactType: ArtifactType;
  readonly title?: string | null;
  readonly updated?: string | null;
  readonly created: string;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
};

type ArtifactComponentFragment_GoalArtifactNode_Fragment = {
  readonly __typename: "GoalArtifactNode";
  readonly id: number;
  readonly artifactType: ArtifactType;
  readonly title?: string | null;
  readonly updated?: string | null;
  readonly created: string;
  readonly state: GoalState;
  readonly scope: GoalScope;
  readonly ownerCount?: number | null;
  readonly dueDate?: string | null;
  readonly goalVisibility: GoalVisibility;
  readonly status: GoalStatus;
  readonly progress: number;
  readonly progressType: GoalProgressType;
  readonly currentValue: number;
  readonly startValue: number;
  readonly targetValue: number;
  readonly isStale: boolean;
  readonly parentGoalId?: number | null;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
  readonly firstOwner?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
  readonly owners?: {
    readonly __typename: "UserNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "UserNodeEdge";
      readonly node?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      } | null;
    } | null>;
  } | null;
};

type ArtifactComponentFragment_KpiArtifactNode_Fragment = {
  readonly __typename: "KPIArtifactNode";
  readonly id: number;
  readonly artifactType: ArtifactType;
  readonly title?: string | null;
  readonly updated?: string | null;
  readonly created: string;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
};

type ArtifactComponentFragment_RatingArtifactNode_Fragment = {
  readonly __typename: "RatingArtifactNode";
  readonly id: number;
  readonly artifactType: ArtifactType;
  readonly title?: string | null;
  readonly updated?: string | null;
  readonly created: string;
  readonly rating?: {
    readonly __typename: "RatingNode";
    readonly id: number;
    readonly title: string;
  } | null;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
};

type ArtifactComponentFragment_RecognitionArtifactNode_Fragment = {
  readonly __typename: "RecognitionArtifactNode";
  readonly id: number;
  readonly artifactType: ArtifactType;
  readonly title?: string | null;
  readonly updated?: string | null;
  readonly created: string;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
  readonly recognitionCoreValue?: {
    readonly __typename: "RecognitionCoreValueNode";
    readonly id: number;
    readonly title: string;
    readonly emoji?: string | null;
    readonly image?: string | null;
  } | null;
  readonly recipients?: {
    readonly __typename: "UserNodeConnection";
    readonly totalCount: number;
    readonly edges: ReadonlyArray<{
      readonly __typename: "UserNodeEdge";
      readonly node?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      } | null;
    } | null>;
  } | null;
};

export type ArtifactComponentFragmentFragment =
  | ArtifactComponentFragment_ActionItemArtifactNode_Fragment
  | ArtifactComponentFragment_AsanaTaskArtifactNode_Fragment
  | ArtifactComponentFragment_DecisionArtifactNode_Fragment
  | ArtifactComponentFragment_DocumentArtifactNode_Fragment
  | ArtifactComponentFragment_FeedbackArtifactNode_Fragment
  | ArtifactComponentFragment_GithubIssuesArtifactNode_Fragment
  | ArtifactComponentFragment_GoalArtifactNode_Fragment
  | ArtifactComponentFragment_KpiArtifactNode_Fragment
  | ArtifactComponentFragment_RatingArtifactNode_Fragment
  | ArtifactComponentFragment_RecognitionArtifactNode_Fragment;

export type DeleteArtifactMutationMutationVariables = Exact<{
  artifactId: Scalars["Int"]["input"];
}>;

export type DeleteArtifactMutationMutation = {
  readonly __typename: "Mutation";
  readonly deleteArtifact?: {
    readonly __typename: "DeleteArtifactMutation";
    readonly artifact?:
      | { readonly __typename: "ActionItemArtifactNode"; readonly id: number }
      | { readonly __typename: "AsanaTaskArtifactNode"; readonly id: number }
      | { readonly __typename: "DecisionArtifactNode"; readonly id: number }
      | { readonly __typename: "DocumentArtifactNode"; readonly id: number }
      | { readonly __typename: "FeedbackArtifactNode"; readonly id: number }
      | { readonly __typename: "GithubIssuesArtifactNode"; readonly id: number }
      | { readonly __typename: "GoalArtifactNode"; readonly id: number }
      | { readonly __typename: "KPIArtifactNode"; readonly id: number }
      | { readonly __typename: "RatingArtifactNode"; readonly id: number }
      | { readonly __typename: "RecognitionArtifactNode"; readonly id: number }
      | null;
  } | null;
};

export type GetAllOrganizationTeamsQueryQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
}>;

export type GetAllOrganizationTeamsQueryQuery = {
  readonly __typename: "Query";
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
    readonly teams?: {
      readonly __typename: "TeamNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "TeamNodeEdge";
        readonly node?: {
          readonly __typename: "TeamNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetArtifactComponentQueryQueryVariables = Exact<{
  artifactId: Scalars["Int"]["input"];
}>;

export type GetArtifactComponentQueryQuery = {
  readonly __typename: "Query";
  readonly artifact:
    | {
        readonly __typename: "ActionItemArtifactNode";
        readonly isComplete?: boolean | null;
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
        readonly updated?: string | null;
        readonly created: string;
        readonly assignee?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      }
    | {
        readonly __typename: "AsanaTaskArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
        readonly updated?: string | null;
        readonly created: string;
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      }
    | {
        readonly __typename: "DecisionArtifactNode";
        readonly decision: string;
        readonly decisionState?: DecisionState | null;
        readonly isDraft?: boolean | null;
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
        readonly updated?: string | null;
        readonly created: string;
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      }
    | {
        readonly __typename: "DocumentArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
        readonly updated?: string | null;
        readonly created: string;
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      }
    | {
        readonly __typename: "FeedbackArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
        readonly updated?: string | null;
        readonly created: string;
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      }
    | {
        readonly __typename: "GithubIssuesArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
        readonly updated?: string | null;
        readonly created: string;
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      }
    | {
        readonly __typename: "GoalArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
        readonly updated?: string | null;
        readonly created: string;
        readonly state: GoalState;
        readonly scope: GoalScope;
        readonly ownerCount?: number | null;
        readonly dueDate?: string | null;
        readonly goalVisibility: GoalVisibility;
        readonly status: GoalStatus;
        readonly progress: number;
        readonly progressType: GoalProgressType;
        readonly currentValue: number;
        readonly startValue: number;
        readonly targetValue: number;
        readonly isStale: boolean;
        readonly parentGoalId?: number | null;
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly firstOwner?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly owners?: {
          readonly __typename: "UserNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "UserNodeEdge";
            readonly node?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          } | null>;
        } | null;
      }
    | {
        readonly __typename: "KPIArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
        readonly updated?: string | null;
        readonly created: string;
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      }
    | {
        readonly __typename: "RatingArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
        readonly updated?: string | null;
        readonly created: string;
        readonly rating?: {
          readonly __typename: "RatingNode";
          readonly id: number;
          readonly title: string;
        } | null;
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      }
    | {
        readonly __typename: "RecognitionArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
        readonly updated?: string | null;
        readonly created: string;
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly recognitionCoreValue?: {
          readonly __typename: "RecognitionCoreValueNode";
          readonly id: number;
          readonly title: string;
          readonly emoji?: string | null;
          readonly image?: string | null;
        } | null;
        readonly recipients?: {
          readonly __typename: "UserNodeConnection";
          readonly totalCount: number;
          readonly edges: ReadonlyArray<{
            readonly __typename: "UserNodeEdge";
            readonly node?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          } | null>;
        } | null;
      };
};

export type GetGoalParticipantsQueryQueryVariables = Exact<{
  artifactId: Scalars["Int"]["input"];
}>;

export type GetGoalParticipantsQueryQuery = {
  readonly __typename: "Query";
  readonly basicGoal: {
    readonly __typename: "BasicGoalArtifactNode";
    readonly id: number;
    readonly canRead: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    };
    readonly canUpdate: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    };
    readonly goalArtifact?: {
      readonly __typename: "GoalArtifactNode";
      readonly id: number;
      readonly title?: string | null;
      readonly keyResults: {
        readonly __typename: "KeyResultNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "KeyResultNodeEdge";
          readonly node?: {
            readonly __typename: "KeyResultNode";
            readonly id: number;
            readonly title: string;
            readonly assignee?: {
              readonly __typename: "UserNode";
              readonly id: number;
            } | null;
          } | null;
        } | null>;
      };
    } | null;
    readonly owners?: {
      readonly __typename: "UserNodeConnection";
      readonly totalCount: number;
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly avatar?: string | null;
          readonly name: string;
        } | null;
      } | null>;
    } | null;
    readonly contributors?: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly avatar?: string | null;
          readonly name: string;
        } | null;
      } | null>;
    } | null;
  };
};

export type UpdateArtifactMutationVariables = Exact<{
  artifactId: Scalars["Int"]["input"];
  additionalFields: AdditionalArtifactInput;
}>;

export type UpdateArtifactMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateArtifact?: {
    readonly __typename: "CreateOrUpdateArtifactMutation";
    readonly artifact?:
      | {
          readonly __typename: "ActionItemArtifactNode";
          readonly isComplete?: boolean | null;
          readonly actionItemState?: number | null;
          readonly completedAt?: string | null;
          readonly dueDate?: string | null;
          readonly id: number;
          readonly title?: string | null;
          readonly artifactType: ArtifactType;
          readonly assignee?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly avatar?: string | null;
            readonly name: string;
          } | null;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
        }
      | {
          readonly __typename: "AsanaTaskArtifactNode";
          readonly id: number;
          readonly title?: string | null;
          readonly artifactType: ArtifactType;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
        }
      | {
          readonly __typename: "DecisionArtifactNode";
          readonly isDraft?: boolean | null;
          readonly decisionState?: DecisionState | null;
          readonly id: number;
          readonly title?: string | null;
          readonly artifactType: ArtifactType;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
        }
      | {
          readonly __typename: "DocumentArtifactNode";
          readonly id: number;
          readonly title?: string | null;
          readonly artifactType: ArtifactType;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
        }
      | {
          readonly __typename: "FeedbackArtifactNode";
          readonly id: number;
          readonly title?: string | null;
          readonly artifactType: ArtifactType;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
        }
      | {
          readonly __typename: "GithubIssuesArtifactNode";
          readonly id: number;
          readonly title?: string | null;
          readonly artifactType: ArtifactType;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
        }
      | {
          readonly __typename: "GoalArtifactNode";
          readonly id: number;
          readonly title?: string | null;
          readonly artifactType: ArtifactType;
          readonly startValue: number;
          readonly currentValue: number;
          readonly targetValue: number;
          readonly progress: number;
          readonly progressType: GoalProgressType;
          readonly dueDate?: string | null;
          readonly startDate?: string | null;
          readonly state: GoalState;
          readonly status: GoalStatus;
          readonly scope: GoalScope;
          readonly goalVisibility: GoalVisibility;
          readonly created: string;
          readonly parentGoalId?: number | null;
          readonly ownerCount?: number | null;
          readonly contributorCount?: number | null;
          readonly isStale: boolean;
          readonly updated?: string | null;
          readonly kpi?: {
            readonly __typename: "KPINode";
            readonly id: number;
            readonly title: string;
            readonly currentMeasurement?: {
              readonly __typename: "KPIMeasurementNode";
              readonly id: number;
              readonly measurement: number;
            } | null;
          } | null;
          readonly contributors?: {
            readonly __typename: "UserNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "UserNodeEdge";
              readonly node?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            } | null>;
          } | null;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly firstOwner?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly avatar?: string | null;
            readonly name: string;
          } | null;
          readonly canUpdate: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canRead: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly creator?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
        }
      | {
          readonly __typename: "KPIArtifactNode";
          readonly id: number;
          readonly title?: string | null;
          readonly artifactType: ArtifactType;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
        }
      | {
          readonly __typename: "RatingArtifactNode";
          readonly id: number;
          readonly title?: string | null;
          readonly artifactType: ArtifactType;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
        }
      | {
          readonly __typename: "RecognitionArtifactNode";
          readonly id: number;
          readonly title?: string | null;
          readonly artifactType: ArtifactType;
          readonly created: string;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly creator?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
          readonly recipients?: {
            readonly __typename: "UserNodeConnection";
            readonly totalCount: number;
            readonly edges: ReadonlyArray<{
              readonly __typename: "UserNodeEdge";
              readonly node?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            } | null>;
          } | null;
          readonly recognitionCoreValue?: {
            readonly __typename: "RecognitionCoreValueNode";
            readonly id: number;
            readonly title: string;
            readonly description: string;
            readonly emoji?: string | null;
            readonly image?: string | null;
          } | null;
        }
      | null;
  } | null;
};

export type UpdateGoalParticipantsMutationMutationVariables = Exact<{
  artifactId: Scalars["Int"]["input"];
  additionalFields: AdditionalArtifactInput;
}>;

export type UpdateGoalParticipantsMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateArtifact?: {
    readonly __typename: "CreateOrUpdateArtifactMutation";
    readonly artifact?:
      | { readonly __typename: "ActionItemArtifactNode" }
      | { readonly __typename: "AsanaTaskArtifactNode" }
      | { readonly __typename: "DecisionArtifactNode" }
      | { readonly __typename: "DocumentArtifactNode" }
      | { readonly __typename: "FeedbackArtifactNode" }
      | { readonly __typename: "GithubIssuesArtifactNode" }
      | {
          readonly __typename: "GoalArtifactNode";
          readonly id: number;
          readonly ownerCount?: number | null;
          readonly contributorCount?: number | null;
          readonly canRead: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly keyResults: {
            readonly __typename: "KeyResultNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "KeyResultNodeEdge";
              readonly node?: {
                readonly __typename: "KeyResultNode";
                readonly id: number;
                readonly assignee?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                } | null;
              } | null;
            } | null>;
          };
          readonly firstOwner?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly avatar?: string | null;
            readonly name: string;
          } | null;
          readonly owners?: {
            readonly __typename: "UserNodeConnection";
            readonly totalCount: number;
            readonly edges: ReadonlyArray<{
              readonly __typename: "UserNodeEdge";
              readonly node?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            } | null>;
          } | null;
          readonly contributors?: {
            readonly __typename: "UserNodeConnection";
            readonly totalCount: number;
            readonly edges: ReadonlyArray<{
              readonly __typename: "UserNodeEdge";
              readonly node?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            } | null>;
          } | null;
        }
      | { readonly __typename: "KPIArtifactNode" }
      | { readonly __typename: "RatingArtifactNode" }
      | { readonly __typename: "RecognitionArtifactNode" }
      | null;
  } | null;
};

export type UpdateGoalTeamsMutationMutationVariables = Exact<{
  artifactId: Scalars["Int"]["input"];
  additionalFields: AdditionalArtifactInput;
}>;

export type UpdateGoalTeamsMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateArtifact?: {
    readonly __typename: "CreateOrUpdateArtifactMutation";
    readonly artifact?:
      | { readonly __typename: "ActionItemArtifactNode"; readonly id: number }
      | { readonly __typename: "AsanaTaskArtifactNode"; readonly id: number }
      | { readonly __typename: "DecisionArtifactNode"; readonly id: number }
      | { readonly __typename: "DocumentArtifactNode"; readonly id: number }
      | { readonly __typename: "FeedbackArtifactNode"; readonly id: number }
      | { readonly __typename: "GithubIssuesArtifactNode"; readonly id: number }
      | {
          readonly __typename: "GoalArtifactNode";
          readonly id: number;
          readonly artifactType: ArtifactType;
          readonly startValue: number;
          readonly currentValue: number;
          readonly targetValue: number;
          readonly progress: number;
          readonly progressType: GoalProgressType;
          readonly dueDate?: string | null;
          readonly startDate?: string | null;
          readonly state: GoalState;
          readonly status: GoalStatus;
          readonly scope: GoalScope;
          readonly goalVisibility: GoalVisibility;
          readonly created: string;
          readonly parentGoalId?: number | null;
          readonly ownerCount?: number | null;
          readonly contributorCount?: number | null;
          readonly isStale: boolean;
          readonly title?: string | null;
          readonly updated?: string | null;
          readonly firstOwner?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly avatar?: string | null;
            readonly name: string;
          } | null;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canUpdate: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canRead: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly creator?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
          readonly teams?: {
            readonly __typename: "TeamNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "TeamNodeEdge";
              readonly node?: {
                readonly __typename: "TeamNode";
                readonly id: number;
                readonly title: string;
              } | null;
            } | null>;
          } | null;
        }
      | { readonly __typename: "KPIArtifactNode"; readonly id: number }
      | { readonly __typename: "RatingArtifactNode"; readonly id: number }
      | { readonly __typename: "RecognitionArtifactNode"; readonly id: number }
      | null;
  } | null;
};

export type UpdateGoalVisibilityMutationMutationVariables = Exact<{
  artifactId: Scalars["Int"]["input"];
  additionalFields: AdditionalArtifactInput;
}>;

export type UpdateGoalVisibilityMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateArtifact?: {
    readonly __typename: "CreateOrUpdateArtifactMutation";
    readonly artifact?:
      | { readonly __typename: "ActionItemArtifactNode" }
      | { readonly __typename: "AsanaTaskArtifactNode" }
      | { readonly __typename: "DecisionArtifactNode" }
      | { readonly __typename: "DocumentArtifactNode" }
      | { readonly __typename: "FeedbackArtifactNode" }
      | { readonly __typename: "GithubIssuesArtifactNode" }
      | {
          readonly __typename: "GoalArtifactNode";
          readonly id: number;
          readonly goalVisibility: GoalVisibility;
          readonly canRead: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
        }
      | { readonly __typename: "KPIArtifactNode" }
      | { readonly __typename: "RatingArtifactNode" }
      | { readonly __typename: "RecognitionArtifactNode" }
      | null;
  } | null;
};

export type CancelAskAiMessageMutationMutationVariables = Exact<{
  chatSessionId: Scalars["Int"]["input"];
}>;

export type CancelAskAiMessageMutationMutation = {
  readonly __typename: "Mutation";
  readonly cancelChatbotSession?: {
    readonly __typename: "CancelChatbotSessionMutation";
    readonly chatSession?: {
      readonly __typename: "ChatSessionNode";
      readonly id: number;
    } | null;
  } | null;
};

export type CreateAskAiMessageMutationMutationVariables = Exact<{
  chatSessionId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  assessmentId?: InputMaybe<Scalars["Int"]["input"]>;
  assessmentQuestionId?: InputMaybe<Scalars["Int"]["input"]>;
  message: Scalars["String"]["input"];
  imageUrls?: InputMaybe<
    ReadonlyArray<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  messageId?: InputMaybe<Scalars["String"]["input"]>;
  systemContextMessage?: InputMaybe<Scalars["String"]["input"]>;
  isIncognito?: InputMaybe<Scalars["Boolean"]["input"]>;
  skillId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type CreateAskAiMessageMutationMutation = {
  readonly __typename: "Mutation";
  readonly sendMessageToChatbot?: {
    readonly __typename: "SendMessageToChatbotMutation";
    readonly chatSession?: {
      readonly __typename: "ChatSessionNode";
      readonly id: number;
      readonly updated?: string | null;
      readonly isIncognito: boolean;
      readonly title?: string | null;
      readonly assessment?: {
        readonly __typename: "AssessmentNode";
        readonly id: number;
        readonly target?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
        } | null;
      } | null;
      readonly assessmentQuestion?:
        | {
            readonly __typename: "CompetencyAssessmentQuestionNode";
            readonly id: number;
            readonly title: string;
          }
        | {
            readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
            readonly id: number;
            readonly title: string;
          }
        | {
            readonly __typename: "IndividualGoalAssessmentQuestionNode";
            readonly id: number;
            readonly title: string;
          }
        | {
            readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
            readonly id: number;
            readonly title: string;
          }
        | {
            readonly __typename: "MultiChoiceAssessmentQuestionNode";
            readonly id: number;
            readonly title: string;
          }
        | {
            readonly __typename: "NpsAssessmentQuestionNode";
            readonly id: number;
            readonly title: string;
          }
        | {
            readonly __typename: "OverallGoalAssessmentQuestionNode";
            readonly id: number;
            readonly title: string;
          }
        | {
            readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
            readonly id: number;
            readonly title: string;
          }
        | {
            readonly __typename: "RangeAssessmentQuestionNode";
            readonly id: number;
            readonly title: string;
          }
        | {
            readonly __typename: "ResponsibilityAssessmentQuestionNode";
            readonly id: number;
            readonly title: string;
          }
        | {
            readonly __typename: "TalentIndicatorAssessmentQuestionNode";
            readonly id: number;
            readonly title: string;
          }
        | {
            readonly __typename: "TextAssessmentQuestionNode";
            readonly id: number;
            readonly title: string;
          }
        | null;
      readonly meeting?: {
        readonly __typename: "MeetingNode";
        readonly id: number;
        readonly title?: string | null;
      } | null;
      readonly reactions: {
        readonly __typename: "ChatSessionMessageReactionConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "ChatSessionMessageReactionEdge";
          readonly node?: {
            readonly __typename: "ChatSessionMessageReactionNode";
            readonly id: number;
            readonly reactionType: ChatSessionReactionType;
            readonly messageId: string;
            readonly comment?: string | null;
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly firstName: string;
              readonly lastName: string;
            } | null;
          } | null;
        } | null>;
      };
      readonly messages: {
        readonly __typename: "ChatMessageConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "ChatMessageEdge";
          readonly node?: {
            readonly __typename: "ChatMessageNode";
            readonly id: string;
            readonly content: string;
            readonly imageUrls: ReadonlyArray<string>;
            readonly role: ChatbotRoleEnum;
            readonly autogenerated?: boolean | null;
            readonly error?: boolean | null;
            readonly isStreaming?: boolean | null;
            readonly toolCalls?: ReadonlyArray<{
              readonly __typename: "ChatToolCallNode";
              readonly toolName: string;
              readonly resultCount?: number | null;
              readonly arguments?: string | null;
              readonly output?: string | null;
            } | null> | null;
            readonly createdArtifact?:
              | {
                  readonly __typename: "ActionItemArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "AsanaTaskArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "DecisionArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "DocumentArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "FeedbackArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "GithubIssuesArtifactNode";
                  readonly id: number;
                }
              | { readonly __typename: "GoalArtifactNode"; readonly id: number }
              | { readonly __typename: "KPIArtifactNode"; readonly id: number }
              | {
                  readonly __typename: "RatingArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "RecognitionArtifactNode";
                  readonly id: number;
                }
              | null;
          } | null;
        } | null>;
      };
    } | null;
  } | null;
};

export type CreateChatMessageReactionMutationVariables = Exact<{
  messageId: Scalars["String"]["input"];
  reactionType: ChatSessionReactionType;
  chatSessionId: Scalars["Int"]["input"];
  comment?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type CreateChatMessageReactionMutation = {
  readonly __typename: "Mutation";
  readonly createChatbotMessageReaction?: {
    readonly __typename: "CreateChatbotMessageReactionMutation";
    readonly chatSession?: {
      readonly __typename: "ChatSessionNode";
      readonly id: number;
      readonly updated?: string | null;
      readonly reactions: {
        readonly __typename: "ChatSessionMessageReactionConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "ChatSessionMessageReactionEdge";
          readonly node?: {
            readonly __typename: "ChatSessionMessageReactionNode";
            readonly id: number;
          } | null;
        } | null>;
      };
    } | null;
    readonly reaction?: {
      readonly __typename: "ChatSessionMessageReactionNode";
      readonly id: number;
      readonly reactionType: ChatSessionReactionType;
      readonly messageId: string;
      readonly comment?: string | null;
      readonly creator?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly firstName: string;
        readonly lastName: string;
      } | null;
    } | null;
  } | null;
};

export type DeleteAskAiChatSessionMutationMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
}>;

export type DeleteAskAiChatSessionMutationMutation = {
  readonly __typename: "Mutation";
  readonly deleteChatSession?: {
    readonly __typename: "DeleteChatSessionMutation";
    readonly id?: number | null;
    readonly ok?: boolean | null;
  } | null;
};

export type EditSuggestedAssessmentResponseMutationMutationVariables = Exact<{
  suggestionId: Scalars["String"]["input"];
  chatSessionId: Scalars["Int"]["input"];
  messageId: Scalars["String"]["input"];
}>;

export type EditSuggestedAssessmentResponseMutationMutation = {
  readonly __typename: "Mutation";
  readonly editSuggestedAssessmentResponse?: {
    readonly __typename: "EditSuggestedAssessmentResponseMutation";
    readonly chatSession?: {
      readonly __typename: "ChatSessionNode";
      readonly id: number;
      readonly messages: {
        readonly __typename: "ChatMessageConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "ChatMessageEdge";
          readonly node?: {
            readonly __typename: "ChatMessageNode";
            readonly id: string;
            readonly content: string;
            readonly imageUrls: ReadonlyArray<string>;
            readonly role: ChatbotRoleEnum;
            readonly autogenerated?: boolean | null;
            readonly error?: boolean | null;
            readonly isStreaming?: boolean | null;
            readonly toolCalls?: ReadonlyArray<{
              readonly __typename: "ChatToolCallNode";
              readonly toolName: string;
              readonly resultCount?: number | null;
              readonly arguments?: string | null;
              readonly output?: string | null;
            } | null> | null;
            readonly createdArtifact?:
              | {
                  readonly __typename: "ActionItemArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "AsanaTaskArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "DecisionArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "DocumentArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "FeedbackArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "GithubIssuesArtifactNode";
                  readonly id: number;
                }
              | { readonly __typename: "GoalArtifactNode"; readonly id: number }
              | { readonly __typename: "KPIArtifactNode"; readonly id: number }
              | {
                  readonly __typename: "RatingArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "RecognitionArtifactNode";
                  readonly id: number;
                }
              | null;
          } | null;
        } | null>;
      };
    } | null;
  } | null;
};

export type GetAskAiChatSessionHistoryQueryQueryVariables = Exact<{
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetAskAiChatSessionHistoryQueryQuery = {
  readonly __typename: "Query";
  readonly chatSessions?: {
    readonly __typename: "ChatSessionNodeConnection";
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly hasNextPage: boolean;
      readonly endCursor?: string | null;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "ChatSessionNodeEdge";
      readonly node?: {
        readonly __typename: "ChatSessionNode";
        readonly id: number;
        readonly created: string;
        readonly updated?: string | null;
        readonly title?: string | null;
        readonly pinnedAt?: string | null;
        readonly assessment?: {
          readonly __typename: "AssessmentNode";
          readonly id: number;
          readonly target?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
          } | null;
        } | null;
        readonly assessmentQuestion?:
          | {
              readonly __typename: "CompetencyAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "IndividualGoalAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "MultiChoiceAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "NpsAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "OverallGoalAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "RangeAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "ResponsibilityAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "TextAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | null;
        readonly meeting?: {
          readonly __typename: "MeetingNode";
          readonly id: number;
          readonly title?: string | null;
        } | null;
        readonly messages: {
          readonly __typename: "ChatMessageConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "ChatMessageEdge";
            readonly node?: {
              readonly __typename: "ChatMessageNode";
              readonly id: string;
              readonly content: string;
              readonly imageUrls: ReadonlyArray<string>;
              readonly role: ChatbotRoleEnum;
            } | null;
          } | null>;
        };
      } | null;
    } | null>;
  } | null;
};

export type GetAskAiCitationSourcesQueryQueryVariables = Exact<{
  chatSessionId: Scalars["Int"]["input"];
  sourceIds:
    | ReadonlyArray<Scalars["String"]["input"]>
    | Scalars["String"]["input"];
}>;

export type GetAskAiCitationSourcesQueryQuery = {
  readonly __typename: "Query";
  readonly askAiCitationSources: ReadonlyArray<{
    readonly __typename: "AnswerCitationNode";
    readonly url: string;
    readonly title: string;
    readonly sourceId: string;
    readonly sourceProvider: string;
    readonly sourceType: string;
    readonly contextText?: string | null;
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
      readonly meetingGroupId: number;
      readonly title?: string | null;
      readonly startDatetime?: string | null;
    } | null;
    readonly assessment?: {
      readonly __typename: "AssessmentNode";
      readonly id: number;
      readonly submittedDatetime?: string | null;
      readonly responder?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      } | null;
      readonly template: {
        readonly __typename: "AssessmentTemplateNode";
        readonly assessmentType: AssessmentType;
      };
      readonly target?: {
        readonly __typename: "UserNode";
        readonly id: number;
      } | null;
    } | null;
  }>;
};

export type AskAiMeetingEmbedFragmentFragment = {
  readonly __typename: "MeetingNode";
  readonly id: number;
  readonly title?: string | null;
  readonly startDatetime?: string | null;
  readonly endDatetime?: string | null;
  readonly meetingGroupId: number;
  readonly meetingGroup?: {
    readonly __typename: "MeetingGroupNode";
    readonly id: number;
    readonly isFormalOneonone: boolean;
  } | null;
  readonly topics?: {
    readonly __typename: "TopicNodeConnection";
    readonly totalCount: number;
    readonly edges: ReadonlyArray<{
      readonly __typename: "TopicNodeEdge";
      readonly node?: {
        readonly __typename: "TopicNode";
        readonly id: number;
        readonly title: string;
        readonly discussionNotes?: any | null;
      } | null;
    } | null>;
  } | null;
  readonly participants?: {
    readonly __typename: "MeetingParticipantConnection";
    readonly totalCount: number;
    readonly edges: ReadonlyArray<{
      readonly __typename: "MeetingParticipantEdge";
      readonly node?: {
        readonly __typename: "MeetingParticipantNode";
        readonly id?: string | null;
        readonly user?: {
          readonly __typename: "BasicUserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type GetAskAiMeetingEmbedQueryQueryVariables = Exact<{
  meetingId: Scalars["Int"]["input"];
}>;

export type GetAskAiMeetingEmbedQueryQuery = {
  readonly __typename: "Query";
  readonly meeting?: {
    readonly __typename: "MeetingNode";
    readonly id: number;
    readonly title?: string | null;
    readonly startDatetime?: string | null;
    readonly endDatetime?: string | null;
    readonly meetingGroupId: number;
    readonly meetingGroup?: {
      readonly __typename: "MeetingGroupNode";
      readonly id: number;
      readonly isFormalOneonone: boolean;
    } | null;
    readonly topics?: {
      readonly __typename: "TopicNodeConnection";
      readonly totalCount: number;
      readonly edges: ReadonlyArray<{
        readonly __typename: "TopicNodeEdge";
        readonly node?: {
          readonly __typename: "TopicNode";
          readonly id: number;
          readonly title: string;
          readonly discussionNotes?: any | null;
        } | null;
      } | null>;
    } | null;
    readonly participants?: {
      readonly __typename: "MeetingParticipantConnection";
      readonly totalCount: number;
      readonly edges: ReadonlyArray<{
        readonly __typename: "MeetingParticipantEdge";
        readonly node?: {
          readonly __typename: "MeetingParticipantNode";
          readonly id?: string | null;
          readonly user?: {
            readonly __typename: "BasicUserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type ChatSessionMessageReactionFragmentFragment = {
  readonly __typename: "ChatSessionMessageReactionNode";
  readonly id: number;
  readonly reactionType: ChatSessionReactionType;
  readonly messageId: string;
  readonly comment?: string | null;
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly firstName: string;
    readonly lastName: string;
  } | null;
};

export type CitationFragmentFragment = {
  readonly __typename: "AnswerCitationNode";
  readonly url: string;
  readonly title: string;
  readonly sourceId: string;
  readonly sourceProvider: string;
  readonly sourceType: string;
  readonly contextText?: string | null;
  readonly meeting?: {
    readonly __typename: "MeetingNode";
    readonly id: number;
    readonly meetingGroupId: number;
    readonly title?: string | null;
    readonly startDatetime?: string | null;
  } | null;
  readonly assessment?: {
    readonly __typename: "AssessmentNode";
    readonly id: number;
    readonly submittedDatetime?: string | null;
    readonly responder?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly avatar?: string | null;
    } | null;
    readonly template: {
      readonly __typename: "AssessmentTemplateNode";
      readonly assessmentType: AssessmentType;
    };
    readonly target?: {
      readonly __typename: "UserNode";
      readonly id: number;
    } | null;
  } | null;
};

export type AskAiChatMessageFragmentFragment = {
  readonly __typename: "ChatMessageNode";
  readonly id: string;
  readonly content: string;
  readonly imageUrls: ReadonlyArray<string>;
  readonly role: ChatbotRoleEnum;
  readonly autogenerated?: boolean | null;
  readonly error?: boolean | null;
  readonly isStreaming?: boolean | null;
  readonly toolCalls?: ReadonlyArray<{
    readonly __typename: "ChatToolCallNode";
    readonly toolName: string;
    readonly resultCount?: number | null;
    readonly arguments?: string | null;
    readonly output?: string | null;
  } | null> | null;
  readonly createdArtifact?:
    | { readonly __typename: "ActionItemArtifactNode"; readonly id: number }
    | { readonly __typename: "AsanaTaskArtifactNode"; readonly id: number }
    | { readonly __typename: "DecisionArtifactNode"; readonly id: number }
    | { readonly __typename: "DocumentArtifactNode"; readonly id: number }
    | { readonly __typename: "FeedbackArtifactNode"; readonly id: number }
    | { readonly __typename: "GithubIssuesArtifactNode"; readonly id: number }
    | { readonly __typename: "GoalArtifactNode"; readonly id: number }
    | { readonly __typename: "KPIArtifactNode"; readonly id: number }
    | { readonly __typename: "RatingArtifactNode"; readonly id: number }
    | { readonly __typename: "RecognitionArtifactNode"; readonly id: number }
    | null;
};

export type GetAskAiChatSessionQueryQueryVariables = Exact<{
  chatSessionId: Scalars["Int"]["input"];
}>;

export type GetAskAiChatSessionQueryQuery = {
  readonly __typename: "Query";
  readonly chatSession?: {
    readonly __typename: "ChatSessionNode";
    readonly id: number;
    readonly updated?: string | null;
    readonly isIncognito: boolean;
    readonly title?: string | null;
    readonly assessment?: {
      readonly __typename: "AssessmentNode";
      readonly id: number;
      readonly target?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
      } | null;
    } | null;
    readonly assessmentQuestion?:
      | {
          readonly __typename: "CompetencyAssessmentQuestionNode";
          readonly id: number;
          readonly title: string;
        }
      | {
          readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
          readonly id: number;
          readonly title: string;
        }
      | {
          readonly __typename: "IndividualGoalAssessmentQuestionNode";
          readonly id: number;
          readonly title: string;
        }
      | {
          readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
          readonly id: number;
          readonly title: string;
        }
      | {
          readonly __typename: "MultiChoiceAssessmentQuestionNode";
          readonly id: number;
          readonly title: string;
        }
      | {
          readonly __typename: "NpsAssessmentQuestionNode";
          readonly id: number;
          readonly title: string;
        }
      | {
          readonly __typename: "OverallGoalAssessmentQuestionNode";
          readonly id: number;
          readonly title: string;
        }
      | {
          readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
          readonly id: number;
          readonly title: string;
        }
      | {
          readonly __typename: "RangeAssessmentQuestionNode";
          readonly id: number;
          readonly title: string;
        }
      | {
          readonly __typename: "ResponsibilityAssessmentQuestionNode";
          readonly id: number;
          readonly title: string;
        }
      | {
          readonly __typename: "TalentIndicatorAssessmentQuestionNode";
          readonly id: number;
          readonly title: string;
        }
      | {
          readonly __typename: "TextAssessmentQuestionNode";
          readonly id: number;
          readonly title: string;
        }
      | null;
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
      readonly title?: string | null;
    } | null;
    readonly reactions: {
      readonly __typename: "ChatSessionMessageReactionConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "ChatSessionMessageReactionEdge";
        readonly node?: {
          readonly __typename: "ChatSessionMessageReactionNode";
          readonly id: number;
          readonly reactionType: ChatSessionReactionType;
          readonly messageId: string;
          readonly comment?: string | null;
          readonly creator?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly firstName: string;
            readonly lastName: string;
          } | null;
        } | null;
      } | null>;
    };
    readonly messages: {
      readonly __typename: "ChatMessageConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "ChatMessageEdge";
        readonly node?: {
          readonly __typename: "ChatMessageNode";
          readonly id: string;
          readonly content: string;
          readonly imageUrls: ReadonlyArray<string>;
          readonly role: ChatbotRoleEnum;
          readonly autogenerated?: boolean | null;
          readonly error?: boolean | null;
          readonly isStreaming?: boolean | null;
          readonly toolCalls?: ReadonlyArray<{
            readonly __typename: "ChatToolCallNode";
            readonly toolName: string;
            readonly resultCount?: number | null;
            readonly arguments?: string | null;
            readonly output?: string | null;
          } | null> | null;
          readonly createdArtifact?:
            | {
                readonly __typename: "ActionItemArtifactNode";
                readonly id: number;
              }
            | {
                readonly __typename: "AsanaTaskArtifactNode";
                readonly id: number;
              }
            | {
                readonly __typename: "DecisionArtifactNode";
                readonly id: number;
              }
            | {
                readonly __typename: "DocumentArtifactNode";
                readonly id: number;
              }
            | {
                readonly __typename: "FeedbackArtifactNode";
                readonly id: number;
              }
            | {
                readonly __typename: "GithubIssuesArtifactNode";
                readonly id: number;
              }
            | { readonly __typename: "GoalArtifactNode"; readonly id: number }
            | { readonly __typename: "KPIArtifactNode"; readonly id: number }
            | { readonly __typename: "RatingArtifactNode"; readonly id: number }
            | {
                readonly __typename: "RecognitionArtifactNode";
                readonly id: number;
              }
            | null;
        } | null;
      } | null>;
    };
  } | null;
};

export type GetOrCreateChatSessionMutationVariables = Exact<{
  assessmentId?: InputMaybe<Scalars["Int"]["input"]>;
  assessmentQuestionId?: InputMaybe<Scalars["Int"]["input"]>;
  seedWithSuggestedAssessmentAnswer?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type GetOrCreateChatSessionMutation = {
  readonly __typename: "Mutation";
  readonly getOrCreateChatbotSession?: {
    readonly __typename: "GetOrCreateChatbotSession";
    readonly chatSession?: {
      readonly __typename: "ChatSessionNode";
      readonly id: number;
      readonly title?: string | null;
      readonly updated?: string | null;
      readonly isIncognito: boolean;
      readonly assessment?: {
        readonly __typename: "AssessmentNode";
        readonly id: number;
      } | null;
      readonly assessmentQuestion?:
        | {
            readonly __typename: "CompetencyAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "IndividualGoalAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "MultiChoiceAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "NpsAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "OverallGoalAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "RangeAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "ResponsibilityAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "TalentIndicatorAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "TextAssessmentQuestionNode";
            readonly id: number;
          }
        | null;
      readonly reactions: {
        readonly __typename: "ChatSessionMessageReactionConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "ChatSessionMessageReactionEdge";
          readonly node?: {
            readonly __typename: "ChatSessionMessageReactionNode";
            readonly id: number;
            readonly reactionType: ChatSessionReactionType;
            readonly messageId: string;
            readonly comment?: string | null;
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly firstName: string;
              readonly lastName: string;
            } | null;
          } | null;
        } | null>;
      };
      readonly messages: {
        readonly __typename: "ChatMessageConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "ChatMessageEdge";
          readonly node?: {
            readonly __typename: "ChatMessageNode";
            readonly id: string;
            readonly content: string;
            readonly imageUrls: ReadonlyArray<string>;
            readonly role: ChatbotRoleEnum;
            readonly autogenerated?: boolean | null;
            readonly error?: boolean | null;
            readonly isStreaming?: boolean | null;
            readonly toolCalls?: ReadonlyArray<{
              readonly __typename: "ChatToolCallNode";
              readonly toolName: string;
              readonly resultCount?: number | null;
              readonly arguments?: string | null;
              readonly output?: string | null;
            } | null> | null;
            readonly createdArtifact?:
              | {
                  readonly __typename: "ActionItemArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "AsanaTaskArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "DecisionArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "DocumentArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "FeedbackArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "GithubIssuesArtifactNode";
                  readonly id: number;
                }
              | { readonly __typename: "GoalArtifactNode"; readonly id: number }
              | { readonly __typename: "KPIArtifactNode"; readonly id: number }
              | {
                  readonly __typename: "RatingArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "RecognitionArtifactNode";
                  readonly id: number;
                }
              | null;
          } | null;
        } | null>;
      };
    } | null;
  } | null;
};

export type LinkArtifactToChatMessageMutationMutationVariables = Exact<{
  chatSessionId: Scalars["Int"]["input"];
  messageId: Scalars["String"]["input"];
  artifactId: Scalars["Int"]["input"];
}>;

export type LinkArtifactToChatMessageMutationMutation = {
  readonly __typename: "Mutation";
  readonly linkCreatedArtifactToChatMessage?: {
    readonly __typename: "LinkCreatedArtifactToChatMessageMutation";
    readonly chatSession?: {
      readonly __typename: "ChatSessionNode";
      readonly id: number;
      readonly updated?: string | null;
      readonly messages: {
        readonly __typename: "ChatMessageConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "ChatMessageEdge";
          readonly node?: {
            readonly __typename: "ChatMessageNode";
            readonly id: string;
            readonly content: string;
            readonly imageUrls: ReadonlyArray<string>;
            readonly role: ChatbotRoleEnum;
            readonly autogenerated?: boolean | null;
            readonly error?: boolean | null;
            readonly isStreaming?: boolean | null;
            readonly toolCalls?: ReadonlyArray<{
              readonly __typename: "ChatToolCallNode";
              readonly toolName: string;
              readonly resultCount?: number | null;
              readonly arguments?: string | null;
              readonly output?: string | null;
            } | null> | null;
            readonly createdArtifact?:
              | {
                  readonly __typename: "ActionItemArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "AsanaTaskArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "DecisionArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "DocumentArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "FeedbackArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "GithubIssuesArtifactNode";
                  readonly id: number;
                }
              | { readonly __typename: "GoalArtifactNode"; readonly id: number }
              | { readonly __typename: "KPIArtifactNode"; readonly id: number }
              | {
                  readonly __typename: "RatingArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "RecognitionArtifactNode";
                  readonly id: number;
                }
              | null;
          } | null;
        } | null>;
      };
    } | null;
  } | null;
};

export type RetryAskAiMessageMutationMutationVariables = Exact<{
  chatSessionId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type RetryAskAiMessageMutationMutation = {
  readonly __typename: "Mutation";
  readonly retryChatbotSession?: {
    readonly __typename: "RetryChatbotSessionMutation";
    readonly chatSession?: {
      readonly __typename: "ChatSessionNode";
      readonly id: number;
      readonly updated?: string | null;
      readonly title?: string | null;
      readonly messages: {
        readonly __typename: "ChatMessageConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "ChatMessageEdge";
          readonly node?: {
            readonly __typename: "ChatMessageNode";
            readonly id: string;
            readonly content: string;
            readonly imageUrls: ReadonlyArray<string>;
            readonly role: ChatbotRoleEnum;
            readonly autogenerated?: boolean | null;
            readonly error?: boolean | null;
            readonly isStreaming?: boolean | null;
            readonly toolCalls?: ReadonlyArray<{
              readonly __typename: "ChatToolCallNode";
              readonly toolName: string;
              readonly resultCount?: number | null;
              readonly arguments?: string | null;
              readonly output?: string | null;
            } | null> | null;
            readonly createdArtifact?:
              | {
                  readonly __typename: "ActionItemArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "AsanaTaskArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "DecisionArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "DocumentArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "FeedbackArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "GithubIssuesArtifactNode";
                  readonly id: number;
                }
              | { readonly __typename: "GoalArtifactNode"; readonly id: number }
              | { readonly __typename: "KPIArtifactNode"; readonly id: number }
              | {
                  readonly __typename: "RatingArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "RecognitionArtifactNode";
                  readonly id: number;
                }
              | null;
          } | null;
        } | null>;
      };
    } | null;
  } | null;
};

export type SearchSkillsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type SearchSkillsQuery = {
  readonly __typename: "Query";
  readonly searchSkills: ReadonlyArray<
    | {
        readonly __typename: "PlatformSkillType";
        readonly name: string;
        readonly slug: string;
        readonly description: string;
        readonly visibility: SkillVisibilityEnum;
        readonly platformId: string;
      }
    | {
        readonly __typename: "SkillNode";
        readonly id: string;
        readonly name: string;
        readonly slug: string;
        readonly description: string;
        readonly visibility: SkillVisibilityEnum;
      }
  >;
};

export type SkillsQueryVariables = Exact<{ [key: string]: never }>;

export type SkillsQuery = {
  readonly __typename: "Query";
  readonly skills: ReadonlyArray<{
    readonly __typename: "ChatbotSkillType";
    readonly name: string;
    readonly description: string;
  }>;
};

export type UpdateAskAiChatSessionMutationMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
  title?: InputMaybe<Scalars["String"]["input"]>;
  pinned?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type UpdateAskAiChatSessionMutationMutation = {
  readonly __typename: "Mutation";
  readonly updateChatSession?: {
    readonly __typename: "UpdateChatSessionMutation";
    readonly chatSession?: {
      readonly __typename: "ChatSessionNode";
      readonly id: number;
      readonly title?: string | null;
      readonly pinnedAt?: string | null;
    } | null;
  } | null;
};

export type AssessmentNominationFragment = {
  readonly __typename: "AssessmentOpenForNominationNode";
  readonly id: string;
  readonly nominationsCount: number;
  readonly complianceProgram: {
    readonly __typename: "ComplianceProgramNode";
    readonly id: number;
    readonly title: string;
  };
  readonly assessmentTemplate: {
    readonly __typename: "AssessmentTemplateNode";
    readonly id: number;
    readonly assessmentType: AssessmentType;
  };
  readonly targetUser: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  };
};

type AssessmentQuestionFragment_CompetencyAssessmentQuestionNode_Fragment = {
  readonly __typename: "CompetencyAssessmentQuestionNode";
  readonly id: number;
  readonly title: string;
  readonly description?: any | null;
  readonly archived: boolean;
  readonly answersExist: boolean;
  readonly comment: AssessmentQuestionComment;
  readonly responses: AssessmentQuestionResponses;
  readonly responseVisibility: AssessmentQuestionResponseVisibility;
  readonly questionType: AssessmentQuestionType;
  readonly created: string;
  readonly startValue: number;
  readonly endValue: number;
  readonly labels: ReadonlyArray<string | null>;
  readonly labelDescriptions: ReadonlyArray<string | null>;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  };
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  };
  readonly categories: {
    readonly __typename: "AssessmentQuestionCategoryNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "AssessmentQuestionCategoryNodeEdge";
      readonly node?: {
        readonly __typename: "AssessmentQuestionCategoryNode";
        readonly id: number;
        readonly title: string;
      } | null;
    } | null>;
  };
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
  } | null;
};

type AssessmentQuestionFragment_CompetencyCriteriaAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
    readonly id: number;
    readonly title: string;
    readonly description?: any | null;
    readonly archived: boolean;
    readonly answersExist: boolean;
    readonly comment: AssessmentQuestionComment;
    readonly responses: AssessmentQuestionResponses;
    readonly responseVisibility: AssessmentQuestionResponseVisibility;
    readonly questionType: AssessmentQuestionType;
    readonly created: string;
    readonly startValue: number;
    readonly endValue: number;
    readonly labels: ReadonlyArray<string | null>;
    readonly labelDescriptions: ReadonlyArray<string | null>;
    readonly canUpdate: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    };
    readonly canDelete: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    };
    readonly categories: {
      readonly __typename: "AssessmentQuestionCategoryNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AssessmentQuestionCategoryNodeEdge";
        readonly node?: {
          readonly __typename: "AssessmentQuestionCategoryNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null>;
    };
    readonly creator?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
    } | null;
  };

type AssessmentQuestionFragment_IndividualGoalAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "IndividualGoalAssessmentQuestionNode";
    readonly id: number;
    readonly title: string;
    readonly description?: any | null;
    readonly archived: boolean;
    readonly answersExist: boolean;
    readonly comment: AssessmentQuestionComment;
    readonly responses: AssessmentQuestionResponses;
    readonly responseVisibility: AssessmentQuestionResponseVisibility;
    readonly questionType: AssessmentQuestionType;
    readonly created: string;
    readonly startValue: number;
    readonly endValue: number;
    readonly labels: ReadonlyArray<string | null>;
    readonly labelDescriptions: ReadonlyArray<string | null>;
    readonly canUpdate: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    };
    readonly canDelete: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    };
    readonly categories: {
      readonly __typename: "AssessmentQuestionCategoryNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AssessmentQuestionCategoryNodeEdge";
        readonly node?: {
          readonly __typename: "AssessmentQuestionCategoryNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null>;
    };
    readonly creator?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
    } | null;
  };

type AssessmentQuestionFragment_IndividualRecognitionCoreValueAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
    readonly id: number;
    readonly title: string;
    readonly description?: any | null;
    readonly archived: boolean;
    readonly answersExist: boolean;
    readonly comment: AssessmentQuestionComment;
    readonly responses: AssessmentQuestionResponses;
    readonly responseVisibility: AssessmentQuestionResponseVisibility;
    readonly questionType: AssessmentQuestionType;
    readonly created: string;
    readonly startValue: number;
    readonly endValue: number;
    readonly labels: ReadonlyArray<string | null>;
    readonly labelDescriptions: ReadonlyArray<string | null>;
    readonly canUpdate: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    };
    readonly canDelete: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    };
    readonly categories: {
      readonly __typename: "AssessmentQuestionCategoryNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AssessmentQuestionCategoryNodeEdge";
        readonly node?: {
          readonly __typename: "AssessmentQuestionCategoryNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null>;
    };
    readonly creator?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
    } | null;
  };

type AssessmentQuestionFragment_MultiChoiceAssessmentQuestionNode_Fragment = {
  readonly __typename: "MultiChoiceAssessmentQuestionNode";
  readonly id: number;
  readonly title: string;
  readonly description?: any | null;
  readonly archived: boolean;
  readonly answersExist: boolean;
  readonly comment: AssessmentQuestionComment;
  readonly responses: AssessmentQuestionResponses;
  readonly responseVisibility: AssessmentQuestionResponseVisibility;
  readonly questionType: AssessmentQuestionType;
  readonly created: string;
  readonly options: ReadonlyArray<string | null>;
  readonly optionDescriptions: ReadonlyArray<string | null>;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  };
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  };
  readonly categories: {
    readonly __typename: "AssessmentQuestionCategoryNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "AssessmentQuestionCategoryNodeEdge";
      readonly node?: {
        readonly __typename: "AssessmentQuestionCategoryNode";
        readonly id: number;
        readonly title: string;
      } | null;
    } | null>;
  };
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
  } | null;
};

type AssessmentQuestionFragment_NpsAssessmentQuestionNode_Fragment = {
  readonly __typename: "NpsAssessmentQuestionNode";
  readonly id: number;
  readonly title: string;
  readonly description?: any | null;
  readonly archived: boolean;
  readonly answersExist: boolean;
  readonly comment: AssessmentQuestionComment;
  readonly responses: AssessmentQuestionResponses;
  readonly responseVisibility: AssessmentQuestionResponseVisibility;
  readonly questionType: AssessmentQuestionType;
  readonly created: string;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  };
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  };
  readonly categories: {
    readonly __typename: "AssessmentQuestionCategoryNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "AssessmentQuestionCategoryNodeEdge";
      readonly node?: {
        readonly __typename: "AssessmentQuestionCategoryNode";
        readonly id: number;
        readonly title: string;
      } | null;
    } | null>;
  };
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
  } | null;
};

type AssessmentQuestionFragment_OverallGoalAssessmentQuestionNode_Fragment = {
  readonly __typename: "OverallGoalAssessmentQuestionNode";
  readonly id: number;
  readonly title: string;
  readonly description?: any | null;
  readonly archived: boolean;
  readonly answersExist: boolean;
  readonly comment: AssessmentQuestionComment;
  readonly responses: AssessmentQuestionResponses;
  readonly responseVisibility: AssessmentQuestionResponseVisibility;
  readonly questionType: AssessmentQuestionType;
  readonly created: string;
  readonly startValue: number;
  readonly endValue: number;
  readonly labels: ReadonlyArray<string | null>;
  readonly labelDescriptions: ReadonlyArray<string | null>;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  };
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  };
  readonly categories: {
    readonly __typename: "AssessmentQuestionCategoryNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "AssessmentQuestionCategoryNodeEdge";
      readonly node?: {
        readonly __typename: "AssessmentQuestionCategoryNode";
        readonly id: number;
        readonly title: string;
      } | null;
    } | null>;
  };
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
  } | null;
};

type AssessmentQuestionFragment_OverallRecognitionCoreValueAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
    readonly id: number;
    readonly title: string;
    readonly description?: any | null;
    readonly archived: boolean;
    readonly answersExist: boolean;
    readonly comment: AssessmentQuestionComment;
    readonly responses: AssessmentQuestionResponses;
    readonly responseVisibility: AssessmentQuestionResponseVisibility;
    readonly questionType: AssessmentQuestionType;
    readonly created: string;
    readonly startValue: number;
    readonly endValue: number;
    readonly labels: ReadonlyArray<string | null>;
    readonly labelDescriptions: ReadonlyArray<string | null>;
    readonly canUpdate: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    };
    readonly canDelete: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    };
    readonly categories: {
      readonly __typename: "AssessmentQuestionCategoryNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AssessmentQuestionCategoryNodeEdge";
        readonly node?: {
          readonly __typename: "AssessmentQuestionCategoryNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null>;
    };
    readonly creator?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
    } | null;
  };

type AssessmentQuestionFragment_RangeAssessmentQuestionNode_Fragment = {
  readonly __typename: "RangeAssessmentQuestionNode";
  readonly id: number;
  readonly title: string;
  readonly description?: any | null;
  readonly archived: boolean;
  readonly answersExist: boolean;
  readonly comment: AssessmentQuestionComment;
  readonly responses: AssessmentQuestionResponses;
  readonly responseVisibility: AssessmentQuestionResponseVisibility;
  readonly questionType: AssessmentQuestionType;
  readonly created: string;
  readonly startValue: number;
  readonly endValue: number;
  readonly labels: ReadonlyArray<string | null>;
  readonly labelDescriptions: ReadonlyArray<string | null>;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  };
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  };
  readonly categories: {
    readonly __typename: "AssessmentQuestionCategoryNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "AssessmentQuestionCategoryNodeEdge";
      readonly node?: {
        readonly __typename: "AssessmentQuestionCategoryNode";
        readonly id: number;
        readonly title: string;
      } | null;
    } | null>;
  };
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
  } | null;
};

type AssessmentQuestionFragment_ResponsibilityAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "ResponsibilityAssessmentQuestionNode";
    readonly id: number;
    readonly title: string;
    readonly description?: any | null;
    readonly archived: boolean;
    readonly answersExist: boolean;
    readonly comment: AssessmentQuestionComment;
    readonly responses: AssessmentQuestionResponses;
    readonly responseVisibility: AssessmentQuestionResponseVisibility;
    readonly questionType: AssessmentQuestionType;
    readonly created: string;
    readonly startValue: number;
    readonly endValue: number;
    readonly labels: ReadonlyArray<string | null>;
    readonly labelDescriptions: ReadonlyArray<string | null>;
    readonly canUpdate: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    };
    readonly canDelete: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    };
    readonly categories: {
      readonly __typename: "AssessmentQuestionCategoryNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AssessmentQuestionCategoryNodeEdge";
        readonly node?: {
          readonly __typename: "AssessmentQuestionCategoryNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null>;
    };
    readonly creator?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
    } | null;
  };

type AssessmentQuestionFragment_TalentIndicatorAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "TalentIndicatorAssessmentQuestionNode";
    readonly id: number;
    readonly title: string;
    readonly description?: any | null;
    readonly archived: boolean;
    readonly answersExist: boolean;
    readonly comment: AssessmentQuestionComment;
    readonly responses: AssessmentQuestionResponses;
    readonly responseVisibility: AssessmentQuestionResponseVisibility;
    readonly questionType: AssessmentQuestionType;
    readonly created: string;
    readonly startValue: number;
    readonly endValue: number;
    readonly labels: ReadonlyArray<string | null>;
    readonly labelDescriptions: ReadonlyArray<string | null>;
    readonly canUpdate: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    };
    readonly canDelete: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    };
    readonly categories: {
      readonly __typename: "AssessmentQuestionCategoryNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AssessmentQuestionCategoryNodeEdge";
        readonly node?: {
          readonly __typename: "AssessmentQuestionCategoryNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null>;
    };
    readonly creator?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
    } | null;
  };

type AssessmentQuestionFragment_TextAssessmentQuestionNode_Fragment = {
  readonly __typename: "TextAssessmentQuestionNode";
  readonly id: number;
  readonly title: string;
  readonly description?: any | null;
  readonly archived: boolean;
  readonly answersExist: boolean;
  readonly comment: AssessmentQuestionComment;
  readonly responses: AssessmentQuestionResponses;
  readonly responseVisibility: AssessmentQuestionResponseVisibility;
  readonly questionType: AssessmentQuestionType;
  readonly created: string;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  };
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  };
  readonly categories: {
    readonly __typename: "AssessmentQuestionCategoryNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "AssessmentQuestionCategoryNodeEdge";
      readonly node?: {
        readonly __typename: "AssessmentQuestionCategoryNode";
        readonly id: number;
        readonly title: string;
      } | null;
    } | null>;
  };
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
  } | null;
};

export type AssessmentQuestionFragmentFragment =
  | AssessmentQuestionFragment_CompetencyAssessmentQuestionNode_Fragment
  | AssessmentQuestionFragment_CompetencyCriteriaAssessmentQuestionNode_Fragment
  | AssessmentQuestionFragment_IndividualGoalAssessmentQuestionNode_Fragment
  | AssessmentQuestionFragment_IndividualRecognitionCoreValueAssessmentQuestionNode_Fragment
  | AssessmentQuestionFragment_MultiChoiceAssessmentQuestionNode_Fragment
  | AssessmentQuestionFragment_NpsAssessmentQuestionNode_Fragment
  | AssessmentQuestionFragment_OverallGoalAssessmentQuestionNode_Fragment
  | AssessmentQuestionFragment_OverallRecognitionCoreValueAssessmentQuestionNode_Fragment
  | AssessmentQuestionFragment_RangeAssessmentQuestionNode_Fragment
  | AssessmentQuestionFragment_ResponsibilityAssessmentQuestionNode_Fragment
  | AssessmentQuestionFragment_TalentIndicatorAssessmentQuestionNode_Fragment
  | AssessmentQuestionFragment_TextAssessmentQuestionNode_Fragment;

export type AssessmentQuestionCoreValueFragment = {
  readonly __typename: "RecognitionCoreValueNode";
  readonly id: number;
  readonly title: string;
  readonly description: string;
  readonly emoji?: string | null;
  readonly image?: string | null;
};

export type SaveAssessmentGroupMutationVariables = Exact<{
  title?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  assessmentGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  sections?: InputMaybe<
    | ReadonlyArray<InputMaybe<AssessmentGroupSectionInput>>
    | InputMaybe<AssessmentGroupSectionInput>
  >;
  archived?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type SaveAssessmentGroupMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateAssessmentGroup?: {
    readonly __typename: "CreateOrUpdateAssessmentGroupMutation";
    readonly assessmentGroup?: {
      readonly __typename: "AssessmentGroupNode";
      readonly id: number;
    } | null;
  } | null;
};

export type SaveAssessmentMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  targetId?: InputMaybe<Scalars["Int"]["input"]>;
  assessmentTemplateId: Scalars["Int"]["input"];
  assessmentId?: InputMaybe<Scalars["Int"]["input"]>;
  complianceProgramId?: InputMaybe<Scalars["Int"]["input"]>;
  state?: InputMaybe<AssessmentState>;
  answers?: InputMaybe<
    | ReadonlyArray<InputMaybe<AssessmentQuestionAnswerInput>>
    | InputMaybe<AssessmentQuestionAnswerInput>
  >;
}>;

export type SaveAssessmentMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateAssessment: {
    readonly __typename: "CreateOrUpdateAssessmentMutation";
    readonly assessment: {
      readonly __typename: "AssessmentNode";
      readonly id: number;
    };
  };
};

export type DeleteAssessmentAnswerMutationMutationVariables = Exact<{
  assessmentId: Scalars["Int"]["input"];
  questionIds:
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>;
}>;

export type DeleteAssessmentAnswerMutationMutation = {
  readonly __typename: "Mutation";
  readonly deleteAssessmentAnswer: {
    readonly __typename: "DeleteAssessmentAnswerMutation";
    readonly ok?: boolean | null;
  };
};

export type ActiveReviewsProgramAssessmentTemplateFragment = {
  readonly __typename: "AssessmentTemplateNode";
  readonly id: number;
  readonly assessmentType: AssessmentType;
};

export type ActiveReviewsComplianceProgramFragment = {
  readonly __typename: "ComplianceProgramNode";
  readonly id: number;
  readonly title: string;
  readonly dueDate?: string | null;
  readonly canReadDetails: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  };
  readonly usersMissingAssessment: {
    readonly __typename: "MissingAssessmentConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "MissingAssessmentEdge";
      readonly node?: {
        readonly __typename: "MissingAssessmentNode";
        readonly assessmentTemplateId?: number | null;
        readonly dueDate: string;
        readonly target?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly responder: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        };
      } | null;
    } | null>;
  };
  readonly matchingOneonones?: {
    readonly __typename: "MeetingNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "MeetingNodeEdge";
      readonly node?: {
        readonly __typename: "MeetingNode";
        readonly id: number;
        readonly title?: string | null;
        readonly meetingGroupId: number;
        readonly isFinalized: boolean;
        readonly startDatetime?: string | null;
        readonly draft: boolean;
        readonly meetingGroup?: {
          readonly __typename: "MeetingGroupNode";
          readonly id: number;
          readonly topicTemplate?: {
            readonly __typename: "TopicTemplateNode";
            readonly id: number;
          } | null;
        } | null;
        readonly participants?: {
          readonly __typename: "MeetingParticipantConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "MeetingParticipantEdge";
            readonly node?: {
              readonly __typename: "MeetingParticipantNode";
              readonly id?: string | null;
              readonly status?: AttendeeStatus | null;
              readonly user?: {
                readonly __typename: "BasicUserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
                readonly email: string;
              } | null;
            } | null;
          } | null>;
        } | null;
      } | null;
    } | null>;
  } | null;
  readonly requiredTopicTemplates: {
    readonly __typename: "TopicTemplateNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "TopicTemplateNodeEdge";
      readonly node?: {
        readonly __typename: "TopicTemplateNode";
        readonly id: number;
        readonly title: string;
      } | null;
    } | null>;
  };
  readonly applicableReports: {
    readonly __typename: "UserNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "UserNodeEdge";
      readonly node?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
        readonly email: string;
      } | null;
    } | null>;
  };
  readonly applicableManagers: {
    readonly __typename: "UserNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "UserNodeEdge";
      readonly node?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
        readonly email: string;
      } | null;
    } | null>;
  };
  readonly performanceAssessmentTemplate?: {
    readonly __typename: "AssessmentTemplateNode";
    readonly id: number;
    readonly assessmentType: AssessmentType;
  } | null;
  readonly managerAssessmentTemplate?: {
    readonly __typename: "AssessmentTemplateNode";
    readonly id: number;
    readonly assessmentType: AssessmentType;
  } | null;
  readonly peerAssessmentTemplate?: {
    readonly __typename: "AssessmentTemplateNode";
    readonly id: number;
    readonly assessmentType: AssessmentType;
  } | null;
  readonly assessments: {
    readonly __typename: "AssessmentNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "AssessmentNodeEdge";
      readonly node?: {
        readonly __typename: "AssessmentNode";
        readonly id: number;
        readonly state: AssessmentState;
        readonly assessmentDeliveryState?: AssessmentDeliveryState | null;
        readonly submittedDatetime?: string | null;
        readonly dueDate?: string | null;
        readonly target?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly responder?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly template: {
          readonly __typename: "AssessmentTemplateNode";
          readonly id: number;
        };
      } | null;
    } | null>;
  };
};

export type GetActiveReviewsActionsQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  currentUserId: Scalars["Int"]["input"];
  nominationTargetId?: InputMaybe<Scalars["Int"]["input"]>;
  deliveryTargetIds:
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetActiveReviewsActionsQuery = {
  readonly __typename: "Query";
  readonly compliancePrograms: {
    readonly __typename: "ComplianceProgramNodeConnection";
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly endCursor?: string | null;
      readonly hasNextPage: boolean;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "ComplianceProgramNodeEdge";
      readonly node?: {
        readonly __typename: "ComplianceProgramNode";
        readonly id: number;
        readonly title: string;
        readonly dueDate?: string | null;
        readonly canReadDetails: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
          readonly reason: string;
        };
        readonly usersMissingAssessment: {
          readonly __typename: "MissingAssessmentConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "MissingAssessmentEdge";
            readonly node?: {
              readonly __typename: "MissingAssessmentNode";
              readonly assessmentTemplateId?: number | null;
              readonly dueDate: string;
              readonly target?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly responder: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              };
            } | null;
          } | null>;
        };
        readonly matchingOneonones?: {
          readonly __typename: "MeetingNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "MeetingNodeEdge";
            readonly node?: {
              readonly __typename: "MeetingNode";
              readonly id: number;
              readonly title?: string | null;
              readonly meetingGroupId: number;
              readonly isFinalized: boolean;
              readonly startDatetime?: string | null;
              readonly draft: boolean;
              readonly meetingGroup?: {
                readonly __typename: "MeetingGroupNode";
                readonly id: number;
                readonly topicTemplate?: {
                  readonly __typename: "TopicTemplateNode";
                  readonly id: number;
                } | null;
              } | null;
              readonly participants?: {
                readonly __typename: "MeetingParticipantConnection";
                readonly edges: ReadonlyArray<{
                  readonly __typename: "MeetingParticipantEdge";
                  readonly node?: {
                    readonly __typename: "MeetingParticipantNode";
                    readonly id?: string | null;
                    readonly status?: AttendeeStatus | null;
                    readonly user?: {
                      readonly __typename: "BasicUserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                      readonly email: string;
                    } | null;
                  } | null;
                } | null>;
              } | null;
            } | null;
          } | null>;
        } | null;
        readonly requiredTopicTemplates: {
          readonly __typename: "TopicTemplateNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "TopicTemplateNodeEdge";
            readonly node?: {
              readonly __typename: "TopicTemplateNode";
              readonly id: number;
              readonly title: string;
            } | null;
          } | null>;
        };
        readonly applicableReports: {
          readonly __typename: "UserNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "UserNodeEdge";
            readonly node?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
              readonly email: string;
            } | null;
          } | null>;
        };
        readonly applicableManagers: {
          readonly __typename: "UserNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "UserNodeEdge";
            readonly node?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
              readonly email: string;
            } | null;
          } | null>;
        };
        readonly performanceAssessmentTemplate?: {
          readonly __typename: "AssessmentTemplateNode";
          readonly id: number;
          readonly assessmentType: AssessmentType;
        } | null;
        readonly managerAssessmentTemplate?: {
          readonly __typename: "AssessmentTemplateNode";
          readonly id: number;
          readonly assessmentType: AssessmentType;
        } | null;
        readonly peerAssessmentTemplate?: {
          readonly __typename: "AssessmentTemplateNode";
          readonly id: number;
          readonly assessmentType: AssessmentType;
        } | null;
        readonly assessments: {
          readonly __typename: "AssessmentNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "AssessmentNodeEdge";
            readonly node?: {
              readonly __typename: "AssessmentNode";
              readonly id: number;
              readonly state: AssessmentState;
              readonly assessmentDeliveryState?: AssessmentDeliveryState | null;
              readonly submittedDatetime?: string | null;
              readonly dueDate?: string | null;
              readonly target?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly template: {
                readonly __typename: "AssessmentTemplateNode";
                readonly id: number;
              };
            } | null;
          } | null>;
        };
      } | null;
    } | null>;
  };
  readonly assessmentDeliveries: {
    readonly __typename: "AssessmentDeliveryNodeConnection";
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly endCursor?: string | null;
      readonly hasNextPage: boolean;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "AssessmentDeliveryNodeEdge";
      readonly node?: {
        readonly __typename: "AssessmentDeliveryNode";
        readonly id: number;
        readonly state: AssessmentDeliveryState;
        readonly deliveryDatetime?: string | null;
        readonly lastSubmissionDatetime?: string | null;
        readonly peerRespondersCount?: number | null;
        readonly target?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly email: string;
          readonly firstName: string;
          readonly avatar?: string | null;
        } | null;
        readonly complianceProgram?: {
          readonly __typename: "ComplianceProgramNode";
          readonly id: number;
          readonly title: string;
          readonly dueDate?: string | null;
        } | null;
        readonly nominees: {
          readonly __typename: "UserNodeConnection";
          readonly totalCount: number;
        };
        readonly canUpdate?: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        } | null;
      } | null;
    } | null>;
  };
  readonly assessmentsOpenForNominations: {
    readonly __typename: "AssessmentOpenForNominationConnection";
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly endCursor?: string | null;
      readonly hasNextPage: boolean;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "AssessmentOpenForNominationEdge";
      readonly node?: {
        readonly __typename: "AssessmentOpenForNominationNode";
        readonly id: string;
        readonly nominationsCount: number;
        readonly complianceProgram: {
          readonly __typename: "ComplianceProgramNode";
          readonly id: number;
          readonly title: string;
        };
        readonly assessmentTemplate: {
          readonly __typename: "AssessmentTemplateNode";
          readonly id: number;
          readonly assessmentType: AssessmentType;
        };
        readonly targetUser: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        };
      } | null;
    } | null>;
  };
  readonly allCalibrationGroups: {
    readonly __typename: "CalibrationGroupNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "CalibrationGroupNodeEdge";
      readonly node?: {
        readonly __typename: "CalibrationGroupNode";
        readonly id: number;
        readonly name: string;
        readonly complianceProgram: {
          readonly __typename: "ComplianceProgramNode";
          readonly id: number;
          readonly title: string;
          readonly calibration: ComplianceProgramCalibrationType;
          readonly dueDate?: string | null;
          readonly ongoing: boolean;
          readonly state: ComplianceProgramState;
          readonly canReadDetails: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
            readonly reason: string;
          };
        };
      } | null;
    } | null>;
  };
};

export type GetAssessmentAnswerSuggestedAnswersQueryVariables = Exact<{
  assessmentAnswerId: Scalars["Int"]["input"];
}>;

export type GetAssessmentAnswerSuggestedAnswersQuery = {
  readonly __typename: "Query";
  readonly assessmentAnswer?:
    | {
        readonly __typename: "CompetencyAssessmentAnswerNode";
        readonly id: number;
        readonly question:
          | {
              readonly __typename: "CompetencyAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "IndividualGoalAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "MultiChoiceAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "NpsAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "OverallGoalAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "RangeAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "ResponsibilityAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "TextAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            };
      }
    | {
        readonly __typename: "CompetencyCriteriaAssessmentAnswerNode";
        readonly id: number;
        readonly question:
          | {
              readonly __typename: "CompetencyAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "IndividualGoalAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "MultiChoiceAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "NpsAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "OverallGoalAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "RangeAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "ResponsibilityAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "TextAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            };
      }
    | {
        readonly __typename: "IndividualGoalAssessmentAnswerNode";
        readonly id: number;
        readonly question:
          | {
              readonly __typename: "CompetencyAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "IndividualGoalAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "MultiChoiceAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "NpsAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "OverallGoalAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "RangeAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "ResponsibilityAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "TextAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            };
      }
    | {
        readonly __typename: "IndividualRecognitionCoreValueAssessmentAnswerNode";
        readonly id: number;
        readonly question:
          | {
              readonly __typename: "CompetencyAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "IndividualGoalAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "MultiChoiceAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "NpsAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "OverallGoalAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "RangeAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "ResponsibilityAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "TextAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            };
      }
    | {
        readonly __typename: "MultiChoiceAssessmentAnswerNode";
        readonly id: number;
        readonly question:
          | {
              readonly __typename: "CompetencyAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "IndividualGoalAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "MultiChoiceAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "NpsAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "OverallGoalAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "RangeAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "ResponsibilityAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "TextAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            };
      }
    | {
        readonly __typename: "NpsAssessmentAnswerNode";
        readonly id: number;
        readonly question:
          | {
              readonly __typename: "CompetencyAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "IndividualGoalAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "MultiChoiceAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "NpsAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "OverallGoalAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "RangeAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "ResponsibilityAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "TextAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            };
      }
    | {
        readonly __typename: "OverallGoalAssessmentAnswerNode";
        readonly id: number;
        readonly question:
          | {
              readonly __typename: "CompetencyAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "IndividualGoalAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "MultiChoiceAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "NpsAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "OverallGoalAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "RangeAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "ResponsibilityAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "TextAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            };
      }
    | {
        readonly __typename: "OverallRecognitionCoreValueAssessmentAnswerNode";
        readonly id: number;
        readonly question:
          | {
              readonly __typename: "CompetencyAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "IndividualGoalAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "MultiChoiceAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "NpsAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "OverallGoalAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "RangeAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "ResponsibilityAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "TextAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            };
      }
    | {
        readonly __typename: "RangeAssessmentAnswerNode";
        readonly id: number;
        readonly question:
          | {
              readonly __typename: "CompetencyAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "IndividualGoalAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "MultiChoiceAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "NpsAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "OverallGoalAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "RangeAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "ResponsibilityAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "TextAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            };
      }
    | {
        readonly __typename: "ResponsibilityAssessmentAnswerNode";
        readonly id: number;
        readonly question:
          | {
              readonly __typename: "CompetencyAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "IndividualGoalAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "MultiChoiceAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "NpsAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "OverallGoalAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "RangeAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "ResponsibilityAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "TextAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            };
      }
    | {
        readonly __typename: "TalentIndicatorAssessmentAnswerNode";
        readonly id: number;
        readonly question:
          | {
              readonly __typename: "CompetencyAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "IndividualGoalAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "MultiChoiceAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "NpsAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "OverallGoalAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "RangeAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "ResponsibilityAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "TextAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            };
      }
    | {
        readonly __typename: "TextAssessmentAnswerNode";
        readonly id: number;
        readonly inferredSources?: {
          readonly __typename: "AnswerCitationConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "AnswerCitationEdge";
            readonly node?: {
              readonly __typename: "AnswerCitationNode";
              readonly sourceId: string;
              readonly sourceType: string;
              readonly title: string;
              readonly url: string;
              readonly date?: string | null;
              readonly sourceProvider: string;
              readonly contextText?: string | null;
            } | null;
          } | null>;
        } | null;
        readonly question:
          | {
              readonly __typename: "CompetencyAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "IndividualGoalAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "MultiChoiceAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "NpsAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "OverallGoalAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "RangeAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "ResponsibilityAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            }
          | {
              readonly __typename: "TextAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
            };
      }
    | null;
};

export type GetAssessmentDeliveriesReceivedQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  targetId?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  orderBy: Scalars["String"]["input"];
}>;

export type GetAssessmentDeliveriesReceivedQuery = {
  readonly __typename: "Query";
  readonly assessmentDeliveries: {
    readonly __typename: "AssessmentDeliveryNodeConnection";
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly endCursor?: string | null;
      readonly hasNextPage: boolean;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "AssessmentDeliveryNodeEdge";
      readonly node?: {
        readonly __typename: "AssessmentDeliveryNode";
        readonly id: number;
        readonly deliveryDatetime?: string | null;
        readonly lastSubmissionDatetime?: string | null;
        readonly target?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly email: string;
          readonly firstName: string;
          readonly avatar?: string | null;
        } | null;
        readonly complianceProgram?: {
          readonly __typename: "ComplianceProgramNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null;
    } | null>;
  };
};

type AssessmentDeliveryAssessmentGroupSection_AssessmentGroupSectionNode_Fragment =
  {
    readonly __typename: "AssessmentGroupSectionNode";
    readonly id: number;
    readonly title?: string | null;
    readonly description?: any | null;
    readonly subjectVisibility: AssessmentSectionSubjectVisibility;
    readonly questions: {
      readonly __typename: "AssessmentGroupQuestionContainerConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AssessmentGroupQuestionContainerEdge";
        readonly node?: {
          readonly __typename: "AssessmentGroupQuestionContainer";
          readonly id: number;
          readonly question:
            | {
                readonly __typename: "CompetencyAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly role: {
                  readonly __typename: "CareerTrackRoleNode";
                  readonly id: number;
                  readonly title: string;
                  readonly level: number;
                };
                readonly competency: {
                  readonly __typename: "CompetencyNode";
                  readonly id: number;
                  readonly title: string;
                  readonly criteria: {
                    readonly __typename: "CompetencyCriteriaConnection";
                    readonly edges: ReadonlyArray<{
                      readonly __typename: "CompetencyCriteriaEdge";
                      readonly node?: {
                        readonly __typename: "CompetencyCriteriaNode";
                        readonly id: number;
                        readonly content: any;
                      } | null;
                    } | null>;
                  };
                };
              }
            | {
                readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly role: {
                  readonly __typename: "CareerTrackRoleNode";
                  readonly id: number;
                  readonly title: string;
                  readonly level: number;
                };
                readonly competencyCriteria: {
                  readonly __typename: "CompetencyCriteriaNode";
                  readonly id: number;
                  readonly content: any;
                  readonly competency: {
                    readonly __typename: "CompetencyNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description: any;
                  };
                };
              }
            | {
                readonly __typename: "IndividualGoalAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly goal?: {
                  readonly __typename: "GoalArtifactNode";
                  readonly id: number;
                  readonly artifactType: ArtifactType;
                  readonly startValue: number;
                  readonly currentValue: number;
                  readonly targetValue: number;
                  readonly progress: number;
                  readonly progressType: GoalProgressType;
                  readonly dueDate?: string | null;
                  readonly startDate?: string | null;
                  readonly state: GoalState;
                  readonly status: GoalStatus;
                  readonly scope: GoalScope;
                  readonly goalVisibility: GoalVisibility;
                  readonly created: string;
                  readonly parentGoalId?: number | null;
                  readonly ownerCount?: number | null;
                  readonly contributorCount?: number | null;
                  readonly isStale: boolean;
                  readonly title?: string | null;
                  readonly updated?: string | null;
                  readonly firstOwner?: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly avatar?: string | null;
                    readonly name: string;
                  } | null;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                  readonly canUpdate: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                  readonly canRead: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                  readonly creator?: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly name: string;
                    readonly avatar?: string | null;
                  } | null;
                } | null;
              }
            | {
                readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly coreValue?: {
                  readonly __typename: "RecognitionCoreValueNode";
                  readonly id: number;
                  readonly title: string;
                  readonly description: string;
                  readonly emoji?: string | null;
                  readonly image?: string | null;
                } | null;
              }
            | {
                readonly __typename: "MultiChoiceAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly options: ReadonlyArray<string | null>;
                readonly optionDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              }
            | {
                readonly __typename: "NpsAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              }
            | {
                readonly __typename: "OverallGoalAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              }
            | {
                readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              }
            | {
                readonly __typename: "RangeAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              }
            | {
                readonly __typename: "ResponsibilityAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly responsibility?: {
                  readonly __typename: "CareerTrackRoleResponsibilityNode";
                  readonly id: number;
                  readonly content: any;
                  readonly role: {
                    readonly __typename: "CareerTrackRoleNode";
                    readonly id: number;
                    readonly title: string;
                    readonly level: number;
                  };
                } | null;
              }
            | {
                readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly talentIndicator?: {
                  readonly __typename: "TalentIndicatorNode";
                  readonly id: number;
                  readonly talentIndicatorType: TalentIndicatorType;
                } | null;
              }
            | {
                readonly __typename: "TextAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              };
        } | null;
      } | null>;
    };
  };

type AssessmentDeliveryAssessmentGroupSection_VirtualAssessmentSectionNode_Fragment =
  {
    readonly __typename: "VirtualAssessmentSectionNode";
    readonly id: number;
    readonly title?: string | null;
    readonly description?: any | null;
    readonly subjectVisibility: AssessmentSectionSubjectVisibility;
    readonly questions: {
      readonly __typename: "AssessmentGroupQuestionContainerConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AssessmentGroupQuestionContainerEdge";
        readonly node?: {
          readonly __typename: "AssessmentGroupQuestionContainer";
          readonly id: number;
          readonly question:
            | {
                readonly __typename: "CompetencyAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly role: {
                  readonly __typename: "CareerTrackRoleNode";
                  readonly id: number;
                  readonly title: string;
                  readonly level: number;
                };
                readonly competency: {
                  readonly __typename: "CompetencyNode";
                  readonly id: number;
                  readonly title: string;
                  readonly criteria: {
                    readonly __typename: "CompetencyCriteriaConnection";
                    readonly edges: ReadonlyArray<{
                      readonly __typename: "CompetencyCriteriaEdge";
                      readonly node?: {
                        readonly __typename: "CompetencyCriteriaNode";
                        readonly id: number;
                        readonly content: any;
                      } | null;
                    } | null>;
                  };
                };
              }
            | {
                readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly role: {
                  readonly __typename: "CareerTrackRoleNode";
                  readonly id: number;
                  readonly title: string;
                  readonly level: number;
                };
                readonly competencyCriteria: {
                  readonly __typename: "CompetencyCriteriaNode";
                  readonly id: number;
                  readonly content: any;
                  readonly competency: {
                    readonly __typename: "CompetencyNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description: any;
                  };
                };
              }
            | {
                readonly __typename: "IndividualGoalAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly goal?: {
                  readonly __typename: "GoalArtifactNode";
                  readonly id: number;
                  readonly artifactType: ArtifactType;
                  readonly startValue: number;
                  readonly currentValue: number;
                  readonly targetValue: number;
                  readonly progress: number;
                  readonly progressType: GoalProgressType;
                  readonly dueDate?: string | null;
                  readonly startDate?: string | null;
                  readonly state: GoalState;
                  readonly status: GoalStatus;
                  readonly scope: GoalScope;
                  readonly goalVisibility: GoalVisibility;
                  readonly created: string;
                  readonly parentGoalId?: number | null;
                  readonly ownerCount?: number | null;
                  readonly contributorCount?: number | null;
                  readonly isStale: boolean;
                  readonly title?: string | null;
                  readonly updated?: string | null;
                  readonly firstOwner?: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly avatar?: string | null;
                    readonly name: string;
                  } | null;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                  readonly canUpdate: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                  readonly canRead: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                  readonly creator?: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly name: string;
                    readonly avatar?: string | null;
                  } | null;
                } | null;
              }
            | {
                readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly coreValue?: {
                  readonly __typename: "RecognitionCoreValueNode";
                  readonly id: number;
                  readonly title: string;
                  readonly description: string;
                  readonly emoji?: string | null;
                  readonly image?: string | null;
                } | null;
              }
            | {
                readonly __typename: "MultiChoiceAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly options: ReadonlyArray<string | null>;
                readonly optionDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              }
            | {
                readonly __typename: "NpsAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              }
            | {
                readonly __typename: "OverallGoalAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              }
            | {
                readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              }
            | {
                readonly __typename: "RangeAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              }
            | {
                readonly __typename: "ResponsibilityAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly responsibility?: {
                  readonly __typename: "CareerTrackRoleResponsibilityNode";
                  readonly id: number;
                  readonly content: any;
                  readonly role: {
                    readonly __typename: "CareerTrackRoleNode";
                    readonly id: number;
                    readonly title: string;
                    readonly level: number;
                  };
                } | null;
              }
            | {
                readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly talentIndicator?: {
                  readonly __typename: "TalentIndicatorNode";
                  readonly id: number;
                  readonly talentIndicatorType: TalentIndicatorType;
                } | null;
              }
            | {
                readonly __typename: "TextAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              };
        } | null;
      } | null>;
    };
  };

export type AssessmentDeliveryAssessmentGroupSectionFragment =
  | AssessmentDeliveryAssessmentGroupSection_AssessmentGroupSectionNode_Fragment
  | AssessmentDeliveryAssessmentGroupSection_VirtualAssessmentSectionNode_Fragment;

export type AssessmentDeliveryTemplateFragment = {
  readonly __typename: "AssessmentTemplateNode";
  readonly id: number;
  readonly assessmentType: AssessmentType;
  readonly anonymity: AssessmentGroupAnonymity;
  readonly delivery: AssessmentGroupDelivery;
  readonly questionSets: {
    readonly __typename: "AssessmentGroupNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "AssessmentGroupNodeEdge";
      readonly node?: {
        readonly __typename: "AssessmentGroupNode";
        readonly id: number;
        readonly title: string;
        readonly sections: {
          readonly __typename: "AssessmentGroupSectionNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "AssessmentGroupSectionNodeEdge";
            readonly node?: {
              readonly __typename: "AssessmentGroupSectionNode";
              readonly id: number;
              readonly title?: string | null;
              readonly description?: any | null;
              readonly subjectVisibility: AssessmentSectionSubjectVisibility;
              readonly questions: {
                readonly __typename: "AssessmentGroupQuestionContainerConnection";
                readonly edges: ReadonlyArray<{
                  readonly __typename: "AssessmentGroupQuestionContainerEdge";
                  readonly node?: {
                    readonly __typename: "AssessmentGroupQuestionContainer";
                    readonly id: number;
                    readonly question:
                      | {
                          readonly __typename: "CompetencyAssessmentQuestionNode";
                          readonly id: number;
                          readonly title: string;
                          readonly description?: any | null;
                          readonly startValue: number;
                          readonly endValue: number;
                          readonly labels: ReadonlyArray<string | null>;
                          readonly labelDescriptions: ReadonlyArray<
                            string | null
                          >;
                          readonly comment: AssessmentQuestionComment;
                          readonly isResponseMandatory: boolean;
                          readonly responses: AssessmentQuestionResponses;
                          readonly questionType: AssessmentQuestionType;
                          readonly responseVisibility: AssessmentQuestionResponseVisibility;
                          readonly role: {
                            readonly __typename: "CareerTrackRoleNode";
                            readonly id: number;
                            readonly title: string;
                            readonly level: number;
                          };
                          readonly competency: {
                            readonly __typename: "CompetencyNode";
                            readonly id: number;
                            readonly title: string;
                            readonly criteria: {
                              readonly __typename: "CompetencyCriteriaConnection";
                              readonly edges: ReadonlyArray<{
                                readonly __typename: "CompetencyCriteriaEdge";
                                readonly node?: {
                                  readonly __typename: "CompetencyCriteriaNode";
                                  readonly id: number;
                                  readonly content: any;
                                } | null;
                              } | null>;
                            };
                          };
                        }
                      | {
                          readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                          readonly id: number;
                          readonly title: string;
                          readonly description?: any | null;
                          readonly startValue: number;
                          readonly endValue: number;
                          readonly labels: ReadonlyArray<string | null>;
                          readonly labelDescriptions: ReadonlyArray<
                            string | null
                          >;
                          readonly comment: AssessmentQuestionComment;
                          readonly isResponseMandatory: boolean;
                          readonly responses: AssessmentQuestionResponses;
                          readonly questionType: AssessmentQuestionType;
                          readonly responseVisibility: AssessmentQuestionResponseVisibility;
                          readonly role: {
                            readonly __typename: "CareerTrackRoleNode";
                            readonly id: number;
                            readonly title: string;
                            readonly level: number;
                          };
                          readonly competencyCriteria: {
                            readonly __typename: "CompetencyCriteriaNode";
                            readonly id: number;
                            readonly content: any;
                            readonly competency: {
                              readonly __typename: "CompetencyNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description: any;
                            };
                          };
                        }
                      | {
                          readonly __typename: "IndividualGoalAssessmentQuestionNode";
                          readonly id: number;
                          readonly title: string;
                          readonly description?: any | null;
                          readonly startValue: number;
                          readonly endValue: number;
                          readonly labels: ReadonlyArray<string | null>;
                          readonly labelDescriptions: ReadonlyArray<
                            string | null
                          >;
                          readonly comment: AssessmentQuestionComment;
                          readonly isResponseMandatory: boolean;
                          readonly responses: AssessmentQuestionResponses;
                          readonly questionType: AssessmentQuestionType;
                          readonly responseVisibility: AssessmentQuestionResponseVisibility;
                          readonly goal?: {
                            readonly __typename: "GoalArtifactNode";
                            readonly id: number;
                            readonly artifactType: ArtifactType;
                            readonly startValue: number;
                            readonly currentValue: number;
                            readonly targetValue: number;
                            readonly progress: number;
                            readonly progressType: GoalProgressType;
                            readonly dueDate?: string | null;
                            readonly startDate?: string | null;
                            readonly state: GoalState;
                            readonly status: GoalStatus;
                            readonly scope: GoalScope;
                            readonly goalVisibility: GoalVisibility;
                            readonly created: string;
                            readonly parentGoalId?: number | null;
                            readonly ownerCount?: number | null;
                            readonly contributorCount?: number | null;
                            readonly isStale: boolean;
                            readonly title?: string | null;
                            readonly updated?: string | null;
                            readonly firstOwner?: {
                              readonly __typename: "UserNode";
                              readonly id: number;
                              readonly avatar?: string | null;
                              readonly name: string;
                            } | null;
                            readonly canDelete: {
                              readonly __typename: "PermissionNode";
                              readonly permission: boolean;
                            };
                            readonly canUpdate: {
                              readonly __typename: "PermissionNode";
                              readonly permission: boolean;
                            };
                            readonly canRead: {
                              readonly __typename: "PermissionNode";
                              readonly permission: boolean;
                            };
                            readonly creator?: {
                              readonly __typename: "UserNode";
                              readonly id: number;
                              readonly name: string;
                              readonly avatar?: string | null;
                            } | null;
                          } | null;
                        }
                      | {
                          readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                          readonly id: number;
                          readonly title: string;
                          readonly description?: any | null;
                          readonly startValue: number;
                          readonly endValue: number;
                          readonly labels: ReadonlyArray<string | null>;
                          readonly labelDescriptions: ReadonlyArray<
                            string | null
                          >;
                          readonly comment: AssessmentQuestionComment;
                          readonly isResponseMandatory: boolean;
                          readonly responses: AssessmentQuestionResponses;
                          readonly questionType: AssessmentQuestionType;
                          readonly responseVisibility: AssessmentQuestionResponseVisibility;
                          readonly coreValue?: {
                            readonly __typename: "RecognitionCoreValueNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description: string;
                            readonly emoji?: string | null;
                            readonly image?: string | null;
                          } | null;
                        }
                      | {
                          readonly __typename: "MultiChoiceAssessmentQuestionNode";
                          readonly id: number;
                          readonly title: string;
                          readonly description?: any | null;
                          readonly options: ReadonlyArray<string | null>;
                          readonly optionDescriptions: ReadonlyArray<
                            string | null
                          >;
                          readonly comment: AssessmentQuestionComment;
                          readonly isResponseMandatory: boolean;
                          readonly responses: AssessmentQuestionResponses;
                          readonly questionType: AssessmentQuestionType;
                          readonly responseVisibility: AssessmentQuestionResponseVisibility;
                        }
                      | {
                          readonly __typename: "NpsAssessmentQuestionNode";
                          readonly id: number;
                          readonly title: string;
                          readonly description?: any | null;
                          readonly comment: AssessmentQuestionComment;
                          readonly isResponseMandatory: boolean;
                          readonly responses: AssessmentQuestionResponses;
                          readonly questionType: AssessmentQuestionType;
                          readonly responseVisibility: AssessmentQuestionResponseVisibility;
                        }
                      | {
                          readonly __typename: "OverallGoalAssessmentQuestionNode";
                          readonly id: number;
                          readonly title: string;
                          readonly description?: any | null;
                          readonly startValue: number;
                          readonly endValue: number;
                          readonly labels: ReadonlyArray<string | null>;
                          readonly labelDescriptions: ReadonlyArray<
                            string | null
                          >;
                          readonly comment: AssessmentQuestionComment;
                          readonly isResponseMandatory: boolean;
                          readonly responses: AssessmentQuestionResponses;
                          readonly questionType: AssessmentQuestionType;
                          readonly responseVisibility: AssessmentQuestionResponseVisibility;
                        }
                      | {
                          readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                          readonly id: number;
                          readonly title: string;
                          readonly description?: any | null;
                          readonly startValue: number;
                          readonly endValue: number;
                          readonly labels: ReadonlyArray<string | null>;
                          readonly labelDescriptions: ReadonlyArray<
                            string | null
                          >;
                          readonly comment: AssessmentQuestionComment;
                          readonly isResponseMandatory: boolean;
                          readonly responses: AssessmentQuestionResponses;
                          readonly questionType: AssessmentQuestionType;
                          readonly responseVisibility: AssessmentQuestionResponseVisibility;
                        }
                      | {
                          readonly __typename: "RangeAssessmentQuestionNode";
                          readonly id: number;
                          readonly title: string;
                          readonly description?: any | null;
                          readonly startValue: number;
                          readonly endValue: number;
                          readonly labels: ReadonlyArray<string | null>;
                          readonly labelDescriptions: ReadonlyArray<
                            string | null
                          >;
                          readonly comment: AssessmentQuestionComment;
                          readonly isResponseMandatory: boolean;
                          readonly responses: AssessmentQuestionResponses;
                          readonly questionType: AssessmentQuestionType;
                          readonly responseVisibility: AssessmentQuestionResponseVisibility;
                        }
                      | {
                          readonly __typename: "ResponsibilityAssessmentQuestionNode";
                          readonly id: number;
                          readonly title: string;
                          readonly description?: any | null;
                          readonly startValue: number;
                          readonly endValue: number;
                          readonly labels: ReadonlyArray<string | null>;
                          readonly labelDescriptions: ReadonlyArray<
                            string | null
                          >;
                          readonly comment: AssessmentQuestionComment;
                          readonly isResponseMandatory: boolean;
                          readonly responses: AssessmentQuestionResponses;
                          readonly questionType: AssessmentQuestionType;
                          readonly responseVisibility: AssessmentQuestionResponseVisibility;
                          readonly responsibility?: {
                            readonly __typename: "CareerTrackRoleResponsibilityNode";
                            readonly id: number;
                            readonly content: any;
                            readonly role: {
                              readonly __typename: "CareerTrackRoleNode";
                              readonly id: number;
                              readonly title: string;
                              readonly level: number;
                            };
                          } | null;
                        }
                      | {
                          readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                          readonly id: number;
                          readonly title: string;
                          readonly description?: any | null;
                          readonly startValue: number;
                          readonly endValue: number;
                          readonly labels: ReadonlyArray<string | null>;
                          readonly labelDescriptions: ReadonlyArray<
                            string | null
                          >;
                          readonly comment: AssessmentQuestionComment;
                          readonly isResponseMandatory: boolean;
                          readonly responses: AssessmentQuestionResponses;
                          readonly questionType: AssessmentQuestionType;
                          readonly responseVisibility: AssessmentQuestionResponseVisibility;
                          readonly talentIndicator?: {
                            readonly __typename: "TalentIndicatorNode";
                            readonly id: number;
                            readonly talentIndicatorType: TalentIndicatorType;
                          } | null;
                        }
                      | {
                          readonly __typename: "TextAssessmentQuestionNode";
                          readonly id: number;
                          readonly title: string;
                          readonly description?: any | null;
                          readonly comment: AssessmentQuestionComment;
                          readonly isResponseMandatory: boolean;
                          readonly responses: AssessmentQuestionResponses;
                          readonly questionType: AssessmentQuestionType;
                          readonly responseVisibility: AssessmentQuestionResponseVisibility;
                        };
                  } | null;
                } | null>;
              };
            } | null;
          } | null>;
        };
      } | null;
    } | null>;
  };
};

export type AssessmentDeliveryFragment = {
  readonly __typename: "AssessmentDeliveryNode";
  readonly id: number;
  readonly state: AssessmentDeliveryState;
  readonly summary?: any | null;
  readonly calibrationAssessmentId?: number | null;
  readonly excludedAnswerIds: ReadonlyArray<number | null>;
  readonly deliveryDatetime?: string | null;
  readonly dueDate?: string | null;
  readonly periodStartDate?: string | null;
  readonly periodEndDate?: string | null;
  readonly targetCurrentRoleIds: ReadonlyArray<number | null>;
  readonly targetPosition?: string | null;
  readonly canUpdate?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  } | null;
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
  } | null;
  readonly target?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly email: string;
    readonly firstName: string;
    readonly avatar?: string | null;
    readonly organizationSpecificInfo?: {
      readonly __typename: "UserMemberNode";
      readonly jobLevel?: string | null;
      readonly startDate?: string | null;
    } | null;
    readonly managers: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly email: string;
          readonly firstName: string;
          readonly avatar?: string | null;
        } | null;
      } | null>;
    };
  } | null;
  readonly relatedMeetings: {
    readonly __typename: "MeetingNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "MeetingNodeEdge";
      readonly node?: {
        readonly __typename: "MeetingNode";
        readonly id: number;
        readonly title?: string | null;
        readonly meetingGroupId: number;
        readonly startDatetime?: string | null;
        readonly endDatetime?: string | null;
        readonly draft: boolean;
        readonly isFinalized: boolean;
        readonly canUpdate?: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        } | null;
      } | null;
    } | null>;
  };
  readonly mostRecentAnswers?: ReadonlyArray<{
    readonly __typename: "MostRecentAssessmentAnswerNode";
    readonly questionId: number;
    readonly questionType: AssessmentQuestionType;
    readonly integerAnswer: number;
    readonly submitted: string;
  } | null> | null;
  readonly complianceProgram?: {
    readonly __typename: "ComplianceProgramNode";
    readonly id: number;
    readonly title: string;
    readonly periodStartDate?: string | null;
    readonly periodEndDate?: string | null;
    readonly calibration: ComplianceProgramCalibrationType;
    readonly canReadDetails: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    };
    readonly performanceAssessmentTemplate?: {
      readonly __typename: "AssessmentTemplateNode";
      readonly id: number;
      readonly assessmentType: AssessmentType;
      readonly anonymity: AssessmentGroupAnonymity;
      readonly delivery: AssessmentGroupDelivery;
      readonly questionSets: {
        readonly __typename: "AssessmentGroupNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentGroupNodeEdge";
          readonly node?: {
            readonly __typename: "AssessmentGroupNode";
            readonly id: number;
            readonly title: string;
            readonly sections: {
              readonly __typename: "AssessmentGroupSectionNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "AssessmentGroupSectionNodeEdge";
                readonly node?: {
                  readonly __typename: "AssessmentGroupSectionNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly description?: any | null;
                  readonly subjectVisibility: AssessmentSectionSubjectVisibility;
                  readonly questions: {
                    readonly __typename: "AssessmentGroupQuestionContainerConnection";
                    readonly edges: ReadonlyArray<{
                      readonly __typename: "AssessmentGroupQuestionContainerEdge";
                      readonly node?: {
                        readonly __typename: "AssessmentGroupQuestionContainer";
                        readonly id: number;
                        readonly question:
                          | {
                              readonly __typename: "CompetencyAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly role: {
                                readonly __typename: "CareerTrackRoleNode";
                                readonly id: number;
                                readonly title: string;
                                readonly level: number;
                              };
                              readonly competency: {
                                readonly __typename: "CompetencyNode";
                                readonly id: number;
                                readonly title: string;
                                readonly criteria: {
                                  readonly __typename: "CompetencyCriteriaConnection";
                                  readonly edges: ReadonlyArray<{
                                    readonly __typename: "CompetencyCriteriaEdge";
                                    readonly node?: {
                                      readonly __typename: "CompetencyCriteriaNode";
                                      readonly id: number;
                                      readonly content: any;
                                    } | null;
                                  } | null>;
                                };
                              };
                            }
                          | {
                              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly role: {
                                readonly __typename: "CareerTrackRoleNode";
                                readonly id: number;
                                readonly title: string;
                                readonly level: number;
                              };
                              readonly competencyCriteria: {
                                readonly __typename: "CompetencyCriteriaNode";
                                readonly id: number;
                                readonly content: any;
                                readonly competency: {
                                  readonly __typename: "CompetencyNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly description: any;
                                };
                              };
                            }
                          | {
                              readonly __typename: "IndividualGoalAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly goal?: {
                                readonly __typename: "GoalArtifactNode";
                                readonly id: number;
                                readonly artifactType: ArtifactType;
                                readonly startValue: number;
                                readonly currentValue: number;
                                readonly targetValue: number;
                                readonly progress: number;
                                readonly progressType: GoalProgressType;
                                readonly dueDate?: string | null;
                                readonly startDate?: string | null;
                                readonly state: GoalState;
                                readonly status: GoalStatus;
                                readonly scope: GoalScope;
                                readonly goalVisibility: GoalVisibility;
                                readonly created: string;
                                readonly parentGoalId?: number | null;
                                readonly ownerCount?: number | null;
                                readonly contributorCount?: number | null;
                                readonly isStale: boolean;
                                readonly title?: string | null;
                                readonly updated?: string | null;
                                readonly firstOwner?: {
                                  readonly __typename: "UserNode";
                                  readonly id: number;
                                  readonly avatar?: string | null;
                                  readonly name: string;
                                } | null;
                                readonly canDelete: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly canUpdate: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly canRead: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly creator?: {
                                  readonly __typename: "UserNode";
                                  readonly id: number;
                                  readonly name: string;
                                  readonly avatar?: string | null;
                                } | null;
                              } | null;
                            }
                          | {
                              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly coreValue?: {
                                readonly __typename: "RecognitionCoreValueNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description: string;
                                readonly emoji?: string | null;
                                readonly image?: string | null;
                              } | null;
                            }
                          | {
                              readonly __typename: "MultiChoiceAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly options: ReadonlyArray<string | null>;
                              readonly optionDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "NpsAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "OverallGoalAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "RangeAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "ResponsibilityAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly responsibility?: {
                                readonly __typename: "CareerTrackRoleResponsibilityNode";
                                readonly id: number;
                                readonly content: any;
                                readonly role: {
                                  readonly __typename: "CareerTrackRoleNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly level: number;
                                };
                              } | null;
                            }
                          | {
                              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly talentIndicator?: {
                                readonly __typename: "TalentIndicatorNode";
                                readonly id: number;
                                readonly talentIndicatorType: TalentIndicatorType;
                              } | null;
                            }
                          | {
                              readonly __typename: "TextAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            };
                      } | null;
                    } | null>;
                  };
                } | null;
              } | null>;
            };
          } | null;
        } | null>;
      };
    } | null;
    readonly managerAssessmentTemplate?: {
      readonly __typename: "AssessmentTemplateNode";
      readonly id: number;
      readonly assessmentType: AssessmentType;
      readonly anonymity: AssessmentGroupAnonymity;
      readonly delivery: AssessmentGroupDelivery;
      readonly questionSets: {
        readonly __typename: "AssessmentGroupNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentGroupNodeEdge";
          readonly node?: {
            readonly __typename: "AssessmentGroupNode";
            readonly id: number;
            readonly title: string;
            readonly sections: {
              readonly __typename: "AssessmentGroupSectionNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "AssessmentGroupSectionNodeEdge";
                readonly node?: {
                  readonly __typename: "AssessmentGroupSectionNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly description?: any | null;
                  readonly subjectVisibility: AssessmentSectionSubjectVisibility;
                  readonly questions: {
                    readonly __typename: "AssessmentGroupQuestionContainerConnection";
                    readonly edges: ReadonlyArray<{
                      readonly __typename: "AssessmentGroupQuestionContainerEdge";
                      readonly node?: {
                        readonly __typename: "AssessmentGroupQuestionContainer";
                        readonly id: number;
                        readonly question:
                          | {
                              readonly __typename: "CompetencyAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly role: {
                                readonly __typename: "CareerTrackRoleNode";
                                readonly id: number;
                                readonly title: string;
                                readonly level: number;
                              };
                              readonly competency: {
                                readonly __typename: "CompetencyNode";
                                readonly id: number;
                                readonly title: string;
                                readonly criteria: {
                                  readonly __typename: "CompetencyCriteriaConnection";
                                  readonly edges: ReadonlyArray<{
                                    readonly __typename: "CompetencyCriteriaEdge";
                                    readonly node?: {
                                      readonly __typename: "CompetencyCriteriaNode";
                                      readonly id: number;
                                      readonly content: any;
                                    } | null;
                                  } | null>;
                                };
                              };
                            }
                          | {
                              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly role: {
                                readonly __typename: "CareerTrackRoleNode";
                                readonly id: number;
                                readonly title: string;
                                readonly level: number;
                              };
                              readonly competencyCriteria: {
                                readonly __typename: "CompetencyCriteriaNode";
                                readonly id: number;
                                readonly content: any;
                                readonly competency: {
                                  readonly __typename: "CompetencyNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly description: any;
                                };
                              };
                            }
                          | {
                              readonly __typename: "IndividualGoalAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly goal?: {
                                readonly __typename: "GoalArtifactNode";
                                readonly id: number;
                                readonly artifactType: ArtifactType;
                                readonly startValue: number;
                                readonly currentValue: number;
                                readonly targetValue: number;
                                readonly progress: number;
                                readonly progressType: GoalProgressType;
                                readonly dueDate?: string | null;
                                readonly startDate?: string | null;
                                readonly state: GoalState;
                                readonly status: GoalStatus;
                                readonly scope: GoalScope;
                                readonly goalVisibility: GoalVisibility;
                                readonly created: string;
                                readonly parentGoalId?: number | null;
                                readonly ownerCount?: number | null;
                                readonly contributorCount?: number | null;
                                readonly isStale: boolean;
                                readonly title?: string | null;
                                readonly updated?: string | null;
                                readonly firstOwner?: {
                                  readonly __typename: "UserNode";
                                  readonly id: number;
                                  readonly avatar?: string | null;
                                  readonly name: string;
                                } | null;
                                readonly canDelete: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly canUpdate: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly canRead: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly creator?: {
                                  readonly __typename: "UserNode";
                                  readonly id: number;
                                  readonly name: string;
                                  readonly avatar?: string | null;
                                } | null;
                              } | null;
                            }
                          | {
                              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly coreValue?: {
                                readonly __typename: "RecognitionCoreValueNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description: string;
                                readonly emoji?: string | null;
                                readonly image?: string | null;
                              } | null;
                            }
                          | {
                              readonly __typename: "MultiChoiceAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly options: ReadonlyArray<string | null>;
                              readonly optionDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "NpsAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "OverallGoalAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "RangeAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "ResponsibilityAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly responsibility?: {
                                readonly __typename: "CareerTrackRoleResponsibilityNode";
                                readonly id: number;
                                readonly content: any;
                                readonly role: {
                                  readonly __typename: "CareerTrackRoleNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly level: number;
                                };
                              } | null;
                            }
                          | {
                              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly talentIndicator?: {
                                readonly __typename: "TalentIndicatorNode";
                                readonly id: number;
                                readonly talentIndicatorType: TalentIndicatorType;
                              } | null;
                            }
                          | {
                              readonly __typename: "TextAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            };
                      } | null;
                    } | null>;
                  };
                } | null;
              } | null>;
            };
          } | null;
        } | null>;
      };
    } | null;
    readonly peerAssessmentTemplate?: {
      readonly __typename: "AssessmentTemplateNode";
      readonly id: number;
      readonly assessmentType: AssessmentType;
      readonly anonymity: AssessmentGroupAnonymity;
      readonly delivery: AssessmentGroupDelivery;
      readonly questionSets: {
        readonly __typename: "AssessmentGroupNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentGroupNodeEdge";
          readonly node?: {
            readonly __typename: "AssessmentGroupNode";
            readonly id: number;
            readonly title: string;
            readonly sections: {
              readonly __typename: "AssessmentGroupSectionNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "AssessmentGroupSectionNodeEdge";
                readonly node?: {
                  readonly __typename: "AssessmentGroupSectionNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly description?: any | null;
                  readonly subjectVisibility: AssessmentSectionSubjectVisibility;
                  readonly questions: {
                    readonly __typename: "AssessmentGroupQuestionContainerConnection";
                    readonly edges: ReadonlyArray<{
                      readonly __typename: "AssessmentGroupQuestionContainerEdge";
                      readonly node?: {
                        readonly __typename: "AssessmentGroupQuestionContainer";
                        readonly id: number;
                        readonly question:
                          | {
                              readonly __typename: "CompetencyAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly role: {
                                readonly __typename: "CareerTrackRoleNode";
                                readonly id: number;
                                readonly title: string;
                                readonly level: number;
                              };
                              readonly competency: {
                                readonly __typename: "CompetencyNode";
                                readonly id: number;
                                readonly title: string;
                                readonly criteria: {
                                  readonly __typename: "CompetencyCriteriaConnection";
                                  readonly edges: ReadonlyArray<{
                                    readonly __typename: "CompetencyCriteriaEdge";
                                    readonly node?: {
                                      readonly __typename: "CompetencyCriteriaNode";
                                      readonly id: number;
                                      readonly content: any;
                                    } | null;
                                  } | null>;
                                };
                              };
                            }
                          | {
                              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly role: {
                                readonly __typename: "CareerTrackRoleNode";
                                readonly id: number;
                                readonly title: string;
                                readonly level: number;
                              };
                              readonly competencyCriteria: {
                                readonly __typename: "CompetencyCriteriaNode";
                                readonly id: number;
                                readonly content: any;
                                readonly competency: {
                                  readonly __typename: "CompetencyNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly description: any;
                                };
                              };
                            }
                          | {
                              readonly __typename: "IndividualGoalAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly goal?: {
                                readonly __typename: "GoalArtifactNode";
                                readonly id: number;
                                readonly artifactType: ArtifactType;
                                readonly startValue: number;
                                readonly currentValue: number;
                                readonly targetValue: number;
                                readonly progress: number;
                                readonly progressType: GoalProgressType;
                                readonly dueDate?: string | null;
                                readonly startDate?: string | null;
                                readonly state: GoalState;
                                readonly status: GoalStatus;
                                readonly scope: GoalScope;
                                readonly goalVisibility: GoalVisibility;
                                readonly created: string;
                                readonly parentGoalId?: number | null;
                                readonly ownerCount?: number | null;
                                readonly contributorCount?: number | null;
                                readonly isStale: boolean;
                                readonly title?: string | null;
                                readonly updated?: string | null;
                                readonly firstOwner?: {
                                  readonly __typename: "UserNode";
                                  readonly id: number;
                                  readonly avatar?: string | null;
                                  readonly name: string;
                                } | null;
                                readonly canDelete: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly canUpdate: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly canRead: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly creator?: {
                                  readonly __typename: "UserNode";
                                  readonly id: number;
                                  readonly name: string;
                                  readonly avatar?: string | null;
                                } | null;
                              } | null;
                            }
                          | {
                              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly coreValue?: {
                                readonly __typename: "RecognitionCoreValueNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description: string;
                                readonly emoji?: string | null;
                                readonly image?: string | null;
                              } | null;
                            }
                          | {
                              readonly __typename: "MultiChoiceAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly options: ReadonlyArray<string | null>;
                              readonly optionDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "NpsAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "OverallGoalAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "RangeAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "ResponsibilityAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly responsibility?: {
                                readonly __typename: "CareerTrackRoleResponsibilityNode";
                                readonly id: number;
                                readonly content: any;
                                readonly role: {
                                  readonly __typename: "CareerTrackRoleNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly level: number;
                                };
                              } | null;
                            }
                          | {
                              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly talentIndicator?: {
                                readonly __typename: "TalentIndicatorNode";
                                readonly id: number;
                                readonly talentIndicatorType: TalentIndicatorType;
                              } | null;
                            }
                          | {
                              readonly __typename: "TextAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            };
                      } | null;
                    } | null>;
                  };
                } | null;
              } | null>;
            };
          } | null;
        } | null>;
      };
    } | null;
    readonly engagementSurveyTemplate?: {
      readonly __typename: "AssessmentTemplateNode";
      readonly id: number;
      readonly assessmentType: AssessmentType;
      readonly anonymity: AssessmentGroupAnonymity;
      readonly delivery: AssessmentGroupDelivery;
      readonly questionSets: {
        readonly __typename: "AssessmentGroupNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentGroupNodeEdge";
          readonly node?: {
            readonly __typename: "AssessmentGroupNode";
            readonly id: number;
            readonly title: string;
            readonly sections: {
              readonly __typename: "AssessmentGroupSectionNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "AssessmentGroupSectionNodeEdge";
                readonly node?: {
                  readonly __typename: "AssessmentGroupSectionNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly description?: any | null;
                  readonly subjectVisibility: AssessmentSectionSubjectVisibility;
                  readonly questions: {
                    readonly __typename: "AssessmentGroupQuestionContainerConnection";
                    readonly edges: ReadonlyArray<{
                      readonly __typename: "AssessmentGroupQuestionContainerEdge";
                      readonly node?: {
                        readonly __typename: "AssessmentGroupQuestionContainer";
                        readonly id: number;
                        readonly question:
                          | {
                              readonly __typename: "CompetencyAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly role: {
                                readonly __typename: "CareerTrackRoleNode";
                                readonly id: number;
                                readonly title: string;
                                readonly level: number;
                              };
                              readonly competency: {
                                readonly __typename: "CompetencyNode";
                                readonly id: number;
                                readonly title: string;
                                readonly criteria: {
                                  readonly __typename: "CompetencyCriteriaConnection";
                                  readonly edges: ReadonlyArray<{
                                    readonly __typename: "CompetencyCriteriaEdge";
                                    readonly node?: {
                                      readonly __typename: "CompetencyCriteriaNode";
                                      readonly id: number;
                                      readonly content: any;
                                    } | null;
                                  } | null>;
                                };
                              };
                            }
                          | {
                              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly role: {
                                readonly __typename: "CareerTrackRoleNode";
                                readonly id: number;
                                readonly title: string;
                                readonly level: number;
                              };
                              readonly competencyCriteria: {
                                readonly __typename: "CompetencyCriteriaNode";
                                readonly id: number;
                                readonly content: any;
                                readonly competency: {
                                  readonly __typename: "CompetencyNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly description: any;
                                };
                              };
                            }
                          | {
                              readonly __typename: "IndividualGoalAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly goal?: {
                                readonly __typename: "GoalArtifactNode";
                                readonly id: number;
                                readonly artifactType: ArtifactType;
                                readonly startValue: number;
                                readonly currentValue: number;
                                readonly targetValue: number;
                                readonly progress: number;
                                readonly progressType: GoalProgressType;
                                readonly dueDate?: string | null;
                                readonly startDate?: string | null;
                                readonly state: GoalState;
                                readonly status: GoalStatus;
                                readonly scope: GoalScope;
                                readonly goalVisibility: GoalVisibility;
                                readonly created: string;
                                readonly parentGoalId?: number | null;
                                readonly ownerCount?: number | null;
                                readonly contributorCount?: number | null;
                                readonly isStale: boolean;
                                readonly title?: string | null;
                                readonly updated?: string | null;
                                readonly firstOwner?: {
                                  readonly __typename: "UserNode";
                                  readonly id: number;
                                  readonly avatar?: string | null;
                                  readonly name: string;
                                } | null;
                                readonly canDelete: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly canUpdate: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly canRead: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly creator?: {
                                  readonly __typename: "UserNode";
                                  readonly id: number;
                                  readonly name: string;
                                  readonly avatar?: string | null;
                                } | null;
                              } | null;
                            }
                          | {
                              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly coreValue?: {
                                readonly __typename: "RecognitionCoreValueNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description: string;
                                readonly emoji?: string | null;
                                readonly image?: string | null;
                              } | null;
                            }
                          | {
                              readonly __typename: "MultiChoiceAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly options: ReadonlyArray<string | null>;
                              readonly optionDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "NpsAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "OverallGoalAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "RangeAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "ResponsibilityAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly responsibility?: {
                                readonly __typename: "CareerTrackRoleResponsibilityNode";
                                readonly id: number;
                                readonly content: any;
                                readonly role: {
                                  readonly __typename: "CareerTrackRoleNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly level: number;
                                };
                              } | null;
                            }
                          | {
                              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly talentIndicator?: {
                                readonly __typename: "TalentIndicatorNode";
                                readonly id: number;
                                readonly talentIndicatorType: TalentIndicatorType;
                              } | null;
                            }
                          | {
                              readonly __typename: "TextAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            };
                      } | null;
                    } | null>;
                  };
                } | null;
              } | null>;
            };
          } | null;
        } | null>;
      };
    } | null;
    readonly requiredTopicTemplates: {
      readonly __typename: "TopicTemplateNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "TopicTemplateNodeEdge";
        readonly node?: {
          readonly __typename: "TopicTemplateNode";
          readonly id: number;
        } | null;
      } | null>;
    };
    readonly participantStatus: {
      readonly __typename: "ParticipantStatusConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "ParticipantStatusEdge";
        readonly node?: {
          readonly __typename: "ParticipantStatusNode";
          readonly performanceAssessmentStatus: ComplianceProgramParticipantStatus;
          readonly performanceSelfAssessmentStatus: ComplianceProgramParticipantStatus;
          readonly managerAssessmentStatus: ComplianceProgramParticipantStatus;
          readonly managerSelfAssessmentStatus: ComplianceProgramParticipantStatus;
          readonly peerAssessmentStatus: ComplianceProgramParticipantStatus;
          readonly peerSelfAssessmentStatus: ComplianceProgramParticipantStatus;
          readonly user: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly email: string;
            readonly avatar?: string | null;
          };
        } | null;
      } | null>;
    };
  } | null;
  readonly additionalQuestionSets?: {
    readonly __typename: "ExtraAssessmentQuestionSetsByAssessmentTypeNode";
    readonly performance?: {
      readonly __typename: "AssessmentGroupConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AssessmentGroupEdge";
        readonly node?: {
          readonly __typename: "RoleBasedAssessmentGroupNode";
          readonly id: number;
          readonly title?: string | null;
          readonly sections?: {
            readonly __typename: "VirtualAssessmentSectionConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "VirtualAssessmentSectionEdge";
              readonly node?: {
                readonly __typename: "VirtualAssessmentSectionNode";
                readonly id: number;
                readonly title?: string | null;
                readonly description?: any | null;
                readonly subjectVisibility: AssessmentSectionSubjectVisibility;
                readonly questions: {
                  readonly __typename: "AssessmentGroupQuestionContainerConnection";
                  readonly edges: ReadonlyArray<{
                    readonly __typename: "AssessmentGroupQuestionContainerEdge";
                    readonly node?: {
                      readonly __typename: "AssessmentGroupQuestionContainer";
                      readonly id: number;
                      readonly question:
                        | {
                            readonly __typename: "CompetencyAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly startValue: number;
                            readonly endValue: number;
                            readonly labels: ReadonlyArray<string | null>;
                            readonly labelDescriptions: ReadonlyArray<
                              string | null
                            >;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            readonly role: {
                              readonly __typename: "CareerTrackRoleNode";
                              readonly id: number;
                              readonly title: string;
                              readonly level: number;
                            };
                            readonly competency: {
                              readonly __typename: "CompetencyNode";
                              readonly id: number;
                              readonly title: string;
                              readonly criteria: {
                                readonly __typename: "CompetencyCriteriaConnection";
                                readonly edges: ReadonlyArray<{
                                  readonly __typename: "CompetencyCriteriaEdge";
                                  readonly node?: {
                                    readonly __typename: "CompetencyCriteriaNode";
                                    readonly id: number;
                                    readonly content: any;
                                  } | null;
                                } | null>;
                              };
                            };
                          }
                        | {
                            readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly startValue: number;
                            readonly endValue: number;
                            readonly labels: ReadonlyArray<string | null>;
                            readonly labelDescriptions: ReadonlyArray<
                              string | null
                            >;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            readonly role: {
                              readonly __typename: "CareerTrackRoleNode";
                              readonly id: number;
                              readonly title: string;
                              readonly level: number;
                            };
                            readonly competencyCriteria: {
                              readonly __typename: "CompetencyCriteriaNode";
                              readonly id: number;
                              readonly content: any;
                              readonly competency: {
                                readonly __typename: "CompetencyNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description: any;
                              };
                            };
                          }
                        | {
                            readonly __typename: "IndividualGoalAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly startValue: number;
                            readonly endValue: number;
                            readonly labels: ReadonlyArray<string | null>;
                            readonly labelDescriptions: ReadonlyArray<
                              string | null
                            >;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            readonly goal?: {
                              readonly __typename: "GoalArtifactNode";
                              readonly id: number;
                              readonly artifactType: ArtifactType;
                              readonly startValue: number;
                              readonly currentValue: number;
                              readonly targetValue: number;
                              readonly progress: number;
                              readonly progressType: GoalProgressType;
                              readonly dueDate?: string | null;
                              readonly startDate?: string | null;
                              readonly state: GoalState;
                              readonly status: GoalStatus;
                              readonly scope: GoalScope;
                              readonly goalVisibility: GoalVisibility;
                              readonly created: string;
                              readonly parentGoalId?: number | null;
                              readonly ownerCount?: number | null;
                              readonly contributorCount?: number | null;
                              readonly isStale: boolean;
                              readonly title?: string | null;
                              readonly updated?: string | null;
                              readonly firstOwner?: {
                                readonly __typename: "UserNode";
                                readonly id: number;
                                readonly avatar?: string | null;
                                readonly name: string;
                              } | null;
                              readonly canDelete: {
                                readonly __typename: "PermissionNode";
                                readonly permission: boolean;
                              };
                              readonly canUpdate: {
                                readonly __typename: "PermissionNode";
                                readonly permission: boolean;
                              };
                              readonly canRead: {
                                readonly __typename: "PermissionNode";
                                readonly permission: boolean;
                              };
                              readonly creator?: {
                                readonly __typename: "UserNode";
                                readonly id: number;
                                readonly name: string;
                                readonly avatar?: string | null;
                              } | null;
                            } | null;
                          }
                        | {
                            readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly startValue: number;
                            readonly endValue: number;
                            readonly labels: ReadonlyArray<string | null>;
                            readonly labelDescriptions: ReadonlyArray<
                              string | null
                            >;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            readonly coreValue?: {
                              readonly __typename: "RecognitionCoreValueNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description: string;
                              readonly emoji?: string | null;
                              readonly image?: string | null;
                            } | null;
                          }
                        | {
                            readonly __typename: "MultiChoiceAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly options: ReadonlyArray<string | null>;
                            readonly optionDescriptions: ReadonlyArray<
                              string | null
                            >;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                          }
                        | {
                            readonly __typename: "NpsAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                          }
                        | {
                            readonly __typename: "OverallGoalAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly startValue: number;
                            readonly endValue: number;
                            readonly labels: ReadonlyArray<string | null>;
                            readonly labelDescriptions: ReadonlyArray<
                              string | null
                            >;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                          }
                        | {
                            readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly startValue: number;
                            readonly endValue: number;
                            readonly labels: ReadonlyArray<string | null>;
                            readonly labelDescriptions: ReadonlyArray<
                              string | null
                            >;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                          }
                        | {
                            readonly __typename: "RangeAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly startValue: number;
                            readonly endValue: number;
                            readonly labels: ReadonlyArray<string | null>;
                            readonly labelDescriptions: ReadonlyArray<
                              string | null
                            >;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                          }
                        | {
                            readonly __typename: "ResponsibilityAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly startValue: number;
                            readonly endValue: number;
                            readonly labels: ReadonlyArray<string | null>;
                            readonly labelDescriptions: ReadonlyArray<
                              string | null
                            >;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            readonly responsibility?: {
                              readonly __typename: "CareerTrackRoleResponsibilityNode";
                              readonly id: number;
                              readonly content: any;
                              readonly role: {
                                readonly __typename: "CareerTrackRoleNode";
                                readonly id: number;
                                readonly title: string;
                                readonly level: number;
                              };
                            } | null;
                          }
                        | {
                            readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly startValue: number;
                            readonly endValue: number;
                            readonly labels: ReadonlyArray<string | null>;
                            readonly labelDescriptions: ReadonlyArray<
                              string | null
                            >;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            readonly talentIndicator?: {
                              readonly __typename: "TalentIndicatorNode";
                              readonly id: number;
                              readonly talentIndicatorType: TalentIndicatorType;
                            } | null;
                          }
                        | {
                            readonly __typename: "TextAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                          };
                    } | null;
                  } | null>;
                };
              } | null;
            } | null>;
          } | null;
        } | null;
      } | null>;
    } | null;
    readonly peer?: {
      readonly __typename: "AssessmentGroupConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AssessmentGroupEdge";
        readonly node?: {
          readonly __typename: "RoleBasedAssessmentGroupNode";
          readonly id: number;
          readonly title?: string | null;
          readonly sections?: {
            readonly __typename: "VirtualAssessmentSectionConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "VirtualAssessmentSectionEdge";
              readonly node?: {
                readonly __typename: "VirtualAssessmentSectionNode";
                readonly id: number;
                readonly title?: string | null;
                readonly description?: any | null;
                readonly subjectVisibility: AssessmentSectionSubjectVisibility;
                readonly questions: {
                  readonly __typename: "AssessmentGroupQuestionContainerConnection";
                  readonly edges: ReadonlyArray<{
                    readonly __typename: "AssessmentGroupQuestionContainerEdge";
                    readonly node?: {
                      readonly __typename: "AssessmentGroupQuestionContainer";
                      readonly id: number;
                      readonly question:
                        | {
                            readonly __typename: "CompetencyAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly startValue: number;
                            readonly endValue: number;
                            readonly labels: ReadonlyArray<string | null>;
                            readonly labelDescriptions: ReadonlyArray<
                              string | null
                            >;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            readonly role: {
                              readonly __typename: "CareerTrackRoleNode";
                              readonly id: number;
                              readonly title: string;
                              readonly level: number;
                            };
                            readonly competency: {
                              readonly __typename: "CompetencyNode";
                              readonly id: number;
                              readonly title: string;
                              readonly criteria: {
                                readonly __typename: "CompetencyCriteriaConnection";
                                readonly edges: ReadonlyArray<{
                                  readonly __typename: "CompetencyCriteriaEdge";
                                  readonly node?: {
                                    readonly __typename: "CompetencyCriteriaNode";
                                    readonly id: number;
                                    readonly content: any;
                                  } | null;
                                } | null>;
                              };
                            };
                          }
                        | {
                            readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly startValue: number;
                            readonly endValue: number;
                            readonly labels: ReadonlyArray<string | null>;
                            readonly labelDescriptions: ReadonlyArray<
                              string | null
                            >;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            readonly role: {
                              readonly __typename: "CareerTrackRoleNode";
                              readonly id: number;
                              readonly title: string;
                              readonly level: number;
                            };
                            readonly competencyCriteria: {
                              readonly __typename: "CompetencyCriteriaNode";
                              readonly id: number;
                              readonly content: any;
                              readonly competency: {
                                readonly __typename: "CompetencyNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description: any;
                              };
                            };
                          }
                        | {
                            readonly __typename: "IndividualGoalAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly startValue: number;
                            readonly endValue: number;
                            readonly labels: ReadonlyArray<string | null>;
                            readonly labelDescriptions: ReadonlyArray<
                              string | null
                            >;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            readonly goal?: {
                              readonly __typename: "GoalArtifactNode";
                              readonly id: number;
                              readonly artifactType: ArtifactType;
                              readonly startValue: number;
                              readonly currentValue: number;
                              readonly targetValue: number;
                              readonly progress: number;
                              readonly progressType: GoalProgressType;
                              readonly dueDate?: string | null;
                              readonly startDate?: string | null;
                              readonly state: GoalState;
                              readonly status: GoalStatus;
                              readonly scope: GoalScope;
                              readonly goalVisibility: GoalVisibility;
                              readonly created: string;
                              readonly parentGoalId?: number | null;
                              readonly ownerCount?: number | null;
                              readonly contributorCount?: number | null;
                              readonly isStale: boolean;
                              readonly title?: string | null;
                              readonly updated?: string | null;
                              readonly firstOwner?: {
                                readonly __typename: "UserNode";
                                readonly id: number;
                                readonly avatar?: string | null;
                                readonly name: string;
                              } | null;
                              readonly canDelete: {
                                readonly __typename: "PermissionNode";
                                readonly permission: boolean;
                              };
                              readonly canUpdate: {
                                readonly __typename: "PermissionNode";
                                readonly permission: boolean;
                              };
                              readonly canRead: {
                                readonly __typename: "PermissionNode";
                                readonly permission: boolean;
                              };
                              readonly creator?: {
                                readonly __typename: "UserNode";
                                readonly id: number;
                                readonly name: string;
                                readonly avatar?: string | null;
                              } | null;
                            } | null;
                          }
                        | {
                            readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly startValue: number;
                            readonly endValue: number;
                            readonly labels: ReadonlyArray<string | null>;
                            readonly labelDescriptions: ReadonlyArray<
                              string | null
                            >;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            readonly coreValue?: {
                              readonly __typename: "RecognitionCoreValueNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description: string;
                              readonly emoji?: string | null;
                              readonly image?: string | null;
                            } | null;
                          }
                        | {
                            readonly __typename: "MultiChoiceAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly options: ReadonlyArray<string | null>;
                            readonly optionDescriptions: ReadonlyArray<
                              string | null
                            >;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                          }
                        | {
                            readonly __typename: "NpsAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                          }
                        | {
                            readonly __typename: "OverallGoalAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly startValue: number;
                            readonly endValue: number;
                            readonly labels: ReadonlyArray<string | null>;
                            readonly labelDescriptions: ReadonlyArray<
                              string | null
                            >;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                          }
                        | {
                            readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly startValue: number;
                            readonly endValue: number;
                            readonly labels: ReadonlyArray<string | null>;
                            readonly labelDescriptions: ReadonlyArray<
                              string | null
                            >;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                          }
                        | {
                            readonly __typename: "RangeAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly startValue: number;
                            readonly endValue: number;
                            readonly labels: ReadonlyArray<string | null>;
                            readonly labelDescriptions: ReadonlyArray<
                              string | null
                            >;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                          }
                        | {
                            readonly __typename: "ResponsibilityAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly startValue: number;
                            readonly endValue: number;
                            readonly labels: ReadonlyArray<string | null>;
                            readonly labelDescriptions: ReadonlyArray<
                              string | null
                            >;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            readonly responsibility?: {
                              readonly __typename: "CareerTrackRoleResponsibilityNode";
                              readonly id: number;
                              readonly content: any;
                              readonly role: {
                                readonly __typename: "CareerTrackRoleNode";
                                readonly id: number;
                                readonly title: string;
                                readonly level: number;
                              };
                            } | null;
                          }
                        | {
                            readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly startValue: number;
                            readonly endValue: number;
                            readonly labels: ReadonlyArray<string | null>;
                            readonly labelDescriptions: ReadonlyArray<
                              string | null
                            >;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            readonly talentIndicator?: {
                              readonly __typename: "TalentIndicatorNode";
                              readonly id: number;
                              readonly talentIndicatorType: TalentIndicatorType;
                            } | null;
                          }
                        | {
                            readonly __typename: "TextAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                          };
                    } | null;
                  } | null>;
                };
              } | null;
            } | null>;
          } | null;
        } | null;
      } | null>;
    } | null;
    readonly manager?: {
      readonly __typename: "AssessmentGroupConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AssessmentGroupEdge";
        readonly node?: {
          readonly __typename: "RoleBasedAssessmentGroupNode";
          readonly id: number;
          readonly title?: string | null;
          readonly sections?: {
            readonly __typename: "VirtualAssessmentSectionConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "VirtualAssessmentSectionEdge";
              readonly node?: {
                readonly __typename: "VirtualAssessmentSectionNode";
                readonly id: number;
                readonly title?: string | null;
                readonly description?: any | null;
                readonly subjectVisibility: AssessmentSectionSubjectVisibility;
                readonly questions: {
                  readonly __typename: "AssessmentGroupQuestionContainerConnection";
                  readonly edges: ReadonlyArray<{
                    readonly __typename: "AssessmentGroupQuestionContainerEdge";
                    readonly node?: {
                      readonly __typename: "AssessmentGroupQuestionContainer";
                      readonly id: number;
                      readonly question:
                        | {
                            readonly __typename: "CompetencyAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly startValue: number;
                            readonly endValue: number;
                            readonly labels: ReadonlyArray<string | null>;
                            readonly labelDescriptions: ReadonlyArray<
                              string | null
                            >;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            readonly role: {
                              readonly __typename: "CareerTrackRoleNode";
                              readonly id: number;
                              readonly title: string;
                              readonly level: number;
                            };
                            readonly competency: {
                              readonly __typename: "CompetencyNode";
                              readonly id: number;
                              readonly title: string;
                              readonly criteria: {
                                readonly __typename: "CompetencyCriteriaConnection";
                                readonly edges: ReadonlyArray<{
                                  readonly __typename: "CompetencyCriteriaEdge";
                                  readonly node?: {
                                    readonly __typename: "CompetencyCriteriaNode";
                                    readonly id: number;
                                    readonly content: any;
                                  } | null;
                                } | null>;
                              };
                            };
                          }
                        | {
                            readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly startValue: number;
                            readonly endValue: number;
                            readonly labels: ReadonlyArray<string | null>;
                            readonly labelDescriptions: ReadonlyArray<
                              string | null
                            >;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            readonly role: {
                              readonly __typename: "CareerTrackRoleNode";
                              readonly id: number;
                              readonly title: string;
                              readonly level: number;
                            };
                            readonly competencyCriteria: {
                              readonly __typename: "CompetencyCriteriaNode";
                              readonly id: number;
                              readonly content: any;
                              readonly competency: {
                                readonly __typename: "CompetencyNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description: any;
                              };
                            };
                          }
                        | {
                            readonly __typename: "IndividualGoalAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly startValue: number;
                            readonly endValue: number;
                            readonly labels: ReadonlyArray<string | null>;
                            readonly labelDescriptions: ReadonlyArray<
                              string | null
                            >;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            readonly goal?: {
                              readonly __typename: "GoalArtifactNode";
                              readonly id: number;
                              readonly artifactType: ArtifactType;
                              readonly startValue: number;
                              readonly currentValue: number;
                              readonly targetValue: number;
                              readonly progress: number;
                              readonly progressType: GoalProgressType;
                              readonly dueDate?: string | null;
                              readonly startDate?: string | null;
                              readonly state: GoalState;
                              readonly status: GoalStatus;
                              readonly scope: GoalScope;
                              readonly goalVisibility: GoalVisibility;
                              readonly created: string;
                              readonly parentGoalId?: number | null;
                              readonly ownerCount?: number | null;
                              readonly contributorCount?: number | null;
                              readonly isStale: boolean;
                              readonly title?: string | null;
                              readonly updated?: string | null;
                              readonly firstOwner?: {
                                readonly __typename: "UserNode";
                                readonly id: number;
                                readonly avatar?: string | null;
                                readonly name: string;
                              } | null;
                              readonly canDelete: {
                                readonly __typename: "PermissionNode";
                                readonly permission: boolean;
                              };
                              readonly canUpdate: {
                                readonly __typename: "PermissionNode";
                                readonly permission: boolean;
                              };
                              readonly canRead: {
                                readonly __typename: "PermissionNode";
                                readonly permission: boolean;
                              };
                              readonly creator?: {
                                readonly __typename: "UserNode";
                                readonly id: number;
                                readonly name: string;
                                readonly avatar?: string | null;
                              } | null;
                            } | null;
                          }
                        | {
                            readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly startValue: number;
                            readonly endValue: number;
                            readonly labels: ReadonlyArray<string | null>;
                            readonly labelDescriptions: ReadonlyArray<
                              string | null
                            >;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            readonly coreValue?: {
                              readonly __typename: "RecognitionCoreValueNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description: string;
                              readonly emoji?: string | null;
                              readonly image?: string | null;
                            } | null;
                          }
                        | {
                            readonly __typename: "MultiChoiceAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly options: ReadonlyArray<string | null>;
                            readonly optionDescriptions: ReadonlyArray<
                              string | null
                            >;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                          }
                        | {
                            readonly __typename: "NpsAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                          }
                        | {
                            readonly __typename: "OverallGoalAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly startValue: number;
                            readonly endValue: number;
                            readonly labels: ReadonlyArray<string | null>;
                            readonly labelDescriptions: ReadonlyArray<
                              string | null
                            >;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                          }
                        | {
                            readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly startValue: number;
                            readonly endValue: number;
                            readonly labels: ReadonlyArray<string | null>;
                            readonly labelDescriptions: ReadonlyArray<
                              string | null
                            >;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                          }
                        | {
                            readonly __typename: "RangeAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly startValue: number;
                            readonly endValue: number;
                            readonly labels: ReadonlyArray<string | null>;
                            readonly labelDescriptions: ReadonlyArray<
                              string | null
                            >;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                          }
                        | {
                            readonly __typename: "ResponsibilityAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly startValue: number;
                            readonly endValue: number;
                            readonly labels: ReadonlyArray<string | null>;
                            readonly labelDescriptions: ReadonlyArray<
                              string | null
                            >;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            readonly responsibility?: {
                              readonly __typename: "CareerTrackRoleResponsibilityNode";
                              readonly id: number;
                              readonly content: any;
                              readonly role: {
                                readonly __typename: "CareerTrackRoleNode";
                                readonly id: number;
                                readonly title: string;
                                readonly level: number;
                              };
                            } | null;
                          }
                        | {
                            readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly startValue: number;
                            readonly endValue: number;
                            readonly labels: ReadonlyArray<string | null>;
                            readonly labelDescriptions: ReadonlyArray<
                              string | null
                            >;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            readonly talentIndicator?: {
                              readonly __typename: "TalentIndicatorNode";
                              readonly id: number;
                              readonly talentIndicatorType: TalentIndicatorType;
                            } | null;
                          }
                        | {
                            readonly __typename: "TextAssessmentQuestionNode";
                            readonly id: number;
                            readonly title: string;
                            readonly description?: any | null;
                            readonly comment: AssessmentQuestionComment;
                            readonly isResponseMandatory: boolean;
                            readonly responses: AssessmentQuestionResponses;
                            readonly questionType: AssessmentQuestionType;
                            readonly responseVisibility: AssessmentQuestionResponseVisibility;
                          };
                    } | null;
                  } | null>;
                };
              } | null;
            } | null>;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
  readonly answers: {
    readonly __typename: "AssessmentAnswerConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "AssessmentAnswerEdge";
      readonly node?:
        | {
            readonly __typename: "CompetencyAssessmentAnswerNode";
            readonly id: number;
            readonly questionId: number;
            readonly integerAnswer?: number | null;
            readonly comment?: any | null;
            readonly responder?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly email: string;
              readonly firstName: string;
              readonly avatar?: string | null;
            } | null;
          }
        | {
            readonly __typename: "CompetencyCriteriaAssessmentAnswerNode";
            readonly id: number;
            readonly questionId: number;
            readonly integerAnswer?: number | null;
            readonly comment?: any | null;
            readonly responder?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly email: string;
              readonly firstName: string;
              readonly avatar?: string | null;
            } | null;
          }
        | {
            readonly __typename: "IndividualGoalAssessmentAnswerNode";
            readonly id: number;
            readonly questionId: number;
            readonly integerAnswer?: number | null;
            readonly comment?: any | null;
            readonly responder?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly email: string;
              readonly firstName: string;
              readonly avatar?: string | null;
            } | null;
          }
        | {
            readonly __typename: "IndividualRecognitionCoreValueAssessmentAnswerNode";
            readonly id: number;
            readonly questionId: number;
            readonly integerAnswer?: number | null;
            readonly comment?: any | null;
            readonly responder?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly email: string;
              readonly firstName: string;
              readonly avatar?: string | null;
            } | null;
          }
        | {
            readonly __typename: "MultiChoiceAssessmentAnswerNode";
            readonly id: number;
            readonly questionId: number;
            readonly choices: ReadonlyArray<number | null>;
            readonly comment?: any | null;
            readonly responder?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly email: string;
              readonly firstName: string;
              readonly avatar?: string | null;
            } | null;
          }
        | {
            readonly __typename: "NpsAssessmentAnswerNode";
            readonly id: number;
            readonly questionId: number;
            readonly integerAnswer?: number | null;
            readonly comment?: any | null;
            readonly responder?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly email: string;
              readonly firstName: string;
              readonly avatar?: string | null;
            } | null;
          }
        | {
            readonly __typename: "OverallGoalAssessmentAnswerNode";
            readonly id: number;
            readonly questionId: number;
            readonly integerAnswer?: number | null;
            readonly comment?: any | null;
            readonly responder?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly email: string;
              readonly firstName: string;
              readonly avatar?: string | null;
            } | null;
          }
        | {
            readonly __typename: "OverallRecognitionCoreValueAssessmentAnswerNode";
            readonly id: number;
            readonly questionId: number;
            readonly integerAnswer?: number | null;
            readonly comment?: any | null;
            readonly responder?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly email: string;
              readonly firstName: string;
              readonly avatar?: string | null;
            } | null;
          }
        | {
            readonly __typename: "RangeAssessmentAnswerNode";
            readonly id: number;
            readonly questionId: number;
            readonly integerAnswer?: number | null;
            readonly comment?: any | null;
            readonly responder?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly email: string;
              readonly firstName: string;
              readonly avatar?: string | null;
            } | null;
          }
        | {
            readonly __typename: "ResponsibilityAssessmentAnswerNode";
            readonly id: number;
            readonly questionId: number;
            readonly integerAnswer?: number | null;
            readonly comment?: any | null;
            readonly responder?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly email: string;
              readonly firstName: string;
              readonly avatar?: string | null;
            } | null;
          }
        | {
            readonly __typename: "TalentIndicatorAssessmentAnswerNode";
            readonly id: number;
            readonly questionId: number;
            readonly integerAnswer?: number | null;
            readonly comment?: any | null;
            readonly responder?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly email: string;
              readonly firstName: string;
              readonly avatar?: string | null;
            } | null;
          }
        | {
            readonly __typename: "TextAssessmentAnswerNode";
            readonly id: number;
            readonly questionId: number;
            readonly textAnswer?: any | null;
            readonly comment?: any | null;
            readonly responder?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly email: string;
              readonly firstName: string;
              readonly avatar?: string | null;
            } | null;
            readonly inferredSources?: {
              readonly __typename: "AnswerCitationConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "AnswerCitationEdge";
                readonly node?: {
                  readonly __typename: "AnswerCitationNode";
                  readonly url: string;
                  readonly title: string;
                  readonly sourceId: string;
                  readonly sourceProvider: string;
                  readonly sourceType: string;
                  readonly contextText?: string | null;
                  readonly meeting?: {
                    readonly __typename: "MeetingNode";
                    readonly id: number;
                    readonly meetingGroupId: number;
                    readonly title?: string | null;
                    readonly startDatetime?: string | null;
                  } | null;
                  readonly assessment?: {
                    readonly __typename: "AssessmentNode";
                    readonly id: number;
                    readonly submittedDatetime?: string | null;
                    readonly responder?: {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    } | null;
                    readonly template: {
                      readonly __typename: "AssessmentTemplateNode";
                      readonly assessmentType: AssessmentType;
                    };
                    readonly target?: {
                      readonly __typename: "UserNode";
                      readonly id: number;
                    } | null;
                  } | null;
                } | null;
              } | null>;
            } | null;
          }
        | null;
    } | null>;
  };
};

export type GetAssessmentDeliveryQueryVariables = Exact<{
  assessmentDeliveryId: Scalars["IntOrString"]["input"];
  organizationId: Scalars["Int"]["input"];
}>;

export type GetAssessmentDeliveryQuery = {
  readonly __typename: "Query";
  readonly assessmentDelivery?: {
    readonly __typename: "AssessmentDeliveryNode";
    readonly undeliveredPeerAssessmentDeliveryId?: string | null;
    readonly id: number;
    readonly state: AssessmentDeliveryState;
    readonly summary?: any | null;
    readonly calibrationAssessmentId?: number | null;
    readonly excludedAnswerIds: ReadonlyArray<number | null>;
    readonly deliveryDatetime?: string | null;
    readonly dueDate?: string | null;
    readonly periodStartDate?: string | null;
    readonly periodEndDate?: string | null;
    readonly targetCurrentRoleIds: ReadonlyArray<number | null>;
    readonly targetPosition?: string | null;
    readonly canUpdate?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    } | null;
    readonly creator?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
    } | null;
    readonly target?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly email: string;
      readonly firstName: string;
      readonly avatar?: string | null;
      readonly organizationSpecificInfo?: {
        readonly __typename: "UserMemberNode";
        readonly jobLevel?: string | null;
        readonly startDate?: string | null;
      } | null;
      readonly managers: {
        readonly __typename: "UserNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "UserNodeEdge";
          readonly node?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly email: string;
            readonly firstName: string;
            readonly avatar?: string | null;
          } | null;
        } | null>;
      };
    } | null;
    readonly relatedMeetings: {
      readonly __typename: "MeetingNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "MeetingNodeEdge";
        readonly node?: {
          readonly __typename: "MeetingNode";
          readonly id: number;
          readonly title?: string | null;
          readonly meetingGroupId: number;
          readonly startDatetime?: string | null;
          readonly endDatetime?: string | null;
          readonly draft: boolean;
          readonly isFinalized: boolean;
          readonly canUpdate?: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          } | null;
        } | null;
      } | null>;
    };
    readonly mostRecentAnswers?: ReadonlyArray<{
      readonly __typename: "MostRecentAssessmentAnswerNode";
      readonly questionId: number;
      readonly questionType: AssessmentQuestionType;
      readonly integerAnswer: number;
      readonly submitted: string;
    } | null> | null;
    readonly complianceProgram?: {
      readonly __typename: "ComplianceProgramNode";
      readonly id: number;
      readonly title: string;
      readonly periodStartDate?: string | null;
      readonly periodEndDate?: string | null;
      readonly calibration: ComplianceProgramCalibrationType;
      readonly canReadDetails: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
        readonly reason: string;
      };
      readonly performanceAssessmentTemplate?: {
        readonly __typename: "AssessmentTemplateNode";
        readonly id: number;
        readonly assessmentType: AssessmentType;
        readonly anonymity: AssessmentGroupAnonymity;
        readonly delivery: AssessmentGroupDelivery;
        readonly questionSets: {
          readonly __typename: "AssessmentGroupNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "AssessmentGroupNodeEdge";
            readonly node?: {
              readonly __typename: "AssessmentGroupNode";
              readonly id: number;
              readonly title: string;
              readonly sections: {
                readonly __typename: "AssessmentGroupSectionNodeConnection";
                readonly edges: ReadonlyArray<{
                  readonly __typename: "AssessmentGroupSectionNodeEdge";
                  readonly node?: {
                    readonly __typename: "AssessmentGroupSectionNode";
                    readonly id: number;
                    readonly title?: string | null;
                    readonly description?: any | null;
                    readonly subjectVisibility: AssessmentSectionSubjectVisibility;
                    readonly questions: {
                      readonly __typename: "AssessmentGroupQuestionContainerConnection";
                      readonly edges: ReadonlyArray<{
                        readonly __typename: "AssessmentGroupQuestionContainerEdge";
                        readonly node?: {
                          readonly __typename: "AssessmentGroupQuestionContainer";
                          readonly id: number;
                          readonly question:
                            | {
                                readonly __typename: "CompetencyAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                                readonly role: {
                                  readonly __typename: "CareerTrackRoleNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly level: number;
                                };
                                readonly competency: {
                                  readonly __typename: "CompetencyNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly criteria: {
                                    readonly __typename: "CompetencyCriteriaConnection";
                                    readonly edges: ReadonlyArray<{
                                      readonly __typename: "CompetencyCriteriaEdge";
                                      readonly node?: {
                                        readonly __typename: "CompetencyCriteriaNode";
                                        readonly id: number;
                                        readonly content: any;
                                      } | null;
                                    } | null>;
                                  };
                                };
                              }
                            | {
                                readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                                readonly role: {
                                  readonly __typename: "CareerTrackRoleNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly level: number;
                                };
                                readonly competencyCriteria: {
                                  readonly __typename: "CompetencyCriteriaNode";
                                  readonly id: number;
                                  readonly content: any;
                                  readonly competency: {
                                    readonly __typename: "CompetencyNode";
                                    readonly id: number;
                                    readonly title: string;
                                    readonly description: any;
                                  };
                                };
                              }
                            | {
                                readonly __typename: "IndividualGoalAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                                readonly goal?: {
                                  readonly __typename: "GoalArtifactNode";
                                  readonly id: number;
                                  readonly artifactType: ArtifactType;
                                  readonly startValue: number;
                                  readonly currentValue: number;
                                  readonly targetValue: number;
                                  readonly progress: number;
                                  readonly progressType: GoalProgressType;
                                  readonly dueDate?: string | null;
                                  readonly startDate?: string | null;
                                  readonly state: GoalState;
                                  readonly status: GoalStatus;
                                  readonly scope: GoalScope;
                                  readonly goalVisibility: GoalVisibility;
                                  readonly created: string;
                                  readonly parentGoalId?: number | null;
                                  readonly ownerCount?: number | null;
                                  readonly contributorCount?: number | null;
                                  readonly isStale: boolean;
                                  readonly title?: string | null;
                                  readonly updated?: string | null;
                                  readonly firstOwner?: {
                                    readonly __typename: "UserNode";
                                    readonly id: number;
                                    readonly avatar?: string | null;
                                    readonly name: string;
                                  } | null;
                                  readonly canDelete: {
                                    readonly __typename: "PermissionNode";
                                    readonly permission: boolean;
                                  };
                                  readonly canUpdate: {
                                    readonly __typename: "PermissionNode";
                                    readonly permission: boolean;
                                  };
                                  readonly canRead: {
                                    readonly __typename: "PermissionNode";
                                    readonly permission: boolean;
                                  };
                                  readonly creator?: {
                                    readonly __typename: "UserNode";
                                    readonly id: number;
                                    readonly name: string;
                                    readonly avatar?: string | null;
                                  } | null;
                                } | null;
                              }
                            | {
                                readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                                readonly coreValue?: {
                                  readonly __typename: "RecognitionCoreValueNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly description: string;
                                  readonly emoji?: string | null;
                                  readonly image?: string | null;
                                } | null;
                              }
                            | {
                                readonly __typename: "MultiChoiceAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly options: ReadonlyArray<string | null>;
                                readonly optionDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              }
                            | {
                                readonly __typename: "NpsAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              }
                            | {
                                readonly __typename: "OverallGoalAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              }
                            | {
                                readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              }
                            | {
                                readonly __typename: "RangeAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              }
                            | {
                                readonly __typename: "ResponsibilityAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                                readonly responsibility?: {
                                  readonly __typename: "CareerTrackRoleResponsibilityNode";
                                  readonly id: number;
                                  readonly content: any;
                                  readonly role: {
                                    readonly __typename: "CareerTrackRoleNode";
                                    readonly id: number;
                                    readonly title: string;
                                    readonly level: number;
                                  };
                                } | null;
                              }
                            | {
                                readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                                readonly talentIndicator?: {
                                  readonly __typename: "TalentIndicatorNode";
                                  readonly id: number;
                                  readonly talentIndicatorType: TalentIndicatorType;
                                } | null;
                              }
                            | {
                                readonly __typename: "TextAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              };
                        } | null;
                      } | null>;
                    };
                  } | null;
                } | null>;
              };
            } | null;
          } | null>;
        };
      } | null;
      readonly managerAssessmentTemplate?: {
        readonly __typename: "AssessmentTemplateNode";
        readonly id: number;
        readonly assessmentType: AssessmentType;
        readonly anonymity: AssessmentGroupAnonymity;
        readonly delivery: AssessmentGroupDelivery;
        readonly questionSets: {
          readonly __typename: "AssessmentGroupNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "AssessmentGroupNodeEdge";
            readonly node?: {
              readonly __typename: "AssessmentGroupNode";
              readonly id: number;
              readonly title: string;
              readonly sections: {
                readonly __typename: "AssessmentGroupSectionNodeConnection";
                readonly edges: ReadonlyArray<{
                  readonly __typename: "AssessmentGroupSectionNodeEdge";
                  readonly node?: {
                    readonly __typename: "AssessmentGroupSectionNode";
                    readonly id: number;
                    readonly title?: string | null;
                    readonly description?: any | null;
                    readonly subjectVisibility: AssessmentSectionSubjectVisibility;
                    readonly questions: {
                      readonly __typename: "AssessmentGroupQuestionContainerConnection";
                      readonly edges: ReadonlyArray<{
                        readonly __typename: "AssessmentGroupQuestionContainerEdge";
                        readonly node?: {
                          readonly __typename: "AssessmentGroupQuestionContainer";
                          readonly id: number;
                          readonly question:
                            | {
                                readonly __typename: "CompetencyAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                                readonly role: {
                                  readonly __typename: "CareerTrackRoleNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly level: number;
                                };
                                readonly competency: {
                                  readonly __typename: "CompetencyNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly criteria: {
                                    readonly __typename: "CompetencyCriteriaConnection";
                                    readonly edges: ReadonlyArray<{
                                      readonly __typename: "CompetencyCriteriaEdge";
                                      readonly node?: {
                                        readonly __typename: "CompetencyCriteriaNode";
                                        readonly id: number;
                                        readonly content: any;
                                      } | null;
                                    } | null>;
                                  };
                                };
                              }
                            | {
                                readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                                readonly role: {
                                  readonly __typename: "CareerTrackRoleNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly level: number;
                                };
                                readonly competencyCriteria: {
                                  readonly __typename: "CompetencyCriteriaNode";
                                  readonly id: number;
                                  readonly content: any;
                                  readonly competency: {
                                    readonly __typename: "CompetencyNode";
                                    readonly id: number;
                                    readonly title: string;
                                    readonly description: any;
                                  };
                                };
                              }
                            | {
                                readonly __typename: "IndividualGoalAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                                readonly goal?: {
                                  readonly __typename: "GoalArtifactNode";
                                  readonly id: number;
                                  readonly artifactType: ArtifactType;
                                  readonly startValue: number;
                                  readonly currentValue: number;
                                  readonly targetValue: number;
                                  readonly progress: number;
                                  readonly progressType: GoalProgressType;
                                  readonly dueDate?: string | null;
                                  readonly startDate?: string | null;
                                  readonly state: GoalState;
                                  readonly status: GoalStatus;
                                  readonly scope: GoalScope;
                                  readonly goalVisibility: GoalVisibility;
                                  readonly created: string;
                                  readonly parentGoalId?: number | null;
                                  readonly ownerCount?: number | null;
                                  readonly contributorCount?: number | null;
                                  readonly isStale: boolean;
                                  readonly title?: string | null;
                                  readonly updated?: string | null;
                                  readonly firstOwner?: {
                                    readonly __typename: "UserNode";
                                    readonly id: number;
                                    readonly avatar?: string | null;
                                    readonly name: string;
                                  } | null;
                                  readonly canDelete: {
                                    readonly __typename: "PermissionNode";
                                    readonly permission: boolean;
                                  };
                                  readonly canUpdate: {
                                    readonly __typename: "PermissionNode";
                                    readonly permission: boolean;
                                  };
                                  readonly canRead: {
                                    readonly __typename: "PermissionNode";
                                    readonly permission: boolean;
                                  };
                                  readonly creator?: {
                                    readonly __typename: "UserNode";
                                    readonly id: number;
                                    readonly name: string;
                                    readonly avatar?: string | null;
                                  } | null;
                                } | null;
                              }
                            | {
                                readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                                readonly coreValue?: {
                                  readonly __typename: "RecognitionCoreValueNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly description: string;
                                  readonly emoji?: string | null;
                                  readonly image?: string | null;
                                } | null;
                              }
                            | {
                                readonly __typename: "MultiChoiceAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly options: ReadonlyArray<string | null>;
                                readonly optionDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              }
                            | {
                                readonly __typename: "NpsAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              }
                            | {
                                readonly __typename: "OverallGoalAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              }
                            | {
                                readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              }
                            | {
                                readonly __typename: "RangeAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              }
                            | {
                                readonly __typename: "ResponsibilityAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                                readonly responsibility?: {
                                  readonly __typename: "CareerTrackRoleResponsibilityNode";
                                  readonly id: number;
                                  readonly content: any;
                                  readonly role: {
                                    readonly __typename: "CareerTrackRoleNode";
                                    readonly id: number;
                                    readonly title: string;
                                    readonly level: number;
                                  };
                                } | null;
                              }
                            | {
                                readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                                readonly talentIndicator?: {
                                  readonly __typename: "TalentIndicatorNode";
                                  readonly id: number;
                                  readonly talentIndicatorType: TalentIndicatorType;
                                } | null;
                              }
                            | {
                                readonly __typename: "TextAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              };
                        } | null;
                      } | null>;
                    };
                  } | null;
                } | null>;
              };
            } | null;
          } | null>;
        };
      } | null;
      readonly peerAssessmentTemplate?: {
        readonly __typename: "AssessmentTemplateNode";
        readonly id: number;
        readonly assessmentType: AssessmentType;
        readonly anonymity: AssessmentGroupAnonymity;
        readonly delivery: AssessmentGroupDelivery;
        readonly questionSets: {
          readonly __typename: "AssessmentGroupNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "AssessmentGroupNodeEdge";
            readonly node?: {
              readonly __typename: "AssessmentGroupNode";
              readonly id: number;
              readonly title: string;
              readonly sections: {
                readonly __typename: "AssessmentGroupSectionNodeConnection";
                readonly edges: ReadonlyArray<{
                  readonly __typename: "AssessmentGroupSectionNodeEdge";
                  readonly node?: {
                    readonly __typename: "AssessmentGroupSectionNode";
                    readonly id: number;
                    readonly title?: string | null;
                    readonly description?: any | null;
                    readonly subjectVisibility: AssessmentSectionSubjectVisibility;
                    readonly questions: {
                      readonly __typename: "AssessmentGroupQuestionContainerConnection";
                      readonly edges: ReadonlyArray<{
                        readonly __typename: "AssessmentGroupQuestionContainerEdge";
                        readonly node?: {
                          readonly __typename: "AssessmentGroupQuestionContainer";
                          readonly id: number;
                          readonly question:
                            | {
                                readonly __typename: "CompetencyAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                                readonly role: {
                                  readonly __typename: "CareerTrackRoleNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly level: number;
                                };
                                readonly competency: {
                                  readonly __typename: "CompetencyNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly criteria: {
                                    readonly __typename: "CompetencyCriteriaConnection";
                                    readonly edges: ReadonlyArray<{
                                      readonly __typename: "CompetencyCriteriaEdge";
                                      readonly node?: {
                                        readonly __typename: "CompetencyCriteriaNode";
                                        readonly id: number;
                                        readonly content: any;
                                      } | null;
                                    } | null>;
                                  };
                                };
                              }
                            | {
                                readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                                readonly role: {
                                  readonly __typename: "CareerTrackRoleNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly level: number;
                                };
                                readonly competencyCriteria: {
                                  readonly __typename: "CompetencyCriteriaNode";
                                  readonly id: number;
                                  readonly content: any;
                                  readonly competency: {
                                    readonly __typename: "CompetencyNode";
                                    readonly id: number;
                                    readonly title: string;
                                    readonly description: any;
                                  };
                                };
                              }
                            | {
                                readonly __typename: "IndividualGoalAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                                readonly goal?: {
                                  readonly __typename: "GoalArtifactNode";
                                  readonly id: number;
                                  readonly artifactType: ArtifactType;
                                  readonly startValue: number;
                                  readonly currentValue: number;
                                  readonly targetValue: number;
                                  readonly progress: number;
                                  readonly progressType: GoalProgressType;
                                  readonly dueDate?: string | null;
                                  readonly startDate?: string | null;
                                  readonly state: GoalState;
                                  readonly status: GoalStatus;
                                  readonly scope: GoalScope;
                                  readonly goalVisibility: GoalVisibility;
                                  readonly created: string;
                                  readonly parentGoalId?: number | null;
                                  readonly ownerCount?: number | null;
                                  readonly contributorCount?: number | null;
                                  readonly isStale: boolean;
                                  readonly title?: string | null;
                                  readonly updated?: string | null;
                                  readonly firstOwner?: {
                                    readonly __typename: "UserNode";
                                    readonly id: number;
                                    readonly avatar?: string | null;
                                    readonly name: string;
                                  } | null;
                                  readonly canDelete: {
                                    readonly __typename: "PermissionNode";
                                    readonly permission: boolean;
                                  };
                                  readonly canUpdate: {
                                    readonly __typename: "PermissionNode";
                                    readonly permission: boolean;
                                  };
                                  readonly canRead: {
                                    readonly __typename: "PermissionNode";
                                    readonly permission: boolean;
                                  };
                                  readonly creator?: {
                                    readonly __typename: "UserNode";
                                    readonly id: number;
                                    readonly name: string;
                                    readonly avatar?: string | null;
                                  } | null;
                                } | null;
                              }
                            | {
                                readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                                readonly coreValue?: {
                                  readonly __typename: "RecognitionCoreValueNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly description: string;
                                  readonly emoji?: string | null;
                                  readonly image?: string | null;
                                } | null;
                              }
                            | {
                                readonly __typename: "MultiChoiceAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly options: ReadonlyArray<string | null>;
                                readonly optionDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              }
                            | {
                                readonly __typename: "NpsAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              }
                            | {
                                readonly __typename: "OverallGoalAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              }
                            | {
                                readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              }
                            | {
                                readonly __typename: "RangeAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              }
                            | {
                                readonly __typename: "ResponsibilityAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                                readonly responsibility?: {
                                  readonly __typename: "CareerTrackRoleResponsibilityNode";
                                  readonly id: number;
                                  readonly content: any;
                                  readonly role: {
                                    readonly __typename: "CareerTrackRoleNode";
                                    readonly id: number;
                                    readonly title: string;
                                    readonly level: number;
                                  };
                                } | null;
                              }
                            | {
                                readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                                readonly talentIndicator?: {
                                  readonly __typename: "TalentIndicatorNode";
                                  readonly id: number;
                                  readonly talentIndicatorType: TalentIndicatorType;
                                } | null;
                              }
                            | {
                                readonly __typename: "TextAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              };
                        } | null;
                      } | null>;
                    };
                  } | null;
                } | null>;
              };
            } | null;
          } | null>;
        };
      } | null;
      readonly engagementSurveyTemplate?: {
        readonly __typename: "AssessmentTemplateNode";
        readonly id: number;
        readonly assessmentType: AssessmentType;
        readonly anonymity: AssessmentGroupAnonymity;
        readonly delivery: AssessmentGroupDelivery;
        readonly questionSets: {
          readonly __typename: "AssessmentGroupNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "AssessmentGroupNodeEdge";
            readonly node?: {
              readonly __typename: "AssessmentGroupNode";
              readonly id: number;
              readonly title: string;
              readonly sections: {
                readonly __typename: "AssessmentGroupSectionNodeConnection";
                readonly edges: ReadonlyArray<{
                  readonly __typename: "AssessmentGroupSectionNodeEdge";
                  readonly node?: {
                    readonly __typename: "AssessmentGroupSectionNode";
                    readonly id: number;
                    readonly title?: string | null;
                    readonly description?: any | null;
                    readonly subjectVisibility: AssessmentSectionSubjectVisibility;
                    readonly questions: {
                      readonly __typename: "AssessmentGroupQuestionContainerConnection";
                      readonly edges: ReadonlyArray<{
                        readonly __typename: "AssessmentGroupQuestionContainerEdge";
                        readonly node?: {
                          readonly __typename: "AssessmentGroupQuestionContainer";
                          readonly id: number;
                          readonly question:
                            | {
                                readonly __typename: "CompetencyAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                                readonly role: {
                                  readonly __typename: "CareerTrackRoleNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly level: number;
                                };
                                readonly competency: {
                                  readonly __typename: "CompetencyNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly criteria: {
                                    readonly __typename: "CompetencyCriteriaConnection";
                                    readonly edges: ReadonlyArray<{
                                      readonly __typename: "CompetencyCriteriaEdge";
                                      readonly node?: {
                                        readonly __typename: "CompetencyCriteriaNode";
                                        readonly id: number;
                                        readonly content: any;
                                      } | null;
                                    } | null>;
                                  };
                                };
                              }
                            | {
                                readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                                readonly role: {
                                  readonly __typename: "CareerTrackRoleNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly level: number;
                                };
                                readonly competencyCriteria: {
                                  readonly __typename: "CompetencyCriteriaNode";
                                  readonly id: number;
                                  readonly content: any;
                                  readonly competency: {
                                    readonly __typename: "CompetencyNode";
                                    readonly id: number;
                                    readonly title: string;
                                    readonly description: any;
                                  };
                                };
                              }
                            | {
                                readonly __typename: "IndividualGoalAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                                readonly goal?: {
                                  readonly __typename: "GoalArtifactNode";
                                  readonly id: number;
                                  readonly artifactType: ArtifactType;
                                  readonly startValue: number;
                                  readonly currentValue: number;
                                  readonly targetValue: number;
                                  readonly progress: number;
                                  readonly progressType: GoalProgressType;
                                  readonly dueDate?: string | null;
                                  readonly startDate?: string | null;
                                  readonly state: GoalState;
                                  readonly status: GoalStatus;
                                  readonly scope: GoalScope;
                                  readonly goalVisibility: GoalVisibility;
                                  readonly created: string;
                                  readonly parentGoalId?: number | null;
                                  readonly ownerCount?: number | null;
                                  readonly contributorCount?: number | null;
                                  readonly isStale: boolean;
                                  readonly title?: string | null;
                                  readonly updated?: string | null;
                                  readonly firstOwner?: {
                                    readonly __typename: "UserNode";
                                    readonly id: number;
                                    readonly avatar?: string | null;
                                    readonly name: string;
                                  } | null;
                                  readonly canDelete: {
                                    readonly __typename: "PermissionNode";
                                    readonly permission: boolean;
                                  };
                                  readonly canUpdate: {
                                    readonly __typename: "PermissionNode";
                                    readonly permission: boolean;
                                  };
                                  readonly canRead: {
                                    readonly __typename: "PermissionNode";
                                    readonly permission: boolean;
                                  };
                                  readonly creator?: {
                                    readonly __typename: "UserNode";
                                    readonly id: number;
                                    readonly name: string;
                                    readonly avatar?: string | null;
                                  } | null;
                                } | null;
                              }
                            | {
                                readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                                readonly coreValue?: {
                                  readonly __typename: "RecognitionCoreValueNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly description: string;
                                  readonly emoji?: string | null;
                                  readonly image?: string | null;
                                } | null;
                              }
                            | {
                                readonly __typename: "MultiChoiceAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly options: ReadonlyArray<string | null>;
                                readonly optionDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              }
                            | {
                                readonly __typename: "NpsAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              }
                            | {
                                readonly __typename: "OverallGoalAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              }
                            | {
                                readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              }
                            | {
                                readonly __typename: "RangeAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              }
                            | {
                                readonly __typename: "ResponsibilityAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                                readonly responsibility?: {
                                  readonly __typename: "CareerTrackRoleResponsibilityNode";
                                  readonly id: number;
                                  readonly content: any;
                                  readonly role: {
                                    readonly __typename: "CareerTrackRoleNode";
                                    readonly id: number;
                                    readonly title: string;
                                    readonly level: number;
                                  };
                                } | null;
                              }
                            | {
                                readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                                readonly talentIndicator?: {
                                  readonly __typename: "TalentIndicatorNode";
                                  readonly id: number;
                                  readonly talentIndicatorType: TalentIndicatorType;
                                } | null;
                              }
                            | {
                                readonly __typename: "TextAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              };
                        } | null;
                      } | null>;
                    };
                  } | null;
                } | null>;
              };
            } | null;
          } | null>;
        };
      } | null;
      readonly requiredTopicTemplates: {
        readonly __typename: "TopicTemplateNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "TopicTemplateNodeEdge";
          readonly node?: {
            readonly __typename: "TopicTemplateNode";
            readonly id: number;
          } | null;
        } | null>;
      };
      readonly participantStatus: {
        readonly __typename: "ParticipantStatusConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "ParticipantStatusEdge";
          readonly node?: {
            readonly __typename: "ParticipantStatusNode";
            readonly performanceAssessmentStatus: ComplianceProgramParticipantStatus;
            readonly performanceSelfAssessmentStatus: ComplianceProgramParticipantStatus;
            readonly managerAssessmentStatus: ComplianceProgramParticipantStatus;
            readonly managerSelfAssessmentStatus: ComplianceProgramParticipantStatus;
            readonly peerAssessmentStatus: ComplianceProgramParticipantStatus;
            readonly peerSelfAssessmentStatus: ComplianceProgramParticipantStatus;
            readonly user: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly email: string;
              readonly avatar?: string | null;
            };
          } | null;
        } | null>;
      };
    } | null;
    readonly additionalQuestionSets?: {
      readonly __typename: "ExtraAssessmentQuestionSetsByAssessmentTypeNode";
      readonly performance?: {
        readonly __typename: "AssessmentGroupConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentGroupEdge";
          readonly node?: {
            readonly __typename: "RoleBasedAssessmentGroupNode";
            readonly id: number;
            readonly title?: string | null;
            readonly sections?: {
              readonly __typename: "VirtualAssessmentSectionConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "VirtualAssessmentSectionEdge";
                readonly node?: {
                  readonly __typename: "VirtualAssessmentSectionNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly description?: any | null;
                  readonly subjectVisibility: AssessmentSectionSubjectVisibility;
                  readonly questions: {
                    readonly __typename: "AssessmentGroupQuestionContainerConnection";
                    readonly edges: ReadonlyArray<{
                      readonly __typename: "AssessmentGroupQuestionContainerEdge";
                      readonly node?: {
                        readonly __typename: "AssessmentGroupQuestionContainer";
                        readonly id: number;
                        readonly question:
                          | {
                              readonly __typename: "CompetencyAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly role: {
                                readonly __typename: "CareerTrackRoleNode";
                                readonly id: number;
                                readonly title: string;
                                readonly level: number;
                              };
                              readonly competency: {
                                readonly __typename: "CompetencyNode";
                                readonly id: number;
                                readonly title: string;
                                readonly criteria: {
                                  readonly __typename: "CompetencyCriteriaConnection";
                                  readonly edges: ReadonlyArray<{
                                    readonly __typename: "CompetencyCriteriaEdge";
                                    readonly node?: {
                                      readonly __typename: "CompetencyCriteriaNode";
                                      readonly id: number;
                                      readonly content: any;
                                    } | null;
                                  } | null>;
                                };
                              };
                            }
                          | {
                              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly role: {
                                readonly __typename: "CareerTrackRoleNode";
                                readonly id: number;
                                readonly title: string;
                                readonly level: number;
                              };
                              readonly competencyCriteria: {
                                readonly __typename: "CompetencyCriteriaNode";
                                readonly id: number;
                                readonly content: any;
                                readonly competency: {
                                  readonly __typename: "CompetencyNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly description: any;
                                };
                              };
                            }
                          | {
                              readonly __typename: "IndividualGoalAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly goal?: {
                                readonly __typename: "GoalArtifactNode";
                                readonly id: number;
                                readonly artifactType: ArtifactType;
                                readonly startValue: number;
                                readonly currentValue: number;
                                readonly targetValue: number;
                                readonly progress: number;
                                readonly progressType: GoalProgressType;
                                readonly dueDate?: string | null;
                                readonly startDate?: string | null;
                                readonly state: GoalState;
                                readonly status: GoalStatus;
                                readonly scope: GoalScope;
                                readonly goalVisibility: GoalVisibility;
                                readonly created: string;
                                readonly parentGoalId?: number | null;
                                readonly ownerCount?: number | null;
                                readonly contributorCount?: number | null;
                                readonly isStale: boolean;
                                readonly title?: string | null;
                                readonly updated?: string | null;
                                readonly firstOwner?: {
                                  readonly __typename: "UserNode";
                                  readonly id: number;
                                  readonly avatar?: string | null;
                                  readonly name: string;
                                } | null;
                                readonly canDelete: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly canUpdate: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly canRead: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly creator?: {
                                  readonly __typename: "UserNode";
                                  readonly id: number;
                                  readonly name: string;
                                  readonly avatar?: string | null;
                                } | null;
                              } | null;
                            }
                          | {
                              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly coreValue?: {
                                readonly __typename: "RecognitionCoreValueNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description: string;
                                readonly emoji?: string | null;
                                readonly image?: string | null;
                              } | null;
                            }
                          | {
                              readonly __typename: "MultiChoiceAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly options: ReadonlyArray<string | null>;
                              readonly optionDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "NpsAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "OverallGoalAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "RangeAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "ResponsibilityAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly responsibility?: {
                                readonly __typename: "CareerTrackRoleResponsibilityNode";
                                readonly id: number;
                                readonly content: any;
                                readonly role: {
                                  readonly __typename: "CareerTrackRoleNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly level: number;
                                };
                              } | null;
                            }
                          | {
                              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly talentIndicator?: {
                                readonly __typename: "TalentIndicatorNode";
                                readonly id: number;
                                readonly talentIndicatorType: TalentIndicatorType;
                              } | null;
                            }
                          | {
                              readonly __typename: "TextAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            };
                      } | null;
                    } | null>;
                  };
                } | null;
              } | null>;
            } | null;
          } | null;
        } | null>;
      } | null;
      readonly peer?: {
        readonly __typename: "AssessmentGroupConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentGroupEdge";
          readonly node?: {
            readonly __typename: "RoleBasedAssessmentGroupNode";
            readonly id: number;
            readonly title?: string | null;
            readonly sections?: {
              readonly __typename: "VirtualAssessmentSectionConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "VirtualAssessmentSectionEdge";
                readonly node?: {
                  readonly __typename: "VirtualAssessmentSectionNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly description?: any | null;
                  readonly subjectVisibility: AssessmentSectionSubjectVisibility;
                  readonly questions: {
                    readonly __typename: "AssessmentGroupQuestionContainerConnection";
                    readonly edges: ReadonlyArray<{
                      readonly __typename: "AssessmentGroupQuestionContainerEdge";
                      readonly node?: {
                        readonly __typename: "AssessmentGroupQuestionContainer";
                        readonly id: number;
                        readonly question:
                          | {
                              readonly __typename: "CompetencyAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly role: {
                                readonly __typename: "CareerTrackRoleNode";
                                readonly id: number;
                                readonly title: string;
                                readonly level: number;
                              };
                              readonly competency: {
                                readonly __typename: "CompetencyNode";
                                readonly id: number;
                                readonly title: string;
                                readonly criteria: {
                                  readonly __typename: "CompetencyCriteriaConnection";
                                  readonly edges: ReadonlyArray<{
                                    readonly __typename: "CompetencyCriteriaEdge";
                                    readonly node?: {
                                      readonly __typename: "CompetencyCriteriaNode";
                                      readonly id: number;
                                      readonly content: any;
                                    } | null;
                                  } | null>;
                                };
                              };
                            }
                          | {
                              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly role: {
                                readonly __typename: "CareerTrackRoleNode";
                                readonly id: number;
                                readonly title: string;
                                readonly level: number;
                              };
                              readonly competencyCriteria: {
                                readonly __typename: "CompetencyCriteriaNode";
                                readonly id: number;
                                readonly content: any;
                                readonly competency: {
                                  readonly __typename: "CompetencyNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly description: any;
                                };
                              };
                            }
                          | {
                              readonly __typename: "IndividualGoalAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly goal?: {
                                readonly __typename: "GoalArtifactNode";
                                readonly id: number;
                                readonly artifactType: ArtifactType;
                                readonly startValue: number;
                                readonly currentValue: number;
                                readonly targetValue: number;
                                readonly progress: number;
                                readonly progressType: GoalProgressType;
                                readonly dueDate?: string | null;
                                readonly startDate?: string | null;
                                readonly state: GoalState;
                                readonly status: GoalStatus;
                                readonly scope: GoalScope;
                                readonly goalVisibility: GoalVisibility;
                                readonly created: string;
                                readonly parentGoalId?: number | null;
                                readonly ownerCount?: number | null;
                                readonly contributorCount?: number | null;
                                readonly isStale: boolean;
                                readonly title?: string | null;
                                readonly updated?: string | null;
                                readonly firstOwner?: {
                                  readonly __typename: "UserNode";
                                  readonly id: number;
                                  readonly avatar?: string | null;
                                  readonly name: string;
                                } | null;
                                readonly canDelete: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly canUpdate: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly canRead: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly creator?: {
                                  readonly __typename: "UserNode";
                                  readonly id: number;
                                  readonly name: string;
                                  readonly avatar?: string | null;
                                } | null;
                              } | null;
                            }
                          | {
                              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly coreValue?: {
                                readonly __typename: "RecognitionCoreValueNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description: string;
                                readonly emoji?: string | null;
                                readonly image?: string | null;
                              } | null;
                            }
                          | {
                              readonly __typename: "MultiChoiceAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly options: ReadonlyArray<string | null>;
                              readonly optionDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "NpsAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "OverallGoalAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "RangeAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "ResponsibilityAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly responsibility?: {
                                readonly __typename: "CareerTrackRoleResponsibilityNode";
                                readonly id: number;
                                readonly content: any;
                                readonly role: {
                                  readonly __typename: "CareerTrackRoleNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly level: number;
                                };
                              } | null;
                            }
                          | {
                              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly talentIndicator?: {
                                readonly __typename: "TalentIndicatorNode";
                                readonly id: number;
                                readonly talentIndicatorType: TalentIndicatorType;
                              } | null;
                            }
                          | {
                              readonly __typename: "TextAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            };
                      } | null;
                    } | null>;
                  };
                } | null;
              } | null>;
            } | null;
          } | null;
        } | null>;
      } | null;
      readonly manager?: {
        readonly __typename: "AssessmentGroupConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentGroupEdge";
          readonly node?: {
            readonly __typename: "RoleBasedAssessmentGroupNode";
            readonly id: number;
            readonly title?: string | null;
            readonly sections?: {
              readonly __typename: "VirtualAssessmentSectionConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "VirtualAssessmentSectionEdge";
                readonly node?: {
                  readonly __typename: "VirtualAssessmentSectionNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly description?: any | null;
                  readonly subjectVisibility: AssessmentSectionSubjectVisibility;
                  readonly questions: {
                    readonly __typename: "AssessmentGroupQuestionContainerConnection";
                    readonly edges: ReadonlyArray<{
                      readonly __typename: "AssessmentGroupQuestionContainerEdge";
                      readonly node?: {
                        readonly __typename: "AssessmentGroupQuestionContainer";
                        readonly id: number;
                        readonly question:
                          | {
                              readonly __typename: "CompetencyAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly role: {
                                readonly __typename: "CareerTrackRoleNode";
                                readonly id: number;
                                readonly title: string;
                                readonly level: number;
                              };
                              readonly competency: {
                                readonly __typename: "CompetencyNode";
                                readonly id: number;
                                readonly title: string;
                                readonly criteria: {
                                  readonly __typename: "CompetencyCriteriaConnection";
                                  readonly edges: ReadonlyArray<{
                                    readonly __typename: "CompetencyCriteriaEdge";
                                    readonly node?: {
                                      readonly __typename: "CompetencyCriteriaNode";
                                      readonly id: number;
                                      readonly content: any;
                                    } | null;
                                  } | null>;
                                };
                              };
                            }
                          | {
                              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly role: {
                                readonly __typename: "CareerTrackRoleNode";
                                readonly id: number;
                                readonly title: string;
                                readonly level: number;
                              };
                              readonly competencyCriteria: {
                                readonly __typename: "CompetencyCriteriaNode";
                                readonly id: number;
                                readonly content: any;
                                readonly competency: {
                                  readonly __typename: "CompetencyNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly description: any;
                                };
                              };
                            }
                          | {
                              readonly __typename: "IndividualGoalAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly goal?: {
                                readonly __typename: "GoalArtifactNode";
                                readonly id: number;
                                readonly artifactType: ArtifactType;
                                readonly startValue: number;
                                readonly currentValue: number;
                                readonly targetValue: number;
                                readonly progress: number;
                                readonly progressType: GoalProgressType;
                                readonly dueDate?: string | null;
                                readonly startDate?: string | null;
                                readonly state: GoalState;
                                readonly status: GoalStatus;
                                readonly scope: GoalScope;
                                readonly goalVisibility: GoalVisibility;
                                readonly created: string;
                                readonly parentGoalId?: number | null;
                                readonly ownerCount?: number | null;
                                readonly contributorCount?: number | null;
                                readonly isStale: boolean;
                                readonly title?: string | null;
                                readonly updated?: string | null;
                                readonly firstOwner?: {
                                  readonly __typename: "UserNode";
                                  readonly id: number;
                                  readonly avatar?: string | null;
                                  readonly name: string;
                                } | null;
                                readonly canDelete: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly canUpdate: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly canRead: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly creator?: {
                                  readonly __typename: "UserNode";
                                  readonly id: number;
                                  readonly name: string;
                                  readonly avatar?: string | null;
                                } | null;
                              } | null;
                            }
                          | {
                              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly coreValue?: {
                                readonly __typename: "RecognitionCoreValueNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description: string;
                                readonly emoji?: string | null;
                                readonly image?: string | null;
                              } | null;
                            }
                          | {
                              readonly __typename: "MultiChoiceAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly options: ReadonlyArray<string | null>;
                              readonly optionDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "NpsAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "OverallGoalAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "RangeAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "ResponsibilityAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly responsibility?: {
                                readonly __typename: "CareerTrackRoleResponsibilityNode";
                                readonly id: number;
                                readonly content: any;
                                readonly role: {
                                  readonly __typename: "CareerTrackRoleNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly level: number;
                                };
                              } | null;
                            }
                          | {
                              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly talentIndicator?: {
                                readonly __typename: "TalentIndicatorNode";
                                readonly id: number;
                                readonly talentIndicatorType: TalentIndicatorType;
                              } | null;
                            }
                          | {
                              readonly __typename: "TextAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            };
                      } | null;
                    } | null>;
                  };
                } | null;
              } | null>;
            } | null;
          } | null;
        } | null>;
      } | null;
    } | null;
    readonly answers: {
      readonly __typename: "AssessmentAnswerConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AssessmentAnswerEdge";
        readonly node?:
          | {
              readonly __typename: "CompetencyAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
              readonly integerAnswer?: number | null;
              readonly comment?: any | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly email: string;
                readonly firstName: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "CompetencyCriteriaAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
              readonly integerAnswer?: number | null;
              readonly comment?: any | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly email: string;
                readonly firstName: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "IndividualGoalAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
              readonly integerAnswer?: number | null;
              readonly comment?: any | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly email: string;
                readonly firstName: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "IndividualRecognitionCoreValueAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
              readonly integerAnswer?: number | null;
              readonly comment?: any | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly email: string;
                readonly firstName: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "MultiChoiceAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
              readonly choices: ReadonlyArray<number | null>;
              readonly comment?: any | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly email: string;
                readonly firstName: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "NpsAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
              readonly integerAnswer?: number | null;
              readonly comment?: any | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly email: string;
                readonly firstName: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "OverallGoalAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
              readonly integerAnswer?: number | null;
              readonly comment?: any | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly email: string;
                readonly firstName: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "OverallRecognitionCoreValueAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
              readonly integerAnswer?: number | null;
              readonly comment?: any | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly email: string;
                readonly firstName: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "RangeAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
              readonly integerAnswer?: number | null;
              readonly comment?: any | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly email: string;
                readonly firstName: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "ResponsibilityAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
              readonly integerAnswer?: number | null;
              readonly comment?: any | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly email: string;
                readonly firstName: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "TalentIndicatorAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
              readonly integerAnswer?: number | null;
              readonly comment?: any | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly email: string;
                readonly firstName: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "TextAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
              readonly textAnswer?: any | null;
              readonly comment?: any | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly email: string;
                readonly firstName: string;
                readonly avatar?: string | null;
              } | null;
              readonly inferredSources?: {
                readonly __typename: "AnswerCitationConnection";
                readonly edges: ReadonlyArray<{
                  readonly __typename: "AnswerCitationEdge";
                  readonly node?: {
                    readonly __typename: "AnswerCitationNode";
                    readonly url: string;
                    readonly title: string;
                    readonly sourceId: string;
                    readonly sourceProvider: string;
                    readonly sourceType: string;
                    readonly contextText?: string | null;
                    readonly meeting?: {
                      readonly __typename: "MeetingNode";
                      readonly id: number;
                      readonly meetingGroupId: number;
                      readonly title?: string | null;
                      readonly startDatetime?: string | null;
                    } | null;
                    readonly assessment?: {
                      readonly __typename: "AssessmentNode";
                      readonly id: number;
                      readonly submittedDatetime?: string | null;
                      readonly responder?: {
                        readonly __typename: "UserNode";
                        readonly id: number;
                        readonly name: string;
                        readonly avatar?: string | null;
                      } | null;
                      readonly template: {
                        readonly __typename: "AssessmentTemplateNode";
                        readonly assessmentType: AssessmentType;
                      };
                      readonly target?: {
                        readonly __typename: "UserNode";
                        readonly id: number;
                      } | null;
                    } | null;
                  } | null;
                } | null>;
              } | null;
            }
          | null;
      } | null>;
    };
  } | null;
};

export type AssessmentGroupListFragmentFragment = {
  readonly __typename: "AssessmentGroupNode";
  readonly id: number;
  readonly title: string;
  readonly created: string;
  readonly archived: boolean;
  readonly assessmentType: AssessmentType;
  readonly isOnlySelfAssessment: boolean;
  readonly hasNpsQuestions: boolean;
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
  } | null;
  readonly canUpdate?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  } | null;
  readonly canDelete?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  } | null;
};

export type GetAssessmentGroupsListQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  archived?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type GetAssessmentGroupsListQuery = {
  readonly __typename: "Query";
  readonly assessmentGroups: {
    readonly __typename: "AssessmentGroupNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "AssessmentGroupNodeEdge";
      readonly node?: {
        readonly __typename: "AssessmentGroupNode";
        readonly id: number;
        readonly title: string;
        readonly created: string;
        readonly archived: boolean;
        readonly assessmentType: AssessmentType;
        readonly isOnlySelfAssessment: boolean;
        readonly hasNpsQuestions: boolean;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
        } | null;
        readonly canUpdate?: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
          readonly reason: string;
        } | null;
        readonly canDelete?: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
          readonly reason: string;
        } | null;
      } | null;
    } | null>;
  };
};

export type AssessmentNomineeResponderFragment = {
  readonly __typename: "UserNode";
  readonly id: number;
  readonly name: string;
  readonly avatar?: string | null;
  readonly activeAssessmentNominationCount: number;
};

export type AssessmentNomineeFragment = {
  readonly __typename: "AssessmentNominationNode";
  readonly id: number;
  readonly responder: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
    readonly activeAssessmentNominationCount: number;
  };
};

export type GetAssessmentProgramNomineesQueryVariables = Exact<{
  programId: Scalars["Int"]["input"];
  targetId: Scalars["Int"]["input"];
}>;

export type GetAssessmentProgramNomineesQuery = {
  readonly __typename: "Query";
  readonly complianceProgram?: {
    readonly __typename: "ComplianceProgramNode";
    readonly id: number;
    readonly nominationsForUser: {
      readonly __typename: "AssessmentNominationNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AssessmentNominationNodeEdge";
        readonly node?: {
          readonly __typename: "AssessmentNominationNode";
          readonly id: number;
          readonly responder: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
            readonly activeAssessmentNominationCount: number;
          };
        } | null;
      } | null>;
    };
  } | null;
};

type GetAssessmentAsessmentGroupSection_AssessmentGroupSectionNode_Fragment = {
  readonly __typename: "AssessmentGroupSectionNode";
  readonly id: number;
  readonly title?: string | null;
  readonly description?: any | null;
  readonly subjectVisibility: AssessmentSectionSubjectVisibility;
  readonly questions: {
    readonly __typename: "AssessmentGroupQuestionContainerConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "AssessmentGroupQuestionContainerEdge";
      readonly node?: {
        readonly __typename: "AssessmentGroupQuestionContainer";
        readonly id: number;
        readonly question:
          | {
              readonly __typename: "CompetencyAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
              readonly description?: any | null;
              readonly startValue: number;
              readonly endValue: number;
              readonly labels: ReadonlyArray<string | null>;
              readonly labelDescriptions: ReadonlyArray<string | null>;
              readonly comment: AssessmentQuestionComment;
              readonly isResponseMandatory: boolean;
              readonly responses: AssessmentQuestionResponses;
              readonly questionType: AssessmentQuestionType;
              readonly responseVisibility: AssessmentQuestionResponseVisibility;
              readonly role: {
                readonly __typename: "CareerTrackRoleNode";
                readonly id: number;
                readonly title: string;
                readonly level: number;
              };
              readonly competency: {
                readonly __typename: "CompetencyNode";
                readonly id: number;
                readonly title: string;
                readonly criteria: {
                  readonly __typename: "CompetencyCriteriaConnection";
                  readonly edges: ReadonlyArray<{
                    readonly __typename: "CompetencyCriteriaEdge";
                    readonly node?: {
                      readonly __typename: "CompetencyCriteriaNode";
                      readonly id: number;
                      readonly content: any;
                    } | null;
                  } | null>;
                };
              };
            }
          | {
              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
              readonly description?: any | null;
              readonly startValue: number;
              readonly endValue: number;
              readonly labels: ReadonlyArray<string | null>;
              readonly labelDescriptions: ReadonlyArray<string | null>;
              readonly comment: AssessmentQuestionComment;
              readonly isResponseMandatory: boolean;
              readonly responses: AssessmentQuestionResponses;
              readonly questionType: AssessmentQuestionType;
              readonly responseVisibility: AssessmentQuestionResponseVisibility;
              readonly role: {
                readonly __typename: "CareerTrackRoleNode";
                readonly id: number;
                readonly title: string;
                readonly level: number;
              };
              readonly competencyCriteria: {
                readonly __typename: "CompetencyCriteriaNode";
                readonly id: number;
                readonly content: any;
                readonly competency: {
                  readonly __typename: "CompetencyNode";
                  readonly id: number;
                  readonly title: string;
                  readonly description: any;
                };
              };
            }
          | {
              readonly __typename: "IndividualGoalAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
              readonly description?: any | null;
              readonly startValue: number;
              readonly endValue: number;
              readonly labels: ReadonlyArray<string | null>;
              readonly labelDescriptions: ReadonlyArray<string | null>;
              readonly comment: AssessmentQuestionComment;
              readonly isResponseMandatory: boolean;
              readonly responses: AssessmentQuestionResponses;
              readonly questionType: AssessmentQuestionType;
              readonly responseVisibility: AssessmentQuestionResponseVisibility;
              readonly goal?: {
                readonly __typename: "GoalArtifactNode";
                readonly id: number;
                readonly artifactType: ArtifactType;
                readonly startValue: number;
                readonly currentValue: number;
                readonly targetValue: number;
                readonly progress: number;
                readonly progressType: GoalProgressType;
                readonly dueDate?: string | null;
                readonly startDate?: string | null;
                readonly state: GoalState;
                readonly status: GoalStatus;
                readonly scope: GoalScope;
                readonly goalVisibility: GoalVisibility;
                readonly created: string;
                readonly parentGoalId?: number | null;
                readonly ownerCount?: number | null;
                readonly contributorCount?: number | null;
                readonly isStale: boolean;
                readonly title?: string | null;
                readonly updated?: string | null;
                readonly firstOwner?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly avatar?: string | null;
                  readonly name: string;
                } | null;
                readonly canDelete: {
                  readonly __typename: "PermissionNode";
                  readonly permission: boolean;
                };
                readonly canUpdate: {
                  readonly __typename: "PermissionNode";
                  readonly permission: boolean;
                };
                readonly canRead: {
                  readonly __typename: "PermissionNode";
                  readonly permission: boolean;
                };
                readonly creator?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly name: string;
                  readonly avatar?: string | null;
                } | null;
              } | null;
            }
          | {
              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
              readonly description?: any | null;
              readonly startValue: number;
              readonly endValue: number;
              readonly labels: ReadonlyArray<string | null>;
              readonly labelDescriptions: ReadonlyArray<string | null>;
              readonly comment: AssessmentQuestionComment;
              readonly isResponseMandatory: boolean;
              readonly responses: AssessmentQuestionResponses;
              readonly questionType: AssessmentQuestionType;
              readonly responseVisibility: AssessmentQuestionResponseVisibility;
              readonly coreValue?: {
                readonly __typename: "RecognitionCoreValueNode";
                readonly id: number;
                readonly title: string;
                readonly description: string;
                readonly emoji?: string | null;
                readonly image?: string | null;
              } | null;
            }
          | {
              readonly __typename: "MultiChoiceAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
              readonly description?: any | null;
              readonly options: ReadonlyArray<string | null>;
              readonly optionDescriptions: ReadonlyArray<string | null>;
              readonly comment: AssessmentQuestionComment;
              readonly isResponseMandatory: boolean;
              readonly responses: AssessmentQuestionResponses;
              readonly questionType: AssessmentQuestionType;
              readonly responseVisibility: AssessmentQuestionResponseVisibility;
            }
          | {
              readonly __typename: "NpsAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
              readonly description?: any | null;
              readonly comment: AssessmentQuestionComment;
              readonly isResponseMandatory: boolean;
              readonly responses: AssessmentQuestionResponses;
              readonly questionType: AssessmentQuestionType;
              readonly responseVisibility: AssessmentQuestionResponseVisibility;
            }
          | {
              readonly __typename: "OverallGoalAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
              readonly description?: any | null;
              readonly startValue: number;
              readonly endValue: number;
              readonly labels: ReadonlyArray<string | null>;
              readonly labelDescriptions: ReadonlyArray<string | null>;
              readonly comment: AssessmentQuestionComment;
              readonly isResponseMandatory: boolean;
              readonly responses: AssessmentQuestionResponses;
              readonly questionType: AssessmentQuestionType;
              readonly responseVisibility: AssessmentQuestionResponseVisibility;
            }
          | {
              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
              readonly description?: any | null;
              readonly startValue: number;
              readonly endValue: number;
              readonly labels: ReadonlyArray<string | null>;
              readonly labelDescriptions: ReadonlyArray<string | null>;
              readonly comment: AssessmentQuestionComment;
              readonly isResponseMandatory: boolean;
              readonly responses: AssessmentQuestionResponses;
              readonly questionType: AssessmentQuestionType;
              readonly responseVisibility: AssessmentQuestionResponseVisibility;
            }
          | {
              readonly __typename: "RangeAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
              readonly description?: any | null;
              readonly startValue: number;
              readonly endValue: number;
              readonly labels: ReadonlyArray<string | null>;
              readonly labelDescriptions: ReadonlyArray<string | null>;
              readonly comment: AssessmentQuestionComment;
              readonly isResponseMandatory: boolean;
              readonly responses: AssessmentQuestionResponses;
              readonly questionType: AssessmentQuestionType;
              readonly responseVisibility: AssessmentQuestionResponseVisibility;
            }
          | {
              readonly __typename: "ResponsibilityAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
              readonly description?: any | null;
              readonly startValue: number;
              readonly endValue: number;
              readonly labels: ReadonlyArray<string | null>;
              readonly labelDescriptions: ReadonlyArray<string | null>;
              readonly comment: AssessmentQuestionComment;
              readonly isResponseMandatory: boolean;
              readonly responses: AssessmentQuestionResponses;
              readonly questionType: AssessmentQuestionType;
              readonly responseVisibility: AssessmentQuestionResponseVisibility;
              readonly responsibility?: {
                readonly __typename: "CareerTrackRoleResponsibilityNode";
                readonly id: number;
                readonly content: any;
                readonly role: {
                  readonly __typename: "CareerTrackRoleNode";
                  readonly id: number;
                  readonly title: string;
                  readonly level: number;
                };
              } | null;
            }
          | {
              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
              readonly description?: any | null;
              readonly startValue: number;
              readonly endValue: number;
              readonly labels: ReadonlyArray<string | null>;
              readonly labelDescriptions: ReadonlyArray<string | null>;
              readonly comment: AssessmentQuestionComment;
              readonly isResponseMandatory: boolean;
              readonly responses: AssessmentQuestionResponses;
              readonly questionType: AssessmentQuestionType;
              readonly responseVisibility: AssessmentQuestionResponseVisibility;
              readonly talentIndicator?: {
                readonly __typename: "TalentIndicatorNode";
                readonly id: number;
                readonly talentIndicatorType: TalentIndicatorType;
              } | null;
            }
          | {
              readonly __typename: "TextAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
              readonly description?: any | null;
              readonly comment: AssessmentQuestionComment;
              readonly isResponseMandatory: boolean;
              readonly responses: AssessmentQuestionResponses;
              readonly questionType: AssessmentQuestionType;
              readonly responseVisibility: AssessmentQuestionResponseVisibility;
            };
      } | null;
    } | null>;
  };
};

type GetAssessmentAsessmentGroupSection_VirtualAssessmentSectionNode_Fragment =
  {
    readonly __typename: "VirtualAssessmentSectionNode";
    readonly id: number;
    readonly title?: string | null;
    readonly description?: any | null;
    readonly subjectVisibility: AssessmentSectionSubjectVisibility;
    readonly questions: {
      readonly __typename: "AssessmentGroupQuestionContainerConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AssessmentGroupQuestionContainerEdge";
        readonly node?: {
          readonly __typename: "AssessmentGroupQuestionContainer";
          readonly id: number;
          readonly question:
            | {
                readonly __typename: "CompetencyAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly role: {
                  readonly __typename: "CareerTrackRoleNode";
                  readonly id: number;
                  readonly title: string;
                  readonly level: number;
                };
                readonly competency: {
                  readonly __typename: "CompetencyNode";
                  readonly id: number;
                  readonly title: string;
                  readonly criteria: {
                    readonly __typename: "CompetencyCriteriaConnection";
                    readonly edges: ReadonlyArray<{
                      readonly __typename: "CompetencyCriteriaEdge";
                      readonly node?: {
                        readonly __typename: "CompetencyCriteriaNode";
                        readonly id: number;
                        readonly content: any;
                      } | null;
                    } | null>;
                  };
                };
              }
            | {
                readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly role: {
                  readonly __typename: "CareerTrackRoleNode";
                  readonly id: number;
                  readonly title: string;
                  readonly level: number;
                };
                readonly competencyCriteria: {
                  readonly __typename: "CompetencyCriteriaNode";
                  readonly id: number;
                  readonly content: any;
                  readonly competency: {
                    readonly __typename: "CompetencyNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description: any;
                  };
                };
              }
            | {
                readonly __typename: "IndividualGoalAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly goal?: {
                  readonly __typename: "GoalArtifactNode";
                  readonly id: number;
                  readonly artifactType: ArtifactType;
                  readonly startValue: number;
                  readonly currentValue: number;
                  readonly targetValue: number;
                  readonly progress: number;
                  readonly progressType: GoalProgressType;
                  readonly dueDate?: string | null;
                  readonly startDate?: string | null;
                  readonly state: GoalState;
                  readonly status: GoalStatus;
                  readonly scope: GoalScope;
                  readonly goalVisibility: GoalVisibility;
                  readonly created: string;
                  readonly parentGoalId?: number | null;
                  readonly ownerCount?: number | null;
                  readonly contributorCount?: number | null;
                  readonly isStale: boolean;
                  readonly title?: string | null;
                  readonly updated?: string | null;
                  readonly firstOwner?: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly avatar?: string | null;
                    readonly name: string;
                  } | null;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                  readonly canUpdate: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                  readonly canRead: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                  readonly creator?: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly name: string;
                    readonly avatar?: string | null;
                  } | null;
                } | null;
              }
            | {
                readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly coreValue?: {
                  readonly __typename: "RecognitionCoreValueNode";
                  readonly id: number;
                  readonly title: string;
                  readonly description: string;
                  readonly emoji?: string | null;
                  readonly image?: string | null;
                } | null;
              }
            | {
                readonly __typename: "MultiChoiceAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly options: ReadonlyArray<string | null>;
                readonly optionDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              }
            | {
                readonly __typename: "NpsAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              }
            | {
                readonly __typename: "OverallGoalAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              }
            | {
                readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              }
            | {
                readonly __typename: "RangeAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              }
            | {
                readonly __typename: "ResponsibilityAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly responsibility?: {
                  readonly __typename: "CareerTrackRoleResponsibilityNode";
                  readonly id: number;
                  readonly content: any;
                  readonly role: {
                    readonly __typename: "CareerTrackRoleNode";
                    readonly id: number;
                    readonly title: string;
                    readonly level: number;
                  };
                } | null;
              }
            | {
                readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly talentIndicator?: {
                  readonly __typename: "TalentIndicatorNode";
                  readonly id: number;
                  readonly talentIndicatorType: TalentIndicatorType;
                } | null;
              }
            | {
                readonly __typename: "TextAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              };
        } | null;
      } | null>;
    };
  };

export type GetAssessmentAsessmentGroupSectionFragment =
  | GetAssessmentAsessmentGroupSection_AssessmentGroupSectionNode_Fragment
  | GetAssessmentAsessmentGroupSection_VirtualAssessmentSectionNode_Fragment;

export type GetAssessmentQueryVariables = Exact<{
  assessmentId: Scalars["Int"]["input"];
  organizationId: Scalars["Int"]["input"];
}>;

export type GetAssessmentQuery = {
  readonly __typename: "Query";
  readonly assessment?: {
    readonly __typename: "AssessmentNode";
    readonly id: number;
    readonly state: AssessmentState;
    readonly submittedDatetime?: string | null;
    readonly periodStartDate?: string | null;
    readonly periodEndDate?: string | null;
    readonly dueDate?: string | null;
    readonly targetCurrentRoleIds: ReadonlyArray<number | null>;
    readonly targetPosition?: string | null;
    readonly canUpdate?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    } | null;
    readonly complianceProgram?: {
      readonly __typename: "ComplianceProgramNode";
      readonly id: number;
      readonly title: string;
      readonly periodStartDate?: string | null;
      readonly periodEndDate?: string | null;
      readonly calibration: ComplianceProgramCalibrationType;
      readonly canReadDetails: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
        readonly reason: string;
      };
    } | null;
    readonly template: {
      readonly __typename: "AssessmentTemplateNode";
      readonly id: number;
      readonly assessmentType: AssessmentType;
      readonly delivery: AssessmentGroupDelivery;
      readonly anonymity: AssessmentGroupAnonymity;
      readonly roleBasedAssessmentsAssessNextRole: boolean;
      readonly roleBasedAssessmentsSelfAssessNextRole: boolean;
      readonly questionSets: {
        readonly __typename: "AssessmentGroupNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentGroupNodeEdge";
          readonly node?: {
            readonly __typename: "AssessmentGroupNode";
            readonly id: number;
            readonly title: string;
            readonly sections: {
              readonly __typename: "AssessmentGroupSectionNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "AssessmentGroupSectionNodeEdge";
                readonly node?: {
                  readonly __typename: "AssessmentGroupSectionNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly description?: any | null;
                  readonly subjectVisibility: AssessmentSectionSubjectVisibility;
                  readonly questions: {
                    readonly __typename: "AssessmentGroupQuestionContainerConnection";
                    readonly edges: ReadonlyArray<{
                      readonly __typename: "AssessmentGroupQuestionContainerEdge";
                      readonly node?: {
                        readonly __typename: "AssessmentGroupQuestionContainer";
                        readonly id: number;
                        readonly question:
                          | {
                              readonly __typename: "CompetencyAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly role: {
                                readonly __typename: "CareerTrackRoleNode";
                                readonly id: number;
                                readonly title: string;
                                readonly level: number;
                              };
                              readonly competency: {
                                readonly __typename: "CompetencyNode";
                                readonly id: number;
                                readonly title: string;
                                readonly criteria: {
                                  readonly __typename: "CompetencyCriteriaConnection";
                                  readonly edges: ReadonlyArray<{
                                    readonly __typename: "CompetencyCriteriaEdge";
                                    readonly node?: {
                                      readonly __typename: "CompetencyCriteriaNode";
                                      readonly id: number;
                                      readonly content: any;
                                    } | null;
                                  } | null>;
                                };
                              };
                            }
                          | {
                              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly role: {
                                readonly __typename: "CareerTrackRoleNode";
                                readonly id: number;
                                readonly title: string;
                                readonly level: number;
                              };
                              readonly competencyCriteria: {
                                readonly __typename: "CompetencyCriteriaNode";
                                readonly id: number;
                                readonly content: any;
                                readonly competency: {
                                  readonly __typename: "CompetencyNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly description: any;
                                };
                              };
                            }
                          | {
                              readonly __typename: "IndividualGoalAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly goal?: {
                                readonly __typename: "GoalArtifactNode";
                                readonly id: number;
                                readonly artifactType: ArtifactType;
                                readonly startValue: number;
                                readonly currentValue: number;
                                readonly targetValue: number;
                                readonly progress: number;
                                readonly progressType: GoalProgressType;
                                readonly dueDate?: string | null;
                                readonly startDate?: string | null;
                                readonly state: GoalState;
                                readonly status: GoalStatus;
                                readonly scope: GoalScope;
                                readonly goalVisibility: GoalVisibility;
                                readonly created: string;
                                readonly parentGoalId?: number | null;
                                readonly ownerCount?: number | null;
                                readonly contributorCount?: number | null;
                                readonly isStale: boolean;
                                readonly title?: string | null;
                                readonly updated?: string | null;
                                readonly firstOwner?: {
                                  readonly __typename: "UserNode";
                                  readonly id: number;
                                  readonly avatar?: string | null;
                                  readonly name: string;
                                } | null;
                                readonly canDelete: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly canUpdate: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly canRead: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly creator?: {
                                  readonly __typename: "UserNode";
                                  readonly id: number;
                                  readonly name: string;
                                  readonly avatar?: string | null;
                                } | null;
                              } | null;
                            }
                          | {
                              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly coreValue?: {
                                readonly __typename: "RecognitionCoreValueNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description: string;
                                readonly emoji?: string | null;
                                readonly image?: string | null;
                              } | null;
                            }
                          | {
                              readonly __typename: "MultiChoiceAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly options: ReadonlyArray<string | null>;
                              readonly optionDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "NpsAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "OverallGoalAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "RangeAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "ResponsibilityAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly responsibility?: {
                                readonly __typename: "CareerTrackRoleResponsibilityNode";
                                readonly id: number;
                                readonly content: any;
                                readonly role: {
                                  readonly __typename: "CareerTrackRoleNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly level: number;
                                };
                              } | null;
                            }
                          | {
                              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly talentIndicator?: {
                                readonly __typename: "TalentIndicatorNode";
                                readonly id: number;
                                readonly talentIndicatorType: TalentIndicatorType;
                              } | null;
                            }
                          | {
                              readonly __typename: "TextAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            };
                      } | null;
                    } | null>;
                  };
                } | null;
              } | null>;
            };
          } | null;
        } | null>;
      };
    };
    readonly additionalQuestionSets?: {
      readonly __typename: "ExtraAssessmentQuestionSetsByAssessmentTypeNode";
      readonly performance?: {
        readonly __typename: "AssessmentGroupConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentGroupEdge";
          readonly node?: {
            readonly __typename: "RoleBasedAssessmentGroupNode";
            readonly id: number;
            readonly title?: string | null;
            readonly sections?: {
              readonly __typename: "VirtualAssessmentSectionConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "VirtualAssessmentSectionEdge";
                readonly node?: {
                  readonly __typename: "VirtualAssessmentSectionNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly description?: any | null;
                  readonly subjectVisibility: AssessmentSectionSubjectVisibility;
                  readonly questions: {
                    readonly __typename: "AssessmentGroupQuestionContainerConnection";
                    readonly edges: ReadonlyArray<{
                      readonly __typename: "AssessmentGroupQuestionContainerEdge";
                      readonly node?: {
                        readonly __typename: "AssessmentGroupQuestionContainer";
                        readonly id: number;
                        readonly question:
                          | {
                              readonly __typename: "CompetencyAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly role: {
                                readonly __typename: "CareerTrackRoleNode";
                                readonly id: number;
                                readonly title: string;
                                readonly level: number;
                              };
                              readonly competency: {
                                readonly __typename: "CompetencyNode";
                                readonly id: number;
                                readonly title: string;
                                readonly criteria: {
                                  readonly __typename: "CompetencyCriteriaConnection";
                                  readonly edges: ReadonlyArray<{
                                    readonly __typename: "CompetencyCriteriaEdge";
                                    readonly node?: {
                                      readonly __typename: "CompetencyCriteriaNode";
                                      readonly id: number;
                                      readonly content: any;
                                    } | null;
                                  } | null>;
                                };
                              };
                            }
                          | {
                              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly role: {
                                readonly __typename: "CareerTrackRoleNode";
                                readonly id: number;
                                readonly title: string;
                                readonly level: number;
                              };
                              readonly competencyCriteria: {
                                readonly __typename: "CompetencyCriteriaNode";
                                readonly id: number;
                                readonly content: any;
                                readonly competency: {
                                  readonly __typename: "CompetencyNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly description: any;
                                };
                              };
                            }
                          | {
                              readonly __typename: "IndividualGoalAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly goal?: {
                                readonly __typename: "GoalArtifactNode";
                                readonly id: number;
                                readonly artifactType: ArtifactType;
                                readonly startValue: number;
                                readonly currentValue: number;
                                readonly targetValue: number;
                                readonly progress: number;
                                readonly progressType: GoalProgressType;
                                readonly dueDate?: string | null;
                                readonly startDate?: string | null;
                                readonly state: GoalState;
                                readonly status: GoalStatus;
                                readonly scope: GoalScope;
                                readonly goalVisibility: GoalVisibility;
                                readonly created: string;
                                readonly parentGoalId?: number | null;
                                readonly ownerCount?: number | null;
                                readonly contributorCount?: number | null;
                                readonly isStale: boolean;
                                readonly title?: string | null;
                                readonly updated?: string | null;
                                readonly firstOwner?: {
                                  readonly __typename: "UserNode";
                                  readonly id: number;
                                  readonly avatar?: string | null;
                                  readonly name: string;
                                } | null;
                                readonly canDelete: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly canUpdate: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly canRead: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly creator?: {
                                  readonly __typename: "UserNode";
                                  readonly id: number;
                                  readonly name: string;
                                  readonly avatar?: string | null;
                                } | null;
                              } | null;
                            }
                          | {
                              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly coreValue?: {
                                readonly __typename: "RecognitionCoreValueNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description: string;
                                readonly emoji?: string | null;
                                readonly image?: string | null;
                              } | null;
                            }
                          | {
                              readonly __typename: "MultiChoiceAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly options: ReadonlyArray<string | null>;
                              readonly optionDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "NpsAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "OverallGoalAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "RangeAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "ResponsibilityAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly responsibility?: {
                                readonly __typename: "CareerTrackRoleResponsibilityNode";
                                readonly id: number;
                                readonly content: any;
                                readonly role: {
                                  readonly __typename: "CareerTrackRoleNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly level: number;
                                };
                              } | null;
                            }
                          | {
                              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly talentIndicator?: {
                                readonly __typename: "TalentIndicatorNode";
                                readonly id: number;
                                readonly talentIndicatorType: TalentIndicatorType;
                              } | null;
                            }
                          | {
                              readonly __typename: "TextAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            };
                      } | null;
                    } | null>;
                  };
                } | null;
              } | null>;
            } | null;
          } | null;
        } | null>;
      } | null;
      readonly peer?: {
        readonly __typename: "AssessmentGroupConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentGroupEdge";
          readonly node?: {
            readonly __typename: "RoleBasedAssessmentGroupNode";
            readonly id: number;
            readonly title?: string | null;
            readonly sections?: {
              readonly __typename: "VirtualAssessmentSectionConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "VirtualAssessmentSectionEdge";
                readonly node?: {
                  readonly __typename: "VirtualAssessmentSectionNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly description?: any | null;
                  readonly subjectVisibility: AssessmentSectionSubjectVisibility;
                  readonly questions: {
                    readonly __typename: "AssessmentGroupQuestionContainerConnection";
                    readonly edges: ReadonlyArray<{
                      readonly __typename: "AssessmentGroupQuestionContainerEdge";
                      readonly node?: {
                        readonly __typename: "AssessmentGroupQuestionContainer";
                        readonly id: number;
                        readonly question:
                          | {
                              readonly __typename: "CompetencyAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly role: {
                                readonly __typename: "CareerTrackRoleNode";
                                readonly id: number;
                                readonly title: string;
                                readonly level: number;
                              };
                              readonly competency: {
                                readonly __typename: "CompetencyNode";
                                readonly id: number;
                                readonly title: string;
                                readonly criteria: {
                                  readonly __typename: "CompetencyCriteriaConnection";
                                  readonly edges: ReadonlyArray<{
                                    readonly __typename: "CompetencyCriteriaEdge";
                                    readonly node?: {
                                      readonly __typename: "CompetencyCriteriaNode";
                                      readonly id: number;
                                      readonly content: any;
                                    } | null;
                                  } | null>;
                                };
                              };
                            }
                          | {
                              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly role: {
                                readonly __typename: "CareerTrackRoleNode";
                                readonly id: number;
                                readonly title: string;
                                readonly level: number;
                              };
                              readonly competencyCriteria: {
                                readonly __typename: "CompetencyCriteriaNode";
                                readonly id: number;
                                readonly content: any;
                                readonly competency: {
                                  readonly __typename: "CompetencyNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly description: any;
                                };
                              };
                            }
                          | {
                              readonly __typename: "IndividualGoalAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly goal?: {
                                readonly __typename: "GoalArtifactNode";
                                readonly id: number;
                                readonly artifactType: ArtifactType;
                                readonly startValue: number;
                                readonly currentValue: number;
                                readonly targetValue: number;
                                readonly progress: number;
                                readonly progressType: GoalProgressType;
                                readonly dueDate?: string | null;
                                readonly startDate?: string | null;
                                readonly state: GoalState;
                                readonly status: GoalStatus;
                                readonly scope: GoalScope;
                                readonly goalVisibility: GoalVisibility;
                                readonly created: string;
                                readonly parentGoalId?: number | null;
                                readonly ownerCount?: number | null;
                                readonly contributorCount?: number | null;
                                readonly isStale: boolean;
                                readonly title?: string | null;
                                readonly updated?: string | null;
                                readonly firstOwner?: {
                                  readonly __typename: "UserNode";
                                  readonly id: number;
                                  readonly avatar?: string | null;
                                  readonly name: string;
                                } | null;
                                readonly canDelete: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly canUpdate: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly canRead: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly creator?: {
                                  readonly __typename: "UserNode";
                                  readonly id: number;
                                  readonly name: string;
                                  readonly avatar?: string | null;
                                } | null;
                              } | null;
                            }
                          | {
                              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly coreValue?: {
                                readonly __typename: "RecognitionCoreValueNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description: string;
                                readonly emoji?: string | null;
                                readonly image?: string | null;
                              } | null;
                            }
                          | {
                              readonly __typename: "MultiChoiceAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly options: ReadonlyArray<string | null>;
                              readonly optionDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "NpsAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "OverallGoalAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "RangeAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "ResponsibilityAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly responsibility?: {
                                readonly __typename: "CareerTrackRoleResponsibilityNode";
                                readonly id: number;
                                readonly content: any;
                                readonly role: {
                                  readonly __typename: "CareerTrackRoleNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly level: number;
                                };
                              } | null;
                            }
                          | {
                              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly talentIndicator?: {
                                readonly __typename: "TalentIndicatorNode";
                                readonly id: number;
                                readonly talentIndicatorType: TalentIndicatorType;
                              } | null;
                            }
                          | {
                              readonly __typename: "TextAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            };
                      } | null;
                    } | null>;
                  };
                } | null;
              } | null>;
            } | null;
          } | null;
        } | null>;
      } | null;
      readonly manager?: {
        readonly __typename: "AssessmentGroupConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentGroupEdge";
          readonly node?: {
            readonly __typename: "RoleBasedAssessmentGroupNode";
            readonly id: number;
            readonly title?: string | null;
            readonly sections?: {
              readonly __typename: "VirtualAssessmentSectionConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "VirtualAssessmentSectionEdge";
                readonly node?: {
                  readonly __typename: "VirtualAssessmentSectionNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly description?: any | null;
                  readonly subjectVisibility: AssessmentSectionSubjectVisibility;
                  readonly questions: {
                    readonly __typename: "AssessmentGroupQuestionContainerConnection";
                    readonly edges: ReadonlyArray<{
                      readonly __typename: "AssessmentGroupQuestionContainerEdge";
                      readonly node?: {
                        readonly __typename: "AssessmentGroupQuestionContainer";
                        readonly id: number;
                        readonly question:
                          | {
                              readonly __typename: "CompetencyAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly role: {
                                readonly __typename: "CareerTrackRoleNode";
                                readonly id: number;
                                readonly title: string;
                                readonly level: number;
                              };
                              readonly competency: {
                                readonly __typename: "CompetencyNode";
                                readonly id: number;
                                readonly title: string;
                                readonly criteria: {
                                  readonly __typename: "CompetencyCriteriaConnection";
                                  readonly edges: ReadonlyArray<{
                                    readonly __typename: "CompetencyCriteriaEdge";
                                    readonly node?: {
                                      readonly __typename: "CompetencyCriteriaNode";
                                      readonly id: number;
                                      readonly content: any;
                                    } | null;
                                  } | null>;
                                };
                              };
                            }
                          | {
                              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly role: {
                                readonly __typename: "CareerTrackRoleNode";
                                readonly id: number;
                                readonly title: string;
                                readonly level: number;
                              };
                              readonly competencyCriteria: {
                                readonly __typename: "CompetencyCriteriaNode";
                                readonly id: number;
                                readonly content: any;
                                readonly competency: {
                                  readonly __typename: "CompetencyNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly description: any;
                                };
                              };
                            }
                          | {
                              readonly __typename: "IndividualGoalAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly goal?: {
                                readonly __typename: "GoalArtifactNode";
                                readonly id: number;
                                readonly artifactType: ArtifactType;
                                readonly startValue: number;
                                readonly currentValue: number;
                                readonly targetValue: number;
                                readonly progress: number;
                                readonly progressType: GoalProgressType;
                                readonly dueDate?: string | null;
                                readonly startDate?: string | null;
                                readonly state: GoalState;
                                readonly status: GoalStatus;
                                readonly scope: GoalScope;
                                readonly goalVisibility: GoalVisibility;
                                readonly created: string;
                                readonly parentGoalId?: number | null;
                                readonly ownerCount?: number | null;
                                readonly contributorCount?: number | null;
                                readonly isStale: boolean;
                                readonly title?: string | null;
                                readonly updated?: string | null;
                                readonly firstOwner?: {
                                  readonly __typename: "UserNode";
                                  readonly id: number;
                                  readonly avatar?: string | null;
                                  readonly name: string;
                                } | null;
                                readonly canDelete: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly canUpdate: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly canRead: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly creator?: {
                                  readonly __typename: "UserNode";
                                  readonly id: number;
                                  readonly name: string;
                                  readonly avatar?: string | null;
                                } | null;
                              } | null;
                            }
                          | {
                              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly coreValue?: {
                                readonly __typename: "RecognitionCoreValueNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description: string;
                                readonly emoji?: string | null;
                                readonly image?: string | null;
                              } | null;
                            }
                          | {
                              readonly __typename: "MultiChoiceAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly options: ReadonlyArray<string | null>;
                              readonly optionDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "NpsAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "OverallGoalAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "RangeAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "ResponsibilityAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly responsibility?: {
                                readonly __typename: "CareerTrackRoleResponsibilityNode";
                                readonly id: number;
                                readonly content: any;
                                readonly role: {
                                  readonly __typename: "CareerTrackRoleNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly level: number;
                                };
                              } | null;
                            }
                          | {
                              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly talentIndicator?: {
                                readonly __typename: "TalentIndicatorNode";
                                readonly id: number;
                                readonly talentIndicatorType: TalentIndicatorType;
                              } | null;
                            }
                          | {
                              readonly __typename: "TextAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            };
                      } | null;
                    } | null>;
                  };
                } | null;
              } | null>;
            } | null;
          } | null;
        } | null>;
      } | null;
    } | null;
    readonly responder?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly avatar?: string | null;
    } | null;
    readonly target?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly email: string;
      readonly firstName: string;
      readonly avatar?: string | null;
      readonly organizationSpecificInfo?: {
        readonly __typename: "UserMemberNode";
        readonly jobLevel?: string | null;
        readonly startDate?: string | null;
      } | null;
      readonly managersList: ReadonlyArray<{
        readonly __typename: "UserNode";
        readonly id: number;
      }>;
    } | null;
    readonly answers: ReadonlyArray<
      | {
          readonly __typename: "CompetencyAssessmentAnswerNode";
          readonly id: number;
          readonly questionId: number;
          readonly integerAnswer?: number | null;
          readonly comment?: any | null;
          readonly isLocked: boolean;
        }
      | {
          readonly __typename: "CompetencyCriteriaAssessmentAnswerNode";
          readonly id: number;
          readonly questionId: number;
          readonly integerAnswer?: number | null;
          readonly comment?: any | null;
          readonly isLocked: boolean;
        }
      | {
          readonly __typename: "IndividualGoalAssessmentAnswerNode";
          readonly id: number;
          readonly questionId: number;
          readonly integerAnswer?: number | null;
          readonly comment?: any | null;
          readonly isLocked: boolean;
        }
      | {
          readonly __typename: "IndividualRecognitionCoreValueAssessmentAnswerNode";
          readonly id: number;
          readonly questionId: number;
          readonly integerAnswer?: number | null;
          readonly comment?: any | null;
          readonly isLocked: boolean;
        }
      | {
          readonly __typename: "MultiChoiceAssessmentAnswerNode";
          readonly id: number;
          readonly questionId: number;
          readonly choices: ReadonlyArray<number | null>;
          readonly comment?: any | null;
          readonly isLocked: boolean;
        }
      | {
          readonly __typename: "NpsAssessmentAnswerNode";
          readonly id: number;
          readonly questionId: number;
          readonly integerAnswer?: number | null;
          readonly comment?: any | null;
          readonly isLocked: boolean;
        }
      | {
          readonly __typename: "OverallGoalAssessmentAnswerNode";
          readonly id: number;
          readonly questionId: number;
          readonly integerAnswer?: number | null;
          readonly comment?: any | null;
          readonly isLocked: boolean;
        }
      | {
          readonly __typename: "OverallRecognitionCoreValueAssessmentAnswerNode";
          readonly id: number;
          readonly questionId: number;
          readonly integerAnswer?: number | null;
          readonly comment?: any | null;
          readonly isLocked: boolean;
        }
      | {
          readonly __typename: "RangeAssessmentAnswerNode";
          readonly id: number;
          readonly questionId: number;
          readonly integerAnswer?: number | null;
          readonly comment?: any | null;
          readonly isLocked: boolean;
        }
      | {
          readonly __typename: "ResponsibilityAssessmentAnswerNode";
          readonly id: number;
          readonly questionId: number;
          readonly integerAnswer?: number | null;
          readonly comment?: any | null;
          readonly isLocked: boolean;
        }
      | {
          readonly __typename: "TalentIndicatorAssessmentAnswerNode";
          readonly id: number;
          readonly questionId: number;
          readonly integerAnswer?: number | null;
          readonly comment?: any | null;
          readonly isLocked: boolean;
        }
      | {
          readonly __typename: "TextAssessmentAnswerNode";
          readonly id: number;
          readonly questionId: number;
          readonly textAnswer?: any | null;
          readonly comment?: any | null;
          readonly isLocked: boolean;
        }
      | null
    >;
    readonly otherParticipantsAnswers: {
      readonly __typename: "AssessmentAnswerConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AssessmentAnswerEdge";
        readonly node?:
          | {
              readonly __typename: "CompetencyAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
              readonly integerAnswer?: number | null;
              readonly comment?: any | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "CompetencyCriteriaAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
              readonly integerAnswer?: number | null;
              readonly comment?: any | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "IndividualGoalAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
              readonly integerAnswer?: number | null;
              readonly comment?: any | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "IndividualRecognitionCoreValueAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
              readonly integerAnswer?: number | null;
              readonly comment?: any | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "MultiChoiceAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
              readonly choices: ReadonlyArray<number | null>;
              readonly comment?: any | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "NpsAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
              readonly integerAnswer?: number | null;
              readonly comment?: any | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "OverallGoalAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
              readonly integerAnswer?: number | null;
              readonly comment?: any | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "OverallRecognitionCoreValueAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
              readonly integerAnswer?: number | null;
              readonly comment?: any | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "RangeAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
              readonly integerAnswer?: number | null;
              readonly comment?: any | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "ResponsibilityAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
              readonly integerAnswer?: number | null;
              readonly comment?: any | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "TalentIndicatorAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
              readonly integerAnswer?: number | null;
              readonly comment?: any | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "TextAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
              readonly textAnswer?: any | null;
              readonly comment?: any | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            }
          | null;
      } | null>;
    };
    readonly relatedMeetings: {
      readonly __typename: "MeetingNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "MeetingNodeEdge";
        readonly node?: {
          readonly __typename: "MeetingNode";
          readonly id: number;
          readonly title?: string | null;
          readonly meetingGroupId: number;
          readonly startDatetime?: string | null;
          readonly endDatetime?: string | null;
          readonly draft: boolean;
        } | null;
      } | null>;
    };
    readonly mostRecentAnswers?: ReadonlyArray<{
      readonly __typename: "MostRecentAssessmentAnswerNode";
      readonly questionId: number;
      readonly questionType: AssessmentQuestionType;
      readonly integerAnswer: number;
      readonly submitted: string;
    } | null> | null;
  } | null;
};

export type GetAssessmentQuestionQueryVariables = Exact<{
  questionId: Scalars["Int"]["input"];
}>;

export type GetAssessmentQuestionQuery = {
  readonly __typename: "Query";
  readonly assessmentQuestion?:
    | {
        readonly __typename: "CompetencyAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
        readonly description?: any | null;
      }
    | {
        readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
        readonly description?: any | null;
      }
    | {
        readonly __typename: "IndividualGoalAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
        readonly description?: any | null;
      }
    | {
        readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
        readonly description?: any | null;
      }
    | {
        readonly __typename: "MultiChoiceAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
        readonly description?: any | null;
      }
    | {
        readonly __typename: "NpsAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
        readonly description?: any | null;
      }
    | {
        readonly __typename: "OverallGoalAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
        readonly description?: any | null;
      }
    | {
        readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
        readonly description?: any | null;
      }
    | {
        readonly __typename: "RangeAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
        readonly description?: any | null;
      }
    | {
        readonly __typename: "ResponsibilityAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
        readonly description?: any | null;
      }
    | {
        readonly __typename: "TalentIndicatorAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
        readonly description?: any | null;
      }
    | {
        readonly __typename: "TextAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
        readonly description?: any | null;
      }
    | null;
};

export type AssessmentSuggestionCitationFragment = {
  readonly __typename: "AnswerCitationNode";
  readonly sourceId: string;
  readonly sourceType: string;
  readonly title: string;
  readonly url: string;
  readonly date?: string | null;
  readonly sourceProvider: string;
  readonly contextText?: string | null;
};

export type AssessmentSuggestionFragment = {
  readonly __typename: "SuggestionItemNode";
  readonly title: string;
  readonly text: string;
  readonly citations?: {
    readonly __typename: "AnswerCitationConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "AnswerCitationEdge";
      readonly node?: {
        readonly __typename: "AnswerCitationNode";
        readonly sourceId: string;
        readonly sourceType: string;
        readonly title: string;
        readonly url: string;
        readonly date?: string | null;
        readonly sourceProvider: string;
        readonly contextText?: string | null;
      } | null;
    } | null>;
  } | null;
};

export type AssessmentSuggestedAnswerFragment = {
  readonly __typename: "SuggestedQuestionNode";
  readonly questionId?: number | null;
  readonly questionText?: string | null;
  readonly suggestions?: {
    readonly __typename: "SuggestionItemConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "SuggestionItemEdge";
      readonly node?: {
        readonly __typename: "SuggestionItemNode";
        readonly title: string;
        readonly text: string;
        readonly citations?: {
          readonly __typename: "AnswerCitationConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "AnswerCitationEdge";
            readonly node?: {
              readonly __typename: "AnswerCitationNode";
              readonly sourceId: string;
              readonly sourceType: string;
              readonly title: string;
              readonly url: string;
              readonly date?: string | null;
              readonly sourceProvider: string;
              readonly contextText?: string | null;
            } | null;
          } | null>;
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type GetAssessmentSuggestedAnswersQueryVariables = Exact<{
  assessmentId: Scalars["Int"]["input"];
}>;

export type GetAssessmentSuggestedAnswersQuery = {
  readonly __typename: "Query";
  readonly assessment?: {
    readonly __typename: "AssessmentNode";
    readonly id: number;
    readonly suggestedAnswers?: {
      readonly __typename: "SuggestedQuestionConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "SuggestedQuestionEdge";
        readonly node?: {
          readonly __typename: "SuggestedQuestionNode";
          readonly questionId?: number | null;
          readonly questionText?: string | null;
          readonly suggestions?: {
            readonly __typename: "SuggestionItemConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "SuggestionItemEdge";
              readonly node?: {
                readonly __typename: "SuggestionItemNode";
                readonly title: string;
                readonly text: string;
                readonly citations?: {
                  readonly __typename: "AnswerCitationConnection";
                  readonly edges: ReadonlyArray<{
                    readonly __typename: "AnswerCitationEdge";
                    readonly node?: {
                      readonly __typename: "AnswerCitationNode";
                      readonly sourceId: string;
                      readonly sourceType: string;
                      readonly title: string;
                      readonly url: string;
                      readonly date?: string | null;
                      readonly sourceProvider: string;
                      readonly contextText?: string | null;
                    } | null;
                  } | null>;
                } | null;
              } | null;
            } | null>;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetChatSessionsForAssessmentQueryQueryVariables = Exact<{
  assessmentId: Scalars["Int"]["input"];
}>;

export type GetChatSessionsForAssessmentQueryQuery = {
  readonly __typename: "Query";
  readonly assessment?: {
    readonly __typename: "AssessmentNode";
    readonly id: number;
    readonly suggestedAnswersState?: SuggestedAnswerState | null;
  } | null;
  readonly chatSessions?: {
    readonly __typename: "ChatSessionNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "ChatSessionNodeEdge";
      readonly node?: {
        readonly __typename: "ChatSessionNode";
        readonly id: number;
        readonly assessmentQuestionId?: number | null;
      } | null;
    } | null>;
  } | null;
};

export type RoleBasedAssessmentGoalFragmentFragment = {
  readonly __typename: "GoalArtifactNode";
  readonly id: number;
  readonly artifactType: ArtifactType;
  readonly startValue: number;
  readonly currentValue: number;
  readonly targetValue: number;
  readonly progress: number;
  readonly progressType: GoalProgressType;
  readonly dueDate?: string | null;
  readonly startDate?: string | null;
  readonly state: GoalState;
  readonly status: GoalStatus;
  readonly scope: GoalScope;
  readonly goalVisibility: GoalVisibility;
  readonly created: string;
  readonly parentGoalId?: number | null;
  readonly ownerCount?: number | null;
  readonly contributorCount?: number | null;
  readonly isStale: boolean;
  readonly title?: string | null;
  readonly updated?: string | null;
  readonly competencyRelations: {
    readonly __typename: "GoalArtifactToCompetencyM2MNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "GoalArtifactToCompetencyM2MNodeEdge";
      readonly node?: {
        readonly __typename: "GoalArtifactToCompetencyM2MNode";
        readonly id: number;
        readonly competencyId: number;
        readonly roleId?: number | null;
      } | null;
    } | null>;
  };
  readonly firstOwner?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly avatar?: string | null;
    readonly name: string;
  } | null;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canRead: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
};

export type GetDevelopmentGoalsRelatedToCompetenciesQueryQueryVariables =
  Exact<{
    roleId: Scalars["Int"]["input"];
    profileId: Scalars["Int"]["input"];
    competencyIds:
      | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
      | InputMaybe<Scalars["Int"]["input"]>;
  }>;

export type GetDevelopmentGoalsRelatedToCompetenciesQueryQuery = {
  readonly __typename: "Query";
  readonly careerRole?: {
    readonly __typename: "CareerTrackRoleNode";
    readonly id: number;
    readonly developmentGoals?: {
      readonly __typename: "GoalArtifactConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "GoalArtifactEdge";
        readonly node?: {
          readonly __typename: "GoalArtifactNode";
          readonly id: number;
          readonly artifactType: ArtifactType;
          readonly startValue: number;
          readonly currentValue: number;
          readonly targetValue: number;
          readonly progress: number;
          readonly progressType: GoalProgressType;
          readonly dueDate?: string | null;
          readonly startDate?: string | null;
          readonly state: GoalState;
          readonly status: GoalStatus;
          readonly scope: GoalScope;
          readonly goalVisibility: GoalVisibility;
          readonly created: string;
          readonly parentGoalId?: number | null;
          readonly ownerCount?: number | null;
          readonly contributorCount?: number | null;
          readonly isStale: boolean;
          readonly title?: string | null;
          readonly updated?: string | null;
          readonly competencyRelations: {
            readonly __typename: "GoalArtifactToCompetencyM2MNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "GoalArtifactToCompetencyM2MNodeEdge";
              readonly node?: {
                readonly __typename: "GoalArtifactToCompetencyM2MNode";
                readonly id: number;
                readonly competencyId: number;
                readonly roleId?: number | null;
              } | null;
            } | null>;
          };
          readonly firstOwner?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly avatar?: string | null;
            readonly name: string;
          } | null;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canUpdate: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canRead: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly creator?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type UnmetComplainceProgramAssessmentTemplateFragment = {
  readonly __typename: "AssessmentTemplateNode";
  readonly id: number;
  readonly assessmentType: AssessmentType;
};

export type UnmetComplianceProgramFragment = {
  readonly __typename: "ComplianceProgramNode";
  readonly id: number;
  readonly title: string;
  readonly dueDate?: string | null;
  readonly canReadDetails: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  };
  readonly usersMissingAssessment: {
    readonly __typename: "MissingAssessmentConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "MissingAssessmentEdge";
      readonly node?: {
        readonly __typename: "MissingAssessmentNode";
        readonly assessmentTemplateId?: number | null;
        readonly dueDate: string;
        readonly target?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly responder: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        };
      } | null;
    } | null>;
  };
  readonly performanceAssessmentTemplate?: {
    readonly __typename: "AssessmentTemplateNode";
    readonly id: number;
    readonly assessmentType: AssessmentType;
  } | null;
  readonly managerAssessmentTemplate?: {
    readonly __typename: "AssessmentTemplateNode";
    readonly id: number;
    readonly assessmentType: AssessmentType;
  } | null;
  readonly peerAssessmentTemplate?: {
    readonly __typename: "AssessmentTemplateNode";
    readonly id: number;
    readonly assessmentType: AssessmentType;
  } | null;
  readonly assessments: {
    readonly __typename: "AssessmentNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "AssessmentNodeEdge";
      readonly node?: {
        readonly __typename: "AssessmentNode";
        readonly id: number;
        readonly state: AssessmentState;
        readonly assessmentDeliveryState?: AssessmentDeliveryState | null;
        readonly dueDate?: string | null;
        readonly submittedDatetime?: string | null;
        readonly target?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly responder?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly template: {
          readonly __typename: "AssessmentTemplateNode";
          readonly id: number;
        };
      } | null;
    } | null>;
  };
};

export type GetMyAssessmentsQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  currentUserId: Scalars["Int"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  afterPerformance?: InputMaybe<Scalars["String"]["input"]>;
  afterPeer?: InputMaybe<Scalars["String"]["input"]>;
  afterManager?: InputMaybe<Scalars["String"]["input"]>;
  orderBy: Scalars["String"]["input"];
}>;

export type GetMyAssessmentsQuery = {
  readonly __typename: "Query";
  readonly unmetPerformanceAssessmentCompliancePrograms: {
    readonly __typename: "ComplianceProgramNodeConnection";
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly endCursor?: string | null;
      readonly hasNextPage: boolean;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "ComplianceProgramNodeEdge";
      readonly node?: {
        readonly __typename: "ComplianceProgramNode";
        readonly id: number;
        readonly title: string;
        readonly dueDate?: string | null;
        readonly canReadDetails: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
          readonly reason: string;
        };
        readonly usersMissingAssessment: {
          readonly __typename: "MissingAssessmentConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "MissingAssessmentEdge";
            readonly node?: {
              readonly __typename: "MissingAssessmentNode";
              readonly assessmentTemplateId?: number | null;
              readonly dueDate: string;
              readonly target?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly responder: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              };
            } | null;
          } | null>;
        };
        readonly performanceAssessmentTemplate?: {
          readonly __typename: "AssessmentTemplateNode";
          readonly id: number;
          readonly assessmentType: AssessmentType;
        } | null;
        readonly managerAssessmentTemplate?: {
          readonly __typename: "AssessmentTemplateNode";
          readonly id: number;
          readonly assessmentType: AssessmentType;
        } | null;
        readonly peerAssessmentTemplate?: {
          readonly __typename: "AssessmentTemplateNode";
          readonly id: number;
          readonly assessmentType: AssessmentType;
        } | null;
        readonly assessments: {
          readonly __typename: "AssessmentNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "AssessmentNodeEdge";
            readonly node?: {
              readonly __typename: "AssessmentNode";
              readonly id: number;
              readonly state: AssessmentState;
              readonly assessmentDeliveryState?: AssessmentDeliveryState | null;
              readonly dueDate?: string | null;
              readonly submittedDatetime?: string | null;
              readonly target?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly template: {
                readonly __typename: "AssessmentTemplateNode";
                readonly id: number;
              };
            } | null;
          } | null>;
        };
      } | null;
    } | null>;
  };
  readonly unmetPeerAssessmentCompliancePrograms: {
    readonly __typename: "ComplianceProgramNodeConnection";
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly endCursor?: string | null;
      readonly hasNextPage: boolean;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "ComplianceProgramNodeEdge";
      readonly node?: {
        readonly __typename: "ComplianceProgramNode";
        readonly id: number;
        readonly title: string;
        readonly dueDate?: string | null;
        readonly canReadDetails: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
          readonly reason: string;
        };
        readonly usersMissingAssessment: {
          readonly __typename: "MissingAssessmentConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "MissingAssessmentEdge";
            readonly node?: {
              readonly __typename: "MissingAssessmentNode";
              readonly assessmentTemplateId?: number | null;
              readonly dueDate: string;
              readonly target?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly responder: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              };
            } | null;
          } | null>;
        };
        readonly performanceAssessmentTemplate?: {
          readonly __typename: "AssessmentTemplateNode";
          readonly id: number;
          readonly assessmentType: AssessmentType;
        } | null;
        readonly managerAssessmentTemplate?: {
          readonly __typename: "AssessmentTemplateNode";
          readonly id: number;
          readonly assessmentType: AssessmentType;
        } | null;
        readonly peerAssessmentTemplate?: {
          readonly __typename: "AssessmentTemplateNode";
          readonly id: number;
          readonly assessmentType: AssessmentType;
        } | null;
        readonly assessments: {
          readonly __typename: "AssessmentNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "AssessmentNodeEdge";
            readonly node?: {
              readonly __typename: "AssessmentNode";
              readonly id: number;
              readonly state: AssessmentState;
              readonly assessmentDeliveryState?: AssessmentDeliveryState | null;
              readonly dueDate?: string | null;
              readonly submittedDatetime?: string | null;
              readonly target?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly template: {
                readonly __typename: "AssessmentTemplateNode";
                readonly id: number;
              };
            } | null;
          } | null>;
        };
      } | null;
    } | null>;
  };
  readonly unmetManagerEffectivenessCompliancePrograms: {
    readonly __typename: "ComplianceProgramNodeConnection";
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly endCursor?: string | null;
      readonly hasNextPage: boolean;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "ComplianceProgramNodeEdge";
      readonly node?: {
        readonly __typename: "ComplianceProgramNode";
        readonly id: number;
        readonly title: string;
        readonly dueDate?: string | null;
        readonly canReadDetails: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
          readonly reason: string;
        };
        readonly usersMissingAssessment: {
          readonly __typename: "MissingAssessmentConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "MissingAssessmentEdge";
            readonly node?: {
              readonly __typename: "MissingAssessmentNode";
              readonly assessmentTemplateId?: number | null;
              readonly dueDate: string;
              readonly target?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly responder: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              };
            } | null;
          } | null>;
        };
        readonly performanceAssessmentTemplate?: {
          readonly __typename: "AssessmentTemplateNode";
          readonly id: number;
          readonly assessmentType: AssessmentType;
        } | null;
        readonly managerAssessmentTemplate?: {
          readonly __typename: "AssessmentTemplateNode";
          readonly id: number;
          readonly assessmentType: AssessmentType;
        } | null;
        readonly peerAssessmentTemplate?: {
          readonly __typename: "AssessmentTemplateNode";
          readonly id: number;
          readonly assessmentType: AssessmentType;
        } | null;
        readonly assessments: {
          readonly __typename: "AssessmentNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "AssessmentNodeEdge";
            readonly node?: {
              readonly __typename: "AssessmentNode";
              readonly id: number;
              readonly state: AssessmentState;
              readonly assessmentDeliveryState?: AssessmentDeliveryState | null;
              readonly dueDate?: string | null;
              readonly submittedDatetime?: string | null;
              readonly target?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly template: {
                readonly __typename: "AssessmentTemplateNode";
                readonly id: number;
              };
            } | null;
          } | null>;
        };
      } | null;
    } | null>;
  };
};

export type GetRelatedRecognitionForCoreValueQuestionQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  coreValueId: Scalars["Int"]["input"];
  recipientId?: InputMaybe<Scalars["Int"]["input"]>;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates:
    | ReadonlyArray<Scalars["Date"]["input"]>
    | Scalars["Date"]["input"];
}>;

export type GetRelatedRecognitionForCoreValueQuestionQuery = {
  readonly __typename: "Query";
  readonly artifacts?: {
    readonly __typename: "ArtifactConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "ArtifactEdge";
      readonly node?:
        | { readonly __typename: "ActionItemArtifactNode"; readonly id: number }
        | { readonly __typename: "AsanaTaskArtifactNode"; readonly id: number }
        | { readonly __typename: "DecisionArtifactNode"; readonly id: number }
        | { readonly __typename: "DocumentArtifactNode"; readonly id: number }
        | { readonly __typename: "FeedbackArtifactNode"; readonly id: number }
        | {
            readonly __typename: "GithubIssuesArtifactNode";
            readonly id: number;
          }
        | { readonly __typename: "GoalArtifactNode"; readonly id: number }
        | { readonly __typename: "KPIArtifactNode"; readonly id: number }
        | { readonly __typename: "RatingArtifactNode"; readonly id: number }
        | {
            readonly __typename: "RecognitionArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly created: string;
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
            readonly recipients?: {
              readonly __typename: "UserNodeConnection";
              readonly totalCount: number;
              readonly edges: ReadonlyArray<{
                readonly __typename: "UserNodeEdge";
                readonly node?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly name: string;
                  readonly avatar?: string | null;
                } | null;
              } | null>;
            } | null;
            readonly recognitionCoreValue?: {
              readonly __typename: "RecognitionCoreValueNode";
              readonly id: number;
              readonly title: string;
              readonly description: string;
              readonly emoji?: string | null;
              readonly image?: string | null;
            } | null;
          }
        | null;
    } | null>;
  } | null;
};

export type RelatedAssessmentSubmissionFragment = {
  readonly __typename: "AssessmentSubmissionNode";
  readonly type: AssessmentSubmissionNodeType;
  readonly status: ComplianceProgramParticipantStatus;
  readonly completeCount: number;
  readonly pendingCount: number;
  readonly delivery?: {
    readonly __typename: "AssessmentDeliveryNode";
    readonly id: number;
    readonly canUpdate?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    } | null;
  } | null;
  readonly users: ReadonlyArray<{
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  }>;
  readonly template?: {
    readonly __typename: "AssessmentTemplateNode";
    readonly id: number;
    readonly anonymity: AssessmentGroupAnonymity;
    readonly delivery: AssessmentGroupDelivery;
    readonly assessmentType: AssessmentType;
    readonly assessments: {
      readonly __typename: "AssessmentNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AssessmentNodeEdge";
        readonly node?: {
          readonly __typename: "AssessmentNode";
          readonly id: number;
          readonly canUpdate?: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          } | null;
          readonly target?: {
            readonly __typename: "UserNode";
            readonly id: number;
          } | null;
          readonly responder?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
        } | null;
      } | null>;
    };
  } | null;
  readonly canCalibrate?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  } | null;
};

export type GetReviewSubmissionsQueryVariables = Exact<{
  complianceProgramId: Scalars["Int"]["input"];
  targetId: Scalars["Int"]["input"];
}>;

export type GetReviewSubmissionsQuery = {
  readonly __typename: "Query";
  readonly complianceProgram?: {
    readonly __typename: "ComplianceProgramNode";
    readonly id: number;
    readonly assessmentSubmissions: ReadonlyArray<{
      readonly __typename: "AssessmentSubmissionNode";
      readonly type: AssessmentSubmissionNodeType;
      readonly status: ComplianceProgramParticipantStatus;
      readonly completeCount: number;
      readonly pendingCount: number;
      readonly delivery?: {
        readonly __typename: "AssessmentDeliveryNode";
        readonly id: number;
        readonly canUpdate?: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        } | null;
      } | null;
      readonly users: ReadonlyArray<{
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      }>;
      readonly template?: {
        readonly __typename: "AssessmentTemplateNode";
        readonly id: number;
        readonly anonymity: AssessmentGroupAnonymity;
        readonly delivery: AssessmentGroupDelivery;
        readonly assessmentType: AssessmentType;
        readonly assessments: {
          readonly __typename: "AssessmentNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "AssessmentNodeEdge";
            readonly node?: {
              readonly __typename: "AssessmentNode";
              readonly id: number;
              readonly canUpdate?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              } | null;
              readonly target?: {
                readonly __typename: "UserNode";
                readonly id: number;
              } | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            } | null;
          } | null>;
        };
      } | null;
      readonly canCalibrate?: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
      } | null;
    } | null>;
  } | null;
};

export type GetUserRolesDetailsQueryQueryVariables = Exact<{
  userId: Scalars["Int"]["input"];
}>;

export type GetUserRolesDetailsQueryQuery = {
  readonly __typename: "Query";
  readonly user?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly email: string;
    readonly avatar?: string | null;
    readonly isInCurrentUserReportingTree: boolean;
    readonly currentRoles: ReadonlyArray<{
      readonly __typename: "CareerTrackRoleNode";
      readonly id: number;
      readonly title: string;
      readonly level: number;
      readonly roleType: CareerTrackRoleType;
      readonly careerTrack: {
        readonly __typename: "CareerTrackNode";
        readonly id: number;
        readonly title: string;
      };
      readonly competencies: {
        readonly __typename: "CompetencyConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "CompetencyEdge";
          readonly node?: {
            readonly __typename: "CompetencyNode";
            readonly id: number;
            readonly title: string;
            readonly criteria: {
              readonly __typename: "CompetencyCriteriaConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "CompetencyCriteriaEdge";
                readonly node?: {
                  readonly __typename: "CompetencyCriteriaNode";
                  readonly id: number;
                  readonly content: any;
                } | null;
              } | null>;
            };
          } | null;
        } | null>;
      };
      readonly responsibilities: {
        readonly __typename: "CareerTrackRoleResponsibilityNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "CareerTrackRoleResponsibilityNodeEdge";
          readonly node?: {
            readonly __typename: "CareerTrackRoleResponsibilityNode";
            readonly id: number;
            readonly content: any;
          } | null;
        } | null>;
      };
    }>;
    readonly futureRoles: ReadonlyArray<{
      readonly __typename: "CareerTrackRoleNode";
      readonly id: number;
      readonly title: string;
      readonly level: number;
      readonly roleType: CareerTrackRoleType;
      readonly careerTrack: {
        readonly __typename: "CareerTrackNode";
        readonly id: number;
        readonly title: string;
      };
      readonly competencies: {
        readonly __typename: "CompetencyConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "CompetencyEdge";
          readonly node?: {
            readonly __typename: "CompetencyNode";
            readonly id: number;
            readonly title: string;
            readonly criteria: {
              readonly __typename: "CompetencyCriteriaConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "CompetencyCriteriaEdge";
                readonly node?: {
                  readonly __typename: "CompetencyCriteriaNode";
                  readonly id: number;
                  readonly content: any;
                } | null;
              } | null>;
            };
          } | null;
        } | null>;
      };
      readonly responsibilities: {
        readonly __typename: "CareerTrackRoleResponsibilityNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "CareerTrackRoleResponsibilityNodeEdge";
          readonly node?: {
            readonly __typename: "CareerTrackRoleResponsibilityNode";
            readonly id: number;
            readonly content: any;
          } | null;
        } | null>;
      };
    }>;
  } | null;
};

export type RegenerateAssessmentAnswersMutationVariables = Exact<{
  assessmentId: Scalars["Int"]["input"];
  questionId: Scalars["Int"]["input"];
}>;

export type RegenerateAssessmentAnswersMutation = {
  readonly __typename: "Mutation";
  readonly regenerateQuestionAnswer: {
    readonly __typename: "RegenerateQuestionAnswer";
    readonly assessment?: {
      readonly __typename: "AssessmentNode";
      readonly id: number;
      readonly suggestedAnswers?: {
        readonly __typename: "SuggestedQuestionConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "SuggestedQuestionEdge";
          readonly node?: {
            readonly __typename: "SuggestedQuestionNode";
            readonly questionId?: number | null;
            readonly questionText?: string | null;
            readonly suggestions?: {
              readonly __typename: "SuggestionItemConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "SuggestionItemEdge";
                readonly node?: {
                  readonly __typename: "SuggestionItemNode";
                  readonly title: string;
                  readonly text: string;
                  readonly citations?: {
                    readonly __typename: "AnswerCitationConnection";
                    readonly edges: ReadonlyArray<{
                      readonly __typename: "AnswerCitationEdge";
                      readonly node?: {
                        readonly __typename: "AnswerCitationNode";
                        readonly sourceId: string;
                        readonly sourceType: string;
                        readonly title: string;
                        readonly url: string;
                        readonly date?: string | null;
                        readonly sourceProvider: string;
                        readonly contextText?: string | null;
                      } | null;
                    } | null>;
                  } | null;
                } | null;
              } | null>;
            } | null;
          } | null;
        } | null>;
      } | null;
    } | null;
  };
};

export type UnsubmitAssessmentMutationVariables = Exact<{
  assessmentIds:
    | ReadonlyArray<Scalars["Int"]["input"]>
    | Scalars["Int"]["input"];
}>;

export type UnsubmitAssessmentMutation = {
  readonly __typename: "Mutation";
  readonly reopenAssessment: {
    readonly __typename: "ReopenAssessmentMutation";
    readonly assessments: ReadonlyArray<{
      readonly __typename: "AssessmentNode";
      readonly id: number;
      readonly state: AssessmentState;
      readonly assessmentDeliveryState?: AssessmentDeliveryState | null;
      readonly assessmentDelivery?: {
        readonly __typename: "AssessmentDeliveryNode";
        readonly id: number;
        readonly state: AssessmentDeliveryState;
      } | null;
    } | null>;
    readonly reportRows: {
      readonly __typename: "PerformanceReviewReportRowConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "PerformanceReviewReportRowEdge";
        readonly node?: {
          readonly __typename: "PerformanceReviewReportRowNode";
          readonly id: number;
          readonly assessment?: {
            readonly __typename: "AssessmentNode";
            readonly id: number;
            readonly state: AssessmentState;
            readonly roleAssessmentAvg?: number | null;
            readonly selfRoleAssessmentAvg?: number | null;
            readonly assessmentDeliveryState?: AssessmentDeliveryState | null;
            readonly responder?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly firstName: string;
              readonly avatar?: string | null;
            } | null;
            readonly target?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
              readonly organizationSpecificInfo?: {
                readonly __typename: "UserMemberNode";
                readonly startDate?: string | null;
              } | null;
              readonly primaryManager?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
              } | null;
              readonly teamsList: ReadonlyArray<{
                readonly __typename: "TeamNode";
                readonly id: number;
                readonly title: string;
              }>;
            } | null;
            readonly answers: ReadonlyArray<
              | {
                  readonly __typename: "CompetencyAssessmentAnswerNode";
                  readonly id: number;
                  readonly questionId: number;
                  readonly integerAnswer?: number | null;
                  readonly comment?: any | null;
                  readonly roleId: number;
                  readonly hasCalibrations: boolean;
                  readonly hasCalibrationSuggestions: boolean;
                }
              | {
                  readonly __typename: "CompetencyCriteriaAssessmentAnswerNode";
                  readonly id: number;
                  readonly questionId: number;
                  readonly integerAnswer?: number | null;
                  readonly comment?: any | null;
                  readonly roleId: number;
                  readonly hasCalibrations: boolean;
                  readonly hasCalibrationSuggestions: boolean;
                }
              | {
                  readonly __typename: "IndividualGoalAssessmentAnswerNode";
                  readonly id: number;
                  readonly questionId: number;
                  readonly integerAnswer?: number | null;
                  readonly comment?: any | null;
                  readonly hasCalibrations: boolean;
                  readonly hasCalibrationSuggestions: boolean;
                }
              | {
                  readonly __typename: "IndividualRecognitionCoreValueAssessmentAnswerNode";
                  readonly id: number;
                  readonly questionId: number;
                  readonly integerAnswer?: number | null;
                  readonly comment?: any | null;
                  readonly hasCalibrations: boolean;
                  readonly hasCalibrationSuggestions: boolean;
                }
              | {
                  readonly __typename: "MultiChoiceAssessmentAnswerNode";
                  readonly id: number;
                  readonly questionId: number;
                  readonly choices: ReadonlyArray<number | null>;
                  readonly comment?: any | null;
                  readonly hasCalibrations: boolean;
                  readonly hasCalibrationSuggestions: boolean;
                }
              | {
                  readonly __typename: "NpsAssessmentAnswerNode";
                  readonly id: number;
                  readonly questionId: number;
                  readonly integerAnswer?: number | null;
                  readonly comment?: any | null;
                  readonly hasCalibrations: boolean;
                  readonly hasCalibrationSuggestions: boolean;
                }
              | {
                  readonly __typename: "OverallGoalAssessmentAnswerNode";
                  readonly id: number;
                  readonly questionId: number;
                  readonly integerAnswer?: number | null;
                  readonly comment?: any | null;
                  readonly hasCalibrations: boolean;
                  readonly hasCalibrationSuggestions: boolean;
                }
              | {
                  readonly __typename: "OverallRecognitionCoreValueAssessmentAnswerNode";
                  readonly id: number;
                  readonly questionId: number;
                  readonly integerAnswer?: number | null;
                  readonly comment?: any | null;
                  readonly hasCalibrations: boolean;
                  readonly hasCalibrationSuggestions: boolean;
                }
              | {
                  readonly __typename: "RangeAssessmentAnswerNode";
                  readonly id: number;
                  readonly questionId: number;
                  readonly integerAnswer?: number | null;
                  readonly comment?: any | null;
                  readonly hasCalibrations: boolean;
                  readonly hasCalibrationSuggestions: boolean;
                }
              | {
                  readonly __typename: "ResponsibilityAssessmentAnswerNode";
                  readonly id: number;
                  readonly questionId: number;
                  readonly integerAnswer?: number | null;
                  readonly comment?: any | null;
                  readonly roleId: number;
                  readonly hasCalibrations: boolean;
                  readonly hasCalibrationSuggestions: boolean;
                }
              | {
                  readonly __typename: "TalentIndicatorAssessmentAnswerNode";
                  readonly id: number;
                  readonly questionId: number;
                  readonly integerAnswer?: number | null;
                  readonly comment?: any | null;
                  readonly hasCalibrations: boolean;
                  readonly hasCalibrationSuggestions: boolean;
                }
              | {
                  readonly __typename: "TextAssessmentAnswerNode";
                  readonly id: number;
                  readonly questionId: number;
                  readonly textAnswer?: any | null;
                  readonly comment?: any | null;
                  readonly hasCalibrations: boolean;
                  readonly hasCalibrationSuggestions: boolean;
                }
              | null
            >;
            readonly assessmentDelivery?: {
              readonly __typename: "AssessmentDeliveryNode";
              readonly id: number;
              readonly state: AssessmentDeliveryState;
              readonly deliveryDatetime?: string | null;
              readonly canUpdate?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              } | null;
              readonly canRead?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              } | null;
            } | null;
            readonly template: {
              readonly __typename: "AssessmentTemplateNode";
              readonly id: number;
              readonly organization: {
                readonly __typename: "OrganizationNode";
                readonly id: number;
              };
            };
          } | null;
        } | null;
      } | null>;
    };
  };
};

export type SaveAssessmentNomineesMutationVariables = Exact<{
  complianceProgramId: Scalars["Int"]["input"];
  assessmentTemplateId: Scalars["Int"]["input"];
  responderIds:
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>;
  targetId: Scalars["Int"]["input"];
}>;

export type SaveAssessmentNomineesMutation = {
  readonly __typename: "Mutation";
  readonly setAssessmentNominations?: {
    readonly __typename: "SetAssessmentNominationsMutation";
    readonly complianceProgram?: {
      readonly __typename: "ComplianceProgramNode";
      readonly id: number;
      readonly nominationsForUser: {
        readonly __typename: "AssessmentNominationNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentNominationNodeEdge";
          readonly node?: {
            readonly __typename: "AssessmentNominationNode";
            readonly id: number;
            readonly responder: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            };
          } | null;
        } | null>;
      };
    } | null;
    readonly assessmentOpenForNomination?: {
      readonly __typename: "AssessmentOpenForNominationNode";
      readonly id: string;
      readonly nominationsCount: number;
    } | null;
  } | null;
};

export type SaveAssessmentDeliveryMutationVariables = Exact<{
  assessmentDeliveryId: Scalars["Int"]["input"];
  excludedAnswerIds?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  summary?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<AssessmentDeliveryState>;
}>;

export type SaveAssessmentDeliveryMutation = {
  readonly __typename: "Mutation";
  readonly updateAssessmentDelivery: {
    readonly __typename: "UpdateAssessmentDeliveryMutation";
    readonly assessmentDelivery: {
      readonly __typename: "AssessmentDeliveryNode";
      readonly id: number;
      readonly state: AssessmentDeliveryState;
      readonly canUpdate?: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
      } | null;
      readonly canRead?: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
      } | null;
    };
  };
};

export type CalendarMeetingFragmentFragment = {
  readonly __typename: "MeetingNode";
  readonly id: number;
  readonly draft: boolean;
  readonly status?: EventStatus | null;
  readonly externalUrl?: string | null;
  readonly ignored: boolean;
  readonly videoConferenceType?: OnlineVideoConference | null;
  readonly videoConferenceUrl?: string | null;
  readonly hasBotInMeeting: boolean;
  readonly botIsRecording: boolean;
  readonly botIsWaitingToJoinMeeting: boolean;
  readonly title?: string | null;
  readonly startDatetime?: string | null;
  readonly isRecurring: boolean;
  readonly endDatetime?: string | null;
  readonly meetingGroupId: number;
  readonly canDelete?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  } | null;
  readonly canUpdate?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  } | null;
  readonly transcript?: {
    readonly __typename: "MeetingTranscriptNode";
    readonly id: number;
  } | null;
  readonly organizer?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
  } | null;
  readonly meetingGroup?: {
    readonly __typename: "MeetingGroupNode";
    readonly id: number;
    readonly hasTemplate?: boolean | null;
    readonly isFormalOneonone: boolean;
    readonly addTranscriptionBotToMeetingsByDefault: boolean;
    readonly transcribeMeetingsByDefault?: boolean | null;
    readonly facilitator?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly avatar?: string | null;
    } | null;
  } | null;
};

export type CalendarEventFragmentFragment = {
  readonly __typename: "BasicMeetingNode";
  readonly id: number;
  readonly startDatetime?: string | null;
  readonly endDatetime?: string | null;
  readonly title?: string | null;
  readonly meetingGroupId: number;
  readonly canRead: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly meeting?: {
    readonly __typename: "MeetingNode";
    readonly id: number;
    readonly draft: boolean;
    readonly status?: EventStatus | null;
    readonly externalUrl?: string | null;
    readonly ignored: boolean;
    readonly videoConferenceType?: OnlineVideoConference | null;
    readonly videoConferenceUrl?: string | null;
    readonly hasBotInMeeting: boolean;
    readonly botIsRecording: boolean;
    readonly botIsWaitingToJoinMeeting: boolean;
    readonly title?: string | null;
    readonly startDatetime?: string | null;
    readonly isRecurring: boolean;
    readonly endDatetime?: string | null;
    readonly meetingGroupId: number;
    readonly canDelete?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    } | null;
    readonly canUpdate?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    } | null;
    readonly transcript?: {
      readonly __typename: "MeetingTranscriptNode";
      readonly id: number;
    } | null;
    readonly organizer?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
    } | null;
    readonly meetingGroup?: {
      readonly __typename: "MeetingGroupNode";
      readonly id: number;
      readonly hasTemplate?: boolean | null;
      readonly isFormalOneonone: boolean;
      readonly addTranscriptionBotToMeetingsByDefault: boolean;
      readonly transcribeMeetingsByDefault?: boolean | null;
      readonly facilitator?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      } | null;
    } | null;
  } | null;
};

export type GetCalendarMeetingsQueryVariables = Exact<{
  forUserId: Scalars["Int"]["input"];
  startDatetime_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDatetime_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  participants?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetCalendarMeetingsQuery = {
  readonly __typename: "Query";
  readonly calendar?: {
    readonly __typename: "BasicMeetingNodeConnection";
    readonly totalCount: number;
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly startCursor?: string | null;
      readonly endCursor?: string | null;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "BasicMeetingNodeEdge";
      readonly node?: {
        readonly __typename: "BasicMeetingNode";
        readonly id: number;
        readonly startDatetime?: string | null;
        readonly endDatetime?: string | null;
        readonly title?: string | null;
        readonly meetingGroupId: number;
        readonly canRead: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly meeting?: {
          readonly __typename: "MeetingNode";
          readonly id: number;
          readonly draft: boolean;
          readonly status?: EventStatus | null;
          readonly externalUrl?: string | null;
          readonly ignored: boolean;
          readonly videoConferenceType?: OnlineVideoConference | null;
          readonly videoConferenceUrl?: string | null;
          readonly hasBotInMeeting: boolean;
          readonly botIsRecording: boolean;
          readonly botIsWaitingToJoinMeeting: boolean;
          readonly title?: string | null;
          readonly startDatetime?: string | null;
          readonly isRecurring: boolean;
          readonly endDatetime?: string | null;
          readonly meetingGroupId: number;
          readonly canDelete?: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          } | null;
          readonly canUpdate?: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          } | null;
          readonly transcript?: {
            readonly __typename: "MeetingTranscriptNode";
            readonly id: number;
          } | null;
          readonly organizer?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
          } | null;
          readonly meetingGroup?: {
            readonly __typename: "MeetingGroupNode";
            readonly id: number;
            readonly hasTemplate?: boolean | null;
            readonly isFormalOneonone: boolean;
            readonly addTranscriptionBotToMeetingsByDefault: boolean;
            readonly transcribeMeetingsByDefault?: boolean | null;
            readonly facilitator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          } | null;
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type GetGoalProgressQueryQueryVariables = Exact<{
  artifactId: Scalars["Int"]["input"];
}>;

export type GetGoalProgressQueryQuery = {
  readonly __typename: "Query";
  readonly artifact:
    | {
        readonly __typename: "ActionItemArtifactNode";
        readonly id: number;
        readonly title?: string | null;
      }
    | {
        readonly __typename: "AsanaTaskArtifactNode";
        readonly id: number;
        readonly title?: string | null;
      }
    | {
        readonly __typename: "DecisionArtifactNode";
        readonly id: number;
        readonly title?: string | null;
      }
    | {
        readonly __typename: "DocumentArtifactNode";
        readonly id: number;
        readonly title?: string | null;
      }
    | {
        readonly __typename: "FeedbackArtifactNode";
        readonly id: number;
        readonly title?: string | null;
      }
    | {
        readonly __typename: "GithubIssuesArtifactNode";
        readonly id: number;
        readonly title?: string | null;
      }
    | {
        readonly __typename: "GoalArtifactNode";
        readonly status: GoalStatus;
        readonly startValue: number;
        readonly currentValue: number;
        readonly targetValue: number;
        readonly progress: number;
        readonly progressType: GoalProgressType;
        readonly id: number;
        readonly title?: string | null;
        readonly keyResults: {
          readonly __typename: "KeyResultNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "KeyResultNodeEdge";
            readonly node?: {
              readonly __typename: "KeyResultNode";
              readonly id: number;
              readonly title: string;
              readonly startValue: number;
              readonly currentValue: number;
              readonly targetValue: number;
              readonly progressType: GoalProgressType;
              readonly kpi?: {
                readonly __typename: "KPINode";
                readonly id: number;
                readonly title: string;
                readonly currentMeasurement?: {
                  readonly __typename: "KPIMeasurementNode";
                  readonly id: number;
                  readonly measurement: number;
                } | null;
              } | null;
              readonly canUpdate?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              } | null;
              readonly assignee?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
                readonly email: string;
              } | null;
            } | null;
          } | null>;
        };
      }
    | {
        readonly __typename: "KPIArtifactNode";
        readonly id: number;
        readonly title?: string | null;
      }
    | {
        readonly __typename: "RatingArtifactNode";
        readonly id: number;
        readonly title?: string | null;
      }
    | {
        readonly __typename: "RecognitionArtifactNode";
        readonly id: number;
        readonly title?: string | null;
      };
};

export type GoalCheckinMutationMutationVariables = Exact<{
  comment?: InputMaybe<Scalars["JSONString"]["input"]>;
  currentValue?: InputMaybe<Scalars["Float"]["input"]>;
  goalStatus?: InputMaybe<GoalStatus>;
  keyResults?: InputMaybe<
    | ReadonlyArray<InputMaybe<GoalCheckinKeyResultInput>>
    | InputMaybe<GoalCheckinKeyResultInput>
  >;
  goalId: Scalars["Int"]["input"];
}>;

export type GoalCheckinMutationMutation = {
  readonly __typename: "Mutation";
  readonly createGoalCheckin?: {
    readonly __typename: "CreateGoalCheckinMutation";
    readonly goal?: {
      readonly __typename: "GoalArtifactNode";
      readonly status: GoalStatus;
      readonly startValue: number;
      readonly currentValue: number;
      readonly targetValue: number;
      readonly progress: number;
      readonly progressType: GoalProgressType;
      readonly isStale: boolean;
      readonly id: number;
      readonly keyResults: {
        readonly __typename: "KeyResultNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "KeyResultNodeEdge";
          readonly node?: {
            readonly __typename: "KeyResultNode";
            readonly id: number;
            readonly title: string;
            readonly startValue: number;
            readonly currentValue: number;
            readonly targetValue: number;
            readonly progressType: GoalProgressType;
            readonly kpi?: {
              readonly __typename: "KPINode";
              readonly id: number;
              readonly title: string;
              readonly currentMeasurement?: {
                readonly __typename: "KPIMeasurementNode";
                readonly id: number;
                readonly measurement: number;
              } | null;
            } | null;
            readonly canUpdate?: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            } | null;
            readonly assignee?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
              readonly email: string;
            } | null;
          } | null;
        } | null>;
      };
      readonly activities: {
        readonly __typename: "ArtifactActivityNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "ArtifactActivityNodeEdge";
          readonly node?: {
            readonly __typename: "ArtifactActivityNode";
            readonly id: number;
            readonly created: string;
            readonly activityType: ArtifactActivityType;
            readonly canDelete?: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
              readonly reason: string;
            } | null;
            readonly canUpdate?: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
              readonly reason: string;
            } | null;
            readonly actor?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
            readonly changedFields?: ReadonlyArray<{
              readonly __typename: "ArtifactChangedFieldNode";
              readonly fieldName?: string | null;
              readonly previousValue?: string | null;
              readonly newValue?: string | null;
              readonly changedFields?: ReadonlyArray<{
                readonly __typename: "ArtifactChangedFieldNode";
                readonly newValue?: string | null;
                readonly previousValue?: string | null;
                readonly fieldName?: string | null;
              } | null> | null;
              readonly newValueObject?:
                | {
                    readonly __typename: "BaseArtifactNode";
                    readonly id: number;
                    readonly title: string;
                    readonly artifactType: ArtifactType;
                  }
                | {
                    readonly __typename: "CareerTrackRoleNode";
                    readonly id: number;
                    readonly title: string;
                  }
                | {
                    readonly __typename: "CommentNode";
                    readonly id: number;
                    readonly comment?: any | null;
                    readonly deleted?: boolean | null;
                    readonly creator?: {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    } | null;
                  }
                | {
                    readonly __typename: "CompetencyNode";
                    readonly id: number;
                    readonly title: string;
                  }
                | {
                    readonly __typename: "KeyResultNode";
                    readonly id: number;
                    readonly title: string;
                  }
                | {
                    readonly __typename: "TopicNode";
                    readonly id: number;
                    readonly title: string;
                    readonly meeting?: {
                      readonly __typename: "MeetingNode";
                      readonly id: number;
                      readonly title?: string | null;
                      readonly meetingGroupId: number;
                    } | null;
                  }
                | {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly name: string;
                    readonly avatar?: string | null;
                  }
                | null;
              readonly previousValueObject?:
                | {
                    readonly __typename: "BaseArtifactNode";
                    readonly id: number;
                    readonly title: string;
                    readonly artifactType: ArtifactType;
                  }
                | {
                    readonly __typename: "CareerTrackRoleNode";
                    readonly id: number;
                    readonly title: string;
                  }
                | { readonly __typename: "CommentNode" }
                | {
                    readonly __typename: "CompetencyNode";
                    readonly id: number;
                    readonly title: string;
                  }
                | {
                    readonly __typename: "KeyResultNode";
                    readonly id: number;
                    readonly title: string;
                  }
                | {
                    readonly __typename: "TopicNode";
                    readonly id: number;
                    readonly title: string;
                    readonly meeting?: {
                      readonly __typename: "MeetingNode";
                      readonly id: number;
                      readonly title?: string | null;
                      readonly meetingGroupId: number;
                    } | null;
                  }
                | {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly name: string;
                    readonly avatar?: string | null;
                  }
                | null;
            } | null> | null;
          } | null;
        } | null>;
      };
    } | null;
  } | null;
};

export type CreateCommentMutationMutationVariables = Exact<{
  comment: Scalars["String"]["input"];
  topicId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type CreateCommentMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateComment?: {
    readonly __typename: "CreateOrUpdateCommentMutation";
    readonly comment?: {
      readonly __typename: "CommentNode";
      readonly id: number;
      readonly created: string;
      readonly comment?: any | null;
      readonly creator?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      } | null;
      readonly topic?: {
        readonly __typename: "TopicNode";
        readonly id: number;
        readonly commentCount?: number | null;
      } | null;
      readonly artifact?:
        | {
            readonly __typename: "ActionItemArtifactNode";
            readonly id: number;
            readonly comments?: {
              readonly __typename: "CommentNodeConnection";
              readonly totalCount: number;
            } | null;
          }
        | {
            readonly __typename: "AsanaTaskArtifactNode";
            readonly id: number;
            readonly comments?: {
              readonly __typename: "CommentNodeConnection";
              readonly totalCount: number;
            } | null;
          }
        | {
            readonly __typename: "DecisionArtifactNode";
            readonly id: number;
            readonly comments?: {
              readonly __typename: "CommentNodeConnection";
              readonly totalCount: number;
            } | null;
          }
        | {
            readonly __typename: "DocumentArtifactNode";
            readonly id: number;
            readonly comments?: {
              readonly __typename: "CommentNodeConnection";
              readonly totalCount: number;
            } | null;
          }
        | {
            readonly __typename: "FeedbackArtifactNode";
            readonly id: number;
            readonly comments?: {
              readonly __typename: "CommentNodeConnection";
              readonly totalCount: number;
            } | null;
          }
        | {
            readonly __typename: "GithubIssuesArtifactNode";
            readonly id: number;
            readonly comments?: {
              readonly __typename: "CommentNodeConnection";
              readonly totalCount: number;
            } | null;
          }
        | {
            readonly __typename: "GoalArtifactNode";
            readonly id: number;
            readonly comments?: {
              readonly __typename: "CommentNodeConnection";
              readonly totalCount: number;
            } | null;
          }
        | {
            readonly __typename: "KPIArtifactNode";
            readonly id: number;
            readonly comments?: {
              readonly __typename: "CommentNodeConnection";
              readonly totalCount: number;
            } | null;
          }
        | {
            readonly __typename: "RatingArtifactNode";
            readonly id: number;
            readonly comments?: {
              readonly __typename: "CommentNodeConnection";
              readonly totalCount: number;
            } | null;
          }
        | {
            readonly __typename: "RecognitionArtifactNode";
            readonly id: number;
            readonly comments?: {
              readonly __typename: "CommentNodeConnection";
              readonly totalCount: number;
            } | null;
          }
        | null;
    } | null;
  } | null;
};

export type DeleteCommentMutationMutationVariables = Exact<{
  commentId: Scalars["Int"]["input"];
}>;

export type DeleteCommentMutationMutation = {
  readonly __typename: "Mutation";
  readonly deleteComment?: {
    readonly __typename: "DeleteCommentMutation";
    readonly topic?: {
      readonly __typename: "TopicNode";
      readonly id: number;
    } | null;
  } | null;
};

export type GetCommentsOfRelatedTopicQueryVariables = Exact<{
  topicId: Scalars["Int"]["input"];
}>;

export type GetCommentsOfRelatedTopicQuery = {
  readonly __typename: "Query";
  readonly me?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly avatar?: string | null;
    readonly name: string;
  } | null;
  readonly comments?: {
    readonly __typename: "CommentNodeConnection";
    readonly totalCount: number;
    readonly edges: ReadonlyArray<{
      readonly __typename: "CommentNodeEdge";
      readonly node?: {
        readonly __typename: "CommentNode";
        readonly id: number;
        readonly created: string;
        readonly comment?: any | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type GetCommentsQueryVariables = Exact<{
  topicId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetCommentsQuery = {
  readonly __typename: "Query";
  readonly me?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly avatar?: string | null;
    readonly name: string;
  } | null;
  readonly comments?: {
    readonly __typename: "CommentNodeConnection";
    readonly totalCount: number;
    readonly edges: ReadonlyArray<{
      readonly __typename: "CommentNodeEdge";
      readonly node?: {
        readonly __typename: "CommentNode";
        readonly id: number;
        readonly created: string;
        readonly comment?: any | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type UpdateCommentMutationMutationVariables = Exact<{
  commentId: Scalars["Int"]["input"];
  comment: Scalars["String"]["input"];
}>;

export type UpdateCommentMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateComment?: {
    readonly __typename: "CreateOrUpdateCommentMutation";
    readonly comment?: {
      readonly __typename: "CommentNode";
      readonly id: number;
      readonly comment?: any | null;
    } | null;
  } | null;
};

type DashboardGoalFragment_ActionItemArtifactNode_Fragment = {
  readonly __typename: "ActionItemArtifactNode";
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly created: string;
  readonly isStale: boolean;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
};

type DashboardGoalFragment_AsanaTaskArtifactNode_Fragment = {
  readonly __typename: "AsanaTaskArtifactNode";
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly created: string;
  readonly isStale: boolean;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
};

type DashboardGoalFragment_DecisionArtifactNode_Fragment = {
  readonly __typename: "DecisionArtifactNode";
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly created: string;
  readonly isStale: boolean;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
};

type DashboardGoalFragment_DocumentArtifactNode_Fragment = {
  readonly __typename: "DocumentArtifactNode";
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly created: string;
  readonly isStale: boolean;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
};

type DashboardGoalFragment_FeedbackArtifactNode_Fragment = {
  readonly __typename: "FeedbackArtifactNode";
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly created: string;
  readonly isStale: boolean;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
};

type DashboardGoalFragment_GithubIssuesArtifactNode_Fragment = {
  readonly __typename: "GithubIssuesArtifactNode";
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly created: string;
  readonly isStale: boolean;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
};

type DashboardGoalFragment_GoalArtifactNode_Fragment = {
  readonly __typename: "GoalArtifactNode";
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly created: string;
  readonly isStale: boolean;
  readonly startValue: number;
  readonly currentValue: number;
  readonly targetValue: number;
  readonly progress: number;
  readonly progressType: GoalProgressType;
  readonly dueDate?: string | null;
  readonly startDate?: string | null;
  readonly state: GoalState;
  readonly status: GoalStatus;
  readonly scope: GoalScope;
  readonly goalVisibility: GoalVisibility;
  readonly parentGoalId?: number | null;
  readonly ownerCount?: number | null;
  readonly contributorCount?: number | null;
  readonly updated?: string | null;
  readonly activities: {
    readonly __typename: "ArtifactActivityNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "ArtifactActivityNodeEdge";
      readonly node?: {
        readonly __typename: "ArtifactActivityNode";
        readonly created: string;
      } | null;
    } | null>;
  };
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
  readonly firstOwner?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly avatar?: string | null;
    readonly name: string;
  } | null;
  readonly canRead: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
};

type DashboardGoalFragment_KpiArtifactNode_Fragment = {
  readonly __typename: "KPIArtifactNode";
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly created: string;
  readonly isStale: boolean;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
};

type DashboardGoalFragment_RatingArtifactNode_Fragment = {
  readonly __typename: "RatingArtifactNode";
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly created: string;
  readonly isStale: boolean;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
};

type DashboardGoalFragment_RecognitionArtifactNode_Fragment = {
  readonly __typename: "RecognitionArtifactNode";
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly created: string;
  readonly isStale: boolean;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
};

export type DashboardGoalFragmentFragment =
  | DashboardGoalFragment_ActionItemArtifactNode_Fragment
  | DashboardGoalFragment_AsanaTaskArtifactNode_Fragment
  | DashboardGoalFragment_DecisionArtifactNode_Fragment
  | DashboardGoalFragment_DocumentArtifactNode_Fragment
  | DashboardGoalFragment_FeedbackArtifactNode_Fragment
  | DashboardGoalFragment_GithubIssuesArtifactNode_Fragment
  | DashboardGoalFragment_GoalArtifactNode_Fragment
  | DashboardGoalFragment_KpiArtifactNode_Fragment
  | DashboardGoalFragment_RatingArtifactNode_Fragment
  | DashboardGoalFragment_RecognitionArtifactNode_Fragment;

export type DashboardTeamUserFragmentFragment = {
  readonly __typename: "UserNode";
  readonly id: number;
  readonly name: string;
  readonly firstName: string;
  readonly email: string;
  readonly avatar?: string | null;
  readonly primaryManager?: {
    readonly __typename: "UserNode";
    readonly id: number;
  } | null;
};

export type DismissInsightMutationMutationVariables = Exact<{
  type: InsightType;
  userId: Scalars["Int"]["input"];
  reportId?: InputMaybe<Scalars["Int"]["input"]>;
  managerId?: InputMaybe<Scalars["Int"]["input"]>;
  complianceProgramId?: InputMaybe<Scalars["Int"]["input"]>;
  assessmentGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type DismissInsightMutationMutation = {
  readonly __typename: "Mutation";
  readonly dismissInsight?: {
    readonly __typename: "DismissInsightMutation";
    readonly user?: {
      readonly __typename: "UserNode";
      readonly id: number;
    } | null;
  } | null;
};

export type FavouritesGroupFragmentFragment = {
  readonly __typename: "FavouritesGroupNode";
  readonly id: number;
  readonly users?: {
    readonly __typename: "UserNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "UserNodeEdge";
      readonly node?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly firstName: string;
        readonly name: string;
        readonly email: string;
        readonly avatar?: string | null;
      } | null;
    } | null>;
  } | null;
};

export type GetNewDashboardFeedbackQueryQueryVariables = Exact<{
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  fetchData: Scalars["Boolean"]["input"];
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackState?: InputMaybe<FeedbackState>;
  createdBetweenDates?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
    | InputMaybe<Scalars["Date"]["input"]>
  >;
  after?: InputMaybe<Scalars["String"]["input"]>;
  first: Scalars["Int"]["input"];
}>;

export type GetNewDashboardFeedbackQueryQuery = {
  readonly __typename: "Query";
  readonly artifacts?: {
    readonly __typename: "ArtifactConnection";
    readonly totalCount: number;
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly hasNextPage: boolean;
      readonly endCursor?: string | null;
    };
    readonly edges?: ReadonlyArray<{
      readonly __typename: "ArtifactEdge";
      readonly node?:
        | { readonly __typename: "ActionItemArtifactNode"; readonly id: number }
        | { readonly __typename: "AsanaTaskArtifactNode"; readonly id: number }
        | { readonly __typename: "DecisionArtifactNode"; readonly id: number }
        | { readonly __typename: "DocumentArtifactNode"; readonly id: number }
        | {
            readonly __typename: "FeedbackArtifactNode";
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly created: string;
            readonly updated?: string | null;
            readonly id: number;
            readonly recipientsCanView: boolean;
            readonly recipientsManagersCanView: boolean;
            readonly adminsCanView: boolean;
            readonly creatorCanView: boolean;
            readonly feedbackState: FeedbackState;
            readonly message?: any | null;
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly feedbackRecipients: {
              readonly __typename: "UserNodeConnection";
              readonly totalCount: number;
              readonly edges: ReadonlyArray<{
                readonly __typename: "UserNodeEdge";
                readonly node?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly avatar?: string | null;
                  readonly name: string;
                } | null;
              } | null>;
            };
            readonly sender: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly avatar?: string | null;
              readonly name: string;
            };
          }
        | {
            readonly __typename: "GithubIssuesArtifactNode";
            readonly id: number;
          }
        | { readonly __typename: "GoalArtifactNode"; readonly id: number }
        | { readonly __typename: "KPIArtifactNode"; readonly id: number }
        | { readonly __typename: "RatingArtifactNode"; readonly id: number }
        | {
            readonly __typename: "RecognitionArtifactNode";
            readonly id: number;
          }
        | null;
    } | null>;
  } | null;
};

export type GetDashboardGoalsNewPageQueryQueryVariables = Exact<{
  owners?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  contributors?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  goalInvolvingUsers?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  teamGoalsOfUser?: InputMaybe<Scalars["Int"]["input"]>;
  forUserId: Scalars["Int"]["input"];
  fetchData: Scalars["Boolean"]["input"];
  goalStates: ReadonlyArray<InputMaybe<GoalState>> | InputMaybe<GoalState>;
  goalScopes?: InputMaybe<
    ReadonlyArray<InputMaybe<GoalScope>> | InputMaybe<GoalScope>
  >;
  goalDueBetweenDates?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
    | InputMaybe<Scalars["Date"]["input"]>
  >;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetDashboardGoalsNewPageQueryQuery = {
  readonly __typename: "Query";
  readonly goalsForUser?: {
    readonly __typename: "GoalArtifactConnection";
    readonly totalCount: number;
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly hasNextPage: boolean;
      readonly endCursor?: string | null;
    };
    readonly edges?: ReadonlyArray<{
      readonly __typename: "GoalArtifactEdge";
      readonly node?: {
        readonly __typename: "GoalArtifactNode";
        readonly id: number;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly created: string;
        readonly isStale: boolean;
        readonly startValue: number;
        readonly currentValue: number;
        readonly targetValue: number;
        readonly progress: number;
        readonly progressType: GoalProgressType;
        readonly dueDate?: string | null;
        readonly startDate?: string | null;
        readonly state: GoalState;
        readonly status: GoalStatus;
        readonly scope: GoalScope;
        readonly goalVisibility: GoalVisibility;
        readonly parentGoalId?: number | null;
        readonly ownerCount?: number | null;
        readonly contributorCount?: number | null;
        readonly updated?: string | null;
        readonly activities: {
          readonly __typename: "ArtifactActivityNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactActivityNodeEdge";
            readonly node?: {
              readonly __typename: "ArtifactActivityNode";
              readonly created: string;
            } | null;
          } | null>;
        };
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
        readonly firstOwner?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly avatar?: string | null;
          readonly name: string;
        } | null;
        readonly canRead: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type DashboardInsightFragment = {
  readonly __typename: "InsightNode";
  readonly id: number;
  readonly type: InsightType;
  readonly report?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly firstName: string;
    readonly name: string;
    readonly avatar?: string | null;
    readonly email: string;
  } | null;
  readonly manager?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly firstName: string;
    readonly name: string;
    readonly avatar?: string | null;
    readonly email: string;
  } | null;
  readonly artifact?:
    | { readonly __typename: "ActionItemArtifactNode"; readonly id: number }
    | { readonly __typename: "AsanaTaskArtifactNode"; readonly id: number }
    | { readonly __typename: "DecisionArtifactNode"; readonly id: number }
    | { readonly __typename: "DocumentArtifactNode"; readonly id: number }
    | {
        readonly __typename: "FeedbackArtifactNode";
        readonly id: number;
        readonly recipients: {
          readonly __typename: "UserNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "UserNodeEdge";
            readonly node?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          } | null>;
        };
      }
    | { readonly __typename: "GithubIssuesArtifactNode"; readonly id: number }
    | {
        readonly __typename: "GoalArtifactNode";
        readonly id: number;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly progressType: GoalProgressType;
      }
    | { readonly __typename: "KPIArtifactNode"; readonly id: number }
    | { readonly __typename: "RatingArtifactNode"; readonly id: number }
    | { readonly __typename: "RecognitionArtifactNode"; readonly id: number }
    | null;
  readonly assessmentGroup?: {
    readonly __typename: "AssessmentGroupNode";
    readonly id: number;
    readonly title: string;
  } | null;
  readonly complianceProgram?: {
    readonly __typename: "ComplianceProgramNode";
    readonly id: number;
    readonly title: string;
    readonly requiredTopicTemplates: {
      readonly __typename: "TopicTemplateNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "TopicTemplateNodeEdge";
        readonly node?: {
          readonly __typename: "TopicTemplateNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null>;
    };
  } | null;
};

export type GetDashboardInsightsQueryVariables = Exact<{
  personId: Scalars["Int"]["input"];
}>;

export type GetDashboardInsightsQuery = {
  readonly __typename: "Query";
  readonly user?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly insights?: {
      readonly __typename: "InsightConnection";
      readonly totalCount: number;
      readonly edges: ReadonlyArray<{
        readonly __typename: "InsightEdge";
        readonly node?: {
          readonly __typename: "InsightNode";
          readonly id: number;
          readonly type: InsightType;
          readonly report?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly firstName: string;
            readonly name: string;
            readonly avatar?: string | null;
            readonly email: string;
          } | null;
          readonly manager?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly firstName: string;
            readonly name: string;
            readonly avatar?: string | null;
            readonly email: string;
          } | null;
          readonly artifact?:
            | {
                readonly __typename: "ActionItemArtifactNode";
                readonly id: number;
              }
            | {
                readonly __typename: "AsanaTaskArtifactNode";
                readonly id: number;
              }
            | {
                readonly __typename: "DecisionArtifactNode";
                readonly id: number;
              }
            | {
                readonly __typename: "DocumentArtifactNode";
                readonly id: number;
              }
            | {
                readonly __typename: "FeedbackArtifactNode";
                readonly id: number;
                readonly recipients: {
                  readonly __typename: "UserNodeConnection";
                  readonly edges: ReadonlyArray<{
                    readonly __typename: "UserNodeEdge";
                    readonly node?: {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    } | null;
                  } | null>;
                };
              }
            | {
                readonly __typename: "GithubIssuesArtifactNode";
                readonly id: number;
              }
            | {
                readonly __typename: "GoalArtifactNode";
                readonly id: number;
                readonly title?: string | null;
                readonly artifactType: ArtifactType;
                readonly progressType: GoalProgressType;
              }
            | { readonly __typename: "KPIArtifactNode"; readonly id: number }
            | { readonly __typename: "RatingArtifactNode"; readonly id: number }
            | {
                readonly __typename: "RecognitionArtifactNode";
                readonly id: number;
              }
            | null;
          readonly assessmentGroup?: {
            readonly __typename: "AssessmentGroupNode";
            readonly id: number;
            readonly title: string;
          } | null;
          readonly complianceProgram?: {
            readonly __typename: "ComplianceProgramNode";
            readonly id: number;
            readonly title: string;
            readonly requiredTopicTemplates: {
              readonly __typename: "TopicTemplateNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "TopicTemplateNodeEdge";
                readonly node?: {
                  readonly __typename: "TopicTemplateNode";
                  readonly id: number;
                  readonly title: string;
                } | null;
              } | null>;
            };
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetNewDashboardRecognitionsQueryQueryVariables = Exact<{
  asUser?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
    | InputMaybe<Scalars["Date"]["input"]>
  >;
  createdBy?: InputMaybe<Scalars["Int"]["input"]>;
  fetchData: Scalars["Boolean"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
  first: Scalars["Int"]["input"];
}>;

export type GetNewDashboardRecognitionsQueryQuery = {
  readonly __typename: "Query";
  readonly artifacts?: {
    readonly __typename: "ArtifactConnection";
    readonly totalCount: number;
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly hasNextPage: boolean;
      readonly endCursor?: string | null;
    };
    readonly edges?: ReadonlyArray<{
      readonly __typename: "ArtifactEdge";
      readonly node?:
        | { readonly __typename: "ActionItemArtifactNode"; readonly id: number }
        | { readonly __typename: "AsanaTaskArtifactNode"; readonly id: number }
        | { readonly __typename: "DecisionArtifactNode"; readonly id: number }
        | { readonly __typename: "DocumentArtifactNode"; readonly id: number }
        | { readonly __typename: "FeedbackArtifactNode"; readonly id: number }
        | {
            readonly __typename: "GithubIssuesArtifactNode";
            readonly id: number;
          }
        | { readonly __typename: "GoalArtifactNode"; readonly id: number }
        | { readonly __typename: "KPIArtifactNode"; readonly id: number }
        | { readonly __typename: "RatingArtifactNode"; readonly id: number }
        | {
            readonly __typename: "RecognitionArtifactNode";
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly created: string;
            readonly updated?: string | null;
            readonly id: number;
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly recipients?: {
              readonly __typename: "UserNodeConnection";
              readonly totalCount: number;
              readonly edges: ReadonlyArray<{
                readonly __typename: "UserNodeEdge";
                readonly node?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly name: string;
                  readonly avatar?: string | null;
                } | null;
              } | null>;
            } | null;
            readonly recognitionCoreValue?: {
              readonly __typename: "RecognitionCoreValueNode";
              readonly id: number;
              readonly title: string;
              readonly description: string;
              readonly emoji?: string | null;
              readonly image?: string | null;
            } | null;
          }
        | null;
    } | null>;
  } | null;
};

export type GetDashboardSelectedUserQueryQueryVariables = Exact<{
  userId: Scalars["Int"]["input"];
}>;

export type GetDashboardSelectedUserQueryQuery = {
  readonly __typename: "Query";
  readonly user?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly firstName: string;
    readonly email: string;
    readonly avatar?: string | null;
    readonly managersList: ReadonlyArray<{
      readonly __typename: "UserNode";
      readonly id: number;
    }>;
    readonly primaryManager?: {
      readonly __typename: "UserNode";
      readonly id: number;
    } | null;
  } | null;
};

export type DashboardPeopleTableUserMeetingFragmentFragment = {
  readonly __typename: "MeetingNode";
  readonly id: number;
  readonly meetingGroupId: number;
  readonly startDatetime?: string | null;
};

export type DashboardPeopleTableUserArtifactsFragmentFragment = {
  readonly __typename: "UserNode";
  readonly id: number;
  readonly primaryManager?: {
    readonly __typename: "UserNode";
    readonly id: number;
  } | null;
  readonly goals?: {
    readonly __typename: "ArtifactConnection";
    readonly totalCount: number;
    readonly edges: ReadonlyArray<{
      readonly __typename: "ArtifactEdge";
      readonly node?:
        | { readonly __typename: "ActionItemArtifactNode"; readonly id: number }
        | { readonly __typename: "AsanaTaskArtifactNode"; readonly id: number }
        | { readonly __typename: "DecisionArtifactNode"; readonly id: number }
        | { readonly __typename: "DocumentArtifactNode"; readonly id: number }
        | { readonly __typename: "FeedbackArtifactNode"; readonly id: number }
        | {
            readonly __typename: "GithubIssuesArtifactNode";
            readonly id: number;
          }
        | {
            readonly __typename: "GoalArtifactNode";
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
            readonly state: GoalState;
            readonly isStale: boolean;
            readonly status: GoalStatus;
            readonly progress: number;
            readonly startValue: number;
            readonly currentValue: number;
            readonly targetValue: number;
            readonly progressType: GoalProgressType;
            readonly id: number;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | { readonly __typename: "KPIArtifactNode"; readonly id: number }
        | { readonly __typename: "RatingArtifactNode"; readonly id: number }
        | {
            readonly __typename: "RecognitionArtifactNode";
            readonly id: number;
          }
        | null;
    } | null>;
  } | null;
  readonly mostRecentlyReceivedRecognition?: {
    readonly __typename: "RecognitionArtifactNode";
    readonly id: number;
    readonly artifactType: ArtifactType;
    readonly created: string;
  } | null;
};

export type GetPeopleTableMetadataQueryQueryVariables = Exact<{
  oneononeUserIds:
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>;
  hasOneononeUserIds: Scalars["Boolean"]["input"];
  meetingUserIds:
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>;
  hasMeetingUserIds: Scalars["Boolean"]["input"];
  peopleTableGoalMax: Scalars["Int"]["input"];
  now: Scalars["DateTime"]["input"];
  currentUserId: Scalars["Int"]["input"];
}>;

export type GetPeopleTableMetadataQueryQuery = {
  readonly __typename: "Query";
  readonly oneononeUsers?: {
    readonly __typename: "UserNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "UserNodeEdge";
      readonly node?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly meetings?: {
          readonly __typename: "MeetingNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "MeetingNodeEdge";
            readonly node?: {
              readonly __typename: "MeetingNode";
              readonly id: number;
              readonly meetingGroupId: number;
              readonly startDatetime?: string | null;
            } | null;
          } | null>;
        } | null;
        readonly primaryManager?: {
          readonly __typename: "UserNode";
          readonly id: number;
        } | null;
        readonly goals?: {
          readonly __typename: "ArtifactConnection";
          readonly totalCount: number;
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactEdge";
            readonly node?:
              | {
                  readonly __typename: "ActionItemArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "AsanaTaskArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "DecisionArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "DocumentArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "FeedbackArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "GithubIssuesArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "GoalArtifactNode";
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly state: GoalState;
                  readonly isStale: boolean;
                  readonly status: GoalStatus;
                  readonly progress: number;
                  readonly startValue: number;
                  readonly currentValue: number;
                  readonly targetValue: number;
                  readonly progressType: GoalProgressType;
                  readonly id: number;
                  readonly canUpdate: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | { readonly __typename: "KPIArtifactNode"; readonly id: number }
              | {
                  readonly __typename: "RatingArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "RecognitionArtifactNode";
                  readonly id: number;
                }
              | null;
          } | null>;
        } | null;
        readonly mostRecentlyReceivedRecognition?: {
          readonly __typename: "RecognitionArtifactNode";
          readonly id: number;
          readonly artifactType: ArtifactType;
          readonly created: string;
        } | null;
      } | null;
    } | null>;
  };
  readonly meetingUsers?: {
    readonly __typename: "UserNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "UserNodeEdge";
      readonly node?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly meetings?: {
          readonly __typename: "MeetingNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "MeetingNodeEdge";
            readonly node?: {
              readonly __typename: "MeetingNode";
              readonly id: number;
              readonly meetingGroupId: number;
              readonly startDatetime?: string | null;
            } | null;
          } | null>;
        } | null;
        readonly primaryManager?: {
          readonly __typename: "UserNode";
          readonly id: number;
        } | null;
        readonly goals?: {
          readonly __typename: "ArtifactConnection";
          readonly totalCount: number;
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactEdge";
            readonly node?:
              | {
                  readonly __typename: "ActionItemArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "AsanaTaskArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "DecisionArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "DocumentArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "FeedbackArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "GithubIssuesArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "GoalArtifactNode";
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly state: GoalState;
                  readonly isStale: boolean;
                  readonly status: GoalStatus;
                  readonly progress: number;
                  readonly startValue: number;
                  readonly currentValue: number;
                  readonly targetValue: number;
                  readonly progressType: GoalProgressType;
                  readonly id: number;
                  readonly canUpdate: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | { readonly __typename: "KPIArtifactNode"; readonly id: number }
              | {
                  readonly __typename: "RatingArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "RecognitionArtifactNode";
                  readonly id: number;
                }
              | null;
          } | null>;
        } | null;
        readonly mostRecentlyReceivedRecognition?: {
          readonly __typename: "RecognitionArtifactNode";
          readonly id: number;
          readonly artifactType: ArtifactType;
          readonly created: string;
        } | null;
      } | null;
    } | null>;
  };
};

export type SetRelationshipsMutationMutationVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  relationships?: InputMaybe<
    ReadonlyArray<InputMaybe<RelationshipInput>> | InputMaybe<RelationshipInput>
  >;
  userId: Scalars["Int"]["input"];
  favouriteUserIds:
    | ReadonlyArray<
        | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
        | InputMaybe<Scalars["Int"]["input"]>
      >
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>;
  invitations:
    | ReadonlyArray<InputMaybe<InvitationInput>>
    | InputMaybe<InvitationInput>;
}>;

export type SetRelationshipsMutationMutation = {
  readonly __typename: "Mutation";
  readonly setRelationships?: {
    readonly __typename: "SetRelationshipsMutation";
    readonly me?: {
      readonly __typename: "UserNode";
      readonly id: number;
    } | null;
  } | null;
  readonly setFavouriteGroups?: {
    readonly __typename: "SetFavouriteGroupsMutation";
    readonly me?: {
      readonly __typename: "UserNode";
      readonly id: number;
    } | null;
  } | null;
  readonly createInvitations?: {
    readonly __typename: "CreateInvitationsMutation";
    readonly invitationErrors?: ReadonlyArray<{
      readonly __typename: "InviteError";
      readonly inviteeEmail?: string | null;
      readonly message?: string | null;
    } | null> | null;
  } | null;
};

export type EngagementSurveyProgramAssessmentTemplateFragment = {
  readonly __typename: "AssessmentTemplateNode";
  readonly id: number;
  readonly assessmentType: AssessmentType;
};

export type EngagementSurveyComplianceProgramFragment = {
  readonly __typename: "ComplianceProgramNode";
  readonly id: number;
  readonly title: string;
  readonly dueDate?: string | null;
  readonly canReadDetails: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  };
  readonly usersMissingAssessment: {
    readonly __typename: "MissingAssessmentConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "MissingAssessmentEdge";
      readonly node?: {
        readonly __typename: "MissingAssessmentNode";
        readonly assessmentTemplateId?: number | null;
        readonly dueDate: string;
        readonly target?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly responder: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        };
      } | null;
    } | null>;
  };
  readonly engagementSurveyTemplate?: {
    readonly __typename: "AssessmentTemplateNode";
    readonly id: number;
    readonly assessmentType: AssessmentType;
  } | null;
  readonly assessments: {
    readonly __typename: "AssessmentNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "AssessmentNodeEdge";
      readonly node?: {
        readonly __typename: "AssessmentNode";
        readonly id: number;
        readonly state: AssessmentState;
        readonly submittedDatetime?: string | null;
        readonly target?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly responder?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly template: {
          readonly __typename: "AssessmentTemplateNode";
          readonly id: number;
        };
      } | null;
    } | null>;
  };
};

export type GetActiveEngagementSurveyActionsQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  currentUserId: Scalars["Int"]["input"];
}>;

export type GetActiveEngagementSurveyActionsQuery = {
  readonly __typename: "Query";
  readonly compliancePrograms: {
    readonly __typename: "ComplianceProgramNodeConnection";
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly endCursor?: string | null;
      readonly hasNextPage: boolean;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "ComplianceProgramNodeEdge";
      readonly node?: {
        readonly __typename: "ComplianceProgramNode";
        readonly id: number;
        readonly title: string;
        readonly dueDate?: string | null;
        readonly canReadDetails: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
          readonly reason: string;
        };
        readonly usersMissingAssessment: {
          readonly __typename: "MissingAssessmentConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "MissingAssessmentEdge";
            readonly node?: {
              readonly __typename: "MissingAssessmentNode";
              readonly assessmentTemplateId?: number | null;
              readonly dueDate: string;
              readonly target?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly responder: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              };
            } | null;
          } | null>;
        };
        readonly engagementSurveyTemplate?: {
          readonly __typename: "AssessmentTemplateNode";
          readonly id: number;
          readonly assessmentType: AssessmentType;
        } | null;
        readonly assessments: {
          readonly __typename: "AssessmentNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "AssessmentNodeEdge";
            readonly node?: {
              readonly __typename: "AssessmentNode";
              readonly id: number;
              readonly state: AssessmentState;
              readonly submittedDatetime?: string | null;
              readonly target?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly template: {
                readonly __typename: "AssessmentTemplateNode";
                readonly id: number;
              };
            } | null;
          } | null>;
        };
      } | null;
    } | null>;
  };
};

type EngagementSurveyDeliveryAssessmentGroupSection_AssessmentGroupSectionNode_Fragment =
  {
    readonly __typename: "AssessmentGroupSectionNode";
    readonly id: number;
    readonly title?: string | null;
    readonly description?: any | null;
    readonly subjectVisibility: AssessmentSectionSubjectVisibility;
    readonly questions: {
      readonly __typename: "AssessmentGroupQuestionContainerConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AssessmentGroupQuestionContainerEdge";
        readonly node?: {
          readonly __typename: "AssessmentGroupQuestionContainer";
          readonly id: number;
          readonly question:
            | {
                readonly __typename: "CompetencyAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly role: {
                  readonly __typename: "CareerTrackRoleNode";
                  readonly id: number;
                  readonly title: string;
                  readonly level: number;
                };
                readonly competency: {
                  readonly __typename: "CompetencyNode";
                  readonly id: number;
                  readonly title: string;
                  readonly criteria: {
                    readonly __typename: "CompetencyCriteriaConnection";
                    readonly edges: ReadonlyArray<{
                      readonly __typename: "CompetencyCriteriaEdge";
                      readonly node?: {
                        readonly __typename: "CompetencyCriteriaNode";
                        readonly id: number;
                        readonly content: any;
                      } | null;
                    } | null>;
                  };
                };
              }
            | {
                readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly role: {
                  readonly __typename: "CareerTrackRoleNode";
                  readonly id: number;
                  readonly title: string;
                  readonly level: number;
                };
                readonly competencyCriteria: {
                  readonly __typename: "CompetencyCriteriaNode";
                  readonly id: number;
                  readonly content: any;
                  readonly competency: {
                    readonly __typename: "CompetencyNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description: any;
                  };
                };
              }
            | {
                readonly __typename: "IndividualGoalAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly goal?: {
                  readonly __typename: "GoalArtifactNode";
                  readonly id: number;
                  readonly artifactType: ArtifactType;
                  readonly startValue: number;
                  readonly currentValue: number;
                  readonly targetValue: number;
                  readonly progress: number;
                  readonly progressType: GoalProgressType;
                  readonly dueDate?: string | null;
                  readonly startDate?: string | null;
                  readonly state: GoalState;
                  readonly status: GoalStatus;
                  readonly scope: GoalScope;
                  readonly goalVisibility: GoalVisibility;
                  readonly created: string;
                  readonly parentGoalId?: number | null;
                  readonly ownerCount?: number | null;
                  readonly contributorCount?: number | null;
                  readonly isStale: boolean;
                  readonly title?: string | null;
                  readonly updated?: string | null;
                  readonly firstOwner?: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly avatar?: string | null;
                    readonly name: string;
                  } | null;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                  readonly canUpdate: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                  readonly canRead: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                  readonly creator?: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly name: string;
                    readonly avatar?: string | null;
                  } | null;
                } | null;
              }
            | {
                readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly coreValue?: {
                  readonly __typename: "RecognitionCoreValueNode";
                  readonly id: number;
                  readonly title: string;
                  readonly description: string;
                  readonly emoji?: string | null;
                  readonly image?: string | null;
                } | null;
              }
            | {
                readonly __typename: "MultiChoiceAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly options: ReadonlyArray<string | null>;
                readonly optionDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              }
            | {
                readonly __typename: "NpsAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              }
            | {
                readonly __typename: "OverallGoalAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              }
            | {
                readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              }
            | {
                readonly __typename: "RangeAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              }
            | {
                readonly __typename: "ResponsibilityAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly responsibility?: {
                  readonly __typename: "CareerTrackRoleResponsibilityNode";
                  readonly id: number;
                  readonly content: any;
                  readonly role: {
                    readonly __typename: "CareerTrackRoleNode";
                    readonly id: number;
                    readonly title: string;
                    readonly level: number;
                  };
                } | null;
              }
            | {
                readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly talentIndicator?: {
                  readonly __typename: "TalentIndicatorNode";
                  readonly id: number;
                  readonly talentIndicatorType: TalentIndicatorType;
                } | null;
              }
            | {
                readonly __typename: "TextAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              };
        } | null;
      } | null>;
    };
  };

type EngagementSurveyDeliveryAssessmentGroupSection_VirtualAssessmentSectionNode_Fragment =
  {
    readonly __typename: "VirtualAssessmentSectionNode";
    readonly id: number;
    readonly title?: string | null;
    readonly description?: any | null;
    readonly subjectVisibility: AssessmentSectionSubjectVisibility;
    readonly questions: {
      readonly __typename: "AssessmentGroupQuestionContainerConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AssessmentGroupQuestionContainerEdge";
        readonly node?: {
          readonly __typename: "AssessmentGroupQuestionContainer";
          readonly id: number;
          readonly question:
            | {
                readonly __typename: "CompetencyAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly role: {
                  readonly __typename: "CareerTrackRoleNode";
                  readonly id: number;
                  readonly title: string;
                  readonly level: number;
                };
                readonly competency: {
                  readonly __typename: "CompetencyNode";
                  readonly id: number;
                  readonly title: string;
                  readonly criteria: {
                    readonly __typename: "CompetencyCriteriaConnection";
                    readonly edges: ReadonlyArray<{
                      readonly __typename: "CompetencyCriteriaEdge";
                      readonly node?: {
                        readonly __typename: "CompetencyCriteriaNode";
                        readonly id: number;
                        readonly content: any;
                      } | null;
                    } | null>;
                  };
                };
              }
            | {
                readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly role: {
                  readonly __typename: "CareerTrackRoleNode";
                  readonly id: number;
                  readonly title: string;
                  readonly level: number;
                };
                readonly competencyCriteria: {
                  readonly __typename: "CompetencyCriteriaNode";
                  readonly id: number;
                  readonly content: any;
                  readonly competency: {
                    readonly __typename: "CompetencyNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description: any;
                  };
                };
              }
            | {
                readonly __typename: "IndividualGoalAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly goal?: {
                  readonly __typename: "GoalArtifactNode";
                  readonly id: number;
                  readonly artifactType: ArtifactType;
                  readonly startValue: number;
                  readonly currentValue: number;
                  readonly targetValue: number;
                  readonly progress: number;
                  readonly progressType: GoalProgressType;
                  readonly dueDate?: string | null;
                  readonly startDate?: string | null;
                  readonly state: GoalState;
                  readonly status: GoalStatus;
                  readonly scope: GoalScope;
                  readonly goalVisibility: GoalVisibility;
                  readonly created: string;
                  readonly parentGoalId?: number | null;
                  readonly ownerCount?: number | null;
                  readonly contributorCount?: number | null;
                  readonly isStale: boolean;
                  readonly title?: string | null;
                  readonly updated?: string | null;
                  readonly firstOwner?: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly avatar?: string | null;
                    readonly name: string;
                  } | null;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                  readonly canUpdate: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                  readonly canRead: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                  readonly creator?: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly name: string;
                    readonly avatar?: string | null;
                  } | null;
                } | null;
              }
            | {
                readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly coreValue?: {
                  readonly __typename: "RecognitionCoreValueNode";
                  readonly id: number;
                  readonly title: string;
                  readonly description: string;
                  readonly emoji?: string | null;
                  readonly image?: string | null;
                } | null;
              }
            | {
                readonly __typename: "MultiChoiceAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly options: ReadonlyArray<string | null>;
                readonly optionDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              }
            | {
                readonly __typename: "NpsAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              }
            | {
                readonly __typename: "OverallGoalAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              }
            | {
                readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              }
            | {
                readonly __typename: "RangeAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              }
            | {
                readonly __typename: "ResponsibilityAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly responsibility?: {
                  readonly __typename: "CareerTrackRoleResponsibilityNode";
                  readonly id: number;
                  readonly content: any;
                  readonly role: {
                    readonly __typename: "CareerTrackRoleNode";
                    readonly id: number;
                    readonly title: string;
                    readonly level: number;
                  };
                } | null;
              }
            | {
                readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly startValue: number;
                readonly endValue: number;
                readonly labels: ReadonlyArray<string | null>;
                readonly labelDescriptions: ReadonlyArray<string | null>;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly talentIndicator?: {
                  readonly __typename: "TalentIndicatorNode";
                  readonly id: number;
                  readonly talentIndicatorType: TalentIndicatorType;
                } | null;
              }
            | {
                readonly __typename: "TextAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
                readonly description?: any | null;
                readonly comment: AssessmentQuestionComment;
                readonly isResponseMandatory: boolean;
                readonly responses: AssessmentQuestionResponses;
                readonly questionType: AssessmentQuestionType;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              };
        } | null;
      } | null>;
    };
  };

export type EngagementSurveyDeliveryAssessmentGroupSectionFragment =
  | EngagementSurveyDeliveryAssessmentGroupSection_AssessmentGroupSectionNode_Fragment
  | EngagementSurveyDeliveryAssessmentGroupSection_VirtualAssessmentSectionNode_Fragment;

export type EngagementSurveyDeliveryFragment = {
  readonly __typename: "AssessmentDeliveryNode";
  readonly id: number;
  readonly state: AssessmentDeliveryState;
  readonly deliveryDatetime?: string | null;
  readonly dueDate?: string | null;
  readonly periodStartDate?: string | null;
  readonly periodEndDate?: string | null;
  readonly canUpdate?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  } | null;
  readonly complianceProgram?: {
    readonly __typename: "ComplianceProgramNode";
    readonly id: number;
    readonly title: string;
    readonly hasAccessToAppliesToUsers: boolean;
    readonly periodStartDate?: string | null;
    readonly periodEndDate?: string | null;
    readonly canReadDetails: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    };
    readonly engagementSurveyTemplate?: {
      readonly __typename: "AssessmentTemplateNode";
      readonly id: number;
      readonly assessmentType: AssessmentType;
      readonly anonymity: AssessmentGroupAnonymity;
      readonly questionSets: {
        readonly __typename: "AssessmentGroupNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentGroupNodeEdge";
          readonly node?: {
            readonly __typename: "AssessmentGroupNode";
            readonly id: number;
            readonly title: string;
            readonly sections: {
              readonly __typename: "AssessmentGroupSectionNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "AssessmentGroupSectionNodeEdge";
                readonly node?: {
                  readonly __typename: "AssessmentGroupSectionNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly description?: any | null;
                  readonly subjectVisibility: AssessmentSectionSubjectVisibility;
                  readonly questions: {
                    readonly __typename: "AssessmentGroupQuestionContainerConnection";
                    readonly edges: ReadonlyArray<{
                      readonly __typename: "AssessmentGroupQuestionContainerEdge";
                      readonly node?: {
                        readonly __typename: "AssessmentGroupQuestionContainer";
                        readonly id: number;
                        readonly question:
                          | {
                              readonly __typename: "CompetencyAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly role: {
                                readonly __typename: "CareerTrackRoleNode";
                                readonly id: number;
                                readonly title: string;
                                readonly level: number;
                              };
                              readonly competency: {
                                readonly __typename: "CompetencyNode";
                                readonly id: number;
                                readonly title: string;
                                readonly criteria: {
                                  readonly __typename: "CompetencyCriteriaConnection";
                                  readonly edges: ReadonlyArray<{
                                    readonly __typename: "CompetencyCriteriaEdge";
                                    readonly node?: {
                                      readonly __typename: "CompetencyCriteriaNode";
                                      readonly id: number;
                                      readonly content: any;
                                    } | null;
                                  } | null>;
                                };
                              };
                            }
                          | {
                              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly role: {
                                readonly __typename: "CareerTrackRoleNode";
                                readonly id: number;
                                readonly title: string;
                                readonly level: number;
                              };
                              readonly competencyCriteria: {
                                readonly __typename: "CompetencyCriteriaNode";
                                readonly id: number;
                                readonly content: any;
                                readonly competency: {
                                  readonly __typename: "CompetencyNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly description: any;
                                };
                              };
                            }
                          | {
                              readonly __typename: "IndividualGoalAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly goal?: {
                                readonly __typename: "GoalArtifactNode";
                                readonly id: number;
                                readonly artifactType: ArtifactType;
                                readonly startValue: number;
                                readonly currentValue: number;
                                readonly targetValue: number;
                                readonly progress: number;
                                readonly progressType: GoalProgressType;
                                readonly dueDate?: string | null;
                                readonly startDate?: string | null;
                                readonly state: GoalState;
                                readonly status: GoalStatus;
                                readonly scope: GoalScope;
                                readonly goalVisibility: GoalVisibility;
                                readonly created: string;
                                readonly parentGoalId?: number | null;
                                readonly ownerCount?: number | null;
                                readonly contributorCount?: number | null;
                                readonly isStale: boolean;
                                readonly title?: string | null;
                                readonly updated?: string | null;
                                readonly firstOwner?: {
                                  readonly __typename: "UserNode";
                                  readonly id: number;
                                  readonly avatar?: string | null;
                                  readonly name: string;
                                } | null;
                                readonly canDelete: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly canUpdate: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly canRead: {
                                  readonly __typename: "PermissionNode";
                                  readonly permission: boolean;
                                };
                                readonly creator?: {
                                  readonly __typename: "UserNode";
                                  readonly id: number;
                                  readonly name: string;
                                  readonly avatar?: string | null;
                                } | null;
                              } | null;
                            }
                          | {
                              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly coreValue?: {
                                readonly __typename: "RecognitionCoreValueNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description: string;
                                readonly emoji?: string | null;
                                readonly image?: string | null;
                              } | null;
                            }
                          | {
                              readonly __typename: "MultiChoiceAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly options: ReadonlyArray<string | null>;
                              readonly optionDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "NpsAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "OverallGoalAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "RangeAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            }
                          | {
                              readonly __typename: "ResponsibilityAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly responsibility?: {
                                readonly __typename: "CareerTrackRoleResponsibilityNode";
                                readonly id: number;
                                readonly content: any;
                                readonly role: {
                                  readonly __typename: "CareerTrackRoleNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly level: number;
                                };
                              } | null;
                            }
                          | {
                              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              readonly talentIndicator?: {
                                readonly __typename: "TalentIndicatorNode";
                                readonly id: number;
                                readonly talentIndicatorType: TalentIndicatorType;
                              } | null;
                            }
                          | {
                              readonly __typename: "TextAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly comment: AssessmentQuestionComment;
                              readonly isResponseMandatory: boolean;
                              readonly responses: AssessmentQuestionResponses;
                              readonly questionType: AssessmentQuestionType;
                              readonly responseVisibility: AssessmentQuestionResponseVisibility;
                            };
                      } | null;
                    } | null>;
                  };
                } | null;
              } | null>;
            };
          } | null;
        } | null>;
      };
    } | null;
  } | null;
  readonly answers: {
    readonly __typename: "AssessmentAnswerConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "AssessmentAnswerEdge";
      readonly node?:
        | {
            readonly __typename: "CompetencyAssessmentAnswerNode";
            readonly id: number;
            readonly questionId: number;
          }
        | {
            readonly __typename: "CompetencyCriteriaAssessmentAnswerNode";
            readonly id: number;
            readonly questionId: number;
          }
        | {
            readonly __typename: "IndividualGoalAssessmentAnswerNode";
            readonly id: number;
            readonly questionId: number;
          }
        | {
            readonly __typename: "IndividualRecognitionCoreValueAssessmentAnswerNode";
            readonly id: number;
            readonly questionId: number;
          }
        | {
            readonly __typename: "MultiChoiceAssessmentAnswerNode";
            readonly id: number;
            readonly questionId: number;
            readonly choices: ReadonlyArray<number | null>;
            readonly comment?: any | null;
            readonly responder?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly email: string;
              readonly firstName: string;
              readonly avatar?: string | null;
            } | null;
          }
        | {
            readonly __typename: "NpsAssessmentAnswerNode";
            readonly id: number;
            readonly questionId: number;
            readonly integerAnswer?: number | null;
            readonly npsValue?: NpsAnswerValue | null;
            readonly comment?: any | null;
            readonly responder?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly email: string;
              readonly firstName: string;
              readonly avatar?: string | null;
            } | null;
          }
        | {
            readonly __typename: "OverallGoalAssessmentAnswerNode";
            readonly id: number;
            readonly questionId: number;
          }
        | {
            readonly __typename: "OverallRecognitionCoreValueAssessmentAnswerNode";
            readonly id: number;
            readonly questionId: number;
          }
        | {
            readonly __typename: "RangeAssessmentAnswerNode";
            readonly id: number;
            readonly questionId: number;
            readonly integerAnswer?: number | null;
            readonly comment?: any | null;
            readonly responder?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly email: string;
              readonly firstName: string;
              readonly avatar?: string | null;
            } | null;
          }
        | {
            readonly __typename: "ResponsibilityAssessmentAnswerNode";
            readonly id: number;
            readonly questionId: number;
          }
        | {
            readonly __typename: "TalentIndicatorAssessmentAnswerNode";
            readonly id: number;
            readonly questionId: number;
          }
        | {
            readonly __typename: "TextAssessmentAnswerNode";
            readonly id: number;
            readonly questionId: number;
            readonly textAnswer?: any | null;
            readonly comment?: any | null;
            readonly responder?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly email: string;
              readonly firstName: string;
              readonly avatar?: string | null;
            } | null;
          }
        | null;
    } | null>;
  };
  readonly groupedAnswers?: ReadonlyArray<{
    readonly __typename: "GroupedAnswersNode";
    readonly groupKey: string;
    readonly groupLabel: string;
    readonly rollupType: EngagementSurveyRollupType;
    readonly questionId: number;
    readonly answerIds: ReadonlyArray<number | null>;
    readonly numberResponders: number;
    readonly numberComments: number;
    readonly isHidden: boolean;
    readonly isCollapsed: boolean;
  } | null> | null;
};

export type GetDeliveredEngagementSurveyQueryVariables = Exact<{
  assessmentDeliveryId: Scalars["IntOrString"]["input"];
  teamIds?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  managerIds?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  managerIdsFullTree?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  employeeStartDateRange?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
  locations?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
  groupBy?: InputMaybe<EngagementSurveyReportGroupBy>;
  collapsedKeys?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
}>;

export type GetDeliveredEngagementSurveyQuery = {
  readonly __typename: "Query";
  readonly assessmentDelivery?: {
    readonly __typename: "AssessmentDeliveryNode";
    readonly id: number;
    readonly state: AssessmentDeliveryState;
    readonly deliveryDatetime?: string | null;
    readonly dueDate?: string | null;
    readonly periodStartDate?: string | null;
    readonly periodEndDate?: string | null;
    readonly canUpdate?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    } | null;
    readonly complianceProgram?: {
      readonly __typename: "ComplianceProgramNode";
      readonly id: number;
      readonly title: string;
      readonly hasAccessToAppliesToUsers: boolean;
      readonly periodStartDate?: string | null;
      readonly periodEndDate?: string | null;
      readonly canReadDetails: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
        readonly reason: string;
      };
      readonly engagementSurveyTemplate?: {
        readonly __typename: "AssessmentTemplateNode";
        readonly id: number;
        readonly assessmentType: AssessmentType;
        readonly anonymity: AssessmentGroupAnonymity;
        readonly questionSets: {
          readonly __typename: "AssessmentGroupNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "AssessmentGroupNodeEdge";
            readonly node?: {
              readonly __typename: "AssessmentGroupNode";
              readonly id: number;
              readonly title: string;
              readonly sections: {
                readonly __typename: "AssessmentGroupSectionNodeConnection";
                readonly edges: ReadonlyArray<{
                  readonly __typename: "AssessmentGroupSectionNodeEdge";
                  readonly node?: {
                    readonly __typename: "AssessmentGroupSectionNode";
                    readonly id: number;
                    readonly title?: string | null;
                    readonly description?: any | null;
                    readonly subjectVisibility: AssessmentSectionSubjectVisibility;
                    readonly questions: {
                      readonly __typename: "AssessmentGroupQuestionContainerConnection";
                      readonly edges: ReadonlyArray<{
                        readonly __typename: "AssessmentGroupQuestionContainerEdge";
                        readonly node?: {
                          readonly __typename: "AssessmentGroupQuestionContainer";
                          readonly id: number;
                          readonly question:
                            | {
                                readonly __typename: "CompetencyAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                                readonly role: {
                                  readonly __typename: "CareerTrackRoleNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly level: number;
                                };
                                readonly competency: {
                                  readonly __typename: "CompetencyNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly criteria: {
                                    readonly __typename: "CompetencyCriteriaConnection";
                                    readonly edges: ReadonlyArray<{
                                      readonly __typename: "CompetencyCriteriaEdge";
                                      readonly node?: {
                                        readonly __typename: "CompetencyCriteriaNode";
                                        readonly id: number;
                                        readonly content: any;
                                      } | null;
                                    } | null>;
                                  };
                                };
                              }
                            | {
                                readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                                readonly role: {
                                  readonly __typename: "CareerTrackRoleNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly level: number;
                                };
                                readonly competencyCriteria: {
                                  readonly __typename: "CompetencyCriteriaNode";
                                  readonly id: number;
                                  readonly content: any;
                                  readonly competency: {
                                    readonly __typename: "CompetencyNode";
                                    readonly id: number;
                                    readonly title: string;
                                    readonly description: any;
                                  };
                                };
                              }
                            | {
                                readonly __typename: "IndividualGoalAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                                readonly goal?: {
                                  readonly __typename: "GoalArtifactNode";
                                  readonly id: number;
                                  readonly artifactType: ArtifactType;
                                  readonly startValue: number;
                                  readonly currentValue: number;
                                  readonly targetValue: number;
                                  readonly progress: number;
                                  readonly progressType: GoalProgressType;
                                  readonly dueDate?: string | null;
                                  readonly startDate?: string | null;
                                  readonly state: GoalState;
                                  readonly status: GoalStatus;
                                  readonly scope: GoalScope;
                                  readonly goalVisibility: GoalVisibility;
                                  readonly created: string;
                                  readonly parentGoalId?: number | null;
                                  readonly ownerCount?: number | null;
                                  readonly contributorCount?: number | null;
                                  readonly isStale: boolean;
                                  readonly title?: string | null;
                                  readonly updated?: string | null;
                                  readonly firstOwner?: {
                                    readonly __typename: "UserNode";
                                    readonly id: number;
                                    readonly avatar?: string | null;
                                    readonly name: string;
                                  } | null;
                                  readonly canDelete: {
                                    readonly __typename: "PermissionNode";
                                    readonly permission: boolean;
                                  };
                                  readonly canUpdate: {
                                    readonly __typename: "PermissionNode";
                                    readonly permission: boolean;
                                  };
                                  readonly canRead: {
                                    readonly __typename: "PermissionNode";
                                    readonly permission: boolean;
                                  };
                                  readonly creator?: {
                                    readonly __typename: "UserNode";
                                    readonly id: number;
                                    readonly name: string;
                                    readonly avatar?: string | null;
                                  } | null;
                                } | null;
                              }
                            | {
                                readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                                readonly coreValue?: {
                                  readonly __typename: "RecognitionCoreValueNode";
                                  readonly id: number;
                                  readonly title: string;
                                  readonly description: string;
                                  readonly emoji?: string | null;
                                  readonly image?: string | null;
                                } | null;
                              }
                            | {
                                readonly __typename: "MultiChoiceAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly options: ReadonlyArray<string | null>;
                                readonly optionDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              }
                            | {
                                readonly __typename: "NpsAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              }
                            | {
                                readonly __typename: "OverallGoalAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              }
                            | {
                                readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              }
                            | {
                                readonly __typename: "RangeAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              }
                            | {
                                readonly __typename: "ResponsibilityAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                                readonly responsibility?: {
                                  readonly __typename: "CareerTrackRoleResponsibilityNode";
                                  readonly id: number;
                                  readonly content: any;
                                  readonly role: {
                                    readonly __typename: "CareerTrackRoleNode";
                                    readonly id: number;
                                    readonly title: string;
                                    readonly level: number;
                                  };
                                } | null;
                              }
                            | {
                                readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly startValue: number;
                                readonly endValue: number;
                                readonly labels: ReadonlyArray<string | null>;
                                readonly labelDescriptions: ReadonlyArray<
                                  string | null
                                >;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                                readonly talentIndicator?: {
                                  readonly __typename: "TalentIndicatorNode";
                                  readonly id: number;
                                  readonly talentIndicatorType: TalentIndicatorType;
                                } | null;
                              }
                            | {
                                readonly __typename: "TextAssessmentQuestionNode";
                                readonly id: number;
                                readonly title: string;
                                readonly description?: any | null;
                                readonly comment: AssessmentQuestionComment;
                                readonly isResponseMandatory: boolean;
                                readonly responses: AssessmentQuestionResponses;
                                readonly questionType: AssessmentQuestionType;
                                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                              };
                        } | null;
                      } | null>;
                    };
                  } | null;
                } | null>;
              };
            } | null;
          } | null>;
        };
      } | null;
    } | null;
    readonly answers: {
      readonly __typename: "AssessmentAnswerConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AssessmentAnswerEdge";
        readonly node?:
          | {
              readonly __typename: "CompetencyAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
            }
          | {
              readonly __typename: "CompetencyCriteriaAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
            }
          | {
              readonly __typename: "IndividualGoalAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
            }
          | {
              readonly __typename: "IndividualRecognitionCoreValueAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
            }
          | {
              readonly __typename: "MultiChoiceAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
              readonly choices: ReadonlyArray<number | null>;
              readonly comment?: any | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly email: string;
                readonly firstName: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "NpsAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
              readonly integerAnswer?: number | null;
              readonly npsValue?: NpsAnswerValue | null;
              readonly comment?: any | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly email: string;
                readonly firstName: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "OverallGoalAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
            }
          | {
              readonly __typename: "OverallRecognitionCoreValueAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
            }
          | {
              readonly __typename: "RangeAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
              readonly integerAnswer?: number | null;
              readonly comment?: any | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly email: string;
                readonly firstName: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "ResponsibilityAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
            }
          | {
              readonly __typename: "TalentIndicatorAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
            }
          | {
              readonly __typename: "TextAssessmentAnswerNode";
              readonly id: number;
              readonly questionId: number;
              readonly textAnswer?: any | null;
              readonly comment?: any | null;
              readonly responder?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly email: string;
                readonly firstName: string;
                readonly avatar?: string | null;
              } | null;
            }
          | null;
      } | null>;
    };
    readonly groupedAnswers?: ReadonlyArray<{
      readonly __typename: "GroupedAnswersNode";
      readonly groupKey: string;
      readonly groupLabel: string;
      readonly rollupType: EngagementSurveyRollupType;
      readonly questionId: number;
      readonly answerIds: ReadonlyArray<number | null>;
      readonly numberResponders: number;
      readonly numberComments: number;
      readonly isHidden: boolean;
      readonly isCollapsed: boolean;
    } | null> | null;
  } | null;
};

export type GetDeliveredEngagementSurveysQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
  orderBy: Scalars["String"]["input"];
}>;

export type GetDeliveredEngagementSurveysQuery = {
  readonly __typename: "Query";
  readonly engagementSurveyDeliveries: {
    readonly __typename: "AssessmentDeliveryNodeConnection";
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly endCursor?: string | null;
      readonly hasNextPage: boolean;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "AssessmentDeliveryNodeEdge";
      readonly node?: {
        readonly __typename: "AssessmentDeliveryNode";
        readonly id: number;
        readonly deliveryDatetime?: string | null;
        readonly lastSubmissionDatetime?: string | null;
        readonly target?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly email: string;
          readonly firstName: string;
          readonly avatar?: string | null;
        } | null;
        readonly complianceProgram?: {
          readonly __typename: "ComplianceProgramNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null;
    } | null>;
  };
};

export type DeleteExplorerBookmarkMutationMutationVariables = Exact<{
  explorerBookmarkId: Scalars["Int"]["input"];
}>;

export type DeleteExplorerBookmarkMutationMutation = {
  readonly __typename: "Mutation";
  readonly deleteExplorerBookmark?: {
    readonly __typename: "DeleteExplorerBookmark";
    readonly user?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly explorerBookmarks?: {
        readonly __typename: "ExplorerFilterBookmarkNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "ExplorerFilterBookmarkNodeEdge";
          readonly node?: {
            readonly __typename: "ExplorerFilterBookmarkNode";
            readonly id: number;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type ExportExplorerToCsvMutationVariables = Exact<{
  search: Scalars["String"]["input"];
  options?: InputMaybe<SearchOptions>;
}>;

export type ExportExplorerToCsvMutation = {
  readonly __typename: "Mutation";
  readonly searchCsvExport?: {
    readonly __typename: "SearchCSVExportMutation";
    readonly user?: {
      readonly __typename: "UserNode";
      readonly email: string;
    } | null;
  } | null;
};

export type GetArtifactExplorerMeetingGroupQueryQueryVariables = Exact<{
  meetingGroupId: Scalars["Int"]["input"];
  search?: InputMaybe<Scalars["String"]["input"]>;
  fetchMeetingGroup: Scalars["Boolean"]["input"];
  organizationId: Scalars["Int"]["input"];
}>;

export type GetArtifactExplorerMeetingGroupQueryQuery = {
  readonly __typename: "Query";
  readonly meetingGroups?: {
    readonly __typename: "MeetingGroupNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "MeetingGroupNodeEdge";
      readonly node?: {
        readonly __typename: "MeetingGroupNode";
        readonly id: number;
        readonly recurrenceRule?: string | null;
        readonly meetings?: {
          readonly __typename: "MeetingNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "MeetingNodeEdge";
            readonly node?: {
              readonly __typename: "MeetingNode";
              readonly id: number;
              readonly meetingGroupId: number;
              readonly title?: string | null;
              readonly startDatetime?: string | null;
            } | null;
          } | null>;
        } | null;
      } | null;
    } | null>;
  } | null;
  readonly meetingGroup?: {
    readonly __typename: "MeetingGroupNode";
    readonly id: number;
    readonly recurrenceRule?: string | null;
    readonly meetings?: {
      readonly __typename: "MeetingNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "MeetingNodeEdge";
        readonly node?: {
          readonly __typename: "MeetingNode";
          readonly id: number;
          readonly meetingGroupId: number;
          readonly title?: string | null;
          readonly startDatetime?: string | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetArtifactExplorerTeamsQueryQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
}>;

export type GetArtifactExplorerTeamsQueryQuery = {
  readonly __typename: "Query";
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
    readonly teams?: {
      readonly __typename: "TeamNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "TeamNodeEdge";
        readonly node?: {
          readonly __typename: "TeamNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type ExplorerMeetingResultFragmentFragment = {
  readonly __typename: "MeetingWithRelevantSectionsNode";
  readonly meeting?: {
    readonly __typename: "MeetingNode";
    readonly id: number;
    readonly title?: string | null;
    readonly startDatetime?: string | null;
    readonly meetingGroupId: number;
    readonly meetingGroup?: {
      readonly __typename: "MeetingGroupNode";
      readonly id: number;
      readonly isFormalOneonone: boolean;
    } | null;
    readonly participants?: {
      readonly __typename: "MeetingParticipantConnection";
      readonly totalCount: number;
      readonly edges: ReadonlyArray<{
        readonly __typename: "MeetingParticipantEdge";
        readonly node?: {
          readonly __typename: "MeetingParticipantNode";
          readonly id?: string | null;
          readonly user?: {
            readonly __typename: "BasicUserNode";
            readonly id: number;
            readonly name: string;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type ExplorerBaseArtifactFragmentFragment = {
  readonly __typename: "BaseArtifactNode";
  readonly id: number;
  readonly specificArtifact?:
    | {
        readonly __typename: "ActionItemArtifactNode";
        readonly isComplete?: boolean | null;
        readonly actionItemState?: number | null;
        readonly dueDate?: string | null;
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
        readonly created: string;
        readonly updated?: string | null;
        readonly assignee?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly avatar?: string | null;
          readonly name: string;
        } | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "AsanaTaskArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
        readonly created: string;
        readonly updated?: string | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "DecisionArtifactNode";
        readonly decision: string;
        readonly decisionState?: DecisionState | null;
        readonly isDraft?: boolean | null;
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
        readonly created: string;
        readonly updated?: string | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "DocumentArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
        readonly created: string;
        readonly updated?: string | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "FeedbackArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
        readonly created: string;
        readonly updated?: string | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "GithubIssuesArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
        readonly created: string;
        readonly updated?: string | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "GoalArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
        readonly created: string;
        readonly updated?: string | null;
        readonly startValue: number;
        readonly currentValue: number;
        readonly targetValue: number;
        readonly progress: number;
        readonly progressType: GoalProgressType;
        readonly dueDate?: string | null;
        readonly startDate?: string | null;
        readonly state: GoalState;
        readonly status: GoalStatus;
        readonly scope: GoalScope;
        readonly goalVisibility: GoalVisibility;
        readonly parentGoalId?: number | null;
        readonly ownerCount?: number | null;
        readonly contributorCount?: number | null;
        readonly isStale: boolean;
        readonly activities: {
          readonly __typename: "ArtifactActivityNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactActivityNodeEdge";
            readonly node?: {
              readonly __typename: "ArtifactActivityNode";
              readonly created: string;
            } | null;
          } | null>;
        };
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly firstOwner?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly avatar?: string | null;
          readonly name: string;
        } | null;
        readonly canRead: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "KPIArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
        readonly created: string;
        readonly updated?: string | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "RatingArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
        readonly created: string;
        readonly updated?: string | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "RecognitionArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
        readonly created: string;
        readonly updated?: string | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly recipients?: {
          readonly __typename: "UserNodeConnection";
          readonly totalCount: number;
          readonly edges: ReadonlyArray<{
            readonly __typename: "UserNodeEdge";
            readonly node?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          } | null>;
        } | null;
        readonly recognitionCoreValue?: {
          readonly __typename: "RecognitionCoreValueNode";
          readonly id: number;
          readonly title: string;
          readonly description: string;
          readonly emoji?: string | null;
          readonly image?: string | null;
        } | null;
      }
    | null;
};

type ExplorerResultFragment_BaseArtifactNode_Fragment = {
  readonly __typename: "BaseArtifactNode";
  readonly id: number;
  readonly specificArtifact?:
    | {
        readonly __typename: "ActionItemArtifactNode";
        readonly isComplete?: boolean | null;
        readonly actionItemState?: number | null;
        readonly dueDate?: string | null;
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
        readonly created: string;
        readonly updated?: string | null;
        readonly assignee?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly avatar?: string | null;
          readonly name: string;
        } | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "AsanaTaskArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
        readonly created: string;
        readonly updated?: string | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "DecisionArtifactNode";
        readonly decision: string;
        readonly decisionState?: DecisionState | null;
        readonly isDraft?: boolean | null;
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
        readonly created: string;
        readonly updated?: string | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "DocumentArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
        readonly created: string;
        readonly updated?: string | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "FeedbackArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
        readonly created: string;
        readonly updated?: string | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "GithubIssuesArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
        readonly created: string;
        readonly updated?: string | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "GoalArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
        readonly created: string;
        readonly updated?: string | null;
        readonly startValue: number;
        readonly currentValue: number;
        readonly targetValue: number;
        readonly progress: number;
        readonly progressType: GoalProgressType;
        readonly dueDate?: string | null;
        readonly startDate?: string | null;
        readonly state: GoalState;
        readonly status: GoalStatus;
        readonly scope: GoalScope;
        readonly goalVisibility: GoalVisibility;
        readonly parentGoalId?: number | null;
        readonly ownerCount?: number | null;
        readonly contributorCount?: number | null;
        readonly isStale: boolean;
        readonly activities: {
          readonly __typename: "ArtifactActivityNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactActivityNodeEdge";
            readonly node?: {
              readonly __typename: "ArtifactActivityNode";
              readonly created: string;
            } | null;
          } | null>;
        };
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly firstOwner?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly avatar?: string | null;
          readonly name: string;
        } | null;
        readonly canRead: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "KPIArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
        readonly created: string;
        readonly updated?: string | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "RatingArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
        readonly created: string;
        readonly updated?: string | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "RecognitionArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
        readonly created: string;
        readonly updated?: string | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly recipients?: {
          readonly __typename: "UserNodeConnection";
          readonly totalCount: number;
          readonly edges: ReadonlyArray<{
            readonly __typename: "UserNodeEdge";
            readonly node?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          } | null>;
        } | null;
        readonly recognitionCoreValue?: {
          readonly __typename: "RecognitionCoreValueNode";
          readonly id: number;
          readonly title: string;
          readonly description: string;
          readonly emoji?: string | null;
          readonly image?: string | null;
        } | null;
      }
    | null;
};

type ExplorerResultFragment_CommentNode_Fragment = {
  readonly __typename: "CommentNode";
};

type ExplorerResultFragment_FlowNode_Fragment = {
  readonly __typename: "FlowNode";
};

type ExplorerResultFragment_GithubIssueNode_Fragment = {
  readonly __typename: "GithubIssueNode";
  readonly id: number;
  readonly title: string;
  readonly url: string;
  readonly providerName?: string | null;
  readonly repository?: string | null;
  readonly closedAt?: string | null;
  readonly isMerged?: boolean | null;
  readonly assignees: ReadonlyArray<{
    readonly __typename: "ExternalProfileNode";
    readonly username?: string | null;
    readonly url?: string | null;
  } | null>;
};

type ExplorerResultFragment_HubspotDealNode_Fragment = {
  readonly __typename: "HubspotDealNode";
  readonly id: number;
  readonly title: string;
  readonly url: string;
  readonly providerName?: string | null;
  readonly closedAt?: string | null;
  readonly amount?: number | null;
  readonly closedWon?: boolean | null;
  readonly stageName?: string | null;
  readonly assignees: ReadonlyArray<{
    readonly __typename: "ExternalProfileNode";
    readonly username?: string | null;
    readonly url?: string | null;
  } | null>;
};

type ExplorerResultFragment_JiraIssueNode_Fragment = {
  readonly __typename: "JiraIssueNode";
  readonly id: number;
  readonly title: string;
  readonly url: string;
  readonly providerName?: string | null;
  readonly closedAt?: string | null;
  readonly assignees: ReadonlyArray<{
    readonly __typename: "ExternalProfileNode";
    readonly username?: string | null;
    readonly url?: string | null;
  } | null>;
};

type ExplorerResultFragment_MeetingWithRelevantSectionsNode_Fragment = {
  readonly __typename: "MeetingWithRelevantSectionsNode";
  readonly meeting?: {
    readonly __typename: "MeetingNode";
    readonly id: number;
    readonly title?: string | null;
    readonly startDatetime?: string | null;
    readonly meetingGroupId: number;
    readonly meetingGroup?: {
      readonly __typename: "MeetingGroupNode";
      readonly id: number;
      readonly isFormalOneonone: boolean;
    } | null;
    readonly participants?: {
      readonly __typename: "MeetingParticipantConnection";
      readonly totalCount: number;
      readonly edges: ReadonlyArray<{
        readonly __typename: "MeetingParticipantEdge";
        readonly node?: {
          readonly __typename: "MeetingParticipantNode";
          readonly id?: string | null;
          readonly user?: {
            readonly __typename: "BasicUserNode";
            readonly id: number;
            readonly name: string;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

type ExplorerResultFragment_TopicNode_Fragment = {
  readonly __typename: "TopicNode";
};

type ExplorerResultFragment_UserNode_Fragment = {
  readonly __typename: "UserNode";
  readonly id: number;
  readonly name: string;
  readonly email: string;
  readonly avatar?: string | null;
};

type ExplorerResultFragment_YouTrackIssueNode_Fragment = {
  readonly __typename: "YouTrackIssueNode";
  readonly id: number;
  readonly title: string;
  readonly url: string;
  readonly providerName?: string | null;
  readonly closedAt?: string | null;
  readonly assignees: ReadonlyArray<{
    readonly __typename: "ExternalProfileNode";
    readonly username?: string | null;
    readonly url?: string | null;
  } | null>;
};

export type ExplorerResultFragmentFragment =
  | ExplorerResultFragment_BaseArtifactNode_Fragment
  | ExplorerResultFragment_CommentNode_Fragment
  | ExplorerResultFragment_FlowNode_Fragment
  | ExplorerResultFragment_GithubIssueNode_Fragment
  | ExplorerResultFragment_HubspotDealNode_Fragment
  | ExplorerResultFragment_JiraIssueNode_Fragment
  | ExplorerResultFragment_MeetingWithRelevantSectionsNode_Fragment
  | ExplorerResultFragment_TopicNode_Fragment
  | ExplorerResultFragment_UserNode_Fragment
  | ExplorerResultFragment_YouTrackIssueNode_Fragment;

export type GetExplorerResultsQueryQueryVariables = Exact<{
  limit: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
  search: Scalars["String"]["input"];
  options?: InputMaybe<SearchOptions>;
}>;

export type GetExplorerResultsQueryQuery = {
  readonly __typename: "Query";
  readonly search?: {
    readonly __typename: "SearchConnection";
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly endCursor?: string | null;
      readonly hasNextPage: boolean;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "SearchEdge";
      readonly node?:
        | {
            readonly __typename: "BaseArtifactNode";
            readonly id: number;
            readonly specificArtifact?:
              | {
                  readonly __typename: "ActionItemArtifactNode";
                  readonly isComplete?: boolean | null;
                  readonly actionItemState?: number | null;
                  readonly dueDate?: string | null;
                  readonly id: number;
                  readonly artifactType: ArtifactType;
                  readonly title?: string | null;
                  readonly created: string;
                  readonly updated?: string | null;
                  readonly assignee?: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly avatar?: string | null;
                    readonly name: string;
                  } | null;
                  readonly creator?: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly name: string;
                    readonly avatar?: string | null;
                  } | null;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                  readonly canUpdate: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "AsanaTaskArtifactNode";
                  readonly id: number;
                  readonly artifactType: ArtifactType;
                  readonly title?: string | null;
                  readonly created: string;
                  readonly updated?: string | null;
                  readonly creator?: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly name: string;
                    readonly avatar?: string | null;
                  } | null;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                  readonly canUpdate: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "DecisionArtifactNode";
                  readonly decision: string;
                  readonly decisionState?: DecisionState | null;
                  readonly isDraft?: boolean | null;
                  readonly id: number;
                  readonly artifactType: ArtifactType;
                  readonly title?: string | null;
                  readonly created: string;
                  readonly updated?: string | null;
                  readonly creator?: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly name: string;
                    readonly avatar?: string | null;
                  } | null;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                  readonly canUpdate: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "DocumentArtifactNode";
                  readonly id: number;
                  readonly artifactType: ArtifactType;
                  readonly title?: string | null;
                  readonly created: string;
                  readonly updated?: string | null;
                  readonly creator?: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly name: string;
                    readonly avatar?: string | null;
                  } | null;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                  readonly canUpdate: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "FeedbackArtifactNode";
                  readonly id: number;
                  readonly artifactType: ArtifactType;
                  readonly title?: string | null;
                  readonly created: string;
                  readonly updated?: string | null;
                  readonly creator?: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly name: string;
                    readonly avatar?: string | null;
                  } | null;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                  readonly canUpdate: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "GithubIssuesArtifactNode";
                  readonly id: number;
                  readonly artifactType: ArtifactType;
                  readonly title?: string | null;
                  readonly created: string;
                  readonly updated?: string | null;
                  readonly creator?: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly name: string;
                    readonly avatar?: string | null;
                  } | null;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                  readonly canUpdate: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "GoalArtifactNode";
                  readonly id: number;
                  readonly artifactType: ArtifactType;
                  readonly title?: string | null;
                  readonly created: string;
                  readonly updated?: string | null;
                  readonly startValue: number;
                  readonly currentValue: number;
                  readonly targetValue: number;
                  readonly progress: number;
                  readonly progressType: GoalProgressType;
                  readonly dueDate?: string | null;
                  readonly startDate?: string | null;
                  readonly state: GoalState;
                  readonly status: GoalStatus;
                  readonly scope: GoalScope;
                  readonly goalVisibility: GoalVisibility;
                  readonly parentGoalId?: number | null;
                  readonly ownerCount?: number | null;
                  readonly contributorCount?: number | null;
                  readonly isStale: boolean;
                  readonly activities: {
                    readonly __typename: "ArtifactActivityNodeConnection";
                    readonly edges: ReadonlyArray<{
                      readonly __typename: "ArtifactActivityNodeEdge";
                      readonly node?: {
                        readonly __typename: "ArtifactActivityNode";
                        readonly created: string;
                      } | null;
                    } | null>;
                  };
                  readonly creator?: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly name: string;
                    readonly avatar?: string | null;
                  } | null;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                  readonly canUpdate: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                  readonly firstOwner?: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly avatar?: string | null;
                    readonly name: string;
                  } | null;
                  readonly canRead: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "KPIArtifactNode";
                  readonly id: number;
                  readonly artifactType: ArtifactType;
                  readonly title?: string | null;
                  readonly created: string;
                  readonly updated?: string | null;
                  readonly creator?: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly name: string;
                    readonly avatar?: string | null;
                  } | null;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                  readonly canUpdate: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "RatingArtifactNode";
                  readonly id: number;
                  readonly artifactType: ArtifactType;
                  readonly title?: string | null;
                  readonly created: string;
                  readonly updated?: string | null;
                  readonly creator?: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly name: string;
                    readonly avatar?: string | null;
                  } | null;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                  readonly canUpdate: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | {
                  readonly __typename: "RecognitionArtifactNode";
                  readonly id: number;
                  readonly artifactType: ArtifactType;
                  readonly title?: string | null;
                  readonly created: string;
                  readonly updated?: string | null;
                  readonly creator?: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly name: string;
                    readonly avatar?: string | null;
                  } | null;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                  readonly canUpdate: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                  readonly recipients?: {
                    readonly __typename: "UserNodeConnection";
                    readonly totalCount: number;
                    readonly edges: ReadonlyArray<{
                      readonly __typename: "UserNodeEdge";
                      readonly node?: {
                        readonly __typename: "UserNode";
                        readonly id: number;
                        readonly name: string;
                        readonly avatar?: string | null;
                      } | null;
                    } | null>;
                  } | null;
                  readonly recognitionCoreValue?: {
                    readonly __typename: "RecognitionCoreValueNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description: string;
                    readonly emoji?: string | null;
                    readonly image?: string | null;
                  } | null;
                }
              | null;
          }
        | { readonly __typename: "CommentNode" }
        | { readonly __typename: "FlowNode" }
        | {
            readonly __typename: "GithubIssueNode";
            readonly id: number;
            readonly title: string;
            readonly url: string;
            readonly providerName?: string | null;
            readonly repository?: string | null;
            readonly closedAt?: string | null;
            readonly isMerged?: boolean | null;
            readonly assignees: ReadonlyArray<{
              readonly __typename: "ExternalProfileNode";
              readonly username?: string | null;
              readonly url?: string | null;
            } | null>;
          }
        | {
            readonly __typename: "HubspotDealNode";
            readonly id: number;
            readonly title: string;
            readonly url: string;
            readonly providerName?: string | null;
            readonly closedAt?: string | null;
            readonly amount?: number | null;
            readonly closedWon?: boolean | null;
            readonly stageName?: string | null;
            readonly assignees: ReadonlyArray<{
              readonly __typename: "ExternalProfileNode";
              readonly username?: string | null;
              readonly url?: string | null;
            } | null>;
          }
        | {
            readonly __typename: "JiraIssueNode";
            readonly id: number;
            readonly title: string;
            readonly url: string;
            readonly providerName?: string | null;
            readonly closedAt?: string | null;
            readonly assignees: ReadonlyArray<{
              readonly __typename: "ExternalProfileNode";
              readonly username?: string | null;
              readonly url?: string | null;
            } | null>;
          }
        | {
            readonly __typename: "MeetingWithRelevantSectionsNode";
            readonly meeting?: {
              readonly __typename: "MeetingNode";
              readonly id: number;
              readonly title?: string | null;
              readonly startDatetime?: string | null;
              readonly meetingGroupId: number;
              readonly meetingGroup?: {
                readonly __typename: "MeetingGroupNode";
                readonly id: number;
                readonly isFormalOneonone: boolean;
              } | null;
              readonly participants?: {
                readonly __typename: "MeetingParticipantConnection";
                readonly totalCount: number;
                readonly edges: ReadonlyArray<{
                  readonly __typename: "MeetingParticipantEdge";
                  readonly node?: {
                    readonly __typename: "MeetingParticipantNode";
                    readonly id?: string | null;
                    readonly user?: {
                      readonly __typename: "BasicUserNode";
                      readonly id: number;
                      readonly name: string;
                    } | null;
                  } | null;
                } | null>;
              } | null;
            } | null;
          }
        | { readonly __typename: "TopicNode" }
        | {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly email: string;
            readonly avatar?: string | null;
          }
        | {
            readonly __typename: "YouTrackIssueNode";
            readonly id: number;
            readonly title: string;
            readonly url: string;
            readonly providerName?: string | null;
            readonly closedAt?: string | null;
            readonly assignees: ReadonlyArray<{
              readonly __typename: "ExternalProfileNode";
              readonly username?: string | null;
              readonly url?: string | null;
            } | null>;
          }
        | null;
    } | null>;
  } | null;
};

export type SaveExplorerBookmarkMutationMutationVariables = Exact<{
  explorerBookmarkId?: InputMaybe<Scalars["Int"]["input"]>;
  filters?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  private?: InputMaybe<Scalars["Boolean"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type SaveExplorerBookmarkMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateExplorerBookmark?: {
    readonly __typename: "CreateOrUpdateExplorerBookmarkMutation";
    readonly user?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly explorerBookmarks?: {
        readonly __typename: "ExplorerFilterBookmarkNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "ExplorerFilterBookmarkNodeEdge";
          readonly node?: {
            readonly __typename: "ExplorerFilterBookmarkNode";
            readonly id: number;
          } | null;
        } | null>;
      } | null;
    } | null;
    readonly explorerBookmark?: {
      readonly __typename: "ExplorerFilterBookmarkNode";
      readonly id: number;
      readonly title: string;
      readonly filters: string;
      readonly private: boolean;
      readonly canUpdate: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
      };
      readonly canDelete: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
      };
    } | null;
  } | null;
};

export type GetMeetingForExtensionQueryQueryVariables = Exact<{
  meetingId: Scalars["Int"]["input"];
}>;

export type GetMeetingForExtensionQueryQuery = {
  readonly __typename: "Query";
  readonly meeting?: {
    readonly __typename: "MeetingNode";
    readonly id: number;
    readonly title?: string | null;
    readonly startDatetime?: string | null;
    readonly startDate?: string | null;
    readonly endDatetime?: string | null;
    readonly externalUrl?: string | null;
    readonly videoConferenceType?: OnlineVideoConference | null;
    readonly videoConferenceUrl?: string | null;
    readonly allowExternalViewers?: boolean | null;
    readonly writableSharingUrl?: string | null;
    readonly websocketToken?: string | null;
    readonly hasPreviousMeetings?: boolean | null;
    readonly ignored: boolean;
    readonly finalizedAt?: string | null;
    readonly isFinalized: boolean;
    readonly meetingGroupId: number;
    readonly isSubmitted: boolean;
    readonly hasIncompleteMandatoryTopics: boolean;
    readonly transcriptionStatus?: boolean | null;
    readonly created: string;
    readonly draft: boolean;
    readonly isRecurring: boolean;
    readonly hasExternalParticipants?: boolean | null;
    readonly isManagerAndReportOneonone: boolean;
    readonly hasBotInMeeting: boolean;
    readonly botIsRecording: boolean;
    readonly botIsWaitingToJoinMeeting: boolean;
    readonly previousMeeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
      readonly startDate?: string | null;
      readonly startDatetime?: string | null;
    } | null;
    readonly subject?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly isInCurrentUserReportingTree: boolean;
      readonly managersList: ReadonlyArray<{
        readonly __typename: "UserNode";
        readonly id: number;
      }>;
    } | null;
    readonly canFinalize: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    };
    readonly canDelete?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    } | null;
    readonly canUpdate?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    } | null;
    readonly finalizedBy?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly avatar?: string | null;
    } | null;
    readonly organization?: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
      readonly name: string;
      readonly effectivePricingTier?: PricingTier | null;
      readonly enableMeetingSummarization: boolean;
      readonly domains?: ReadonlyArray<string | null> | null;
      readonly enableMeetingBot: boolean;
    } | null;
    readonly organizer?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
    } | null;
    readonly creator?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly firstName: string;
      readonly lastName: string;
      readonly avatar?: string | null;
    } | null;
    readonly transcript?: {
      readonly __typename: "MeetingTranscriptNode";
      readonly id: number;
    } | null;
    readonly meetingGroup?: {
      readonly __typename: "MeetingGroupNode";
      readonly id: number;
      readonly title: string;
      readonly hasTemplate?: boolean | null;
      readonly allowAdminVisibility: boolean;
      readonly allowOrgVisibility: boolean;
      readonly allowManagementTreeVisibility: boolean;
      readonly isFormalOneonone: boolean;
      readonly detectedOneononeBannerDismissed: boolean;
      readonly meetingBotSetting?: MeetingBotSetting | null;
      readonly addTranscriptionBotToMeetingsByDefault: boolean;
      readonly transcribeMeetingsByDefault?: boolean | null;
      readonly canUpdate?: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
      } | null;
      readonly facilitator?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      } | null;
      readonly organization?: {
        readonly __typename: "OrganizationNode";
        readonly id: number;
        readonly name: string;
      } | null;
      readonly syncCredentials?: {
        readonly __typename: "UserSyncCredentialsNode";
        readonly id: number;
        readonly hasCalendarWriteCredentials?: boolean | null;
        readonly provider?: SyncCredentialsTypeEnum | null;
      } | null;
      readonly topicTemplate?: {
        readonly __typename: "TopicTemplateNode";
        readonly id: number;
        readonly title: string;
        readonly globalTemplate: boolean;
        readonly publicTemplate: boolean;
        readonly meetingTemplate: boolean;
        readonly finalizePermissions: FinalizePermissions;
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
      } | null;
    } | null;
    readonly topics?: {
      readonly __typename: "TopicNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "TopicNodeEdge";
        readonly node?: {
          readonly __typename: "TopicNode";
          readonly id: number;
          readonly clientId?: number | null;
          readonly title: string;
          readonly description?: string | null;
          readonly discussionNotes?: any | null;
          readonly created: string;
          readonly state?: TopicState | null;
          readonly eventChannelName?: string | null;
          readonly includesIndividualNotes: boolean;
          readonly includesIndividualNotesForCurrentUser: boolean;
          readonly includesSharedNotes: boolean;
          readonly isMandatory: boolean;
          readonly notesRequirement: NotesRequirement;
          readonly individualNotes?: {
            readonly __typename: "IndividualNoteNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "IndividualNoteNodeEdge";
              readonly node?: {
                readonly __typename: "IndividualNoteNode";
                readonly id: number;
                readonly created: string;
                readonly hidden: boolean;
                readonly enabled: boolean;
                readonly notes?: any | null;
                readonly creator: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                };
              } | null;
            } | null>;
          } | null;
          readonly creator?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
          } | null;
          readonly assignee?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly avatar?: string | null;
            readonly name: string;
          } | null;
          readonly previousTopic?: {
            readonly __typename: "TopicNode";
            readonly id: number;
            readonly discussionNotes?: any | null;
          } | null;
          readonly linkedTemplateTopic?: {
            readonly __typename: "TopicNode";
            readonly id: number;
            readonly title: string;
            readonly discussionNotes?: any | null;
            readonly defaultSubjectNotes?: any | null;
            readonly defaultFacilitatorNotes?: any | null;
            readonly topicTemplate?: {
              readonly __typename: "TopicTemplateNode";
              readonly id: number;
              readonly title: string;
            } | null;
          } | null;
          readonly canUpdate: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly copiedFrom?: {
            readonly __typename: "TopicNode";
            readonly id: number;
            readonly title: string;
            readonly meeting?: {
              readonly __typename: "MeetingNode";
              readonly id: number;
              readonly title?: string | null;
              readonly startDatetime?: string | null;
              readonly meetingGroupId: number;
            } | null;
          } | null;
        } | null;
      } | null>;
    } | null;
    readonly assessmentDeliveriesMatching1on1Template: {
      readonly __typename: "AssessmentDeliveryNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AssessmentDeliveryNodeEdge";
        readonly node?: {
          readonly __typename: "AssessmentDeliveryNode";
          readonly id: number;
          readonly target?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
          } | null;
          readonly complianceProgram?: {
            readonly __typename: "ComplianceProgramNode";
            readonly id: number;
            readonly title: string;
            readonly requiredTopicTemplates: {
              readonly __typename: "TopicTemplateNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "TopicTemplateNodeEdge";
                readonly node?: {
                  readonly __typename: "TopicTemplateNode";
                  readonly id: number;
                  readonly title: string;
                } | null;
              } | null>;
            };
          } | null;
        } | null;
      } | null>;
    };
    readonly botParticipationDetails: {
      readonly __typename: "BotParticipationDetailsNode";
      readonly willBotJoin: boolean;
      readonly reason: MeetingBotJoinReason;
      readonly joinBecauseOfParticipants: ReadonlyArray<{
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
      }>;
    };
    readonly participants?: {
      readonly __typename: "MeetingParticipantConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "MeetingParticipantEdge";
        readonly node?: {
          readonly __typename: "MeetingParticipantNode";
          readonly id?: string | null;
          readonly status?: AttendeeStatus | null;
          readonly participantEmail?: string | null;
          readonly role?: AttendeeRole | null;
          readonly user?: {
            readonly __typename: "BasicUserNode";
            readonly id: number;
            readonly name: string;
            readonly firstName: string;
            readonly lastName: string;
            readonly avatar?: string | null;
            readonly email: string;
            readonly status?: UserStatus | null;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetMeetingUsingGoogleMeetUrlQueryQueryVariables = Exact<{
  googleMeetUrl: Scalars["String"]["input"];
}>;

export type GetMeetingUsingGoogleMeetUrlQueryQuery = {
  readonly __typename: "Query";
  readonly meeting?: {
    readonly __typename: "MeetingNode";
    readonly id: number;
  } | null;
};

export type GetFavouriteArtifactsQueryQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetFavouriteArtifactsQueryQuery = {
  readonly __typename: "Query";
  readonly me?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly favouriteArtifacts: {
      readonly __typename: "ArtifactConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "ArtifactEdge";
        readonly node?:
          | {
              readonly __typename: "ActionItemArtifactNode";
              readonly isComplete?: boolean | null;
              readonly id: number;
              readonly artifactType: ArtifactType;
              readonly title?: string | null;
              readonly updated?: string | null;
              readonly created: string;
              readonly assignee?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly canUpdate: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
              readonly canDelete: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
              readonly creator?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "AsanaTaskArtifactNode";
              readonly id: number;
              readonly artifactType: ArtifactType;
              readonly title?: string | null;
              readonly updated?: string | null;
              readonly created: string;
              readonly canUpdate: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
              readonly canDelete: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
              readonly creator?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "DecisionArtifactNode";
              readonly decision: string;
              readonly decisionState?: DecisionState | null;
              readonly isDraft?: boolean | null;
              readonly id: number;
              readonly artifactType: ArtifactType;
              readonly title?: string | null;
              readonly updated?: string | null;
              readonly created: string;
              readonly canUpdate: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
              readonly canDelete: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
              readonly creator?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "DocumentArtifactNode";
              readonly id: number;
              readonly artifactType: ArtifactType;
              readonly title?: string | null;
              readonly updated?: string | null;
              readonly created: string;
              readonly canUpdate: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
              readonly canDelete: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
              readonly creator?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "FeedbackArtifactNode";
              readonly id: number;
              readonly artifactType: ArtifactType;
              readonly title?: string | null;
              readonly updated?: string | null;
              readonly created: string;
              readonly canUpdate: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
              readonly canDelete: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
              readonly creator?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "GithubIssuesArtifactNode";
              readonly id: number;
              readonly artifactType: ArtifactType;
              readonly title?: string | null;
              readonly updated?: string | null;
              readonly created: string;
              readonly canUpdate: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
              readonly canDelete: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
              readonly creator?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "GoalArtifactNode";
              readonly id: number;
              readonly artifactType: ArtifactType;
              readonly title?: string | null;
              readonly updated?: string | null;
              readonly created: string;
              readonly state: GoalState;
              readonly scope: GoalScope;
              readonly ownerCount?: number | null;
              readonly dueDate?: string | null;
              readonly goalVisibility: GoalVisibility;
              readonly status: GoalStatus;
              readonly progress: number;
              readonly progressType: GoalProgressType;
              readonly currentValue: number;
              readonly startValue: number;
              readonly targetValue: number;
              readonly isStale: boolean;
              readonly parentGoalId?: number | null;
              readonly canUpdate: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
              readonly canDelete: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
              readonly creator?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly firstOwner?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly owners?: {
                readonly __typename: "UserNodeConnection";
                readonly edges: ReadonlyArray<{
                  readonly __typename: "UserNodeEdge";
                  readonly node?: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly name: string;
                    readonly avatar?: string | null;
                  } | null;
                } | null>;
              } | null;
            }
          | {
              readonly __typename: "KPIArtifactNode";
              readonly id: number;
              readonly artifactType: ArtifactType;
              readonly title?: string | null;
              readonly updated?: string | null;
              readonly created: string;
              readonly canUpdate: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
              readonly canDelete: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
              readonly creator?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "RatingArtifactNode";
              readonly id: number;
              readonly artifactType: ArtifactType;
              readonly title?: string | null;
              readonly updated?: string | null;
              readonly created: string;
              readonly rating?: {
                readonly __typename: "RatingNode";
                readonly id: number;
                readonly title: string;
              } | null;
              readonly canUpdate: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
              readonly canDelete: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
              readonly creator?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "RecognitionArtifactNode";
              readonly id: number;
              readonly artifactType: ArtifactType;
              readonly title?: string | null;
              readonly updated?: string | null;
              readonly created: string;
              readonly canUpdate: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
              readonly canDelete: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
              readonly creator?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly recognitionCoreValue?: {
                readonly __typename: "RecognitionCoreValueNode";
                readonly id: number;
                readonly title: string;
                readonly emoji?: string | null;
                readonly image?: string | null;
              } | null;
              readonly recipients?: {
                readonly __typename: "UserNodeConnection";
                readonly totalCount: number;
                readonly edges: ReadonlyArray<{
                  readonly __typename: "UserNodeEdge";
                  readonly node?: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly name: string;
                    readonly avatar?: string | null;
                  } | null;
                } | null>;
              } | null;
            }
          | null;
      } | null>;
    };
  } | null;
};

export type GetFeedbackPageQueryQueryVariables = Exact<{
  pendingRequestRecipientId?: InputMaybe<Scalars["Int"]["input"]>;
  pendingRequestRecipientsOfManagerId?: InputMaybe<Scalars["Int"]["input"]>;
  fetchPendingRequest: Scalars["Boolean"]["input"];
  organizationId: Scalars["Int"]["input"];
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipients?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  feedbackSender?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackState?: InputMaybe<FeedbackState>;
  createdBetweenDates?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
    | InputMaybe<Scalars["Date"]["input"]>
  >;
  limit: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetFeedbackPageQueryQuery = {
  readonly __typename: "Query";
  readonly artifacts?: {
    readonly __typename: "ArtifactConnection";
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly endCursor?: string | null;
      readonly hasNextPage: boolean;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "ArtifactEdge";
      readonly node?:
        | { readonly __typename: "ActionItemArtifactNode"; readonly id: number }
        | { readonly __typename: "AsanaTaskArtifactNode"; readonly id: number }
        | { readonly __typename: "DecisionArtifactNode"; readonly id: number }
        | { readonly __typename: "DocumentArtifactNode"; readonly id: number }
        | {
            readonly __typename: "FeedbackArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly recipientsCanView: boolean;
            readonly recipientsManagersCanView: boolean;
            readonly adminsCanView: boolean;
            readonly creatorCanView: boolean;
            readonly feedbackState: FeedbackState;
            readonly message?: any | null;
            readonly created: string;
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
            readonly feedbackRecipients: {
              readonly __typename: "UserNodeConnection";
              readonly totalCount: number;
              readonly edges: ReadonlyArray<{
                readonly __typename: "UserNodeEdge";
                readonly node?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly avatar?: string | null;
                  readonly name: string;
                } | null;
              } | null>;
            };
            readonly sender: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly avatar?: string | null;
              readonly name: string;
            };
          }
        | {
            readonly __typename: "GithubIssuesArtifactNode";
            readonly id: number;
          }
        | { readonly __typename: "GoalArtifactNode"; readonly id: number }
        | { readonly __typename: "KPIArtifactNode"; readonly id: number }
        | { readonly __typename: "RatingArtifactNode"; readonly id: number }
        | {
            readonly __typename: "RecognitionArtifactNode";
            readonly id: number;
          }
        | null;
    } | null>;
  } | null;
  readonly pendingFeedbackRequests?: {
    readonly __typename: "BasicFeedbackArtifactNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "BasicFeedbackArtifactNodeEdge";
      readonly node?: {
        readonly __typename: "BasicFeedbackArtifactNode";
        readonly id: number;
        readonly title?: string | null;
        readonly created: string;
        readonly feedbackState: FeedbackState;
        readonly sender?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly recipients?: {
          readonly __typename: "UserNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "UserNodeEdge";
            readonly node?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          } | null>;
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type GetGoalSearchResultsToAlignQueryQueryVariables = Exact<{
  search: Scalars["String"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetGoalSearchResultsToAlignQueryQuery = {
  readonly __typename: "Query";
  readonly artifacts?: {
    readonly __typename: "ArtifactConnection";
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly endCursor?: string | null;
      readonly hasNextPage: boolean;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "ArtifactEdge";
      readonly node?:
        | { readonly __typename: "ActionItemArtifactNode"; readonly id: number }
        | { readonly __typename: "AsanaTaskArtifactNode"; readonly id: number }
        | { readonly __typename: "DecisionArtifactNode"; readonly id: number }
        | { readonly __typename: "DocumentArtifactNode"; readonly id: number }
        | { readonly __typename: "FeedbackArtifactNode"; readonly id: number }
        | {
            readonly __typename: "GithubIssuesArtifactNode";
            readonly id: number;
          }
        | {
            readonly __typename: "GoalArtifactNode";
            readonly id: number;
            readonly parentGoalId?: number | null;
            readonly artifactType: ArtifactType;
            readonly startValue: number;
            readonly currentValue: number;
            readonly targetValue: number;
            readonly progress: number;
            readonly progressType: GoalProgressType;
            readonly dueDate?: string | null;
            readonly startDate?: string | null;
            readonly state: GoalState;
            readonly status: GoalStatus;
            readonly scope: GoalScope;
            readonly goalVisibility: GoalVisibility;
            readonly created: string;
            readonly ownerCount?: number | null;
            readonly contributorCount?: number | null;
            readonly isStale: boolean;
            readonly title?: string | null;
            readonly updated?: string | null;
            readonly firstOwner?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly avatar?: string | null;
              readonly name: string;
            } | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canRead: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          }
        | { readonly __typename: "KPIArtifactNode"; readonly id: number }
        | { readonly __typename: "RatingArtifactNode"; readonly id: number }
        | {
            readonly __typename: "RecognitionArtifactNode";
            readonly id: number;
          }
        | null;
    } | null>;
  } | null;
};

export type GetGoalToAlignQueryQueryVariables = Exact<{
  artifactId: Scalars["Int"]["input"];
}>;

export type GetGoalToAlignQueryQuery = {
  readonly __typename: "Query";
  readonly artifact:
    | { readonly __typename: "ActionItemArtifactNode" }
    | { readonly __typename: "AsanaTaskArtifactNode" }
    | { readonly __typename: "DecisionArtifactNode" }
    | { readonly __typename: "DocumentArtifactNode" }
    | { readonly __typename: "FeedbackArtifactNode" }
    | { readonly __typename: "GithubIssuesArtifactNode" }
    | {
        readonly __typename: "GoalArtifactNode";
        readonly parentGoalId?: number | null;
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly startValue: number;
        readonly currentValue: number;
        readonly targetValue: number;
        readonly progress: number;
        readonly progressType: GoalProgressType;
        readonly dueDate?: string | null;
        readonly startDate?: string | null;
        readonly state: GoalState;
        readonly status: GoalStatus;
        readonly scope: GoalScope;
        readonly goalVisibility: GoalVisibility;
        readonly created: string;
        readonly ownerCount?: number | null;
        readonly contributorCount?: number | null;
        readonly isStale: boolean;
        readonly title?: string | null;
        readonly updated?: string | null;
        readonly childGoals?: {
          readonly __typename: "GoalArtifactConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "GoalArtifactEdge";
            readonly node?: {
              readonly __typename: "GoalArtifactNode";
              readonly id: number;
            } | null;
          } | null>;
        } | null;
        readonly firstOwner?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly avatar?: string | null;
          readonly name: string;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canRead: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      }
    | { readonly __typename: "KPIArtifactNode" }
    | { readonly __typename: "RatingArtifactNode" }
    | { readonly __typename: "RecognitionArtifactNode" };
};

export type GoalAlignmentDialogGoalFragmentFragment = {
  readonly __typename: "GoalArtifactNode";
  readonly parentGoalId?: number | null;
  readonly id: number;
  readonly artifactType: ArtifactType;
  readonly startValue: number;
  readonly currentValue: number;
  readonly targetValue: number;
  readonly progress: number;
  readonly progressType: GoalProgressType;
  readonly dueDate?: string | null;
  readonly startDate?: string | null;
  readonly state: GoalState;
  readonly status: GoalStatus;
  readonly scope: GoalScope;
  readonly goalVisibility: GoalVisibility;
  readonly created: string;
  readonly ownerCount?: number | null;
  readonly contributorCount?: number | null;
  readonly isStale: boolean;
  readonly title?: string | null;
  readonly updated?: string | null;
  readonly firstOwner?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly avatar?: string | null;
    readonly name: string;
  } | null;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canRead: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
};

export type AlignmentGoalFragmentFragment = {
  readonly __typename: "GoalArtifactNode";
  readonly id: number;
  readonly artifactType: ArtifactType;
  readonly title?: string | null;
  readonly updated?: string | null;
  readonly state: GoalState;
  readonly scope: GoalScope;
  readonly ownerCount?: number | null;
  readonly dueDate?: string | null;
  readonly goalVisibility: GoalVisibility;
  readonly status: GoalStatus;
  readonly progress: number;
  readonly progressType: GoalProgressType;
  readonly currentValue: number;
  readonly startValue: number;
  readonly targetValue: number;
  readonly isStale: boolean;
  readonly created: string;
  readonly parentGoalId?: number | null;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canRead: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly firstOwner?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
  readonly keyResultsList?: ReadonlyArray<{
    readonly __typename: "KeyResultNode";
    readonly id: number;
    readonly title: string;
    readonly startValue: number;
    readonly currentValue: number;
    readonly targetValue: number;
    readonly progressType: GoalProgressType;
    readonly kpi?: {
      readonly __typename: "KPINode";
      readonly id: number;
      readonly title: string;
      readonly currentMeasurement?: {
        readonly __typename: "KPIMeasurementNode";
        readonly id: number;
        readonly measurement: number;
      } | null;
    } | null;
    readonly canUpdate?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    } | null;
    readonly assignee?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly avatar?: string | null;
      readonly email: string;
    } | null;
  } | null>;
};

export type BasicAlignmentGoalFragmentFragment = {
  readonly __typename: "BasicGoalArtifactNode";
  readonly id: number;
  readonly artifactType: ArtifactType;
  readonly updated: string;
  readonly state: GoalState;
  readonly scope: GoalScope;
  readonly ownerCount?: number | null;
  readonly dueDate?: string | null;
  readonly goalVisibility: GoalVisibility;
  readonly status: GoalStatus;
  readonly progress: number;
  readonly progressType: GoalProgressType;
  readonly currentValue: number;
  readonly startValue: number;
  readonly targetValue: number;
  readonly isStale: boolean;
  readonly created: string;
  readonly parentGoalId?: number | null;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canRead: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly firstOwner?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
  readonly goalArtifact?: {
    readonly __typename: "GoalArtifactNode";
    readonly id: number;
    readonly artifactType: ArtifactType;
    readonly title?: string | null;
    readonly updated?: string | null;
    readonly state: GoalState;
    readonly scope: GoalScope;
    readonly ownerCount?: number | null;
    readonly dueDate?: string | null;
    readonly goalVisibility: GoalVisibility;
    readonly status: GoalStatus;
    readonly progress: number;
    readonly progressType: GoalProgressType;
    readonly currentValue: number;
    readonly startValue: number;
    readonly targetValue: number;
    readonly isStale: boolean;
    readonly created: string;
    readonly parentGoalId?: number | null;
    readonly canUpdate: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    };
    readonly canDelete: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    };
    readonly canRead: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    };
    readonly firstOwner?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly avatar?: string | null;
    } | null;
    readonly keyResultsList?: ReadonlyArray<{
      readonly __typename: "KeyResultNode";
      readonly id: number;
      readonly title: string;
      readonly startValue: number;
      readonly currentValue: number;
      readonly targetValue: number;
      readonly progressType: GoalProgressType;
      readonly kpi?: {
        readonly __typename: "KPINode";
        readonly id: number;
        readonly title: string;
        readonly currentMeasurement?: {
          readonly __typename: "KPIMeasurementNode";
          readonly id: number;
          readonly measurement: number;
        } | null;
      } | null;
      readonly canUpdate?: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
      } | null;
      readonly assignee?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
        readonly email: string;
      } | null;
    } | null>;
  } | null;
};

export type GetAlignmentGoalsQueryQueryVariables = Exact<{
  first: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
  goalScopes?: InputMaybe<
    ReadonlyArray<InputMaybe<GoalScope>> | InputMaybe<GoalScope>
  >;
  goalStates?: InputMaybe<
    ReadonlyArray<InputMaybe<GoalState>> | InputMaybe<GoalState>
  >;
  goalDueBetweenDates?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
    | InputMaybe<Scalars["Date"]["input"]>
  >;
  idsToMergeInApolloCache?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  searchGoalOwners?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  searchGoalTeams?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  inPathOfGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  hasSearch: Scalars["Boolean"]["input"];
  showKeyResults: Scalars["Boolean"]["input"];
}>;

export type GetAlignmentGoalsQueryQuery = {
  readonly __typename: "Query";
  readonly basicGoals?: {
    readonly __typename: "BasicGoalArtifactNodeConnection";
    readonly totalCount: number;
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly hasNextPage: boolean;
      readonly endCursor?: string | null;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "BasicGoalArtifactNodeEdge";
      readonly node?: {
        readonly __typename: "BasicGoalArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly updated: string;
        readonly state: GoalState;
        readonly scope: GoalScope;
        readonly ownerCount?: number | null;
        readonly dueDate?: string | null;
        readonly goalVisibility: GoalVisibility;
        readonly status: GoalStatus;
        readonly progress: number;
        readonly progressType: GoalProgressType;
        readonly currentValue: number;
        readonly startValue: number;
        readonly targetValue: number;
        readonly isStale: boolean;
        readonly created: string;
        readonly parentGoalId?: number | null;
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canRead: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly firstOwner?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly goalArtifact?: {
          readonly __typename: "GoalArtifactNode";
          readonly id: number;
          readonly artifactType: ArtifactType;
          readonly title?: string | null;
          readonly updated?: string | null;
          readonly state: GoalState;
          readonly scope: GoalScope;
          readonly ownerCount?: number | null;
          readonly dueDate?: string | null;
          readonly goalVisibility: GoalVisibility;
          readonly status: GoalStatus;
          readonly progress: number;
          readonly progressType: GoalProgressType;
          readonly currentValue: number;
          readonly startValue: number;
          readonly targetValue: number;
          readonly isStale: boolean;
          readonly created: string;
          readonly parentGoalId?: number | null;
          readonly canUpdate: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canRead: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly firstOwner?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
          readonly keyResultsList?: ReadonlyArray<{
            readonly __typename: "KeyResultNode";
            readonly id: number;
            readonly title: string;
            readonly startValue: number;
            readonly currentValue: number;
            readonly targetValue: number;
            readonly progressType: GoalProgressType;
            readonly kpi?: {
              readonly __typename: "KPINode";
              readonly id: number;
              readonly title: string;
              readonly currentMeasurement?: {
                readonly __typename: "KPIMeasurementNode";
                readonly id: number;
                readonly measurement: number;
              } | null;
            } | null;
            readonly canUpdate?: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            } | null;
            readonly assignee?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
              readonly email: string;
            } | null;
          } | null>;
        } | null;
      } | null;
    } | null>;
  } | null;
  readonly searchResults?: {
    readonly __typename: "ArtifactConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "ArtifactEdge";
      readonly node?:
        | { readonly __typename: "ActionItemArtifactNode"; readonly id: number }
        | { readonly __typename: "AsanaTaskArtifactNode"; readonly id: number }
        | { readonly __typename: "DecisionArtifactNode"; readonly id: number }
        | { readonly __typename: "DocumentArtifactNode"; readonly id: number }
        | { readonly __typename: "FeedbackArtifactNode"; readonly id: number }
        | {
            readonly __typename: "GithubIssuesArtifactNode";
            readonly id: number;
          }
        | { readonly __typename: "GoalArtifactNode"; readonly id: number }
        | { readonly __typename: "KPIArtifactNode"; readonly id: number }
        | { readonly __typename: "RatingArtifactNode"; readonly id: number }
        | {
            readonly __typename: "RecognitionArtifactNode";
            readonly id: number;
          }
        | null;
    } | null>;
  } | null;
};

export type DuplicateGoalMutationMutationVariables = Exact<{
  goalId: Scalars["Int"]["input"];
  parentGoalId?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  startDate: Scalars["Date"]["input"];
  dueDate: Scalars["Date"]["input"];
  resetProgress?: InputMaybe<Scalars["Boolean"]["input"]>;
  duplicateKeyResults?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type DuplicateGoalMutationMutation = {
  readonly __typename: "Mutation";
  readonly duplicateGoal?: {
    readonly __typename: "DuplicateGoalMutation";
    readonly duplicatedGoal?:
      | { readonly __typename: "ActionItemArtifactNode"; readonly id: number }
      | { readonly __typename: "AsanaTaskArtifactNode"; readonly id: number }
      | { readonly __typename: "DecisionArtifactNode"; readonly id: number }
      | { readonly __typename: "DocumentArtifactNode"; readonly id: number }
      | { readonly __typename: "FeedbackArtifactNode"; readonly id: number }
      | { readonly __typename: "GithubIssuesArtifactNode"; readonly id: number }
      | { readonly __typename: "GoalArtifactNode"; readonly id: number }
      | { readonly __typename: "KPIArtifactNode"; readonly id: number }
      | { readonly __typename: "RatingArtifactNode"; readonly id: number }
      | { readonly __typename: "RecognitionArtifactNode"; readonly id: number }
      | null;
  } | null;
};

export type GoalOverviewRelatedEntityGoalFragmentFragment = {
  readonly __typename: "GoalArtifactNode";
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly scope: GoalScope;
  readonly state: GoalState;
  readonly status: GoalStatus;
  readonly progress: number;
  readonly isStale: boolean;
  readonly goalVisibility: GoalVisibility;
  readonly dueDate?: string | null;
  readonly startDate?: string | null;
  readonly startValue: number;
  readonly targetValue: number;
  readonly progressType: GoalProgressType;
  readonly currentValue: number;
  readonly created: string;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly ownersList: ReadonlyArray<{
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null>;
  readonly teamsList: ReadonlyArray<{
    readonly __typename: "TeamNode";
    readonly id: number;
    readonly title: string;
  } | null>;
  readonly activities: {
    readonly __typename: "ArtifactActivityNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "ArtifactActivityNodeEdge";
      readonly node?: {
        readonly __typename: "ArtifactActivityNode";
        readonly id: number;
        readonly created: string;
      } | null;
    } | null>;
  };
};

export type GetGoalOverviewRelatedEntitiesQueryQueryVariables = Exact<{
  goalOwners?: InputMaybe<
    ReadonlyArray<Scalars["Int"]["input"]> | Scalars["Int"]["input"]
  >;
  goalTeams?: InputMaybe<
    ReadonlyArray<Scalars["Int"]["input"]> | Scalars["Int"]["input"]
  >;
  goalDueBetweenDates:
    | ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
    | InputMaybe<Scalars["Date"]["input"]>;
  hasOwners: Scalars["Boolean"]["input"];
  hasTeams: Scalars["Boolean"]["input"];
}>;

export type GetGoalOverviewRelatedEntitiesQueryQuery = {
  readonly __typename: "Query";
  readonly ownerGoals?: {
    readonly __typename: "ArtifactConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "ArtifactEdge";
      readonly node?:
        | { readonly __typename: "ActionItemArtifactNode"; readonly id: number }
        | { readonly __typename: "AsanaTaskArtifactNode"; readonly id: number }
        | { readonly __typename: "DecisionArtifactNode"; readonly id: number }
        | { readonly __typename: "DocumentArtifactNode"; readonly id: number }
        | { readonly __typename: "FeedbackArtifactNode"; readonly id: number }
        | {
            readonly __typename: "GithubIssuesArtifactNode";
            readonly id: number;
          }
        | {
            readonly __typename: "GoalArtifactNode";
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
            readonly scope: GoalScope;
            readonly state: GoalState;
            readonly status: GoalStatus;
            readonly progress: number;
            readonly isStale: boolean;
            readonly goalVisibility: GoalVisibility;
            readonly dueDate?: string | null;
            readonly startDate?: string | null;
            readonly startValue: number;
            readonly targetValue: number;
            readonly progressType: GoalProgressType;
            readonly currentValue: number;
            readonly created: string;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly ownersList: ReadonlyArray<{
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null>;
            readonly teamsList: ReadonlyArray<{
              readonly __typename: "TeamNode";
              readonly id: number;
              readonly title: string;
            } | null>;
            readonly activities: {
              readonly __typename: "ArtifactActivityNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "ArtifactActivityNodeEdge";
                readonly node?: {
                  readonly __typename: "ArtifactActivityNode";
                  readonly id: number;
                  readonly created: string;
                } | null;
              } | null>;
            };
          }
        | { readonly __typename: "KPIArtifactNode"; readonly id: number }
        | { readonly __typename: "RatingArtifactNode"; readonly id: number }
        | {
            readonly __typename: "RecognitionArtifactNode";
            readonly id: number;
          }
        | null;
    } | null>;
  } | null;
  readonly teamGoals?: {
    readonly __typename: "ArtifactConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "ArtifactEdge";
      readonly node?:
        | { readonly __typename: "ActionItemArtifactNode"; readonly id: number }
        | { readonly __typename: "AsanaTaskArtifactNode"; readonly id: number }
        | { readonly __typename: "DecisionArtifactNode"; readonly id: number }
        | { readonly __typename: "DocumentArtifactNode"; readonly id: number }
        | { readonly __typename: "FeedbackArtifactNode"; readonly id: number }
        | {
            readonly __typename: "GithubIssuesArtifactNode";
            readonly id: number;
          }
        | {
            readonly __typename: "GoalArtifactNode";
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
            readonly scope: GoalScope;
            readonly state: GoalState;
            readonly status: GoalStatus;
            readonly progress: number;
            readonly isStale: boolean;
            readonly goalVisibility: GoalVisibility;
            readonly dueDate?: string | null;
            readonly startDate?: string | null;
            readonly startValue: number;
            readonly targetValue: number;
            readonly progressType: GoalProgressType;
            readonly currentValue: number;
            readonly created: string;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly ownersList: ReadonlyArray<{
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null>;
            readonly teamsList: ReadonlyArray<{
              readonly __typename: "TeamNode";
              readonly id: number;
              readonly title: string;
            } | null>;
            readonly activities: {
              readonly __typename: "ArtifactActivityNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "ArtifactActivityNodeEdge";
                readonly node?: {
                  readonly __typename: "ArtifactActivityNode";
                  readonly id: number;
                  readonly created: string;
                } | null;
              } | null>;
            };
          }
        | { readonly __typename: "KPIArtifactNode"; readonly id: number }
        | { readonly __typename: "RatingArtifactNode"; readonly id: number }
        | {
            readonly __typename: "RecognitionArtifactNode";
            readonly id: number;
          }
        | null;
    } | null>;
  } | null;
};

export type GetGoalOverviewSelectedEntityQueryQueryVariables = Exact<{
  teamId: Scalars["Int"]["input"];
  userId: Scalars["Int"]["input"];
  organizationId: Scalars["Int"]["input"];
  hasTeamId: Scalars["Boolean"]["input"];
  hasUserId: Scalars["Boolean"]["input"];
  hasOrganizationId: Scalars["Boolean"]["input"];
}>;

export type GetGoalOverviewSelectedEntityQueryQuery = {
  readonly __typename: "Query";
  readonly user?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly email: string;
    readonly name: string;
    readonly avatar?: string | null;
    readonly directReports: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null>;
    };
    readonly managers: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null>;
    };
    readonly teams?: {
      readonly __typename: "TeamNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "TeamNodeEdge";
        readonly node?: {
          readonly __typename: "TeamNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null>;
    } | null;
  } | null;
  readonly team?: {
    readonly __typename: "TeamNode";
    readonly id: number;
    readonly title: string;
    readonly members?: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null>;
    } | null;
  } | null;
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
    readonly name: string;
    readonly teams?: {
      readonly __typename: "TeamNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "TeamNodeEdge";
        readonly node?: {
          readonly __typename: "TeamNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null>;
    } | null;
  } | null;
  readonly userArtifacts?: {
    readonly __typename: "ArtifactConnection";
    readonly totalCount: number;
  } | null;
  readonly teamArtifacts?: {
    readonly __typename: "ArtifactConnection";
    readonly totalCount: number;
  } | null;
  readonly organizationArtifacts?: {
    readonly __typename: "ArtifactConnection";
    readonly totalCount: number;
  } | null;
};

export type GetOverviewFavouriteGoalsQueryQueryVariables = Exact<{
  userId: Scalars["Int"]["input"];
  goalDueBetweenDates:
    | ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
    | InputMaybe<Scalars["Date"]["input"]>;
}>;

export type GetOverviewFavouriteGoalsQueryQuery = {
  readonly __typename: "Query";
  readonly user?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly favouriteArtifacts: {
      readonly __typename: "ArtifactConnection";
      readonly totalCount: number;
      readonly pageInfo: {
        readonly __typename: "PageInfo";
        readonly hasNextPage: boolean;
        readonly endCursor?: string | null;
      };
      readonly edges: ReadonlyArray<{
        readonly __typename: "ArtifactEdge";
        readonly node?:
          | {
              readonly __typename: "ActionItemArtifactNode";
              readonly id: number;
            }
          | {
              readonly __typename: "AsanaTaskArtifactNode";
              readonly id: number;
            }
          | { readonly __typename: "DecisionArtifactNode"; readonly id: number }
          | { readonly __typename: "DocumentArtifactNode"; readonly id: number }
          | { readonly __typename: "FeedbackArtifactNode"; readonly id: number }
          | {
              readonly __typename: "GithubIssuesArtifactNode";
              readonly id: number;
            }
          | {
              readonly __typename: "GoalArtifactNode";
              readonly id: number;
              readonly artifactType: ArtifactType;
              readonly title?: string | null;
              readonly created: string;
              readonly updated?: string | null;
              readonly state: GoalState;
              readonly scope: GoalScope;
              readonly dueDate?: string | null;
              readonly goalVisibility: GoalVisibility;
              readonly status: GoalStatus;
              readonly startValue: number;
              readonly currentValue: number;
              readonly targetValue: number;
              readonly progress: number;
              readonly progressType: GoalProgressType;
              readonly isStale: boolean;
              readonly ownerCount?: number | null;
              readonly canUpdate: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
              readonly canDelete: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
              readonly creator?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly activities: {
                readonly __typename: "ArtifactActivityNodeConnection";
                readonly edges: ReadonlyArray<{
                  readonly __typename: "ArtifactActivityNodeEdge";
                  readonly node?: {
                    readonly __typename: "ArtifactActivityNode";
                    readonly created: string;
                  } | null;
                } | null>;
              };
              readonly keyResultsList: ReadonlyArray<{
                readonly __typename: "KeyResultNode";
                readonly id: number;
                readonly title: string;
                readonly startValue: number;
                readonly currentValue: number;
                readonly targetValue: number;
                readonly progressType: GoalProgressType;
                readonly assignee?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly name: string;
                  readonly avatar?: string | null;
                } | null;
                readonly kpi?: {
                  readonly __typename: "KPINode";
                  readonly id: number;
                  readonly title: string;
                } | null;
              } | null>;
              readonly basicChildGoals?: {
                readonly __typename: "BasicGoalArtifactNodeConnection";
                readonly edges: ReadonlyArray<{
                  readonly __typename: "BasicGoalArtifactNodeEdge";
                  readonly node?: {
                    readonly __typename: "BasicGoalArtifactNode";
                    readonly id: number;
                    readonly artifactType: ArtifactType;
                    readonly startValue: number;
                    readonly currentValue: number;
                    readonly targetValue: number;
                    readonly progress: number;
                    readonly progressType: GoalProgressType;
                    readonly dueDate?: string | null;
                    readonly startDate?: string | null;
                    readonly state: GoalState;
                    readonly status: GoalStatus;
                    readonly scope: GoalScope;
                    readonly goalVisibility: GoalVisibility;
                    readonly created: string;
                    readonly parentGoalId?: number | null;
                    readonly ownerCount?: number | null;
                    readonly contributorCount?: number | null;
                    readonly isStale: boolean;
                    readonly firstOwner?: {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly avatar?: string | null;
                      readonly name: string;
                    } | null;
                    readonly canDelete: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                    };
                    readonly canUpdate: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                    };
                    readonly canRead: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                    };
                    readonly goalArtifact?: {
                      readonly __typename: "GoalArtifactNode";
                      readonly id: number;
                      readonly title?: string | null;
                    } | null;
                  } | null;
                } | null>;
              } | null;
              readonly firstOwner?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            }
          | { readonly __typename: "KPIArtifactNode"; readonly id: number }
          | { readonly __typename: "RatingArtifactNode"; readonly id: number }
          | {
              readonly __typename: "RecognitionArtifactNode";
              readonly id: number;
            }
          | null;
      } | null>;
    };
  } | null;
};

export type GoalOverviewGoalOwnersFragment = {
  readonly __typename: "GoalArtifactNode";
  readonly id: number;
  readonly ownerCount?: number | null;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly firstOwner?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
};

export type GoalOverviewGoalFragmentFragment = {
  readonly __typename: "GoalArtifactNode";
  readonly id: number;
  readonly artifactType: ArtifactType;
  readonly title?: string | null;
  readonly created: string;
  readonly updated?: string | null;
  readonly state: GoalState;
  readonly scope: GoalScope;
  readonly dueDate?: string | null;
  readonly goalVisibility: GoalVisibility;
  readonly status: GoalStatus;
  readonly startValue: number;
  readonly currentValue: number;
  readonly targetValue: number;
  readonly progress: number;
  readonly progressType: GoalProgressType;
  readonly isStale: boolean;
  readonly ownerCount?: number | null;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
  readonly activities: {
    readonly __typename: "ArtifactActivityNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "ArtifactActivityNodeEdge";
      readonly node?: {
        readonly __typename: "ArtifactActivityNode";
        readonly created: string;
      } | null;
    } | null>;
  };
  readonly keyResultsList: ReadonlyArray<{
    readonly __typename: "KeyResultNode";
    readonly id: number;
    readonly title: string;
    readonly startValue: number;
    readonly currentValue: number;
    readonly targetValue: number;
    readonly progressType: GoalProgressType;
    readonly assignee?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly avatar?: string | null;
    } | null;
    readonly kpi?: {
      readonly __typename: "KPINode";
      readonly id: number;
      readonly title: string;
    } | null;
  } | null>;
  readonly basicChildGoals?: {
    readonly __typename: "BasicGoalArtifactNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "BasicGoalArtifactNodeEdge";
      readonly node?: {
        readonly __typename: "BasicGoalArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly startValue: number;
        readonly currentValue: number;
        readonly targetValue: number;
        readonly progress: number;
        readonly progressType: GoalProgressType;
        readonly dueDate?: string | null;
        readonly startDate?: string | null;
        readonly state: GoalState;
        readonly status: GoalStatus;
        readonly scope: GoalScope;
        readonly goalVisibility: GoalVisibility;
        readonly created: string;
        readonly parentGoalId?: number | null;
        readonly ownerCount?: number | null;
        readonly contributorCount?: number | null;
        readonly isStale: boolean;
        readonly firstOwner?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly avatar?: string | null;
          readonly name: string;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canRead: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly goalArtifact?: {
          readonly __typename: "GoalArtifactNode";
          readonly id: number;
          readonly title?: string | null;
        } | null;
      } | null;
    } | null>;
  } | null;
  readonly firstOwner?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
};

export type GetOverviewGoalsQueryQueryVariables = Exact<{
  ownerIds?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  contributorIds?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  involvingUserIds?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  teamIds?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  goalScopes?: InputMaybe<
    ReadonlyArray<InputMaybe<GoalScope>> | InputMaybe<GoalScope>
  >;
  goalDueBetweenDates:
    | ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
    | InputMaybe<Scalars["Date"]["input"]>;
}>;

export type GetOverviewGoalsQueryQuery = {
  readonly __typename: "Query";
  readonly artifacts?: {
    readonly __typename: "ArtifactConnection";
    readonly totalCount: number;
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly hasNextPage: boolean;
      readonly endCursor?: string | null;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "ArtifactEdge";
      readonly node?:
        | { readonly __typename: "ActionItemArtifactNode"; readonly id: number }
        | { readonly __typename: "AsanaTaskArtifactNode"; readonly id: number }
        | { readonly __typename: "DecisionArtifactNode"; readonly id: number }
        | { readonly __typename: "DocumentArtifactNode"; readonly id: number }
        | { readonly __typename: "FeedbackArtifactNode"; readonly id: number }
        | {
            readonly __typename: "GithubIssuesArtifactNode";
            readonly id: number;
          }
        | {
            readonly __typename: "GoalArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly created: string;
            readonly updated?: string | null;
            readonly state: GoalState;
            readonly scope: GoalScope;
            readonly dueDate?: string | null;
            readonly goalVisibility: GoalVisibility;
            readonly status: GoalStatus;
            readonly startValue: number;
            readonly currentValue: number;
            readonly targetValue: number;
            readonly progress: number;
            readonly progressType: GoalProgressType;
            readonly isStale: boolean;
            readonly ownerCount?: number | null;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
            readonly activities: {
              readonly __typename: "ArtifactActivityNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "ArtifactActivityNodeEdge";
                readonly node?: {
                  readonly __typename: "ArtifactActivityNode";
                  readonly created: string;
                } | null;
              } | null>;
            };
            readonly keyResultsList: ReadonlyArray<{
              readonly __typename: "KeyResultNode";
              readonly id: number;
              readonly title: string;
              readonly startValue: number;
              readonly currentValue: number;
              readonly targetValue: number;
              readonly progressType: GoalProgressType;
              readonly assignee?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly kpi?: {
                readonly __typename: "KPINode";
                readonly id: number;
                readonly title: string;
              } | null;
            } | null>;
            readonly basicChildGoals?: {
              readonly __typename: "BasicGoalArtifactNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "BasicGoalArtifactNodeEdge";
                readonly node?: {
                  readonly __typename: "BasicGoalArtifactNode";
                  readonly id: number;
                  readonly artifactType: ArtifactType;
                  readonly startValue: number;
                  readonly currentValue: number;
                  readonly targetValue: number;
                  readonly progress: number;
                  readonly progressType: GoalProgressType;
                  readonly dueDate?: string | null;
                  readonly startDate?: string | null;
                  readonly state: GoalState;
                  readonly status: GoalStatus;
                  readonly scope: GoalScope;
                  readonly goalVisibility: GoalVisibility;
                  readonly created: string;
                  readonly parentGoalId?: number | null;
                  readonly ownerCount?: number | null;
                  readonly contributorCount?: number | null;
                  readonly isStale: boolean;
                  readonly firstOwner?: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly avatar?: string | null;
                    readonly name: string;
                  } | null;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                  readonly canUpdate: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                  readonly canRead: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                  readonly goalArtifact?: {
                    readonly __typename: "GoalArtifactNode";
                    readonly id: number;
                    readonly title?: string | null;
                  } | null;
                } | null;
              } | null>;
            } | null;
            readonly firstOwner?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          }
        | { readonly __typename: "KPIArtifactNode"; readonly id: number }
        | { readonly __typename: "RatingArtifactNode"; readonly id: number }
        | {
            readonly __typename: "RecognitionArtifactNode";
            readonly id: number;
          }
        | null;
    } | null>;
  } | null;
};

export type GetLastCheckinActivityQueryQueryVariables = Exact<{
  artifactId: Scalars["Int"]["input"];
}>;

export type GetLastCheckinActivityQueryQuery = {
  readonly __typename: "Query";
  readonly artifact:
    | { readonly __typename: "ActionItemArtifactNode"; readonly id: number }
    | { readonly __typename: "AsanaTaskArtifactNode"; readonly id: number }
    | { readonly __typename: "DecisionArtifactNode"; readonly id: number }
    | { readonly __typename: "DocumentArtifactNode"; readonly id: number }
    | { readonly __typename: "FeedbackArtifactNode"; readonly id: number }
    | { readonly __typename: "GithubIssuesArtifactNode"; readonly id: number }
    | {
        readonly __typename: "GoalArtifactNode";
        readonly currentValue: number;
        readonly targetValue: number;
        readonly progress: number;
        readonly startValue: number;
        readonly id: number;
        readonly keyResults: {
          readonly __typename: "KeyResultNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "KeyResultNodeEdge";
            readonly node?: {
              readonly __typename: "KeyResultNode";
              readonly id: number;
              readonly title: string;
              readonly startValue: number;
              readonly currentValue: number;
              readonly targetValue: number;
              readonly progressType: GoalProgressType;
              readonly kpi?: {
                readonly __typename: "KPINode";
                readonly id: number;
                readonly title: string;
                readonly currentMeasurement?: {
                  readonly __typename: "KPIMeasurementNode";
                  readonly id: number;
                  readonly measurement: number;
                } | null;
              } | null;
              readonly canUpdate?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              } | null;
              readonly assignee?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
                readonly email: string;
              } | null;
            } | null;
          } | null>;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly activities: {
          readonly __typename: "ArtifactActivityNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactActivityNodeEdge";
            readonly node?: {
              readonly __typename: "ArtifactActivityNode";
              readonly id: number;
              readonly created: string;
              readonly activityType: ArtifactActivityType;
              readonly canDelete?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
                readonly reason: string;
              } | null;
              readonly canUpdate?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
                readonly reason: string;
              } | null;
              readonly actor?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly changedFields?: ReadonlyArray<{
                readonly __typename: "ArtifactChangedFieldNode";
                readonly fieldName?: string | null;
                readonly previousValue?: string | null;
                readonly newValue?: string | null;
                readonly changedFields?: ReadonlyArray<{
                  readonly __typename: "ArtifactChangedFieldNode";
                  readonly newValue?: string | null;
                  readonly previousValue?: string | null;
                  readonly fieldName?: string | null;
                } | null> | null;
                readonly newValueObject?:
                  | {
                      readonly __typename: "BaseArtifactNode";
                      readonly id: number;
                      readonly title: string;
                      readonly artifactType: ArtifactType;
                    }
                  | {
                      readonly __typename: "CareerTrackRoleNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "CommentNode";
                      readonly id: number;
                      readonly comment?: any | null;
                      readonly deleted?: boolean | null;
                      readonly creator?: {
                        readonly __typename: "UserNode";
                        readonly id: number;
                        readonly name: string;
                        readonly avatar?: string | null;
                      } | null;
                    }
                  | {
                      readonly __typename: "CompetencyNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "KeyResultNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "TopicNode";
                      readonly id: number;
                      readonly title: string;
                      readonly meeting?: {
                        readonly __typename: "MeetingNode";
                        readonly id: number;
                        readonly title?: string | null;
                        readonly meetingGroupId: number;
                      } | null;
                    }
                  | {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    }
                  | null;
                readonly previousValueObject?:
                  | {
                      readonly __typename: "BaseArtifactNode";
                      readonly id: number;
                      readonly title: string;
                      readonly artifactType: ArtifactType;
                    }
                  | {
                      readonly __typename: "CareerTrackRoleNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | { readonly __typename: "CommentNode" }
                  | {
                      readonly __typename: "CompetencyNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "KeyResultNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "TopicNode";
                      readonly id: number;
                      readonly title: string;
                      readonly meeting?: {
                        readonly __typename: "MeetingNode";
                        readonly id: number;
                        readonly title?: string | null;
                        readonly meetingGroupId: number;
                      } | null;
                    }
                  | {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    }
                  | null;
              } | null> | null;
            } | null;
          } | null>;
        };
      }
    | { readonly __typename: "KPIArtifactNode"; readonly id: number }
    | { readonly __typename: "RatingArtifactNode"; readonly id: number }
    | { readonly __typename: "RecognitionArtifactNode"; readonly id: number };
};

export type HomepageDirectReportMeetingFragmentFragment = {
  readonly __typename: "MeetingNode";
  readonly id: number;
  readonly meetingGroupId: number;
  readonly startDatetime?: string | null;
};

export type HomepageDirectReportGoalFragmentFragment = {
  readonly __typename: "GoalArtifactNode";
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly state: GoalState;
  readonly isStale: boolean;
  readonly status: GoalStatus;
  readonly progress: number;
  readonly startValue: number;
  readonly currentValue: number;
  readonly targetValue: number;
  readonly progressType: GoalProgressType;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
};

export type GetHomepageDirectReportsMetadataQueryQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  directReportIds:
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>;
  hasDirectReportIds: Scalars["Boolean"]["input"];
  goalMax: Scalars["Int"]["input"];
  now: Scalars["DateTime"]["input"];
  currentUserId: Scalars["Int"]["input"];
}>;

export type GetHomepageDirectReportsMetadataQueryQuery = {
  readonly __typename: "Query";
  readonly directReports?: {
    readonly __typename: "UserNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "UserNodeEdge";
      readonly node?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly firstName: string;
        readonly name: string;
        readonly avatar?: string | null;
        readonly email: string;
        readonly status?: UserStatus | null;
        readonly calendarInsightStatus?: string | null;
        readonly homepageStatus?: string | null;
        readonly goals?: {
          readonly __typename: "ArtifactConnection";
          readonly totalCount: number;
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactEdge";
            readonly node?:
              | {
                  readonly __typename: "ActionItemArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "AsanaTaskArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "DecisionArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "DocumentArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "FeedbackArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "GithubIssuesArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "GoalArtifactNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly artifactType: ArtifactType;
                  readonly state: GoalState;
                  readonly isStale: boolean;
                  readonly status: GoalStatus;
                  readonly progress: number;
                  readonly startValue: number;
                  readonly currentValue: number;
                  readonly targetValue: number;
                  readonly progressType: GoalProgressType;
                  readonly canUpdate: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                  };
                }
              | { readonly __typename: "KPIArtifactNode"; readonly id: number }
              | {
                  readonly __typename: "RatingArtifactNode";
                  readonly id: number;
                }
              | {
                  readonly __typename: "RecognitionArtifactNode";
                  readonly id: number;
                }
              | null;
          } | null>;
        } | null;
        readonly meetings?: {
          readonly __typename: "MeetingNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "MeetingNodeEdge";
            readonly node?: {
              readonly __typename: "MeetingNode";
              readonly id: number;
              readonly meetingGroupId: number;
              readonly startDatetime?: string | null;
            } | null;
          } | null>;
        } | null;
      } | null;
    } | null>;
  };
};

export type InviteUsersMutationVariables = Exact<{
  invitationRequests:
    | ReadonlyArray<InputMaybe<InvitationInput>>
    | InputMaybe<InvitationInput>;
}>;

export type InviteUsersMutation = {
  readonly __typename: "Mutation";
  readonly createInvitations?: {
    readonly __typename: "CreateInvitationsMutation";
    readonly invitations?: ReadonlyArray<{
      readonly __typename: "InvitationNode";
      readonly id: number;
      readonly inviteKey: string;
      readonly inviteeEmail: string;
    } | null> | null;
    readonly invitationErrors?: ReadonlyArray<{
      readonly __typename: "InviteError";
      readonly inviteeEmail?: string | null;
      readonly message?: string | null;
    } | null> | null;
  } | null;
};

export type CreateOrUpdateKpiGroupMutationMutationVariables = Exact<{
  title?: InputMaybe<Scalars["String"]["input"]>;
  kpiGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type CreateOrUpdateKpiGroupMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateKpiGroup?: {
    readonly __typename: "CreateOrUpdateKPIGroupMutation";
    readonly kpiGroup?: {
      readonly __typename: "KPIGroupNode";
      readonly id: number;
      readonly title: string;
    } | null;
  } | null;
};

export type CreateOrUpdateKpiMeasurementMutationMutationVariables = Exact<{
  kpiMeasurementId?: InputMaybe<Scalars["Int"]["input"]>;
  kpiId?: InputMaybe<Scalars["Int"]["input"]>;
  measurement: Scalars["Float"]["input"];
  timestamp?: InputMaybe<Scalars["DateTime"]["input"]>;
}>;

export type CreateOrUpdateKpiMeasurementMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateKpiMeasurement?: {
    readonly __typename: "CreateOrUpdateKPIMeasurementMutation";
    readonly kpi?: {
      readonly __typename: "KPINode";
      readonly id: number;
    } | null;
    readonly kpiMeasurement?: {
      readonly __typename: "KPIMeasurementNode";
      readonly id: number;
      readonly measurement: number;
      readonly timestamp: string;
    } | null;
  } | null;
};

export type CreateOrUpdateKpiMutationMutationVariables = Exact<{
  title?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  visibility?: InputMaybe<KpiVisibility>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  kpiId?: InputMaybe<Scalars["Int"]["input"]>;
  integration?: InputMaybe<KpiIntegrationInput>;
  defaultSummaryPeriod?: InputMaybe<KpiSummaryPeriod>;
  defaultSummaryMethod?: InputMaybe<KpiSummaryMethod>;
  targetType?: InputMaybe<KpiTargetType>;
  targetValue?: InputMaybe<Scalars["Float"]["input"]>;
  targetCondition?: InputMaybe<KpiTargetCondition>;
  groupIds?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  teamIds?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
}>;

export type CreateOrUpdateKpiMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateKpi?: {
    readonly __typename: "CreateOrUpdateKPI";
    readonly kpi?: {
      readonly __typename: "KPINode";
      readonly id: number;
      readonly title: string;
      readonly description?: any | null;
      readonly visibility: KpiVisibility;
      readonly defaultSummaryMethod: KpiSummaryMethod;
      readonly defaultSummaryPeriod: KpiSummaryPeriod;
      readonly targetType: KpiTargetType;
      readonly targetValue?: number | null;
      readonly targetCondition: KpiTargetCondition;
      readonly groups?: {
        readonly __typename: "KPIGroupNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "KPIGroupNodeEdge";
          readonly node?: {
            readonly __typename: "KPIGroupNode";
            readonly id: number;
            readonly title: string;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type DeleteKpiMeasurementMutationMutationVariables = Exact<{
  measurementId: Scalars["Int"]["input"];
}>;

export type DeleteKpiMeasurementMutationMutation = {
  readonly __typename: "Mutation";
  readonly deleteKpiMeasurement?: {
    readonly __typename: "DeleteKPIMeasurement";
    readonly ok?: boolean | null;
  } | null;
};

export type DeleteKpiMutationMutationVariables = Exact<{
  kpiId: Scalars["Int"]["input"];
}>;

export type DeleteKpiMutationMutation = {
  readonly __typename: "Mutation";
  readonly deleteKpi?: {
    readonly __typename: "DeleteKPI";
    readonly ok?: boolean | null;
  } | null;
};

export type GetKpiGoalsQueryQueryVariables = Exact<{
  kpiId: Scalars["Int"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetKpiGoalsQueryQuery = {
  readonly __typename: "Query";
  readonly kpi?: {
    readonly __typename: "KPINode";
    readonly id: number;
    readonly linkedKeyResults?: {
      readonly __typename: "KeyResultNodeConnection";
      readonly totalCount: number;
      readonly pageInfo: {
        readonly __typename: "PageInfo";
        readonly endCursor?: string | null;
        readonly hasNextPage: boolean;
      };
      readonly edges: ReadonlyArray<{
        readonly __typename: "KeyResultNodeEdge";
        readonly node?: {
          readonly __typename: "KeyResultNode";
          readonly id: number;
          readonly goal?: {
            readonly __typename: "GoalArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly startValue: number;
            readonly currentValue: number;
            readonly targetValue: number;
            readonly progress: number;
            readonly progressType: GoalProgressType;
            readonly dueDate?: string | null;
            readonly startDate?: string | null;
            readonly state: GoalState;
            readonly status: GoalStatus;
            readonly scope: GoalScope;
            readonly goalVisibility: GoalVisibility;
            readonly created: string;
            readonly parentGoalId?: number | null;
            readonly ownerCount?: number | null;
            readonly contributorCount?: number | null;
            readonly isStale: boolean;
            readonly title?: string | null;
            readonly updated?: string | null;
            readonly activities: {
              readonly __typename: "ArtifactActivityNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "ArtifactActivityNodeEdge";
                readonly node?: {
                  readonly __typename: "ArtifactActivityNode";
                  readonly created: string;
                } | null;
              } | null>;
            };
            readonly firstOwner?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly avatar?: string | null;
              readonly name: string;
            } | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canRead: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          } | null;
        } | null;
      } | null>;
    } | null;
    readonly linkedGoals?: {
      readonly __typename: "GoalArtifactConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "GoalArtifactEdge";
        readonly node?: {
          readonly __typename: "GoalArtifactNode";
          readonly id: number;
          readonly artifactType: ArtifactType;
          readonly startValue: number;
          readonly currentValue: number;
          readonly targetValue: number;
          readonly progress: number;
          readonly progressType: GoalProgressType;
          readonly dueDate?: string | null;
          readonly startDate?: string | null;
          readonly state: GoalState;
          readonly status: GoalStatus;
          readonly scope: GoalScope;
          readonly goalVisibility: GoalVisibility;
          readonly created: string;
          readonly parentGoalId?: number | null;
          readonly ownerCount?: number | null;
          readonly contributorCount?: number | null;
          readonly isStale: boolean;
          readonly title?: string | null;
          readonly updated?: string | null;
          readonly activities: {
            readonly __typename: "ArtifactActivityNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "ArtifactActivityNodeEdge";
              readonly node?: {
                readonly __typename: "ArtifactActivityNode";
                readonly created: string;
              } | null;
            } | null>;
          };
          readonly firstOwner?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly avatar?: string | null;
            readonly name: string;
          } | null;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canUpdate: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canRead: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly creator?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetKpiGroupQueryQueryVariables = Exact<{
  kpiGroupId: Scalars["Int"]["input"];
}>;

export type GetKpiGroupQueryQuery = {
  readonly __typename: "Query";
  readonly kpiGroup?: {
    readonly __typename: "KPIGroupNode";
    readonly id: number;
    readonly title: string;
    readonly canDelete?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    } | null;
    readonly canUpdate?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    } | null;
  } | null;
};

export type KpiMeasurementTableFragment = {
  readonly __typename: "KPIMeasurementNode";
  readonly id: number;
  readonly measurement: number;
  readonly created: string;
  readonly timestamp: string;
  readonly canUpdate?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  } | null;
  readonly canDelete?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  } | null;
};

export type GetKpiMeasurementsQueryQueryVariables = Exact<{
  kpiId: Scalars["Int"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetKpiMeasurementsQueryQuery = {
  readonly __typename: "Query";
  readonly kpi?: {
    readonly __typename: "KPINode";
    readonly id: number;
    readonly measurements?: {
      readonly __typename: "KPIMeasurementNodeConnection";
      readonly pageInfo: {
        readonly __typename: "PageInfo";
        readonly hasNextPage: boolean;
        readonly endCursor?: string | null;
      };
      readonly edges: ReadonlyArray<{
        readonly __typename: "KPIMeasurementNodeEdge";
        readonly node?: {
          readonly __typename: "KPIMeasurementNode";
          readonly id: number;
          readonly measurement: number;
          readonly created: string;
          readonly timestamp: string;
          readonly canUpdate?: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
            readonly reason: string;
          } | null;
          readonly canDelete?: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
            readonly reason: string;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetKpiQueryQueryVariables = Exact<{
  kpiId: Scalars["Int"]["input"];
  hasKpi: Scalars["Boolean"]["input"];
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  hasOrganizationId: Scalars["Boolean"]["input"];
}>;

export type GetKpiQueryQuery = {
  readonly __typename: "Query";
  readonly kpiGroups?: {
    readonly __typename: "KPIGroupNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "KPIGroupNodeEdge";
      readonly node?: {
        readonly __typename: "KPIGroupNode";
        readonly id: number;
        readonly title: string;
      } | null;
    } | null>;
  } | null;
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
    readonly integrations: {
      readonly __typename: "OrganizationIntegrationNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "OrganizationIntegrationNodeEdge";
        readonly node?: {
          readonly __typename: "OrganizationIntegrationNode";
          readonly id: number;
          readonly integrationType: IntegrationTypes;
          readonly socialAuth: {
            readonly __typename: "UserSocialAuthNode";
            readonly id: number;
            readonly extraData: any;
          };
        } | null;
      } | null>;
    };
  } | null;
  readonly kpi?: {
    readonly __typename: "KPINode";
    readonly created: string;
    readonly description?: any | null;
    readonly id: number;
    readonly title: string;
    readonly visibility: KpiVisibility;
    readonly defaultSummaryPeriod: KpiSummaryPeriod;
    readonly defaultSummaryMethod: KpiSummaryMethod;
    readonly targetType: KpiTargetType;
    readonly targetValue?: number | null;
    readonly targetCondition: KpiTargetCondition;
    readonly teams?: {
      readonly __typename: "TeamNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "TeamNodeEdge";
        readonly node?: {
          readonly __typename: "TeamNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null>;
    } | null;
    readonly organization?: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
      readonly name: string;
    } | null;
    readonly currentMeasurement?: {
      readonly __typename: "KPIMeasurementNode";
      readonly id: number;
      readonly measurement: number;
    } | null;
    readonly canDelete?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    } | null;
    readonly canUpdate: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    };
    readonly groups?: {
      readonly __typename: "KPIGroupNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "KPIGroupNodeEdge";
        readonly node?: {
          readonly __typename: "KPIGroupNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null>;
    } | null;
    readonly integration?:
      | {
          readonly __typename: "GithubKPIIntegrationNode";
          readonly owner: string;
          readonly repository: string;
          readonly id: number;
          readonly integrationType?: KpiIntegrationType | null;
          readonly ghMetricType?: GithubIntegrationMetricType | null;
          readonly ghTimeBucket?: GithubIntegrationTimeBucket | null;
          readonly organizationIntegrationConnection?: {
            readonly __typename: "OrganizationIntegrationNode";
            readonly id: number;
          } | null;
        }
      | {
          readonly __typename: "GoogleSheetsKPIIntegrationNode";
          readonly spreadsheetId: string;
          readonly cellId?: string | null;
          readonly bottomRowFromColumn?: string | null;
          readonly rightmostColumnFromRow?: string | null;
          readonly id: number;
          readonly integrationType?: KpiIntegrationType | null;
          readonly organizationIntegrationConnection?: {
            readonly __typename: "OrganizationIntegrationNode";
            readonly id: number;
          } | null;
        }
      | {
          readonly __typename: "HubspotKPIIntegrationNode";
          readonly dealStageId?: string | null;
          readonly id: number;
          readonly integrationType?: KpiIntegrationType | null;
          readonly hubspotMetricType?: HubspotIntegrationMetricType | null;
          readonly hubspotTimeBucket?: HubspotIntegrationTimeBucket | null;
          readonly organizationIntegrationConnection?: {
            readonly __typename: "OrganizationIntegrationNode";
            readonly id: number;
          } | null;
        }
      | {
          readonly __typename: "SalesforceKPIIntegrationNode";
          readonly soqlQuery: string;
          readonly kpiFieldName: string;
          readonly id: number;
          readonly integrationType?: KpiIntegrationType | null;
          readonly organizationIntegrationConnection?: {
            readonly __typename: "OrganizationIntegrationNode";
            readonly id: number;
          } | null;
        }
      | {
          readonly __typename: "TopicflowKPIIntegrationNode";
          readonly metricType?: TopicflowIntegrationMetricType | null;
          readonly timeBucket?: TopicflowIntegrationTimeBucket | null;
          readonly value?: TopicflowIntegrationValue | null;
          readonly id: number;
          readonly integrationType?: KpiIntegrationType | null;
          readonly user?: {
            readonly __typename: "UserNode";
            readonly id: number;
          } | null;
          readonly organizationIntegrationConnection?: {
            readonly __typename: "OrganizationIntegrationNode";
            readonly id: number;
          } | null;
        }
      | null;
    readonly creator?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly avatar?: string | null;
      readonly name: string;
    } | null;
  } | null;
};

export type GetKpiSummaryQueryQueryVariables = Exact<{
  kpiId: Scalars["Int"]["input"];
  summaryPeriod?: InputMaybe<KpiSummaryPeriod>;
  summaryMethod?: InputMaybe<KpiSummaryMethod>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetKpiSummaryQueryQuery = {
  readonly __typename: "Query";
  readonly kpi?: {
    readonly __typename: "KPINode";
    readonly id: number;
    readonly title: string;
    readonly visibility: KpiVisibility;
    readonly defaultSummaryPeriod: KpiSummaryPeriod;
    readonly defaultSummaryMethod: KpiSummaryMethod;
    readonly targetType: KpiTargetType;
    readonly targetValue?: number | null;
    readonly targetCondition: KpiTargetCondition;
    readonly summarizedMeasurements: {
      readonly __typename: "SummarizedMeasurementsConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "SummarizedMeasurementsEdge";
        readonly node?: {
          readonly __typename: "SummarizedMeasurements";
          readonly aggregateMeasurementId?: string | null;
          readonly aggregateMeasurement?: number | null;
          readonly date?: string | null;
        } | null;
      } | null>;
    };
    readonly canUpdate: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    };
    readonly creator?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly avatar?: string | null;
      readonly name: string;
    } | null;
    readonly organization?: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
      readonly name: string;
    } | null;
    readonly teams?: {
      readonly __typename: "TeamNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "TeamNodeEdge";
        readonly node?: {
          readonly __typename: "TeamNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetKpiUpdateUrlQueryQueryVariables = Exact<{
  kpiId: Scalars["Int"]["input"];
}>;

export type GetKpiUpdateUrlQueryQuery = {
  readonly __typename: "Query";
  readonly kpi?: {
    readonly __typename: "KPINode";
    readonly id: number;
    readonly updateUrl: string;
    readonly currentMeasurement?: {
      readonly __typename: "KPIMeasurementNode";
      readonly measurement: number;
    } | null;
  } | null;
};

export type KpiDashboardKpiFragmentFragment = {
  readonly __typename: "KPINode";
  readonly id: number;
  readonly title: string;
  readonly visibility: KpiVisibility;
  readonly defaultSummaryPeriod: KpiSummaryPeriod;
  readonly defaultSummaryMethod: KpiSummaryMethod;
  readonly targetType: KpiTargetType;
  readonly targetValue?: number | null;
  readonly targetCondition: KpiTargetCondition;
  readonly groups?: {
    readonly __typename: "KPIGroupNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "KPIGroupNodeEdge";
      readonly node?: {
        readonly __typename: "KPIGroupNode";
        readonly id: number;
        readonly title: string;
      } | null;
    } | null>;
  } | null;
  readonly summarizedMeasurements: {
    readonly __typename: "SummarizedMeasurementsConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "SummarizedMeasurementsEdge";
      readonly node?: {
        readonly __typename: "SummarizedMeasurements";
        readonly aggregateMeasurementId?: string | null;
        readonly aggregateMeasurement?: number | null;
        readonly date?: string | null;
      } | null;
    } | null>;
  };
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  };
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly avatar?: string | null;
    readonly name: string;
  } | null;
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
    readonly name: string;
  } | null;
  readonly teams?: {
    readonly __typename: "TeamNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "TeamNodeEdge";
      readonly node?: {
        readonly __typename: "TeamNode";
        readonly id: number;
        readonly title: string;
      } | null;
    } | null>;
  } | null;
};

export type GetKpisQueryQueryVariables = Exact<{
  first: Scalars["Int"]["input"];
  kpiSummaryPeriod: KpiSummaryPeriod;
}>;

export type GetKpisQueryQuery = {
  readonly __typename: "Query";
  readonly kpis?: {
    readonly __typename: "KPINodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "KPINodeEdge";
      readonly node?: {
        readonly __typename: "KPINode";
        readonly id: number;
        readonly title: string;
        readonly visibility: KpiVisibility;
        readonly defaultSummaryPeriod: KpiSummaryPeriod;
        readonly defaultSummaryMethod: KpiSummaryMethod;
        readonly targetType: KpiTargetType;
        readonly targetValue?: number | null;
        readonly targetCondition: KpiTargetCondition;
        readonly groups?: {
          readonly __typename: "KPIGroupNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "KPIGroupNodeEdge";
            readonly node?: {
              readonly __typename: "KPIGroupNode";
              readonly id: number;
              readonly title: string;
            } | null;
          } | null>;
        } | null;
        readonly summarizedMeasurements: {
          readonly __typename: "SummarizedMeasurementsConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "SummarizedMeasurementsEdge";
            readonly node?: {
              readonly __typename: "SummarizedMeasurements";
              readonly aggregateMeasurementId?: string | null;
              readonly aggregateMeasurement?: number | null;
              readonly date?: string | null;
            } | null;
          } | null>;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
          readonly reason: string;
        };
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly avatar?: string | null;
          readonly name: string;
        } | null;
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
          readonly name: string;
        } | null;
        readonly teams?: {
          readonly __typename: "TeamNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "TeamNodeEdge";
            readonly node?: {
              readonly __typename: "TeamNode";
              readonly id: number;
              readonly title: string;
            } | null;
          } | null>;
        } | null;
      } | null;
    } | null>;
  } | null;
  readonly kpiGroups?: {
    readonly __typename: "KPIGroupNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "KPIGroupNodeEdge";
      readonly node?: {
        readonly __typename: "KPIGroupNode";
        readonly id: number;
        readonly title: string;
      } | null;
    } | null>;
  } | null;
};

export type KpiFragmentFragment = {
  readonly __typename: "KPINode";
  readonly id: number;
  readonly title: string;
  readonly visibility: KpiVisibility;
  readonly defaultSummaryPeriod: KpiSummaryPeriod;
  readonly defaultSummaryMethod: KpiSummaryMethod;
  readonly targetType: KpiTargetType;
  readonly targetValue?: number | null;
  readonly targetCondition: KpiTargetCondition;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  };
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly avatar?: string | null;
    readonly name: string;
  } | null;
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
    readonly name: string;
  } | null;
  readonly teams?: {
    readonly __typename: "TeamNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "TeamNodeEdge";
      readonly node?: {
        readonly __typename: "TeamNode";
        readonly id: number;
        readonly title: string;
      } | null;
    } | null>;
  } | null;
};

export type KpiSummarizedMeasurementFragmentFragment = {
  readonly __typename: "SummarizedMeasurements";
  readonly aggregateMeasurementId?: string | null;
  readonly aggregateMeasurement?: number | null;
  readonly date?: string | null;
};

export type ExplorerBookmarkFragmentFragment = {
  readonly __typename: "ExplorerFilterBookmarkNode";
  readonly id: number;
  readonly title: string;
  readonly filters: string;
  readonly private: boolean;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
};

type FavouriteArtifactFragment_ActionItemArtifactNode_Fragment = {
  readonly __typename: "ActionItemArtifactNode";
  readonly id: number;
};

type FavouriteArtifactFragment_AsanaTaskArtifactNode_Fragment = {
  readonly __typename: "AsanaTaskArtifactNode";
  readonly id: number;
};

type FavouriteArtifactFragment_DecisionArtifactNode_Fragment = {
  readonly __typename: "DecisionArtifactNode";
  readonly id: number;
};

type FavouriteArtifactFragment_DocumentArtifactNode_Fragment = {
  readonly __typename: "DocumentArtifactNode";
  readonly id: number;
};

type FavouriteArtifactFragment_FeedbackArtifactNode_Fragment = {
  readonly __typename: "FeedbackArtifactNode";
  readonly id: number;
};

type FavouriteArtifactFragment_GithubIssuesArtifactNode_Fragment = {
  readonly __typename: "GithubIssuesArtifactNode";
  readonly id: number;
};

type FavouriteArtifactFragment_GoalArtifactNode_Fragment = {
  readonly __typename: "GoalArtifactNode";
  readonly id: number;
};

type FavouriteArtifactFragment_KpiArtifactNode_Fragment = {
  readonly __typename: "KPIArtifactNode";
  readonly id: number;
};

type FavouriteArtifactFragment_RatingArtifactNode_Fragment = {
  readonly __typename: "RatingArtifactNode";
  readonly id: number;
};

type FavouriteArtifactFragment_RecognitionArtifactNode_Fragment = {
  readonly __typename: "RecognitionArtifactNode";
  readonly id: number;
};

export type FavouriteArtifactFragmentFragment =
  | FavouriteArtifactFragment_ActionItemArtifactNode_Fragment
  | FavouriteArtifactFragment_AsanaTaskArtifactNode_Fragment
  | FavouriteArtifactFragment_DecisionArtifactNode_Fragment
  | FavouriteArtifactFragment_DocumentArtifactNode_Fragment
  | FavouriteArtifactFragment_FeedbackArtifactNode_Fragment
  | FavouriteArtifactFragment_GithubIssuesArtifactNode_Fragment
  | FavouriteArtifactFragment_GoalArtifactNode_Fragment
  | FavouriteArtifactFragment_KpiArtifactNode_Fragment
  | FavouriteArtifactFragment_RatingArtifactNode_Fragment
  | FavouriteArtifactFragment_RecognitionArtifactNode_Fragment;

export type LoggedInUserOrgFragment = {
  readonly __typename: "OrganizationNode";
  readonly id: number;
  readonly name: string;
  readonly topicChannelName?: string | null;
  readonly personal?: boolean | null;
  readonly goalLabel: string;
  readonly keyResultLabel: string;
  readonly teamLabel: string;
  readonly orgLabel: string;
  readonly recognitionLabel: string;
  readonly oneononeLabel: string;
  readonly reviewLabel: string;
  readonly expectationLabel: string;
  readonly conversationLabel: string;
  readonly developmentLabel: string;
  readonly competencyLabel: string;
  readonly daysLeftOnTrial?: number | null;
  readonly pricingTier?: PricingTier | null;
  readonly maxCareerTrackRoleLevel: number;
  readonly quarterStartMonth: number;
  readonly enableMeetingSummarization: boolean;
  readonly effectivePricingTier?: PricingTier | null;
  readonly defaultGoalState?: GoalState | null;
  readonly hasCareerFramework?: boolean | null;
  readonly hasSlackConnection?: boolean | null;
  readonly hasTeamsNotificationConnection?: boolean | null;
  readonly hasYoutrackIntegration?: boolean | null;
  readonly hasTeamsInstallation?: boolean | null;
  readonly hasTeamsTranscriptConnection?: boolean | null;
  readonly hasGithubInstallation?: boolean | null;
  readonly hasFellowTranscriptSyncConnection?: boolean | null;
  readonly fellowApiDomain?: string | null;
  readonly youtrackUrl?: string | null;
  readonly teams?: {
    readonly __typename: "TeamNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "TeamNodeEdge";
      readonly node?: {
        readonly __typename: "TeamNode";
        readonly id: number;
        readonly title: string;
      } | null;
    } | null>;
  } | null;
  readonly userMembership?: {
    readonly __typename: "UserMemberNode";
    readonly id: number;
    readonly role?: OrganizationRole | null;
  } | null;
  readonly actionItemStates: ReadonlyArray<{
    readonly __typename: "ActionItemState";
    readonly value: number;
    readonly label: string;
    readonly isComplete: boolean;
    readonly isDefaultIncomplete: boolean;
  } | null>;
  readonly coreValues?: {
    readonly __typename: "RecognitionCoreValueNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "RecognitionCoreValueNodeEdge";
      readonly node?: {
        readonly __typename: "RecognitionCoreValueNode";
        readonly id: number;
        readonly title: string;
        readonly description: string;
        readonly emoji?: string | null;
        readonly image?: string | null;
      } | null;
    } | null>;
  } | null;
  readonly featureFlags: {
    readonly __typename: "OrganizationFeatureFlags";
    readonly actionItems?: boolean | null;
    readonly feedbacks?: boolean | null;
    readonly goals?: boolean | null;
    readonly recognitions?: boolean | null;
    readonly kpis?: boolean | null;
    readonly explorer?: boolean | null;
    readonly homepageMyConnections?: boolean | null;
    readonly homepageMyConnectionsPeers?: boolean | null;
    readonly meetings?: boolean | null;
    readonly workHistory?: boolean | null;
    readonly askAi?: boolean | null;
    readonly reviewContextGeneration?: boolean | null;
  };
  readonly mergeIntegrationsMetadata: ReadonlyArray<{
    readonly __typename: "MergeIntegrationMetadata";
    readonly name: string;
    readonly displayName: string;
    readonly iconUrl: string;
    readonly imageUrl: string;
    readonly sourceProvider: string;
  } | null>;
  readonly globalAdmins: {
    readonly __typename: "UserMemberNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "UserMemberNodeEdge";
      readonly node?: {
        readonly __typename: "UserMemberNode";
        readonly id: number;
        readonly user?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null;
    } | null>;
  };
  readonly allMembers?: {
    readonly __typename: "UserMemberNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "UserMemberNodeEdge";
      readonly node?: {
        readonly __typename: "UserMemberNode";
        readonly id: number;
        readonly user?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly email: string;
        } | null;
      } | null;
    } | null>;
  };
};

export type GetLoggedInUserQueryVariables = Exact<{
  canImpersonate: Scalars["Boolean"]["input"];
}>;

export type GetLoggedInUserQuery = {
  readonly __typename: "Query";
  readonly loggedIn?: boolean | null;
  readonly me?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly email: string;
    readonly emails: ReadonlyArray<string>;
    readonly name: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly status?: UserStatus | null;
    readonly avatar?: string | null;
    readonly hasAsanaAuth?: boolean | null;
    readonly hasHubspotAuth?: boolean | null;
    readonly hasGithubAuth?: boolean | null;
    readonly hasJiraAuth?: boolean | null;
    readonly hasZoomAuth?: boolean | null;
    readonly hasGoogleSheetsAuth?: boolean | null;
    readonly hasSalesforceAuth?: boolean | null;
    readonly hasReadAiAuth?: boolean | null;
    readonly hasGranolaPersonalApiToken?: boolean | null;
    readonly hasFirefliesPersonalApiToken?: boolean | null;
    readonly onboardingData?: any | null;
    readonly eventLinkInDescriptionPreference?: EventDescriptionLinkSetting | null;
    readonly timezone?: string | null;
    readonly pusherChannelName?: string | null;
    readonly hasSyncedCalendar?: boolean | null;
    readonly uiPreferenceCache?: any | null;
    readonly videoRecordingPreference?: UserVideoRecordingPreference | null;
    readonly onlyUserInOrg?: boolean | null;
    readonly calendarIsSyncingForFirstTime?: boolean | null;
    readonly hasCalendarSyncError?: boolean | null;
    readonly hasOrgWithTooManyUsers?: boolean | null;
    readonly reportingTreeIds: ReadonlyArray<number | null>;
    readonly meetingBotPreference?: UserMeetingBotPreference | null;
    readonly showPersonalMeetings?: boolean | null;
    readonly explorerBookmarks?: {
      readonly __typename: "ExplorerFilterBookmarkNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "ExplorerFilterBookmarkNodeEdge";
        readonly node?: {
          readonly __typename: "ExplorerFilterBookmarkNode";
          readonly id: number;
          readonly title: string;
          readonly filters: string;
          readonly private: boolean;
          readonly canUpdate: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
        } | null;
      } | null>;
    } | null;
    readonly favouriteArtifacts: {
      readonly __typename: "ArtifactConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "ArtifactEdge";
        readonly node?:
          | {
              readonly __typename: "ActionItemArtifactNode";
              readonly id: number;
            }
          | {
              readonly __typename: "AsanaTaskArtifactNode";
              readonly id: number;
            }
          | { readonly __typename: "DecisionArtifactNode"; readonly id: number }
          | { readonly __typename: "DocumentArtifactNode"; readonly id: number }
          | { readonly __typename: "FeedbackArtifactNode"; readonly id: number }
          | {
              readonly __typename: "GithubIssuesArtifactNode";
              readonly id: number;
            }
          | { readonly __typename: "GoalArtifactNode"; readonly id: number }
          | { readonly __typename: "KPIArtifactNode"; readonly id: number }
          | { readonly __typename: "RatingArtifactNode"; readonly id: number }
          | {
              readonly __typename: "RecognitionArtifactNode";
              readonly id: number;
            }
          | null;
      } | null>;
    };
    readonly favouritesGroups?: {
      readonly __typename: "FavouritesGroupNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "FavouritesGroupNodeEdge";
        readonly node?: {
          readonly __typename: "FavouritesGroupNode";
          readonly id: number;
          readonly users?: {
            readonly __typename: "UserNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "UserNodeEdge";
              readonly node?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly firstName: string;
                readonly name: string;
                readonly email: string;
                readonly avatar?: string | null;
              } | null;
            } | null>;
          } | null;
        } | null;
      } | null>;
    } | null;
    readonly syncCredentials?: {
      readonly __typename: "UserSyncCredentialsNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserSyncCredentialsNodeEdge";
        readonly node?: {
          readonly __typename: "UserSyncCredentialsNode";
          readonly id: number;
          readonly provider?: SyncCredentialsTypeEnum | null;
          readonly credentialsUid?: string | null;
          readonly hasValidCalendarCredentials?: boolean | null;
          readonly hasCalendarWriteCredentials?: boolean | null;
          readonly organization?: {
            readonly __typename: "OrganizationNode";
            readonly id: number;
            readonly domains?: ReadonlyArray<string | null> | null;
          } | null;
        } | null;
      } | null>;
    } | null;
    readonly organizations: {
      readonly __typename: "OrganizationNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "OrganizationNodeEdge";
        readonly node?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
          readonly name: string;
          readonly topicChannelName?: string | null;
          readonly personal?: boolean | null;
          readonly goalLabel: string;
          readonly keyResultLabel: string;
          readonly teamLabel: string;
          readonly orgLabel: string;
          readonly recognitionLabel: string;
          readonly oneononeLabel: string;
          readonly reviewLabel: string;
          readonly expectationLabel: string;
          readonly conversationLabel: string;
          readonly developmentLabel: string;
          readonly competencyLabel: string;
          readonly daysLeftOnTrial?: number | null;
          readonly pricingTier?: PricingTier | null;
          readonly maxCareerTrackRoleLevel: number;
          readonly quarterStartMonth: number;
          readonly enableMeetingSummarization: boolean;
          readonly effectivePricingTier?: PricingTier | null;
          readonly defaultGoalState?: GoalState | null;
          readonly hasCareerFramework?: boolean | null;
          readonly hasSlackConnection?: boolean | null;
          readonly hasTeamsNotificationConnection?: boolean | null;
          readonly hasYoutrackIntegration?: boolean | null;
          readonly hasTeamsInstallation?: boolean | null;
          readonly hasTeamsTranscriptConnection?: boolean | null;
          readonly hasGithubInstallation?: boolean | null;
          readonly hasFellowTranscriptSyncConnection?: boolean | null;
          readonly fellowApiDomain?: string | null;
          readonly youtrackUrl?: string | null;
          readonly teams?: {
            readonly __typename: "TeamNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "TeamNodeEdge";
              readonly node?: {
                readonly __typename: "TeamNode";
                readonly id: number;
                readonly title: string;
              } | null;
            } | null>;
          } | null;
          readonly userMembership?: {
            readonly __typename: "UserMemberNode";
            readonly id: number;
            readonly role?: OrganizationRole | null;
          } | null;
          readonly actionItemStates: ReadonlyArray<{
            readonly __typename: "ActionItemState";
            readonly value: number;
            readonly label: string;
            readonly isComplete: boolean;
            readonly isDefaultIncomplete: boolean;
          } | null>;
          readonly coreValues?: {
            readonly __typename: "RecognitionCoreValueNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "RecognitionCoreValueNodeEdge";
              readonly node?: {
                readonly __typename: "RecognitionCoreValueNode";
                readonly id: number;
                readonly title: string;
                readonly description: string;
                readonly emoji?: string | null;
                readonly image?: string | null;
              } | null;
            } | null>;
          } | null;
          readonly featureFlags: {
            readonly __typename: "OrganizationFeatureFlags";
            readonly actionItems?: boolean | null;
            readonly feedbacks?: boolean | null;
            readonly goals?: boolean | null;
            readonly recognitions?: boolean | null;
            readonly kpis?: boolean | null;
            readonly explorer?: boolean | null;
            readonly homepageMyConnections?: boolean | null;
            readonly homepageMyConnectionsPeers?: boolean | null;
            readonly meetings?: boolean | null;
            readonly workHistory?: boolean | null;
            readonly askAi?: boolean | null;
            readonly reviewContextGeneration?: boolean | null;
          };
          readonly mergeIntegrationsMetadata: ReadonlyArray<{
            readonly __typename: "MergeIntegrationMetadata";
            readonly name: string;
            readonly displayName: string;
            readonly iconUrl: string;
            readonly imageUrl: string;
            readonly sourceProvider: string;
          } | null>;
          readonly globalAdmins: {
            readonly __typename: "UserMemberNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "UserMemberNodeEdge";
              readonly node?: {
                readonly __typename: "UserMemberNode";
                readonly id: number;
                readonly user?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly name: string;
                  readonly avatar?: string | null;
                } | null;
              } | null;
            } | null>;
          };
          readonly allMembers?: {
            readonly __typename: "UserMemberNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "UserMemberNodeEdge";
              readonly node?: {
                readonly __typename: "UserMemberNode";
                readonly id: number;
                readonly user?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly name: string;
                  readonly email: string;
                } | null;
              } | null;
            } | null>;
          };
        } | null;
      } | null>;
    };
    readonly paidFeatures: {
      readonly __typename: "PaidFeaturesNode";
      readonly canCreateGoals?: boolean | null;
      readonly canCreateGroupGoals?: boolean | null;
      readonly canCreateOrgTemplates?: boolean | null;
    };
    readonly directReports: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly firstName: string;
          readonly name: string;
          readonly avatar?: string | null;
          readonly email: string;
          readonly status?: UserStatus | null;
        } | null;
      } | null>;
    };
    readonly managers: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly firstName: string;
          readonly name: string;
          readonly avatar?: string | null;
          readonly email: string;
        } | null;
      } | null>;
    };
    readonly peers: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly firstName: string;
          readonly name: string;
          readonly avatar?: string | null;
          readonly email: string;
        } | null;
      } | null>;
    };
    readonly teams?: {
      readonly __typename: "TeamNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "TeamNodeEdge";
        readonly node?: {
          readonly __typename: "TeamNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetRefreshedUserDataQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetRefreshedUserDataQuery = {
  readonly __typename: "Query";
  readonly me?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly tiptapAiJwt?: string | null;
  } | null;
};

export type SidebarMeetingFragmentFragment = {
  readonly __typename: "MeetingNode";
  readonly id: number;
  readonly title?: string | null;
  readonly draft: boolean;
  readonly isRecurring: boolean;
  readonly startDate?: string | null;
  readonly startDatetime?: string | null;
  readonly endDatetime?: string | null;
  readonly externalUrl?: string | null;
  readonly ignored: boolean;
  readonly videoConferenceType?: OnlineVideoConference | null;
  readonly videoConferenceUrl?: string | null;
  readonly meetingGroup?: {
    readonly __typename: "MeetingGroupNode";
    readonly id: number;
    readonly isFormalOneonone: boolean;
    readonly hasTemplate?: boolean | null;
    readonly facilitator?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
    } | null;
  } | null;
  readonly organizer?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
  } | null;
  readonly canDelete?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  } | null;
  readonly canUpdate?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  } | null;
};

export type GetSidebarDataQueryQueryVariables = Exact<{
  participants:
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>;
  startDatetimeGte: Scalars["DateTime"]["input"];
  startDatetimeLte: Scalars["DateTime"]["input"];
}>;

export type GetSidebarDataQueryQuery = {
  readonly __typename: "Query";
  readonly meetings?: {
    readonly __typename: "MeetingNodeConnection";
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly hasNextPage: boolean;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "MeetingNodeEdge";
      readonly node?: {
        readonly __typename: "MeetingNode";
        readonly id: number;
        readonly title?: string | null;
        readonly draft: boolean;
        readonly isRecurring: boolean;
        readonly startDate?: string | null;
        readonly startDatetime?: string | null;
        readonly endDatetime?: string | null;
        readonly externalUrl?: string | null;
        readonly ignored: boolean;
        readonly videoConferenceType?: OnlineVideoConference | null;
        readonly videoConferenceUrl?: string | null;
        readonly meetingGroup?: {
          readonly __typename: "MeetingGroupNode";
          readonly id: number;
          readonly isFormalOneonone: boolean;
          readonly hasTemplate?: boolean | null;
          readonly facilitator?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
          } | null;
        } | null;
        readonly organizer?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
        } | null;
        readonly canDelete?: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        } | null;
        readonly canUpdate?: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        } | null;
      } | null;
    } | null>;
  } | null;
  readonly unscheduledMeetings?: {
    readonly __typename: "MeetingNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "MeetingNodeEdge";
      readonly node?: {
        readonly __typename: "MeetingNode";
        readonly id: number;
        readonly title?: string | null;
        readonly draft: boolean;
        readonly isRecurring: boolean;
        readonly startDate?: string | null;
        readonly startDatetime?: string | null;
        readonly endDatetime?: string | null;
        readonly externalUrl?: string | null;
        readonly ignored: boolean;
        readonly videoConferenceType?: OnlineVideoConference | null;
        readonly videoConferenceUrl?: string | null;
        readonly meetingGroup?: {
          readonly __typename: "MeetingGroupNode";
          readonly id: number;
          readonly isFormalOneonone: boolean;
          readonly hasTemplate?: boolean | null;
          readonly facilitator?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
          } | null;
        } | null;
        readonly organizer?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
        } | null;
        readonly canDelete?: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        } | null;
        readonly canUpdate?: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        } | null;
      } | null;
    } | null>;
  } | null;
  readonly me?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly calendarIsSyncingForFirstTime?: boolean | null;
    readonly hasCalendarSyncError?: boolean | null;
  } | null;
};

export type UpdateUserTimezoneMutationVariables = Exact<{
  userId: Scalars["Int"]["input"];
  timezone: Scalars["String"]["input"];
}>;

export type UpdateUserTimezoneMutation = {
  readonly __typename: "Mutation";
  readonly updateUser?: {
    readonly __typename: "UpdateUserMutation";
    readonly user?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly timezone?: string | null;
    } | null;
  } | null;
};

export type CancelMeetingMutationMutationVariables = Exact<{
  meetingId: Scalars["Int"]["input"];
  editType: MeetingEditTypeEnum;
}>;

export type CancelMeetingMutationMutation = {
  readonly __typename: "Mutation";
  readonly cancelMeeting?: {
    readonly __typename: "CancelMeetingMutation";
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
      readonly status?: EventStatus | null;
    } | null;
  } | null;
};

export type CreateOrUpdateMeetingInExternalCalendarMutationMutationVariables =
  Exact<{
    attendees:
      | ReadonlyArray<InputMaybe<AttendeeInput>>
      | InputMaybe<AttendeeInput>;
    onlineConference: OnlineConference;
    editType: MeetingEditTypeEnum;
    credentialsId?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    startDatetime?: InputMaybe<Scalars["DateTime"]["input"]>;
    endDatetime?: InputMaybe<Scalars["DateTime"]["input"]>;
    recurrence?: InputMaybe<FrequencyInput>;
    startTimezone?: InputMaybe<Scalars["String"]["input"]>;
    endTimezone?: InputMaybe<Scalars["String"]["input"]>;
    meetingId?: InputMaybe<Scalars["Int"]["input"]>;
    organizationId?: InputMaybe<Scalars["Int"]["input"]>;
    publish: Scalars["Boolean"]["input"];
    title: Scalars["String"]["input"];
    isFormalOneonone: Scalars["Boolean"]["input"];
    addTranscriptionBotToMeetingsByDefault: Scalars["Boolean"]["input"];
    facilitatorId?: InputMaybe<Scalars["Int"]["input"]>;
    templateId?: InputMaybe<Scalars["Int"]["input"]>;
  }>;

export type CreateOrUpdateMeetingInExternalCalendarMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateMeetingInExternalCalendar?: {
    readonly __typename: "CreateOrUpdateMeetingInExternalCalendarMutation";
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
      readonly title?: string | null;
      readonly description?: string | null;
      readonly draft: boolean;
      readonly meetingGroupId: number;
      readonly ignored: boolean;
      readonly videoConferenceType?: OnlineVideoConference | null;
      readonly videoConferenceUrl?: string | null;
      readonly startDatetime?: string | null;
      readonly endDatetime?: string | null;
      readonly isRecurring: boolean;
      readonly botIsRecording: boolean;
      readonly botIsWaitingToJoinMeeting: boolean;
      readonly hasBotInMeeting: boolean;
      readonly organizer?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
      } | null;
      readonly meetingGroup?: {
        readonly __typename: "MeetingGroupNode";
        readonly id: number;
        readonly title: string;
        readonly description?: string | null;
        readonly isFormalOneonone: boolean;
        readonly recurrenceRule?: string | null;
        readonly onlineConference: OnlineConference;
        readonly addTranscriptionBotToMeetingsByDefault: boolean;
        readonly transcribeMeetingsByDefault?: boolean | null;
        readonly facilitator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly topicTemplate?: {
          readonly __typename: "TopicTemplateNode";
          readonly id: number;
        } | null;
        readonly syncCredentials?: {
          readonly __typename: "UserSyncCredentialsNode";
          readonly id: number;
          readonly credentialsUid?: string | null;
        } | null;
        readonly recurrenceParameters?: {
          readonly __typename: "FrequencyNode";
          readonly byMonthDay?: ReadonlyArray<number | null> | null;
          readonly byYearDay?: ReadonlyArray<number | null> | null;
          readonly byWeekDay?: ReadonlyArray<number | null> | null;
          readonly bySetPos?: ReadonlyArray<number | null> | null;
          readonly frequency: FrequencyEnum;
          readonly interval: number;
        } | null;
      } | null;
      readonly canRead?: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
        readonly reason: string;
      } | null;
      readonly canUpdate?: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
        readonly reason: string;
      } | null;
      readonly canDelete?: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
        readonly reason: string;
      } | null;
      readonly creator?: {
        readonly __typename: "UserNode";
        readonly id: number;
      } | null;
      readonly participants?: {
        readonly __typename: "MeetingParticipantConnection";
        readonly totalCount: number;
        readonly edges: ReadonlyArray<{
          readonly __typename: "MeetingParticipantEdge";
          readonly node?: {
            readonly __typename: "MeetingParticipantNode";
            readonly id?: string | null;
            readonly status?: AttendeeStatus | null;
            readonly participantEmail?: string | null;
            readonly role?: AttendeeRole | null;
            readonly user?: {
              readonly __typename: "BasicUserNode";
              readonly id: number;
              readonly name: string;
              readonly firstName: string;
              readonly lastName: string;
              readonly avatar?: string | null;
              readonly email: string;
              readonly status?: UserStatus | null;
            } | null;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type GetMeetingToEditQueryQueryVariables = Exact<{
  meetingId: Scalars["Int"]["input"];
}>;

export type GetMeetingToEditQueryQuery = {
  readonly __typename: "Query";
  readonly meeting?: {
    readonly __typename: "MeetingNode";
    readonly id: number;
    readonly title?: string | null;
    readonly description?: string | null;
    readonly draft: boolean;
    readonly meetingGroupId: number;
    readonly ignored: boolean;
    readonly videoConferenceType?: OnlineVideoConference | null;
    readonly videoConferenceUrl?: string | null;
    readonly startDatetime?: string | null;
    readonly endDatetime?: string | null;
    readonly isRecurring: boolean;
    readonly botIsRecording: boolean;
    readonly botIsWaitingToJoinMeeting: boolean;
    readonly hasBotInMeeting: boolean;
    readonly organizer?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
    } | null;
    readonly meetingGroup?: {
      readonly __typename: "MeetingGroupNode";
      readonly id: number;
      readonly title: string;
      readonly description?: string | null;
      readonly isFormalOneonone: boolean;
      readonly recurrenceRule?: string | null;
      readonly onlineConference: OnlineConference;
      readonly addTranscriptionBotToMeetingsByDefault: boolean;
      readonly transcribeMeetingsByDefault?: boolean | null;
      readonly facilitator?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      } | null;
      readonly topicTemplate?: {
        readonly __typename: "TopicTemplateNode";
        readonly id: number;
      } | null;
      readonly syncCredentials?: {
        readonly __typename: "UserSyncCredentialsNode";
        readonly id: number;
        readonly credentialsUid?: string | null;
      } | null;
      readonly recurrenceParameters?: {
        readonly __typename: "FrequencyNode";
        readonly byMonthDay?: ReadonlyArray<number | null> | null;
        readonly byYearDay?: ReadonlyArray<number | null> | null;
        readonly byWeekDay?: ReadonlyArray<number | null> | null;
        readonly bySetPos?: ReadonlyArray<number | null> | null;
        readonly frequency: FrequencyEnum;
        readonly interval: number;
      } | null;
    } | null;
    readonly canRead?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    } | null;
    readonly canUpdate?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    } | null;
    readonly canDelete?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    } | null;
    readonly creator?: {
      readonly __typename: "UserNode";
      readonly id: number;
    } | null;
    readonly participants?: {
      readonly __typename: "MeetingParticipantConnection";
      readonly totalCount: number;
      readonly edges: ReadonlyArray<{
        readonly __typename: "MeetingParticipantEdge";
        readonly node?: {
          readonly __typename: "MeetingParticipantNode";
          readonly id?: string | null;
          readonly status?: AttendeeStatus | null;
          readonly participantEmail?: string | null;
          readonly role?: AttendeeRole | null;
          readonly user?: {
            readonly __typename: "BasicUserNode";
            readonly id: number;
            readonly name: string;
            readonly firstName: string;
            readonly lastName: string;
            readonly avatar?: string | null;
            readonly email: string;
            readonly status?: UserStatus | null;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetTeamMembersQueryQueryVariables = Exact<{
  teamId: Scalars["Int"]["input"];
}>;

export type GetTeamMembersQueryQuery = {
  readonly __typename: "Query";
  readonly team?: {
    readonly __typename: "TeamNode";
    readonly id: number;
    readonly title: string;
    readonly members?: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly firstName: string;
          readonly email: string;
          readonly avatar?: string | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type Upcoming1on1MeetingFragment = {
  readonly __typename: "MeetingNode";
  readonly id: number;
  readonly title?: string | null;
  readonly startDatetime?: string | null;
  readonly endDatetime?: string | null;
  readonly meetingGroupId: number;
  readonly draft: boolean;
  readonly isLocked: boolean;
  readonly isFinalized: boolean;
};

export type GetUpcoming1on1sQueryVariables = Exact<{
  startDatetime: Scalars["DateTime"]["input"];
  participants:
    | ReadonlyArray<Scalars["Int"]["input"]>
    | Scalars["Int"]["input"];
}>;

export type GetUpcoming1on1sQuery = {
  readonly __typename: "Query";
  readonly scheduledMeetings?: {
    readonly __typename: "MeetingNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "MeetingNodeEdge";
      readonly node?: {
        readonly __typename: "MeetingNode";
        readonly id: number;
        readonly title?: string | null;
        readonly startDatetime?: string | null;
        readonly endDatetime?: string | null;
        readonly meetingGroupId: number;
        readonly draft: boolean;
        readonly isLocked: boolean;
        readonly isFinalized: boolean;
      } | null;
    } | null>;
  } | null;
};

export type MeetingDialogFragmentFragment = {
  readonly __typename: "MeetingNode";
  readonly id: number;
  readonly title?: string | null;
  readonly description?: string | null;
  readonly draft: boolean;
  readonly meetingGroupId: number;
  readonly ignored: boolean;
  readonly videoConferenceType?: OnlineVideoConference | null;
  readonly videoConferenceUrl?: string | null;
  readonly startDatetime?: string | null;
  readonly endDatetime?: string | null;
  readonly isRecurring: boolean;
  readonly botIsRecording: boolean;
  readonly botIsWaitingToJoinMeeting: boolean;
  readonly hasBotInMeeting: boolean;
  readonly organizer?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
  } | null;
  readonly meetingGroup?: {
    readonly __typename: "MeetingGroupNode";
    readonly id: number;
    readonly title: string;
    readonly description?: string | null;
    readonly isFormalOneonone: boolean;
    readonly recurrenceRule?: string | null;
    readonly onlineConference: OnlineConference;
    readonly addTranscriptionBotToMeetingsByDefault: boolean;
    readonly transcribeMeetingsByDefault?: boolean | null;
    readonly facilitator?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly avatar?: string | null;
    } | null;
    readonly topicTemplate?: {
      readonly __typename: "TopicTemplateNode";
      readonly id: number;
    } | null;
    readonly syncCredentials?: {
      readonly __typename: "UserSyncCredentialsNode";
      readonly id: number;
      readonly credentialsUid?: string | null;
    } | null;
    readonly recurrenceParameters?: {
      readonly __typename: "FrequencyNode";
      readonly byMonthDay?: ReadonlyArray<number | null> | null;
      readonly byYearDay?: ReadonlyArray<number | null> | null;
      readonly byWeekDay?: ReadonlyArray<number | null> | null;
      readonly bySetPos?: ReadonlyArray<number | null> | null;
      readonly frequency: FrequencyEnum;
      readonly interval: number;
    } | null;
  } | null;
  readonly canRead?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  } | null;
  readonly canUpdate?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  } | null;
  readonly canDelete?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  } | null;
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
  } | null;
  readonly participants?: {
    readonly __typename: "MeetingParticipantConnection";
    readonly totalCount: number;
    readonly edges: ReadonlyArray<{
      readonly __typename: "MeetingParticipantEdge";
      readonly node?: {
        readonly __typename: "MeetingParticipantNode";
        readonly id?: string | null;
        readonly status?: AttendeeStatus | null;
        readonly participantEmail?: string | null;
        readonly role?: AttendeeRole | null;
        readonly user?: {
          readonly __typename: "BasicUserNode";
          readonly id: number;
          readonly name: string;
          readonly firstName: string;
          readonly lastName: string;
          readonly avatar?: string | null;
          readonly email: string;
          readonly status?: UserStatus | null;
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type RefreshCalendarsQueryQueryVariables = Exact<{
  [key: string]: never;
}>;

export type RefreshCalendarsQueryQuery = {
  readonly __typename: "Query";
  readonly loggedIn?: boolean | null;
  readonly me?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly syncCredentials?: {
      readonly __typename: "UserSyncCredentialsNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserSyncCredentialsNodeEdge";
        readonly node?: {
          readonly __typename: "UserSyncCredentialsNode";
          readonly id: number;
          readonly provider?: SyncCredentialsTypeEnum | null;
          readonly credentialsUid?: string | null;
          readonly hasValidCalendarCredentials?: boolean | null;
          readonly hasCalendarWriteCredentials?: boolean | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type UpdateAttendanceStatusMutationMutationVariables = Exact<{
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  status: AttendeeStatus;
}>;

export type UpdateAttendanceStatusMutationMutation = {
  readonly __typename: "Mutation";
  readonly updateAttendanceStatus?: {
    readonly __typename: "UpdateAttendanceStatusMutation";
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
      readonly title?: string | null;
      readonly description?: string | null;
      readonly draft: boolean;
      readonly meetingGroupId: number;
      readonly ignored: boolean;
      readonly videoConferenceType?: OnlineVideoConference | null;
      readonly videoConferenceUrl?: string | null;
      readonly startDatetime?: string | null;
      readonly endDatetime?: string | null;
      readonly isRecurring: boolean;
      readonly botIsRecording: boolean;
      readonly botIsWaitingToJoinMeeting: boolean;
      readonly hasBotInMeeting: boolean;
      readonly organizer?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
      } | null;
      readonly meetingGroup?: {
        readonly __typename: "MeetingGroupNode";
        readonly id: number;
        readonly title: string;
        readonly description?: string | null;
        readonly isFormalOneonone: boolean;
        readonly recurrenceRule?: string | null;
        readonly onlineConference: OnlineConference;
        readonly addTranscriptionBotToMeetingsByDefault: boolean;
        readonly transcribeMeetingsByDefault?: boolean | null;
        readonly facilitator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly topicTemplate?: {
          readonly __typename: "TopicTemplateNode";
          readonly id: number;
        } | null;
        readonly syncCredentials?: {
          readonly __typename: "UserSyncCredentialsNode";
          readonly id: number;
          readonly credentialsUid?: string | null;
        } | null;
        readonly recurrenceParameters?: {
          readonly __typename: "FrequencyNode";
          readonly byMonthDay?: ReadonlyArray<number | null> | null;
          readonly byYearDay?: ReadonlyArray<number | null> | null;
          readonly byWeekDay?: ReadonlyArray<number | null> | null;
          readonly bySetPos?: ReadonlyArray<number | null> | null;
          readonly frequency: FrequencyEnum;
          readonly interval: number;
        } | null;
      } | null;
      readonly canRead?: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
        readonly reason: string;
      } | null;
      readonly canUpdate?: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
        readonly reason: string;
      } | null;
      readonly canDelete?: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
        readonly reason: string;
      } | null;
      readonly creator?: {
        readonly __typename: "UserNode";
        readonly id: number;
      } | null;
      readonly participants?: {
        readonly __typename: "MeetingParticipantConnection";
        readonly totalCount: number;
        readonly edges: ReadonlyArray<{
          readonly __typename: "MeetingParticipantEdge";
          readonly node?: {
            readonly __typename: "MeetingParticipantNode";
            readonly id?: string | null;
            readonly status?: AttendeeStatus | null;
            readonly participantEmail?: string | null;
            readonly role?: AttendeeRole | null;
            readonly user?: {
              readonly __typename: "BasicUserNode";
              readonly id: number;
              readonly name: string;
              readonly firstName: string;
              readonly lastName: string;
              readonly avatar?: string | null;
              readonly email: string;
              readonly status?: UserStatus | null;
            } | null;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type CreateTemplateFromMeetingMutationMutationVariables = Exact<{
  meetingId: Scalars["Int"]["input"];
  title: Scalars["String"]["input"];
}>;

export type CreateTemplateFromMeetingMutationMutation = {
  readonly __typename: "Mutation";
  readonly createTemplateFromMeeting?: {
    readonly __typename: "CreateTemplateFromMeetingMutation";
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
    } | null;
    readonly topicTemplate?: {
      readonly __typename: "TopicTemplateNode";
      readonly id: number;
    } | null;
  } | null;
};

export type IgnoreMeetingMutationMutationVariables = Exact<{
  meetingId: Scalars["Int"]["input"];
  ignore: Scalars["Boolean"]["input"];
}>;

export type IgnoreMeetingMutationMutation = {
  readonly __typename: "Mutation";
  readonly ignoreMeeting?: {
    readonly __typename: "IgnoreMeetingMutation";
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
      readonly ignored: boolean;
      readonly meetingGroup?: {
        readonly __typename: "MeetingGroupNode";
        readonly id: number;
      } | null;
    } | null;
  } | null;
};

export type DeleteMeetingTranscriptsNewPageMutationMutationVariables = Exact<{
  meetingId: Scalars["Int"]["input"];
}>;

export type DeleteMeetingTranscriptsNewPageMutationMutation = {
  readonly __typename: "Mutation";
  readonly deleteMeetingTranscripts?: {
    readonly __typename: "DeleteMeetingTranscriptsMutation";
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
      readonly hasTranscript?: boolean | null;
      readonly transcript?: {
        readonly __typename: "MeetingTranscriptNode";
        readonly id: number;
      } | null;
    } | null;
  } | null;
};

export type DeleteMeetingVideoRecordingMutationMutationVariables = Exact<{
  meetingId: Scalars["Int"]["input"];
}>;

export type DeleteMeetingVideoRecordingMutationMutation = {
  readonly __typename: "Mutation";
  readonly deleteMeetingVideoRecording?: {
    readonly __typename: "DeleteMeetingVideoRecordingMutation";
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
      readonly transcript?: {
        readonly __typename: "MeetingTranscriptNode";
        readonly id: number;
        readonly videoRecording?: string | null;
        readonly canSaveVideoRecording?: boolean | null;
        readonly videoRecordingAvailableUntil?: string | null;
      } | null;
    } | null;
  } | null;
};

export type SaveMeetingVideoRecordingMutationMutationVariables = Exact<{
  meetingId: Scalars["Int"]["input"];
}>;

export type SaveMeetingVideoRecordingMutationMutation = {
  readonly __typename: "Mutation";
  readonly saveMeetingVideoRecording?: {
    readonly __typename: "SaveMeetingVideoRecordingMutation";
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
      readonly transcript?: {
        readonly __typename: "MeetingTranscriptNode";
        readonly id: number;
        readonly videoRecording?: string | null;
        readonly canSaveVideoRecording?: boolean | null;
        readonly videoRecordingAvailableUntil?: string | null;
      } | null;
    } | null;
  } | null;
};

export type SubmitOneononeNewPageMutationVariables = Exact<{
  meetingId: Scalars["Int"]["input"];
  unhideIndividualNotes?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type SubmitOneononeNewPageMutation = {
  readonly __typename: "Mutation";
  readonly submitOneonone?: {
    readonly __typename: "SubmitOneOnOneMutation";
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
      readonly isSubmitted: boolean;
      readonly topics?: {
        readonly __typename: "TopicNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "TopicNodeEdge";
          readonly node?: {
            readonly __typename: "TopicNode";
            readonly individualNotes?: {
              readonly __typename: "IndividualNoteNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "IndividualNoteNodeEdge";
                readonly node?: {
                  readonly __typename: "IndividualNoteNode";
                  readonly id: number;
                  readonly created: string;
                  readonly hidden: boolean;
                  readonly enabled: boolean;
                  readonly notes?: any | null;
                  readonly creator: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                  };
                } | null;
              } | null>;
            } | null;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type UpdateMeetingFinalizationStatusNewPageMutationMutationVariables =
  Exact<{
    meetingId: Scalars["Int"]["input"];
    isFinalized: Scalars["Boolean"]["input"];
  }>;

export type UpdateMeetingFinalizationStatusNewPageMutationMutation = {
  readonly __typename: "Mutation";
  readonly updateMeetingFinalizationStatus?: {
    readonly __typename: "UpdateMeetingFinalizationStatus";
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
      readonly isFinalized: boolean;
      readonly finalizedAt?: string | null;
      readonly finalizedBy?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
      } | null;
      readonly topics?: {
        readonly __typename: "TopicNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "TopicNodeEdge";
          readonly node?: {
            readonly __typename: "TopicNode";
            readonly id: number;
            readonly isMandatory: boolean;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type ConvertToReviewMeetingMutationVariables = Exact<{
  meetingId: Scalars["Int"]["input"];
  topicTemplateId: Scalars["Int"]["input"];
  clearExistingTopics?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type ConvertToReviewMeetingMutation = {
  readonly __typename: "Mutation";
  readonly addTemplateToMeeting?: {
    readonly __typename: "AddTemplateToMeetingMutation";
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
    } | null;
  } | null;
};

export type AddBotToMeetingNewPageMutationMutationVariables = Exact<{
  meetingId: Scalars["Int"]["input"];
}>;

export type AddBotToMeetingNewPageMutationMutation = {
  readonly __typename: "Mutation";
  readonly addBotToMeeting?: {
    readonly __typename: "AddBotToMeetingMutation";
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly botIsRecording: boolean;
      readonly botIsWaitingToJoinMeeting: boolean;
      readonly hasBotInMeeting: boolean;
      readonly id: number;
    } | null;
  } | null;
};

export type ChangeBotRecordingStatusNewPageMutationMutationVariables = Exact<{
  meetingId: Scalars["Int"]["input"];
  isRecording: Scalars["Boolean"]["input"];
}>;

export type ChangeBotRecordingStatusNewPageMutationMutation = {
  readonly __typename: "Mutation";
  readonly changeBotRecordingStatus?: {
    readonly __typename: "ChangeBotRecordingStatusMutation";
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
    } | null;
  } | null;
};

export type CreateTopicNewPageMutationMutationVariables = Exact<{
  topicId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  afterTopicId?: InputMaybe<Scalars["Int"]["input"]>;
  beforeTopicId?: InputMaybe<Scalars["Int"]["input"]>;
  includesIndividualNotes?: InputMaybe<Scalars["Boolean"]["input"]>;
  includesSharedNotes?: InputMaybe<Scalars["Boolean"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  discussionNotes?: InputMaybe<Scalars["JSONString"]["input"]>;
  individualNotes?: InputMaybe<Scalars["JSONString"]["input"]>;
  assignee?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type CreateTopicNewPageMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateTopic?: {
    readonly __typename: "CreateOrUpdateTopicMutation";
    readonly topic?: {
      readonly __typename: "TopicNode";
      readonly id: number;
      readonly clientId?: number | null;
      readonly title: string;
      readonly description?: string | null;
      readonly discussionNotes?: any | null;
      readonly created: string;
      readonly state?: TopicState | null;
      readonly eventChannelName?: string | null;
      readonly includesIndividualNotes: boolean;
      readonly includesIndividualNotesForCurrentUser: boolean;
      readonly includesSharedNotes: boolean;
      readonly isMandatory: boolean;
      readonly notesRequirement: NotesRequirement;
      readonly individualNotes?: {
        readonly __typename: "IndividualNoteNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "IndividualNoteNodeEdge";
          readonly node?: {
            readonly __typename: "IndividualNoteNode";
            readonly id: number;
            readonly created: string;
            readonly hidden: boolean;
            readonly enabled: boolean;
            readonly notes?: any | null;
            readonly creator: {
              readonly __typename: "UserNode";
              readonly id: number;
            };
          } | null;
        } | null>;
      } | null;
      readonly creator?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
      } | null;
      readonly assignee?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly avatar?: string | null;
        readonly name: string;
      } | null;
      readonly previousTopic?: {
        readonly __typename: "TopicNode";
        readonly id: number;
        readonly discussionNotes?: any | null;
      } | null;
      readonly linkedTemplateTopic?: {
        readonly __typename: "TopicNode";
        readonly id: number;
        readonly title: string;
        readonly discussionNotes?: any | null;
        readonly defaultSubjectNotes?: any | null;
        readonly defaultFacilitatorNotes?: any | null;
        readonly topicTemplate?: {
          readonly __typename: "TopicTemplateNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null;
      readonly canUpdate: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
      };
      readonly canDelete: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
      };
      readonly copiedFrom?: {
        readonly __typename: "TopicNode";
        readonly id: number;
        readonly title: string;
        readonly meeting?: {
          readonly __typename: "MeetingNode";
          readonly id: number;
          readonly title?: string | null;
          readonly startDatetime?: string | null;
          readonly meetingGroupId: number;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type DeleteDraftMeetingNewPageMutationMutationVariables = Exact<{
  meetingId: Scalars["Int"]["input"];
}>;

export type DeleteDraftMeetingNewPageMutationMutation = {
  readonly __typename: "Mutation";
  readonly deleteMeeting?: {
    readonly __typename: "DeleteMeetingMutation";
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
    } | null;
  } | null;
};

export type GetActiveComplianceProgramWithUnmetTopicTemplatesQueryVariables =
  Exact<{
    meetingId: Scalars["Int"]["input"];
  }>;

export type GetActiveComplianceProgramWithUnmetTopicTemplatesQuery = {
  readonly __typename: "Query";
  readonly meeting?: {
    readonly __typename: "MeetingNode";
    readonly id: number;
    readonly activeComplianceProgramsWithUnmetTopicTemplates: {
      readonly __typename: "ComplianceProgramNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "ComplianceProgramNodeEdge";
        readonly node?: {
          readonly __typename: "ComplianceProgramNode";
          readonly id: number;
          readonly title: string;
          readonly requiredTopicTemplates: {
            readonly __typename: "TopicTemplateNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "TopicTemplateNodeEdge";
              readonly node?: {
                readonly __typename: "TopicTemplateNode";
                readonly id: number;
              } | null;
            } | null>;
          };
        } | null;
      } | null>;
    };
  } | null;
};

export type GetFirstMeetingOfMeetingGroupQueryQueryVariables = Exact<{
  meetingGroupId: Scalars["Int"]["input"];
  today: Scalars["DateTime"]["input"];
}>;

export type GetFirstMeetingOfMeetingGroupQueryQuery = {
  readonly __typename: "Query";
  readonly meetingGroup?: {
    readonly __typename: "MeetingGroupNode";
    readonly id: number;
    readonly nextMeetings?: {
      readonly __typename: "MeetingNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "MeetingNodeEdge";
        readonly node?: {
          readonly __typename: "MeetingNode";
          readonly id: number;
        } | null;
      } | null>;
    } | null;
    readonly lastMeetings?: {
      readonly __typename: "MeetingNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "MeetingNodeEdge";
        readonly node?: {
          readonly __typename: "MeetingNode";
          readonly id: number;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetMeetingBotStatusQueryQueryVariables = Exact<{
  meetingId: Scalars["Int"]["input"];
}>;

export type GetMeetingBotStatusQueryQuery = {
  readonly __typename: "Query";
  readonly meeting?: {
    readonly __typename: "MeetingNode";
    readonly id: number;
    readonly botIsRecording: boolean;
    readonly botIsWaitingToJoinMeeting: boolean;
    readonly hasBotInMeeting: boolean;
  } | null;
};

export type GetMeetingFeedbackNewPageQueryQueryVariables = Exact<{
  feedbackRecipients?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  feedbackSenders?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  fetchData: Scalars["Boolean"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
  first: Scalars["Int"]["input"];
}>;

export type GetMeetingFeedbackNewPageQueryQuery = {
  readonly __typename: "Query";
  readonly artifacts?: {
    readonly __typename: "ArtifactConnection";
    readonly totalCount: number;
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly hasNextPage: boolean;
      readonly endCursor?: string | null;
    };
    readonly edges?: ReadonlyArray<{
      readonly __typename: "ArtifactEdge";
      readonly node?:
        | {
            readonly __typename: "ActionItemArtifactNode";
            readonly created: string;
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "AsanaTaskArtifactNode";
            readonly created: string;
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "DecisionArtifactNode";
            readonly created: string;
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "DocumentArtifactNode";
            readonly created: string;
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "FeedbackArtifactNode";
            readonly created: string;
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly recipientsCanView: boolean;
            readonly recipientsManagersCanView: boolean;
            readonly adminsCanView: boolean;
            readonly creatorCanView: boolean;
            readonly feedbackState: FeedbackState;
            readonly message?: any | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
            readonly feedbackRecipients: {
              readonly __typename: "UserNodeConnection";
              readonly totalCount: number;
              readonly edges: ReadonlyArray<{
                readonly __typename: "UserNodeEdge";
                readonly node?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly avatar?: string | null;
                  readonly name: string;
                } | null;
              } | null>;
            };
            readonly sender: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly avatar?: string | null;
              readonly name: string;
            };
          }
        | {
            readonly __typename: "GithubIssuesArtifactNode";
            readonly created: string;
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "GoalArtifactNode";
            readonly created: string;
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "KPIArtifactNode";
            readonly created: string;
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "RatingArtifactNode";
            readonly created: string;
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "RecognitionArtifactNode";
            readonly created: string;
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | null;
    } | null>;
  } | null;
};

export type GetMeetingGoalsNewPageQueryQueryVariables = Exact<{
  fetchData: Scalars["Boolean"]["input"];
  goalInvolvingUsers:
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>;
  asUsers?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  goalState: GoalState;
  goalScopes?: InputMaybe<
    ReadonlyArray<InputMaybe<GoalScope>> | InputMaybe<GoalScope>
  >;
  goalsCompletedInTheLastXDays?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  first: Scalars["Int"]["input"];
}>;

export type GetMeetingGoalsNewPageQueryQuery = {
  readonly __typename: "Query";
  readonly artifacts?: {
    readonly __typename: "ArtifactConnection";
    readonly totalCount: number;
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly hasNextPage: boolean;
      readonly endCursor?: string | null;
    };
    readonly edges?: ReadonlyArray<{
      readonly __typename: "ArtifactEdge";
      readonly node?:
        | {
            readonly __typename: "ActionItemArtifactNode";
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
            readonly created: string;
            readonly isStale: boolean;
            readonly activities: {
              readonly __typename: "ArtifactActivityNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "ArtifactActivityNodeEdge";
                readonly node?: {
                  readonly __typename: "ArtifactActivityNode";
                  readonly created: string;
                } | null;
              } | null>;
            };
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly organization?: {
              readonly __typename: "OrganizationNode";
              readonly id: number;
            } | null;
          }
        | {
            readonly __typename: "AsanaTaskArtifactNode";
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
            readonly created: string;
            readonly isStale: boolean;
            readonly activities: {
              readonly __typename: "ArtifactActivityNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "ArtifactActivityNodeEdge";
                readonly node?: {
                  readonly __typename: "ArtifactActivityNode";
                  readonly created: string;
                } | null;
              } | null>;
            };
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly organization?: {
              readonly __typename: "OrganizationNode";
              readonly id: number;
            } | null;
          }
        | {
            readonly __typename: "DecisionArtifactNode";
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
            readonly created: string;
            readonly isStale: boolean;
            readonly activities: {
              readonly __typename: "ArtifactActivityNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "ArtifactActivityNodeEdge";
                readonly node?: {
                  readonly __typename: "ArtifactActivityNode";
                  readonly created: string;
                } | null;
              } | null>;
            };
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly organization?: {
              readonly __typename: "OrganizationNode";
              readonly id: number;
            } | null;
          }
        | {
            readonly __typename: "DocumentArtifactNode";
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
            readonly created: string;
            readonly isStale: boolean;
            readonly activities: {
              readonly __typename: "ArtifactActivityNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "ArtifactActivityNodeEdge";
                readonly node?: {
                  readonly __typename: "ArtifactActivityNode";
                  readonly created: string;
                } | null;
              } | null>;
            };
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly organization?: {
              readonly __typename: "OrganizationNode";
              readonly id: number;
            } | null;
          }
        | {
            readonly __typename: "FeedbackArtifactNode";
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
            readonly created: string;
            readonly isStale: boolean;
            readonly activities: {
              readonly __typename: "ArtifactActivityNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "ArtifactActivityNodeEdge";
                readonly node?: {
                  readonly __typename: "ArtifactActivityNode";
                  readonly created: string;
                } | null;
              } | null>;
            };
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly organization?: {
              readonly __typename: "OrganizationNode";
              readonly id: number;
            } | null;
          }
        | {
            readonly __typename: "GithubIssuesArtifactNode";
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
            readonly created: string;
            readonly isStale: boolean;
            readonly activities: {
              readonly __typename: "ArtifactActivityNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "ArtifactActivityNodeEdge";
                readonly node?: {
                  readonly __typename: "ArtifactActivityNode";
                  readonly created: string;
                } | null;
              } | null>;
            };
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly organization?: {
              readonly __typename: "OrganizationNode";
              readonly id: number;
            } | null;
          }
        | {
            readonly __typename: "GoalArtifactNode";
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
            readonly created: string;
            readonly isStale: boolean;
            readonly startValue: number;
            readonly currentValue: number;
            readonly targetValue: number;
            readonly progress: number;
            readonly progressType: GoalProgressType;
            readonly dueDate?: string | null;
            readonly startDate?: string | null;
            readonly state: GoalState;
            readonly status: GoalStatus;
            readonly scope: GoalScope;
            readonly goalVisibility: GoalVisibility;
            readonly parentGoalId?: number | null;
            readonly ownerCount?: number | null;
            readonly contributorCount?: number | null;
            readonly updated?: string | null;
            readonly activities: {
              readonly __typename: "ArtifactActivityNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "ArtifactActivityNodeEdge";
                readonly node?: {
                  readonly __typename: "ArtifactActivityNode";
                  readonly created: string;
                } | null;
              } | null>;
            };
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly organization?: {
              readonly __typename: "OrganizationNode";
              readonly id: number;
            } | null;
            readonly firstOwner?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly avatar?: string | null;
              readonly name: string;
            } | null;
            readonly canRead: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          }
        | {
            readonly __typename: "KPIArtifactNode";
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
            readonly created: string;
            readonly isStale: boolean;
            readonly activities: {
              readonly __typename: "ArtifactActivityNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "ArtifactActivityNodeEdge";
                readonly node?: {
                  readonly __typename: "ArtifactActivityNode";
                  readonly created: string;
                } | null;
              } | null>;
            };
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly organization?: {
              readonly __typename: "OrganizationNode";
              readonly id: number;
            } | null;
          }
        | {
            readonly __typename: "RatingArtifactNode";
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
            readonly created: string;
            readonly isStale: boolean;
            readonly activities: {
              readonly __typename: "ArtifactActivityNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "ArtifactActivityNodeEdge";
                readonly node?: {
                  readonly __typename: "ArtifactActivityNode";
                  readonly created: string;
                } | null;
              } | null>;
            };
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly organization?: {
              readonly __typename: "OrganizationNode";
              readonly id: number;
            } | null;
          }
        | {
            readonly __typename: "RecognitionArtifactNode";
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
            readonly created: string;
            readonly isStale: boolean;
            readonly activities: {
              readonly __typename: "ArtifactActivityNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "ArtifactActivityNodeEdge";
                readonly node?: {
                  readonly __typename: "ArtifactActivityNode";
                  readonly created: string;
                } | null;
              } | null>;
            };
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly organization?: {
              readonly __typename: "OrganizationNode";
              readonly id: number;
            } | null;
          }
        | null;
    } | null>;
  } | null;
};

export type GetMeetingNewPageQueryQueryVariables = Exact<{
  meetingId: Scalars["Int"]["input"];
}>;

export type GetMeetingNewPageQueryQuery = {
  readonly __typename: "Query";
  readonly meeting?: {
    readonly __typename: "MeetingNode";
    readonly id: number;
    readonly title?: string | null;
    readonly startDatetime?: string | null;
    readonly startDate?: string | null;
    readonly endDatetime?: string | null;
    readonly externalUrl?: string | null;
    readonly videoConferenceType?: OnlineVideoConference | null;
    readonly videoConferenceUrl?: string | null;
    readonly allowExternalViewers?: boolean | null;
    readonly writableSharingUrl?: string | null;
    readonly websocketToken?: string | null;
    readonly hasPreviousMeetings?: boolean | null;
    readonly ignored: boolean;
    readonly finalizedAt?: string | null;
    readonly isFinalized: boolean;
    readonly meetingGroupId: number;
    readonly isSubmitted: boolean;
    readonly hasIncompleteMandatoryTopics: boolean;
    readonly transcriptionStatus?: boolean | null;
    readonly created: string;
    readonly draft: boolean;
    readonly isRecurring: boolean;
    readonly hasExternalParticipants?: boolean | null;
    readonly isManagerAndReportOneonone: boolean;
    readonly hasBotInMeeting: boolean;
    readonly botIsRecording: boolean;
    readonly botIsWaitingToJoinMeeting: boolean;
    readonly previousMeeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
      readonly startDate?: string | null;
      readonly startDatetime?: string | null;
    } | null;
    readonly subject?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly isInCurrentUserReportingTree: boolean;
      readonly managersList: ReadonlyArray<{
        readonly __typename: "UserNode";
        readonly id: number;
      }>;
    } | null;
    readonly canFinalize: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    };
    readonly canDelete?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    } | null;
    readonly canUpdate?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    } | null;
    readonly finalizedBy?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly avatar?: string | null;
    } | null;
    readonly organization?: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
      readonly name: string;
      readonly effectivePricingTier?: PricingTier | null;
      readonly enableMeetingSummarization: boolean;
      readonly domains?: ReadonlyArray<string | null> | null;
      readonly enableMeetingBot: boolean;
    } | null;
    readonly organizer?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
    } | null;
    readonly creator?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly firstName: string;
      readonly lastName: string;
      readonly avatar?: string | null;
    } | null;
    readonly transcript?: {
      readonly __typename: "MeetingTranscriptNode";
      readonly id: number;
    } | null;
    readonly meetingGroup?: {
      readonly __typename: "MeetingGroupNode";
      readonly id: number;
      readonly title: string;
      readonly hasTemplate?: boolean | null;
      readonly allowAdminVisibility: boolean;
      readonly allowOrgVisibility: boolean;
      readonly allowManagementTreeVisibility: boolean;
      readonly isFormalOneonone: boolean;
      readonly detectedOneononeBannerDismissed: boolean;
      readonly meetingBotSetting?: MeetingBotSetting | null;
      readonly addTranscriptionBotToMeetingsByDefault: boolean;
      readonly transcribeMeetingsByDefault?: boolean | null;
      readonly canUpdate?: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
      } | null;
      readonly facilitator?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      } | null;
      readonly organization?: {
        readonly __typename: "OrganizationNode";
        readonly id: number;
        readonly name: string;
      } | null;
      readonly syncCredentials?: {
        readonly __typename: "UserSyncCredentialsNode";
        readonly id: number;
        readonly hasCalendarWriteCredentials?: boolean | null;
        readonly provider?: SyncCredentialsTypeEnum | null;
      } | null;
      readonly topicTemplate?: {
        readonly __typename: "TopicTemplateNode";
        readonly id: number;
        readonly title: string;
        readonly globalTemplate: boolean;
        readonly publicTemplate: boolean;
        readonly meetingTemplate: boolean;
        readonly finalizePermissions: FinalizePermissions;
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
      } | null;
    } | null;
    readonly topics?: {
      readonly __typename: "TopicNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "TopicNodeEdge";
        readonly node?: {
          readonly __typename: "TopicNode";
          readonly id: number;
          readonly clientId?: number | null;
          readonly title: string;
          readonly description?: string | null;
          readonly discussionNotes?: any | null;
          readonly created: string;
          readonly state?: TopicState | null;
          readonly eventChannelName?: string | null;
          readonly includesIndividualNotes: boolean;
          readonly includesIndividualNotesForCurrentUser: boolean;
          readonly includesSharedNotes: boolean;
          readonly isMandatory: boolean;
          readonly notesRequirement: NotesRequirement;
          readonly individualNotes?: {
            readonly __typename: "IndividualNoteNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "IndividualNoteNodeEdge";
              readonly node?: {
                readonly __typename: "IndividualNoteNode";
                readonly id: number;
                readonly created: string;
                readonly hidden: boolean;
                readonly enabled: boolean;
                readonly notes?: any | null;
                readonly creator: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                };
              } | null;
            } | null>;
          } | null;
          readonly creator?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
          } | null;
          readonly assignee?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly avatar?: string | null;
            readonly name: string;
          } | null;
          readonly previousTopic?: {
            readonly __typename: "TopicNode";
            readonly id: number;
            readonly discussionNotes?: any | null;
          } | null;
          readonly linkedTemplateTopic?: {
            readonly __typename: "TopicNode";
            readonly id: number;
            readonly title: string;
            readonly discussionNotes?: any | null;
            readonly defaultSubjectNotes?: any | null;
            readonly defaultFacilitatorNotes?: any | null;
            readonly topicTemplate?: {
              readonly __typename: "TopicTemplateNode";
              readonly id: number;
              readonly title: string;
            } | null;
          } | null;
          readonly canUpdate: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly copiedFrom?: {
            readonly __typename: "TopicNode";
            readonly id: number;
            readonly title: string;
            readonly meeting?: {
              readonly __typename: "MeetingNode";
              readonly id: number;
              readonly title?: string | null;
              readonly startDatetime?: string | null;
              readonly meetingGroupId: number;
            } | null;
          } | null;
        } | null;
      } | null>;
    } | null;
    readonly assessmentDeliveriesMatching1on1Template: {
      readonly __typename: "AssessmentDeliveryNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AssessmentDeliveryNodeEdge";
        readonly node?: {
          readonly __typename: "AssessmentDeliveryNode";
          readonly id: number;
          readonly target?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
          } | null;
          readonly complianceProgram?: {
            readonly __typename: "ComplianceProgramNode";
            readonly id: number;
            readonly title: string;
            readonly requiredTopicTemplates: {
              readonly __typename: "TopicTemplateNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "TopicTemplateNodeEdge";
                readonly node?: {
                  readonly __typename: "TopicTemplateNode";
                  readonly id: number;
                  readonly title: string;
                } | null;
              } | null>;
            };
          } | null;
        } | null;
      } | null>;
    };
    readonly botParticipationDetails: {
      readonly __typename: "BotParticipationDetailsNode";
      readonly willBotJoin: boolean;
      readonly reason: MeetingBotJoinReason;
      readonly joinBecauseOfParticipants: ReadonlyArray<{
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
      }>;
    };
    readonly participants?: {
      readonly __typename: "MeetingParticipantConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "MeetingParticipantEdge";
        readonly node?: {
          readonly __typename: "MeetingParticipantNode";
          readonly id?: string | null;
          readonly status?: AttendeeStatus | null;
          readonly participantEmail?: string | null;
          readonly role?: AttendeeRole | null;
          readonly user?: {
            readonly __typename: "BasicUserNode";
            readonly id: number;
            readonly name: string;
            readonly firstName: string;
            readonly lastName: string;
            readonly avatar?: string | null;
            readonly email: string;
            readonly status?: UserStatus | null;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetMeetingRecognitionsNewPageQueryQueryVariables = Exact<{
  recognitionRecipients?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  createdByIds?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  fetchData: Scalars["Boolean"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
  first: Scalars["Int"]["input"];
}>;

export type GetMeetingRecognitionsNewPageQueryQuery = {
  readonly __typename: "Query";
  readonly artifacts?: {
    readonly __typename: "ArtifactConnection";
    readonly totalCount: number;
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly hasNextPage: boolean;
      readonly endCursor?: string | null;
    };
    readonly edges?: ReadonlyArray<{
      readonly __typename: "ArtifactEdge";
      readonly node?:
        | {
            readonly __typename: "ActionItemArtifactNode";
            readonly id: number;
            readonly created: string;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "AsanaTaskArtifactNode";
            readonly id: number;
            readonly created: string;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "DecisionArtifactNode";
            readonly id: number;
            readonly created: string;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "DocumentArtifactNode";
            readonly id: number;
            readonly created: string;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "FeedbackArtifactNode";
            readonly id: number;
            readonly created: string;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "GithubIssuesArtifactNode";
            readonly id: number;
            readonly created: string;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "GoalArtifactNode";
            readonly id: number;
            readonly created: string;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "KPIArtifactNode";
            readonly id: number;
            readonly created: string;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "RatingArtifactNode";
            readonly id: number;
            readonly created: string;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "RecognitionArtifactNode";
            readonly id: number;
            readonly created: string;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
            readonly recipients?: {
              readonly __typename: "UserNodeConnection";
              readonly totalCount: number;
              readonly edges: ReadonlyArray<{
                readonly __typename: "UserNodeEdge";
                readonly node?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly name: string;
                  readonly avatar?: string | null;
                } | null;
              } | null>;
            } | null;
            readonly recognitionCoreValue?: {
              readonly __typename: "RecognitionCoreValueNode";
              readonly id: number;
              readonly title: string;
              readonly description: string;
              readonly emoji?: string | null;
              readonly image?: string | null;
            } | null;
          }
        | null;
    } | null>;
  } | null;
};

export type MeetingHeaderFragmentFragment = {
  readonly __typename: "MeetingNode";
  readonly id: number;
  readonly title?: string | null;
  readonly startDatetime?: string | null;
  readonly meetingGroupId: number;
  readonly draft: boolean;
  readonly isRecurring: boolean;
};

export type GetPreviousMeetingsQueryQueryVariables = Exact<{
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  subject?: InputMaybe<Scalars["Int"]["input"]>;
  beforeDate: Scalars["DateTime"]["input"];
  maxFutureDate: Scalars["DateTime"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
  limit: Scalars["Int"]["input"];
  draft?: InputMaybe<Scalars["Boolean"]["input"]>;
  ignored?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type GetPreviousMeetingsQueryQuery = {
  readonly __typename: "Query";
  readonly meetings?: {
    readonly __typename: "MeetingNodeConnection";
    readonly totalCount: number;
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly endCursor?: string | null;
      readonly hasNextPage: boolean;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "MeetingNodeEdge";
      readonly node?: {
        readonly __typename: "MeetingNode";
        readonly id: number;
        readonly title?: string | null;
        readonly startDatetime?: string | null;
        readonly meetingGroupId: number;
        readonly draft: boolean;
        readonly isRecurring: boolean;
      } | null;
    } | null>;
  } | null;
  readonly nextMeetings?: {
    readonly __typename: "MeetingNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "MeetingNodeEdge";
      readonly node?: {
        readonly __typename: "MeetingNode";
        readonly id: number;
        readonly title?: string | null;
        readonly startDatetime?: string | null;
        readonly meetingGroupId: number;
        readonly draft: boolean;
        readonly isRecurring: boolean;
      } | null;
    } | null>;
  } | null;
};

export type GetPreviousRecurringMeetingQueryQueryVariables = Exact<{
  beforeMeetingId: Scalars["Int"]["input"];
}>;

export type GetPreviousRecurringMeetingQueryQuery = {
  readonly __typename: "Query";
  readonly previousMeeting?: {
    readonly __typename: "MeetingNode";
    readonly id: number;
  } | null;
};

export type GetRecurringMeetingPaginationQueryQueryVariables = Exact<{
  meetingId: Scalars["Int"]["input"];
}>;

export type GetRecurringMeetingPaginationQueryQuery = {
  readonly __typename: "Query";
  readonly beforeMeeting?: {
    readonly __typename: "MeetingNode";
    readonly id: number;
    readonly meetingGroupId: number;
    readonly startDatetime?: string | null;
  } | null;
  readonly afterMeeting?: {
    readonly __typename: "MeetingNode";
    readonly id: number;
    readonly meetingGroupId: number;
    readonly startDatetime?: string | null;
  } | null;
};

export type IndividualNoteNodeFragmentFragment = {
  readonly __typename: "IndividualNoteNode";
  readonly id: number;
  readonly created: string;
  readonly hidden: boolean;
  readonly enabled: boolean;
  readonly notes?: any | null;
  readonly creator: { readonly __typename: "UserNode"; readonly id: number };
};

export type MarkMeetingTopicsAsDiscussedMutationMutationVariables = Exact<{
  meetingId: Scalars["Int"]["input"];
}>;

export type MarkMeetingTopicsAsDiscussedMutationMutation = {
  readonly __typename: "Mutation";
  readonly markMeetingTopicsAsDiscussed?: {
    readonly __typename: "MarkMeetingTopicsAsDiscussedMutation";
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
      readonly topics?: {
        readonly __typename: "TopicNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "TopicNodeEdge";
          readonly node?: {
            readonly __typename: "TopicNode";
            readonly id: number;
            readonly state?: TopicState | null;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type MeetingGroupGoalsNewPageFragmentFragment = {
  readonly __typename: "MeetingGroupNode";
  readonly id: number;
  readonly incompleteGoals?: {
    readonly __typename: "ArtifactConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "ArtifactEdge";
      readonly node?:
        | {
            readonly __typename: "ActionItemArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "AsanaTaskArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "DecisionArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "DocumentArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "FeedbackArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "GithubIssuesArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "GoalArtifactNode";
            readonly currentUserIsOwner?: boolean | null;
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly startValue: number;
            readonly currentValue: number;
            readonly targetValue: number;
            readonly progress: number;
            readonly progressType: GoalProgressType;
            readonly dueDate?: string | null;
            readonly startDate?: string | null;
            readonly state: GoalState;
            readonly status: GoalStatus;
            readonly scope: GoalScope;
            readonly goalVisibility: GoalVisibility;
            readonly created: string;
            readonly parentGoalId?: number | null;
            readonly ownerCount?: number | null;
            readonly contributorCount?: number | null;
            readonly isStale: boolean;
            readonly updated?: string | null;
            readonly owners?: {
              readonly __typename: "UserNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "UserNodeEdge";
                readonly node?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly name: string;
                  readonly avatar?: string | null;
                } | null;
              } | null>;
            } | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly firstOwner?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly avatar?: string | null;
              readonly name: string;
            } | null;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canRead: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          }
        | {
            readonly __typename: "KPIArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "RatingArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "RecognitionArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | null;
    } | null>;
  } | null;
  readonly draftGoals?: {
    readonly __typename: "ArtifactConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "ArtifactEdge";
      readonly node?:
        | {
            readonly __typename: "ActionItemArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "AsanaTaskArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "DecisionArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "DocumentArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "FeedbackArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "GithubIssuesArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "GoalArtifactNode";
            readonly currentUserIsOwner?: boolean | null;
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly startValue: number;
            readonly currentValue: number;
            readonly targetValue: number;
            readonly progress: number;
            readonly progressType: GoalProgressType;
            readonly dueDate?: string | null;
            readonly startDate?: string | null;
            readonly state: GoalState;
            readonly status: GoalStatus;
            readonly scope: GoalScope;
            readonly goalVisibility: GoalVisibility;
            readonly created: string;
            readonly parentGoalId?: number | null;
            readonly ownerCount?: number | null;
            readonly contributorCount?: number | null;
            readonly isStale: boolean;
            readonly updated?: string | null;
            readonly owners?: {
              readonly __typename: "UserNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "UserNodeEdge";
                readonly node?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly name: string;
                  readonly avatar?: string | null;
                } | null;
              } | null>;
            } | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly firstOwner?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly avatar?: string | null;
              readonly name: string;
            } | null;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canRead: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          }
        | {
            readonly __typename: "KPIArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "RatingArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "RecognitionArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | null;
    } | null>;
  } | null;
  readonly completeGoals?: {
    readonly __typename: "ArtifactConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "ArtifactEdge";
      readonly node?:
        | {
            readonly __typename: "ActionItemArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "AsanaTaskArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "DecisionArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "DocumentArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "FeedbackArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "GithubIssuesArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "GoalArtifactNode";
            readonly currentUserIsOwner?: boolean | null;
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly startValue: number;
            readonly currentValue: number;
            readonly targetValue: number;
            readonly progress: number;
            readonly progressType: GoalProgressType;
            readonly dueDate?: string | null;
            readonly startDate?: string | null;
            readonly state: GoalState;
            readonly status: GoalStatus;
            readonly scope: GoalScope;
            readonly goalVisibility: GoalVisibility;
            readonly created: string;
            readonly parentGoalId?: number | null;
            readonly ownerCount?: number | null;
            readonly contributorCount?: number | null;
            readonly isStale: boolean;
            readonly updated?: string | null;
            readonly owners?: {
              readonly __typename: "UserNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "UserNodeEdge";
                readonly node?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly name: string;
                  readonly avatar?: string | null;
                } | null;
              } | null>;
            } | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly firstOwner?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly avatar?: string | null;
              readonly name: string;
            } | null;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canRead: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          }
        | {
            readonly __typename: "KPIArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "RatingArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | {
            readonly __typename: "RecognitionArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
          }
        | null;
    } | null>;
  } | null;
};

export type MeetingParticipantFragmentFragment = {
  readonly __typename: "MeetingParticipantNode";
  readonly id?: string | null;
  readonly status?: AttendeeStatus | null;
  readonly participantEmail?: string | null;
  readonly role?: AttendeeRole | null;
  readonly user?: {
    readonly __typename: "BasicUserNode";
    readonly id: number;
    readonly name: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly avatar?: string | null;
    readonly email: string;
    readonly status?: UserStatus | null;
  } | null;
};

export type MeetingParticipantsNewPageFragmentFragment = {
  readonly __typename: "MeetingNode";
  readonly participants?: {
    readonly __typename: "MeetingParticipantConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "MeetingParticipantEdge";
      readonly node?: {
        readonly __typename: "MeetingParticipantNode";
        readonly id?: string | null;
        readonly status?: AttendeeStatus | null;
        readonly participantEmail?: string | null;
        readonly role?: AttendeeRole | null;
        readonly user?: {
          readonly __typename: "BasicUserNode";
          readonly id: number;
          readonly name: string;
          readonly firstName: string;
          readonly lastName: string;
          readonly avatar?: string | null;
          readonly email: string;
          readonly status?: UserStatus | null;
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type MeetingViewMeetingGroupNewPageFragmentFragment = {
  readonly __typename: "MeetingGroupNode";
  readonly id: number;
  readonly title: string;
  readonly hasTemplate?: boolean | null;
  readonly allowAdminVisibility: boolean;
  readonly allowOrgVisibility: boolean;
  readonly allowManagementTreeVisibility: boolean;
  readonly isFormalOneonone: boolean;
  readonly detectedOneononeBannerDismissed: boolean;
  readonly meetingBotSetting?: MeetingBotSetting | null;
  readonly addTranscriptionBotToMeetingsByDefault: boolean;
  readonly transcribeMeetingsByDefault?: boolean | null;
  readonly canUpdate?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  } | null;
  readonly facilitator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
    readonly name: string;
  } | null;
  readonly syncCredentials?: {
    readonly __typename: "UserSyncCredentialsNode";
    readonly id: number;
    readonly hasCalendarWriteCredentials?: boolean | null;
    readonly provider?: SyncCredentialsTypeEnum | null;
  } | null;
  readonly topicTemplate?: {
    readonly __typename: "TopicTemplateNode";
    readonly id: number;
    readonly title: string;
    readonly globalTemplate: boolean;
    readonly publicTemplate: boolean;
    readonly meetingTemplate: boolean;
    readonly finalizePermissions: FinalizePermissions;
    readonly organization?: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
    } | null;
  } | null;
};

export type MeetingViewMeetingNodeNewPageFragmentFragment = {
  readonly __typename: "MeetingNode";
  readonly id: number;
  readonly title?: string | null;
  readonly startDatetime?: string | null;
  readonly startDate?: string | null;
  readonly endDatetime?: string | null;
  readonly externalUrl?: string | null;
  readonly videoConferenceType?: OnlineVideoConference | null;
  readonly videoConferenceUrl?: string | null;
  readonly allowExternalViewers?: boolean | null;
  readonly writableSharingUrl?: string | null;
  readonly websocketToken?: string | null;
  readonly hasPreviousMeetings?: boolean | null;
  readonly ignored: boolean;
  readonly finalizedAt?: string | null;
  readonly isFinalized: boolean;
  readonly meetingGroupId: number;
  readonly isSubmitted: boolean;
  readonly hasIncompleteMandatoryTopics: boolean;
  readonly transcriptionStatus?: boolean | null;
  readonly created: string;
  readonly draft: boolean;
  readonly isRecurring: boolean;
  readonly hasExternalParticipants?: boolean | null;
  readonly isManagerAndReportOneonone: boolean;
  readonly hasBotInMeeting: boolean;
  readonly botIsRecording: boolean;
  readonly botIsWaitingToJoinMeeting: boolean;
  readonly previousMeeting?: {
    readonly __typename: "MeetingNode";
    readonly id: number;
    readonly startDate?: string | null;
    readonly startDatetime?: string | null;
  } | null;
  readonly subject?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly isInCurrentUserReportingTree: boolean;
    readonly managersList: ReadonlyArray<{
      readonly __typename: "UserNode";
      readonly id: number;
    }>;
  } | null;
  readonly canFinalize: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canDelete?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  } | null;
  readonly canUpdate?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  } | null;
  readonly finalizedBy?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
    readonly name: string;
    readonly effectivePricingTier?: PricingTier | null;
    readonly enableMeetingSummarization: boolean;
    readonly domains?: ReadonlyArray<string | null> | null;
    readonly enableMeetingBot: boolean;
  } | null;
  readonly organizer?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
  } | null;
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly avatar?: string | null;
  } | null;
  readonly transcript?: {
    readonly __typename: "MeetingTranscriptNode";
    readonly id: number;
  } | null;
  readonly meetingGroup?: {
    readonly __typename: "MeetingGroupNode";
    readonly id: number;
    readonly title: string;
    readonly hasTemplate?: boolean | null;
    readonly allowAdminVisibility: boolean;
    readonly allowOrgVisibility: boolean;
    readonly allowManagementTreeVisibility: boolean;
    readonly isFormalOneonone: boolean;
    readonly detectedOneononeBannerDismissed: boolean;
    readonly meetingBotSetting?: MeetingBotSetting | null;
    readonly addTranscriptionBotToMeetingsByDefault: boolean;
    readonly transcribeMeetingsByDefault?: boolean | null;
    readonly canUpdate?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    } | null;
    readonly facilitator?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly avatar?: string | null;
    } | null;
    readonly organization?: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
      readonly name: string;
    } | null;
    readonly syncCredentials?: {
      readonly __typename: "UserSyncCredentialsNode";
      readonly id: number;
      readonly hasCalendarWriteCredentials?: boolean | null;
      readonly provider?: SyncCredentialsTypeEnum | null;
    } | null;
    readonly topicTemplate?: {
      readonly __typename: "TopicTemplateNode";
      readonly id: number;
      readonly title: string;
      readonly globalTemplate: boolean;
      readonly publicTemplate: boolean;
      readonly meetingTemplate: boolean;
      readonly finalizePermissions: FinalizePermissions;
      readonly organization?: {
        readonly __typename: "OrganizationNode";
        readonly id: number;
      } | null;
    } | null;
  } | null;
  readonly topics?: {
    readonly __typename: "TopicNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "TopicNodeEdge";
      readonly node?: {
        readonly __typename: "TopicNode";
        readonly id: number;
        readonly clientId?: number | null;
        readonly title: string;
        readonly description?: string | null;
        readonly discussionNotes?: any | null;
        readonly created: string;
        readonly state?: TopicState | null;
        readonly eventChannelName?: string | null;
        readonly includesIndividualNotes: boolean;
        readonly includesIndividualNotesForCurrentUser: boolean;
        readonly includesSharedNotes: boolean;
        readonly isMandatory: boolean;
        readonly notesRequirement: NotesRequirement;
        readonly individualNotes?: {
          readonly __typename: "IndividualNoteNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "IndividualNoteNodeEdge";
            readonly node?: {
              readonly __typename: "IndividualNoteNode";
              readonly id: number;
              readonly created: string;
              readonly hidden: boolean;
              readonly enabled: boolean;
              readonly notes?: any | null;
              readonly creator: {
                readonly __typename: "UserNode";
                readonly id: number;
              };
            } | null;
          } | null>;
        } | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
        } | null;
        readonly assignee?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly avatar?: string | null;
          readonly name: string;
        } | null;
        readonly previousTopic?: {
          readonly __typename: "TopicNode";
          readonly id: number;
          readonly discussionNotes?: any | null;
        } | null;
        readonly linkedTemplateTopic?: {
          readonly __typename: "TopicNode";
          readonly id: number;
          readonly title: string;
          readonly discussionNotes?: any | null;
          readonly defaultSubjectNotes?: any | null;
          readonly defaultFacilitatorNotes?: any | null;
          readonly topicTemplate?: {
            readonly __typename: "TopicTemplateNode";
            readonly id: number;
            readonly title: string;
          } | null;
        } | null;
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly copiedFrom?: {
          readonly __typename: "TopicNode";
          readonly id: number;
          readonly title: string;
          readonly meeting?: {
            readonly __typename: "MeetingNode";
            readonly id: number;
            readonly title?: string | null;
            readonly startDatetime?: string | null;
            readonly meetingGroupId: number;
          } | null;
        } | null;
      } | null;
    } | null>;
  } | null;
  readonly assessmentDeliveriesMatching1on1Template: {
    readonly __typename: "AssessmentDeliveryNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "AssessmentDeliveryNodeEdge";
      readonly node?: {
        readonly __typename: "AssessmentDeliveryNode";
        readonly id: number;
        readonly target?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
        } | null;
        readonly complianceProgram?: {
          readonly __typename: "ComplianceProgramNode";
          readonly id: number;
          readonly title: string;
          readonly requiredTopicTemplates: {
            readonly __typename: "TopicTemplateNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "TopicTemplateNodeEdge";
              readonly node?: {
                readonly __typename: "TopicTemplateNode";
                readonly id: number;
                readonly title: string;
              } | null;
            } | null>;
          };
        } | null;
      } | null;
    } | null>;
  };
  readonly botParticipationDetails: {
    readonly __typename: "BotParticipationDetailsNode";
    readonly willBotJoin: boolean;
    readonly reason: MeetingBotJoinReason;
    readonly joinBecauseOfParticipants: ReadonlyArray<{
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
    }>;
  };
  readonly participants?: {
    readonly __typename: "MeetingParticipantConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "MeetingParticipantEdge";
      readonly node?: {
        readonly __typename: "MeetingParticipantNode";
        readonly id?: string | null;
        readonly status?: AttendeeStatus | null;
        readonly participantEmail?: string | null;
        readonly role?: AttendeeRole | null;
        readonly user?: {
          readonly __typename: "BasicUserNode";
          readonly id: number;
          readonly name: string;
          readonly firstName: string;
          readonly lastName: string;
          readonly avatar?: string | null;
          readonly email: string;
          readonly status?: UserStatus | null;
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type RemoveBotFromMeetingNewPageMutationMutationVariables = Exact<{
  meetingId: Scalars["Int"]["input"];
}>;

export type RemoveBotFromMeetingNewPageMutationMutation = {
  readonly __typename: "Mutation";
  readonly removeBotFromMeeting?: {
    readonly __typename: "RemoveBotFromMeetingMutation";
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
    } | null;
  } | null;
};

export type ReorderTopicNewPageMutationMutationVariables = Exact<{
  afterTopicId?: InputMaybe<Scalars["Int"]["input"]>;
  beforeTopicId?: InputMaybe<Scalars["Int"]["input"]>;
  topicId: Scalars["Int"]["input"];
}>;

export type ReorderTopicNewPageMutationMutation = {
  readonly __typename: "Mutation";
  readonly reorderTopic?: {
    readonly __typename: "ReorderTopicMutation";
    readonly topic?: {
      readonly __typename: "TopicNode";
      readonly id: number;
    } | null;
    readonly afterTopic?: {
      readonly __typename: "TopicNode";
      readonly id: number;
    } | null;
    readonly beforeTopic?: {
      readonly __typename: "TopicNode";
      readonly id: number;
    } | null;
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
    } | null;
  } | null;
};

export type EmailMeetingInvitesNewPageMutationMutationVariables = Exact<{
  meetingId: Scalars["Int"]["input"];
  recipientEmails:
    | ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>;
  message?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type EmailMeetingInvitesNewPageMutationMutation = {
  readonly __typename: "Mutation";
  readonly emailMeetingInvites?: {
    readonly __typename: "EmailMeetingInvitesMutation";
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
    } | null;
  } | null;
};

export type EmailMeetingNotesNewPageMutationMutationVariables = Exact<{
  meetingId: Scalars["Int"]["input"];
  recipientEmails:
    | ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>;
  message?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type EmailMeetingNotesNewPageMutationMutation = {
  readonly __typename: "Mutation";
  readonly emailMeetingNotes?: {
    readonly __typename: "EmailMeetingNotesMutation";
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
    } | null;
  } | null;
};

export type ToggleTopicIndividualNoteVisibilityNewPageMutationMutationVariables =
  Exact<{
    topicIds:
      | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
      | InputMaybe<Scalars["Int"]["input"]>;
    hidden?: InputMaybe<Scalars["Boolean"]["input"]>;
    enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    notes?: InputMaybe<Scalars["JSONString"]["input"]>;
  }>;

export type ToggleTopicIndividualNoteVisibilityNewPageMutationMutation = {
  readonly __typename: "Mutation";
  readonly toggleIndividualNoteVisibility?: {
    readonly __typename: "ToggleIndividualNoteVisibilityMutation";
    readonly topics?: {
      readonly __typename: "TopicNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "TopicNodeEdge";
        readonly node?: {
          readonly __typename: "TopicNode";
          readonly id: number;
          readonly includesIndividualNotesForCurrentUser: boolean;
          readonly includesSharedNotes: boolean;
          readonly individualNotes?: {
            readonly __typename: "IndividualNoteNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "IndividualNoteNodeEdge";
              readonly node?: {
                readonly __typename: "IndividualNoteNode";
                readonly id: number;
                readonly created: string;
                readonly hidden: boolean;
                readonly enabled: boolean;
                readonly notes?: any | null;
                readonly creator: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                };
              } | null;
            } | null>;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type TopicIndividualNotesFragmentFragment = {
  readonly __typename: "IndividualNoteNode";
  readonly id: number;
  readonly created: string;
  readonly hidden: boolean;
  readonly enabled: boolean;
  readonly notes?: any | null;
  readonly creator: { readonly __typename: "UserNode"; readonly id: number };
};

export type TopicNodeNewPageFragmentFragment = {
  readonly __typename: "TopicNode";
  readonly id: number;
  readonly clientId?: number | null;
  readonly title: string;
  readonly description?: string | null;
  readonly discussionNotes?: any | null;
  readonly created: string;
  readonly state?: TopicState | null;
  readonly eventChannelName?: string | null;
  readonly includesIndividualNotes: boolean;
  readonly includesIndividualNotesForCurrentUser: boolean;
  readonly includesSharedNotes: boolean;
  readonly isMandatory: boolean;
  readonly notesRequirement: NotesRequirement;
  readonly individualNotes?: {
    readonly __typename: "IndividualNoteNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "IndividualNoteNodeEdge";
      readonly node?: {
        readonly __typename: "IndividualNoteNode";
        readonly id: number;
        readonly created: string;
        readonly hidden: boolean;
        readonly enabled: boolean;
        readonly notes?: any | null;
        readonly creator: {
          readonly __typename: "UserNode";
          readonly id: number;
        };
      } | null;
    } | null>;
  } | null;
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
  } | null;
  readonly assignee?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly avatar?: string | null;
    readonly name: string;
  } | null;
  readonly previousTopic?: {
    readonly __typename: "TopicNode";
    readonly id: number;
    readonly discussionNotes?: any | null;
  } | null;
  readonly linkedTemplateTopic?: {
    readonly __typename: "TopicNode";
    readonly id: number;
    readonly title: string;
    readonly discussionNotes?: any | null;
    readonly defaultSubjectNotes?: any | null;
    readonly defaultFacilitatorNotes?: any | null;
    readonly topicTemplate?: {
      readonly __typename: "TopicTemplateNode";
      readonly id: number;
      readonly title: string;
    } | null;
  } | null;
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly copiedFrom?: {
    readonly __typename: "TopicNode";
    readonly id: number;
    readonly title: string;
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
      readonly title?: string | null;
      readonly startDatetime?: string | null;
      readonly meetingGroupId: number;
    } | null;
  } | null;
};

export type UpdateMeetingGroupNewPageMutationMutationVariables = Exact<{
  meetingGroupId: Scalars["Int"]["input"];
  facilitatorId?: InputMaybe<Scalars["Int"]["input"]>;
  allowManagementTreeVisibility?: InputMaybe<Scalars["Boolean"]["input"]>;
  allowAdminVisibility?: InputMaybe<Scalars["Boolean"]["input"]>;
  allowOrgVisibility?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFormalOneonone?: InputMaybe<Scalars["Boolean"]["input"]>;
  transcribeMeetingsByDefault?: InputMaybe<Scalars["Boolean"]["input"]>;
  addTranscriptionBotToMeetingsByDefault?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  meetingBotSetting?: InputMaybe<MeetingBotSetting>;
  detectedOneononeBannerDismissed?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type UpdateMeetingGroupNewPageMutationMutation = {
  readonly __typename: "Mutation";
  readonly updateMeetingGroup?: {
    readonly __typename: "UpdateMeetingGroupMutation";
    readonly meetingGroup?: {
      readonly __typename: "MeetingGroupNode";
      readonly id: number;
      readonly allowAdminVisibility: boolean;
      readonly allowManagementTreeVisibility: boolean;
      readonly allowOrgVisibility: boolean;
      readonly isFormalOneonone: boolean;
      readonly detectedOneononeBannerDismissed: boolean;
      readonly transcribeMeetingsByDefault?: boolean | null;
      readonly addTranscriptionBotToMeetingsByDefault: boolean;
      readonly meetingBotSetting?: MeetingBotSetting | null;
      readonly facilitator?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      } | null;
    } | null;
  } | null;
};

export type UpdateMeetingGroupTranscriptionFlagMutationMutationVariables =
  Exact<{
    meetingGroupId: Scalars["Int"]["input"];
    transcribeMeetingsByDefault?: InputMaybe<Scalars["Boolean"]["input"]>;
    addTranscriptionBotToMeetingsByDefault?: InputMaybe<
      Scalars["Boolean"]["input"]
    >;
  }>;

export type UpdateMeetingGroupTranscriptionFlagMutationMutation = {
  readonly __typename: "Mutation";
  readonly updateMeetingGroup?: {
    readonly __typename: "UpdateMeetingGroupMutation";
    readonly meetingGroup?: {
      readonly __typename: "MeetingGroupNode";
      readonly id: number;
      readonly transcribeMeetingsByDefault?: boolean | null;
      readonly addTranscriptionBotToMeetingsByDefault: boolean;
    } | null;
  } | null;
};

export type UpdateMeetingNewPageMutationMutationVariables = Exact<{
  meetingId: Scalars["Int"]["input"];
  allowExternalViewers?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type UpdateMeetingNewPageMutationMutation = {
  readonly __typename: "Mutation";
  readonly updateMeeting?: {
    readonly __typename: "UpdateMeetingMutation";
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
      readonly allowExternalViewers?: boolean | null;
      readonly writableSharingUrl?: string | null;
    } | null;
  } | null;
};

export type CreateOrUpdateSlackNotificationsForMeetingGroupMutationMutationVariables =
  Exact<{
    meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
    notificationId?: InputMaybe<Scalars["Int"]["input"]>;
    channel?: InputMaybe<Scalars["String"]["input"]>;
  }>;

export type CreateOrUpdateSlackNotificationsForMeetingGroupMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateSlackNotificationsForMeetingGroup?: {
    readonly __typename: "CreateOrUpdateSlackNotificationsForMeetingGroup";
    readonly meetingGroup?: {
      readonly __typename: "MeetingGroupNode";
      readonly id: number;
      readonly slackNotifications?: {
        readonly __typename: "SlackNotificationConnectionNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "SlackNotificationConnectionNodeEdge";
          readonly node?: {
            readonly __typename: "SlackNotificationConnectionNode";
            readonly id: number;
            readonly channel: string;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type CreateOrUpdateTemplateSeriesForMeetingMutationMutationVariables =
  Exact<{
    meetingGroupId: Scalars["Int"]["input"];
    templateId?: InputMaybe<Scalars["Int"]["input"]>;
    templateSeriesId?: InputMaybe<Scalars["Int"]["input"]>;
    topics:
      | ReadonlyArray<InputMaybe<TemplateTopicInput>>
      | InputMaybe<TemplateTopicInput>;
  }>;

export type CreateOrUpdateTemplateSeriesForMeetingMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateTemplateSeriesForMeeting?: {
    readonly __typename: "CreateOrUpdateTemplateSeriesForMeetingMutation";
    readonly templateSeries?: {
      readonly __typename: "TemplateSeriesNode";
      readonly id: number;
      readonly title: string;
      readonly description: string;
      readonly topicTemplates?: {
        readonly __typename: "TemplateSeriesToTopicTemplatesNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "TemplateSeriesToTopicTemplatesNodeEdge";
          readonly node?: {
            readonly __typename: "TemplateSeriesToTopicTemplatesNode";
            readonly id: number;
            readonly topicTemplate?: {
              readonly __typename: "TopicTemplateNode";
              readonly id: number;
              readonly title: string;
              readonly description: string;
              readonly publicTemplate: boolean;
              readonly topics?: {
                readonly __typename: "TopicNodeConnection";
                readonly edges: ReadonlyArray<{
                  readonly __typename: "TopicNodeEdge";
                  readonly node?: {
                    readonly __typename: "TopicNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description?: string | null;
                    readonly discussionNotes?: any | null;
                  } | null;
                } | null>;
              } | null;
            } | null;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type CreateOrUpdateMeetingTopicTemplateMutationMutationVariables =
  Exact<{
    title: Scalars["String"]["input"];
    organization: Scalars["Int"]["input"];
    topics:
      | ReadonlyArray<InputMaybe<TemplateTopicInput>>
      | InputMaybe<TemplateTopicInput>;
  }>;

export type CreateOrUpdateMeetingTopicTemplateMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateTopicTemplate?: {
    readonly __typename: "CreateOrUpdateTopicTemplateMutation";
    readonly topicTemplate?: {
      readonly __typename: "TopicTemplateNode";
      readonly id: number;
      readonly title: string;
      readonly description: string;
      readonly publicTemplate: boolean;
      readonly topics?: {
        readonly __typename: "TopicNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "TopicNodeEdge";
          readonly node?: {
            readonly __typename: "TopicNode";
            readonly id: number;
            readonly title: string;
            readonly description?: string | null;
            readonly discussionNotes?: any | null;
            readonly includesSharedNotes: boolean;
            readonly includesIndividualNotes: boolean;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type DeleteSlackNotificationsForMeetingGroupMutationVariables = Exact<{
  notificationId: Scalars["Int"]["input"];
}>;

export type DeleteSlackNotificationsForMeetingGroupMutation = {
  readonly __typename: "Mutation";
  readonly deleteSlackNotificationsForMeetingGroup?: {
    readonly __typename: "DeleteSlackNotificationsForMeetingGroup";
    readonly meetingGroup?: {
      readonly __typename: "MeetingGroupNode";
      readonly id: number;
      readonly slackNotifications?: {
        readonly __typename: "SlackNotificationConnectionNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "SlackNotificationConnectionNodeEdge";
          readonly node?: {
            readonly __typename: "SlackNotificationConnectionNode";
            readonly id: number;
            readonly channel: string;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type SlackNotificationFragmentFragment = {
  readonly __typename: "SlackNotificationConnectionNode";
  readonly id: number;
  readonly channel: string;
};

export type SlackChannelFragmentFragment = {
  readonly __typename: "SlackChannelNode";
  readonly id?: string | null;
  readonly name?: string | null;
};

export type GetMeetingGroupSettingsQueryQueryVariables = Exact<{
  meetingGroupId: Scalars["Int"]["input"];
}>;

export type GetMeetingGroupSettingsQueryQuery = {
  readonly __typename: "Query";
  readonly meetingGroup?: {
    readonly __typename: "MeetingGroupNode";
    readonly id: number;
    readonly transcribeMeetingsByDefault?: boolean | null;
    readonly title: string;
    readonly hasTemplate?: boolean | null;
    readonly allowAdminVisibility: boolean;
    readonly allowOrgVisibility: boolean;
    readonly allowManagementTreeVisibility: boolean;
    readonly isFormalOneonone: boolean;
    readonly detectedOneononeBannerDismissed: boolean;
    readonly meetingBotSetting?: MeetingBotSetting | null;
    readonly addTranscriptionBotToMeetingsByDefault: boolean;
    readonly canUpdate?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    } | null;
    readonly slackNotifications?: {
      readonly __typename: "SlackNotificationConnectionNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "SlackNotificationConnectionNodeEdge";
        readonly node?: {
          readonly __typename: "SlackNotificationConnectionNode";
          readonly id: number;
          readonly channel: string;
        } | null;
      } | null>;
    } | null;
    readonly organization?: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
      readonly hasSlackConnection?: boolean | null;
      readonly name: string;
      readonly publicSlackChannels?: {
        readonly __typename: "SlackChannelConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "SlackChannelEdge";
          readonly node?: {
            readonly __typename: "SlackChannelNode";
            readonly id?: string | null;
            readonly name?: string | null;
          } | null;
        } | null>;
      } | null;
    } | null;
    readonly facilitator?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly avatar?: string | null;
    } | null;
    readonly syncCredentials?: {
      readonly __typename: "UserSyncCredentialsNode";
      readonly id: number;
      readonly hasCalendarWriteCredentials?: boolean | null;
      readonly provider?: SyncCredentialsTypeEnum | null;
    } | null;
    readonly topicTemplate?: {
      readonly __typename: "TopicTemplateNode";
      readonly id: number;
      readonly title: string;
      readonly globalTemplate: boolean;
      readonly publicTemplate: boolean;
      readonly meetingTemplate: boolean;
      readonly finalizePermissions: FinalizePermissions;
      readonly organization?: {
        readonly __typename: "OrganizationNode";
        readonly id: number;
      } | null;
    } | null;
  } | null;
};

export type GetTemplateSeriesQueryQueryVariables = Exact<{
  meetingGroupId: Scalars["Int"]["input"];
}>;

export type GetTemplateSeriesQueryQuery = {
  readonly __typename: "Query";
  readonly meetingGroup?: {
    readonly __typename: "MeetingGroupNode";
    readonly id: number;
    readonly isFormalOneonone: boolean;
    readonly allowAdminVisibility: boolean;
    readonly templateSeries?: {
      readonly __typename: "TemplateSeriesNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "TemplateSeriesNodeEdge";
        readonly node?: {
          readonly __typename: "TemplateSeriesNode";
          readonly id: number;
          readonly topicTemplates?: {
            readonly __typename: "TemplateSeriesToTopicTemplatesNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "TemplateSeriesToTopicTemplatesNodeEdge";
              readonly node?: {
                readonly __typename: "TemplateSeriesToTopicTemplatesNode";
                readonly id: number;
                readonly topicTemplate?: {
                  readonly __typename: "TopicTemplateNode";
                  readonly id: number;
                  readonly title: string;
                  readonly description: string;
                  readonly globalTemplate: boolean;
                  readonly publicTemplate: boolean;
                  readonly oneononeTemplate: boolean;
                  readonly finalizePermissions: FinalizePermissions;
                  readonly managerInstructions: string;
                  readonly reportInstructions: string;
                  readonly allowAdminVisibility: boolean;
                  readonly allowOrgVisibility: boolean;
                  readonly allowManagementTreeVisibility: boolean;
                  readonly organization?: {
                    readonly __typename: "OrganizationNode";
                    readonly id: number;
                  } | null;
                  readonly canDelete: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                    readonly reason: string;
                  };
                  readonly canUpdate: {
                    readonly __typename: "PermissionNode";
                    readonly permission: boolean;
                    readonly reason: string;
                  };
                  readonly creator?: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly name: string;
                    readonly avatar?: string | null;
                  } | null;
                  readonly categoriesList: ReadonlyArray<{
                    readonly __typename: "TemplateCategoryNode";
                    readonly id: number;
                    readonly title: string;
                    readonly ordinal?: number | null;
                    readonly organization?: {
                      readonly __typename: "OrganizationNode";
                      readonly id: number;
                    } | null;
                    readonly canUpdate?: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                    } | null;
                    readonly canDelete?: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                    } | null;
                  } | null>;
                  readonly topicsList: ReadonlyArray<{
                    readonly __typename: "TopicNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description?: string | null;
                    readonly discussionNotes?: any | null;
                    readonly defaultSubjectNotes?: any | null;
                    readonly defaultFacilitatorNotes?: any | null;
                    readonly includesIndividualNotes: boolean;
                    readonly includesSharedNotes: boolean;
                    readonly isMandatory: boolean;
                    readonly notesRequirement: NotesRequirement;
                  } | null>;
                } | null;
              } | null;
            } | null>;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type RemoveTemplateSeriesFromMeetingMutationMutationVariables = Exact<{
  meetingGroupId: Scalars["Int"]["input"];
}>;

export type RemoveTemplateSeriesFromMeetingMutationMutation = {
  readonly __typename: "Mutation";
  readonly removeTemplateSeriesFromMeeting?: {
    readonly __typename: "RemoveTemplateSeriesFromMeetingMutation";
    readonly meetingGroup?: {
      readonly __typename: "MeetingGroupNode";
      readonly id: number;
      readonly templateSeries?: {
        readonly __typename: "TemplateSeriesNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "TemplateSeriesNodeEdge";
          readonly node?: {
            readonly __typename: "TemplateSeriesNode";
            readonly id: number;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type DeleteMeetingTranscriptMessagesMutationVariables = Exact<{
  meetingId: Scalars["Int"]["input"];
  removeMessageIds?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
}>;

export type DeleteMeetingTranscriptMessagesMutation = {
  readonly __typename: "Mutation";
  readonly updateMeetingTranscript?: {
    readonly __typename: "UpdateMeetingTranscriptMutation";
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
      readonly transcript?: {
        readonly __typename: "MeetingTranscriptNode";
        readonly userMapping?: any | null;
        readonly orderedTranscriptData?: ReadonlyArray<{
          readonly __typename: "MeetingTranscriptMessageNode";
          readonly text: string;
          readonly speaker?: string | null;
          readonly created?: number | null;
          readonly messageId?: string | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type GetMeetingTranscriptQueryQueryVariables = Exact<{
  meetingId: Scalars["Int"]["input"];
}>;

export type GetMeetingTranscriptQueryQuery = {
  readonly __typename: "Query";
  readonly meeting?: {
    readonly __typename: "MeetingNode";
    readonly id: number;
    readonly startDatetime?: string | null;
    readonly hasTranscript?: boolean | null;
    readonly endDatetime?: string | null;
    readonly isRecurring: boolean;
    readonly hasBotInMeeting: boolean;
    readonly botIsRecording: boolean;
    readonly botStatus?: RecallBotStatus | null;
    readonly draft: boolean;
    readonly botIsWaitingToJoinMeeting: boolean;
    readonly notesSummary?: string | null;
    readonly videoConferenceType?: OnlineVideoConference | null;
    readonly botParticipationDetails: {
      readonly __typename: "BotParticipationDetailsNode";
      readonly reason: MeetingBotJoinReason;
      readonly willBotJoin: boolean;
      readonly joinBecauseOfParticipants: ReadonlyArray<{
        readonly __typename: "UserNode";
        readonly name: string;
      }>;
    };
    readonly organization?: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
      readonly name: string;
      readonly effectivePricingTier?: PricingTier | null;
      readonly enableMeetingSummarization: boolean;
      readonly enableMeetingBot: boolean;
    } | null;
    readonly meetingGroup?: {
      readonly __typename: "MeetingGroupNode";
      readonly id: number;
      readonly addTranscriptionBotToMeetingsByDefault: boolean;
      readonly meetingBotSetting?: MeetingBotSetting | null;
      readonly canUpdate?: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
      } | null;
    } | null;
    readonly transcript?: {
      readonly __typename: "MeetingTranscriptNode";
      readonly id: number;
      readonly summary?: string | null;
      readonly longSummary?: string | null;
      readonly highlights?: string | null;
      readonly videoRecording?: string | null;
      readonly recallVideoRecording?: string | null;
      readonly canSaveVideoRecording?: boolean | null;
      readonly videoRecordingAvailableUntil?: string | null;
      readonly orderedTranscriptData?: ReadonlyArray<{
        readonly __typename: "MeetingTranscriptMessageNode";
        readonly text: string;
        readonly speaker?: string | null;
        readonly created?: number | null;
        readonly startTimestamp?: number | null;
        readonly messageId?: string | null;
      } | null> | null;
      readonly highlightList?: {
        readonly __typename: "TranscriptHighlightConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "TranscriptHighlightEdge";
          readonly node?: {
            readonly __typename: "TranscriptHighlightNode";
            readonly id?: string | null;
            readonly highlight?: string | null;
          } | null;
        } | null>;
      } | null;
      readonly highlightCategories?: {
        readonly __typename: "TranscriptHighlightCategoryConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "TranscriptHighlightCategoryEdge";
          readonly node?: {
            readonly __typename: "TranscriptHighlightCategoryNode";
            readonly id?: string | null;
            readonly categoryTitle?: string | null;
            readonly highlights?: {
              readonly __typename: "TranscriptHighlightConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "TranscriptHighlightEdge";
                readonly node?: {
                  readonly __typename: "TranscriptHighlightNode";
                  readonly id?: string | null;
                  readonly highlight?: string | null;
                } | null;
              } | null>;
            } | null;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type HideSuggestedArtifactMutationMutationVariables = Exact<{
  suggestedArtifactId: Scalars["Int"]["input"];
}>;

export type HideSuggestedArtifactMutationMutation = {
  readonly __typename: "Mutation";
  readonly updateSuggestedArtifact?: {
    readonly __typename: "UpdateSuggestedArtifactMutation";
    readonly suggestedArtifact?: {
      readonly __typename: "SuggestedArtifactNode";
      readonly id: number;
      readonly hidden: boolean;
    } | null;
  } | null;
};

export type GetMeetingOverviewMeetingsQueryQueryVariables = Exact<{
  participants?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  dateRangeStart?: InputMaybe<Scalars["DateTime"]["input"]>;
  dateRangeEnd?: InputMaybe<Scalars["DateTime"]["input"]>;
  isOneonone?: InputMaybe<Scalars["Boolean"]["input"]>;
  searchQuery?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  minimumDateRange?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetMeetingOverviewMeetingsQueryQuery = {
  readonly __typename: "Query";
  readonly meetings?: {
    readonly __typename: "MeetingNodeConnection";
    readonly totalCount: number;
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly startCursor?: string | null;
      readonly endCursor?: string | null;
      readonly hasNextPage: boolean;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "MeetingNodeEdge";
      readonly node?: {
        readonly __typename: "MeetingNode";
        readonly id: number;
        readonly title?: string | null;
        readonly draft: boolean;
        readonly meetingGroupId: number;
        readonly ignored: boolean;
        readonly startDatetime?: string | null;
        readonly endDatetime?: string | null;
        readonly videoConferenceUrl?: string | null;
        readonly videoConferenceType?: OnlineVideoConference | null;
        readonly meetingGroup?: {
          readonly __typename: "MeetingGroupNode";
          readonly id: number;
          readonly title: string;
          readonly description?: string | null;
          readonly isFormalOneonone: boolean;
        } | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
        } | null;
        readonly participants?: {
          readonly __typename: "MeetingParticipantConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "MeetingParticipantEdge";
            readonly node?: {
              readonly __typename: "MeetingParticipantNode";
              readonly id?: string | null;
              readonly user?: {
                readonly __typename: "BasicUserNode";
                readonly id: number;
              } | null;
            } | null;
          } | null>;
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type GetUnscheduledMeetingsQueryQueryVariables = Exact<{
  forUserId: Scalars["Int"]["input"];
  selectedUserId: Scalars["Int"]["input"];
  hasSelectedUserId: Scalars["Boolean"]["input"];
}>;

export type GetUnscheduledMeetingsQueryQuery = {
  readonly __typename: "Query";
  readonly unscheduledMeetings?: {
    readonly __typename: "BasicMeetingNodeConnection";
    readonly totalCount: number;
    readonly edges: ReadonlyArray<{
      readonly __typename: "BasicMeetingNodeEdge";
      readonly node?: {
        readonly __typename: "BasicMeetingNode";
        readonly id: number;
        readonly meeting?: {
          readonly __typename: "MeetingNode";
          readonly id: number;
          readonly title?: string | null;
          readonly draft: boolean;
          readonly meetingGroupId: number;
          readonly ignored: boolean;
          readonly startDatetime?: string | null;
          readonly endDatetime?: string | null;
          readonly videoConferenceUrl?: string | null;
          readonly videoConferenceType?: OnlineVideoConference | null;
          readonly meetingGroup?: {
            readonly __typename: "MeetingGroupNode";
            readonly id: number;
            readonly title: string;
            readonly description?: string | null;
            readonly isFormalOneonone: boolean;
          } | null;
          readonly creator?: {
            readonly __typename: "UserNode";
            readonly id: number;
          } | null;
          readonly participants?: {
            readonly __typename: "MeetingParticipantConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "MeetingParticipantEdge";
              readonly node?: {
                readonly __typename: "MeetingParticipantNode";
                readonly id?: string | null;
                readonly user?: {
                  readonly __typename: "BasicUserNode";
                  readonly id: number;
                } | null;
              } | null;
            } | null>;
          } | null;
        } | null;
      } | null;
    } | null>;
  } | null;
  readonly user?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly firstName: string;
    readonly email: string;
    readonly avatar?: string | null;
  } | null;
};

export type MeetingsOverviewMeetingFragment = {
  readonly __typename: "MeetingNode";
  readonly id: number;
  readonly title?: string | null;
  readonly draft: boolean;
  readonly meetingGroupId: number;
  readonly ignored: boolean;
  readonly startDatetime?: string | null;
  readonly endDatetime?: string | null;
  readonly videoConferenceUrl?: string | null;
  readonly videoConferenceType?: OnlineVideoConference | null;
  readonly meetingGroup?: {
    readonly __typename: "MeetingGroupNode";
    readonly id: number;
    readonly title: string;
    readonly description?: string | null;
    readonly isFormalOneonone: boolean;
  } | null;
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
  } | null;
  readonly participants?: {
    readonly __typename: "MeetingParticipantConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "MeetingParticipantEdge";
      readonly node?: {
        readonly __typename: "MeetingParticipantNode";
        readonly id?: string | null;
        readonly user?: {
          readonly __typename: "BasicUserNode";
          readonly id: number;
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type AcceptInvitationMutationMutationVariables = Exact<{
  invitationId: Scalars["Int"]["input"];
}>;

export type AcceptInvitationMutationMutation = {
  readonly __typename: "Mutation";
  readonly acceptInvitation?: {
    readonly __typename: "AcceptInvitationMutation";
    readonly user?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly syncCredentials?: {
        readonly __typename: "UserSyncCredentialsNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "UserSyncCredentialsNodeEdge";
          readonly node?: {
            readonly __typename: "UserSyncCredentialsNode";
            readonly id: number;
            readonly provider?: SyncCredentialsTypeEnum | null;
            readonly credentialsUid?: string | null;
            readonly hasValidCalendarCredentials?: boolean | null;
            readonly hasCalendarWriteCredentials?: boolean | null;
            readonly organization?: {
              readonly __typename: "OrganizationNode";
              readonly id: number;
              readonly domains?: ReadonlyArray<string | null> | null;
              readonly personal?: boolean | null;
            } | null;
          } | null;
        } | null>;
      } | null;
      readonly organizations: {
        readonly __typename: "OrganizationNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "OrganizationNodeEdge";
          readonly node?: {
            readonly __typename: "OrganizationNode";
            readonly id: number;
            readonly name: string;
            readonly personal?: boolean | null;
            readonly domains?: ReadonlyArray<string | null> | null;
            readonly members: {
              readonly __typename: "UserMemberNodeConnection";
              readonly totalCount: number;
            };
          } | null;
        } | null>;
      };
      readonly invitations?: {
        readonly __typename: "InvitationNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "InvitationNodeEdge";
          readonly node?: {
            readonly __typename: "InvitationNode";
            readonly id: number;
            readonly organizationId?: number | null;
            readonly organizationName?: string | null;
            readonly organizationMemberCount?: number | null;
            readonly status?: InvitationStatus | null;
            readonly inviteeEmail: string;
          } | null;
        } | null>;
      } | null;
    } | null;
    readonly invitation?: {
      readonly __typename: "InvitationNode";
      readonly id: number;
      readonly organizationId?: number | null;
      readonly organizationName?: string | null;
      readonly organizationMemberCount?: number | null;
      readonly status?: InvitationStatus | null;
      readonly inviteeEmail: string;
    } | null;
  } | null;
};

export type CreateOrganizationMutationMutationVariables = Exact<{
  name: Scalars["String"]["input"];
  membershipSetting: OrganizationMembershipSetting;
  associatedDomainName?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type CreateOrganizationMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateOrganization?: {
    readonly __typename: "CreateOrUpdateOrganizationMutation";
    readonly organization?: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
      readonly name: string;
      readonly personal?: boolean | null;
      readonly domains?: ReadonlyArray<string | null> | null;
      readonly members: {
        readonly __typename: "UserMemberNodeConnection";
        readonly totalCount: number;
      };
    } | null;
  } | null;
};

export type GetAccountSetupReportingQueryQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
}>;

export type GetAccountSetupReportingQueryQuery = {
  readonly __typename: "Query";
  readonly me?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly calendarIsSyncingForFirstTime?: boolean | null;
    readonly managers: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly firstName: string;
          readonly lastName: string;
          readonly name: string;
          readonly email: string;
          readonly status?: UserStatus | null;
          readonly avatar?: string | null;
        } | null;
      } | null>;
    };
    readonly directReports: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly firstName: string;
          readonly lastName: string;
          readonly name: string;
          readonly email: string;
          readonly status?: UserStatus | null;
          readonly avatar?: string | null;
        } | null;
      } | null>;
    };
    readonly reportingPredictions?: {
      readonly __typename: "UserReportingPredictionResultNode";
      readonly status: ReportingPredictionStatus;
      readonly generatedAt?: string | null;
      readonly predictions: ReadonlyArray<{
        readonly __typename: "UserReportingPredictionNode";
        readonly confidence: number;
        readonly predictedDirection: ReportingPredictionDirection;
        readonly otherUser: {
          readonly __typename: "BasicUserNode";
          readonly id: number;
          readonly firstName: string;
          readonly lastName: string;
          readonly name: string;
          readonly email: string;
          readonly status?: UserStatus | null;
          readonly avatar?: string | null;
        };
      }>;
    } | null;
  } | null;
};

export type GetInvitationQueryQueryVariables = Exact<{
  inviteKey: Scalars["String"]["input"];
}>;

export type GetInvitationQueryQuery = {
  readonly __typename: "Query";
  readonly invitation?: {
    readonly __typename: "InvitationNode";
    readonly id: number;
    readonly organizationId?: number | null;
    readonly organizationName?: string | null;
    readonly organizationMemberCount?: number | null;
    readonly status?: InvitationStatus | null;
    readonly inviteeEmail: string;
  } | null;
};

export type GetLoggedInUserOnboardingQueryQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetLoggedInUserOnboardingQueryQuery = {
  readonly __typename: "Query";
  readonly loggedIn?: boolean | null;
  readonly me?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly email: string;
    readonly emails: ReadonlyArray<string>;
    readonly emailsWithNonFreeDomains?: ReadonlyArray<string | null> | null;
    readonly name: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly avatar?: string | null;
    readonly status?: UserStatus | null;
    readonly pusherChannelName?: string | null;
    readonly onboardingData?: any | null;
    readonly calendarIsSyncingForFirstTime?: boolean | null;
    readonly syncCredentials?: {
      readonly __typename: "UserSyncCredentialsNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserSyncCredentialsNodeEdge";
        readonly node?: {
          readonly __typename: "UserSyncCredentialsNode";
          readonly id: number;
          readonly provider?: SyncCredentialsTypeEnum | null;
          readonly credentialsUid?: string | null;
          readonly hasValidCalendarCredentials?: boolean | null;
          readonly hasCalendarWriteCredentials?: boolean | null;
          readonly organization?: {
            readonly __typename: "OrganizationNode";
            readonly id: number;
            readonly domains?: ReadonlyArray<string | null> | null;
            readonly personal?: boolean | null;
          } | null;
        } | null;
      } | null>;
    } | null;
    readonly organizations: {
      readonly __typename: "OrganizationNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "OrganizationNodeEdge";
        readonly node?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
          readonly name: string;
          readonly personal?: boolean | null;
          readonly domains?: ReadonlyArray<string | null> | null;
          readonly members: {
            readonly __typename: "UserMemberNodeConnection";
            readonly totalCount: number;
          };
        } | null;
      } | null>;
    };
  } | null;
};

export type GetOrganizationQueryQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
}>;

export type GetOrganizationQueryQuery = {
  readonly __typename: "Query";
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
    readonly name: string;
    readonly personal?: boolean | null;
    readonly domains?: ReadonlyArray<string | null> | null;
    readonly members: {
      readonly __typename: "UserMemberNodeConnection";
      readonly totalCount: number;
    };
  } | null;
};

export type InvitationFragmentFragment = {
  readonly __typename: "InvitationNode";
  readonly id: number;
  readonly organizationId?: number | null;
  readonly organizationName?: string | null;
  readonly organizationMemberCount?: number | null;
  readonly status?: InvitationStatus | null;
  readonly inviteeEmail: string;
};

export type LinkCalendarToOrganizationOnboardingMutationMutationVariables =
  Exact<{
    credentialsId: Scalars["Int"]["input"];
    organizationId: Scalars["Int"]["input"];
  }>;

export type LinkCalendarToOrganizationOnboardingMutationMutation = {
  readonly __typename: "Mutation";
  readonly linkCalendarToOrganization?: {
    readonly __typename: "LinkCalendarToOrganizationMutation";
    readonly user?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly syncCredentials?: {
        readonly __typename: "UserSyncCredentialsNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "UserSyncCredentialsNodeEdge";
          readonly node?: {
            readonly __typename: "UserSyncCredentialsNode";
            readonly id: number;
            readonly provider?: SyncCredentialsTypeEnum | null;
            readonly credentialsUid?: string | null;
            readonly hasValidCalendarCredentials?: boolean | null;
            readonly hasCalendarWriteCredentials?: boolean | null;
            readonly organization?: {
              readonly __typename: "OrganizationNode";
              readonly id: number;
              readonly domains?: ReadonlyArray<string | null> | null;
              readonly personal?: boolean | null;
            } | null;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type OrganizationFragmentFragment = {
  readonly __typename: "OrganizationNode";
  readonly id: number;
  readonly name: string;
  readonly personal?: boolean | null;
  readonly domains?: ReadonlyArray<string | null> | null;
  readonly members: {
    readonly __typename: "UserMemberNodeConnection";
    readonly totalCount: number;
  };
};

export type SetAccountSetupRelationshipsMutationMutationVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  relationships?: InputMaybe<
    ReadonlyArray<InputMaybe<RelationshipInput>> | InputMaybe<RelationshipInput>
  >;
  userId: Scalars["Int"]["input"];
  invitations:
    | ReadonlyArray<InputMaybe<InvitationInput>>
    | InputMaybe<InvitationInput>;
  saveRelationships: Scalars["Boolean"]["input"];
}>;

export type SetAccountSetupRelationshipsMutationMutation = {
  readonly __typename: "Mutation";
  readonly setRelationships?: {
    readonly __typename: "SetRelationshipsMutation";
    readonly me?: {
      readonly __typename: "UserNode";
      readonly id: number;
    } | null;
  } | null;
  readonly createInvitations?: {
    readonly __typename: "CreateInvitationsMutation";
    readonly invitationErrors?: ReadonlyArray<{
      readonly __typename: "InviteError";
      readonly inviteeEmail?: string | null;
      readonly message?: string | null;
    } | null> | null;
  } | null;
};

export type SyncCredentialFragmentFragment = {
  readonly __typename: "UserSyncCredentialsNode";
  readonly id: number;
  readonly provider?: SyncCredentialsTypeEnum | null;
  readonly credentialsUid?: string | null;
  readonly hasValidCalendarCredentials?: boolean | null;
  readonly hasCalendarWriteCredentials?: boolean | null;
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
    readonly domains?: ReadonlyArray<string | null> | null;
    readonly personal?: boolean | null;
  } | null;
};

export type UpdateAccountOnboardingMutationMutationVariables = Exact<{
  accountSetupData: Scalars["JSONString"]["input"];
}>;

export type UpdateAccountOnboardingMutationMutation = {
  readonly __typename: "Mutation";
  readonly updateAccountOnboarding?: {
    readonly __typename: "UpdateAccountOnboardingMutation";
    readonly user?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly onboardingData?: any | null;
    } | null;
  } | null;
};

export type GetOrgChartOrganizationMemberQueryQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  userId: Scalars["Int"]["input"];
}>;

export type GetOrgChartOrganizationMemberQueryQuery = {
  readonly __typename: "Query";
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
    readonly members: {
      readonly __typename: "UserMemberNodeConnection";
      readonly totalCount: number;
      readonly pageInfo: {
        readonly __typename: "PageInfo";
        readonly endCursor?: string | null;
        readonly hasNextPage: boolean;
      };
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserMemberNodeEdge";
        readonly node?: {
          readonly __typename: "UserMemberNode";
          readonly id: number;
          readonly user?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
            readonly status?: UserStatus | null;
            readonly primaryManager?: {
              readonly __typename: "UserNode";
              readonly id: number;
            } | null;
            readonly managers: {
              readonly __typename: "UserNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "UserNodeEdge";
                readonly node?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                } | null;
              } | null>;
            };
            readonly currentRoles: ReadonlyArray<{
              readonly __typename: "CareerTrackRoleNode";
              readonly id: number;
              readonly title: string;
            }>;
            readonly teamsList: ReadonlyArray<{
              readonly __typename: "TeamNode";
              readonly id: number;
            }>;
          } | null;
        } | null;
      } | null>;
    };
  } | null;
};

export type OrgChartUserNodeFragment = {
  readonly __typename: "UserNode";
  readonly id: number;
  readonly name: string;
  readonly avatar?: string | null;
  readonly status?: UserStatus | null;
  readonly primaryManager?: {
    readonly __typename: "UserNode";
    readonly id: number;
  } | null;
  readonly managers: {
    readonly __typename: "UserNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "UserNodeEdge";
      readonly node?: {
        readonly __typename: "UserNode";
        readonly id: number;
      } | null;
    } | null>;
  };
  readonly currentRoles: ReadonlyArray<{
    readonly __typename: "CareerTrackRoleNode";
    readonly id: number;
    readonly title: string;
  }>;
  readonly teamsList: ReadonlyArray<{
    readonly __typename: "TeamNode";
    readonly id: number;
  }>;
};

export type GetOrgChartOrganizationMembersQueryQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  userIsActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetOrgChartOrganizationMembersQueryQuery = {
  readonly __typename: "Query";
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
    readonly members: {
      readonly __typename: "UserMemberNodeConnection";
      readonly totalCount: number;
      readonly pageInfo: {
        readonly __typename: "PageInfo";
        readonly endCursor?: string | null;
        readonly hasNextPage: boolean;
      };
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserMemberNodeEdge";
        readonly node?: {
          readonly __typename: "UserMemberNode";
          readonly id: number;
          readonly user?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
            readonly status?: UserStatus | null;
            readonly primaryManager?: {
              readonly __typename: "UserNode";
              readonly id: number;
            } | null;
            readonly managers: {
              readonly __typename: "UserNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "UserNodeEdge";
                readonly node?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                } | null;
              } | null>;
            };
            readonly currentRoles: ReadonlyArray<{
              readonly __typename: "CareerTrackRoleNode";
              readonly id: number;
              readonly title: string;
            }>;
            readonly teamsList: ReadonlyArray<{
              readonly __typename: "TeamNode";
              readonly id: number;
            }>;
          } | null;
        } | null;
      } | null>;
    };
  } | null;
};

export type AddTeamMemberMutationMutationVariables = Exact<{
  teamId: Scalars["Int"]["input"];
  userId: Scalars["Int"]["input"];
}>;

export type AddTeamMemberMutationMutation = {
  readonly __typename: "Mutation";
  readonly addTeamMember?: {
    readonly __typename: "AddTeamMemberMutation";
    readonly user?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly teams?: {
        readonly __typename: "TeamNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "TeamNodeEdge";
          readonly node?: {
            readonly __typename: "TeamNode";
            readonly id: number;
            readonly title: string;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type BackfillSlackDataMutationMutationVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  startDate: Scalars["String"]["input"];
}>;

export type BackfillSlackDataMutationMutation = {
  readonly __typename: "Mutation";
  readonly backfillSlackData?: {
    readonly __typename: "BackfillSlackDataMutation";
    readonly organization?: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
      readonly slackIndexingConfiguration?: {
        readonly __typename: "SlackIndexingConfigurationNode";
        readonly indexNewChannelsByDefault: boolean;
        readonly indexMessages: boolean;
        readonly channels: ReadonlyArray<{
          readonly __typename: "SlackChannelConfigurationNode";
          readonly id: string;
          readonly name: string;
          readonly shouldIndex: boolean;
          readonly lastIndexedTs?: string | null;
          readonly firstIndexedTs?: string | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type CreateMergeLinkTokenMutationVariables = Exact<{
  integrationSlug: Scalars["String"]["input"];
  category: Scalars["String"]["input"];
}>;

export type CreateMergeLinkTokenMutation = {
  readonly __typename: "Mutation";
  readonly createMergeLinkToken?: {
    readonly __typename: "CreateMergeLinkToken";
    readonly success?: boolean | null;
    readonly linkToken?: string | null;
    readonly integrationName?: string | null;
    readonly endUserOriginId?: string | null;
    readonly error?: string | null;
  } | null;
};

export type SaveOrgWideCareerTrackMutationVariables = Exact<{
  careerTrackId?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  teamId?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  roles?: InputMaybe<
    | ReadonlyArray<InputMaybe<CareerTrackRoleInput>>
    | InputMaybe<CareerTrackRoleInput>
  >;
  additionalCompetencies?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
}>;

export type SaveOrgWideCareerTrackMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateCareerTrack?: {
    readonly __typename: "CreateOrUpdateCareerTrackMutation";
    readonly careerTrack?: {
      readonly __typename: "CareerTrackNode";
      readonly id: number;
      readonly title: string;
      readonly team?: {
        readonly __typename: "TeamNode";
        readonly id: number;
        readonly title: string;
      } | null;
      readonly roles: {
        readonly __typename: "CareerTrackRoleNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "CareerTrackRoleNodeEdge";
          readonly node?: {
            readonly __typename: "CareerTrackRoleNode";
            readonly id: number;
            readonly title: string;
            readonly level: number;
            readonly roleType: CareerTrackRoleType;
            readonly assignedUsers: {
              readonly __typename: "UserNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "UserNodeEdge";
                readonly node?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly name: string;
                  readonly email: string;
                  readonly avatar?: string | null;
                } | null;
              } | null>;
            };
            readonly responsibilities: {
              readonly __typename: "CareerTrackRoleResponsibilityNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "CareerTrackRoleResponsibilityNodeEdge";
                readonly node?: {
                  readonly __typename: "CareerTrackRoleResponsibilityNode";
                  readonly id: number;
                  readonly content: any;
                } | null;
              } | null>;
            };
            readonly competencies: {
              readonly __typename: "CompetencyConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "CompetencyEdge";
                readonly node?: {
                  readonly __typename: "CompetencyNode";
                  readonly id: number;
                  readonly title: string;
                  readonly appliesTo: CompetencyAppliesTo;
                  readonly criteriaUniqueness: CompetencyCriteriaUniqueness;
                  readonly criteria: {
                    readonly __typename: "CompetencyCriteriaConnection";
                    readonly edges: ReadonlyArray<{
                      readonly __typename: "CompetencyCriteriaEdge";
                      readonly node?: {
                        readonly __typename: "CompetencyCriteriaNode";
                        readonly id: number;
                        readonly content: any;
                        readonly level: number;
                      } | null;
                    } | null>;
                  };
                } | null;
              } | null>;
            };
          } | null;
        } | null>;
      };
    } | null;
  } | null;
};

export type OrgSettingsCreateOrUpdateCoreValueMutationVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  emoji?: InputMaybe<Scalars["String"]["input"]>;
  image?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<RecognitionCoreValueStatus>;
}>;

export type OrgSettingsCreateOrUpdateCoreValueMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateCoreValue?: {
    readonly __typename: "CreateOrUpdateCoreValueMutation";
    readonly coreValue?: {
      readonly __typename: "RecognitionCoreValueNode";
      readonly id: number;
      readonly title: string;
      readonly description: string;
      readonly emoji?: string | null;
      readonly image?: string | null;
      readonly status?: RecognitionCoreValueStatus | null;
    } | null;
  } | null;
};

export type SaveOrgWideCompetencyMutationVariables = Exact<{
  competencyId?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  appliesTo?: InputMaybe<CompetencyAppliesTo>;
  criteriaUniqueness?: InputMaybe<CompetencyCriteriaUniqueness>;
  appliesToManagementRoles?: InputMaybe<Scalars["Boolean"]["input"]>;
  appliesToIcRoles?: InputMaybe<Scalars["Boolean"]["input"]>;
  appliesToTeams?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  appliesToCareerTracks?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  criteria?: InputMaybe<
    | ReadonlyArray<InputMaybe<CompetencyCriteriaInput>>
    | InputMaybe<CompetencyCriteriaInput>
  >;
}>;

export type SaveOrgWideCompetencyMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateCompetency?: {
    readonly __typename: "CreateOrUpdateCompetencyMutation";
    readonly competency?: {
      readonly __typename: "CompetencyNode";
      readonly id: number;
      readonly title: string;
      readonly description: any;
      readonly appliesTo: CompetencyAppliesTo;
    } | null;
  } | null;
};

export type CreateOrUpdateSlackNotificationForChannelMutationMutationVariables =
  Exact<{
    channel?: InputMaybe<Scalars["String"]["input"]>;
    organizationId?: InputMaybe<Scalars["Int"]["input"]>;
    notificationId?: InputMaybe<Scalars["Int"]["input"]>;
    recognitions?: InputMaybe<Scalars["Boolean"]["input"]>;
    goalCheckins?: InputMaybe<Scalars["Boolean"]["input"]>;
  }>;

export type CreateOrUpdateSlackNotificationForChannelMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateSlackNotificationForChannel?: {
    readonly __typename: "CreateOrUpdateSlackNotificationForChannelMutation";
    readonly organization?: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
      readonly slackNotifications?: {
        readonly __typename: "SlackNotificationForChannelNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "SlackNotificationForChannelNodeEdge";
          readonly node?: {
            readonly __typename: "SlackNotificationForChannelNode";
            readonly id: number;
            readonly channel: string;
            readonly recognitions: boolean;
            readonly goalCheckins: boolean;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type CreateOrUpdateTeamsNotificationForChannelMutationMutationVariables =
  Exact<{
    channelId?: InputMaybe<Scalars["String"]["input"]>;
    teamId?: InputMaybe<Scalars["String"]["input"]>;
    organizationId?: InputMaybe<Scalars["Int"]["input"]>;
    notificationId?: InputMaybe<Scalars["Int"]["input"]>;
    recognitions?: InputMaybe<Scalars["Boolean"]["input"]>;
    goalCheckins?: InputMaybe<Scalars["Boolean"]["input"]>;
  }>;

export type CreateOrUpdateTeamsNotificationForChannelMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateTeamsNotificationForChannel?: {
    readonly __typename: "CreateOrUpdateTeamsNotificationForChannelMutation";
    readonly organization?: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
      readonly teamsNotifications?: {
        readonly __typename: "TeamsNotificationForChannelNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "TeamsNotificationForChannelNodeEdge";
          readonly node?: {
            readonly __typename: "TeamsNotificationForChannelNode";
            readonly id: number;
            readonly teamId: string;
            readonly teamName: string;
            readonly channelId: string;
            readonly channelName: string;
            readonly recognitions: boolean;
            readonly goalCheckins: boolean;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type DeleteCoreValueMutationMutationVariables = Exact<{
  coreValueId: Scalars["Int"]["input"];
}>;

export type DeleteCoreValueMutationMutation = {
  readonly __typename: "Mutation";
  readonly deleteCoreValue?: {
    readonly __typename: "DeleteCoreValueMutation";
    readonly ok?: boolean | null;
  } | null;
};

export type DeleteOrgWideCareerTrackMutationVariables = Exact<{
  careerTrackId: Scalars["Int"]["input"];
}>;

export type DeleteOrgWideCareerTrackMutation = {
  readonly __typename: "Mutation";
  readonly deleteCareerTrack?: {
    readonly __typename: "DeleteCareerTrackMutation";
    readonly ok?: boolean | null;
  } | null;
};

export type DeleteOrgWideCompetencyMutationVariables = Exact<{
  competencyId: Scalars["Int"]["input"];
}>;

export type DeleteOrgWideCompetencyMutation = {
  readonly __typename: "Mutation";
  readonly deleteCompetency?: {
    readonly __typename: "DeleteCompetencyMutation";
    readonly ok?: boolean | null;
  } | null;
};

export type DeleteSlackNotificationForChannelMutationMutationVariables = Exact<{
  notificationId: Scalars["Int"]["input"];
}>;

export type DeleteSlackNotificationForChannelMutationMutation = {
  readonly __typename: "Mutation";
  readonly deleteSlackNotificationForChannel?: {
    readonly __typename: "DeleteSlackNotificationForChannelMutation";
    readonly organization?: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
      readonly slackNotifications?: {
        readonly __typename: "SlackNotificationForChannelNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "SlackNotificationForChannelNodeEdge";
          readonly node?: {
            readonly __typename: "SlackNotificationForChannelNode";
            readonly id: number;
            readonly channel: string;
            readonly recognitions: boolean;
            readonly goalCheckins: boolean;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type DeleteTeamMutationMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
}>;

export type DeleteTeamMutationMutation = {
  readonly __typename: "Mutation";
  readonly deleteTeam?: {
    readonly __typename: "DeleteTeamMutation";
    readonly team?: {
      readonly __typename: "TeamNode";
      readonly id: number;
    } | null;
  } | null;
};

export type DeleteTeamsNotificationForChannelMutationMutationVariables = Exact<{
  notificationId: Scalars["Int"]["input"];
}>;

export type DeleteTeamsNotificationForChannelMutationMutation = {
  readonly __typename: "Mutation";
  readonly deleteTeamsNotificationForChannel?: {
    readonly __typename: "DeleteTeamsNotificationForChannelMutation";
    readonly organization?: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
      readonly teamsNotifications?: {
        readonly __typename: "TeamsNotificationForChannelNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "TeamsNotificationForChannelNodeEdge";
          readonly node?: {
            readonly __typename: "TeamsNotificationForChannelNode";
            readonly id: number;
            readonly teamId: string;
            readonly teamName: string;
            readonly channelId: string;
            readonly channelName: string;
            readonly recognitions: boolean;
            readonly goalCheckins: boolean;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type ExchangeMergePublicTokenMutationVariables = Exact<{
  publicToken: Scalars["String"]["input"];
  endUserOriginId: Scalars["String"]["input"];
}>;

export type ExchangeMergePublicTokenMutation = {
  readonly __typename: "Mutation";
  readonly exchangeMergePublicToken?: {
    readonly __typename: "ExchangeMergePublicToken";
    readonly success?: boolean | null;
    readonly error?: string | null;
    readonly integration?: {
      readonly __typename: "MergeDevIntegrationNode";
      readonly id: number;
      readonly category: string;
      readonly integrationName?: string | null;
      readonly createdAt: string;
    } | null;
  } | null;
};

export type GetAvailableMergeIntegrationsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetAvailableMergeIntegrationsQuery = {
  readonly __typename: "Query";
  readonly availableMergeIntegrations: ReadonlyArray<{
    readonly __typename: "AvailableMergeIntegrationType";
    readonly name: string;
    readonly slug: string;
    readonly image?: string | null;
    readonly squareImage?: string | null;
    readonly color?: string | null;
    readonly categories: ReadonlyArray<string | null>;
  } | null>;
};

export type GetMeetingsByManagerReportQueryQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  personId?: InputMaybe<Scalars["Int"]["input"]>;
  templateId?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetMeetingsByManagerReportQueryQuery = {
  readonly __typename: "Query";
  readonly meetingsByManagerReport?: {
    readonly __typename: "MeetingsByManagerReportConnection";
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly endCursor?: string | null;
      readonly hasNextPage: boolean;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "MeetingsByManagerReportEdge";
      readonly node?: {
        readonly __typename: "MeetingsByManagerReportNode";
        readonly id?: number | null;
        readonly reports?: {
          readonly __typename: "UserReportConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "UserReportEdge";
            readonly node?: {
              readonly __typename: "UserReportNode";
              readonly user?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly email: string;
                readonly avatar?: string | null;
              } | null;
              readonly lastMeeting?: {
                readonly __typename: "MeetingInfoNode";
                readonly id?: number | null;
                readonly startDatetime?: string | null;
                readonly meeting?: {
                  readonly __typename: "MeetingNode";
                  readonly id: number;
                  readonly meetingGroupId: number;
                  readonly title?: string | null;
                } | null;
              } | null;
              readonly nextMeeting?: {
                readonly __typename: "MeetingInfoNode";
                readonly id?: number | null;
                readonly startDatetime?: string | null;
                readonly meeting?: {
                  readonly __typename: "MeetingNode";
                  readonly id: number;
                  readonly meetingGroupId: number;
                  readonly title?: string | null;
                } | null;
              } | null;
            } | null;
          } | null>;
        } | null;
        readonly manager?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
          readonly email: string;
          readonly managers: {
            readonly __typename: "UserNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "UserNodeEdge";
              readonly node?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
                readonly email: string;
              } | null;
            } | null>;
          };
        } | null;
      } | null;
    } | null>;
  } | null;
  readonly users: {
    readonly __typename: "UserNodeConnection";
    readonly totalCount: number;
  };
};

export type GetMergeDevIntegrationsQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
}>;

export type GetMergeDevIntegrationsQuery = {
  readonly __typename: "Query";
  readonly mergeDevIntegrations: ReadonlyArray<{
    readonly __typename: "MergeDevIntegrationNode";
    readonly id: number;
    readonly category: string;
    readonly integrationName?: string | null;
    readonly integrationDisplayName: string;
    readonly iconUrl: string;
    readonly fullImageUrl: string;
    readonly createdAt: string;
    readonly updatedAt: string;
  } | null>;
};

export type OrganizationCareerTrackFragmentFragment = {
  readonly __typename: "CareerTrackNode";
  readonly id: number;
  readonly title: string;
  readonly team?: {
    readonly __typename: "TeamNode";
    readonly id: number;
    readonly title: string;
  } | null;
  readonly roles: {
    readonly __typename: "CareerTrackRoleNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "CareerTrackRoleNodeEdge";
      readonly node?: {
        readonly __typename: "CareerTrackRoleNode";
        readonly id: number;
        readonly title: string;
        readonly level: number;
        readonly roleType: CareerTrackRoleType;
        readonly assignedUsers: {
          readonly __typename: "UserNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "UserNodeEdge";
            readonly node?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly email: string;
              readonly avatar?: string | null;
            } | null;
          } | null>;
        };
        readonly responsibilities: {
          readonly __typename: "CareerTrackRoleResponsibilityNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "CareerTrackRoleResponsibilityNodeEdge";
            readonly node?: {
              readonly __typename: "CareerTrackRoleResponsibilityNode";
              readonly id: number;
              readonly content: any;
            } | null;
          } | null>;
        };
        readonly competencies: {
          readonly __typename: "CompetencyConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "CompetencyEdge";
            readonly node?: {
              readonly __typename: "CompetencyNode";
              readonly id: number;
              readonly title: string;
              readonly appliesTo: CompetencyAppliesTo;
              readonly criteriaUniqueness: CompetencyCriteriaUniqueness;
              readonly criteria: {
                readonly __typename: "CompetencyCriteriaConnection";
                readonly edges: ReadonlyArray<{
                  readonly __typename: "CompetencyCriteriaEdge";
                  readonly node?: {
                    readonly __typename: "CompetencyCriteriaNode";
                    readonly id: number;
                    readonly content: any;
                    readonly level: number;
                  } | null;
                } | null>;
              };
            } | null;
          } | null>;
        };
      } | null;
    } | null>;
  };
};

export type GetOrganizationCareerTrackQueryVariables = Exact<{
  careerTrackId: Scalars["Int"]["input"];
}>;

export type GetOrganizationCareerTrackQuery = {
  readonly __typename: "Query";
  readonly careerTrack?: {
    readonly __typename: "CareerTrackNode";
    readonly id: number;
    readonly title: string;
    readonly team?: {
      readonly __typename: "TeamNode";
      readonly id: number;
      readonly title: string;
    } | null;
    readonly roles: {
      readonly __typename: "CareerTrackRoleNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "CareerTrackRoleNodeEdge";
        readonly node?: {
          readonly __typename: "CareerTrackRoleNode";
          readonly id: number;
          readonly title: string;
          readonly level: number;
          readonly roleType: CareerTrackRoleType;
          readonly assignedUsers: {
            readonly __typename: "UserNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "UserNodeEdge";
              readonly node?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly email: string;
                readonly avatar?: string | null;
              } | null;
            } | null>;
          };
          readonly responsibilities: {
            readonly __typename: "CareerTrackRoleResponsibilityNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "CareerTrackRoleResponsibilityNodeEdge";
              readonly node?: {
                readonly __typename: "CareerTrackRoleResponsibilityNode";
                readonly id: number;
                readonly content: any;
              } | null;
            } | null>;
          };
          readonly competencies: {
            readonly __typename: "CompetencyConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "CompetencyEdge";
              readonly node?: {
                readonly __typename: "CompetencyNode";
                readonly id: number;
                readonly title: string;
                readonly appliesTo: CompetencyAppliesTo;
                readonly criteriaUniqueness: CompetencyCriteriaUniqueness;
                readonly criteria: {
                  readonly __typename: "CompetencyCriteriaConnection";
                  readonly edges: ReadonlyArray<{
                    readonly __typename: "CompetencyCriteriaEdge";
                    readonly node?: {
                      readonly __typename: "CompetencyCriteriaNode";
                      readonly id: number;
                      readonly content: any;
                      readonly level: number;
                    } | null;
                  } | null>;
                };
              } | null;
            } | null>;
          };
        } | null;
      } | null>;
    };
  } | null;
};

export type GetOrganizationCareerTrackRolesQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
}>;

export type GetOrganizationCareerTrackRolesQuery = {
  readonly __typename: "Query";
  readonly careerRoles: {
    readonly __typename: "CareerTrackRoleNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "CareerTrackRoleNodeEdge";
      readonly node?: {
        readonly __typename: "CareerTrackRoleNode";
        readonly id: number;
        readonly title: string;
        readonly level: number;
        readonly careerTrack: {
          readonly __typename: "CareerTrackNode";
          readonly id: number;
          readonly title: string;
        };
      } | null;
    } | null>;
  };
};

export type GetOrganizationCareerTracksQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  teamId?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetOrganizationCareerTracksQuery = {
  readonly __typename: "Query";
  readonly careerTracks: {
    readonly __typename: "CareerTrackNodeConnection";
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly hasNextPage: boolean;
      readonly endCursor?: string | null;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "CareerTrackNodeEdge";
      readonly node?: {
        readonly __typename: "CareerTrackNode";
        readonly id: number;
        readonly title: string;
        readonly roles: {
          readonly __typename: "CareerTrackRoleNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "CareerTrackRoleNodeEdge";
            readonly node?: {
              readonly __typename: "CareerTrackRoleNode";
              readonly id: number;
              readonly title: string;
              readonly level: number;
              readonly roleType: CareerTrackRoleType;
            } | null;
          } | null>;
        };
      } | null;
    } | null>;
  };
};

export type OrganizationCompetencyCriteriaFragment = {
  readonly __typename: "CompetencyNode";
  readonly criteria: {
    readonly __typename: "CompetencyCriteriaConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "CompetencyCriteriaEdge";
      readonly node?: {
        readonly __typename: "CompetencyCriteriaNode";
        readonly id: number;
        readonly content: any;
        readonly level: number;
      } | null;
    } | null>;
  };
};

export type OrganizationCompetencyFragment = {
  readonly __typename: "CompetencyNode";
  readonly id: number;
  readonly title: string;
  readonly description: any;
  readonly appliesTo: CompetencyAppliesTo;
  readonly appliesToManagementRoles: boolean;
  readonly appliesToIcRoles: boolean;
  readonly criteriaUniqueness: CompetencyCriteriaUniqueness;
  readonly appliesToTeams: {
    readonly __typename: "TeamNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "TeamNodeEdge";
      readonly node?: {
        readonly __typename: "TeamNode";
        readonly id: number;
        readonly title: string;
      } | null;
    } | null>;
  };
  readonly appliesToCareerTracks: {
    readonly __typename: "CareerTrackNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "CareerTrackNodeEdge";
      readonly node?: {
        readonly __typename: "CareerTrackNode";
        readonly id: number;
      } | null;
    } | null>;
  };
  readonly criteria: {
    readonly __typename: "CompetencyCriteriaConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "CompetencyCriteriaEdge";
      readonly node?: {
        readonly __typename: "CompetencyCriteriaNode";
        readonly id: number;
        readonly content: any;
        readonly level: number;
      } | null;
    } | null>;
  };
};

export type GetOrganizationCompetenciesQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
}>;

export type GetOrganizationCompetenciesQuery = {
  readonly __typename: "Query";
  readonly competencies: {
    readonly __typename: "CompetencyConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "CompetencyEdge";
      readonly node?: {
        readonly __typename: "CompetencyNode";
        readonly id: number;
        readonly title: string;
        readonly description: any;
        readonly appliesTo: CompetencyAppliesTo;
        readonly appliesToManagementRoles: boolean;
        readonly appliesToIcRoles: boolean;
        readonly criteriaUniqueness: CompetencyCriteriaUniqueness;
        readonly appliesToTeams: {
          readonly __typename: "TeamNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "TeamNodeEdge";
            readonly node?: {
              readonly __typename: "TeamNode";
              readonly id: number;
              readonly title: string;
            } | null;
          } | null>;
        };
        readonly appliesToCareerTracks: {
          readonly __typename: "CareerTrackNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "CareerTrackNodeEdge";
            readonly node?: {
              readonly __typename: "CareerTrackNode";
              readonly id: number;
            } | null;
          } | null>;
        };
        readonly criteria: {
          readonly __typename: "CompetencyCriteriaConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "CompetencyCriteriaEdge";
            readonly node?: {
              readonly __typename: "CompetencyCriteriaNode";
              readonly id: number;
              readonly content: any;
              readonly level: number;
            } | null;
          } | null>;
        };
      } | null;
    } | null>;
  };
};

export type GetOrgWideCompetencyQueryVariables = Exact<{
  competencyId: Scalars["Int"]["input"];
}>;

export type GetOrgWideCompetencyQuery = {
  readonly __typename: "Query";
  readonly competency?: {
    readonly __typename: "CompetencyNode";
    readonly id: number;
    readonly title: string;
    readonly description: any;
    readonly appliesTo: CompetencyAppliesTo;
    readonly appliesToManagementRoles: boolean;
    readonly appliesToIcRoles: boolean;
    readonly criteriaUniqueness: CompetencyCriteriaUniqueness;
    readonly appliesToTeams: {
      readonly __typename: "TeamNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "TeamNodeEdge";
        readonly node?: {
          readonly __typename: "TeamNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null>;
    };
    readonly appliesToCareerTracks: {
      readonly __typename: "CareerTrackNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "CareerTrackNodeEdge";
        readonly node?: {
          readonly __typename: "CareerTrackNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null>;
    };
    readonly criteria: {
      readonly __typename: "CompetencyCriteriaConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "CompetencyCriteriaEdge";
        readonly node?: {
          readonly __typename: "CompetencyCriteriaNode";
          readonly id: number;
          readonly content: any;
          readonly level: number;
        } | null;
      } | null>;
    };
  } | null;
};

export type GetOrganizationCoreValuesQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
}>;

export type GetOrganizationCoreValuesQuery = {
  readonly __typename: "Query";
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
    readonly coreValues?: {
      readonly __typename: "RecognitionCoreValueNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "RecognitionCoreValueNodeEdge";
        readonly node?: {
          readonly __typename: "RecognitionCoreValueNode";
          readonly id: number;
          readonly title: string;
          readonly description: string;
          readonly emoji?: string | null;
          readonly image?: string | null;
          readonly status?: RecognitionCoreValueStatus | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetOrganizationIntegrationsQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
}>;

export type GetOrganizationIntegrationsQuery = {
  readonly __typename: "Query";
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
    readonly integrations: {
      readonly __typename: "OrganizationIntegrationNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "OrganizationIntegrationNodeEdge";
        readonly node?: {
          readonly __typename: "OrganizationIntegrationNode";
          readonly id: number;
          readonly integrationType: IntegrationTypes;
          readonly created: string;
          readonly creator: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
          };
          readonly socialAuth: {
            readonly __typename: "UserSocialAuthNode";
            readonly id: number;
            readonly extraData: any;
          };
        } | null;
      } | null>;
    };
  } | null;
};

export type GetOrganizationMemberQueryQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  userId: Scalars["Int"]["input"];
}>;

export type GetOrganizationMemberQueryQuery = {
  readonly __typename: "Query";
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
    readonly members: {
      readonly __typename: "UserMemberNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserMemberNodeEdge";
        readonly node?: {
          readonly __typename: "UserMemberNode";
          readonly id: number;
          readonly position?: string | null;
          readonly role?: OrganizationRole | null;
          readonly startDate?: string | null;
          readonly employeeId?: string | null;
          readonly jobLevel?: string | null;
          readonly location?: string | null;
          readonly membershipStatus?: AccountToOrganizationMembershipStatus | null;
          readonly user?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly firstName: string;
            readonly lastName: string;
            readonly avatar?: string | null;
            readonly email: string;
            readonly status?: UserStatus | null;
            readonly lastSeenStr?: UserLastSeen | null;
            readonly primaryManager?: {
              readonly __typename: "UserNode";
              readonly id: number;
            } | null;
            readonly managers: {
              readonly __typename: "UserNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "UserNodeEdge";
                readonly node?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly name: string;
                  readonly avatar?: string | null;
                } | null;
              } | null>;
            };
            readonly teams?: {
              readonly __typename: "TeamNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "TeamNodeEdge";
                readonly node?: {
                  readonly __typename: "TeamNode";
                  readonly id: number;
                  readonly title: string;
                } | null;
              } | null>;
            } | null;
            readonly currentRoles: ReadonlyArray<{
              readonly __typename: "CareerTrackRoleNode";
              readonly id: number;
              readonly title: string;
              readonly level: number;
              readonly careerTrack: {
                readonly __typename: "CareerTrackNode";
                readonly id: number;
                readonly title: string;
              };
            }>;
          } | null;
        } | null;
      } | null>;
    };
  } | null;
};

export type OrganizationMemberFragment = {
  readonly __typename: "UserMemberNode";
  readonly id: number;
  readonly position?: string | null;
  readonly role?: OrganizationRole | null;
  readonly startDate?: string | null;
  readonly employeeId?: string | null;
  readonly jobLevel?: string | null;
  readonly location?: string | null;
  readonly membershipStatus?: AccountToOrganizationMembershipStatus | null;
  readonly user?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly avatar?: string | null;
    readonly email: string;
    readonly status?: UserStatus | null;
    readonly lastSeenStr?: UserLastSeen | null;
    readonly primaryManager?: {
      readonly __typename: "UserNode";
      readonly id: number;
    } | null;
    readonly managers: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null>;
    };
    readonly teams?: {
      readonly __typename: "TeamNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "TeamNodeEdge";
        readonly node?: {
          readonly __typename: "TeamNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null>;
    } | null;
    readonly currentRoles: ReadonlyArray<{
      readonly __typename: "CareerTrackRoleNode";
      readonly id: number;
      readonly title: string;
      readonly level: number;
      readonly careerTrack: {
        readonly __typename: "CareerTrackNode";
        readonly id: number;
        readonly title: string;
      };
    }>;
  } | null;
};

export type GetOrganizationMembersQueryQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
  managerId?: InputMaybe<Scalars["Int"]["input"]>;
  showAdminsOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  teamId?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  membershipStatus?: InputMaybe<AccountToOrganizationMembershipStatus>;
}>;

export type GetOrganizationMembersQueryQuery = {
  readonly __typename: "Query";
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
    readonly members: {
      readonly __typename: "UserMemberNodeConnection";
      readonly totalCount: number;
      readonly pageInfo: {
        readonly __typename: "PageInfo";
        readonly endCursor?: string | null;
        readonly hasNextPage: boolean;
      };
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserMemberNodeEdge";
        readonly node?: {
          readonly __typename: "UserMemberNode";
          readonly id: number;
          readonly position?: string | null;
          readonly role?: OrganizationRole | null;
          readonly startDate?: string | null;
          readonly employeeId?: string | null;
          readonly jobLevel?: string | null;
          readonly location?: string | null;
          readonly membershipStatus?: AccountToOrganizationMembershipStatus | null;
          readonly user?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly firstName: string;
            readonly lastName: string;
            readonly avatar?: string | null;
            readonly email: string;
            readonly status?: UserStatus | null;
            readonly lastSeenStr?: UserLastSeen | null;
            readonly primaryManager?: {
              readonly __typename: "UserNode";
              readonly id: number;
            } | null;
            readonly managers: {
              readonly __typename: "UserNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "UserNodeEdge";
                readonly node?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly name: string;
                  readonly avatar?: string | null;
                } | null;
              } | null>;
            };
            readonly teams?: {
              readonly __typename: "TeamNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "TeamNodeEdge";
                readonly node?: {
                  readonly __typename: "TeamNode";
                  readonly id: number;
                  readonly title: string;
                } | null;
              } | null>;
            } | null;
            readonly currentRoles: ReadonlyArray<{
              readonly __typename: "CareerTrackRoleNode";
              readonly id: number;
              readonly title: string;
              readonly level: number;
              readonly careerTrack: {
                readonly __typename: "CareerTrackNode";
                readonly id: number;
                readonly title: string;
              };
            }>;
          } | null;
        } | null;
      } | null>;
    };
  } | null;
};

export type GetOrganizationNotificationsQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
}>;

export type GetOrganizationNotificationsQuery = {
  readonly __typename: "Query";
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
    readonly hasSlackConnection?: boolean | null;
    readonly hasTeamsNotificationConnection?: boolean | null;
    readonly slackNotifications?: {
      readonly __typename: "SlackNotificationForChannelNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "SlackNotificationForChannelNodeEdge";
        readonly node?: {
          readonly __typename: "SlackNotificationForChannelNode";
          readonly id: number;
          readonly channel: string;
          readonly recognitions: boolean;
          readonly goalCheckins: boolean;
        } | null;
      } | null>;
    } | null;
    readonly publicSlackChannels?: {
      readonly __typename: "SlackChannelConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "SlackChannelEdge";
        readonly node?: {
          readonly __typename: "SlackChannelNode";
          readonly id?: string | null;
          readonly name?: string | null;
        } | null;
      } | null>;
    } | null;
    readonly teamsNotifications?: {
      readonly __typename: "TeamsNotificationForChannelNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "TeamsNotificationForChannelNodeEdge";
        readonly node?: {
          readonly __typename: "TeamsNotificationForChannelNode";
          readonly id: number;
          readonly teamId: string;
          readonly teamName: string;
          readonly channelId: string;
          readonly channelName: string;
          readonly recognitions: boolean;
          readonly goalCheckins: boolean;
        } | null;
      } | null>;
    } | null;
    readonly availableTeamsNotificationChannels: ReadonlyArray<{
      readonly __typename: "AvailableTeamsNotificationChannel";
      readonly teamId: string;
      readonly teamName: string;
      readonly channelId: string;
      readonly channelName: string;
    } | null>;
  } | null;
};

export type OrgSettingsOrganizationFragmentFragment = {
  readonly __typename: "OrganizationNode";
  readonly id: number;
  readonly name: string;
  readonly pricingTier?: PricingTier | null;
  readonly pricingTierValidUntil?: string | null;
  readonly membershipSetting?: OrganizationMembershipSetting | null;
  readonly domains?: ReadonlyArray<string | null> | null;
  readonly goalLabel: string;
  readonly personal?: boolean | null;
  readonly keyResultLabel: string;
  readonly teamLabel: string;
  readonly orgLabel: string;
  readonly recognitionLabel: string;
  readonly oneononeLabel: string;
  readonly reviewLabel: string;
  readonly expectationLabel: string;
  readonly conversationLabel: string;
  readonly developmentLabel: string;
  readonly competencyLabel: string;
  readonly effectivePricingTier?: PricingTier | null;
  readonly defaultGoalState?: GoalState | null;
  readonly hasSlackConnection?: boolean | null;
  readonly hasTeamsInstallation?: boolean | null;
  readonly hasTeamsNotificationConnection?: boolean | null;
  readonly hasTeamsTranscriptConnection?: boolean | null;
  readonly hasGithubInstallation?: boolean | null;
  readonly hasYoutrackIntegration?: boolean | null;
  readonly hasFellowTranscriptSyncConnection?: boolean | null;
  readonly fellowApiDomain?: string | null;
  readonly youtrackUrl?: string | null;
  readonly youtrackLastSync?: string | null;
  readonly quarterStartMonth: number;
  readonly enableMeetingBot: boolean;
  readonly enableMeetingSummarization: boolean;
  readonly transcribeMeetingsByDefault?: boolean | null;
  readonly aiGuidelines: string;
  readonly hasAnthropicApiKey?: boolean | null;
  readonly directorySync?: {
    readonly __typename: "DirectorySyncNode";
    readonly id?: string | null;
    readonly state?: string | null;
    readonly type?: string | null;
    readonly name?: string | null;
    readonly lastSyncStart?: string | null;
    readonly lastSyncEnd?: string | null;
  } | null;
  readonly userMembership?: {
    readonly __typename: "UserMemberNode";
    readonly id: number;
    readonly role?: OrganizationRole | null;
  } | null;
  readonly featureFlags: {
    readonly __typename: "OrganizationFeatureFlags";
    readonly actionItems?: boolean | null;
    readonly feedbacks?: boolean | null;
    readonly goals?: boolean | null;
    readonly recognitions?: boolean | null;
    readonly kpis?: boolean | null;
    readonly explorer?: boolean | null;
    readonly homepageMyConnections?: boolean | null;
    readonly homepageMyConnectionsPeers?: boolean | null;
    readonly workHistory?: boolean | null;
    readonly askAi?: boolean | null;
    readonly meetings?: boolean | null;
    readonly reviewContextGeneration?: boolean | null;
  };
};

export type GetOrganizationSettingsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetOrganizationSettingsQuery = {
  readonly __typename: "Query";
  readonly me?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly organizations: {
      readonly __typename: "OrganizationNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "OrganizationNodeEdge";
        readonly node?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
          readonly name: string;
          readonly pricingTier?: PricingTier | null;
          readonly pricingTierValidUntil?: string | null;
          readonly membershipSetting?: OrganizationMembershipSetting | null;
          readonly domains?: ReadonlyArray<string | null> | null;
          readonly goalLabel: string;
          readonly personal?: boolean | null;
          readonly keyResultLabel: string;
          readonly teamLabel: string;
          readonly orgLabel: string;
          readonly recognitionLabel: string;
          readonly oneononeLabel: string;
          readonly reviewLabel: string;
          readonly expectationLabel: string;
          readonly conversationLabel: string;
          readonly developmentLabel: string;
          readonly competencyLabel: string;
          readonly effectivePricingTier?: PricingTier | null;
          readonly defaultGoalState?: GoalState | null;
          readonly hasSlackConnection?: boolean | null;
          readonly hasTeamsInstallation?: boolean | null;
          readonly hasTeamsNotificationConnection?: boolean | null;
          readonly hasTeamsTranscriptConnection?: boolean | null;
          readonly hasGithubInstallation?: boolean | null;
          readonly hasYoutrackIntegration?: boolean | null;
          readonly hasFellowTranscriptSyncConnection?: boolean | null;
          readonly fellowApiDomain?: string | null;
          readonly youtrackUrl?: string | null;
          readonly youtrackLastSync?: string | null;
          readonly quarterStartMonth: number;
          readonly enableMeetingBot: boolean;
          readonly enableMeetingSummarization: boolean;
          readonly transcribeMeetingsByDefault?: boolean | null;
          readonly aiGuidelines: string;
          readonly hasAnthropicApiKey?: boolean | null;
          readonly directorySync?: {
            readonly __typename: "DirectorySyncNode";
            readonly id?: string | null;
            readonly state?: string | null;
            readonly type?: string | null;
            readonly name?: string | null;
            readonly lastSyncStart?: string | null;
            readonly lastSyncEnd?: string | null;
          } | null;
          readonly userMembership?: {
            readonly __typename: "UserMemberNode";
            readonly id: number;
            readonly role?: OrganizationRole | null;
          } | null;
          readonly featureFlags: {
            readonly __typename: "OrganizationFeatureFlags";
            readonly actionItems?: boolean | null;
            readonly feedbacks?: boolean | null;
            readonly goals?: boolean | null;
            readonly recognitions?: boolean | null;
            readonly kpis?: boolean | null;
            readonly explorer?: boolean | null;
            readonly homepageMyConnections?: boolean | null;
            readonly homepageMyConnectionsPeers?: boolean | null;
            readonly workHistory?: boolean | null;
            readonly askAi?: boolean | null;
            readonly meetings?: boolean | null;
            readonly reviewContextGeneration?: boolean | null;
          };
        } | null;
      } | null>;
    };
  } | null;
};

export type GetOrganizationTalentIndicatorsQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
}>;

export type GetOrganizationTalentIndicatorsQuery = {
  readonly __typename: "Query";
  readonly talentIndicators: {
    readonly __typename: "TalentIndicatorNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "TalentIndicatorNodeEdge";
      readonly node?: {
        readonly __typename: "TalentIndicatorNode";
        readonly id: number;
        readonly talentIndicatorType: TalentIndicatorType;
        readonly name: string;
        readonly customName?: string | null;
        readonly questionTitle?: string | null;
        readonly description: any;
        readonly scaleStartsAt: number;
        readonly scale: number;
        readonly labels: ReadonlyArray<string | null>;
        readonly labelDescriptions: ReadonlyArray<string | null>;
        readonly isManagerIndicator: boolean;
        readonly hasLockedLabels: boolean;
        readonly hasAssessmentQuestions: boolean;
      } | null;
    } | null>;
  };
};

export type OrgSettingOrgTeamFragment = {
  readonly __typename: "TeamNode";
  readonly id: number;
  readonly title: string;
  readonly members?: {
    readonly __typename: "UserNodeConnection";
    readonly totalCount: number;
    readonly edges: ReadonlyArray<{
      readonly __typename: "UserNodeEdge";
      readonly node?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      } | null;
    } | null>;
  } | null;
};

export type GetOrganizationTeamsQueryQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetOrganizationTeamsQueryQuery = {
  readonly __typename: "Query";
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
    readonly teams?: {
      readonly __typename: "TeamNodeConnection";
      readonly totalCount: number;
      readonly pageInfo: {
        readonly __typename: "PageInfo";
        readonly endCursor?: string | null;
        readonly hasNextPage: boolean;
      };
      readonly edges: ReadonlyArray<{
        readonly __typename: "TeamNodeEdge";
        readonly node?: {
          readonly __typename: "TeamNode";
          readonly id: number;
          readonly title: string;
          readonly members?: {
            readonly __typename: "UserNodeConnection";
            readonly totalCount: number;
            readonly edges: ReadonlyArray<{
              readonly __typename: "UserNodeEdge";
              readonly node?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            } | null>;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetOrganizationTemplatesQueryQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetOrganizationTemplatesQueryQuery = {
  readonly __typename: "Query";
  readonly topicTemplates?: {
    readonly __typename: "TopicTemplateNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "TopicTemplateNodeEdge";
      readonly node?: {
        readonly __typename: "TopicTemplateNode";
        readonly id: number;
        readonly title: string;
      } | null;
    } | null>;
  } | null;
};

export type GetSlackConfigurationQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
}>;

export type GetSlackConfigurationQuery = {
  readonly __typename: "Query";
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
    readonly publicSlackChannels?: {
      readonly __typename: "SlackChannelConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "SlackChannelEdge";
        readonly node?: {
          readonly __typename: "SlackChannelNode";
          readonly id?: string | null;
          readonly name?: string | null;
        } | null;
      } | null>;
    } | null;
    readonly slackIndexingConfiguration?: {
      readonly __typename: "SlackIndexingConfigurationNode";
      readonly indexNewChannelsByDefault: boolean;
      readonly indexMessages: boolean;
      readonly hasDataIngestionPermissions: boolean;
      readonly hasNotificationPermissions: boolean;
      readonly hasBotPermissions: boolean;
      readonly hasBotContextPermissions: boolean;
      readonly channels: ReadonlyArray<{
        readonly __typename: "SlackChannelConfigurationNode";
        readonly id: string;
        readonly name: string;
        readonly shouldIndex: boolean;
        readonly lastIndexedTs?: string | null;
        readonly firstIndexedTs?: string | null;
      } | null>;
    } | null;
  } | null;
};

export type OrganizationTalentIndicatorFragment = {
  readonly __typename: "TalentIndicatorNode";
  readonly id: number;
  readonly talentIndicatorType: TalentIndicatorType;
  readonly name: string;
  readonly customName?: string | null;
  readonly questionTitle?: string | null;
  readonly description: any;
  readonly scaleStartsAt: number;
  readonly scale: number;
  readonly labels: ReadonlyArray<string | null>;
  readonly labelDescriptions: ReadonlyArray<string | null>;
  readonly isManagerIndicator: boolean;
  readonly hasLockedLabels: boolean;
  readonly hasAssessmentQuestions: boolean;
};

export type RelinkMergeDevIntegrationMutationVariables = Exact<{
  integrationId: Scalars["Int"]["input"];
}>;

export type RelinkMergeDevIntegrationMutation = {
  readonly __typename: "Mutation";
  readonly relinkMergeDevIntegration?: {
    readonly __typename: "RelinkMergeDevIntegration";
    readonly success?: boolean | null;
    readonly linkToken?: string | null;
    readonly integrationName?: string | null;
    readonly endUserOriginId?: string | null;
    readonly error?: string | null;
  } | null;
};

export type RemoveGitHubFromOrganizationMutationMutationVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
}>;

export type RemoveGitHubFromOrganizationMutationMutation = {
  readonly __typename: "Mutation";
  readonly removeOrgGithubIntegration?: {
    readonly __typename: "RemoveOrganizationGitHubIntegrationMutation";
    readonly organization?: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
      readonly hasGithubInstallation?: boolean | null;
    } | null;
  } | null;
};

export type RemoveMergeDevIntegrationMutationVariables = Exact<{
  integrationId: Scalars["Int"]["input"];
}>;

export type RemoveMergeDevIntegrationMutation = {
  readonly __typename: "Mutation";
  readonly removeMergeDevIntegration?: {
    readonly __typename: "RemoveMergeDevIntegration";
    readonly success: boolean;
    readonly error?: string | null;
  } | null;
};

export type RemoveSlackIntegrationMutationMutationVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
}>;

export type RemoveSlackIntegrationMutationMutation = {
  readonly __typename: "Mutation";
  readonly removeSlackIntegration?: {
    readonly __typename: "RemoveSlackIntegrationMutation";
    readonly organization?: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
      readonly hasSlackConnection?: boolean | null;
    } | null;
  } | null;
};

export type RemoveTeamMemberMutationMutationVariables = Exact<{
  teamId: Scalars["Int"]["input"];
  userId: Scalars["Int"]["input"];
}>;

export type RemoveTeamMemberMutationMutation = {
  readonly __typename: "Mutation";
  readonly removeTeamMember?: {
    readonly __typename: "RemoveTeamMemberMutation";
    readonly user?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly teams?: {
        readonly __typename: "TeamNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "TeamNodeEdge";
          readonly node?: {
            readonly __typename: "TeamNode";
            readonly id: number;
            readonly title: string;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type RemoveTeamsIntegrationMutationMutationVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
}>;

export type RemoveTeamsIntegrationMutationMutation = {
  readonly __typename: "Mutation";
  readonly removeTeamsIntegration?: {
    readonly __typename: "RemoveTeamsIntegrationMutation";
    readonly organization?: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
      readonly hasTeamsTranscriptConnection?: boolean | null;
      readonly hasTeamsInstallation?: boolean | null;
    } | null;
  } | null;
};

export type RemoveUserFromOrganizationMutationMutationVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  userToRemoveId: Scalars["Int"]["input"];
}>;

export type RemoveUserFromOrganizationMutationMutation = {
  readonly __typename: "Mutation";
  readonly removeUserFromOrganization?: {
    readonly __typename: "RemoveUserFromOrganizationMutation";
    readonly org?: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
    } | null;
  } | null;
};

export type RemoveYouTrackIntegrationMutationMutationVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
}>;

export type RemoveYouTrackIntegrationMutationMutation = {
  readonly __typename: "Mutation";
  readonly removeYoutrackIntegration?: {
    readonly __typename: "RemoveYouTrackIntegrationMutation";
    readonly organization?: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
      readonly hasYoutrackIntegration?: boolean | null;
      readonly youtrackUrl?: string | null;
    } | null;
  } | null;
};

export type SaveFellowIntegrationMutationVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  fellowApiKey?: InputMaybe<Scalars["String"]["input"]>;
  fellowApiDomain?: InputMaybe<Scalars["String"]["input"]>;
  fellowTranscriptSyncEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type SaveFellowIntegrationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateOrganization?: {
    readonly __typename: "CreateOrUpdateOrganizationMutation";
    readonly organization?: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
      readonly hasFellowTranscriptSyncConnection?: boolean | null;
      readonly fellowApiDomain?: string | null;
    } | null;
  } | null;
};

export type SendNudgeEmailMutationMutationVariables = Exact<{
  managerId: Scalars["Int"]["input"];
  reportId: Scalars["Int"]["input"];
  topicTemplateId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type SendNudgeEmailMutationMutation = {
  readonly __typename: "Mutation";
  readonly email1on1Nudge?: {
    readonly __typename: "Email1on1NudgeMutation";
    readonly report?: {
      readonly __typename: "UserNode";
      readonly id: number;
    } | null;
    readonly manager?: {
      readonly __typename: "UserNode";
      readonly id: number;
    } | null;
  } | null;
};

export type SyncWithHrisMutationMutationVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
}>;

export type SyncWithHrisMutationMutation = {
  readonly __typename: "Mutation";
  readonly syncWithHris?: {
    readonly __typename: "SyncWithHRISMutation";
    readonly organization?: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
      readonly directorySync?: {
        readonly __typename: "DirectorySyncNode";
        readonly id?: string | null;
        readonly state?: string | null;
        readonly type?: string | null;
        readonly name?: string | null;
        readonly lastSyncStart?: string | null;
        readonly lastSyncEnd?: string | null;
      } | null;
    } | null;
  } | null;
};

export type UnlinkIntegrationFromOrganizationMutationMutationVariables = Exact<{
  organizationIntegrationId: Scalars["Int"]["input"];
}>;

export type UnlinkIntegrationFromOrganizationMutationMutation = {
  readonly __typename: "Mutation";
  readonly unlinkIntegrationFromOrganization?: {
    readonly __typename: "UnlinkIntegrationFromOrganizationMutation";
    readonly organization?: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
      readonly integrations: {
        readonly __typename: "OrganizationIntegrationNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "OrganizationIntegrationNodeEdge";
          readonly node?: {
            readonly __typename: "OrganizationIntegrationNode";
            readonly id: number;
            readonly integrationType: IntegrationTypes;
            readonly created: string;
            readonly creator: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
            };
          } | null;
        } | null>;
      };
    } | null;
  } | null;
};

export type UpdateMemberMutationMutationVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  role?: InputMaybe<OrganizationRole>;
  userId: Scalars["Int"]["input"];
  startDate?: InputMaybe<Scalars["String"]["input"]>;
  employeeId?: InputMaybe<Scalars["String"]["input"]>;
  position?: InputMaybe<Scalars["String"]["input"]>;
  jobLevel?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  membershipStatus?: InputMaybe<AccountToOrganizationMembershipStatus>;
}>;

export type UpdateMemberMutationMutation = {
  readonly __typename: "Mutation";
  readonly updateOrganizationMembership?: {
    readonly __typename: "UpdateOrganizationMembershipMutation";
    readonly member?: {
      readonly __typename: "UserMemberNode";
      readonly id: number;
      readonly position?: string | null;
      readonly role?: OrganizationRole | null;
      readonly startDate?: string | null;
      readonly employeeId?: string | null;
      readonly jobLevel?: string | null;
      readonly location?: string | null;
      readonly membershipStatus?: AccountToOrganizationMembershipStatus | null;
      readonly user?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly firstName: string;
        readonly lastName: string;
        readonly avatar?: string | null;
        readonly email: string;
        readonly status?: UserStatus | null;
        readonly lastSeenStr?: UserLastSeen | null;
        readonly primaryManager?: {
          readonly __typename: "UserNode";
          readonly id: number;
        } | null;
        readonly managers: {
          readonly __typename: "UserNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "UserNodeEdge";
            readonly node?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          } | null>;
        };
        readonly teams?: {
          readonly __typename: "TeamNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "TeamNodeEdge";
            readonly node?: {
              readonly __typename: "TeamNode";
              readonly id: number;
              readonly title: string;
            } | null;
          } | null>;
        } | null;
        readonly currentRoles: ReadonlyArray<{
          readonly __typename: "CareerTrackRoleNode";
          readonly id: number;
          readonly title: string;
          readonly level: number;
          readonly careerTrack: {
            readonly __typename: "CareerTrackNode";
            readonly id: number;
            readonly title: string;
          };
        }>;
      } | null;
    } | null;
  } | null;
};

export type SaveOrgTalentIndicatorMutationVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  talentIndicatorType: TalentIndicatorType;
  customName?: InputMaybe<Scalars["String"]["input"]>;
  questionTitle?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  scaleStartsAt?: InputMaybe<Scalars["Int"]["input"]>;
  scale?: InputMaybe<Scalars["Int"]["input"]>;
  labels?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
  labelDescriptions?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
}>;

export type SaveOrgTalentIndicatorMutation = {
  readonly __typename: "Mutation";
  readonly updateTalentIndicator?: {
    readonly __typename: "UpdateTalentIndicatorMutation";
    readonly talentIndicator: {
      readonly __typename: "TalentIndicatorNode";
      readonly id: number;
      readonly talentIndicatorType: TalentIndicatorType;
      readonly name: string;
      readonly customName?: string | null;
      readonly questionTitle?: string | null;
      readonly description: any;
      readonly scaleStartsAt: number;
      readonly scale: number;
      readonly labels: ReadonlyArray<string | null>;
      readonly labelDescriptions: ReadonlyArray<string | null>;
      readonly isManagerIndicator: boolean;
      readonly hasLockedLabels: boolean;
    };
  } | null;
};

export type CreateOrUpdateOrganizationSettingsMutationVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  goalLabel?: InputMaybe<Scalars["String"]["input"]>;
  orgLabel?: InputMaybe<Scalars["String"]["input"]>;
  recognitionLabel?: InputMaybe<Scalars["String"]["input"]>;
  teamLabel?: InputMaybe<Scalars["String"]["input"]>;
  reviewLabel?: InputMaybe<Scalars["String"]["input"]>;
  expectationLabel?: InputMaybe<Scalars["String"]["input"]>;
  conversationLabel?: InputMaybe<Scalars["String"]["input"]>;
  developmentLabel?: InputMaybe<Scalars["String"]["input"]>;
  competencyLabel?: InputMaybe<Scalars["String"]["input"]>;
  membershipSetting?: InputMaybe<OrganizationMembershipSetting>;
  enableMeetingSummarization?: InputMaybe<Scalars["Boolean"]["input"]>;
  transcribeMeetingsByDefault?: InputMaybe<Scalars["Boolean"]["input"]>;
  defaultGoalState?: InputMaybe<GoalState>;
  enableMeetingBot?: InputMaybe<Scalars["Boolean"]["input"]>;
  quarterStartMonth?: InputMaybe<Scalars["Int"]["input"]>;
  featureFlags?: InputMaybe<OrganizationFeatureFlagsInput>;
  aiGuidelines?: InputMaybe<Scalars["String"]["input"]>;
  anthropicApiKey?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type CreateOrUpdateOrganizationSettingsMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateOrganization?: {
    readonly __typename: "CreateOrUpdateOrganizationMutation";
    readonly organization?: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
      readonly name: string;
      readonly pricingTier?: PricingTier | null;
      readonly pricingTierValidUntil?: string | null;
      readonly membershipSetting?: OrganizationMembershipSetting | null;
      readonly domains?: ReadonlyArray<string | null> | null;
      readonly goalLabel: string;
      readonly personal?: boolean | null;
      readonly keyResultLabel: string;
      readonly teamLabel: string;
      readonly orgLabel: string;
      readonly recognitionLabel: string;
      readonly oneononeLabel: string;
      readonly reviewLabel: string;
      readonly expectationLabel: string;
      readonly conversationLabel: string;
      readonly developmentLabel: string;
      readonly competencyLabel: string;
      readonly effectivePricingTier?: PricingTier | null;
      readonly defaultGoalState?: GoalState | null;
      readonly hasSlackConnection?: boolean | null;
      readonly hasTeamsInstallation?: boolean | null;
      readonly hasTeamsNotificationConnection?: boolean | null;
      readonly hasTeamsTranscriptConnection?: boolean | null;
      readonly hasGithubInstallation?: boolean | null;
      readonly hasYoutrackIntegration?: boolean | null;
      readonly hasFellowTranscriptSyncConnection?: boolean | null;
      readonly fellowApiDomain?: string | null;
      readonly youtrackUrl?: string | null;
      readonly youtrackLastSync?: string | null;
      readonly quarterStartMonth: number;
      readonly enableMeetingBot: boolean;
      readonly enableMeetingSummarization: boolean;
      readonly transcribeMeetingsByDefault?: boolean | null;
      readonly aiGuidelines: string;
      readonly hasAnthropicApiKey?: boolean | null;
      readonly directorySync?: {
        readonly __typename: "DirectorySyncNode";
        readonly id?: string | null;
        readonly state?: string | null;
        readonly type?: string | null;
        readonly name?: string | null;
        readonly lastSyncStart?: string | null;
        readonly lastSyncEnd?: string | null;
      } | null;
      readonly userMembership?: {
        readonly __typename: "UserMemberNode";
        readonly id: number;
        readonly role?: OrganizationRole | null;
      } | null;
      readonly featureFlags: {
        readonly __typename: "OrganizationFeatureFlags";
        readonly actionItems?: boolean | null;
        readonly feedbacks?: boolean | null;
        readonly goals?: boolean | null;
        readonly recognitions?: boolean | null;
        readonly kpis?: boolean | null;
        readonly explorer?: boolean | null;
        readonly homepageMyConnections?: boolean | null;
        readonly homepageMyConnectionsPeers?: boolean | null;
        readonly workHistory?: boolean | null;
        readonly askAi?: boolean | null;
        readonly meetings?: boolean | null;
        readonly reviewContextGeneration?: boolean | null;
      };
    } | null;
  } | null;
};

export type UpdateSlackOrgSettingsMutationMutationVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  indexMessages?: InputMaybe<Scalars["Boolean"]["input"]>;
  indexNewChannelsByDefault?: InputMaybe<Scalars["Boolean"]["input"]>;
  channelConfigurations?: InputMaybe<
    | ReadonlyArray<SlackChannelConfigurationInput>
    | SlackChannelConfigurationInput
  >;
}>;

export type UpdateSlackOrgSettingsMutationMutation = {
  readonly __typename: "Mutation";
  readonly updateSlackOrgSettings?: {
    readonly __typename: "UpdateSlackOrgSettingsMutation";
    readonly organization?: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
      readonly slackIndexingConfiguration?: {
        readonly __typename: "SlackIndexingConfigurationNode";
        readonly indexNewChannelsByDefault: boolean;
        readonly indexMessages: boolean;
        readonly channels: ReadonlyArray<{
          readonly __typename: "SlackChannelConfigurationNode";
          readonly id: string;
          readonly name: string;
          readonly shouldIndex: boolean;
        } | null>;
      } | null;
      readonly publicSlackChannels?: {
        readonly __typename: "SlackChannelConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "SlackChannelEdge";
          readonly node?: {
            readonly __typename: "SlackChannelNode";
            readonly id?: string | null;
            readonly name?: string | null;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type UpdateTeamMutationMutationVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  memberIds?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  title?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type UpdateTeamMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateTeam?: {
    readonly __typename: "CreateOrUpdateTeamMutation";
    readonly team?: {
      readonly __typename: "TeamNode";
      readonly id: number;
      readonly title: string;
      readonly members?: {
        readonly __typename: "UserNodeConnection";
        readonly totalCount: number;
        readonly edges: ReadonlyArray<{
          readonly __typename: "UserNodeEdge";
          readonly node?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type AverageAssessmentAnswersByProgramFragment = {
  readonly __typename: "AverageAssessmentAnswersByProgramNode";
  readonly averageAnswer: number;
  readonly maxRange: number;
  readonly submittedDatetime: string;
  readonly minRange: number;
  readonly program: {
    readonly __typename: "ComplianceProgramNode";
    readonly id: number;
    readonly title: string;
    readonly assessmentDeliveries: {
      readonly __typename: "AssessmentDeliveryNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AssessmentDeliveryNodeEdge";
        readonly node?: {
          readonly __typename: "AssessmentDeliveryNode";
          readonly id: number;
        } | null;
      } | null>;
    };
  };
};

export type CompetencyGoalFragmentFragment = {
  readonly __typename: "GoalArtifactNode";
  readonly id: number;
  readonly artifactType: ArtifactType;
  readonly startValue: number;
  readonly currentValue: number;
  readonly targetValue: number;
  readonly progress: number;
  readonly progressType: GoalProgressType;
  readonly dueDate?: string | null;
  readonly startDate?: string | null;
  readonly state: GoalState;
  readonly status: GoalStatus;
  readonly scope: GoalScope;
  readonly goalVisibility: GoalVisibility;
  readonly created: string;
  readonly parentGoalId?: number | null;
  readonly ownerCount?: number | null;
  readonly contributorCount?: number | null;
  readonly isStale: boolean;
  readonly title?: string | null;
  readonly updated?: string | null;
  readonly competencyRelations: {
    readonly __typename: "GoalArtifactToCompetencyM2MNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "GoalArtifactToCompetencyM2MNodeEdge";
      readonly node?: {
        readonly __typename: "GoalArtifactToCompetencyM2MNode";
        readonly id: number;
        readonly competencyId: number;
        readonly roleId?: number | null;
      } | null;
    } | null>;
  };
  readonly firstOwner?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly avatar?: string | null;
    readonly name: string;
  } | null;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canRead: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
};

export type CareerTableRoleFragmentFragment = {
  readonly __typename: "CareerTrackRoleNode";
  readonly id: number;
  readonly competencies: {
    readonly __typename: "CompetencyConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "CompetencyEdge";
      readonly node?: {
        readonly __typename: "CompetencyNode";
        readonly id: number;
        readonly averageAssessmentAnswersByProgram: ReadonlyArray<{
          readonly __typename: "AverageAssessmentAnswersByProgramNode";
          readonly averageAnswer: number;
          readonly maxRange: number;
          readonly submittedDatetime: string;
          readonly minRange: number;
          readonly program: {
            readonly __typename: "ComplianceProgramNode";
            readonly id: number;
            readonly title: string;
            readonly assessmentDeliveries: {
              readonly __typename: "AssessmentDeliveryNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "AssessmentDeliveryNodeEdge";
                readonly node?: {
                  readonly __typename: "AssessmentDeliveryNode";
                  readonly id: number;
                } | null;
              } | null>;
            };
          };
        } | null>;
      } | null;
    } | null>;
  };
  readonly developmentGoals?: {
    readonly __typename: "GoalArtifactConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "GoalArtifactEdge";
      readonly node?: {
        readonly __typename: "GoalArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly startValue: number;
        readonly currentValue: number;
        readonly targetValue: number;
        readonly progress: number;
        readonly progressType: GoalProgressType;
        readonly dueDate?: string | null;
        readonly startDate?: string | null;
        readonly state: GoalState;
        readonly status: GoalStatus;
        readonly scope: GoalScope;
        readonly goalVisibility: GoalVisibility;
        readonly created: string;
        readonly parentGoalId?: number | null;
        readonly ownerCount?: number | null;
        readonly contributorCount?: number | null;
        readonly isStale: boolean;
        readonly title?: string | null;
        readonly updated?: string | null;
        readonly competencyRelations: {
          readonly __typename: "GoalArtifactToCompetencyM2MNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "GoalArtifactToCompetencyM2MNodeEdge";
            readonly node?: {
              readonly __typename: "GoalArtifactToCompetencyM2MNode";
              readonly id: number;
              readonly competencyId: number;
              readonly roleId?: number | null;
            } | null;
          } | null>;
        };
        readonly firstOwner?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly avatar?: string | null;
          readonly name: string;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canRead: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null;
    } | null>;
  } | null;
  readonly responsibilityAverageAssessmentAnswersByProgram: ReadonlyArray<{
    readonly __typename: "AverageAssessmentAnswersByProgramNode";
    readonly averageAnswer: number;
    readonly maxRange: number;
    readonly submittedDatetime: string;
    readonly minRange: number;
    readonly program: {
      readonly __typename: "ComplianceProgramNode";
      readonly id: number;
      readonly title: string;
      readonly assessmentDeliveries: {
        readonly __typename: "AssessmentDeliveryNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentDeliveryNodeEdge";
          readonly node?: {
            readonly __typename: "AssessmentDeliveryNode";
            readonly id: number;
          } | null;
        } | null>;
      };
    };
  } | null>;
};

export type GetCareerRoleRelatedDataQueryQueryVariables = Exact<{
  roleId: Scalars["Int"]["input"];
  profileId: Scalars["Int"]["input"];
}>;

export type GetCareerRoleRelatedDataQueryQuery = {
  readonly __typename: "Query";
  readonly careerRole?: {
    readonly __typename: "CareerTrackRoleNode";
    readonly id: number;
    readonly competencies: {
      readonly __typename: "CompetencyConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "CompetencyEdge";
        readonly node?: {
          readonly __typename: "CompetencyNode";
          readonly id: number;
          readonly averageAssessmentAnswersByProgram: ReadonlyArray<{
            readonly __typename: "AverageAssessmentAnswersByProgramNode";
            readonly averageAnswer: number;
            readonly maxRange: number;
            readonly submittedDatetime: string;
            readonly minRange: number;
            readonly program: {
              readonly __typename: "ComplianceProgramNode";
              readonly id: number;
              readonly title: string;
              readonly assessmentDeliveries: {
                readonly __typename: "AssessmentDeliveryNodeConnection";
                readonly edges: ReadonlyArray<{
                  readonly __typename: "AssessmentDeliveryNodeEdge";
                  readonly node?: {
                    readonly __typename: "AssessmentDeliveryNode";
                    readonly id: number;
                  } | null;
                } | null>;
              };
            };
          } | null>;
        } | null;
      } | null>;
    };
    readonly developmentGoals?: {
      readonly __typename: "GoalArtifactConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "GoalArtifactEdge";
        readonly node?: {
          readonly __typename: "GoalArtifactNode";
          readonly id: number;
          readonly artifactType: ArtifactType;
          readonly startValue: number;
          readonly currentValue: number;
          readonly targetValue: number;
          readonly progress: number;
          readonly progressType: GoalProgressType;
          readonly dueDate?: string | null;
          readonly startDate?: string | null;
          readonly state: GoalState;
          readonly status: GoalStatus;
          readonly scope: GoalScope;
          readonly goalVisibility: GoalVisibility;
          readonly created: string;
          readonly parentGoalId?: number | null;
          readonly ownerCount?: number | null;
          readonly contributorCount?: number | null;
          readonly isStale: boolean;
          readonly title?: string | null;
          readonly updated?: string | null;
          readonly competencyRelations: {
            readonly __typename: "GoalArtifactToCompetencyM2MNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "GoalArtifactToCompetencyM2MNodeEdge";
              readonly node?: {
                readonly __typename: "GoalArtifactToCompetencyM2MNode";
                readonly id: number;
                readonly competencyId: number;
                readonly roleId?: number | null;
              } | null;
            } | null>;
          };
          readonly firstOwner?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly avatar?: string | null;
            readonly name: string;
          } | null;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canUpdate: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canRead: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly creator?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
        } | null;
      } | null>;
    } | null;
    readonly responsibilityAverageAssessmentAnswersByProgram: ReadonlyArray<{
      readonly __typename: "AverageAssessmentAnswersByProgramNode";
      readonly averageAnswer: number;
      readonly maxRange: number;
      readonly submittedDatetime: string;
      readonly minRange: number;
      readonly program: {
        readonly __typename: "ComplianceProgramNode";
        readonly id: number;
        readonly title: string;
        readonly assessmentDeliveries: {
          readonly __typename: "AssessmentDeliveryNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "AssessmentDeliveryNodeEdge";
            readonly node?: {
              readonly __typename: "AssessmentDeliveryNode";
              readonly id: number;
            } | null;
          } | null>;
        };
      };
    } | null>;
  } | null;
};

export type ProfileCareerTabCompetencyFragment = {
  readonly __typename: "CompetencyNode";
  readonly id: number;
  readonly title: string;
  readonly criteria: {
    readonly __typename: "CompetencyCriteriaConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "CompetencyCriteriaEdge";
      readonly node?: {
        readonly __typename: "CompetencyCriteriaNode";
        readonly id: number;
        readonly content: any;
      } | null;
    } | null>;
  };
};

export type ProfileCareerTabResponsibilityFragment = {
  readonly __typename: "CareerTrackRoleResponsibilityNode";
  readonly id: number;
  readonly content: any;
};

export type ProfileCareerTabRoleFragment = {
  readonly __typename: "CareerTrackRoleNode";
  readonly id: number;
  readonly title: string;
  readonly level: number;
  readonly roleType: CareerTrackRoleType;
  readonly competencies: {
    readonly __typename: "CompetencyConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "CompetencyEdge";
      readonly node?: {
        readonly __typename: "CompetencyNode";
        readonly id: number;
        readonly title: string;
        readonly criteria: {
          readonly __typename: "CompetencyCriteriaConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "CompetencyCriteriaEdge";
            readonly node?: {
              readonly __typename: "CompetencyCriteriaNode";
              readonly id: number;
              readonly content: any;
            } | null;
          } | null>;
        };
      } | null;
    } | null>;
  };
  readonly responsibilities: {
    readonly __typename: "CareerTrackRoleResponsibilityNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "CareerTrackRoleResponsibilityNodeEdge";
      readonly node?: {
        readonly __typename: "CareerTrackRoleResponsibilityNode";
        readonly id: number;
        readonly content: any;
      } | null;
    } | null>;
  };
};

export type ProfileCareerTabCareerTrackFragment = {
  readonly __typename: "CareerTrackNode";
  readonly id: number;
  readonly title: string;
  readonly roles: {
    readonly __typename: "CareerTrackRoleNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "CareerTrackRoleNodeEdge";
      readonly node?: {
        readonly __typename: "CareerTrackRoleNode";
        readonly id: number;
        readonly title: string;
        readonly level: number;
        readonly roleType: CareerTrackRoleType;
        readonly competencies: {
          readonly __typename: "CompetencyConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "CompetencyEdge";
            readonly node?: {
              readonly __typename: "CompetencyNode";
              readonly id: number;
              readonly title: string;
              readonly criteria: {
                readonly __typename: "CompetencyCriteriaConnection";
                readonly edges: ReadonlyArray<{
                  readonly __typename: "CompetencyCriteriaEdge";
                  readonly node?: {
                    readonly __typename: "CompetencyCriteriaNode";
                    readonly id: number;
                    readonly content: any;
                  } | null;
                } | null>;
              };
            } | null;
          } | null>;
        };
        readonly responsibilities: {
          readonly __typename: "CareerTrackRoleResponsibilityNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "CareerTrackRoleResponsibilityNodeEdge";
            readonly node?: {
              readonly __typename: "CareerTrackRoleResponsibilityNode";
              readonly id: number;
              readonly content: any;
            } | null;
          } | null>;
        };
      } | null;
    } | null>;
  };
};

export type GetProfileCareerQueryQueryVariables = Exact<{
  userId: Scalars["Int"]["input"];
  organizationId: Scalars["Int"]["input"];
}>;

export type GetProfileCareerQueryQuery = {
  readonly __typename: "Query";
  readonly user?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly firstName: string;
    readonly isInCurrentUserReportingTree: boolean;
    readonly email: string;
    readonly avatar?: string | null;
    readonly timezone?: string | null;
    readonly lastSeenStr?: UserLastSeen | null;
    readonly managersList: ReadonlyArray<{
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly avatar?: string | null;
    }>;
    readonly currentRoles: ReadonlyArray<{
      readonly __typename: "CareerTrackRoleNode";
      readonly id: number;
      readonly careerTrack: {
        readonly __typename: "CareerTrackNode";
        readonly id: number;
        readonly title: string;
        readonly roles: {
          readonly __typename: "CareerTrackRoleNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "CareerTrackRoleNodeEdge";
            readonly node?: {
              readonly __typename: "CareerTrackRoleNode";
              readonly id: number;
              readonly title: string;
              readonly level: number;
              readonly roleType: CareerTrackRoleType;
              readonly competencies: {
                readonly __typename: "CompetencyConnection";
                readonly edges: ReadonlyArray<{
                  readonly __typename: "CompetencyEdge";
                  readonly node?: {
                    readonly __typename: "CompetencyNode";
                    readonly id: number;
                    readonly title: string;
                    readonly criteria: {
                      readonly __typename: "CompetencyCriteriaConnection";
                      readonly edges: ReadonlyArray<{
                        readonly __typename: "CompetencyCriteriaEdge";
                        readonly node?: {
                          readonly __typename: "CompetencyCriteriaNode";
                          readonly id: number;
                          readonly content: any;
                        } | null;
                      } | null>;
                    };
                  } | null;
                } | null>;
              };
              readonly responsibilities: {
                readonly __typename: "CareerTrackRoleResponsibilityNodeConnection";
                readonly edges: ReadonlyArray<{
                  readonly __typename: "CareerTrackRoleResponsibilityNodeEdge";
                  readonly node?: {
                    readonly __typename: "CareerTrackRoleResponsibilityNode";
                    readonly id: number;
                    readonly content: any;
                  } | null;
                } | null>;
              };
            } | null;
          } | null>;
        };
      };
    }>;
  } | null;
  readonly careerTracks: {
    readonly __typename: "CareerTrackNodeConnection";
    readonly totalCount: number;
  };
};

export type GetCoachingReportQueryVariables = Exact<{
  subjectId: Scalars["Int"]["input"];
  managerId: Scalars["Int"]["input"];
}>;

export type GetCoachingReportQuery = {
  readonly __typename: "Query";
  readonly coachingReport?: {
    readonly __typename: "CoachingReportNode";
    readonly id: number;
    readonly reportStartDate: string;
    readonly reportEndDate: string;
    readonly created: string;
    readonly meta?: {
      readonly __typename: "CoachingMetaNode";
      readonly generated?: string | null;
      readonly manager?: {
        readonly __typename: "CoachingMetaUserNode";
        readonly name?: string | null;
        readonly firstName?: string | null;
      } | null;
      readonly report?: {
        readonly __typename: "CoachingMetaReportNode";
        readonly name?: string | null;
        readonly firstName?: string | null;
        readonly role?: string | null;
        readonly tenure?: string | null;
      } | null;
      readonly period?: {
        readonly __typename: "CoachingPeriodNode";
        readonly start?: string | null;
        readonly end?: string | null;
      } | null;
      readonly dataCounts?: {
        readonly __typename: "CoachingDataCountsNode";
        readonly meetings?: number | null;
        readonly workSummaries?: number | null;
        readonly goals?: number | null;
        readonly checkins?: number | null;
        readonly recognitions?: number | null;
      } | null;
    } | null;
    readonly dashboard?: ReadonlyArray<{
      readonly __typename: "CoachingDashboardItemNode";
      readonly dimension?: string | null;
      readonly status?: DimensionStatus | null;
      readonly statusLabel?: string | null;
      readonly detail?: string | null;
    } | null> | null;
    readonly sources?: ReadonlyArray<{
      readonly __typename: "CoachingSourceNode";
      readonly type?: SourceType | null;
      readonly title?: string | null;
      readonly sourceUrl?: string | null;
    } | null> | null;
    readonly dimensions?: ReadonlyArray<{
      readonly __typename: "CoachingDimensionNode";
      readonly name?: string | null;
      readonly status?: DimensionStatus | null;
      readonly insights?: ReadonlyArray<{
        readonly __typename: "CoachingInsightNode";
        readonly title?: string | null;
        readonly priority?: InsightPriority | null;
        readonly body?: string | null;
        readonly evidence?: ReadonlyArray<{
          readonly __typename: "CoachingEvidenceNode";
          readonly text?: string | null;
          readonly sourceUrl?: string | null;
          readonly sourceTitle?: string | null;
        } | null> | null;
        readonly action?: {
          readonly __typename: "CoachingActionNode";
          readonly label?: ActionLabel | null;
          readonly text?: string | null;
          readonly variant?: ActionVariant | null;
        } | null;
        readonly topics?: {
          readonly __typename: "CoachingInsightTopicNode";
          readonly title?: string | null;
          readonly notes?: ReadonlyArray<string | null> | null;
        } | null;
      } | null> | null;
    } | null> | null;
    readonly agenda?: {
      readonly __typename: "CoachingAgendaNode";
      readonly nextMeeting?: ReadonlyArray<{
        readonly __typename: "CoachingAgendaItemNode";
        readonly topic?: string | null;
        readonly tags?: ReadonlyArray<string | null> | null;
        readonly opener?: string | null;
      } | null> | null;
      readonly phasedPlan?: ReadonlyArray<{
        readonly __typename: "CoachingPhasedMeetingNode";
        readonly meeting?: string | null;
        readonly theme?: string | null;
        readonly topics?: ReadonlyArray<string | null> | null;
      } | null> | null;
    } | null;
  } | null;
};

export type CreatePrivateNoteMutationMutationVariables = Exact<{
  profileId: Scalars["Int"]["input"];
  notes: Scalars["JSONString"]["input"];
}>;

export type CreatePrivateNoteMutationMutation = {
  readonly __typename: "Mutation";
  readonly createPrivateNote?: {
    readonly __typename: "CreatePrivateNoteMutation";
    readonly privateNote?: {
      readonly __typename: "PrivateNoteNode";
      readonly id: number;
      readonly pk?: number | null;
      readonly notes?: any | null;
      readonly created: string;
      readonly creator?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      } | null;
    } | null;
  } | null;
};

export type DeletePrivateNoteMutationMutationVariables = Exact<{
  privateNoteId: Scalars["Int"]["input"];
}>;

export type DeletePrivateNoteMutationMutation = {
  readonly __typename: "Mutation";
  readonly deletePrivateNote?: {
    readonly __typename: "DeletePrivateNoteMutation";
    readonly deletedPrivateNoteId?: number | null;
  } | null;
};

export type GetPrivateNotesQueryQueryVariables = Exact<{
  profileId: Scalars["Int"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetPrivateNotesQueryQuery = {
  readonly __typename: "Query";
  readonly user?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly privateNotes?: {
      readonly __typename: "PrivateNoteNodeConnection";
      readonly totalCount: number;
      readonly pageInfo: {
        readonly __typename: "PageInfo";
        readonly hasNextPage: boolean;
        readonly endCursor?: string | null;
      };
      readonly edges: ReadonlyArray<{
        readonly __typename: "PrivateNoteNodeEdge";
        readonly node?: {
          readonly __typename: "PrivateNoteNode";
          readonly id: number;
          readonly pk?: number | null;
          readonly notes?: any | null;
          readonly created: string;
          readonly creator?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetProfileOverviewQueryQueryVariables = Exact<{
  userId: Scalars["Int"]["input"];
}>;

export type GetProfileOverviewQueryQuery = {
  readonly __typename: "Query";
  readonly user?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly firstName: string;
    readonly email: string;
    readonly avatar?: string | null;
    readonly timezone?: string | null;
    readonly lastSeenStr?: UserLastSeen | null;
    readonly isInCurrentUserReportingTree: boolean;
    readonly teamsList: ReadonlyArray<{
      readonly __typename: "TeamNode";
      readonly id: number;
      readonly title: string;
    }>;
    readonly managersList: ReadonlyArray<{
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly avatar?: string | null;
    }>;
    readonly directReports: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null>;
    };
    readonly currentRoles: ReadonlyArray<{
      readonly __typename: "CareerTrackRoleNode";
      readonly id: number;
      readonly title: string;
    }>;
  } | null;
};

export type GetProfileQueryQueryVariables = Exact<{
  userId: Scalars["Int"]["input"];
  currentUserId: Scalars["Int"]["input"];
  now: Scalars["DateTime"]["input"];
}>;

export type GetProfileQueryQuery = {
  readonly __typename: "Query";
  readonly user?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly firstName: string;
    readonly email: string;
    readonly status?: UserStatus | null;
    readonly avatar?: string | null;
    readonly isInCurrentUserReportingTree: boolean;
    readonly upcomingOneonone?: {
      readonly __typename: "MeetingNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "MeetingNodeEdge";
        readonly node?: {
          readonly __typename: "MeetingNode";
          readonly id: number;
        } | null;
      } | null>;
    } | null;
    readonly managersList: ReadonlyArray<{
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly avatar?: string | null;
    }>;
    readonly primaryManager?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly firstName: string;
      readonly email: string;
    } | null;
  } | null;
};

export type GetProfileSidebarQueryQueryVariables = Exact<{
  userId: Scalars["Int"]["input"];
}>;

export type GetProfileSidebarQueryQuery = {
  readonly __typename: "Query";
  readonly user?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly firstName: string;
    readonly email: string;
    readonly avatar?: string | null;
    readonly timezone?: string | null;
    readonly lastSeenStr?: UserLastSeen | null;
    readonly isInCurrentUserReportingTree: boolean;
    readonly teamsList: ReadonlyArray<{
      readonly __typename: "TeamNode";
      readonly id: number;
      readonly title: string;
    }>;
    readonly managersList: ReadonlyArray<{
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly avatar?: string | null;
    }>;
    readonly directReports: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null>;
    };
    readonly currentRoles: ReadonlyArray<{
      readonly __typename: "CareerTrackRoleNode";
      readonly id: number;
      readonly title: string;
    }>;
    readonly ownedGoals?: {
      readonly __typename: "ArtifactConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "ArtifactEdge";
        readonly node?:
          | {
              readonly __typename: "ActionItemArtifactNode";
              readonly id: number;
            }
          | {
              readonly __typename: "AsanaTaskArtifactNode";
              readonly id: number;
            }
          | { readonly __typename: "DecisionArtifactNode"; readonly id: number }
          | { readonly __typename: "DocumentArtifactNode"; readonly id: number }
          | { readonly __typename: "FeedbackArtifactNode"; readonly id: number }
          | {
              readonly __typename: "GithubIssuesArtifactNode";
              readonly id: number;
            }
          | {
              readonly __typename: "GoalArtifactNode";
              readonly isStale: boolean;
              readonly status: GoalStatus;
              readonly state: GoalState;
              readonly id: number;
            }
          | { readonly __typename: "KPIArtifactNode"; readonly id: number }
          | { readonly __typename: "RatingArtifactNode"; readonly id: number }
          | {
              readonly __typename: "RecognitionArtifactNode";
              readonly id: number;
            }
          | null;
      } | null>;
    } | null;
  } | null;
};

export type GetProfileWeeklySummaryQueryVariables = Exact<{
  userId: Scalars["Int"]["input"];
  weekOffset: Scalars["Int"]["input"];
}>;

export type GetProfileWeeklySummaryQuery = {
  readonly __typename: "Query";
  readonly profileWeeklySummary?: {
    readonly __typename: "ProfileWeeklySummaryNode";
    readonly weekStart: string;
    readonly weekEnd: string;
    readonly weekOffset: number;
    readonly subjectName: string;
    readonly insights: ReadonlyArray<{
      readonly __typename: "ProfileSummaryLineNode";
      readonly id: string;
      readonly text: string;
      readonly sources: ReadonlyArray<{
        readonly __typename: "ProfileSummarySourceNode";
        readonly id: string;
        readonly type: string;
        readonly provider: string;
        readonly title: string;
        readonly detail?: string | null;
        readonly timestamp?: string | null;
        readonly url?: string | null;
        readonly isExternal: boolean;
      }>;
    }>;
    readonly activity: ReadonlyArray<{
      readonly __typename: "ProfileSummaryLineNode";
      readonly id: string;
      readonly text: string;
      readonly sources: ReadonlyArray<{
        readonly __typename: "ProfileSummarySourceNode";
        readonly id: string;
        readonly type: string;
        readonly provider: string;
        readonly title: string;
        readonly detail?: string | null;
        readonly timestamp?: string | null;
        readonly url?: string | null;
        readonly isExternal: boolean;
      }>;
    }>;
  } | null;
};

export type MarkReportOnboardedMutationMutationVariables = Exact<{
  reportId: Scalars["Int"]["input"];
}>;

export type MarkReportOnboardedMutationMutation = {
  readonly __typename: "Mutation";
  readonly markReportOnboarded?: {
    readonly __typename: "MarkReportOnboardedMutation";
    readonly user?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly onboardingData?: any | null;
    } | null;
  } | null;
};

export type GetProfileOneononesQueryQueryVariables = Exact<{
  subject: Scalars["Int"]["input"];
  now: Scalars["DateTime"]["input"];
  beforeDate: Scalars["DateTime"]["input"];
  includeUpcoming: Scalars["Boolean"]["input"];
  upcomingFirst: Scalars["Int"]["input"];
  upcomingCursor?: InputMaybe<Scalars["String"]["input"]>;
  pastFirst: Scalars["Int"]["input"];
  pastCursor?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetProfileOneononesQueryQuery = {
  readonly __typename: "Query";
  readonly upcoming?: {
    readonly __typename: "MeetingNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "MeetingNodeEdge";
      readonly node?: {
        readonly __typename: "MeetingNode";
        readonly id: number;
        readonly title?: string | null;
        readonly startDatetime?: string | null;
        readonly meetingGroupId: number;
      } | null;
    } | null>;
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly hasNextPage: boolean;
      readonly endCursor?: string | null;
    };
  } | null;
  readonly past?: {
    readonly __typename: "MeetingNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "MeetingNodeEdge";
      readonly node?: {
        readonly __typename: "MeetingNode";
        readonly id: number;
        readonly title?: string | null;
        readonly startDatetime?: string | null;
        readonly meetingGroupId: number;
      } | null;
    } | null>;
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly hasNextPage: boolean;
      readonly endCursor?: string | null;
    };
  } | null;
};

export type ImportOneononeCandidatesQueryQueryVariables = Exact<{
  reportUserId: Scalars["Int"]["input"];
}>;

export type ImportOneononeCandidatesQueryQuery = {
  readonly __typename: "Query";
  readonly importOneononeCandidates?: ReadonlyArray<{
    readonly __typename: "MeetingNode";
    readonly id: number;
    readonly startDatetime?: string | null;
  } | null> | null;
};

export type ImportOneononeNotesMutationMutationVariables = Exact<{
  reportUserId: Scalars["Int"]["input"];
  timezone?: InputMaybe<Scalars["String"]["input"]>;
  meetings:
    | ReadonlyArray<ImportOneononeMeetingInput>
    | ImportOneononeMeetingInput;
}>;

export type ImportOneononeNotesMutationMutation = {
  readonly __typename: "Mutation";
  readonly importOneononeNotes?: {
    readonly __typename: "ImportOneononeNotesMutation";
    readonly skippedDates?: ReadonlyArray<string | null> | null;
    readonly meetings?: ReadonlyArray<{
      readonly __typename: "MeetingNode";
      readonly id: number;
      readonly meetingGroupId: number;
      readonly startDatetime?: string | null;
    } | null> | null;
  } | null;
};

export type PreviewImportOneononeNotesMutationMutationVariables = Exact<{
  reportUserId: Scalars["Int"]["input"];
  notes: Scalars["String"]["input"];
  timezone?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type PreviewImportOneononeNotesMutationMutation = {
  readonly __typename: "Mutation";
  readonly previewImportOneononeNotes?: {
    readonly __typename: "PreviewImportOneononeNotesMutation";
    readonly plan?: ReadonlyArray<{
      readonly __typename: "PlannedImportMeetingNode";
      readonly date: string;
      readonly action: ImportMeetingAction;
      readonly existingMeeting?: {
        readonly __typename: "MeetingNode";
        readonly id: number;
        readonly title?: string | null;
        readonly startDatetime?: string | null;
      } | null;
      readonly topics?: ReadonlyArray<{
        readonly __typename: "PlannedImportTopicNode";
        readonly title?: string | null;
        readonly notes?: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type CreateQuickTopicMutationMutationVariables = Exact<{
  topicId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  assignee?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type CreateQuickTopicMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateTopic?: {
    readonly __typename: "CreateOrUpdateTopicMutation";
    readonly topic?: {
      readonly __typename: "TopicNode";
      readonly id: number;
      readonly title: string;
      readonly state?: TopicState | null;
      readonly canDelete: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
      };
    } | null;
  } | null;
};

export type ProfileArtifactActivityFragmentFragment = {
  readonly __typename: "ArtifactActivityNode";
  readonly id: number;
  readonly created: string;
  readonly activityType: ArtifactActivityType;
  readonly artifact?:
    | {
        readonly __typename: "ActionItemArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
      }
    | {
        readonly __typename: "AsanaTaskArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
      }
    | {
        readonly __typename: "DecisionArtifactNode";
        readonly decision: string;
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
      }
    | {
        readonly __typename: "DocumentArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
      }
    | {
        readonly __typename: "FeedbackArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
      }
    | {
        readonly __typename: "GithubIssuesArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
      }
    | {
        readonly __typename: "GoalArtifactNode";
        readonly scope: GoalScope;
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
      }
    | {
        readonly __typename: "KPIArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
      }
    | {
        readonly __typename: "RatingArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
      }
    | {
        readonly __typename: "RecognitionArtifactNode";
        readonly id: number;
        readonly artifactType: ArtifactType;
        readonly title?: string | null;
      }
    | null;
  readonly canDelete?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  } | null;
  readonly canUpdate?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  } | null;
  readonly actor?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
  readonly changedFields?: ReadonlyArray<{
    readonly __typename: "ArtifactChangedFieldNode";
    readonly fieldName?: string | null;
    readonly previousValue?: string | null;
    readonly newValue?: string | null;
    readonly changedFields?: ReadonlyArray<{
      readonly __typename: "ArtifactChangedFieldNode";
      readonly newValue?: string | null;
      readonly previousValue?: string | null;
      readonly fieldName?: string | null;
    } | null> | null;
    readonly newValueObject?:
      | {
          readonly __typename: "BaseArtifactNode";
          readonly id: number;
          readonly title: string;
          readonly artifactType: ArtifactType;
        }
      | {
          readonly __typename: "CareerTrackRoleNode";
          readonly id: number;
          readonly title: string;
        }
      | {
          readonly __typename: "CommentNode";
          readonly id: number;
          readonly comment?: any | null;
          readonly deleted?: boolean | null;
          readonly creator?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
        }
      | {
          readonly __typename: "CompetencyNode";
          readonly id: number;
          readonly title: string;
        }
      | {
          readonly __typename: "KeyResultNode";
          readonly id: number;
          readonly title: string;
        }
      | {
          readonly __typename: "TopicNode";
          readonly id: number;
          readonly title: string;
          readonly meeting?: {
            readonly __typename: "MeetingNode";
            readonly id: number;
            readonly title?: string | null;
            readonly meetingGroupId: number;
          } | null;
        }
      | {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        }
      | null;
    readonly previousValueObject?:
      | {
          readonly __typename: "BaseArtifactNode";
          readonly id: number;
          readonly title: string;
          readonly artifactType: ArtifactType;
        }
      | {
          readonly __typename: "CareerTrackRoleNode";
          readonly id: number;
          readonly title: string;
        }
      | { readonly __typename: "CommentNode" }
      | {
          readonly __typename: "CompetencyNode";
          readonly id: number;
          readonly title: string;
        }
      | {
          readonly __typename: "KeyResultNode";
          readonly id: number;
          readonly title: string;
        }
      | {
          readonly __typename: "TopicNode";
          readonly id: number;
          readonly title: string;
          readonly meeting?: {
            readonly __typename: "MeetingNode";
            readonly id: number;
            readonly title?: string | null;
            readonly meetingGroupId: number;
          } | null;
        }
      | {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        }
      | null;
  } | null> | null;
};

export type GetProfileActivitiesQueryQueryVariables = Exact<{
  profileId: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
  createdAfter?: InputMaybe<Scalars["DateTime"]["input"]>;
}>;

export type GetProfileActivitiesQueryQuery = {
  readonly __typename: "Query";
  readonly user?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly activities?: {
      readonly __typename: "ArtifactActivityNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "ArtifactActivityNodeEdge";
        readonly node?: {
          readonly __typename: "ArtifactActivityNode";
          readonly id: number;
          readonly created: string;
          readonly activityType: ArtifactActivityType;
          readonly artifact?:
            | {
                readonly __typename: "ActionItemArtifactNode";
                readonly id: number;
                readonly artifactType: ArtifactType;
                readonly title?: string | null;
              }
            | {
                readonly __typename: "AsanaTaskArtifactNode";
                readonly id: number;
                readonly artifactType: ArtifactType;
                readonly title?: string | null;
              }
            | {
                readonly __typename: "DecisionArtifactNode";
                readonly decision: string;
                readonly id: number;
                readonly artifactType: ArtifactType;
                readonly title?: string | null;
              }
            | {
                readonly __typename: "DocumentArtifactNode";
                readonly id: number;
                readonly artifactType: ArtifactType;
                readonly title?: string | null;
              }
            | {
                readonly __typename: "FeedbackArtifactNode";
                readonly id: number;
                readonly artifactType: ArtifactType;
                readonly title?: string | null;
              }
            | {
                readonly __typename: "GithubIssuesArtifactNode";
                readonly id: number;
                readonly artifactType: ArtifactType;
                readonly title?: string | null;
              }
            | {
                readonly __typename: "GoalArtifactNode";
                readonly scope: GoalScope;
                readonly id: number;
                readonly artifactType: ArtifactType;
                readonly title?: string | null;
              }
            | {
                readonly __typename: "KPIArtifactNode";
                readonly id: number;
                readonly artifactType: ArtifactType;
                readonly title?: string | null;
              }
            | {
                readonly __typename: "RatingArtifactNode";
                readonly id: number;
                readonly artifactType: ArtifactType;
                readonly title?: string | null;
              }
            | {
                readonly __typename: "RecognitionArtifactNode";
                readonly id: number;
                readonly artifactType: ArtifactType;
                readonly title?: string | null;
              }
            | null;
          readonly canDelete?: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
            readonly reason: string;
          } | null;
          readonly canUpdate?: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
            readonly reason: string;
          } | null;
          readonly actor?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
          readonly changedFields?: ReadonlyArray<{
            readonly __typename: "ArtifactChangedFieldNode";
            readonly fieldName?: string | null;
            readonly previousValue?: string | null;
            readonly newValue?: string | null;
            readonly changedFields?: ReadonlyArray<{
              readonly __typename: "ArtifactChangedFieldNode";
              readonly newValue?: string | null;
              readonly previousValue?: string | null;
              readonly fieldName?: string | null;
            } | null> | null;
            readonly newValueObject?:
              | {
                  readonly __typename: "BaseArtifactNode";
                  readonly id: number;
                  readonly title: string;
                  readonly artifactType: ArtifactType;
                }
              | {
                  readonly __typename: "CareerTrackRoleNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "CommentNode";
                  readonly id: number;
                  readonly comment?: any | null;
                  readonly deleted?: boolean | null;
                  readonly creator?: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly name: string;
                    readonly avatar?: string | null;
                  } | null;
                }
              | {
                  readonly __typename: "CompetencyNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "KeyResultNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "TopicNode";
                  readonly id: number;
                  readonly title: string;
                  readonly meeting?: {
                    readonly __typename: "MeetingNode";
                    readonly id: number;
                    readonly title?: string | null;
                    readonly meetingGroupId: number;
                  } | null;
                }
              | {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly name: string;
                  readonly avatar?: string | null;
                }
              | null;
            readonly previousValueObject?:
              | {
                  readonly __typename: "BaseArtifactNode";
                  readonly id: number;
                  readonly title: string;
                  readonly artifactType: ArtifactType;
                }
              | {
                  readonly __typename: "CareerTrackRoleNode";
                  readonly id: number;
                  readonly title: string;
                }
              | { readonly __typename: "CommentNode" }
              | {
                  readonly __typename: "CompetencyNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "KeyResultNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "TopicNode";
                  readonly id: number;
                  readonly title: string;
                  readonly meeting?: {
                    readonly __typename: "MeetingNode";
                    readonly id: number;
                    readonly title?: string | null;
                    readonly meetingGroupId: number;
                  } | null;
                }
              | {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly name: string;
                  readonly avatar?: string | null;
                }
              | null;
          } | null> | null;
        } | null;
      } | null>;
      readonly pageInfo: {
        readonly __typename: "PageInfo";
        readonly hasNextPage: boolean;
        readonly endCursor?: string | null;
      };
    } | null;
  } | null;
};

export type GetProfileArtifactsQueryQueryVariables = Exact<{
  goalOwners?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  artifactType: ArtifactType;
  goalStates?: InputMaybe<
    ReadonlyArray<InputMaybe<GoalState>> | InputMaybe<GoalState>
  >;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  feedbackRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionRecipient?: InputMaybe<Scalars["Int"]["input"]>;
  actionItemIsComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  actionItemAssignee?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetProfileArtifactsQueryQuery = {
  readonly __typename: "Query";
  readonly artifacts?: {
    readonly __typename: "ArtifactConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "ArtifactEdge";
      readonly node?:
        | {
            readonly __typename: "ActionItemArtifactNode";
            readonly isComplete?: boolean | null;
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly updated?: string | null;
            readonly created: string;
            readonly assignee?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          }
        | {
            readonly __typename: "AsanaTaskArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly updated?: string | null;
            readonly created: string;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          }
        | {
            readonly __typename: "DecisionArtifactNode";
            readonly decision: string;
            readonly decisionState?: DecisionState | null;
            readonly isDraft?: boolean | null;
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly updated?: string | null;
            readonly created: string;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          }
        | {
            readonly __typename: "DocumentArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly updated?: string | null;
            readonly created: string;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          }
        | {
            readonly __typename: "FeedbackArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly updated?: string | null;
            readonly created: string;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          }
        | {
            readonly __typename: "GithubIssuesArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly updated?: string | null;
            readonly created: string;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          }
        | {
            readonly __typename: "GoalArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly updated?: string | null;
            readonly created: string;
            readonly state: GoalState;
            readonly scope: GoalScope;
            readonly ownerCount?: number | null;
            readonly dueDate?: string | null;
            readonly goalVisibility: GoalVisibility;
            readonly status: GoalStatus;
            readonly progress: number;
            readonly progressType: GoalProgressType;
            readonly currentValue: number;
            readonly startValue: number;
            readonly targetValue: number;
            readonly isStale: boolean;
            readonly parentGoalId?: number | null;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
            readonly firstOwner?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
            readonly owners?: {
              readonly __typename: "UserNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "UserNodeEdge";
                readonly node?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly name: string;
                  readonly avatar?: string | null;
                } | null;
              } | null>;
            } | null;
          }
        | {
            readonly __typename: "KPIArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly updated?: string | null;
            readonly created: string;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          }
        | {
            readonly __typename: "RatingArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly updated?: string | null;
            readonly created: string;
            readonly rating?: {
              readonly __typename: "RatingNode";
              readonly id: number;
              readonly title: string;
            } | null;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          }
        | {
            readonly __typename: "RecognitionArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly updated?: string | null;
            readonly created: string;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
            readonly recognitionCoreValue?: {
              readonly __typename: "RecognitionCoreValueNode";
              readonly id: number;
              readonly title: string;
              readonly emoji?: string | null;
              readonly image?: string | null;
            } | null;
            readonly recipients?: {
              readonly __typename: "UserNodeConnection";
              readonly totalCount: number;
              readonly edges: ReadonlyArray<{
                readonly __typename: "UserNodeEdge";
                readonly node?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly name: string;
                  readonly avatar?: string | null;
                } | null;
              } | null>;
            } | null;
          }
        | null;
    } | null>;
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly hasNextPage: boolean;
      readonly endCursor?: string | null;
    };
  } | null;
};

export type GetProfileCandidateMeetingsQueryQueryVariables = Exact<{
  participants:
    | ReadonlyArray<Scalars["Int"]["input"]>
    | Scalars["Int"]["input"];
  nextAfterDate: Scalars["DateTime"]["input"];
}>;

export type GetProfileCandidateMeetingsQueryQuery = {
  readonly __typename: "Query";
  readonly candidateMeetings?: {
    readonly __typename: "MeetingNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "MeetingNodeEdge";
      readonly node?: {
        readonly __typename: "MeetingNode";
        readonly id: number;
        readonly title?: string | null;
        readonly startDatetime?: string | null;
        readonly meetingGroupId: number;
      } | null;
    } | null>;
  } | null;
};

export type ProfileCoachingInsightFragmentFragment = {
  readonly __typename: "ManagerInsightNode";
  readonly insightType: ManagerInsightType;
  readonly title: string;
  readonly description?: string | null;
  readonly relatedUrl?: string | null;
  readonly suggestedArtifactTitle?: string | null;
  readonly coachingReportId?: number | null;
  readonly suggestedCoreValue?: {
    readonly __typename: "RecognitionCoreValueNode";
    readonly id: number;
  } | null;
  readonly coachingInsight?: {
    readonly __typename: "CoachingInsightNode";
    readonly title?: string | null;
    readonly body?: string | null;
    readonly evidence?: ReadonlyArray<{
      readonly __typename: "CoachingEvidenceNode";
      readonly text?: string | null;
      readonly sourceRef?: string | null;
      readonly sourceUrl?: string | null;
      readonly sourceTitle?: string | null;
    } | null> | null;
    readonly action?: {
      readonly __typename: "CoachingActionNode";
      readonly label?: ActionLabel | null;
      readonly text?: string | null;
      readonly variant?: ActionVariant | null;
    } | null;
    readonly topics?: {
      readonly __typename: "CoachingInsightTopicNode";
      readonly title?: string | null;
      readonly notes?: ReadonlyArray<string | null> | null;
    } | null;
  } | null;
};

export type GetProfileCoachingInsightsQueryQueryVariables = Exact<{
  profileId: Scalars["Int"]["input"];
}>;

export type GetProfileCoachingInsightsQueryQuery = {
  readonly __typename: "Query";
  readonly user?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly managerInsights?: {
      readonly __typename: "ManagerInsightConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "ManagerInsightEdge";
        readonly node?: {
          readonly __typename: "ManagerInsightNode";
          readonly insightType: ManagerInsightType;
          readonly title: string;
          readonly description?: string | null;
          readonly relatedUrl?: string | null;
          readonly suggestedArtifactTitle?: string | null;
          readonly coachingReportId?: number | null;
          readonly suggestedCoreValue?: {
            readonly __typename: "RecognitionCoreValueNode";
            readonly id: number;
          } | null;
          readonly coachingInsight?: {
            readonly __typename: "CoachingInsightNode";
            readonly title?: string | null;
            readonly body?: string | null;
            readonly evidence?: ReadonlyArray<{
              readonly __typename: "CoachingEvidenceNode";
              readonly text?: string | null;
              readonly sourceRef?: string | null;
              readonly sourceUrl?: string | null;
              readonly sourceTitle?: string | null;
            } | null> | null;
            readonly action?: {
              readonly __typename: "CoachingActionNode";
              readonly label?: ActionLabel | null;
              readonly text?: string | null;
              readonly variant?: ActionVariant | null;
            } | null;
            readonly topics?: {
              readonly __typename: "CoachingInsightTopicNode";
              readonly title?: string | null;
              readonly notes?: ReadonlyArray<string | null> | null;
            } | null;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetProfileOneononeQueryQueryVariables = Exact<{
  participants:
    | ReadonlyArray<Scalars["Int"]["input"]>
    | Scalars["Int"]["input"];
  nextAfterDate: Scalars["DateTime"]["input"];
  lastBeforeDate: Scalars["DateTime"]["input"];
}>;

export type GetProfileOneononeQueryQuery = {
  readonly __typename: "Query";
  readonly nextOneonone?: {
    readonly __typename: "MeetingNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "MeetingNodeEdge";
      readonly node?: {
        readonly __typename: "MeetingNode";
        readonly id: number;
        readonly startDatetime?: string | null;
        readonly endDatetime?: string | null;
        readonly title?: string | null;
        readonly meetingGroupId: number;
        readonly topics?: {
          readonly __typename: "TopicNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "TopicNodeEdge";
            readonly node?: {
              readonly __typename: "TopicNode";
              readonly id: number;
              readonly title: string;
              readonly state?: TopicState | null;
              readonly canDelete: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
            } | null;
          } | null>;
        } | null;
      } | null;
    } | null>;
  } | null;
  readonly lastOneonone?: {
    readonly __typename: "MeetingNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "MeetingNodeEdge";
      readonly node?: {
        readonly __typename: "MeetingNode";
        readonly id: number;
        readonly startDatetime?: string | null;
        readonly endDatetime?: string | null;
        readonly title?: string | null;
        readonly meetingGroupId: number;
        readonly transcript?: {
          readonly __typename: "MeetingTranscriptNode";
          readonly id: number;
          readonly summary?: string | null;
        } | null;
        readonly topics?: {
          readonly __typename: "TopicNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "TopicNodeEdge";
            readonly node?: {
              readonly __typename: "TopicNode";
              readonly id: number;
              readonly title: string;
              readonly state?: TopicState | null;
            } | null;
          } | null>;
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type GetProfileReviewsQueryQueryVariables = Exact<{
  profileId: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetProfileReviewsQueryQuery = {
  readonly __typename: "Query";
  readonly assessmentDeliveries: {
    readonly __typename: "AssessmentDeliveryNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "AssessmentDeliveryNodeEdge";
      readonly node?: {
        readonly __typename: "AssessmentDeliveryNode";
        readonly id: number;
        readonly deliveryDatetime?: string | null;
        readonly lastSubmissionDatetime?: string | null;
        readonly target?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly email: string;
          readonly firstName: string;
          readonly avatar?: string | null;
        } | null;
        readonly complianceProgram?: {
          readonly __typename: "ComplianceProgramNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null;
    } | null>;
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly hasNextPage: boolean;
      readonly endCursor?: string | null;
    };
  };
};

export type SaveComplianceProgramMutationVariables = Exact<{
  complianceProgramId?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  dueDate?: InputMaybe<Scalars["Date"]["input"]>;
  startDate?: InputMaybe<Scalars["Date"]["input"]>;
  periodStartDate?: InputMaybe<Scalars["Date"]["input"]>;
  periodEndDate?: InputMaybe<Scalars["Date"]["input"]>;
  topicTemplates?: InputMaybe<
    | ReadonlyArray<InputMaybe<TopicTemplateComplianceRequirement>>
    | InputMaybe<TopicTemplateComplianceRequirement>
  >;
  assessmentTemplates?: InputMaybe<
    | ReadonlyArray<InputMaybe<AssessmentTemplateComplianceRequirement>>
    | InputMaybe<AssessmentTemplateComplianceRequirement>
  >;
  state?: InputMaybe<ComplianceProgramState>;
  appliesTo?: InputMaybe<ComplianceProgramAppliesTo>;
  appliesToTeams?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  appliesToManagers?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  appliesToUsers?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  excludedUsers?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  excludedHireDateAfter?: InputMaybe<Scalars["Date"]["input"]>;
  removeExcludedHireDateAfter?: InputMaybe<Scalars["Boolean"]["input"]>;
  recurrence?: InputMaybe<ComplianceProgramRecurrence>;
  calibration?: InputMaybe<ComplianceProgramCalibrationType>;
  ongoing?: InputMaybe<Scalars["Boolean"]["input"]>;
  startDateOffset?: InputMaybe<Scalars["Int"]["input"]>;
  startDateDueDateOffset?: InputMaybe<Scalars["Int"]["input"]>;
  startDatePeriodStartOffset?: InputMaybe<Scalars["Int"]["input"]>;
  startDatePeriodEndOffset?: InputMaybe<Scalars["Int"]["input"]>;
  scheduledReminders?: InputMaybe<
    | ReadonlyArray<InputMaybe<ProgramScheduledReminderInput>>
    | InputMaybe<ProgramScheduledReminderInput>
  >;
  steps?: InputMaybe<
    | ReadonlyArray<InputMaybe<ComplianceProgramStepInput>>
    | InputMaybe<ComplianceProgramStepInput>
  >;
}>;

export type SaveComplianceProgramMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateComplianceProgram?: {
    readonly __typename: "CreateOrUpdateComplianceProgramMutation";
    readonly complianceProgram?: {
      readonly __typename: "ComplianceProgramNode";
      readonly id: number;
      readonly state: ComplianceProgramState;
    } | null;
  } | null;
};

export type AssessmentGroupFragmentFragment = {
  readonly __typename: "AssessmentGroupNode";
  readonly id: number;
  readonly title: string;
  readonly created: string;
  readonly archived: boolean;
  readonly isOnlySelfAssessment: boolean;
  readonly hasNpsQuestions: boolean;
  readonly assessmentType: AssessmentType;
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
  } | null;
  readonly canUpdate?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  } | null;
  readonly canDelete?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  } | null;
  readonly sections: {
    readonly __typename: "AssessmentGroupSectionNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "AssessmentGroupSectionNodeEdge";
      readonly node?: {
        readonly __typename: "AssessmentGroupSectionNode";
        readonly id: number;
        readonly title?: string | null;
        readonly description?: any | null;
        readonly questions: {
          readonly __typename: "AssessmentGroupQuestionContainerConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "AssessmentGroupQuestionContainerEdge";
            readonly node?: {
              readonly __typename: "AssessmentGroupQuestionContainer";
              readonly id: number;
              readonly question:
                | {
                    readonly __typename: "CompetencyAssessmentQuestionNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description?: any | null;
                    readonly archived: boolean;
                    readonly answersExist: boolean;
                    readonly comment: AssessmentQuestionComment;
                    readonly responses: AssessmentQuestionResponses;
                    readonly responseVisibility: AssessmentQuestionResponseVisibility;
                    readonly questionType: AssessmentQuestionType;
                    readonly created: string;
                    readonly startValue: number;
                    readonly endValue: number;
                    readonly labels: ReadonlyArray<string | null>;
                    readonly labelDescriptions: ReadonlyArray<string | null>;
                    readonly canUpdate: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                      readonly reason: string;
                    };
                    readonly canDelete: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                      readonly reason: string;
                    };
                    readonly categories: {
                      readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                      readonly edges: ReadonlyArray<{
                        readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                        readonly node?: {
                          readonly __typename: "AssessmentQuestionCategoryNode";
                          readonly id: number;
                          readonly title: string;
                        } | null;
                      } | null>;
                    };
                    readonly creator?: {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                    } | null;
                  }
                | {
                    readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description?: any | null;
                    readonly archived: boolean;
                    readonly answersExist: boolean;
                    readonly comment: AssessmentQuestionComment;
                    readonly responses: AssessmentQuestionResponses;
                    readonly responseVisibility: AssessmentQuestionResponseVisibility;
                    readonly questionType: AssessmentQuestionType;
                    readonly created: string;
                    readonly startValue: number;
                    readonly endValue: number;
                    readonly labels: ReadonlyArray<string | null>;
                    readonly labelDescriptions: ReadonlyArray<string | null>;
                    readonly canUpdate: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                      readonly reason: string;
                    };
                    readonly canDelete: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                      readonly reason: string;
                    };
                    readonly categories: {
                      readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                      readonly edges: ReadonlyArray<{
                        readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                        readonly node?: {
                          readonly __typename: "AssessmentQuestionCategoryNode";
                          readonly id: number;
                          readonly title: string;
                        } | null;
                      } | null>;
                    };
                    readonly creator?: {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                    } | null;
                  }
                | {
                    readonly __typename: "IndividualGoalAssessmentQuestionNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description?: any | null;
                    readonly archived: boolean;
                    readonly answersExist: boolean;
                    readonly comment: AssessmentQuestionComment;
                    readonly responses: AssessmentQuestionResponses;
                    readonly responseVisibility: AssessmentQuestionResponseVisibility;
                    readonly questionType: AssessmentQuestionType;
                    readonly created: string;
                    readonly startValue: number;
                    readonly endValue: number;
                    readonly labels: ReadonlyArray<string | null>;
                    readonly labelDescriptions: ReadonlyArray<string | null>;
                    readonly canUpdate: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                      readonly reason: string;
                    };
                    readonly canDelete: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                      readonly reason: string;
                    };
                    readonly categories: {
                      readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                      readonly edges: ReadonlyArray<{
                        readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                        readonly node?: {
                          readonly __typename: "AssessmentQuestionCategoryNode";
                          readonly id: number;
                          readonly title: string;
                        } | null;
                      } | null>;
                    };
                    readonly creator?: {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                    } | null;
                  }
                | {
                    readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description?: any | null;
                    readonly archived: boolean;
                    readonly answersExist: boolean;
                    readonly comment: AssessmentQuestionComment;
                    readonly responses: AssessmentQuestionResponses;
                    readonly responseVisibility: AssessmentQuestionResponseVisibility;
                    readonly questionType: AssessmentQuestionType;
                    readonly created: string;
                    readonly startValue: number;
                    readonly endValue: number;
                    readonly labels: ReadonlyArray<string | null>;
                    readonly labelDescriptions: ReadonlyArray<string | null>;
                    readonly canUpdate: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                      readonly reason: string;
                    };
                    readonly canDelete: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                      readonly reason: string;
                    };
                    readonly categories: {
                      readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                      readonly edges: ReadonlyArray<{
                        readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                        readonly node?: {
                          readonly __typename: "AssessmentQuestionCategoryNode";
                          readonly id: number;
                          readonly title: string;
                        } | null;
                      } | null>;
                    };
                    readonly creator?: {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                    } | null;
                  }
                | {
                    readonly __typename: "MultiChoiceAssessmentQuestionNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description?: any | null;
                    readonly archived: boolean;
                    readonly answersExist: boolean;
                    readonly comment: AssessmentQuestionComment;
                    readonly responses: AssessmentQuestionResponses;
                    readonly responseVisibility: AssessmentQuestionResponseVisibility;
                    readonly questionType: AssessmentQuestionType;
                    readonly created: string;
                    readonly options: ReadonlyArray<string | null>;
                    readonly optionDescriptions: ReadonlyArray<string | null>;
                    readonly canUpdate: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                      readonly reason: string;
                    };
                    readonly canDelete: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                      readonly reason: string;
                    };
                    readonly categories: {
                      readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                      readonly edges: ReadonlyArray<{
                        readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                        readonly node?: {
                          readonly __typename: "AssessmentQuestionCategoryNode";
                          readonly id: number;
                          readonly title: string;
                        } | null;
                      } | null>;
                    };
                    readonly creator?: {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                    } | null;
                  }
                | {
                    readonly __typename: "NpsAssessmentQuestionNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description?: any | null;
                    readonly archived: boolean;
                    readonly answersExist: boolean;
                    readonly comment: AssessmentQuestionComment;
                    readonly responses: AssessmentQuestionResponses;
                    readonly responseVisibility: AssessmentQuestionResponseVisibility;
                    readonly questionType: AssessmentQuestionType;
                    readonly created: string;
                    readonly canUpdate: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                      readonly reason: string;
                    };
                    readonly canDelete: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                      readonly reason: string;
                    };
                    readonly categories: {
                      readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                      readonly edges: ReadonlyArray<{
                        readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                        readonly node?: {
                          readonly __typename: "AssessmentQuestionCategoryNode";
                          readonly id: number;
                          readonly title: string;
                        } | null;
                      } | null>;
                    };
                    readonly creator?: {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                    } | null;
                  }
                | {
                    readonly __typename: "OverallGoalAssessmentQuestionNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description?: any | null;
                    readonly archived: boolean;
                    readonly answersExist: boolean;
                    readonly comment: AssessmentQuestionComment;
                    readonly responses: AssessmentQuestionResponses;
                    readonly responseVisibility: AssessmentQuestionResponseVisibility;
                    readonly questionType: AssessmentQuestionType;
                    readonly created: string;
                    readonly startValue: number;
                    readonly endValue: number;
                    readonly labels: ReadonlyArray<string | null>;
                    readonly labelDescriptions: ReadonlyArray<string | null>;
                    readonly canUpdate: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                      readonly reason: string;
                    };
                    readonly canDelete: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                      readonly reason: string;
                    };
                    readonly categories: {
                      readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                      readonly edges: ReadonlyArray<{
                        readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                        readonly node?: {
                          readonly __typename: "AssessmentQuestionCategoryNode";
                          readonly id: number;
                          readonly title: string;
                        } | null;
                      } | null>;
                    };
                    readonly creator?: {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                    } | null;
                  }
                | {
                    readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description?: any | null;
                    readonly archived: boolean;
                    readonly answersExist: boolean;
                    readonly comment: AssessmentQuestionComment;
                    readonly responses: AssessmentQuestionResponses;
                    readonly responseVisibility: AssessmentQuestionResponseVisibility;
                    readonly questionType: AssessmentQuestionType;
                    readonly created: string;
                    readonly startValue: number;
                    readonly endValue: number;
                    readonly labels: ReadonlyArray<string | null>;
                    readonly labelDescriptions: ReadonlyArray<string | null>;
                    readonly canUpdate: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                      readonly reason: string;
                    };
                    readonly canDelete: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                      readonly reason: string;
                    };
                    readonly categories: {
                      readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                      readonly edges: ReadonlyArray<{
                        readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                        readonly node?: {
                          readonly __typename: "AssessmentQuestionCategoryNode";
                          readonly id: number;
                          readonly title: string;
                        } | null;
                      } | null>;
                    };
                    readonly creator?: {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                    } | null;
                  }
                | {
                    readonly __typename: "RangeAssessmentQuestionNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description?: any | null;
                    readonly archived: boolean;
                    readonly answersExist: boolean;
                    readonly comment: AssessmentQuestionComment;
                    readonly responses: AssessmentQuestionResponses;
                    readonly responseVisibility: AssessmentQuestionResponseVisibility;
                    readonly questionType: AssessmentQuestionType;
                    readonly created: string;
                    readonly startValue: number;
                    readonly endValue: number;
                    readonly labels: ReadonlyArray<string | null>;
                    readonly labelDescriptions: ReadonlyArray<string | null>;
                    readonly canUpdate: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                      readonly reason: string;
                    };
                    readonly canDelete: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                      readonly reason: string;
                    };
                    readonly categories: {
                      readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                      readonly edges: ReadonlyArray<{
                        readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                        readonly node?: {
                          readonly __typename: "AssessmentQuestionCategoryNode";
                          readonly id: number;
                          readonly title: string;
                        } | null;
                      } | null>;
                    };
                    readonly creator?: {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                    } | null;
                  }
                | {
                    readonly __typename: "ResponsibilityAssessmentQuestionNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description?: any | null;
                    readonly archived: boolean;
                    readonly answersExist: boolean;
                    readonly comment: AssessmentQuestionComment;
                    readonly responses: AssessmentQuestionResponses;
                    readonly responseVisibility: AssessmentQuestionResponseVisibility;
                    readonly questionType: AssessmentQuestionType;
                    readonly created: string;
                    readonly startValue: number;
                    readonly endValue: number;
                    readonly labels: ReadonlyArray<string | null>;
                    readonly labelDescriptions: ReadonlyArray<string | null>;
                    readonly canUpdate: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                      readonly reason: string;
                    };
                    readonly canDelete: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                      readonly reason: string;
                    };
                    readonly categories: {
                      readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                      readonly edges: ReadonlyArray<{
                        readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                        readonly node?: {
                          readonly __typename: "AssessmentQuestionCategoryNode";
                          readonly id: number;
                          readonly title: string;
                        } | null;
                      } | null>;
                    };
                    readonly creator?: {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                    } | null;
                  }
                | {
                    readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description?: any | null;
                    readonly archived: boolean;
                    readonly answersExist: boolean;
                    readonly comment: AssessmentQuestionComment;
                    readonly responses: AssessmentQuestionResponses;
                    readonly responseVisibility: AssessmentQuestionResponseVisibility;
                    readonly questionType: AssessmentQuestionType;
                    readonly created: string;
                    readonly startValue: number;
                    readonly endValue: number;
                    readonly labels: ReadonlyArray<string | null>;
                    readonly labelDescriptions: ReadonlyArray<string | null>;
                    readonly canUpdate: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                      readonly reason: string;
                    };
                    readonly canDelete: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                      readonly reason: string;
                    };
                    readonly categories: {
                      readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                      readonly edges: ReadonlyArray<{
                        readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                        readonly node?: {
                          readonly __typename: "AssessmentQuestionCategoryNode";
                          readonly id: number;
                          readonly title: string;
                        } | null;
                      } | null>;
                    };
                    readonly creator?: {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                    } | null;
                  }
                | {
                    readonly __typename: "TextAssessmentQuestionNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description?: any | null;
                    readonly archived: boolean;
                    readonly answersExist: boolean;
                    readonly comment: AssessmentQuestionComment;
                    readonly responses: AssessmentQuestionResponses;
                    readonly responseVisibility: AssessmentQuestionResponseVisibility;
                    readonly questionType: AssessmentQuestionType;
                    readonly created: string;
                    readonly canUpdate: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                      readonly reason: string;
                    };
                    readonly canDelete: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                      readonly reason: string;
                    };
                    readonly categories: {
                      readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                      readonly edges: ReadonlyArray<{
                        readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                        readonly node?: {
                          readonly __typename: "AssessmentQuestionCategoryNode";
                          readonly id: number;
                          readonly title: string;
                        } | null;
                      } | null>;
                    };
                    readonly creator?: {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                    } | null;
                  };
            } | null;
          } | null>;
        };
      } | null;
    } | null>;
  };
};

export type SaveFullAssessmentGroupMutationVariables = Exact<{
  title?: InputMaybe<Scalars["String"]["input"]>;
  assessmentGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  assessmentType?: InputMaybe<AssessmentType>;
  sections:
    | ReadonlyArray<InputMaybe<FullAssessmentGroupSectionInput>>
    | InputMaybe<FullAssessmentGroupSectionInput>;
}>;

export type SaveFullAssessmentGroupMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateFullAssessmentGroup?: {
    readonly __typename: "CreateOrUpdateFullAssessmentGroupMutation";
    readonly assessmentGroup?: {
      readonly __typename: "AssessmentGroupNode";
      readonly id: number;
      readonly title: string;
      readonly created: string;
      readonly archived: boolean;
      readonly isOnlySelfAssessment: boolean;
      readonly hasNpsQuestions: boolean;
      readonly assessmentType: AssessmentType;
      readonly creator?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
      } | null;
      readonly canUpdate?: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
        readonly reason: string;
      } | null;
      readonly canDelete?: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
        readonly reason: string;
      } | null;
      readonly sections: {
        readonly __typename: "AssessmentGroupSectionNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentGroupSectionNodeEdge";
          readonly node?: {
            readonly __typename: "AssessmentGroupSectionNode";
            readonly id: number;
            readonly title?: string | null;
            readonly description?: any | null;
            readonly questions: {
              readonly __typename: "AssessmentGroupQuestionContainerConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "AssessmentGroupQuestionContainerEdge";
                readonly node?: {
                  readonly __typename: "AssessmentGroupQuestionContainer";
                  readonly id: number;
                  readonly question:
                    | {
                        readonly __typename: "CompetencyAssessmentQuestionNode";
                        readonly id: number;
                        readonly title: string;
                        readonly description?: any | null;
                        readonly archived: boolean;
                        readonly answersExist: boolean;
                        readonly comment: AssessmentQuestionComment;
                        readonly responses: AssessmentQuestionResponses;
                        readonly responseVisibility: AssessmentQuestionResponseVisibility;
                        readonly questionType: AssessmentQuestionType;
                        readonly created: string;
                        readonly startValue: number;
                        readonly endValue: number;
                        readonly labels: ReadonlyArray<string | null>;
                        readonly labelDescriptions: ReadonlyArray<
                          string | null
                        >;
                        readonly canUpdate: {
                          readonly __typename: "PermissionNode";
                          readonly permission: boolean;
                          readonly reason: string;
                        };
                        readonly canDelete: {
                          readonly __typename: "PermissionNode";
                          readonly permission: boolean;
                          readonly reason: string;
                        };
                        readonly categories: {
                          readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                          readonly edges: ReadonlyArray<{
                            readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                            readonly node?: {
                              readonly __typename: "AssessmentQuestionCategoryNode";
                              readonly id: number;
                              readonly title: string;
                            } | null;
                          } | null>;
                        };
                        readonly creator?: {
                          readonly __typename: "UserNode";
                          readonly id: number;
                          readonly name: string;
                        } | null;
                      }
                    | {
                        readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                        readonly id: number;
                        readonly title: string;
                        readonly description?: any | null;
                        readonly archived: boolean;
                        readonly answersExist: boolean;
                        readonly comment: AssessmentQuestionComment;
                        readonly responses: AssessmentQuestionResponses;
                        readonly responseVisibility: AssessmentQuestionResponseVisibility;
                        readonly questionType: AssessmentQuestionType;
                        readonly created: string;
                        readonly startValue: number;
                        readonly endValue: number;
                        readonly labels: ReadonlyArray<string | null>;
                        readonly labelDescriptions: ReadonlyArray<
                          string | null
                        >;
                        readonly canUpdate: {
                          readonly __typename: "PermissionNode";
                          readonly permission: boolean;
                          readonly reason: string;
                        };
                        readonly canDelete: {
                          readonly __typename: "PermissionNode";
                          readonly permission: boolean;
                          readonly reason: string;
                        };
                        readonly categories: {
                          readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                          readonly edges: ReadonlyArray<{
                            readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                            readonly node?: {
                              readonly __typename: "AssessmentQuestionCategoryNode";
                              readonly id: number;
                              readonly title: string;
                            } | null;
                          } | null>;
                        };
                        readonly creator?: {
                          readonly __typename: "UserNode";
                          readonly id: number;
                          readonly name: string;
                        } | null;
                      }
                    | {
                        readonly __typename: "IndividualGoalAssessmentQuestionNode";
                        readonly id: number;
                        readonly title: string;
                        readonly description?: any | null;
                        readonly archived: boolean;
                        readonly answersExist: boolean;
                        readonly comment: AssessmentQuestionComment;
                        readonly responses: AssessmentQuestionResponses;
                        readonly responseVisibility: AssessmentQuestionResponseVisibility;
                        readonly questionType: AssessmentQuestionType;
                        readonly created: string;
                        readonly startValue: number;
                        readonly endValue: number;
                        readonly labels: ReadonlyArray<string | null>;
                        readonly labelDescriptions: ReadonlyArray<
                          string | null
                        >;
                        readonly canUpdate: {
                          readonly __typename: "PermissionNode";
                          readonly permission: boolean;
                          readonly reason: string;
                        };
                        readonly canDelete: {
                          readonly __typename: "PermissionNode";
                          readonly permission: boolean;
                          readonly reason: string;
                        };
                        readonly categories: {
                          readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                          readonly edges: ReadonlyArray<{
                            readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                            readonly node?: {
                              readonly __typename: "AssessmentQuestionCategoryNode";
                              readonly id: number;
                              readonly title: string;
                            } | null;
                          } | null>;
                        };
                        readonly creator?: {
                          readonly __typename: "UserNode";
                          readonly id: number;
                          readonly name: string;
                        } | null;
                      }
                    | {
                        readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                        readonly id: number;
                        readonly title: string;
                        readonly description?: any | null;
                        readonly archived: boolean;
                        readonly answersExist: boolean;
                        readonly comment: AssessmentQuestionComment;
                        readonly responses: AssessmentQuestionResponses;
                        readonly responseVisibility: AssessmentQuestionResponseVisibility;
                        readonly questionType: AssessmentQuestionType;
                        readonly created: string;
                        readonly startValue: number;
                        readonly endValue: number;
                        readonly labels: ReadonlyArray<string | null>;
                        readonly labelDescriptions: ReadonlyArray<
                          string | null
                        >;
                        readonly canUpdate: {
                          readonly __typename: "PermissionNode";
                          readonly permission: boolean;
                          readonly reason: string;
                        };
                        readonly canDelete: {
                          readonly __typename: "PermissionNode";
                          readonly permission: boolean;
                          readonly reason: string;
                        };
                        readonly categories: {
                          readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                          readonly edges: ReadonlyArray<{
                            readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                            readonly node?: {
                              readonly __typename: "AssessmentQuestionCategoryNode";
                              readonly id: number;
                              readonly title: string;
                            } | null;
                          } | null>;
                        };
                        readonly creator?: {
                          readonly __typename: "UserNode";
                          readonly id: number;
                          readonly name: string;
                        } | null;
                      }
                    | {
                        readonly __typename: "MultiChoiceAssessmentQuestionNode";
                        readonly id: number;
                        readonly title: string;
                        readonly description?: any | null;
                        readonly archived: boolean;
                        readonly answersExist: boolean;
                        readonly comment: AssessmentQuestionComment;
                        readonly responses: AssessmentQuestionResponses;
                        readonly responseVisibility: AssessmentQuestionResponseVisibility;
                        readonly questionType: AssessmentQuestionType;
                        readonly created: string;
                        readonly options: ReadonlyArray<string | null>;
                        readonly optionDescriptions: ReadonlyArray<
                          string | null
                        >;
                        readonly canUpdate: {
                          readonly __typename: "PermissionNode";
                          readonly permission: boolean;
                          readonly reason: string;
                        };
                        readonly canDelete: {
                          readonly __typename: "PermissionNode";
                          readonly permission: boolean;
                          readonly reason: string;
                        };
                        readonly categories: {
                          readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                          readonly edges: ReadonlyArray<{
                            readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                            readonly node?: {
                              readonly __typename: "AssessmentQuestionCategoryNode";
                              readonly id: number;
                              readonly title: string;
                            } | null;
                          } | null>;
                        };
                        readonly creator?: {
                          readonly __typename: "UserNode";
                          readonly id: number;
                          readonly name: string;
                        } | null;
                      }
                    | {
                        readonly __typename: "NpsAssessmentQuestionNode";
                        readonly id: number;
                        readonly title: string;
                        readonly description?: any | null;
                        readonly archived: boolean;
                        readonly answersExist: boolean;
                        readonly comment: AssessmentQuestionComment;
                        readonly responses: AssessmentQuestionResponses;
                        readonly responseVisibility: AssessmentQuestionResponseVisibility;
                        readonly questionType: AssessmentQuestionType;
                        readonly created: string;
                        readonly canUpdate: {
                          readonly __typename: "PermissionNode";
                          readonly permission: boolean;
                          readonly reason: string;
                        };
                        readonly canDelete: {
                          readonly __typename: "PermissionNode";
                          readonly permission: boolean;
                          readonly reason: string;
                        };
                        readonly categories: {
                          readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                          readonly edges: ReadonlyArray<{
                            readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                            readonly node?: {
                              readonly __typename: "AssessmentQuestionCategoryNode";
                              readonly id: number;
                              readonly title: string;
                            } | null;
                          } | null>;
                        };
                        readonly creator?: {
                          readonly __typename: "UserNode";
                          readonly id: number;
                          readonly name: string;
                        } | null;
                      }
                    | {
                        readonly __typename: "OverallGoalAssessmentQuestionNode";
                        readonly id: number;
                        readonly title: string;
                        readonly description?: any | null;
                        readonly archived: boolean;
                        readonly answersExist: boolean;
                        readonly comment: AssessmentQuestionComment;
                        readonly responses: AssessmentQuestionResponses;
                        readonly responseVisibility: AssessmentQuestionResponseVisibility;
                        readonly questionType: AssessmentQuestionType;
                        readonly created: string;
                        readonly startValue: number;
                        readonly endValue: number;
                        readonly labels: ReadonlyArray<string | null>;
                        readonly labelDescriptions: ReadonlyArray<
                          string | null
                        >;
                        readonly canUpdate: {
                          readonly __typename: "PermissionNode";
                          readonly permission: boolean;
                          readonly reason: string;
                        };
                        readonly canDelete: {
                          readonly __typename: "PermissionNode";
                          readonly permission: boolean;
                          readonly reason: string;
                        };
                        readonly categories: {
                          readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                          readonly edges: ReadonlyArray<{
                            readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                            readonly node?: {
                              readonly __typename: "AssessmentQuestionCategoryNode";
                              readonly id: number;
                              readonly title: string;
                            } | null;
                          } | null>;
                        };
                        readonly creator?: {
                          readonly __typename: "UserNode";
                          readonly id: number;
                          readonly name: string;
                        } | null;
                      }
                    | {
                        readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                        readonly id: number;
                        readonly title: string;
                        readonly description?: any | null;
                        readonly archived: boolean;
                        readonly answersExist: boolean;
                        readonly comment: AssessmentQuestionComment;
                        readonly responses: AssessmentQuestionResponses;
                        readonly responseVisibility: AssessmentQuestionResponseVisibility;
                        readonly questionType: AssessmentQuestionType;
                        readonly created: string;
                        readonly startValue: number;
                        readonly endValue: number;
                        readonly labels: ReadonlyArray<string | null>;
                        readonly labelDescriptions: ReadonlyArray<
                          string | null
                        >;
                        readonly canUpdate: {
                          readonly __typename: "PermissionNode";
                          readonly permission: boolean;
                          readonly reason: string;
                        };
                        readonly canDelete: {
                          readonly __typename: "PermissionNode";
                          readonly permission: boolean;
                          readonly reason: string;
                        };
                        readonly categories: {
                          readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                          readonly edges: ReadonlyArray<{
                            readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                            readonly node?: {
                              readonly __typename: "AssessmentQuestionCategoryNode";
                              readonly id: number;
                              readonly title: string;
                            } | null;
                          } | null>;
                        };
                        readonly creator?: {
                          readonly __typename: "UserNode";
                          readonly id: number;
                          readonly name: string;
                        } | null;
                      }
                    | {
                        readonly __typename: "RangeAssessmentQuestionNode";
                        readonly id: number;
                        readonly title: string;
                        readonly description?: any | null;
                        readonly archived: boolean;
                        readonly answersExist: boolean;
                        readonly comment: AssessmentQuestionComment;
                        readonly responses: AssessmentQuestionResponses;
                        readonly responseVisibility: AssessmentQuestionResponseVisibility;
                        readonly questionType: AssessmentQuestionType;
                        readonly created: string;
                        readonly startValue: number;
                        readonly endValue: number;
                        readonly labels: ReadonlyArray<string | null>;
                        readonly labelDescriptions: ReadonlyArray<
                          string | null
                        >;
                        readonly canUpdate: {
                          readonly __typename: "PermissionNode";
                          readonly permission: boolean;
                          readonly reason: string;
                        };
                        readonly canDelete: {
                          readonly __typename: "PermissionNode";
                          readonly permission: boolean;
                          readonly reason: string;
                        };
                        readonly categories: {
                          readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                          readonly edges: ReadonlyArray<{
                            readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                            readonly node?: {
                              readonly __typename: "AssessmentQuestionCategoryNode";
                              readonly id: number;
                              readonly title: string;
                            } | null;
                          } | null>;
                        };
                        readonly creator?: {
                          readonly __typename: "UserNode";
                          readonly id: number;
                          readonly name: string;
                        } | null;
                      }
                    | {
                        readonly __typename: "ResponsibilityAssessmentQuestionNode";
                        readonly id: number;
                        readonly title: string;
                        readonly description?: any | null;
                        readonly archived: boolean;
                        readonly answersExist: boolean;
                        readonly comment: AssessmentQuestionComment;
                        readonly responses: AssessmentQuestionResponses;
                        readonly responseVisibility: AssessmentQuestionResponseVisibility;
                        readonly questionType: AssessmentQuestionType;
                        readonly created: string;
                        readonly startValue: number;
                        readonly endValue: number;
                        readonly labels: ReadonlyArray<string | null>;
                        readonly labelDescriptions: ReadonlyArray<
                          string | null
                        >;
                        readonly canUpdate: {
                          readonly __typename: "PermissionNode";
                          readonly permission: boolean;
                          readonly reason: string;
                        };
                        readonly canDelete: {
                          readonly __typename: "PermissionNode";
                          readonly permission: boolean;
                          readonly reason: string;
                        };
                        readonly categories: {
                          readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                          readonly edges: ReadonlyArray<{
                            readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                            readonly node?: {
                              readonly __typename: "AssessmentQuestionCategoryNode";
                              readonly id: number;
                              readonly title: string;
                            } | null;
                          } | null>;
                        };
                        readonly creator?: {
                          readonly __typename: "UserNode";
                          readonly id: number;
                          readonly name: string;
                        } | null;
                      }
                    | {
                        readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                        readonly id: number;
                        readonly title: string;
                        readonly description?: any | null;
                        readonly archived: boolean;
                        readonly answersExist: boolean;
                        readonly comment: AssessmentQuestionComment;
                        readonly responses: AssessmentQuestionResponses;
                        readonly responseVisibility: AssessmentQuestionResponseVisibility;
                        readonly questionType: AssessmentQuestionType;
                        readonly created: string;
                        readonly startValue: number;
                        readonly endValue: number;
                        readonly labels: ReadonlyArray<string | null>;
                        readonly labelDescriptions: ReadonlyArray<
                          string | null
                        >;
                        readonly canUpdate: {
                          readonly __typename: "PermissionNode";
                          readonly permission: boolean;
                          readonly reason: string;
                        };
                        readonly canDelete: {
                          readonly __typename: "PermissionNode";
                          readonly permission: boolean;
                          readonly reason: string;
                        };
                        readonly categories: {
                          readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                          readonly edges: ReadonlyArray<{
                            readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                            readonly node?: {
                              readonly __typename: "AssessmentQuestionCategoryNode";
                              readonly id: number;
                              readonly title: string;
                            } | null;
                          } | null>;
                        };
                        readonly creator?: {
                          readonly __typename: "UserNode";
                          readonly id: number;
                          readonly name: string;
                        } | null;
                      }
                    | {
                        readonly __typename: "TextAssessmentQuestionNode";
                        readonly id: number;
                        readonly title: string;
                        readonly description?: any | null;
                        readonly archived: boolean;
                        readonly answersExist: boolean;
                        readonly comment: AssessmentQuestionComment;
                        readonly responses: AssessmentQuestionResponses;
                        readonly responseVisibility: AssessmentQuestionResponseVisibility;
                        readonly questionType: AssessmentQuestionType;
                        readonly created: string;
                        readonly canUpdate: {
                          readonly __typename: "PermissionNode";
                          readonly permission: boolean;
                          readonly reason: string;
                        };
                        readonly canDelete: {
                          readonly __typename: "PermissionNode";
                          readonly permission: boolean;
                          readonly reason: string;
                        };
                        readonly categories: {
                          readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                          readonly edges: ReadonlyArray<{
                            readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                            readonly node?: {
                              readonly __typename: "AssessmentQuestionCategoryNode";
                              readonly id: number;
                              readonly title: string;
                            } | null;
                          } | null>;
                        };
                        readonly creator?: {
                          readonly __typename: "UserNode";
                          readonly id: number;
                          readonly name: string;
                        } | null;
                      };
                } | null;
              } | null>;
            };
          } | null;
        } | null>;
      };
    } | null;
  } | null;
};

export type CreateProgramScheduledReminderMutationMutationVariables = Exact<{
  complianceProgramId: Scalars["Int"]["input"];
  message: Scalars["String"]["input"];
  nominations: Scalars["Boolean"]["input"];
  oneonone: Scalars["Boolean"]["input"];
  performanceAssessment: Scalars["Boolean"]["input"];
  performanceSelfAssessment: Scalars["Boolean"]["input"];
  managerAssessment: Scalars["Boolean"]["input"];
  peerAssessment: Scalars["Boolean"]["input"];
  engagementSurvey: Scalars["Boolean"]["input"];
  emailNotification: Scalars["Boolean"]["input"];
  slackNotification: Scalars["Boolean"]["input"];
  teamsNotification?: InputMaybe<Scalars["Boolean"]["input"]>;
  daysAfterStartDate: Scalars["Int"]["input"];
  sendNow?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type CreateProgramScheduledReminderMutationMutation = {
  readonly __typename: "Mutation";
  readonly createComplianceProgramScheduledReminder?: {
    readonly __typename: "CreateComplianceProgramScheduledReminderMutation";
    readonly complianceProgram?: {
      readonly __typename: "ComplianceProgramNode";
      readonly id: number;
    } | null;
    readonly reminder?: {
      readonly __typename: "ComplianceProgramScheduledReminderNode";
      readonly id: number;
    } | null;
  } | null;
};

export type DeleteProgramMutationVariables = Exact<{
  complianceProgramId: Scalars["Int"]["input"];
}>;

export type DeleteProgramMutation = {
  readonly __typename: "Mutation";
  readonly deleteComplianceProgram?: {
    readonly __typename: "DeleteComplianceProgramMutation";
    readonly organization?: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
    } | null;
  } | null;
};

export type DeleteComplianceProgramScheduledReminderMutationMutationVariables =
  Exact<{
    reminderId: Scalars["Int"]["input"];
  }>;

export type DeleteComplianceProgramScheduledReminderMutationMutation = {
  readonly __typename: "Mutation";
  readonly deleteComplianceProgramScheduledReminder?: {
    readonly __typename: "DeleteComplianceProgramScheduledReminderMutation";
    readonly complianceProgram?: {
      readonly __typename: "ComplianceProgramNode";
      readonly id: number;
      readonly scheduledReminders: {
        readonly __typename: "ComplianceProgramScheduledReminderNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "ComplianceProgramScheduledReminderNodeEdge";
          readonly node?: {
            readonly __typename: "ComplianceProgramScheduledReminderNode";
            readonly id: number;
          } | null;
        } | null>;
      };
    } | null;
  } | null;
};

export type ExportComplianceProgramToCsvMutationMutationVariables = Exact<{
  complianceProgramId: Scalars["Int"]["input"];
}>;

export type ExportComplianceProgramToCsvMutationMutation = {
  readonly __typename: "Mutation";
  readonly exportComplianceProgramToCsv?: {
    readonly __typename: "ExportComplianceProgramToCSV";
    readonly complianceProgram?: {
      readonly __typename: "ComplianceProgramNode";
      readonly id: number;
    } | null;
  } | null;
};

export type GetAssessmentGroupForSidebarQueryVariables = Exact<{
  assessmentGroupId: Scalars["Int"]["input"];
}>;

export type GetAssessmentGroupForSidebarQuery = {
  readonly __typename: "Query";
  readonly assessmentGroup?: {
    readonly __typename: "AssessmentGroupNode";
    readonly id: number;
    readonly title: string;
    readonly created: string;
    readonly archived: boolean;
    readonly isOnlySelfAssessment: boolean;
    readonly hasNpsQuestions: boolean;
    readonly assessmentType: AssessmentType;
    readonly creator?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
    } | null;
    readonly canUpdate?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    } | null;
    readonly canDelete?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    } | null;
    readonly sections: {
      readonly __typename: "AssessmentGroupSectionNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AssessmentGroupSectionNodeEdge";
        readonly node?: {
          readonly __typename: "AssessmentGroupSectionNode";
          readonly id: number;
          readonly title?: string | null;
          readonly description?: any | null;
          readonly questions: {
            readonly __typename: "AssessmentGroupQuestionContainerConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "AssessmentGroupQuestionContainerEdge";
              readonly node?: {
                readonly __typename: "AssessmentGroupQuestionContainer";
                readonly id: number;
                readonly question:
                  | {
                      readonly __typename: "CompetencyAssessmentQuestionNode";
                      readonly id: number;
                      readonly title: string;
                      readonly description?: any | null;
                      readonly archived: boolean;
                      readonly answersExist: boolean;
                      readonly comment: AssessmentQuestionComment;
                      readonly responses: AssessmentQuestionResponses;
                      readonly responseVisibility: AssessmentQuestionResponseVisibility;
                      readonly questionType: AssessmentQuestionType;
                      readonly created: string;
                      readonly startValue: number;
                      readonly endValue: number;
                      readonly labels: ReadonlyArray<string | null>;
                      readonly labelDescriptions: ReadonlyArray<string | null>;
                      readonly canUpdate: {
                        readonly __typename: "PermissionNode";
                        readonly permission: boolean;
                        readonly reason: string;
                      };
                      readonly canDelete: {
                        readonly __typename: "PermissionNode";
                        readonly permission: boolean;
                        readonly reason: string;
                      };
                      readonly categories: {
                        readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                        readonly edges: ReadonlyArray<{
                          readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                          readonly node?: {
                            readonly __typename: "AssessmentQuestionCategoryNode";
                            readonly id: number;
                            readonly title: string;
                          } | null;
                        } | null>;
                      };
                      readonly creator?: {
                        readonly __typename: "UserNode";
                        readonly id: number;
                        readonly name: string;
                      } | null;
                    }
                  | {
                      readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                      readonly id: number;
                      readonly title: string;
                      readonly description?: any | null;
                      readonly archived: boolean;
                      readonly answersExist: boolean;
                      readonly comment: AssessmentQuestionComment;
                      readonly responses: AssessmentQuestionResponses;
                      readonly responseVisibility: AssessmentQuestionResponseVisibility;
                      readonly questionType: AssessmentQuestionType;
                      readonly created: string;
                      readonly startValue: number;
                      readonly endValue: number;
                      readonly labels: ReadonlyArray<string | null>;
                      readonly labelDescriptions: ReadonlyArray<string | null>;
                      readonly canUpdate: {
                        readonly __typename: "PermissionNode";
                        readonly permission: boolean;
                        readonly reason: string;
                      };
                      readonly canDelete: {
                        readonly __typename: "PermissionNode";
                        readonly permission: boolean;
                        readonly reason: string;
                      };
                      readonly categories: {
                        readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                        readonly edges: ReadonlyArray<{
                          readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                          readonly node?: {
                            readonly __typename: "AssessmentQuestionCategoryNode";
                            readonly id: number;
                            readonly title: string;
                          } | null;
                        } | null>;
                      };
                      readonly creator?: {
                        readonly __typename: "UserNode";
                        readonly id: number;
                        readonly name: string;
                      } | null;
                    }
                  | {
                      readonly __typename: "IndividualGoalAssessmentQuestionNode";
                      readonly id: number;
                      readonly title: string;
                      readonly description?: any | null;
                      readonly archived: boolean;
                      readonly answersExist: boolean;
                      readonly comment: AssessmentQuestionComment;
                      readonly responses: AssessmentQuestionResponses;
                      readonly responseVisibility: AssessmentQuestionResponseVisibility;
                      readonly questionType: AssessmentQuestionType;
                      readonly created: string;
                      readonly startValue: number;
                      readonly endValue: number;
                      readonly labels: ReadonlyArray<string | null>;
                      readonly labelDescriptions: ReadonlyArray<string | null>;
                      readonly canUpdate: {
                        readonly __typename: "PermissionNode";
                        readonly permission: boolean;
                        readonly reason: string;
                      };
                      readonly canDelete: {
                        readonly __typename: "PermissionNode";
                        readonly permission: boolean;
                        readonly reason: string;
                      };
                      readonly categories: {
                        readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                        readonly edges: ReadonlyArray<{
                          readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                          readonly node?: {
                            readonly __typename: "AssessmentQuestionCategoryNode";
                            readonly id: number;
                            readonly title: string;
                          } | null;
                        } | null>;
                      };
                      readonly creator?: {
                        readonly __typename: "UserNode";
                        readonly id: number;
                        readonly name: string;
                      } | null;
                    }
                  | {
                      readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                      readonly id: number;
                      readonly title: string;
                      readonly description?: any | null;
                      readonly archived: boolean;
                      readonly answersExist: boolean;
                      readonly comment: AssessmentQuestionComment;
                      readonly responses: AssessmentQuestionResponses;
                      readonly responseVisibility: AssessmentQuestionResponseVisibility;
                      readonly questionType: AssessmentQuestionType;
                      readonly created: string;
                      readonly startValue: number;
                      readonly endValue: number;
                      readonly labels: ReadonlyArray<string | null>;
                      readonly labelDescriptions: ReadonlyArray<string | null>;
                      readonly canUpdate: {
                        readonly __typename: "PermissionNode";
                        readonly permission: boolean;
                        readonly reason: string;
                      };
                      readonly canDelete: {
                        readonly __typename: "PermissionNode";
                        readonly permission: boolean;
                        readonly reason: string;
                      };
                      readonly categories: {
                        readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                        readonly edges: ReadonlyArray<{
                          readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                          readonly node?: {
                            readonly __typename: "AssessmentQuestionCategoryNode";
                            readonly id: number;
                            readonly title: string;
                          } | null;
                        } | null>;
                      };
                      readonly creator?: {
                        readonly __typename: "UserNode";
                        readonly id: number;
                        readonly name: string;
                      } | null;
                    }
                  | {
                      readonly __typename: "MultiChoiceAssessmentQuestionNode";
                      readonly id: number;
                      readonly title: string;
                      readonly description?: any | null;
                      readonly archived: boolean;
                      readonly answersExist: boolean;
                      readonly comment: AssessmentQuestionComment;
                      readonly responses: AssessmentQuestionResponses;
                      readonly responseVisibility: AssessmentQuestionResponseVisibility;
                      readonly questionType: AssessmentQuestionType;
                      readonly created: string;
                      readonly options: ReadonlyArray<string | null>;
                      readonly optionDescriptions: ReadonlyArray<string | null>;
                      readonly canUpdate: {
                        readonly __typename: "PermissionNode";
                        readonly permission: boolean;
                        readonly reason: string;
                      };
                      readonly canDelete: {
                        readonly __typename: "PermissionNode";
                        readonly permission: boolean;
                        readonly reason: string;
                      };
                      readonly categories: {
                        readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                        readonly edges: ReadonlyArray<{
                          readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                          readonly node?: {
                            readonly __typename: "AssessmentQuestionCategoryNode";
                            readonly id: number;
                            readonly title: string;
                          } | null;
                        } | null>;
                      };
                      readonly creator?: {
                        readonly __typename: "UserNode";
                        readonly id: number;
                        readonly name: string;
                      } | null;
                    }
                  | {
                      readonly __typename: "NpsAssessmentQuestionNode";
                      readonly id: number;
                      readonly title: string;
                      readonly description?: any | null;
                      readonly archived: boolean;
                      readonly answersExist: boolean;
                      readonly comment: AssessmentQuestionComment;
                      readonly responses: AssessmentQuestionResponses;
                      readonly responseVisibility: AssessmentQuestionResponseVisibility;
                      readonly questionType: AssessmentQuestionType;
                      readonly created: string;
                      readonly canUpdate: {
                        readonly __typename: "PermissionNode";
                        readonly permission: boolean;
                        readonly reason: string;
                      };
                      readonly canDelete: {
                        readonly __typename: "PermissionNode";
                        readonly permission: boolean;
                        readonly reason: string;
                      };
                      readonly categories: {
                        readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                        readonly edges: ReadonlyArray<{
                          readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                          readonly node?: {
                            readonly __typename: "AssessmentQuestionCategoryNode";
                            readonly id: number;
                            readonly title: string;
                          } | null;
                        } | null>;
                      };
                      readonly creator?: {
                        readonly __typename: "UserNode";
                        readonly id: number;
                        readonly name: string;
                      } | null;
                    }
                  | {
                      readonly __typename: "OverallGoalAssessmentQuestionNode";
                      readonly id: number;
                      readonly title: string;
                      readonly description?: any | null;
                      readonly archived: boolean;
                      readonly answersExist: boolean;
                      readonly comment: AssessmentQuestionComment;
                      readonly responses: AssessmentQuestionResponses;
                      readonly responseVisibility: AssessmentQuestionResponseVisibility;
                      readonly questionType: AssessmentQuestionType;
                      readonly created: string;
                      readonly startValue: number;
                      readonly endValue: number;
                      readonly labels: ReadonlyArray<string | null>;
                      readonly labelDescriptions: ReadonlyArray<string | null>;
                      readonly canUpdate: {
                        readonly __typename: "PermissionNode";
                        readonly permission: boolean;
                        readonly reason: string;
                      };
                      readonly canDelete: {
                        readonly __typename: "PermissionNode";
                        readonly permission: boolean;
                        readonly reason: string;
                      };
                      readonly categories: {
                        readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                        readonly edges: ReadonlyArray<{
                          readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                          readonly node?: {
                            readonly __typename: "AssessmentQuestionCategoryNode";
                            readonly id: number;
                            readonly title: string;
                          } | null;
                        } | null>;
                      };
                      readonly creator?: {
                        readonly __typename: "UserNode";
                        readonly id: number;
                        readonly name: string;
                      } | null;
                    }
                  | {
                      readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                      readonly id: number;
                      readonly title: string;
                      readonly description?: any | null;
                      readonly archived: boolean;
                      readonly answersExist: boolean;
                      readonly comment: AssessmentQuestionComment;
                      readonly responses: AssessmentQuestionResponses;
                      readonly responseVisibility: AssessmentQuestionResponseVisibility;
                      readonly questionType: AssessmentQuestionType;
                      readonly created: string;
                      readonly startValue: number;
                      readonly endValue: number;
                      readonly labels: ReadonlyArray<string | null>;
                      readonly labelDescriptions: ReadonlyArray<string | null>;
                      readonly canUpdate: {
                        readonly __typename: "PermissionNode";
                        readonly permission: boolean;
                        readonly reason: string;
                      };
                      readonly canDelete: {
                        readonly __typename: "PermissionNode";
                        readonly permission: boolean;
                        readonly reason: string;
                      };
                      readonly categories: {
                        readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                        readonly edges: ReadonlyArray<{
                          readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                          readonly node?: {
                            readonly __typename: "AssessmentQuestionCategoryNode";
                            readonly id: number;
                            readonly title: string;
                          } | null;
                        } | null>;
                      };
                      readonly creator?: {
                        readonly __typename: "UserNode";
                        readonly id: number;
                        readonly name: string;
                      } | null;
                    }
                  | {
                      readonly __typename: "RangeAssessmentQuestionNode";
                      readonly id: number;
                      readonly title: string;
                      readonly description?: any | null;
                      readonly archived: boolean;
                      readonly answersExist: boolean;
                      readonly comment: AssessmentQuestionComment;
                      readonly responses: AssessmentQuestionResponses;
                      readonly responseVisibility: AssessmentQuestionResponseVisibility;
                      readonly questionType: AssessmentQuestionType;
                      readonly created: string;
                      readonly startValue: number;
                      readonly endValue: number;
                      readonly labels: ReadonlyArray<string | null>;
                      readonly labelDescriptions: ReadonlyArray<string | null>;
                      readonly canUpdate: {
                        readonly __typename: "PermissionNode";
                        readonly permission: boolean;
                        readonly reason: string;
                      };
                      readonly canDelete: {
                        readonly __typename: "PermissionNode";
                        readonly permission: boolean;
                        readonly reason: string;
                      };
                      readonly categories: {
                        readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                        readonly edges: ReadonlyArray<{
                          readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                          readonly node?: {
                            readonly __typename: "AssessmentQuestionCategoryNode";
                            readonly id: number;
                            readonly title: string;
                          } | null;
                        } | null>;
                      };
                      readonly creator?: {
                        readonly __typename: "UserNode";
                        readonly id: number;
                        readonly name: string;
                      } | null;
                    }
                  | {
                      readonly __typename: "ResponsibilityAssessmentQuestionNode";
                      readonly id: number;
                      readonly title: string;
                      readonly description?: any | null;
                      readonly archived: boolean;
                      readonly answersExist: boolean;
                      readonly comment: AssessmentQuestionComment;
                      readonly responses: AssessmentQuestionResponses;
                      readonly responseVisibility: AssessmentQuestionResponseVisibility;
                      readonly questionType: AssessmentQuestionType;
                      readonly created: string;
                      readonly startValue: number;
                      readonly endValue: number;
                      readonly labels: ReadonlyArray<string | null>;
                      readonly labelDescriptions: ReadonlyArray<string | null>;
                      readonly canUpdate: {
                        readonly __typename: "PermissionNode";
                        readonly permission: boolean;
                        readonly reason: string;
                      };
                      readonly canDelete: {
                        readonly __typename: "PermissionNode";
                        readonly permission: boolean;
                        readonly reason: string;
                      };
                      readonly categories: {
                        readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                        readonly edges: ReadonlyArray<{
                          readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                          readonly node?: {
                            readonly __typename: "AssessmentQuestionCategoryNode";
                            readonly id: number;
                            readonly title: string;
                          } | null;
                        } | null>;
                      };
                      readonly creator?: {
                        readonly __typename: "UserNode";
                        readonly id: number;
                        readonly name: string;
                      } | null;
                    }
                  | {
                      readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                      readonly id: number;
                      readonly title: string;
                      readonly description?: any | null;
                      readonly archived: boolean;
                      readonly answersExist: boolean;
                      readonly comment: AssessmentQuestionComment;
                      readonly responses: AssessmentQuestionResponses;
                      readonly responseVisibility: AssessmentQuestionResponseVisibility;
                      readonly questionType: AssessmentQuestionType;
                      readonly created: string;
                      readonly startValue: number;
                      readonly endValue: number;
                      readonly labels: ReadonlyArray<string | null>;
                      readonly labelDescriptions: ReadonlyArray<string | null>;
                      readonly canUpdate: {
                        readonly __typename: "PermissionNode";
                        readonly permission: boolean;
                        readonly reason: string;
                      };
                      readonly canDelete: {
                        readonly __typename: "PermissionNode";
                        readonly permission: boolean;
                        readonly reason: string;
                      };
                      readonly categories: {
                        readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                        readonly edges: ReadonlyArray<{
                          readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                          readonly node?: {
                            readonly __typename: "AssessmentQuestionCategoryNode";
                            readonly id: number;
                            readonly title: string;
                          } | null;
                        } | null>;
                      };
                      readonly creator?: {
                        readonly __typename: "UserNode";
                        readonly id: number;
                        readonly name: string;
                      } | null;
                    }
                  | {
                      readonly __typename: "TextAssessmentQuestionNode";
                      readonly id: number;
                      readonly title: string;
                      readonly description?: any | null;
                      readonly archived: boolean;
                      readonly answersExist: boolean;
                      readonly comment: AssessmentQuestionComment;
                      readonly responses: AssessmentQuestionResponses;
                      readonly responseVisibility: AssessmentQuestionResponseVisibility;
                      readonly questionType: AssessmentQuestionType;
                      readonly created: string;
                      readonly canUpdate: {
                        readonly __typename: "PermissionNode";
                        readonly permission: boolean;
                        readonly reason: string;
                      };
                      readonly canDelete: {
                        readonly __typename: "PermissionNode";
                        readonly permission: boolean;
                        readonly reason: string;
                      };
                      readonly categories: {
                        readonly __typename: "AssessmentQuestionCategoryNodeConnection";
                        readonly edges: ReadonlyArray<{
                          readonly __typename: "AssessmentQuestionCategoryNodeEdge";
                          readonly node?: {
                            readonly __typename: "AssessmentQuestionCategoryNode";
                            readonly id: number;
                            readonly title: string;
                          } | null;
                        } | null>;
                      };
                      readonly creator?: {
                        readonly __typename: "UserNode";
                        readonly id: number;
                        readonly name: string;
                      } | null;
                    };
              } | null;
            } | null>;
          };
        } | null;
      } | null>;
    };
  } | null;
};

export type UserActivityComplianceProgramMeetingFragment = {
  readonly __typename: "MeetingNode";
  readonly id: number;
  readonly title?: string | null;
  readonly meetingGroupId: number;
  readonly isFinalized: boolean;
  readonly startDatetime?: string | null;
  readonly draft: boolean;
  readonly meetingGroup?: {
    readonly __typename: "MeetingGroupNode";
    readonly id: number;
    readonly topicTemplate?: {
      readonly __typename: "TopicTemplateNode";
      readonly id: number;
    } | null;
  } | null;
  readonly participants?: {
    readonly __typename: "MeetingParticipantConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "MeetingParticipantEdge";
      readonly node?: {
        readonly __typename: "MeetingParticipantNode";
        readonly id?: string | null;
        readonly status?: AttendeeStatus | null;
        readonly user?: {
          readonly __typename: "BasicUserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
          readonly email: string;
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type ComplianceProgramActionAssessmentDeliveryFragment = {
  readonly __typename: "AssessmentDeliveryNode";
  readonly id: number;
  readonly state: AssessmentDeliveryState;
  readonly deliveryDatetime?: string | null;
  readonly lastSubmissionDatetime?: string | null;
  readonly peerRespondersCount?: number | null;
  readonly target?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly email: string;
    readonly firstName: string;
    readonly avatar?: string | null;
  } | null;
  readonly complianceProgram?: {
    readonly __typename: "ComplianceProgramNode";
    readonly id: number;
    readonly title: string;
    readonly dueDate?: string | null;
  } | null;
  readonly nominees: {
    readonly __typename: "UserNodeConnection";
    readonly totalCount: number;
  };
  readonly canUpdate?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  } | null;
};

export type UserActivityComplianceGroupAssessmentTemplateFragment = {
  readonly __typename: "AssessmentTemplateNode";
  readonly id: number;
  readonly assessmentType: AssessmentType;
  readonly hasSelfAssessment: boolean;
  readonly assessments: {
    readonly __typename: "AssessmentNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "AssessmentNodeEdge";
      readonly node?: {
        readonly __typename: "AssessmentNode";
        readonly id: number;
        readonly state: AssessmentState;
        readonly target?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null;
    } | null>;
  };
};

export type GetComplianceProgramActionsQueryVariables = Exact<{
  complianceProgramId: Scalars["Int"]["input"];
  responderId: Scalars["Int"]["input"];
  deliveryTargetIds:
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetComplianceProgramActionsQuery = {
  readonly __typename: "Query";
  readonly calibrationGroups: {
    readonly __typename: "CalibrationGroupNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "CalibrationGroupNodeEdge";
      readonly node?: {
        readonly __typename: "CalibrationGroupNode";
        readonly id: number;
        readonly name: string;
        readonly complianceProgram: {
          readonly __typename: "ComplianceProgramNode";
          readonly id: number;
          readonly title: string;
          readonly calibration: ComplianceProgramCalibrationType;
          readonly dueDate?: string | null;
          readonly ongoing: boolean;
          readonly state: ComplianceProgramState;
        };
      } | null;
    } | null>;
  };
  readonly assessmentsOpenForNominations: {
    readonly __typename: "AssessmentOpenForNominationConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "AssessmentOpenForNominationEdge";
      readonly node?: {
        readonly __typename: "AssessmentOpenForNominationNode";
        readonly id: string;
        readonly nominationsCount: number;
        readonly complianceProgram: {
          readonly __typename: "ComplianceProgramNode";
          readonly id: number;
          readonly title: string;
        };
        readonly assessmentTemplate: {
          readonly __typename: "AssessmentTemplateNode";
          readonly id: number;
          readonly assessmentType: AssessmentType;
        };
        readonly targetUser: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        };
      } | null;
    } | null>;
  };
  readonly assessmentDeliveries: {
    readonly __typename: "AssessmentDeliveryNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "AssessmentDeliveryNodeEdge";
      readonly node?: {
        readonly __typename: "AssessmentDeliveryNode";
        readonly id: number;
        readonly state: AssessmentDeliveryState;
        readonly deliveryDatetime?: string | null;
        readonly lastSubmissionDatetime?: string | null;
        readonly peerRespondersCount?: number | null;
        readonly target?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly email: string;
          readonly firstName: string;
          readonly avatar?: string | null;
        } | null;
        readonly complianceProgram?: {
          readonly __typename: "ComplianceProgramNode";
          readonly id: number;
          readonly title: string;
          readonly dueDate?: string | null;
        } | null;
        readonly nominees: {
          readonly __typename: "UserNodeConnection";
          readonly totalCount: number;
        };
        readonly canUpdate?: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        } | null;
      } | null;
    } | null>;
  };
  readonly complianceProgram?: {
    readonly __typename: "ComplianceProgramNode";
    readonly id: number;
    readonly title: string;
    readonly dueDate?: string | null;
    readonly startDate?: string | null;
    readonly ongoing: boolean;
    readonly state: ComplianceProgramState;
    readonly appliesTo: ComplianceProgramAppliesTo;
    readonly excludedHireDateAfter?: string | null;
    readonly canUpdate?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    } | null;
    readonly appliesToTeams: {
      readonly __typename: "TeamNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "TeamNodeEdge";
        readonly node?: {
          readonly __typename: "TeamNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null>;
    };
    readonly appliesToManagers: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null>;
    };
    readonly appliesToUsers: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null>;
    };
    readonly excludedUsers: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null>;
    };
    readonly requiredTopicTemplates: {
      readonly __typename: "TopicTemplateNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "TopicTemplateNodeEdge";
        readonly node?: {
          readonly __typename: "TopicTemplateNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null>;
    };
    readonly matchingOneonones?: {
      readonly __typename: "MeetingNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "MeetingNodeEdge";
        readonly node?: {
          readonly __typename: "MeetingNode";
          readonly id: number;
          readonly title?: string | null;
          readonly meetingGroupId: number;
          readonly isFinalized: boolean;
          readonly startDatetime?: string | null;
          readonly draft: boolean;
          readonly meetingGroup?: {
            readonly __typename: "MeetingGroupNode";
            readonly id: number;
            readonly topicTemplate?: {
              readonly __typename: "TopicTemplateNode";
              readonly id: number;
            } | null;
          } | null;
          readonly participants?: {
            readonly __typename: "MeetingParticipantConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "MeetingParticipantEdge";
              readonly node?: {
                readonly __typename: "MeetingParticipantNode";
                readonly id?: string | null;
                readonly status?: AttendeeStatus | null;
                readonly user?: {
                  readonly __typename: "BasicUserNode";
                  readonly id: number;
                  readonly name: string;
                  readonly avatar?: string | null;
                  readonly email: string;
                } | null;
              } | null;
            } | null>;
          } | null;
        } | null;
      } | null>;
    } | null;
    readonly usersMissingAssessment: {
      readonly __typename: "MissingAssessmentConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "MissingAssessmentEdge";
        readonly node?: {
          readonly __typename: "MissingAssessmentNode";
          readonly assessmentTemplateId?: number | null;
          readonly dueDate: string;
          readonly responder: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          };
          readonly target?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
          readonly assessmentTemplate: {
            readonly __typename: "AssessmentTemplateNode";
            readonly id: number;
          };
        } | null;
      } | null>;
    };
    readonly performanceAssessmentTemplate?: {
      readonly __typename: "AssessmentTemplateNode";
      readonly id: number;
      readonly assessmentType: AssessmentType;
      readonly hasSelfAssessment: boolean;
      readonly assessments: {
        readonly __typename: "AssessmentNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentNodeEdge";
          readonly node?: {
            readonly __typename: "AssessmentNode";
            readonly id: number;
            readonly state: AssessmentState;
            readonly target?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          } | null;
        } | null>;
      };
    } | null;
    readonly managerAssessmentTemplate?: {
      readonly __typename: "AssessmentTemplateNode";
      readonly id: number;
      readonly assessmentType: AssessmentType;
      readonly hasSelfAssessment: boolean;
      readonly assessments: {
        readonly __typename: "AssessmentNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentNodeEdge";
          readonly node?: {
            readonly __typename: "AssessmentNode";
            readonly id: number;
            readonly state: AssessmentState;
            readonly target?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          } | null;
        } | null>;
      };
    } | null;
    readonly peerAssessmentTemplate?: {
      readonly __typename: "AssessmentTemplateNode";
      readonly id: number;
      readonly assessmentType: AssessmentType;
      readonly hasSelfAssessment: boolean;
      readonly assessments: {
        readonly __typename: "AssessmentNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentNodeEdge";
          readonly node?: {
            readonly __typename: "AssessmentNode";
            readonly id: number;
            readonly state: AssessmentState;
            readonly target?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          } | null;
        } | null>;
      };
    } | null;
    readonly engagementSurveyTemplate?: {
      readonly __typename: "AssessmentTemplateNode";
      readonly id: number;
      readonly assessmentType: AssessmentType;
      readonly hasSelfAssessment: boolean;
      readonly assessments: {
        readonly __typename: "AssessmentNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentNodeEdge";
          readonly node?: {
            readonly __typename: "AssessmentNode";
            readonly id: number;
            readonly state: AssessmentState;
            readonly target?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          } | null;
        } | null>;
      };
    } | null;
    readonly assessments: {
      readonly __typename: "AssessmentNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AssessmentNodeEdge";
        readonly node?: {
          readonly __typename: "AssessmentNode";
          readonly id: number;
          readonly state: AssessmentState;
          readonly assessmentDeliveryState?: AssessmentDeliveryState | null;
          readonly submittedDatetime?: string | null;
          readonly dueDate?: string | null;
          readonly target?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
          readonly responder?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
          readonly template: {
            readonly __typename: "AssessmentTemplateNode";
            readonly id: number;
          };
        } | null;
      } | null>;
    };
    readonly applicableReports: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
          readonly email: string;
        } | null;
      } | null>;
    };
    readonly applicableManagers: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
          readonly email: string;
        } | null;
      } | null>;
    };
  } | null;
};

export type ComplianceProgramAdminParticipantStatusFragment = {
  readonly __typename: "ParticipantStatusNode";
  readonly oneononeStatus: ComplianceProgramParticipantStatus;
  readonly performanceAssessmentStatus: ComplianceProgramParticipantStatus;
  readonly performanceSelfAssessmentStatus: ComplianceProgramParticipantStatus;
  readonly managerAssessmentStatus: ComplianceProgramParticipantStatus;
  readonly managerSelfAssessmentStatus: ComplianceProgramParticipantStatus;
  readonly peerAssessmentStatus: ComplianceProgramParticipantStatus;
  readonly peerSelfAssessmentStatus: ComplianceProgramParticipantStatus;
  readonly meeting?: {
    readonly __typename: "MeetingNode";
    readonly id: number;
    readonly title?: string | null;
    readonly meetingGroupId: number;
  } | null;
  readonly user: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly email: string;
    readonly avatar?: string | null;
    readonly managers: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null>;
    };
  };
};

export type GetComplianceProgramAdminQueryVariables = Exact<{
  complianceProgramId: Scalars["Int"]["input"];
  complianceProgramExists: Scalars["Boolean"]["input"];
  organizationId: Scalars["Int"]["input"];
}>;

export type GetComplianceProgramAdminQuery = {
  readonly __typename: "Query";
  readonly talentIndicators: {
    readonly __typename: "TalentIndicatorNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "TalentIndicatorNodeEdge";
      readonly node?: {
        readonly __typename: "TalentIndicatorNode";
        readonly id: number;
        readonly talentIndicatorType: TalentIndicatorType;
        readonly name: string;
        readonly customName?: string | null;
        readonly questionTitle?: string | null;
        readonly description: any;
        readonly scaleStartsAt: number;
        readonly scale: number;
        readonly labels: ReadonlyArray<string | null>;
        readonly labelDescriptions: ReadonlyArray<string | null>;
        readonly isManagerIndicator: boolean;
        readonly hasLockedLabels: boolean;
        readonly hasAssessmentQuestions: boolean;
      } | null;
    } | null>;
  };
  readonly complianceProgram?: {
    readonly __typename: "ComplianceProgramNode";
    readonly id: number;
    readonly title: string;
    readonly created: string;
    readonly updated: string;
    readonly dueDate?: string | null;
    readonly startDate?: string | null;
    readonly periodStartDate?: string | null;
    readonly periodEndDate?: string | null;
    readonly ongoing: boolean;
    readonly startDateOffset: number;
    readonly startDateDueDateOffset: number;
    readonly startDatePeriodStartOffset: number;
    readonly startDatePeriodEndOffset: number;
    readonly state: ComplianceProgramState;
    readonly recurrence: ComplianceProgramRecurrence;
    readonly calibration: ComplianceProgramCalibrationType;
    readonly appliesTo: ComplianceProgramAppliesTo;
    readonly excludedHireDateAfter?: string | null;
    readonly steps: ReadonlyArray<{
      readonly __typename: "ComplianceProgramStepConfigNode";
      readonly step: ComplianceProgramStep;
      readonly dueDateOffset: number;
    } | null>;
    readonly creator?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly avatar?: string | null;
      readonly email: string;
    } | null;
    readonly canUpdate?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    } | null;
    readonly canDelete?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    } | null;
    readonly canReadDetails: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    };
    readonly appliesToTeams: {
      readonly __typename: "TeamNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "TeamNodeEdge";
        readonly node?: {
          readonly __typename: "TeamNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null>;
    };
    readonly appliesToManagers: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null>;
    };
    readonly appliesToUsers: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null>;
    };
    readonly excludedUsers: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null>;
    };
    readonly requiredTopicTemplates: {
      readonly __typename: "TopicTemplateNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "TopicTemplateNodeEdge";
        readonly node?: {
          readonly __typename: "TopicTemplateNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null>;
    };
    readonly scheduledReminders: {
      readonly __typename: "ComplianceProgramScheduledReminderNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "ComplianceProgramScheduledReminderNodeEdge";
        readonly node?: {
          readonly __typename: "ComplianceProgramScheduledReminderNode";
          readonly id: number;
          readonly message: string;
          readonly daysAfterStartDate: number;
          readonly sentDatetime?: string | null;
          readonly slackNotification: boolean;
          readonly teamsNotification: boolean;
          readonly emailNotification: boolean;
          readonly nominations: boolean;
          readonly oneonone: boolean;
          readonly performanceAssessment: boolean;
          readonly performanceSelfAssessment: boolean;
          readonly peerAssessment: boolean;
          readonly managerAssessment: boolean;
          readonly engagementSurvey: boolean;
        } | null;
      } | null>;
    };
    readonly performanceAssessmentTemplate?: {
      readonly __typename: "AssessmentTemplateNode";
      readonly id: number;
      readonly assessmentType: AssessmentType;
      readonly anonymity: AssessmentGroupAnonymity;
      readonly providers: AssessmentGroupProviders;
      readonly delivery: AssessmentGroupDelivery;
      readonly hasSelfAssessment: boolean;
      readonly isOnlySelfAssessment: boolean;
      readonly enableRoleBasedAssessments: boolean;
      readonly enableGoalAssessments: boolean;
      readonly goalAssessmentScale: number;
      readonly goalAssessmentScaleLabels: ReadonlyArray<string | null>;
      readonly goalAssessmentScaleStartsAt: number;
      readonly goalAssessmentResponses: AssessmentQuestionResponses;
      readonly roleBasedAssessmentsAssessNextRole: boolean;
      readonly roleBasedAssessmentsSelfAssessNextRole: boolean;
      readonly roleBasedAssessmentScale: number;
      readonly roleBasedAssessmentScaleLabels: ReadonlyArray<string | null>;
      readonly roleBasedAssessmentScaleStartsAt: number;
      readonly enableCoreValueAssessments: boolean;
      readonly coreValueAssessmentScale: number;
      readonly coreValueAssessmentScaleLabels: ReadonlyArray<string | null>;
      readonly coreValueAssessmentScaleStartsAt: number;
      readonly coreValueAssessmentResponses: AssessmentQuestionResponses;
      readonly competencyAssessmentType: CompetencyAssessmentType;
      readonly nextRoleCompetencyAssessmentType: CompetencyAssessmentType;
      readonly questionSets: {
        readonly __typename: "AssessmentGroupNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentGroupNodeEdge";
          readonly node?: {
            readonly __typename: "AssessmentGroupNode";
            readonly id: number;
            readonly talentIndicatorQuestionSettings?: {
              readonly __typename: "TalentIndicatorSettingsNode";
              readonly title?: string | null;
              readonly description?: any | null;
              readonly talentIndicators: ReadonlyArray<{
                readonly __typename: "TalentIndicatorQuestionSettingsNode";
                readonly talentIndicatorId: number;
                readonly comment: AssessmentQuestionComment;
                readonly responses: AssessmentQuestionResponses;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly description?: string | null;
              } | null>;
            } | null;
          } | null;
        } | null>;
      };
    } | null;
    readonly managerAssessmentTemplate?: {
      readonly __typename: "AssessmentTemplateNode";
      readonly id: number;
      readonly assessmentType: AssessmentType;
      readonly anonymity: AssessmentGroupAnonymity;
      readonly providers: AssessmentGroupProviders;
      readonly delivery: AssessmentGroupDelivery;
      readonly hasSelfAssessment: boolean;
      readonly isOnlySelfAssessment: boolean;
      readonly questionSets: {
        readonly __typename: "AssessmentGroupNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentGroupNodeEdge";
          readonly node?: {
            readonly __typename: "AssessmentGroupNode";
            readonly id: number;
            readonly talentIndicatorQuestionSettings?: {
              readonly __typename: "TalentIndicatorSettingsNode";
              readonly title?: string | null;
              readonly description?: any | null;
              readonly talentIndicators: ReadonlyArray<{
                readonly __typename: "TalentIndicatorQuestionSettingsNode";
                readonly talentIndicatorId: number;
                readonly comment: AssessmentQuestionComment;
                readonly responses: AssessmentQuestionResponses;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              } | null>;
            } | null;
          } | null;
        } | null>;
      };
    } | null;
    readonly peerAssessmentTemplate?: {
      readonly __typename: "AssessmentTemplateNode";
      readonly id: number;
      readonly assessmentType: AssessmentType;
      readonly anonymity: AssessmentGroupAnonymity;
      readonly providers: AssessmentGroupProviders;
      readonly delivery: AssessmentGroupDelivery;
      readonly hasSelfAssessment: boolean;
      readonly isOnlySelfAssessment: boolean;
      readonly enableRoleBasedAssessments: boolean;
      readonly enableGoalAssessments: boolean;
      readonly goalAssessmentScale: number;
      readonly goalAssessmentScaleLabels: ReadonlyArray<string | null>;
      readonly goalAssessmentScaleStartsAt: number;
      readonly goalAssessmentResponses: AssessmentQuestionResponses;
      readonly roleBasedAssessmentsAssessNextRole: boolean;
      readonly roleBasedAssessmentsSelfAssessNextRole: boolean;
      readonly roleBasedAssessmentScale: number;
      readonly roleBasedAssessmentScaleLabels: ReadonlyArray<string | null>;
      readonly roleBasedAssessmentScaleStartsAt: number;
      readonly enableCoreValueAssessments: boolean;
      readonly coreValueAssessmentScale: number;
      readonly coreValueAssessmentScaleLabels: ReadonlyArray<string | null>;
      readonly coreValueAssessmentScaleStartsAt: number;
      readonly coreValueAssessmentResponses: AssessmentQuestionResponses;
      readonly competencyAssessmentType: CompetencyAssessmentType;
      readonly nextRoleCompetencyAssessmentType: CompetencyAssessmentType;
      readonly questionSets: {
        readonly __typename: "AssessmentGroupNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentGroupNodeEdge";
          readonly node?: {
            readonly __typename: "AssessmentGroupNode";
            readonly id: number;
            readonly talentIndicatorQuestionSettings?: {
              readonly __typename: "TalentIndicatorSettingsNode";
              readonly title?: string | null;
              readonly description?: any | null;
              readonly talentIndicators: ReadonlyArray<{
                readonly __typename: "TalentIndicatorQuestionSettingsNode";
                readonly talentIndicatorId: number;
                readonly comment: AssessmentQuestionComment;
                readonly responses: AssessmentQuestionResponses;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              } | null>;
            } | null;
          } | null;
        } | null>;
      };
    } | null;
    readonly engagementSurveyTemplate?: {
      readonly __typename: "AssessmentTemplateNode";
      readonly id: number;
      readonly assessmentType: AssessmentType;
      readonly anonymity: AssessmentGroupAnonymity;
      readonly providers: AssessmentGroupProviders;
      readonly delivery: AssessmentGroupDelivery;
      readonly questionSets: {
        readonly __typename: "AssessmentGroupNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentGroupNodeEdge";
          readonly node?: {
            readonly __typename: "AssessmentGroupNode";
            readonly id: number;
            readonly talentIndicatorQuestionSettings?: {
              readonly __typename: "TalentIndicatorSettingsNode";
              readonly title?: string | null;
              readonly description?: any | null;
              readonly talentIndicators: ReadonlyArray<{
                readonly __typename: "TalentIndicatorQuestionSettingsNode";
                readonly talentIndicatorId: number;
                readonly comment: AssessmentQuestionComment;
                readonly responses: AssessmentQuestionResponses;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              } | null>;
            } | null;
          } | null;
        } | null>;
      };
    } | null;
    readonly participantStatus: {
      readonly __typename: "ParticipantStatusConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "ParticipantStatusEdge";
        readonly node?: {
          readonly __typename: "ParticipantStatusNode";
          readonly oneononeStatus: ComplianceProgramParticipantStatus;
          readonly performanceAssessmentStatus: ComplianceProgramParticipantStatus;
          readonly performanceSelfAssessmentStatus: ComplianceProgramParticipantStatus;
          readonly managerAssessmentStatus: ComplianceProgramParticipantStatus;
          readonly managerSelfAssessmentStatus: ComplianceProgramParticipantStatus;
          readonly peerAssessmentStatus: ComplianceProgramParticipantStatus;
          readonly peerSelfAssessmentStatus: ComplianceProgramParticipantStatus;
          readonly meeting?: {
            readonly __typename: "MeetingNode";
            readonly id: number;
            readonly title?: string | null;
            readonly meetingGroupId: number;
          } | null;
          readonly user: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly email: string;
            readonly avatar?: string | null;
            readonly managers: {
              readonly __typename: "UserNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "UserNodeEdge";
                readonly node?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly name: string;
                  readonly avatar?: string | null;
                } | null;
              } | null>;
            };
          };
        } | null;
      } | null>;
    };
  } | null;
};

export type ProgramParticipantUpdatesFragment = {
  readonly __typename: "ProgramAppliesToUpdatesNode";
  readonly hasUpdates: boolean;
  readonly usersToAdd: ReadonlyArray<{
    readonly __typename: "UserNode";
    readonly id: number;
    readonly email: string;
    readonly name: string;
    readonly avatar?: string | null;
    readonly currentRoles: ReadonlyArray<{
      readonly __typename: "CareerTrackRoleNode";
      readonly id: number;
      readonly title: string;
      readonly level: number;
    }>;
  }>;
  readonly usersToRemove: ReadonlyArray<{
    readonly __typename: "UserNode";
    readonly id: number;
    readonly email: string;
    readonly name: string;
    readonly avatar?: string | null;
    readonly currentRoles: ReadonlyArray<{
      readonly __typename: "CareerTrackRoleNode";
      readonly id: number;
      readonly title: string;
    }>;
  }>;
  readonly rolesToChange: ReadonlyArray<{
    readonly __typename: "RoleChangeUserNode";
    readonly user: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly email: string;
      readonly avatar?: string | null;
      readonly currentRoles: ReadonlyArray<{
        readonly __typename: "CareerTrackRoleNode";
        readonly id: number;
        readonly title: string;
      }>;
    };
    readonly oldRoles: ReadonlyArray<{
      readonly __typename: "CareerTrackRoleNode";
      readonly id: number;
      readonly title: string;
    }>;
  }>;
};

export type GetComplianceProgramAvailableAppliesToUpdatesQueryVariables =
  Exact<{
    complianceProgramId: Scalars["Int"]["input"];
  }>;

export type GetComplianceProgramAvailableAppliesToUpdatesQuery = {
  readonly __typename: "Query";
  readonly complianceProgram?: {
    readonly __typename: "ComplianceProgramNode";
    readonly id: number;
    readonly availableAppliesToUpdates?: {
      readonly __typename: "ProgramAppliesToUpdatesNode";
      readonly hasUpdates: boolean;
      readonly usersToAdd: ReadonlyArray<{
        readonly __typename: "UserNode";
        readonly id: number;
        readonly email: string;
        readonly name: string;
        readonly avatar?: string | null;
        readonly currentRoles: ReadonlyArray<{
          readonly __typename: "CareerTrackRoleNode";
          readonly id: number;
          readonly title: string;
          readonly level: number;
        }>;
      }>;
      readonly usersToRemove: ReadonlyArray<{
        readonly __typename: "UserNode";
        readonly id: number;
        readonly email: string;
        readonly name: string;
        readonly avatar?: string | null;
        readonly currentRoles: ReadonlyArray<{
          readonly __typename: "CareerTrackRoleNode";
          readonly id: number;
          readonly title: string;
        }>;
      }>;
      readonly rolesToChange: ReadonlyArray<{
        readonly __typename: "RoleChangeUserNode";
        readonly user: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly email: string;
          readonly avatar?: string | null;
          readonly currentRoles: ReadonlyArray<{
            readonly __typename: "CareerTrackRoleNode";
            readonly id: number;
            readonly title: string;
          }>;
        };
        readonly oldRoles: ReadonlyArray<{
          readonly __typename: "CareerTrackRoleNode";
          readonly id: number;
          readonly title: string;
        }>;
      }>;
    } | null;
  } | null;
};

export type GetComplianceProgramEditQueryVariables = Exact<{
  complianceProgramId: Scalars["Int"]["input"];
  complianceProgramExists: Scalars["Boolean"]["input"];
  organizationId: Scalars["Int"]["input"];
}>;

export type GetComplianceProgramEditQuery = {
  readonly __typename: "Query";
  readonly talentIndicators: {
    readonly __typename: "TalentIndicatorNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "TalentIndicatorNodeEdge";
      readonly node?: {
        readonly __typename: "TalentIndicatorNode";
        readonly id: number;
        readonly talentIndicatorType: TalentIndicatorType;
        readonly name: string;
        readonly customName?: string | null;
        readonly questionTitle?: string | null;
        readonly description: any;
        readonly scaleStartsAt: number;
        readonly scale: number;
        readonly labels: ReadonlyArray<string | null>;
        readonly labelDescriptions: ReadonlyArray<string | null>;
        readonly isManagerIndicator: boolean;
        readonly hasLockedLabels: boolean;
        readonly hasAssessmentQuestions: boolean;
      } | null;
    } | null>;
  };
  readonly complianceProgram?: {
    readonly __typename: "ComplianceProgramNode";
    readonly id: number;
    readonly title: string;
    readonly created: string;
    readonly updated: string;
    readonly dueDate?: string | null;
    readonly startDate?: string | null;
    readonly periodStartDate?: string | null;
    readonly periodEndDate?: string | null;
    readonly ongoing: boolean;
    readonly startDateOffset: number;
    readonly startDateDueDateOffset: number;
    readonly startDatePeriodStartOffset: number;
    readonly startDatePeriodEndOffset: number;
    readonly state: ComplianceProgramState;
    readonly recurrence: ComplianceProgramRecurrence;
    readonly calibration: ComplianceProgramCalibrationType;
    readonly appliesTo: ComplianceProgramAppliesTo;
    readonly excludedHireDateAfter?: string | null;
    readonly steps: ReadonlyArray<{
      readonly __typename: "ComplianceProgramStepConfigNode";
      readonly step: ComplianceProgramStep;
      readonly dueDateOffset: number;
    } | null>;
    readonly creator?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly avatar?: string | null;
      readonly email: string;
    } | null;
    readonly canUpdate?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    } | null;
    readonly canDelete?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    } | null;
    readonly canReadDetails: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    };
    readonly appliesToTeams: {
      readonly __typename: "TeamNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "TeamNodeEdge";
        readonly node?: {
          readonly __typename: "TeamNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null>;
    };
    readonly appliesToManagers: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null>;
    };
    readonly appliesToUsers: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null>;
    };
    readonly excludedUsers: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null>;
    };
    readonly requiredTopicTemplates: {
      readonly __typename: "TopicTemplateNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "TopicTemplateNodeEdge";
        readonly node?: {
          readonly __typename: "TopicTemplateNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null>;
    };
    readonly scheduledReminders: {
      readonly __typename: "ComplianceProgramScheduledReminderNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "ComplianceProgramScheduledReminderNodeEdge";
        readonly node?: {
          readonly __typename: "ComplianceProgramScheduledReminderNode";
          readonly id: number;
          readonly message: string;
          readonly daysAfterStartDate: number;
          readonly sentDatetime?: string | null;
          readonly slackNotification: boolean;
          readonly teamsNotification: boolean;
          readonly emailNotification: boolean;
          readonly nominations: boolean;
          readonly oneonone: boolean;
          readonly performanceAssessment: boolean;
          readonly performanceSelfAssessment: boolean;
          readonly peerAssessment: boolean;
          readonly managerAssessment: boolean;
          readonly engagementSurvey: boolean;
        } | null;
      } | null>;
    };
    readonly performanceAssessmentTemplate?: {
      readonly __typename: "AssessmentTemplateNode";
      readonly id: number;
      readonly assessmentType: AssessmentType;
      readonly anonymity: AssessmentGroupAnonymity;
      readonly providers: AssessmentGroupProviders;
      readonly delivery: AssessmentGroupDelivery;
      readonly hasSelfAssessment: boolean;
      readonly isOnlySelfAssessment: boolean;
      readonly enableRoleBasedAssessments: boolean;
      readonly enableGoalAssessments: boolean;
      readonly goalAssessmentScale: number;
      readonly goalAssessmentScaleLabels: ReadonlyArray<string | null>;
      readonly goalAssessmentScaleStartsAt: number;
      readonly goalAssessmentResponses: AssessmentQuestionResponses;
      readonly roleBasedAssessmentsAssessNextRole: boolean;
      readonly roleBasedAssessmentsSelfAssessNextRole: boolean;
      readonly roleBasedAssessmentScale: number;
      readonly roleBasedAssessmentScaleLabels: ReadonlyArray<string | null>;
      readonly roleBasedAssessmentScaleStartsAt: number;
      readonly enableCoreValueAssessments: boolean;
      readonly coreValueAssessmentScale: number;
      readonly coreValueAssessmentScaleLabels: ReadonlyArray<string | null>;
      readonly coreValueAssessmentScaleStartsAt: number;
      readonly coreValueAssessmentResponses: AssessmentQuestionResponses;
      readonly competencyAssessmentType: CompetencyAssessmentType;
      readonly nextRoleCompetencyAssessmentType: CompetencyAssessmentType;
      readonly questionSets: {
        readonly __typename: "AssessmentGroupNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentGroupNodeEdge";
          readonly node?: {
            readonly __typename: "AssessmentGroupNode";
            readonly id: number;
            readonly talentIndicatorQuestionSettings?: {
              readonly __typename: "TalentIndicatorSettingsNode";
              readonly title?: string | null;
              readonly description?: any | null;
              readonly talentIndicators: ReadonlyArray<{
                readonly __typename: "TalentIndicatorQuestionSettingsNode";
                readonly talentIndicatorId: number;
                readonly comment: AssessmentQuestionComment;
                readonly responses: AssessmentQuestionResponses;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
                readonly description?: string | null;
              } | null>;
            } | null;
          } | null;
        } | null>;
      };
    } | null;
    readonly managerAssessmentTemplate?: {
      readonly __typename: "AssessmentTemplateNode";
      readonly id: number;
      readonly assessmentType: AssessmentType;
      readonly anonymity: AssessmentGroupAnonymity;
      readonly providers: AssessmentGroupProviders;
      readonly delivery: AssessmentGroupDelivery;
      readonly hasSelfAssessment: boolean;
      readonly isOnlySelfAssessment: boolean;
      readonly questionSets: {
        readonly __typename: "AssessmentGroupNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentGroupNodeEdge";
          readonly node?: {
            readonly __typename: "AssessmentGroupNode";
            readonly id: number;
            readonly talentIndicatorQuestionSettings?: {
              readonly __typename: "TalentIndicatorSettingsNode";
              readonly title?: string | null;
              readonly description?: any | null;
              readonly talentIndicators: ReadonlyArray<{
                readonly __typename: "TalentIndicatorQuestionSettingsNode";
                readonly talentIndicatorId: number;
                readonly comment: AssessmentQuestionComment;
                readonly responses: AssessmentQuestionResponses;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              } | null>;
            } | null;
          } | null;
        } | null>;
      };
    } | null;
    readonly peerAssessmentTemplate?: {
      readonly __typename: "AssessmentTemplateNode";
      readonly id: number;
      readonly assessmentType: AssessmentType;
      readonly anonymity: AssessmentGroupAnonymity;
      readonly providers: AssessmentGroupProviders;
      readonly delivery: AssessmentGroupDelivery;
      readonly hasSelfAssessment: boolean;
      readonly isOnlySelfAssessment: boolean;
      readonly enableRoleBasedAssessments: boolean;
      readonly enableGoalAssessments: boolean;
      readonly goalAssessmentScale: number;
      readonly goalAssessmentScaleLabels: ReadonlyArray<string | null>;
      readonly goalAssessmentScaleStartsAt: number;
      readonly goalAssessmentResponses: AssessmentQuestionResponses;
      readonly roleBasedAssessmentsAssessNextRole: boolean;
      readonly roleBasedAssessmentsSelfAssessNextRole: boolean;
      readonly roleBasedAssessmentScale: number;
      readonly roleBasedAssessmentScaleLabels: ReadonlyArray<string | null>;
      readonly roleBasedAssessmentScaleStartsAt: number;
      readonly enableCoreValueAssessments: boolean;
      readonly coreValueAssessmentScale: number;
      readonly coreValueAssessmentScaleLabels: ReadonlyArray<string | null>;
      readonly coreValueAssessmentScaleStartsAt: number;
      readonly coreValueAssessmentResponses: AssessmentQuestionResponses;
      readonly competencyAssessmentType: CompetencyAssessmentType;
      readonly nextRoleCompetencyAssessmentType: CompetencyAssessmentType;
      readonly questionSets: {
        readonly __typename: "AssessmentGroupNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentGroupNodeEdge";
          readonly node?: {
            readonly __typename: "AssessmentGroupNode";
            readonly id: number;
            readonly talentIndicatorQuestionSettings?: {
              readonly __typename: "TalentIndicatorSettingsNode";
              readonly title?: string | null;
              readonly description?: any | null;
              readonly talentIndicators: ReadonlyArray<{
                readonly __typename: "TalentIndicatorQuestionSettingsNode";
                readonly talentIndicatorId: number;
                readonly comment: AssessmentQuestionComment;
                readonly responses: AssessmentQuestionResponses;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              } | null>;
            } | null;
          } | null;
        } | null>;
      };
    } | null;
    readonly engagementSurveyTemplate?: {
      readonly __typename: "AssessmentTemplateNode";
      readonly id: number;
      readonly assessmentType: AssessmentType;
      readonly anonymity: AssessmentGroupAnonymity;
      readonly providers: AssessmentGroupProviders;
      readonly delivery: AssessmentGroupDelivery;
      readonly questionSets: {
        readonly __typename: "AssessmentGroupNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentGroupNodeEdge";
          readonly node?: {
            readonly __typename: "AssessmentGroupNode";
            readonly id: number;
            readonly talentIndicatorQuestionSettings?: {
              readonly __typename: "TalentIndicatorSettingsNode";
              readonly title?: string | null;
              readonly description?: any | null;
              readonly talentIndicators: ReadonlyArray<{
                readonly __typename: "TalentIndicatorQuestionSettingsNode";
                readonly talentIndicatorId: number;
                readonly comment: AssessmentQuestionComment;
                readonly responses: AssessmentQuestionResponses;
                readonly responseVisibility: AssessmentQuestionResponseVisibility;
              } | null>;
            } | null;
          } | null;
        } | null>;
      };
    } | null;
  } | null;
};

export type ComplianceProgramPopoverContentAssessmentFragment = {
  readonly __typename: "AssessmentNode";
  readonly id: number;
  readonly submittedDatetime?: string | null;
  readonly created: string;
  readonly canRead?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  } | null;
  readonly template: {
    readonly __typename: "AssessmentTemplateNode";
    readonly id: number;
    readonly assessmentType: AssessmentType;
  };
  readonly responder?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
  } | null;
  readonly target?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
  } | null;
};

export type ComplianceProgramPopoverContentMeetingFragment = {
  readonly __typename: "MeetingNode";
  readonly id: number;
  readonly title?: string | null;
  readonly meetingGroupId: number;
  readonly isFinalized: boolean;
  readonly finalizedAt?: string | null;
  readonly startDatetime?: string | null;
  readonly meetingGroup?: {
    readonly __typename: "MeetingGroupNode";
    readonly id: number;
    readonly topicTemplate?: {
      readonly __typename: "TopicTemplateNode";
      readonly id: number;
    } | null;
  } | null;
  readonly canRead?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  } | null;
  readonly participants?: {
    readonly __typename: "MeetingParticipantConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "MeetingParticipantEdge";
      readonly node?: {
        readonly __typename: "MeetingParticipantNode";
        readonly id?: string | null;
        readonly status?: AttendeeStatus | null;
        readonly user?: {
          readonly __typename: "BasicUserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
          readonly email: string;
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type ComplianceProgramPopoverContentAssessmentDeliveryFragment = {
  readonly __typename: "AssessmentDeliveryNode";
  readonly id: number;
  readonly target?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
  } | null;
};

export type GetComplianceProgramPopoverContentQueryVariables = Exact<{
  complianceProgramId: Scalars["Int"]["input"];
  assessmentTargetId?: InputMaybe<Scalars["Int"]["input"]>;
  assessmentResponderId?: InputMaybe<Scalars["Int"]["input"]>;
  oneononeTemplateId?: InputMaybe<Scalars["Int"]["input"]>;
  oneononeParticipants?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  fetchAssessments: Scalars["Boolean"]["input"];
  fetchOneonones: Scalars["Boolean"]["input"];
  fetchAssessmentDeliveries: Scalars["Boolean"]["input"];
  oneononeStartDatetimeGte?: InputMaybe<Scalars["DateTime"]["input"]>;
}>;

export type GetComplianceProgramPopoverContentQuery = {
  readonly __typename: "Query";
  readonly complianceProgram?: {
    readonly __typename: "ComplianceProgramNode";
    readonly id: number;
    readonly assessments?: {
      readonly __typename: "AssessmentNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AssessmentNodeEdge";
        readonly node?: {
          readonly __typename: "AssessmentNode";
          readonly id: number;
          readonly submittedDatetime?: string | null;
          readonly created: string;
          readonly canRead?: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          } | null;
          readonly template: {
            readonly __typename: "AssessmentTemplateNode";
            readonly id: number;
            readonly assessmentType: AssessmentType;
          };
          readonly responder?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
          } | null;
          readonly target?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
          } | null;
        } | null;
      } | null>;
    };
    readonly matchingOneonones?: {
      readonly __typename: "MeetingNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "MeetingNodeEdge";
        readonly node?: {
          readonly __typename: "MeetingNode";
          readonly id: number;
          readonly title?: string | null;
          readonly meetingGroupId: number;
          readonly isFinalized: boolean;
          readonly finalizedAt?: string | null;
          readonly startDatetime?: string | null;
          readonly meetingGroup?: {
            readonly __typename: "MeetingGroupNode";
            readonly id: number;
            readonly topicTemplate?: {
              readonly __typename: "TopicTemplateNode";
              readonly id: number;
            } | null;
          } | null;
          readonly canRead?: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          } | null;
          readonly participants?: {
            readonly __typename: "MeetingParticipantConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "MeetingParticipantEdge";
              readonly node?: {
                readonly __typename: "MeetingParticipantNode";
                readonly id?: string | null;
                readonly status?: AttendeeStatus | null;
                readonly user?: {
                  readonly __typename: "BasicUserNode";
                  readonly id: number;
                  readonly name: string;
                  readonly avatar?: string | null;
                  readonly email: string;
                } | null;
              } | null;
            } | null>;
          } | null;
        } | null;
      } | null>;
    } | null;
    readonly assessmentDeliveries?: {
      readonly __typename: "AssessmentDeliveryNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AssessmentDeliveryNodeEdge";
        readonly node?: {
          readonly __typename: "AssessmentDeliveryNode";
          readonly id: number;
          readonly target?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
          } | null;
        } | null;
      } | null>;
    };
  } | null;
};

export type ComplianceProgramMissingAssessmentFragment = {
  readonly __typename: "MissingAssessmentNode";
  readonly responder: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  };
  readonly target?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
  readonly assessmentTemplate: {
    readonly __typename: "AssessmentTemplateNode";
    readonly id: number;
    readonly assessmentType: AssessmentType;
  };
};

export type ComplianceProgramReportParticipantStatusUserFragment = {
  readonly __typename: "UserNode";
  readonly id: number;
  readonly name: string;
  readonly membershipStatus?: AccountToOrganizationMembershipStatus | null;
  readonly teamsList: ReadonlyArray<{
    readonly __typename: "TeamNode";
    readonly id: number;
    readonly title: string;
  }>;
};

export type ComplianceProgramReportParticipantStatusFragment = {
  readonly __typename: "ParticipantStatusNode";
  readonly oneononeStatus: ComplianceProgramParticipantStatus;
  readonly performanceAssessmentStatus: ComplianceProgramParticipantStatus;
  readonly performanceSelfAssessmentStatus: ComplianceProgramParticipantStatus;
  readonly managerAssessmentStatus: ComplianceProgramParticipantStatus;
  readonly managerSelfAssessmentStatus: ComplianceProgramParticipantStatus;
  readonly peerAssessmentStatus: ComplianceProgramParticipantStatus;
  readonly peerSelfAssessmentStatus: ComplianceProgramParticipantStatus;
  readonly calibrationStatus: ComplianceProgramParticipantStatus;
  readonly deliveryStatus: ComplianceProgramParticipantStatus;
  readonly engagementSurveyStatus: ComplianceProgramParticipantStatus;
  readonly meeting?: {
    readonly __typename: "MeetingNode";
    readonly id: number;
    readonly title?: string | null;
    readonly meetingGroupId: number;
  } | null;
  readonly user: {
    readonly __typename: "UserNode";
    readonly email: string;
    readonly avatar?: string | null;
    readonly id: number;
    readonly name: string;
    readonly membershipStatus?: AccountToOrganizationMembershipStatus | null;
    readonly managersList: ReadonlyArray<{
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly avatar?: string | null;
    }>;
    readonly teamsList: ReadonlyArray<{
      readonly __typename: "TeamNode";
      readonly id: number;
      readonly title: string;
    }>;
  };
};

export type GetComplianceProgramProgressQueryVariables = Exact<{
  complianceProgramId: Scalars["Int"]["input"];
  organizationId: Scalars["Int"]["input"];
}>;

export type GetComplianceProgramProgressQuery = {
  readonly __typename: "Query";
  readonly complianceProgram?: {
    readonly __typename: "ComplianceProgramNode";
    readonly id: number;
    readonly title: string;
    readonly created: string;
    readonly updated: string;
    readonly dueDate?: string | null;
    readonly startDate?: string | null;
    readonly periodStartDate?: string | null;
    readonly periodEndDate?: string | null;
    readonly ongoing: boolean;
    readonly startDateOffset: number;
    readonly startDateDueDateOffset: number;
    readonly startDatePeriodStartOffset: number;
    readonly startDatePeriodEndOffset: number;
    readonly state: ComplianceProgramState;
    readonly recurrence: ComplianceProgramRecurrence;
    readonly appliesTo: ComplianceProgramAppliesTo;
    readonly excludedHireDateAfter?: string | null;
    readonly assessmentDeliveries: {
      readonly __typename: "AssessmentDeliveryNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AssessmentDeliveryNodeEdge";
        readonly node?: {
          readonly __typename: "AssessmentDeliveryNode";
          readonly id: number;
          readonly target?: {
            readonly __typename: "UserNode";
            readonly id: number;
          } | null;
        } | null;
      } | null>;
    };
    readonly assessmentsOpenForNominations: {
      readonly __typename: "AssessmentOpenForNominationConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AssessmentOpenForNominationEdge";
        readonly node?: {
          readonly __typename: "AssessmentOpenForNominationNode";
          readonly id: string;
          readonly nominationsCount: number;
          readonly targetUser: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly membershipStatus?: AccountToOrganizationMembershipStatus | null;
            readonly teamsList: ReadonlyArray<{
              readonly __typename: "TeamNode";
              readonly id: number;
              readonly title: string;
            }>;
          };
        } | null;
      } | null>;
    };
    readonly canUpdate?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    } | null;
    readonly canDelete?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    } | null;
    readonly appliesToTeams: {
      readonly __typename: "TeamNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "TeamNodeEdge";
        readonly node?: {
          readonly __typename: "TeamNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null>;
    };
    readonly appliesToManagers: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null>;
    };
    readonly appliesToUsers: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null>;
    };
    readonly excludedUsers: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null>;
    };
    readonly requiredTopicTemplates: {
      readonly __typename: "TopicTemplateNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "TopicTemplateNodeEdge";
        readonly node?: {
          readonly __typename: "TopicTemplateNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null>;
    };
    readonly performanceAssessmentTemplate?: {
      readonly __typename: "AssessmentTemplateNode";
      readonly id: number;
      readonly assessmentType: AssessmentType;
      readonly hasSelfAssessment: boolean;
      readonly isOnlySelfAssessment: boolean;
      readonly delivery: AssessmentGroupDelivery;
    } | null;
    readonly engagementSurveyTemplate?: {
      readonly __typename: "AssessmentTemplateNode";
      readonly id: number;
      readonly assessmentType: AssessmentType;
      readonly hasSelfAssessment: boolean;
      readonly isOnlySelfAssessment: boolean;
      readonly delivery: AssessmentGroupDelivery;
    } | null;
    readonly managerAssessmentTemplate?: {
      readonly __typename: "AssessmentTemplateNode";
      readonly id: number;
      readonly assessmentType: AssessmentType;
      readonly hasSelfAssessment: boolean;
      readonly isOnlySelfAssessment: boolean;
      readonly delivery: AssessmentGroupDelivery;
    } | null;
    readonly peerAssessmentTemplate?: {
      readonly __typename: "AssessmentTemplateNode";
      readonly id: number;
      readonly assessmentType: AssessmentType;
      readonly hasSelfAssessment: boolean;
      readonly isOnlySelfAssessment: boolean;
      readonly providers: AssessmentGroupProviders;
      readonly delivery: AssessmentGroupDelivery;
    } | null;
    readonly participantStatus: {
      readonly __typename: "ParticipantStatusConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "ParticipantStatusEdge";
        readonly node?: {
          readonly __typename: "ParticipantStatusNode";
          readonly oneononeStatus: ComplianceProgramParticipantStatus;
          readonly performanceAssessmentStatus: ComplianceProgramParticipantStatus;
          readonly performanceSelfAssessmentStatus: ComplianceProgramParticipantStatus;
          readonly managerAssessmentStatus: ComplianceProgramParticipantStatus;
          readonly managerSelfAssessmentStatus: ComplianceProgramParticipantStatus;
          readonly peerAssessmentStatus: ComplianceProgramParticipantStatus;
          readonly peerSelfAssessmentStatus: ComplianceProgramParticipantStatus;
          readonly calibrationStatus: ComplianceProgramParticipantStatus;
          readonly deliveryStatus: ComplianceProgramParticipantStatus;
          readonly engagementSurveyStatus: ComplianceProgramParticipantStatus;
          readonly meeting?: {
            readonly __typename: "MeetingNode";
            readonly id: number;
            readonly title?: string | null;
            readonly meetingGroupId: number;
          } | null;
          readonly user: {
            readonly __typename: "UserNode";
            readonly email: string;
            readonly avatar?: string | null;
            readonly id: number;
            readonly name: string;
            readonly membershipStatus?: AccountToOrganizationMembershipStatus | null;
            readonly managersList: ReadonlyArray<{
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            }>;
            readonly teamsList: ReadonlyArray<{
              readonly __typename: "TeamNode";
              readonly id: number;
              readonly title: string;
            }>;
          };
        } | null;
      } | null>;
    };
    readonly usersMissingAssessment: {
      readonly __typename: "MissingAssessmentConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "MissingAssessmentEdge";
        readonly node?: {
          readonly __typename: "MissingAssessmentNode";
          readonly responder: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          };
          readonly target?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
          readonly assessmentTemplate: {
            readonly __typename: "AssessmentTemplateNode";
            readonly id: number;
            readonly assessmentType: AssessmentType;
          };
        } | null;
      } | null>;
    };
  } | null;
};

export type GetComplianceProgramQueryVariables = Exact<{
  complianceProgramId: Scalars["Int"]["input"];
}>;

export type GetComplianceProgramQuery = {
  readonly __typename: "Query";
  readonly complianceProgram?: {
    readonly __typename: "ComplianceProgramNode";
    readonly id: number;
    readonly title: string;
    readonly created: string;
    readonly updated: string;
    readonly dueDate?: string | null;
    readonly startDate?: string | null;
    readonly periodStartDate?: string | null;
    readonly periodEndDate?: string | null;
    readonly ongoing: boolean;
    readonly startDateOffset: number;
    readonly startDateDueDateOffset: number;
    readonly startDatePeriodStartOffset: number;
    readonly startDatePeriodEndOffset: number;
    readonly state: ComplianceProgramState;
    readonly recurrence: ComplianceProgramRecurrence;
    readonly appliesTo: ComplianceProgramAppliesTo;
    readonly excludedHireDateAfter?: string | null;
    readonly creator?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly email: string;
      readonly avatar?: string | null;
    } | null;
    readonly canUpdate?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    } | null;
    readonly canDelete?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    } | null;
    readonly canReadDetails: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    };
    readonly appliesToTeams: {
      readonly __typename: "TeamNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "TeamNodeEdge";
        readonly node?: {
          readonly __typename: "TeamNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null>;
    };
    readonly appliesToManagers: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null>;
    };
    readonly appliesToUsers: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null>;
    };
    readonly excludedUsers: {
      readonly __typename: "UserNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNodeEdge";
        readonly node?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null>;
    };
    readonly requiredTopicTemplates: {
      readonly __typename: "TopicTemplateNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "TopicTemplateNodeEdge";
        readonly node?: {
          readonly __typename: "TopicTemplateNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null>;
    };
    readonly performanceAssessmentTemplate?: {
      readonly __typename: "AssessmentTemplateNode";
      readonly id: number;
      readonly assessmentType: AssessmentType;
      readonly anonymity: AssessmentGroupAnonymity;
      readonly providers: AssessmentGroupProviders;
      readonly delivery: AssessmentGroupDelivery;
      readonly hasSelfAssessment: boolean;
      readonly isOnlySelfAssessment: boolean;
      readonly enableRoleBasedAssessments: boolean;
      readonly enableGoalAssessments: boolean;
      readonly roleBasedAssessmentsAssessNextRole: boolean;
      readonly roleBasedAssessmentScale: number;
      readonly roleBasedAssessmentScaleLabels: ReadonlyArray<string | null>;
      readonly roleBasedAssessmentScaleStartsAt: number;
      readonly competencyAssessmentType: CompetencyAssessmentType;
      readonly nextRoleCompetencyAssessmentType: CompetencyAssessmentType;
      readonly questionSets: {
        readonly __typename: "AssessmentGroupNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentGroupNodeEdge";
          readonly node?: {
            readonly __typename: "AssessmentGroupNode";
            readonly id: number;
          } | null;
        } | null>;
      };
    } | null;
    readonly engagementSurveyTemplate?: {
      readonly __typename: "AssessmentTemplateNode";
      readonly id: number;
      readonly assessmentType: AssessmentType;
      readonly anonymity: AssessmentGroupAnonymity;
      readonly providers: AssessmentGroupProviders;
      readonly delivery: AssessmentGroupDelivery;
    } | null;
    readonly managerAssessmentTemplate?: {
      readonly __typename: "AssessmentTemplateNode";
      readonly id: number;
      readonly assessmentType: AssessmentType;
      readonly anonymity: AssessmentGroupAnonymity;
      readonly providers: AssessmentGroupProviders;
      readonly delivery: AssessmentGroupDelivery;
    } | null;
    readonly peerAssessmentTemplate?: {
      readonly __typename: "AssessmentTemplateNode";
      readonly id: number;
      readonly assessmentType: AssessmentType;
      readonly anonymity: AssessmentGroupAnonymity;
      readonly providers: AssessmentGroupProviders;
      readonly delivery: AssessmentGroupDelivery;
    } | null;
  } | null;
};

export type ComplianceProgramScheduledReminderFragmentFragment = {
  readonly __typename: "ComplianceProgramScheduledReminderNode";
  readonly id: number;
  readonly message: string;
  readonly daysAfterStartDate: number;
  readonly sentDatetime?: string | null;
  readonly slackNotification: boolean;
  readonly teamsNotification: boolean;
  readonly emailNotification: boolean;
  readonly nominations: boolean;
  readonly oneonone: boolean;
  readonly performanceAssessment: boolean;
  readonly performanceSelfAssessment: boolean;
  readonly peerAssessment: boolean;
  readonly managerAssessment: boolean;
  readonly engagementSurvey: boolean;
  readonly remindedUsersCount: number;
};

export type GetComplianceProgramScheduledRemindersQueryVariables = Exact<{
  complianceProgramId: Scalars["Int"]["input"];
}>;

export type GetComplianceProgramScheduledRemindersQuery = {
  readonly __typename: "Query";
  readonly complianceProgram?: {
    readonly __typename: "ComplianceProgramNode";
    readonly id: number;
    readonly scheduledReminders: {
      readonly __typename: "ComplianceProgramScheduledReminderNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "ComplianceProgramScheduledReminderNodeEdge";
        readonly node?: {
          readonly __typename: "ComplianceProgramScheduledReminderNode";
          readonly id: number;
          readonly message: string;
          readonly daysAfterStartDate: number;
          readonly sentDatetime?: string | null;
          readonly slackNotification: boolean;
          readonly teamsNotification: boolean;
          readonly emailNotification: boolean;
          readonly nominations: boolean;
          readonly oneonone: boolean;
          readonly performanceAssessment: boolean;
          readonly performanceSelfAssessment: boolean;
          readonly peerAssessment: boolean;
          readonly managerAssessment: boolean;
          readonly engagementSurvey: boolean;
          readonly remindedUsersCount: number;
        } | null;
      } | null>;
    };
  } | null;
};

export type ComplianceProgramListItemFragment = {
  readonly __typename: "ComplianceProgramNode";
  readonly id: number;
  readonly title: string;
  readonly created: string;
  readonly updated: string;
  readonly dueDate?: string | null;
  readonly startDate?: string | null;
  readonly ongoing: boolean;
  readonly periodStartDate?: string | null;
  readonly periodEndDate?: string | null;
  readonly startDateOffset: number;
  readonly startDateDueDateOffset: number;
  readonly startDatePeriodStartOffset: number;
  readonly startDatePeriodEndOffset: number;
  readonly state: ComplianceProgramState;
  readonly recurrence: ComplianceProgramRecurrence;
  readonly appliesTo: ComplianceProgramAppliesTo;
  readonly excludedHireDateAfter?: string | null;
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly email: string;
    readonly avatar?: string | null;
  } | null;
  readonly requiredTopicTemplates: {
    readonly __typename: "TopicTemplateNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "TopicTemplateNodeEdge";
      readonly node?: {
        readonly __typename: "TopicTemplateNode";
        readonly id: number;
        readonly title: string;
      } | null;
    } | null>;
  };
  readonly canUpdate?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  } | null;
  readonly canDelete?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  } | null;
  readonly performanceAssessmentTemplate?: {
    readonly __typename: "AssessmentTemplateNode";
    readonly id: number;
    readonly assessmentType: AssessmentType;
    readonly anonymity: AssessmentGroupAnonymity;
    readonly providers: AssessmentGroupProviders;
    readonly delivery: AssessmentGroupDelivery;
  } | null;
  readonly managerAssessmentTemplate?: {
    readonly __typename: "AssessmentTemplateNode";
    readonly id: number;
    readonly assessmentType: AssessmentType;
    readonly anonymity: AssessmentGroupAnonymity;
    readonly providers: AssessmentGroupProviders;
    readonly delivery: AssessmentGroupDelivery;
  } | null;
  readonly peerAssessmentTemplate?: {
    readonly __typename: "AssessmentTemplateNode";
    readonly id: number;
    readonly assessmentType: AssessmentType;
    readonly anonymity: AssessmentGroupAnonymity;
    readonly providers: AssessmentGroupProviders;
    readonly delivery: AssessmentGroupDelivery;
  } | null;
  readonly engagementSurveyTemplate?: {
    readonly __typename: "AssessmentTemplateNode";
    readonly id: number;
    readonly assessmentType: AssessmentType;
    readonly anonymity: AssessmentGroupAnonymity;
    readonly providers: AssessmentGroupProviders;
    readonly delivery: AssessmentGroupDelivery;
  } | null;
  readonly appliesToTeams: {
    readonly __typename: "TeamNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "TeamNodeEdge";
      readonly node?: {
        readonly __typename: "TeamNode";
        readonly id: number;
        readonly title: string;
      } | null;
    } | null>;
  };
  readonly appliesToManagers: {
    readonly __typename: "UserNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "UserNodeEdge";
      readonly node?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      } | null;
    } | null>;
  };
  readonly appliesToUsers: {
    readonly __typename: "UserNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "UserNodeEdge";
      readonly node?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      } | null;
    } | null>;
  };
  readonly excludedUsers: {
    readonly __typename: "UserNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "UserNodeEdge";
      readonly node?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      } | null;
    } | null>;
  };
};

export type GetComplianceProgramsQueryVariables = Exact<{
  applicableUser?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId: Scalars["Int"]["input"];
  state?: InputMaybe<ComplianceProgramState>;
  state_In?: InputMaybe<
    | ReadonlyArray<InputMaybe<ComplianceProgramState>>
    | InputMaybe<ComplianceProgramState>
  >;
  assessmentType?: InputMaybe<AssessmentType>;
  assessmentTypes?: InputMaybe<
    ReadonlyArray<InputMaybe<AssessmentType>> | InputMaybe<AssessmentType>
  >;
  search?: InputMaybe<Scalars["String"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  dueDateGte?: InputMaybe<Scalars["Date"]["input"]>;
  dueDateLte?: InputMaybe<Scalars["Date"]["input"]>;
}>;

export type GetComplianceProgramsQuery = {
  readonly __typename: "Query";
  readonly detailedCompliancePrograms: {
    readonly __typename: "ComplianceProgramNodeConnection";
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly endCursor?: string | null;
      readonly hasNextPage: boolean;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "ComplianceProgramNodeEdge";
      readonly node?: {
        readonly __typename: "ComplianceProgramNode";
        readonly id: number;
        readonly title: string;
        readonly created: string;
        readonly updated: string;
        readonly dueDate?: string | null;
        readonly startDate?: string | null;
        readonly ongoing: boolean;
        readonly periodStartDate?: string | null;
        readonly periodEndDate?: string | null;
        readonly startDateOffset: number;
        readonly startDateDueDateOffset: number;
        readonly startDatePeriodStartOffset: number;
        readonly startDatePeriodEndOffset: number;
        readonly state: ComplianceProgramState;
        readonly recurrence: ComplianceProgramRecurrence;
        readonly appliesTo: ComplianceProgramAppliesTo;
        readonly excludedHireDateAfter?: string | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly email: string;
          readonly avatar?: string | null;
        } | null;
        readonly requiredTopicTemplates: {
          readonly __typename: "TopicTemplateNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "TopicTemplateNodeEdge";
            readonly node?: {
              readonly __typename: "TopicTemplateNode";
              readonly id: number;
              readonly title: string;
            } | null;
          } | null>;
        };
        readonly canUpdate?: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        } | null;
        readonly canDelete?: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        } | null;
        readonly performanceAssessmentTemplate?: {
          readonly __typename: "AssessmentTemplateNode";
          readonly id: number;
          readonly assessmentType: AssessmentType;
          readonly anonymity: AssessmentGroupAnonymity;
          readonly providers: AssessmentGroupProviders;
          readonly delivery: AssessmentGroupDelivery;
        } | null;
        readonly managerAssessmentTemplate?: {
          readonly __typename: "AssessmentTemplateNode";
          readonly id: number;
          readonly assessmentType: AssessmentType;
          readonly anonymity: AssessmentGroupAnonymity;
          readonly providers: AssessmentGroupProviders;
          readonly delivery: AssessmentGroupDelivery;
        } | null;
        readonly peerAssessmentTemplate?: {
          readonly __typename: "AssessmentTemplateNode";
          readonly id: number;
          readonly assessmentType: AssessmentType;
          readonly anonymity: AssessmentGroupAnonymity;
          readonly providers: AssessmentGroupProviders;
          readonly delivery: AssessmentGroupDelivery;
        } | null;
        readonly engagementSurveyTemplate?: {
          readonly __typename: "AssessmentTemplateNode";
          readonly id: number;
          readonly assessmentType: AssessmentType;
          readonly anonymity: AssessmentGroupAnonymity;
          readonly providers: AssessmentGroupProviders;
          readonly delivery: AssessmentGroupDelivery;
        } | null;
        readonly appliesToTeams: {
          readonly __typename: "TeamNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "TeamNodeEdge";
            readonly node?: {
              readonly __typename: "TeamNode";
              readonly id: number;
              readonly title: string;
            } | null;
          } | null>;
        };
        readonly appliesToManagers: {
          readonly __typename: "UserNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "UserNodeEdge";
            readonly node?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          } | null>;
        };
        readonly appliesToUsers: {
          readonly __typename: "UserNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "UserNodeEdge";
            readonly node?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          } | null>;
        };
        readonly excludedUsers: {
          readonly __typename: "UserNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "UserNodeEdge";
            readonly node?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          } | null>;
        };
      } | null;
    } | null>;
  };
};

export type SyncComplianceProgramUsersMutationMutationVariables = Exact<{
  complianceProgramId: Scalars["Int"]["input"];
}>;

export type SyncComplianceProgramUsersMutationMutation = {
  readonly __typename: "Mutation";
  readonly syncComplianceProgramUsers?: {
    readonly __typename: "SyncComplianceProgramUsersMutation";
    readonly complianceProgram: {
      readonly __typename: "ComplianceProgramNode";
      readonly id: number;
    };
  } | null;
};

export type GetPusherArtifactQueryQueryVariables = Exact<{
  artifactId: Scalars["Int"]["input"];
  keyResultLimit: Scalars["Int"]["input"];
}>;

export type GetPusherArtifactQueryQuery = {
  readonly __typename: "Query";
  readonly artifact:
    | {
        readonly __typename: "ActionItemArtifactNode";
        readonly isComplete?: boolean | null;
        readonly actionItemState?: number | null;
        readonly dueDate?: string | null;
        readonly id: number;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly assignee?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly avatar?: string | null;
          readonly name: string;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "AsanaTaskArtifactNode";
        readonly id: number;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "DecisionArtifactNode";
        readonly decision: string;
        readonly isDraft?: boolean | null;
        readonly decisionState?: DecisionState | null;
        readonly id: number;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "DocumentArtifactNode";
        readonly id: number;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "FeedbackArtifactNode";
        readonly id: number;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "GithubIssuesArtifactNode";
        readonly id: number;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "GoalArtifactNode";
        readonly id: number;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly startValue: number;
        readonly currentValue: number;
        readonly targetValue: number;
        readonly progress: number;
        readonly progressType: GoalProgressType;
        readonly dueDate?: string | null;
        readonly startDate?: string | null;
        readonly state: GoalState;
        readonly status: GoalStatus;
        readonly scope: GoalScope;
        readonly goalVisibility: GoalVisibility;
        readonly created: string;
        readonly parentGoalId?: number | null;
        readonly ownerCount?: number | null;
        readonly contributorCount?: number | null;
        readonly isStale: boolean;
        readonly updated?: string | null;
        readonly keyResults: {
          readonly __typename: "KeyResultNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "KeyResultNodeEdge";
            readonly node?: {
              readonly __typename: "KeyResultNode";
              readonly id: number;
              readonly title: string;
              readonly startValue: number;
              readonly currentValue: number;
              readonly targetValue: number;
              readonly progressType: GoalProgressType;
              readonly kpi?: {
                readonly __typename: "KPINode";
                readonly id: number;
                readonly title: string;
                readonly currentMeasurement?: {
                  readonly __typename: "KPIMeasurementNode";
                  readonly id: number;
                  readonly measurement: number;
                } | null;
              } | null;
              readonly canUpdate?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              } | null;
              readonly assignee?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
                readonly email: string;
              } | null;
            } | null;
          } | null>;
        };
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly firstOwner?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly avatar?: string | null;
          readonly name: string;
        } | null;
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canRead: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      }
    | {
        readonly __typename: "KPIArtifactNode";
        readonly id: number;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "RatingArtifactNode";
        readonly id: number;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "RecognitionArtifactNode";
        readonly id: number;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly created: string;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly recipients?: {
          readonly __typename: "UserNodeConnection";
          readonly totalCount: number;
          readonly edges: ReadonlyArray<{
            readonly __typename: "UserNodeEdge";
            readonly node?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          } | null>;
        } | null;
        readonly recognitionCoreValue?: {
          readonly __typename: "RecognitionCoreValueNode";
          readonly id: number;
          readonly title: string;
          readonly description: string;
          readonly emoji?: string | null;
          readonly image?: string | null;
        } | null;
      };
};

export type GetMeetingGroupOneononeStatusQueryQueryVariables = Exact<{
  meetingGroupId: Scalars["Int"]["input"];
}>;

export type GetMeetingGroupOneononeStatusQueryQuery = {
  readonly __typename: "Query";
  readonly meetingGroup?: {
    readonly __typename: "MeetingGroupNode";
    readonly id: number;
    readonly title: string;
    readonly isFormalOneonone: boolean;
    readonly canUpdate?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    } | null;
    readonly canDelete?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    } | null;
    readonly participants: {
      readonly __typename: "MeetingParticipantConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "MeetingParticipantEdge";
        readonly node?: {
          readonly __typename: "MeetingParticipantNode";
          readonly id?: string | null;
          readonly user?: {
            readonly __typename: "BasicUserNode";
            readonly id: number;
            readonly firstName: string;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
        } | null;
      } | null>;
    };
    readonly facilitator?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly avatar?: string | null;
    } | null;
  } | null;
};

export type GetPusherMeetingTranscriptionStatusQueryQueryVariables = Exact<{
  meetingId: Scalars["Int"]["input"];
}>;

export type GetPusherMeetingTranscriptionStatusQueryQuery = {
  readonly __typename: "Query";
  readonly meeting?: {
    readonly __typename: "MeetingNode";
    readonly id: number;
    readonly transcriptionStatus?: boolean | null;
  } | null;
};

export type GetTopicQueryVariables = Exact<{
  topicId: Scalars["Int"]["input"];
}>;

export type GetTopicQuery = {
  readonly __typename: "Query";
  readonly topic?: {
    readonly __typename: "TopicNode";
    readonly id: number;
    readonly title: string;
    readonly description?: string | null;
    readonly discussionNotes?: any | null;
    readonly includesIndividualNotes: boolean;
    readonly includesIndividualNotesForCurrentUser: boolean;
    readonly state?: TopicState | null;
    readonly created: string;
    readonly assignee?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly avatar?: string | null;
    } | null;
    readonly creator?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
    } | null;
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
      readonly topics?: {
        readonly __typename: "TopicNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "TopicNodeEdge";
          readonly node?: {
            readonly __typename: "TopicNode";
            readonly id: number;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type CreateOrUpdateRatingAnswerMutationMutationVariables = Exact<{
  integerAnswer: Scalars["Int"]["input"];
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  ratingAnswerId?: InputMaybe<Scalars["Int"]["input"]>;
  ratingArtifactId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingRatingRequirementId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type CreateOrUpdateRatingAnswerMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateRatingAnswer?: {
    readonly __typename: "CreateOrUpdateRatingAnswerMutation";
    readonly ratingRequirement?: {
      readonly __typename: "MeetingRatingRequirementNode";
      readonly id: number;
      readonly ratingArtifact?: {
        readonly __typename: "RatingArtifactNode";
        readonly id: number;
        readonly canAnswer?: boolean | null;
        readonly canViewAnswers?: boolean | null;
        readonly artifactType: ArtifactType;
        readonly answers?: {
          readonly __typename: "RatingAnswerNodeConnection";
          readonly totalCount?: number | null;
          readonly edges: ReadonlyArray<{
            readonly __typename: "RatingAnswerNodeEdge";
            readonly node?: {
              readonly __typename: "RatingAnswerNode";
              readonly id: number;
              readonly integerAnswer: number;
              readonly creator: {
                readonly __typename: "UserNode";
                readonly id: number;
              };
            } | null;
          } | null>;
        } | null;
      } | null;
    } | null;
    readonly ratingAnswer?: {
      readonly __typename: "RatingAnswerNode";
      readonly id: number;
      readonly integerAnswer: number;
      readonly creator: {
        readonly __typename: "UserNode";
        readonly id: number;
      };
      readonly createdInMeeting?: {
        readonly __typename: "MeetingNode";
        readonly id: number;
      } | null;
      readonly rating?: {
        readonly __typename: "RatingNode";
        readonly id: number;
      } | null;
      readonly createdFromArtifact?: {
        readonly __typename: "RatingArtifactNode";
        readonly id: number;
        readonly canAnswer?: boolean | null;
        readonly canViewAnswers?: boolean | null;
        readonly answers?: {
          readonly __typename: "RatingAnswerNodeConnection";
          readonly totalCount?: number | null;
          readonly edges: ReadonlyArray<{
            readonly __typename: "RatingAnswerNodeEdge";
            readonly node?: {
              readonly __typename: "RatingAnswerNode";
              readonly id: number;
              readonly integerAnswer: number;
              readonly creator: {
                readonly __typename: "UserNode";
                readonly id: number;
              };
            } | null;
          } | null>;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CreateOrUpdateRatingMutationMutationVariables = Exact<{
  title?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  ratingId?: InputMaybe<Scalars["Int"]["input"]>;
  startValue?: InputMaybe<Scalars["Int"]["input"]>;
  endValue?: InputMaybe<Scalars["Int"]["input"]>;
  labels:
    | ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>;
}>;

export type CreateOrUpdateRatingMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateRating?: {
    readonly __typename: "CreateOrUpdateRatingMutation";
    readonly rating?: {
      readonly __typename: "RatingNode";
      readonly id: number;
      readonly title: string;
    } | null;
  } | null;
};

export type DeleteRatingMutationMutationVariables = Exact<{
  ratingId: Scalars["Int"]["input"];
}>;

export type DeleteRatingMutationMutation = {
  readonly __typename: "Mutation";
  readonly deleteRating?: {
    readonly __typename: "DeleteRatingMutation";
    readonly ok?: boolean | null;
  } | null;
};

export type GetRatingArtifactAnswersQueryVariables = Exact<{
  artifactId: Scalars["Int"]["input"];
}>;

export type GetRatingArtifactAnswersQuery = {
  readonly __typename: "Query";
  readonly artifact:
    | { readonly __typename: "ActionItemArtifactNode"; readonly id: number }
    | { readonly __typename: "AsanaTaskArtifactNode"; readonly id: number }
    | { readonly __typename: "DecisionArtifactNode"; readonly id: number }
    | { readonly __typename: "DocumentArtifactNode"; readonly id: number }
    | { readonly __typename: "FeedbackArtifactNode"; readonly id: number }
    | { readonly __typename: "GithubIssuesArtifactNode"; readonly id: number }
    | { readonly __typename: "GoalArtifactNode"; readonly id: number }
    | { readonly __typename: "KPIArtifactNode"; readonly id: number }
    | {
        readonly __typename: "RatingArtifactNode";
        readonly canAnswer?: boolean | null;
        readonly canViewAnswers?: boolean | null;
        readonly id: number;
        readonly rating?: {
          readonly __typename: "RatingNode";
          readonly id: number;
          readonly title: string;
          readonly startValue: number;
          readonly endValue: number;
          readonly labels: ReadonlyArray<string | null>;
        } | null;
        readonly answers?: {
          readonly __typename: "RatingAnswerNodeConnection";
          readonly totalCount?: number | null;
          readonly edges: ReadonlyArray<{
            readonly __typename: "RatingAnswerNodeEdge";
            readonly node?: {
              readonly __typename: "RatingAnswerNode";
              readonly id: number;
              readonly created: string;
              readonly integerAnswer: number;
              readonly creator: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
              };
            } | null;
          } | null>;
        } | null;
      }
    | { readonly __typename: "RecognitionArtifactNode"; readonly id: number };
};

export type GetRatingQueryVariables = Exact<{
  ratingId: Scalars["Int"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetRatingQuery = {
  readonly __typename: "Query";
  readonly rating?: {
    readonly __typename: "RatingNode";
    readonly id: number;
    readonly title: string;
    readonly description: any;
    readonly startValue: number;
    readonly endValue: number;
    readonly labels: ReadonlyArray<string | null>;
    readonly created: string;
    readonly creator?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
    } | null;
    readonly organization?: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
      readonly name: string;
    } | null;
    readonly canDelete?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    } | null;
    readonly canUpdate?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    } | null;
    readonly answers?: {
      readonly __typename: "RatingAnswerNodeConnection";
      readonly totalCount?: number | null;
      readonly averageRating?: number | null;
      readonly pageInfo: {
        readonly __typename: "PageInfo";
        readonly endCursor?: string | null;
        readonly hasNextPage: boolean;
      };
      readonly edges: ReadonlyArray<{
        readonly __typename: "RatingAnswerNodeEdge";
        readonly node?: {
          readonly __typename: "RatingAnswerNode";
          readonly id: number;
          readonly created: string;
          readonly integerAnswer: number;
          readonly creator: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
          };
          readonly createdInMeeting?: {
            readonly __typename: "MeetingNode";
            readonly id: number;
            readonly title?: string | null;
            readonly meetingGroupId: number;
            readonly startDatetime?: string | null;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
  readonly topicTemplates?: {
    readonly __typename: "TopicTemplateNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "TopicTemplateNodeEdge";
      readonly node?: {
        readonly __typename: "TopicTemplateNode";
        readonly id: number;
        readonly title: string;
      } | null;
    } | null>;
  } | null;
};

export type GetRatingsQueryVariables = Exact<{ [key: string]: never }>;

export type GetRatingsQuery = {
  readonly __typename: "Query";
  readonly ratings?: {
    readonly __typename: "RatingNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "RatingNodeEdge";
      readonly node?: {
        readonly __typename: "RatingNode";
        readonly id: number;
        readonly title: string;
        readonly created: string;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
        } | null;
        readonly answers?: {
          readonly __typename: "RatingAnswerNodeConnection";
          readonly totalCount?: number | null;
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type GetRecognitionBoardCoreValuesQueryQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  recipientId?: InputMaybe<Scalars["Int"]["input"]>;
  coreValueId?: InputMaybe<Scalars["Int"]["input"]>;
  receivedByMembersOfTeamId?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
    | InputMaybe<Scalars["Date"]["input"]>
  >;
  statsStartDate?: InputMaybe<Scalars["Date"]["input"]>;
  statsEndDate?: InputMaybe<Scalars["Date"]["input"]>;
}>;

export type GetRecognitionBoardCoreValuesQueryQuery = {
  readonly __typename: "Query";
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
    readonly coreValues?: {
      readonly __typename: "RecognitionCoreValueNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "RecognitionCoreValueNodeEdge";
        readonly node?: {
          readonly __typename: "RecognitionCoreValueNode";
          readonly id: number;
          readonly title: string;
          readonly description: string;
          readonly emoji?: string | null;
          readonly image?: string | null;
          readonly recognitions?: {
            readonly __typename: "ArtifactConnection";
            readonly totalCount: number;
          } | null;
        } | null;
      } | null>;
    } | null;
    readonly recognitionStats?: {
      readonly __typename: "RecognitionStatsNode";
      readonly recognitionCount?: number | null;
      readonly userWhoGaveMostRecognitionCount?: number | null;
      readonly userWhoReceivedMostRecognitionCount?: number | null;
      readonly userWhoGaveMostRecognition?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly avatar?: string | null;
        readonly name: string;
      } | null;
      readonly userWhoReceivedMostRecognition?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      } | null;
    } | null;
  } | null;
};

export type GetRecognitionBoardQueryQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  limit: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
  coreValueId?: InputMaybe<Scalars["Int"]["input"]>;
  recipientId?: InputMaybe<Scalars["Int"]["input"]>;
  receivedByMembersOfTeamId?: InputMaybe<Scalars["Int"]["input"]>;
  createdBetweenDates?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
    | InputMaybe<Scalars["Date"]["input"]>
  >;
}>;

export type GetRecognitionBoardQueryQuery = {
  readonly __typename: "Query";
  readonly artifacts?: {
    readonly __typename: "ArtifactConnection";
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly endCursor?: string | null;
      readonly hasNextPage: boolean;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "ArtifactEdge";
      readonly node?:
        | { readonly __typename: "ActionItemArtifactNode"; readonly id: number }
        | { readonly __typename: "AsanaTaskArtifactNode"; readonly id: number }
        | { readonly __typename: "DecisionArtifactNode"; readonly id: number }
        | { readonly __typename: "DocumentArtifactNode"; readonly id: number }
        | { readonly __typename: "FeedbackArtifactNode"; readonly id: number }
        | {
            readonly __typename: "GithubIssuesArtifactNode";
            readonly id: number;
          }
        | { readonly __typename: "GoalArtifactNode"; readonly id: number }
        | { readonly __typename: "KPIArtifactNode"; readonly id: number }
        | { readonly __typename: "RatingArtifactNode"; readonly id: number }
        | {
            readonly __typename: "RecognitionArtifactNode";
            readonly id: number;
            readonly artifactType: ArtifactType;
            readonly title?: string | null;
            readonly created: string;
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
            readonly recipients?: {
              readonly __typename: "UserNodeConnection";
              readonly totalCount: number;
              readonly edges: ReadonlyArray<{
                readonly __typename: "UserNodeEdge";
                readonly node?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly name: string;
                  readonly avatar?: string | null;
                } | null;
              } | null>;
            } | null;
            readonly recognitionCoreValue?: {
              readonly __typename: "RecognitionCoreValueNode";
              readonly id: number;
              readonly title: string;
              readonly description: string;
              readonly emoji?: string | null;
              readonly image?: string | null;
            } | null;
          }
        | null;
    } | null>;
  } | null;
};

type AssessmentCalibrationQuestion_CompetencyAssessmentQuestionNode_Fragment = {
  readonly __typename: "CompetencyAssessmentQuestionNode";
  readonly id: number;
  readonly title: string;
};

type AssessmentCalibrationQuestion_CompetencyCriteriaAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
    readonly id: number;
    readonly title: string;
  };

type AssessmentCalibrationQuestion_IndividualGoalAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "IndividualGoalAssessmentQuestionNode";
    readonly id: number;
    readonly title: string;
  };

type AssessmentCalibrationQuestion_IndividualRecognitionCoreValueAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
    readonly id: number;
    readonly title: string;
  };

type AssessmentCalibrationQuestion_MultiChoiceAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "MultiChoiceAssessmentQuestionNode";
    readonly id: number;
    readonly title: string;
  };

type AssessmentCalibrationQuestion_NpsAssessmentQuestionNode_Fragment = {
  readonly __typename: "NpsAssessmentQuestionNode";
  readonly id: number;
  readonly title: string;
};

type AssessmentCalibrationQuestion_OverallGoalAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "OverallGoalAssessmentQuestionNode";
    readonly id: number;
    readonly title: string;
  };

type AssessmentCalibrationQuestion_OverallRecognitionCoreValueAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
    readonly id: number;
    readonly title: string;
  };

type AssessmentCalibrationQuestion_RangeAssessmentQuestionNode_Fragment = {
  readonly __typename: "RangeAssessmentQuestionNode";
  readonly labels: ReadonlyArray<string | null>;
  readonly startValue: number;
  readonly endValue: number;
  readonly id: number;
  readonly title: string;
};

type AssessmentCalibrationQuestion_ResponsibilityAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "ResponsibilityAssessmentQuestionNode";
    readonly id: number;
    readonly title: string;
  };

type AssessmentCalibrationQuestion_TalentIndicatorAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "TalentIndicatorAssessmentQuestionNode";
    readonly labels: ReadonlyArray<string | null>;
    readonly startValue: number;
    readonly endValue: number;
    readonly id: number;
    readonly title: string;
  };

type AssessmentCalibrationQuestion_TextAssessmentQuestionNode_Fragment = {
  readonly __typename: "TextAssessmentQuestionNode";
  readonly id: number;
  readonly title: string;
};

export type AssessmentCalibrationQuestionFragment =
  | AssessmentCalibrationQuestion_CompetencyAssessmentQuestionNode_Fragment
  | AssessmentCalibrationQuestion_CompetencyCriteriaAssessmentQuestionNode_Fragment
  | AssessmentCalibrationQuestion_IndividualGoalAssessmentQuestionNode_Fragment
  | AssessmentCalibrationQuestion_IndividualRecognitionCoreValueAssessmentQuestionNode_Fragment
  | AssessmentCalibrationQuestion_MultiChoiceAssessmentQuestionNode_Fragment
  | AssessmentCalibrationQuestion_NpsAssessmentQuestionNode_Fragment
  | AssessmentCalibrationQuestion_OverallGoalAssessmentQuestionNode_Fragment
  | AssessmentCalibrationQuestion_OverallRecognitionCoreValueAssessmentQuestionNode_Fragment
  | AssessmentCalibrationQuestion_RangeAssessmentQuestionNode_Fragment
  | AssessmentCalibrationQuestion_ResponsibilityAssessmentQuestionNode_Fragment
  | AssessmentCalibrationQuestion_TalentIndicatorAssessmentQuestionNode_Fragment
  | AssessmentCalibrationQuestion_TextAssessmentQuestionNode_Fragment;

export type BatchAssessmentDeliveryActionMutationMutationVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  complianceProgramId: Scalars["Int"]["input"];
  targetIds: ReadonlyArray<Scalars["Int"]["input"]> | Scalars["Int"]["input"];
  action: BatchCalibrationAction;
}>;

export type BatchAssessmentDeliveryActionMutationMutation = {
  readonly __typename: "Mutation";
  readonly batchAssessmentDeliveryAction: {
    readonly __typename: "BatchAssessmentDeliveriesActionMutation";
    readonly assessmentDeliveries: ReadonlyArray<{
      readonly __typename: "AssessmentDeliveryNode";
      readonly id: number;
      readonly state: AssessmentDeliveryState;
      readonly canUpdate?: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
      } | null;
      readonly canRead?: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
      } | null;
    } | null>;
    readonly reportRows: {
      readonly __typename: "PerformanceReviewReportRowConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "PerformanceReviewReportRowEdge";
        readonly node?: {
          readonly __typename: "PerformanceReviewReportRowNode";
          readonly id: number;
          readonly calibrationStatus: ComplianceProgramCalibrationStatus;
        } | null;
      } | null>;
    };
  };
};

type CalibrationNode_RangeAssessmentAnswerCalibrationNode_Fragment = {
  readonly __typename: "RangeAssessmentAnswerCalibrationNode";
  readonly integerAnswer?: number | null;
  readonly prevIntegerAnswer?: number | null;
  readonly id: number;
  readonly comment?: any | null;
  readonly created: string;
  readonly isSuggestion: boolean;
  readonly isPrecalibration: boolean;
  readonly answerId?: number | null;
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
  readonly target?: {
    readonly __typename: "UserNode";
    readonly id: number;
  } | null;
  readonly question:
    | {
        readonly __typename: "CompetencyAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
      }
    | {
        readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
      }
    | {
        readonly __typename: "IndividualGoalAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
      }
    | {
        readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
      }
    | {
        readonly __typename: "MultiChoiceAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
      }
    | {
        readonly __typename: "NpsAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
      }
    | {
        readonly __typename: "OverallGoalAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
      }
    | {
        readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
      }
    | {
        readonly __typename: "RangeAssessmentQuestionNode";
        readonly labels: ReadonlyArray<string | null>;
        readonly startValue: number;
        readonly endValue: number;
        readonly id: number;
        readonly title: string;
      }
    | {
        readonly __typename: "ResponsibilityAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
      }
    | {
        readonly __typename: "TalentIndicatorAssessmentQuestionNode";
        readonly labels: ReadonlyArray<string | null>;
        readonly startValue: number;
        readonly endValue: number;
        readonly id: number;
        readonly title: string;
      }
    | {
        readonly __typename: "TextAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
      };
};

type CalibrationNode_TalentIndicatorAssessmentAnswerCalibrationNode_Fragment = {
  readonly __typename: "TalentIndicatorAssessmentAnswerCalibrationNode";
  readonly integerAnswer?: number | null;
  readonly prevIntegerAnswer?: number | null;
  readonly id: number;
  readonly comment?: any | null;
  readonly created: string;
  readonly isSuggestion: boolean;
  readonly isPrecalibration: boolean;
  readonly answerId?: number | null;
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
  readonly target?: {
    readonly __typename: "UserNode";
    readonly id: number;
  } | null;
  readonly question:
    | {
        readonly __typename: "CompetencyAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
      }
    | {
        readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
      }
    | {
        readonly __typename: "IndividualGoalAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
      }
    | {
        readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
      }
    | {
        readonly __typename: "MultiChoiceAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
      }
    | {
        readonly __typename: "NpsAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
      }
    | {
        readonly __typename: "OverallGoalAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
      }
    | {
        readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
      }
    | {
        readonly __typename: "RangeAssessmentQuestionNode";
        readonly labels: ReadonlyArray<string | null>;
        readonly startValue: number;
        readonly endValue: number;
        readonly id: number;
        readonly title: string;
      }
    | {
        readonly __typename: "ResponsibilityAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
      }
    | {
        readonly __typename: "TalentIndicatorAssessmentQuestionNode";
        readonly labels: ReadonlyArray<string | null>;
        readonly startValue: number;
        readonly endValue: number;
        readonly id: number;
        readonly title: string;
      }
    | {
        readonly __typename: "TextAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
      };
};

export type CalibrationNodeFragment =
  | CalibrationNode_RangeAssessmentAnswerCalibrationNode_Fragment
  | CalibrationNode_TalentIndicatorAssessmentAnswerCalibrationNode_Fragment;

export type ComplianceProgramCalibrationGroupFragment = {
  readonly __typename: "CalibrationGroupNode";
  readonly id: number;
  readonly name: string;
  readonly users?: ReadonlyArray<{
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null> | null;
  readonly managers?: ReadonlyArray<{
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null> | null;
  readonly approvers?: ReadonlyArray<{
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null> | null;
};

export type ComplianceProgramForReportAssessmentGroupSectionFragment = {
  readonly __typename: "AssessmentGroupSectionNode";
  readonly id: number;
  readonly title?: string | null;
  readonly description?: any | null;
  readonly questions: {
    readonly __typename: "AssessmentGroupQuestionContainerConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "AssessmentGroupQuestionContainerEdge";
      readonly node?: {
        readonly __typename: "AssessmentGroupQuestionContainer";
        readonly id: number;
        readonly question:
          | {
              readonly __typename: "CompetencyAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
              readonly description?: any | null;
              readonly startValue: number;
              readonly endValue: number;
              readonly labels: ReadonlyArray<string | null>;
              readonly questionType: AssessmentQuestionType;
              readonly responses: AssessmentQuestionResponses;
              readonly labelDescriptions: ReadonlyArray<string | null>;
              readonly comment: AssessmentQuestionComment;
            }
          | {
              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
              readonly description?: any | null;
              readonly startValue: number;
              readonly endValue: number;
              readonly labels: ReadonlyArray<string | null>;
              readonly questionType: AssessmentQuestionType;
              readonly responses: AssessmentQuestionResponses;
              readonly labelDescriptions: ReadonlyArray<string | null>;
              readonly comment: AssessmentQuestionComment;
            }
          | {
              readonly __typename: "IndividualGoalAssessmentQuestionNode";
              readonly id: number;
              readonly questionType: AssessmentQuestionType;
            }
          | {
              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
              readonly questionType: AssessmentQuestionType;
            }
          | {
              readonly __typename: "MultiChoiceAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
              readonly description?: any | null;
              readonly options: ReadonlyArray<string | null>;
              readonly questionType: AssessmentQuestionType;
              readonly responses: AssessmentQuestionResponses;
              readonly comment: AssessmentQuestionComment;
            }
          | {
              readonly __typename: "NpsAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
              readonly description?: any | null;
              readonly questionType: AssessmentQuestionType;
              readonly responses: AssessmentQuestionResponses;
              readonly comment: AssessmentQuestionComment;
            }
          | {
              readonly __typename: "OverallGoalAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
              readonly description?: any | null;
              readonly startValue: number;
              readonly endValue: number;
              readonly labels: ReadonlyArray<string | null>;
              readonly questionType: AssessmentQuestionType;
              readonly responses: AssessmentQuestionResponses;
              readonly labelDescriptions: ReadonlyArray<string | null>;
              readonly comment: AssessmentQuestionComment;
            }
          | {
              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
              readonly description?: any | null;
              readonly startValue: number;
              readonly endValue: number;
              readonly labels: ReadonlyArray<string | null>;
              readonly questionType: AssessmentQuestionType;
              readonly responses: AssessmentQuestionResponses;
              readonly labelDescriptions: ReadonlyArray<string | null>;
              readonly comment: AssessmentQuestionComment;
            }
          | {
              readonly __typename: "RangeAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
              readonly description?: any | null;
              readonly startValue: number;
              readonly endValue: number;
              readonly labels: ReadonlyArray<string | null>;
              readonly questionType: AssessmentQuestionType;
              readonly responses: AssessmentQuestionResponses;
              readonly labelDescriptions: ReadonlyArray<string | null>;
              readonly comment: AssessmentQuestionComment;
            }
          | {
              readonly __typename: "ResponsibilityAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
              readonly description?: any | null;
              readonly startValue: number;
              readonly endValue: number;
              readonly labels: ReadonlyArray<string | null>;
              readonly questionType: AssessmentQuestionType;
              readonly responses: AssessmentQuestionResponses;
              readonly labelDescriptions: ReadonlyArray<string | null>;
              readonly comment: AssessmentQuestionComment;
            }
          | {
              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
              readonly description?: any | null;
              readonly startValue: number;
              readonly endValue: number;
              readonly labels: ReadonlyArray<string | null>;
              readonly questionType: AssessmentQuestionType;
              readonly responses: AssessmentQuestionResponses;
              readonly labelDescriptions: ReadonlyArray<string | null>;
              readonly comment: AssessmentQuestionComment;
              readonly talentIndicator?: {
                readonly __typename: "TalentIndicatorNode";
                readonly id: number;
                readonly name: string;
                readonly customName?: string | null;
                readonly talentIndicatorType: TalentIndicatorType;
              } | null;
            }
          | {
              readonly __typename: "TextAssessmentQuestionNode";
              readonly id: number;
              readonly title: string;
              readonly description?: any | null;
              readonly questionType: AssessmentQuestionType;
              readonly responses: AssessmentQuestionResponses;
              readonly comment: AssessmentQuestionComment;
            };
      } | null;
    } | null>;
  };
};

export type ComplianceProgramForReportAssessmentGroupFragment = {
  readonly __typename: "AssessmentGroupNode";
  readonly id: number;
  readonly title: string;
  readonly sections: {
    readonly __typename: "AssessmentGroupSectionNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "AssessmentGroupSectionNodeEdge";
      readonly node?: {
        readonly __typename: "AssessmentGroupSectionNode";
        readonly id: number;
        readonly title?: string | null;
        readonly description?: any | null;
        readonly questions: {
          readonly __typename: "AssessmentGroupQuestionContainerConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "AssessmentGroupQuestionContainerEdge";
            readonly node?: {
              readonly __typename: "AssessmentGroupQuestionContainer";
              readonly id: number;
              readonly question:
                | {
                    readonly __typename: "CompetencyAssessmentQuestionNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description?: any | null;
                    readonly startValue: number;
                    readonly endValue: number;
                    readonly labels: ReadonlyArray<string | null>;
                    readonly questionType: AssessmentQuestionType;
                    readonly responses: AssessmentQuestionResponses;
                    readonly labelDescriptions: ReadonlyArray<string | null>;
                    readonly comment: AssessmentQuestionComment;
                  }
                | {
                    readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description?: any | null;
                    readonly startValue: number;
                    readonly endValue: number;
                    readonly labels: ReadonlyArray<string | null>;
                    readonly questionType: AssessmentQuestionType;
                    readonly responses: AssessmentQuestionResponses;
                    readonly labelDescriptions: ReadonlyArray<string | null>;
                    readonly comment: AssessmentQuestionComment;
                  }
                | {
                    readonly __typename: "IndividualGoalAssessmentQuestionNode";
                    readonly id: number;
                    readonly questionType: AssessmentQuestionType;
                  }
                | {
                    readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                    readonly id: number;
                    readonly questionType: AssessmentQuestionType;
                  }
                | {
                    readonly __typename: "MultiChoiceAssessmentQuestionNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description?: any | null;
                    readonly options: ReadonlyArray<string | null>;
                    readonly questionType: AssessmentQuestionType;
                    readonly responses: AssessmentQuestionResponses;
                    readonly comment: AssessmentQuestionComment;
                  }
                | {
                    readonly __typename: "NpsAssessmentQuestionNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description?: any | null;
                    readonly questionType: AssessmentQuestionType;
                    readonly responses: AssessmentQuestionResponses;
                    readonly comment: AssessmentQuestionComment;
                  }
                | {
                    readonly __typename: "OverallGoalAssessmentQuestionNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description?: any | null;
                    readonly startValue: number;
                    readonly endValue: number;
                    readonly labels: ReadonlyArray<string | null>;
                    readonly questionType: AssessmentQuestionType;
                    readonly responses: AssessmentQuestionResponses;
                    readonly labelDescriptions: ReadonlyArray<string | null>;
                    readonly comment: AssessmentQuestionComment;
                  }
                | {
                    readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description?: any | null;
                    readonly startValue: number;
                    readonly endValue: number;
                    readonly labels: ReadonlyArray<string | null>;
                    readonly questionType: AssessmentQuestionType;
                    readonly responses: AssessmentQuestionResponses;
                    readonly labelDescriptions: ReadonlyArray<string | null>;
                    readonly comment: AssessmentQuestionComment;
                  }
                | {
                    readonly __typename: "RangeAssessmentQuestionNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description?: any | null;
                    readonly startValue: number;
                    readonly endValue: number;
                    readonly labels: ReadonlyArray<string | null>;
                    readonly questionType: AssessmentQuestionType;
                    readonly responses: AssessmentQuestionResponses;
                    readonly labelDescriptions: ReadonlyArray<string | null>;
                    readonly comment: AssessmentQuestionComment;
                  }
                | {
                    readonly __typename: "ResponsibilityAssessmentQuestionNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description?: any | null;
                    readonly startValue: number;
                    readonly endValue: number;
                    readonly labels: ReadonlyArray<string | null>;
                    readonly questionType: AssessmentQuestionType;
                    readonly responses: AssessmentQuestionResponses;
                    readonly labelDescriptions: ReadonlyArray<string | null>;
                    readonly comment: AssessmentQuestionComment;
                  }
                | {
                    readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description?: any | null;
                    readonly startValue: number;
                    readonly endValue: number;
                    readonly labels: ReadonlyArray<string | null>;
                    readonly questionType: AssessmentQuestionType;
                    readonly responses: AssessmentQuestionResponses;
                    readonly labelDescriptions: ReadonlyArray<string | null>;
                    readonly comment: AssessmentQuestionComment;
                    readonly talentIndicator?: {
                      readonly __typename: "TalentIndicatorNode";
                      readonly id: number;
                      readonly name: string;
                      readonly customName?: string | null;
                      readonly talentIndicatorType: TalentIndicatorType;
                    } | null;
                  }
                | {
                    readonly __typename: "TextAssessmentQuestionNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description?: any | null;
                    readonly questionType: AssessmentQuestionType;
                    readonly responses: AssessmentQuestionResponses;
                    readonly comment: AssessmentQuestionComment;
                  };
            } | null;
          } | null>;
        };
      } | null;
    } | null>;
  };
};

type ComplianceProgramReportAnswer_CompetencyAssessmentAnswerNode_Fragment = {
  readonly __typename: "CompetencyAssessmentAnswerNode";
  readonly id: number;
  readonly questionId: number;
  readonly integerAnswer?: number | null;
  readonly comment?: any | null;
  readonly roleId: number;
  readonly hasCalibrations: boolean;
  readonly hasCalibrationSuggestions: boolean;
};

type ComplianceProgramReportAnswer_CompetencyCriteriaAssessmentAnswerNode_Fragment =
  {
    readonly __typename: "CompetencyCriteriaAssessmentAnswerNode";
    readonly id: number;
    readonly questionId: number;
    readonly integerAnswer?: number | null;
    readonly comment?: any | null;
    readonly roleId: number;
    readonly hasCalibrations: boolean;
    readonly hasCalibrationSuggestions: boolean;
  };

type ComplianceProgramReportAnswer_IndividualGoalAssessmentAnswerNode_Fragment =
  {
    readonly __typename: "IndividualGoalAssessmentAnswerNode";
    readonly id: number;
    readonly questionId: number;
    readonly integerAnswer?: number | null;
    readonly comment?: any | null;
    readonly hasCalibrations: boolean;
    readonly hasCalibrationSuggestions: boolean;
  };

type ComplianceProgramReportAnswer_IndividualRecognitionCoreValueAssessmentAnswerNode_Fragment =
  {
    readonly __typename: "IndividualRecognitionCoreValueAssessmentAnswerNode";
    readonly id: number;
    readonly questionId: number;
    readonly integerAnswer?: number | null;
    readonly comment?: any | null;
    readonly hasCalibrations: boolean;
    readonly hasCalibrationSuggestions: boolean;
  };

type ComplianceProgramReportAnswer_MultiChoiceAssessmentAnswerNode_Fragment = {
  readonly __typename: "MultiChoiceAssessmentAnswerNode";
  readonly id: number;
  readonly questionId: number;
  readonly choices: ReadonlyArray<number | null>;
  readonly comment?: any | null;
  readonly hasCalibrations: boolean;
  readonly hasCalibrationSuggestions: boolean;
};

type ComplianceProgramReportAnswer_NpsAssessmentAnswerNode_Fragment = {
  readonly __typename: "NpsAssessmentAnswerNode";
  readonly id: number;
  readonly questionId: number;
  readonly integerAnswer?: number | null;
  readonly comment?: any | null;
  readonly hasCalibrations: boolean;
  readonly hasCalibrationSuggestions: boolean;
};

type ComplianceProgramReportAnswer_OverallGoalAssessmentAnswerNode_Fragment = {
  readonly __typename: "OverallGoalAssessmentAnswerNode";
  readonly id: number;
  readonly questionId: number;
  readonly integerAnswer?: number | null;
  readonly comment?: any | null;
  readonly hasCalibrations: boolean;
  readonly hasCalibrationSuggestions: boolean;
};

type ComplianceProgramReportAnswer_OverallRecognitionCoreValueAssessmentAnswerNode_Fragment =
  {
    readonly __typename: "OverallRecognitionCoreValueAssessmentAnswerNode";
    readonly id: number;
    readonly questionId: number;
    readonly integerAnswer?: number | null;
    readonly comment?: any | null;
    readonly hasCalibrations: boolean;
    readonly hasCalibrationSuggestions: boolean;
  };

type ComplianceProgramReportAnswer_RangeAssessmentAnswerNode_Fragment = {
  readonly __typename: "RangeAssessmentAnswerNode";
  readonly id: number;
  readonly questionId: number;
  readonly integerAnswer?: number | null;
  readonly comment?: any | null;
  readonly hasCalibrations: boolean;
  readonly hasCalibrationSuggestions: boolean;
};

type ComplianceProgramReportAnswer_ResponsibilityAssessmentAnswerNode_Fragment =
  {
    readonly __typename: "ResponsibilityAssessmentAnswerNode";
    readonly id: number;
    readonly questionId: number;
    readonly integerAnswer?: number | null;
    readonly comment?: any | null;
    readonly roleId: number;
    readonly hasCalibrations: boolean;
    readonly hasCalibrationSuggestions: boolean;
  };

type ComplianceProgramReportAnswer_TalentIndicatorAssessmentAnswerNode_Fragment =
  {
    readonly __typename: "TalentIndicatorAssessmentAnswerNode";
    readonly id: number;
    readonly questionId: number;
    readonly integerAnswer?: number | null;
    readonly comment?: any | null;
    readonly hasCalibrations: boolean;
    readonly hasCalibrationSuggestions: boolean;
  };

type ComplianceProgramReportAnswer_TextAssessmentAnswerNode_Fragment = {
  readonly __typename: "TextAssessmentAnswerNode";
  readonly id: number;
  readonly questionId: number;
  readonly textAnswer?: any | null;
  readonly comment?: any | null;
  readonly hasCalibrations: boolean;
  readonly hasCalibrationSuggestions: boolean;
};

export type ComplianceProgramReportAnswerFragment =
  | ComplianceProgramReportAnswer_CompetencyAssessmentAnswerNode_Fragment
  | ComplianceProgramReportAnswer_CompetencyCriteriaAssessmentAnswerNode_Fragment
  | ComplianceProgramReportAnswer_IndividualGoalAssessmentAnswerNode_Fragment
  | ComplianceProgramReportAnswer_IndividualRecognitionCoreValueAssessmentAnswerNode_Fragment
  | ComplianceProgramReportAnswer_MultiChoiceAssessmentAnswerNode_Fragment
  | ComplianceProgramReportAnswer_NpsAssessmentAnswerNode_Fragment
  | ComplianceProgramReportAnswer_OverallGoalAssessmentAnswerNode_Fragment
  | ComplianceProgramReportAnswer_OverallRecognitionCoreValueAssessmentAnswerNode_Fragment
  | ComplianceProgramReportAnswer_RangeAssessmentAnswerNode_Fragment
  | ComplianceProgramReportAnswer_ResponsibilityAssessmentAnswerNode_Fragment
  | ComplianceProgramReportAnswer_TalentIndicatorAssessmentAnswerNode_Fragment
  | ComplianceProgramReportAnswer_TextAssessmentAnswerNode_Fragment;

export type ComplianceProgramReportAssessmentFragment = {
  readonly __typename: "AssessmentNode";
  readonly id: number;
  readonly state: AssessmentState;
  readonly roleAssessmentAvg?: number | null;
  readonly selfRoleAssessmentAvg?: number | null;
  readonly assessmentDeliveryState?: AssessmentDeliveryState | null;
  readonly responder?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly firstName: string;
    readonly avatar?: string | null;
  } | null;
  readonly target?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
    readonly organizationSpecificInfo?: {
      readonly __typename: "UserMemberNode";
      readonly startDate?: string | null;
    } | null;
    readonly primaryManager?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
    } | null;
    readonly teamsList: ReadonlyArray<{
      readonly __typename: "TeamNode";
      readonly id: number;
      readonly title: string;
    }>;
  } | null;
  readonly answers: ReadonlyArray<
    | {
        readonly __typename: "CompetencyAssessmentAnswerNode";
        readonly id: number;
        readonly questionId: number;
        readonly integerAnswer?: number | null;
        readonly comment?: any | null;
        readonly roleId: number;
        readonly hasCalibrations: boolean;
        readonly hasCalibrationSuggestions: boolean;
      }
    | {
        readonly __typename: "CompetencyCriteriaAssessmentAnswerNode";
        readonly id: number;
        readonly questionId: number;
        readonly integerAnswer?: number | null;
        readonly comment?: any | null;
        readonly roleId: number;
        readonly hasCalibrations: boolean;
        readonly hasCalibrationSuggestions: boolean;
      }
    | {
        readonly __typename: "IndividualGoalAssessmentAnswerNode";
        readonly id: number;
        readonly questionId: number;
        readonly integerAnswer?: number | null;
        readonly comment?: any | null;
        readonly hasCalibrations: boolean;
        readonly hasCalibrationSuggestions: boolean;
      }
    | {
        readonly __typename: "IndividualRecognitionCoreValueAssessmentAnswerNode";
        readonly id: number;
        readonly questionId: number;
        readonly integerAnswer?: number | null;
        readonly comment?: any | null;
        readonly hasCalibrations: boolean;
        readonly hasCalibrationSuggestions: boolean;
      }
    | {
        readonly __typename: "MultiChoiceAssessmentAnswerNode";
        readonly id: number;
        readonly questionId: number;
        readonly choices: ReadonlyArray<number | null>;
        readonly comment?: any | null;
        readonly hasCalibrations: boolean;
        readonly hasCalibrationSuggestions: boolean;
      }
    | {
        readonly __typename: "NpsAssessmentAnswerNode";
        readonly id: number;
        readonly questionId: number;
        readonly integerAnswer?: number | null;
        readonly comment?: any | null;
        readonly hasCalibrations: boolean;
        readonly hasCalibrationSuggestions: boolean;
      }
    | {
        readonly __typename: "OverallGoalAssessmentAnswerNode";
        readonly id: number;
        readonly questionId: number;
        readonly integerAnswer?: number | null;
        readonly comment?: any | null;
        readonly hasCalibrations: boolean;
        readonly hasCalibrationSuggestions: boolean;
      }
    | {
        readonly __typename: "OverallRecognitionCoreValueAssessmentAnswerNode";
        readonly id: number;
        readonly questionId: number;
        readonly integerAnswer?: number | null;
        readonly comment?: any | null;
        readonly hasCalibrations: boolean;
        readonly hasCalibrationSuggestions: boolean;
      }
    | {
        readonly __typename: "RangeAssessmentAnswerNode";
        readonly id: number;
        readonly questionId: number;
        readonly integerAnswer?: number | null;
        readonly comment?: any | null;
        readonly hasCalibrations: boolean;
        readonly hasCalibrationSuggestions: boolean;
      }
    | {
        readonly __typename: "ResponsibilityAssessmentAnswerNode";
        readonly id: number;
        readonly questionId: number;
        readonly integerAnswer?: number | null;
        readonly comment?: any | null;
        readonly roleId: number;
        readonly hasCalibrations: boolean;
        readonly hasCalibrationSuggestions: boolean;
      }
    | {
        readonly __typename: "TalentIndicatorAssessmentAnswerNode";
        readonly id: number;
        readonly questionId: number;
        readonly integerAnswer?: number | null;
        readonly comment?: any | null;
        readonly hasCalibrations: boolean;
        readonly hasCalibrationSuggestions: boolean;
      }
    | {
        readonly __typename: "TextAssessmentAnswerNode";
        readonly id: number;
        readonly questionId: number;
        readonly textAnswer?: any | null;
        readonly comment?: any | null;
        readonly hasCalibrations: boolean;
        readonly hasCalibrationSuggestions: boolean;
      }
    | null
  >;
  readonly assessmentDelivery?: {
    readonly __typename: "AssessmentDeliveryNode";
    readonly id: number;
    readonly state: AssessmentDeliveryState;
    readonly deliveryDatetime?: string | null;
    readonly canUpdate?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    } | null;
    readonly canRead?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    } | null;
  } | null;
  readonly template: {
    readonly __typename: "AssessmentTemplateNode";
    readonly id: number;
    readonly organization: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
    };
  };
};

type ComplianceProgramReportQuestion_CompetencyAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "CompetencyAssessmentQuestionNode";
    readonly id: number;
    readonly title: string;
    readonly description?: any | null;
    readonly startValue: number;
    readonly endValue: number;
    readonly labels: ReadonlyArray<string | null>;
    readonly questionType: AssessmentQuestionType;
    readonly responses: AssessmentQuestionResponses;
    readonly labelDescriptions: ReadonlyArray<string | null>;
    readonly comment: AssessmentQuestionComment;
  };

type ComplianceProgramReportQuestion_CompetencyCriteriaAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
    readonly id: number;
    readonly title: string;
    readonly description?: any | null;
    readonly startValue: number;
    readonly endValue: number;
    readonly labels: ReadonlyArray<string | null>;
    readonly questionType: AssessmentQuestionType;
    readonly responses: AssessmentQuestionResponses;
    readonly labelDescriptions: ReadonlyArray<string | null>;
    readonly comment: AssessmentQuestionComment;
  };

type ComplianceProgramReportQuestion_IndividualGoalAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "IndividualGoalAssessmentQuestionNode";
    readonly id: number;
    readonly questionType: AssessmentQuestionType;
  };

type ComplianceProgramReportQuestion_IndividualRecognitionCoreValueAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
    readonly id: number;
    readonly questionType: AssessmentQuestionType;
  };

type ComplianceProgramReportQuestion_MultiChoiceAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "MultiChoiceAssessmentQuestionNode";
    readonly id: number;
    readonly title: string;
    readonly description?: any | null;
    readonly options: ReadonlyArray<string | null>;
    readonly questionType: AssessmentQuestionType;
    readonly responses: AssessmentQuestionResponses;
    readonly comment: AssessmentQuestionComment;
  };

type ComplianceProgramReportQuestion_NpsAssessmentQuestionNode_Fragment = {
  readonly __typename: "NpsAssessmentQuestionNode";
  readonly id: number;
  readonly title: string;
  readonly description?: any | null;
  readonly questionType: AssessmentQuestionType;
  readonly responses: AssessmentQuestionResponses;
  readonly comment: AssessmentQuestionComment;
};

type ComplianceProgramReportQuestion_OverallGoalAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "OverallGoalAssessmentQuestionNode";
    readonly id: number;
    readonly title: string;
    readonly description?: any | null;
    readonly startValue: number;
    readonly endValue: number;
    readonly labels: ReadonlyArray<string | null>;
    readonly questionType: AssessmentQuestionType;
    readonly responses: AssessmentQuestionResponses;
    readonly labelDescriptions: ReadonlyArray<string | null>;
    readonly comment: AssessmentQuestionComment;
  };

type ComplianceProgramReportQuestion_OverallRecognitionCoreValueAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
    readonly id: number;
    readonly title: string;
    readonly description?: any | null;
    readonly startValue: number;
    readonly endValue: number;
    readonly labels: ReadonlyArray<string | null>;
    readonly questionType: AssessmentQuestionType;
    readonly responses: AssessmentQuestionResponses;
    readonly labelDescriptions: ReadonlyArray<string | null>;
    readonly comment: AssessmentQuestionComment;
  };

type ComplianceProgramReportQuestion_RangeAssessmentQuestionNode_Fragment = {
  readonly __typename: "RangeAssessmentQuestionNode";
  readonly id: number;
  readonly title: string;
  readonly description?: any | null;
  readonly startValue: number;
  readonly endValue: number;
  readonly labels: ReadonlyArray<string | null>;
  readonly questionType: AssessmentQuestionType;
  readonly responses: AssessmentQuestionResponses;
  readonly labelDescriptions: ReadonlyArray<string | null>;
  readonly comment: AssessmentQuestionComment;
};

type ComplianceProgramReportQuestion_ResponsibilityAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "ResponsibilityAssessmentQuestionNode";
    readonly id: number;
    readonly title: string;
    readonly description?: any | null;
    readonly startValue: number;
    readonly endValue: number;
    readonly labels: ReadonlyArray<string | null>;
    readonly questionType: AssessmentQuestionType;
    readonly responses: AssessmentQuestionResponses;
    readonly labelDescriptions: ReadonlyArray<string | null>;
    readonly comment: AssessmentQuestionComment;
  };

type ComplianceProgramReportQuestion_TalentIndicatorAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "TalentIndicatorAssessmentQuestionNode";
    readonly id: number;
    readonly title: string;
    readonly description?: any | null;
    readonly startValue: number;
    readonly endValue: number;
    readonly labels: ReadonlyArray<string | null>;
    readonly questionType: AssessmentQuestionType;
    readonly responses: AssessmentQuestionResponses;
    readonly labelDescriptions: ReadonlyArray<string | null>;
    readonly comment: AssessmentQuestionComment;
    readonly talentIndicator?: {
      readonly __typename: "TalentIndicatorNode";
      readonly id: number;
      readonly name: string;
      readonly customName?: string | null;
      readonly talentIndicatorType: TalentIndicatorType;
    } | null;
  };

type ComplianceProgramReportQuestion_TextAssessmentQuestionNode_Fragment = {
  readonly __typename: "TextAssessmentQuestionNode";
  readonly id: number;
  readonly title: string;
  readonly description?: any | null;
  readonly questionType: AssessmentQuestionType;
  readonly responses: AssessmentQuestionResponses;
  readonly comment: AssessmentQuestionComment;
};

export type ComplianceProgramReportQuestionFragment =
  | ComplianceProgramReportQuestion_CompetencyAssessmentQuestionNode_Fragment
  | ComplianceProgramReportQuestion_CompetencyCriteriaAssessmentQuestionNode_Fragment
  | ComplianceProgramReportQuestion_IndividualGoalAssessmentQuestionNode_Fragment
  | ComplianceProgramReportQuestion_IndividualRecognitionCoreValueAssessmentQuestionNode_Fragment
  | ComplianceProgramReportQuestion_MultiChoiceAssessmentQuestionNode_Fragment
  | ComplianceProgramReportQuestion_NpsAssessmentQuestionNode_Fragment
  | ComplianceProgramReportQuestion_OverallGoalAssessmentQuestionNode_Fragment
  | ComplianceProgramReportQuestion_OverallRecognitionCoreValueAssessmentQuestionNode_Fragment
  | ComplianceProgramReportQuestion_RangeAssessmentQuestionNode_Fragment
  | ComplianceProgramReportQuestion_ResponsibilityAssessmentQuestionNode_Fragment
  | ComplianceProgramReportQuestion_TalentIndicatorAssessmentQuestionNode_Fragment
  | ComplianceProgramReportQuestion_TextAssessmentQuestionNode_Fragment;

export type ComplianceProgramTargetFragment = {
  readonly __typename: "UserNode";
  readonly id: number;
  readonly name: string;
  readonly avatar?: string | null;
  readonly organizationSpecificInfo?: {
    readonly __typename: "UserMemberNode";
    readonly startDate?: string | null;
  } | null;
  readonly primaryManager?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
  } | null;
  readonly teamsList: ReadonlyArray<{
    readonly __typename: "TeamNode";
    readonly id: number;
    readonly title: string;
  }>;
};

export type SaveCalibrationGroupMutationVariables = Exact<{
  complianceProgramId: Scalars["Int"]["input"];
  name: Scalars["String"]["input"];
  userIds: ReadonlyArray<Scalars["Int"]["input"]> | Scalars["Int"]["input"];
  managerIds: ReadonlyArray<Scalars["Int"]["input"]> | Scalars["Int"]["input"];
  approverIds: ReadonlyArray<Scalars["Int"]["input"]> | Scalars["Int"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type SaveCalibrationGroupMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateCalibrationGroup?: {
    readonly __typename: "CreateOrUpdateCalibrationGroupMutation";
    readonly calibrationGroup: {
      readonly __typename: "CalibrationGroupNode";
      readonly id: number;
      readonly name: string;
      readonly users?: ReadonlyArray<{
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      } | null> | null;
      readonly managers?: ReadonlyArray<{
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      } | null> | null;
      readonly approvers?: ReadonlyArray<{
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      } | null> | null;
    };
  } | null;
};

export type SaveComplianceProgramReportingViewMutationVariables = Exact<{
  complianceProgramId: Scalars["Int"]["input"];
  assessmentType: AssessmentType;
  name: Scalars["String"]["input"];
  viewOptions: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type SaveComplianceProgramReportingViewMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateComplianceProgramReportingView?: {
    readonly __typename: "CreateOrUpdateComplianceProgramReportingViewMutation";
    readonly complianceProgramReportingView: {
      readonly __typename: "ComplianceProgramReportingViewNode";
      readonly id: number;
      readonly name?: string | null;
      readonly viewOptions: any;
    };
  } | null;
};

export type SavePerfAssessmentLabelMutationVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  labels:
    | ReadonlyArray<InputMaybe<PerformanceAssessmentChartLabelInput>>
    | InputMaybe<PerformanceAssessmentChartLabelInput>;
}>;

export type SavePerfAssessmentLabelMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdatePerformanceAssessmentChartLabel: {
    readonly __typename: "CreateOrUpdatePerformanceAssessmentChartLabel";
    readonly performanceAssessmentChartLabels: ReadonlyArray<{
      readonly __typename: "PerformanceAssessmentChartLabelNode";
      readonly id: number;
      readonly label: string;
      readonly questionOneIntegerAnswer: number;
      readonly questionTwoIntegerAnswer?: number | null;
      readonly questionOne:
        | {
            readonly __typename: "CompetencyAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "IndividualGoalAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "MultiChoiceAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "NpsAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "OverallGoalAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "RangeAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "ResponsibilityAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "TalentIndicatorAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "TextAssessmentQuestionNode";
            readonly id: number;
          };
      readonly questionTwo?:
        | {
            readonly __typename: "CompetencyAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "IndividualGoalAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "MultiChoiceAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "NpsAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "OverallGoalAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "RangeAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "ResponsibilityAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "TalentIndicatorAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "TextAssessmentQuestionNode";
            readonly id: number;
          }
        | null;
    } | null>;
  };
};

export type TrashComplianceProgramCalibrationGroupMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
}>;

export type TrashComplianceProgramCalibrationGroupMutation = {
  readonly __typename: "Mutation";
  readonly deleteCalibrationGroup?: {
    readonly __typename: "DeleteCalibrationGroupMutation";
    readonly ok: boolean;
  } | null;
};

export type TrashComplianceProgramReportingViewMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
}>;

export type TrashComplianceProgramReportingViewMutation = {
  readonly __typename: "Mutation";
  readonly deleteComplianceProgramReportingView?: {
    readonly __typename: "DeleteComplianceProgramReportingViewMutation";
    readonly ok?: boolean | null;
  } | null;
};

export type ExportEngagementSurveyToCsvMutationMutationVariables = Exact<{
  complianceProgramId: Scalars["Int"]["input"];
  groupBy?: InputMaybe<EngagementSurveyReportGroupBy>;
}>;

export type ExportEngagementSurveyToCsvMutationMutation = {
  readonly __typename: "Mutation";
  readonly exportComplianceProgramEngagementSurveyToCsv?: {
    readonly __typename: "ExportComplianceProgramEngagementSurveyToCSV";
    readonly complianceProgram?: {
      readonly __typename: "ComplianceProgramNode";
      readonly id: number;
    } | null;
  } | null;
};

export type ExportEngagementSurveyHeatmapToCsvMutationMutationVariables =
  Exact<{
    complianceProgramId: Scalars["Int"]["input"];
    groupBy: EngagementSurveyReportGroupBy;
    teamIds?: InputMaybe<
      | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
      | InputMaybe<Scalars["Int"]["input"]>
    >;
    managerIds?: InputMaybe<
      | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
      | InputMaybe<Scalars["Int"]["input"]>
    >;
    managerIdsFullTree?: InputMaybe<
      | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
      | InputMaybe<Scalars["Int"]["input"]>
    >;
    employeeStartDateRange?: InputMaybe<
      | ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
      | InputMaybe<Scalars["String"]["input"]>
    >;
    locations?: InputMaybe<
      | ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
      | InputMaybe<Scalars["String"]["input"]>
    >;
    collapsedKeys?: InputMaybe<
      | ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
      | InputMaybe<Scalars["String"]["input"]>
    >;
  }>;

export type ExportEngagementSurveyHeatmapToCsvMutationMutation = {
  readonly __typename: "Mutation";
  readonly exportComplianceProgramEngagementSurveyHeatmapToCsv?: {
    readonly __typename: "ExportComplianceProgramEngagementSurveyHeatmapToCSV";
    readonly complianceProgram?: {
      readonly __typename: "ComplianceProgramNode";
      readonly id: number;
    } | null;
  } | null;
};

export type ExportPerformanceAssessmentCsvMutationVariables = Exact<{
  complianceProgramId: Scalars["Int"]["input"];
  userIds?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  reportToIds?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  teamIds?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  roleIds?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  roleLevels?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  careerTrackIds?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  enrollmentDateFilter?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Date"]["input"]>>
    | InputMaybe<Scalars["Date"]["input"]>
  >;
  answerFilters?: InputMaybe<
    | ReadonlyArray<InputMaybe<PerformanceAssessmentAnswerFilter>>
    | InputMaybe<PerformanceAssessmentAnswerFilter>
  >;
  talentIndicatorFilters?: InputMaybe<
    | ReadonlyArray<
        InputMaybe<
          | ReadonlyArray<InputMaybe<PerformanceAssessmentAnswerFilter>>
          | InputMaybe<PerformanceAssessmentAnswerFilter>
        >
      >
    | InputMaybe<
        | ReadonlyArray<InputMaybe<PerformanceAssessmentAnswerFilter>>
        | InputMaybe<PerformanceAssessmentAnswerFilter>
      >
  >;
  matchAny?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type ExportPerformanceAssessmentCsvMutation = {
  readonly __typename: "Mutation";
  readonly exportComplianceProgramPerformanceAssessmentToCsv?: {
    readonly __typename: "ExportComplianceProgramPerformanceAssessmentToCSV";
    readonly complianceProgram?: {
      readonly __typename: "ComplianceProgramNode";
      readonly id: number;
    } | null;
  } | null;
};

export type GetAdoptionReportQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  attributes:
    | ReadonlyArray<InputMaybe<AdoptionReportAttribute>>
    | InputMaybe<AdoptionReportAttribute>;
  metrics:
    | ReadonlyArray<InputMaybe<AdoptionReportMetric>>
    | InputMaybe<AdoptionReportMetric>;
  filters:
    | ReadonlyArray<InputMaybe<ReportFilterInput>>
    | InputMaybe<ReportFilterInput>;
}>;

export type GetAdoptionReportQuery = {
  readonly __typename: "Query";
  readonly adoptionReport: {
    readonly __typename: "ReportResponseNode";
    readonly totalValues: ReadonlyArray<number | null>;
    readonly data: ReadonlyArray<{
      readonly __typename: "ReportResponseRowNode";
      readonly attributeValues: ReadonlyArray<string | null>;
      readonly metricValues: ReadonlyArray<number | null>;
    } | null>;
  };
};

export type GetAllPrecalibrationsQueryVariables = Exact<{
  complianceProgramId: Scalars["Int"]["input"];
  templateId: Scalars["Int"]["input"];
}>;

export type GetAllPrecalibrationsQuery = {
  readonly __typename: "Query";
  readonly assessmentCalibrations?: {
    readonly __typename: "AssessmentAnswerCalibrationConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "AssessmentAnswerCalibrationEdge";
      readonly node?:
        | {
            readonly __typename: "RangeAssessmentAnswerCalibrationNode";
            readonly integerAnswer?: number | null;
            readonly prevIntegerAnswer?: number | null;
            readonly id: number;
            readonly comment?: any | null;
            readonly created: string;
            readonly isSuggestion: boolean;
            readonly isPrecalibration: boolean;
            readonly answerId?: number | null;
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
            readonly target?: {
              readonly __typename: "UserNode";
              readonly id: number;
            } | null;
            readonly question:
              | {
                  readonly __typename: "CompetencyAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "IndividualGoalAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "MultiChoiceAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "NpsAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "OverallGoalAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "RangeAssessmentQuestionNode";
                  readonly labels: ReadonlyArray<string | null>;
                  readonly startValue: number;
                  readonly endValue: number;
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "ResponsibilityAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                  readonly labels: ReadonlyArray<string | null>;
                  readonly startValue: number;
                  readonly endValue: number;
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "TextAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                };
          }
        | {
            readonly __typename: "TalentIndicatorAssessmentAnswerCalibrationNode";
            readonly integerAnswer?: number | null;
            readonly prevIntegerAnswer?: number | null;
            readonly id: number;
            readonly comment?: any | null;
            readonly created: string;
            readonly isSuggestion: boolean;
            readonly isPrecalibration: boolean;
            readonly answerId?: number | null;
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
            readonly target?: {
              readonly __typename: "UserNode";
              readonly id: number;
            } | null;
            readonly question:
              | {
                  readonly __typename: "CompetencyAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "IndividualGoalAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "MultiChoiceAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "NpsAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "OverallGoalAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "RangeAssessmentQuestionNode";
                  readonly labels: ReadonlyArray<string | null>;
                  readonly startValue: number;
                  readonly endValue: number;
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "ResponsibilityAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                  readonly labels: ReadonlyArray<string | null>;
                  readonly startValue: number;
                  readonly endValue: number;
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "TextAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                };
          }
        | null;
    } | null>;
  } | null;
};

export type GetAssessmentAnswerCalibrationsQueryVariables = Exact<{
  complianceProgramId: Scalars["Int"]["input"];
  templateId: Scalars["Int"]["input"];
  targetId: Scalars["Int"]["input"];
}>;

export type GetAssessmentAnswerCalibrationsQuery = {
  readonly __typename: "Query";
  readonly assessmentCalibrations?: {
    readonly __typename: "AssessmentAnswerCalibrationConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "AssessmentAnswerCalibrationEdge";
      readonly node?:
        | {
            readonly __typename: "RangeAssessmentAnswerCalibrationNode";
            readonly integerAnswer?: number | null;
            readonly prevIntegerAnswer?: number | null;
            readonly id: number;
            readonly comment?: any | null;
            readonly created: string;
            readonly isSuggestion: boolean;
            readonly isPrecalibration: boolean;
            readonly answerId?: number | null;
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
            readonly target?: {
              readonly __typename: "UserNode";
              readonly id: number;
            } | null;
            readonly question:
              | {
                  readonly __typename: "CompetencyAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "IndividualGoalAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "MultiChoiceAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "NpsAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "OverallGoalAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "RangeAssessmentQuestionNode";
                  readonly labels: ReadonlyArray<string | null>;
                  readonly startValue: number;
                  readonly endValue: number;
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "ResponsibilityAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                  readonly labels: ReadonlyArray<string | null>;
                  readonly startValue: number;
                  readonly endValue: number;
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "TextAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                };
          }
        | {
            readonly __typename: "TalentIndicatorAssessmentAnswerCalibrationNode";
            readonly integerAnswer?: number | null;
            readonly prevIntegerAnswer?: number | null;
            readonly id: number;
            readonly comment?: any | null;
            readonly created: string;
            readonly isSuggestion: boolean;
            readonly isPrecalibration: boolean;
            readonly answerId?: number | null;
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
            readonly target?: {
              readonly __typename: "UserNode";
              readonly id: number;
            } | null;
            readonly question:
              | {
                  readonly __typename: "CompetencyAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "IndividualGoalAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "MultiChoiceAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "NpsAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "OverallGoalAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "RangeAssessmentQuestionNode";
                  readonly labels: ReadonlyArray<string | null>;
                  readonly startValue: number;
                  readonly endValue: number;
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "ResponsibilityAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                  readonly labels: ReadonlyArray<string | null>;
                  readonly startValue: number;
                  readonly endValue: number;
                  readonly id: number;
                  readonly title: string;
                }
              | {
                  readonly __typename: "TextAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                };
          }
        | null;
    } | null>;
  } | null;
};

export type ComplianceProgramReportPrevAnswerFragment = {
  readonly __typename: "MostRecentAssessmentAnswerNode";
  readonly questionId: number;
  readonly questionType: AssessmentQuestionType;
  readonly integerAnswer: number;
  readonly submitted: string;
};

export type GetAssessmentMostRecentAnswersQueryVariables = Exact<{
  complianceProgramId: Scalars["Int"]["input"];
}>;

export type GetAssessmentMostRecentAnswersQuery = {
  readonly __typename: "Query";
  readonly complianceProgram?: {
    readonly __typename: "ComplianceProgramNode";
    readonly performanceReportRows: {
      readonly __typename: "PerformanceReviewReportRowConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "PerformanceReviewReportRowEdge";
        readonly node?: {
          readonly __typename: "PerformanceReviewReportRowNode";
          readonly id: number;
          readonly user: {
            readonly __typename: "UserNode";
            readonly id: number;
          };
          readonly assessment?: {
            readonly __typename: "AssessmentNode";
            readonly id: number;
            readonly mostRecentAnswers?: ReadonlyArray<{
              readonly __typename: "MostRecentAssessmentAnswerNode";
              readonly questionId: number;
              readonly questionType: AssessmentQuestionType;
              readonly integerAnswer: number;
              readonly submitted: string;
            } | null> | null;
          } | null;
        } | null;
      } | null>;
    };
  } | null;
};

export type GetComplianceProgramAssessmentsQueryVariables = Exact<{
  complianceProgramId: Scalars["Int"]["input"];
  targetId: Scalars["Int"]["input"];
}>;

export type GetComplianceProgramAssessmentsQuery = {
  readonly __typename: "Query";
  readonly complianceProgram?: {
    readonly __typename: "ComplianceProgramNode";
    readonly id: number;
    readonly assessments: {
      readonly __typename: "AssessmentNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AssessmentNodeEdge";
        readonly node?: {
          readonly __typename: "AssessmentNode";
          readonly id: number;
          readonly state: AssessmentState;
          readonly template: {
            readonly __typename: "AssessmentTemplateNode";
            readonly id: number;
            readonly assessmentType: AssessmentType;
          };
          readonly canUpdate?: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
            readonly reason: string;
          } | null;
          readonly responder?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
          readonly target?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
        } | null;
      } | null>;
    };
  } | null;
};

export type GetComplianceProgramCalibrationGroupsQueryVariables = Exact<{
  complianceProgramId: Scalars["Int"]["input"];
}>;

export type GetComplianceProgramCalibrationGroupsQuery = {
  readonly __typename: "Query";
  readonly calibrationGroups: {
    readonly __typename: "CalibrationGroupNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "CalibrationGroupNodeEdge";
      readonly node?: {
        readonly __typename: "CalibrationGroupNode";
        readonly id: number;
        readonly name: string;
        readonly users?: ReadonlyArray<{
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null> | null;
        readonly managers?: ReadonlyArray<{
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null> | null;
        readonly approvers?: ReadonlyArray<{
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null> | null;
      } | null;
    } | null>;
  };
};

export type EngagementSurveyReportResponderFragment = {
  readonly __typename: "EngagementSurveyReportRespondersNode";
  readonly rollupType: EngagementSurveyRollupType;
  readonly isManager?: boolean | null;
  readonly responderCount: number;
  readonly totalResponders: number;
  readonly isHidden: boolean;
  readonly isCollapsed: boolean;
  readonly location?: string | null;
  readonly team?: {
    readonly __typename: "TeamNode";
    readonly id: number;
    readonly title: string;
  } | null;
  readonly manager?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly firstName: string;
    readonly avatar?: string | null;
  } | null;
  readonly careerTrack?: {
    readonly __typename: "CareerTrackNode";
    readonly id: number;
    readonly title: string;
  } | null;
};

export type EngagementSurveyReportRowRollupFragment = {
  readonly __typename: "EngagementSurveyReportRollupNode";
  readonly rollupType: EngagementSurveyRollupType;
  readonly location?: string | null;
  readonly isManager?: boolean | null;
  readonly value: number;
  readonly team?: {
    readonly __typename: "TeamNode";
    readonly id: number;
    readonly title: string;
  } | null;
  readonly manager?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly firstName: string;
    readonly avatar?: string | null;
  } | null;
  readonly careerTrack?: {
    readonly __typename: "CareerTrackNode";
    readonly id: number;
    readonly title: string;
  } | null;
};

export type EngagementSurveyReportRowFragment = {
  readonly __typename: "EngagementSurveyReportRowNode";
  readonly title: string;
  readonly question:
    | {
        readonly __typename: "CompetencyAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
        readonly description?: any | null;
        readonly startValue: number;
        readonly endValue: number;
        readonly labels: ReadonlyArray<string | null>;
        readonly questionType: AssessmentQuestionType;
        readonly responses: AssessmentQuestionResponses;
        readonly labelDescriptions: ReadonlyArray<string | null>;
        readonly comment: AssessmentQuestionComment;
      }
    | {
        readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
        readonly description?: any | null;
        readonly startValue: number;
        readonly endValue: number;
        readonly labels: ReadonlyArray<string | null>;
        readonly questionType: AssessmentQuestionType;
        readonly responses: AssessmentQuestionResponses;
        readonly labelDescriptions: ReadonlyArray<string | null>;
        readonly comment: AssessmentQuestionComment;
      }
    | {
        readonly __typename: "IndividualGoalAssessmentQuestionNode";
        readonly id: number;
        readonly questionType: AssessmentQuestionType;
      }
    | {
        readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
        readonly id: number;
        readonly questionType: AssessmentQuestionType;
      }
    | {
        readonly __typename: "MultiChoiceAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
        readonly description?: any | null;
        readonly options: ReadonlyArray<string | null>;
        readonly questionType: AssessmentQuestionType;
        readonly responses: AssessmentQuestionResponses;
        readonly comment: AssessmentQuestionComment;
      }
    | {
        readonly __typename: "NpsAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
        readonly description?: any | null;
        readonly questionType: AssessmentQuestionType;
        readonly responses: AssessmentQuestionResponses;
        readonly comment: AssessmentQuestionComment;
      }
    | {
        readonly __typename: "OverallGoalAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
        readonly description?: any | null;
        readonly startValue: number;
        readonly endValue: number;
        readonly labels: ReadonlyArray<string | null>;
        readonly questionType: AssessmentQuestionType;
        readonly responses: AssessmentQuestionResponses;
        readonly labelDescriptions: ReadonlyArray<string | null>;
        readonly comment: AssessmentQuestionComment;
      }
    | {
        readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
        readonly description?: any | null;
        readonly startValue: number;
        readonly endValue: number;
        readonly labels: ReadonlyArray<string | null>;
        readonly questionType: AssessmentQuestionType;
        readonly responses: AssessmentQuestionResponses;
        readonly labelDescriptions: ReadonlyArray<string | null>;
        readonly comment: AssessmentQuestionComment;
      }
    | {
        readonly __typename: "RangeAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
        readonly description?: any | null;
        readonly startValue: number;
        readonly endValue: number;
        readonly labels: ReadonlyArray<string | null>;
        readonly questionType: AssessmentQuestionType;
        readonly responses: AssessmentQuestionResponses;
        readonly labelDescriptions: ReadonlyArray<string | null>;
        readonly comment: AssessmentQuestionComment;
      }
    | {
        readonly __typename: "ResponsibilityAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
        readonly description?: any | null;
        readonly startValue: number;
        readonly endValue: number;
        readonly labels: ReadonlyArray<string | null>;
        readonly questionType: AssessmentQuestionType;
        readonly responses: AssessmentQuestionResponses;
        readonly labelDescriptions: ReadonlyArray<string | null>;
        readonly comment: AssessmentQuestionComment;
      }
    | {
        readonly __typename: "TalentIndicatorAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
        readonly description?: any | null;
        readonly startValue: number;
        readonly endValue: number;
        readonly labels: ReadonlyArray<string | null>;
        readonly questionType: AssessmentQuestionType;
        readonly responses: AssessmentQuestionResponses;
        readonly labelDescriptions: ReadonlyArray<string | null>;
        readonly comment: AssessmentQuestionComment;
        readonly talentIndicator?: {
          readonly __typename: "TalentIndicatorNode";
          readonly id: number;
          readonly name: string;
          readonly customName?: string | null;
          readonly talentIndicatorType: TalentIndicatorType;
        } | null;
      }
    | {
        readonly __typename: "TextAssessmentQuestionNode";
        readonly id: number;
        readonly title: string;
        readonly description?: any | null;
        readonly questionType: AssessmentQuestionType;
        readonly responses: AssessmentQuestionResponses;
        readonly comment: AssessmentQuestionComment;
      };
  readonly rollups: {
    readonly __typename: "EngagementSurveyReportRollupConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "EngagementSurveyReportRollupEdge";
      readonly node?: {
        readonly __typename: "EngagementSurveyReportRollupNode";
        readonly rollupType: EngagementSurveyRollupType;
        readonly location?: string | null;
        readonly isManager?: boolean | null;
        readonly value: number;
        readonly team?: {
          readonly __typename: "TeamNode";
          readonly id: number;
          readonly title: string;
        } | null;
        readonly manager?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly firstName: string;
          readonly avatar?: string | null;
        } | null;
        readonly careerTrack?: {
          readonly __typename: "CareerTrackNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null;
    } | null>;
  };
};

export type GetComplianceProgramEngagementSurveyReportQueryVariables = Exact<{
  complianceProgramId: Scalars["Int"]["input"];
  groupBy: EngagementSurveyReportGroupBy;
  teamIds?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  managerIds?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  managerIdsFullTree?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  employeeStartDateRange?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
  locations?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
  collapsedKeys?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
}>;

export type GetComplianceProgramEngagementSurveyReportQuery = {
  readonly __typename: "Query";
  readonly complianceProgram?: {
    readonly __typename: "ComplianceProgramNode";
    readonly hasAccessToAppliesToUsers: boolean;
    readonly canReadDetails: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    };
    readonly assessmentDeliveries: {
      readonly __typename: "AssessmentDeliveryNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AssessmentDeliveryNodeEdge";
        readonly node?: {
          readonly __typename: "AssessmentDeliveryNode";
          readonly id: number;
        } | null;
      } | null>;
    };
    readonly engagementSurveyReport?: {
      readonly __typename: "EngagementSurveyReportNode";
      readonly responders: {
        readonly __typename: "EngagementSurveyReportRespondersConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "EngagementSurveyReportRespondersEdge";
          readonly node?: {
            readonly __typename: "EngagementSurveyReportRespondersNode";
            readonly rollupType: EngagementSurveyRollupType;
            readonly isManager?: boolean | null;
            readonly responderCount: number;
            readonly totalResponders: number;
            readonly isHidden: boolean;
            readonly isCollapsed: boolean;
            readonly location?: string | null;
            readonly team?: {
              readonly __typename: "TeamNode";
              readonly id: number;
              readonly title: string;
            } | null;
            readonly manager?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly firstName: string;
              readonly avatar?: string | null;
            } | null;
            readonly careerTrack?: {
              readonly __typename: "CareerTrackNode";
              readonly id: number;
              readonly title: string;
            } | null;
          } | null;
        } | null>;
      };
      readonly rangeQuestionRows: {
        readonly __typename: "EngagementSurveyReportRowConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "EngagementSurveyReportRowEdge";
          readonly node?: {
            readonly __typename: "EngagementSurveyReportRowNode";
            readonly title: string;
            readonly question:
              | {
                  readonly __typename: "CompetencyAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                  readonly description?: any | null;
                  readonly startValue: number;
                  readonly endValue: number;
                  readonly labels: ReadonlyArray<string | null>;
                  readonly questionType: AssessmentQuestionType;
                  readonly responses: AssessmentQuestionResponses;
                  readonly labelDescriptions: ReadonlyArray<string | null>;
                  readonly comment: AssessmentQuestionComment;
                }
              | {
                  readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                  readonly description?: any | null;
                  readonly startValue: number;
                  readonly endValue: number;
                  readonly labels: ReadonlyArray<string | null>;
                  readonly questionType: AssessmentQuestionType;
                  readonly responses: AssessmentQuestionResponses;
                  readonly labelDescriptions: ReadonlyArray<string | null>;
                  readonly comment: AssessmentQuestionComment;
                }
              | {
                  readonly __typename: "IndividualGoalAssessmentQuestionNode";
                  readonly id: number;
                  readonly questionType: AssessmentQuestionType;
                }
              | {
                  readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                  readonly id: number;
                  readonly questionType: AssessmentQuestionType;
                }
              | {
                  readonly __typename: "MultiChoiceAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                  readonly description?: any | null;
                  readonly options: ReadonlyArray<string | null>;
                  readonly questionType: AssessmentQuestionType;
                  readonly responses: AssessmentQuestionResponses;
                  readonly comment: AssessmentQuestionComment;
                }
              | {
                  readonly __typename: "NpsAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                  readonly description?: any | null;
                  readonly questionType: AssessmentQuestionType;
                  readonly responses: AssessmentQuestionResponses;
                  readonly comment: AssessmentQuestionComment;
                }
              | {
                  readonly __typename: "OverallGoalAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                  readonly description?: any | null;
                  readonly startValue: number;
                  readonly endValue: number;
                  readonly labels: ReadonlyArray<string | null>;
                  readonly questionType: AssessmentQuestionType;
                  readonly responses: AssessmentQuestionResponses;
                  readonly labelDescriptions: ReadonlyArray<string | null>;
                  readonly comment: AssessmentQuestionComment;
                }
              | {
                  readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                  readonly description?: any | null;
                  readonly startValue: number;
                  readonly endValue: number;
                  readonly labels: ReadonlyArray<string | null>;
                  readonly questionType: AssessmentQuestionType;
                  readonly responses: AssessmentQuestionResponses;
                  readonly labelDescriptions: ReadonlyArray<string | null>;
                  readonly comment: AssessmentQuestionComment;
                }
              | {
                  readonly __typename: "RangeAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                  readonly description?: any | null;
                  readonly startValue: number;
                  readonly endValue: number;
                  readonly labels: ReadonlyArray<string | null>;
                  readonly questionType: AssessmentQuestionType;
                  readonly responses: AssessmentQuestionResponses;
                  readonly labelDescriptions: ReadonlyArray<string | null>;
                  readonly comment: AssessmentQuestionComment;
                }
              | {
                  readonly __typename: "ResponsibilityAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                  readonly description?: any | null;
                  readonly startValue: number;
                  readonly endValue: number;
                  readonly labels: ReadonlyArray<string | null>;
                  readonly questionType: AssessmentQuestionType;
                  readonly responses: AssessmentQuestionResponses;
                  readonly labelDescriptions: ReadonlyArray<string | null>;
                  readonly comment: AssessmentQuestionComment;
                }
              | {
                  readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                  readonly description?: any | null;
                  readonly startValue: number;
                  readonly endValue: number;
                  readonly labels: ReadonlyArray<string | null>;
                  readonly questionType: AssessmentQuestionType;
                  readonly responses: AssessmentQuestionResponses;
                  readonly labelDescriptions: ReadonlyArray<string | null>;
                  readonly comment: AssessmentQuestionComment;
                  readonly talentIndicator?: {
                    readonly __typename: "TalentIndicatorNode";
                    readonly id: number;
                    readonly name: string;
                    readonly customName?: string | null;
                    readonly talentIndicatorType: TalentIndicatorType;
                  } | null;
                }
              | {
                  readonly __typename: "TextAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                  readonly description?: any | null;
                  readonly questionType: AssessmentQuestionType;
                  readonly responses: AssessmentQuestionResponses;
                  readonly comment: AssessmentQuestionComment;
                };
            readonly rollups: {
              readonly __typename: "EngagementSurveyReportRollupConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "EngagementSurveyReportRollupEdge";
                readonly node?: {
                  readonly __typename: "EngagementSurveyReportRollupNode";
                  readonly rollupType: EngagementSurveyRollupType;
                  readonly location?: string | null;
                  readonly isManager?: boolean | null;
                  readonly value: number;
                  readonly team?: {
                    readonly __typename: "TeamNode";
                    readonly id: number;
                    readonly title: string;
                  } | null;
                  readonly manager?: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly name: string;
                    readonly firstName: string;
                    readonly avatar?: string | null;
                  } | null;
                  readonly careerTrack?: {
                    readonly __typename: "CareerTrackNode";
                    readonly id: number;
                    readonly title: string;
                  } | null;
                } | null;
              } | null>;
            };
          } | null;
        } | null>;
      };
      readonly npsQuestionRows: {
        readonly __typename: "EngagementSurveyReportRowConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "EngagementSurveyReportRowEdge";
          readonly node?: {
            readonly __typename: "EngagementSurveyReportRowNode";
            readonly title: string;
            readonly question:
              | {
                  readonly __typename: "CompetencyAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                  readonly description?: any | null;
                  readonly startValue: number;
                  readonly endValue: number;
                  readonly labels: ReadonlyArray<string | null>;
                  readonly questionType: AssessmentQuestionType;
                  readonly responses: AssessmentQuestionResponses;
                  readonly labelDescriptions: ReadonlyArray<string | null>;
                  readonly comment: AssessmentQuestionComment;
                }
              | {
                  readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                  readonly description?: any | null;
                  readonly startValue: number;
                  readonly endValue: number;
                  readonly labels: ReadonlyArray<string | null>;
                  readonly questionType: AssessmentQuestionType;
                  readonly responses: AssessmentQuestionResponses;
                  readonly labelDescriptions: ReadonlyArray<string | null>;
                  readonly comment: AssessmentQuestionComment;
                }
              | {
                  readonly __typename: "IndividualGoalAssessmentQuestionNode";
                  readonly id: number;
                  readonly questionType: AssessmentQuestionType;
                }
              | {
                  readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                  readonly id: number;
                  readonly questionType: AssessmentQuestionType;
                }
              | {
                  readonly __typename: "MultiChoiceAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                  readonly description?: any | null;
                  readonly options: ReadonlyArray<string | null>;
                  readonly questionType: AssessmentQuestionType;
                  readonly responses: AssessmentQuestionResponses;
                  readonly comment: AssessmentQuestionComment;
                }
              | {
                  readonly __typename: "NpsAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                  readonly description?: any | null;
                  readonly questionType: AssessmentQuestionType;
                  readonly responses: AssessmentQuestionResponses;
                  readonly comment: AssessmentQuestionComment;
                }
              | {
                  readonly __typename: "OverallGoalAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                  readonly description?: any | null;
                  readonly startValue: number;
                  readonly endValue: number;
                  readonly labels: ReadonlyArray<string | null>;
                  readonly questionType: AssessmentQuestionType;
                  readonly responses: AssessmentQuestionResponses;
                  readonly labelDescriptions: ReadonlyArray<string | null>;
                  readonly comment: AssessmentQuestionComment;
                }
              | {
                  readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                  readonly description?: any | null;
                  readonly startValue: number;
                  readonly endValue: number;
                  readonly labels: ReadonlyArray<string | null>;
                  readonly questionType: AssessmentQuestionType;
                  readonly responses: AssessmentQuestionResponses;
                  readonly labelDescriptions: ReadonlyArray<string | null>;
                  readonly comment: AssessmentQuestionComment;
                }
              | {
                  readonly __typename: "RangeAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                  readonly description?: any | null;
                  readonly startValue: number;
                  readonly endValue: number;
                  readonly labels: ReadonlyArray<string | null>;
                  readonly questionType: AssessmentQuestionType;
                  readonly responses: AssessmentQuestionResponses;
                  readonly labelDescriptions: ReadonlyArray<string | null>;
                  readonly comment: AssessmentQuestionComment;
                }
              | {
                  readonly __typename: "ResponsibilityAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                  readonly description?: any | null;
                  readonly startValue: number;
                  readonly endValue: number;
                  readonly labels: ReadonlyArray<string | null>;
                  readonly questionType: AssessmentQuestionType;
                  readonly responses: AssessmentQuestionResponses;
                  readonly labelDescriptions: ReadonlyArray<string | null>;
                  readonly comment: AssessmentQuestionComment;
                }
              | {
                  readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                  readonly description?: any | null;
                  readonly startValue: number;
                  readonly endValue: number;
                  readonly labels: ReadonlyArray<string | null>;
                  readonly questionType: AssessmentQuestionType;
                  readonly responses: AssessmentQuestionResponses;
                  readonly labelDescriptions: ReadonlyArray<string | null>;
                  readonly comment: AssessmentQuestionComment;
                  readonly talentIndicator?: {
                    readonly __typename: "TalentIndicatorNode";
                    readonly id: number;
                    readonly name: string;
                    readonly customName?: string | null;
                    readonly talentIndicatorType: TalentIndicatorType;
                  } | null;
                }
              | {
                  readonly __typename: "TextAssessmentQuestionNode";
                  readonly id: number;
                  readonly title: string;
                  readonly description?: any | null;
                  readonly questionType: AssessmentQuestionType;
                  readonly responses: AssessmentQuestionResponses;
                  readonly comment: AssessmentQuestionComment;
                };
            readonly rollups: {
              readonly __typename: "EngagementSurveyReportRollupConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "EngagementSurveyReportRollupEdge";
                readonly node?: {
                  readonly __typename: "EngagementSurveyReportRollupNode";
                  readonly rollupType: EngagementSurveyRollupType;
                  readonly location?: string | null;
                  readonly isManager?: boolean | null;
                  readonly value: number;
                  readonly team?: {
                    readonly __typename: "TeamNode";
                    readonly id: number;
                    readonly title: string;
                  } | null;
                  readonly manager?: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                    readonly name: string;
                    readonly firstName: string;
                    readonly avatar?: string | null;
                  } | null;
                  readonly careerTrack?: {
                    readonly __typename: "CareerTrackNode";
                    readonly id: number;
                    readonly title: string;
                  } | null;
                } | null;
              } | null>;
            };
          } | null;
        } | null>;
      };
    } | null;
  } | null;
};

export type ComplianceProgramPerformanceReportRowFragment = {
  readonly __typename: "PerformanceReviewReportRowNode";
  readonly id: number;
  readonly targetAddedToProgramOn?: string | null;
  readonly position?: string | null;
  readonly calibrationStatus: ComplianceProgramCalibrationStatus;
  readonly canSuggestAnswer: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canCalibrateAnswer: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly user: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
    readonly organizationSpecificInfo?: {
      readonly __typename: "UserMemberNode";
      readonly startDate?: string | null;
    } | null;
    readonly primaryManager?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
    } | null;
    readonly teamsList: ReadonlyArray<{
      readonly __typename: "TeamNode";
      readonly id: number;
      readonly title: string;
    }>;
  };
  readonly roles: ReadonlyArray<{
    readonly __typename: "CareerTrackRoleNode";
    readonly id: number;
    readonly title: string;
    readonly level: number;
    readonly careerTrack: {
      readonly __typename: "CareerTrackNode";
      readonly id: number;
      readonly title: string;
    };
  }>;
  readonly assessment?: {
    readonly __typename: "AssessmentNode";
    readonly id: number;
    readonly state: AssessmentState;
    readonly roleAssessmentAvg?: number | null;
    readonly selfRoleAssessmentAvg?: number | null;
    readonly assessmentDeliveryState?: AssessmentDeliveryState | null;
    readonly responder?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly firstName: string;
      readonly avatar?: string | null;
    } | null;
    readonly target?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly avatar?: string | null;
      readonly organizationSpecificInfo?: {
        readonly __typename: "UserMemberNode";
        readonly startDate?: string | null;
      } | null;
      readonly primaryManager?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
      } | null;
      readonly teamsList: ReadonlyArray<{
        readonly __typename: "TeamNode";
        readonly id: number;
        readonly title: string;
      }>;
    } | null;
    readonly answers: ReadonlyArray<
      | {
          readonly __typename: "CompetencyAssessmentAnswerNode";
          readonly id: number;
          readonly questionId: number;
          readonly integerAnswer?: number | null;
          readonly comment?: any | null;
          readonly roleId: number;
          readonly hasCalibrations: boolean;
          readonly hasCalibrationSuggestions: boolean;
        }
      | {
          readonly __typename: "CompetencyCriteriaAssessmentAnswerNode";
          readonly id: number;
          readonly questionId: number;
          readonly integerAnswer?: number | null;
          readonly comment?: any | null;
          readonly roleId: number;
          readonly hasCalibrations: boolean;
          readonly hasCalibrationSuggestions: boolean;
        }
      | {
          readonly __typename: "IndividualGoalAssessmentAnswerNode";
          readonly id: number;
          readonly questionId: number;
          readonly integerAnswer?: number | null;
          readonly comment?: any | null;
          readonly hasCalibrations: boolean;
          readonly hasCalibrationSuggestions: boolean;
        }
      | {
          readonly __typename: "IndividualRecognitionCoreValueAssessmentAnswerNode";
          readonly id: number;
          readonly questionId: number;
          readonly integerAnswer?: number | null;
          readonly comment?: any | null;
          readonly hasCalibrations: boolean;
          readonly hasCalibrationSuggestions: boolean;
        }
      | {
          readonly __typename: "MultiChoiceAssessmentAnswerNode";
          readonly id: number;
          readonly questionId: number;
          readonly choices: ReadonlyArray<number | null>;
          readonly comment?: any | null;
          readonly hasCalibrations: boolean;
          readonly hasCalibrationSuggestions: boolean;
        }
      | {
          readonly __typename: "NpsAssessmentAnswerNode";
          readonly id: number;
          readonly questionId: number;
          readonly integerAnswer?: number | null;
          readonly comment?: any | null;
          readonly hasCalibrations: boolean;
          readonly hasCalibrationSuggestions: boolean;
        }
      | {
          readonly __typename: "OverallGoalAssessmentAnswerNode";
          readonly id: number;
          readonly questionId: number;
          readonly integerAnswer?: number | null;
          readonly comment?: any | null;
          readonly hasCalibrations: boolean;
          readonly hasCalibrationSuggestions: boolean;
        }
      | {
          readonly __typename: "OverallRecognitionCoreValueAssessmentAnswerNode";
          readonly id: number;
          readonly questionId: number;
          readonly integerAnswer?: number | null;
          readonly comment?: any | null;
          readonly hasCalibrations: boolean;
          readonly hasCalibrationSuggestions: boolean;
        }
      | {
          readonly __typename: "RangeAssessmentAnswerNode";
          readonly id: number;
          readonly questionId: number;
          readonly integerAnswer?: number | null;
          readonly comment?: any | null;
          readonly hasCalibrations: boolean;
          readonly hasCalibrationSuggestions: boolean;
        }
      | {
          readonly __typename: "ResponsibilityAssessmentAnswerNode";
          readonly id: number;
          readonly questionId: number;
          readonly integerAnswer?: number | null;
          readonly comment?: any | null;
          readonly roleId: number;
          readonly hasCalibrations: boolean;
          readonly hasCalibrationSuggestions: boolean;
        }
      | {
          readonly __typename: "TalentIndicatorAssessmentAnswerNode";
          readonly id: number;
          readonly questionId: number;
          readonly integerAnswer?: number | null;
          readonly comment?: any | null;
          readonly hasCalibrations: boolean;
          readonly hasCalibrationSuggestions: boolean;
        }
      | {
          readonly __typename: "TextAssessmentAnswerNode";
          readonly id: number;
          readonly questionId: number;
          readonly textAnswer?: any | null;
          readonly comment?: any | null;
          readonly hasCalibrations: boolean;
          readonly hasCalibrationSuggestions: boolean;
        }
      | null
    >;
    readonly assessmentDelivery?: {
      readonly __typename: "AssessmentDeliveryNode";
      readonly id: number;
      readonly state: AssessmentDeliveryState;
      readonly deliveryDatetime?: string | null;
      readonly canUpdate?: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
      } | null;
      readonly canRead?: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
      } | null;
    } | null;
    readonly template: {
      readonly __typename: "AssessmentTemplateNode";
      readonly id: number;
      readonly organization: {
        readonly __typename: "OrganizationNode";
        readonly id: number;
      };
    };
  } | null;
};

export type ComplianceProgramManagerEffectivenessReportRowFragment = {
  readonly __typename: "ManagerEffectivenessReportRowNode";
  readonly manager: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
    readonly directReports: {
      readonly __typename: "UserNodeConnection";
      readonly totalCount: number;
    };
    readonly organizationSpecificInfo?: {
      readonly __typename: "UserMemberNode";
      readonly startDate?: string | null;
    } | null;
    readonly primaryManager?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
    } | null;
    readonly teamsList: ReadonlyArray<{
      readonly __typename: "TeamNode";
      readonly id: number;
      readonly title: string;
    }>;
  };
  readonly assessments: {
    readonly __typename: "AssessmentNodeConnection";
    readonly totalCount: number;
  };
  readonly assessmentDelivery?: {
    readonly __typename: "AssessmentDeliveryNode";
    readonly id: number;
  } | null;
  readonly questions: {
    readonly __typename: "ManagerEffectivenessReportQuestionConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "ManagerEffectivenessReportQuestionEdge";
      readonly node?: {
        readonly __typename: "ManagerEffectivenessReportQuestionNode";
        readonly avgAnswer?: number | null;
        readonly question:
          | {
              readonly __typename: "CompetencyAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "IndividualGoalAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "MultiChoiceAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "NpsAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "OverallGoalAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "RangeAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "ResponsibilityAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "TextAssessmentQuestionNode";
              readonly id: number;
            };
      } | null;
    } | null>;
  };
};

export type GetComplianceProgramForReportQueryVariables = Exact<{
  complianceProgramId: Scalars["Int"]["input"];
  isUpwardAssessmentReport: Scalars["Boolean"]["input"];
  isPerformanceAssessmentReport: Scalars["Boolean"]["input"];
}>;

export type GetComplianceProgramForReportQuery = {
  readonly __typename: "Query";
  readonly complianceProgram?: {
    readonly __typename: "ComplianceProgramNode";
    readonly id: number;
    readonly title: string;
    readonly periodStartDate?: string | null;
    readonly periodEndDate?: string | null;
    readonly hasAccessToAppliesToUsers: boolean;
    readonly ongoing: boolean;
    readonly calibration: ComplianceProgramCalibrationType;
    readonly canReadDetails: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    };
    readonly performanceAssessmentTemplate?: {
      readonly __typename: "AssessmentTemplateNode";
      readonly id: number;
      readonly assessmentType: AssessmentType;
      readonly isOnlySelfAssessment: boolean;
      readonly delivery: AssessmentGroupDelivery;
      readonly enableGoalAssessments: boolean;
      readonly goalAssessmentScale: number;
      readonly goalAssessmentScaleLabels: ReadonlyArray<string | null>;
      readonly goalAssessmentScaleStartsAt: number;
      readonly enableCoreValueAssessments: boolean;
      readonly coreValueAssessmentScale: number;
      readonly coreValueAssessmentScaleLabels: ReadonlyArray<string | null>;
      readonly coreValueAssessmentScaleStartsAt: number;
      readonly enableRoleBasedAssessments: boolean;
      readonly roleBasedAssessmentScale: number;
      readonly roleBasedAssessmentScaleLabels: ReadonlyArray<string | null>;
      readonly roleBasedAssessmentScaleStartsAt: number;
      readonly questionSets: {
        readonly __typename: "AssessmentGroupNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentGroupNodeEdge";
          readonly node?: {
            readonly __typename: "AssessmentGroupNode";
            readonly id: number;
            readonly title: string;
            readonly sections: {
              readonly __typename: "AssessmentGroupSectionNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "AssessmentGroupSectionNodeEdge";
                readonly node?: {
                  readonly __typename: "AssessmentGroupSectionNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly description?: any | null;
                  readonly questions: {
                    readonly __typename: "AssessmentGroupQuestionContainerConnection";
                    readonly edges: ReadonlyArray<{
                      readonly __typename: "AssessmentGroupQuestionContainerEdge";
                      readonly node?: {
                        readonly __typename: "AssessmentGroupQuestionContainer";
                        readonly id: number;
                        readonly question:
                          | {
                              readonly __typename: "CompetencyAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly questionType: AssessmentQuestionType;
                              readonly responses: AssessmentQuestionResponses;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                            }
                          | {
                              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly questionType: AssessmentQuestionType;
                              readonly responses: AssessmentQuestionResponses;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                            }
                          | {
                              readonly __typename: "IndividualGoalAssessmentQuestionNode";
                              readonly id: number;
                              readonly questionType: AssessmentQuestionType;
                            }
                          | {
                              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                              readonly id: number;
                              readonly questionType: AssessmentQuestionType;
                            }
                          | {
                              readonly __typename: "MultiChoiceAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly options: ReadonlyArray<string | null>;
                              readonly questionType: AssessmentQuestionType;
                              readonly responses: AssessmentQuestionResponses;
                              readonly comment: AssessmentQuestionComment;
                            }
                          | {
                              readonly __typename: "NpsAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly questionType: AssessmentQuestionType;
                              readonly responses: AssessmentQuestionResponses;
                              readonly comment: AssessmentQuestionComment;
                            }
                          | {
                              readonly __typename: "OverallGoalAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly questionType: AssessmentQuestionType;
                              readonly responses: AssessmentQuestionResponses;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                            }
                          | {
                              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly questionType: AssessmentQuestionType;
                              readonly responses: AssessmentQuestionResponses;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                            }
                          | {
                              readonly __typename: "RangeAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly questionType: AssessmentQuestionType;
                              readonly responses: AssessmentQuestionResponses;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                            }
                          | {
                              readonly __typename: "ResponsibilityAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly questionType: AssessmentQuestionType;
                              readonly responses: AssessmentQuestionResponses;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                            }
                          | {
                              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly questionType: AssessmentQuestionType;
                              readonly responses: AssessmentQuestionResponses;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly talentIndicator?: {
                                readonly __typename: "TalentIndicatorNode";
                                readonly id: number;
                                readonly name: string;
                                readonly customName?: string | null;
                                readonly talentIndicatorType: TalentIndicatorType;
                              } | null;
                            }
                          | {
                              readonly __typename: "TextAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly questionType: AssessmentQuestionType;
                              readonly responses: AssessmentQuestionResponses;
                              readonly comment: AssessmentQuestionComment;
                            };
                      } | null;
                    } | null>;
                  };
                } | null;
              } | null>;
            };
          } | null;
        } | null>;
      };
      readonly additionalQuestions: ReadonlyArray<
        | {
            readonly __typename: "CompetencyAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "IndividualGoalAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "MultiChoiceAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "NpsAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "OverallGoalAssessmentQuestionNode";
            readonly id: number;
            readonly title: string;
            readonly description?: any | null;
            readonly startValue: number;
            readonly endValue: number;
            readonly labels: ReadonlyArray<string | null>;
            readonly questionType: AssessmentQuestionType;
            readonly responses: AssessmentQuestionResponses;
            readonly labelDescriptions: ReadonlyArray<string | null>;
            readonly comment: AssessmentQuestionComment;
          }
        | {
            readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
            readonly id: number;
            readonly title: string;
            readonly description?: any | null;
            readonly startValue: number;
            readonly endValue: number;
            readonly labels: ReadonlyArray<string | null>;
            readonly questionType: AssessmentQuestionType;
            readonly responses: AssessmentQuestionResponses;
            readonly labelDescriptions: ReadonlyArray<string | null>;
            readonly comment: AssessmentQuestionComment;
          }
        | {
            readonly __typename: "RangeAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "ResponsibilityAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "TalentIndicatorAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "TextAssessmentQuestionNode";
            readonly id: number;
          }
        | null
      >;
    } | null;
    readonly managerAssessmentTemplate?: {
      readonly __typename: "AssessmentTemplateNode";
      readonly id: number;
      readonly assessmentType: AssessmentType;
      readonly isOnlySelfAssessment: boolean;
      readonly delivery: AssessmentGroupDelivery;
      readonly enableGoalAssessments: boolean;
      readonly goalAssessmentScale: number;
      readonly goalAssessmentScaleLabels: ReadonlyArray<string | null>;
      readonly goalAssessmentScaleStartsAt: number;
      readonly enableCoreValueAssessments: boolean;
      readonly coreValueAssessmentScale: number;
      readonly coreValueAssessmentScaleLabels: ReadonlyArray<string | null>;
      readonly coreValueAssessmentScaleStartsAt: number;
      readonly enableRoleBasedAssessments: boolean;
      readonly roleBasedAssessmentScale: number;
      readonly roleBasedAssessmentScaleLabels: ReadonlyArray<string | null>;
      readonly roleBasedAssessmentScaleStartsAt: number;
      readonly questionSets: {
        readonly __typename: "AssessmentGroupNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentGroupNodeEdge";
          readonly node?: {
            readonly __typename: "AssessmentGroupNode";
            readonly id: number;
            readonly title: string;
            readonly sections: {
              readonly __typename: "AssessmentGroupSectionNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "AssessmentGroupSectionNodeEdge";
                readonly node?: {
                  readonly __typename: "AssessmentGroupSectionNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly description?: any | null;
                  readonly questions: {
                    readonly __typename: "AssessmentGroupQuestionContainerConnection";
                    readonly edges: ReadonlyArray<{
                      readonly __typename: "AssessmentGroupQuestionContainerEdge";
                      readonly node?: {
                        readonly __typename: "AssessmentGroupQuestionContainer";
                        readonly id: number;
                        readonly question:
                          | {
                              readonly __typename: "CompetencyAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly questionType: AssessmentQuestionType;
                              readonly responses: AssessmentQuestionResponses;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                            }
                          | {
                              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly questionType: AssessmentQuestionType;
                              readonly responses: AssessmentQuestionResponses;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                            }
                          | {
                              readonly __typename: "IndividualGoalAssessmentQuestionNode";
                              readonly id: number;
                              readonly questionType: AssessmentQuestionType;
                            }
                          | {
                              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                              readonly id: number;
                              readonly questionType: AssessmentQuestionType;
                            }
                          | {
                              readonly __typename: "MultiChoiceAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly options: ReadonlyArray<string | null>;
                              readonly questionType: AssessmentQuestionType;
                              readonly responses: AssessmentQuestionResponses;
                              readonly comment: AssessmentQuestionComment;
                            }
                          | {
                              readonly __typename: "NpsAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly questionType: AssessmentQuestionType;
                              readonly responses: AssessmentQuestionResponses;
                              readonly comment: AssessmentQuestionComment;
                            }
                          | {
                              readonly __typename: "OverallGoalAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly questionType: AssessmentQuestionType;
                              readonly responses: AssessmentQuestionResponses;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                            }
                          | {
                              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly questionType: AssessmentQuestionType;
                              readonly responses: AssessmentQuestionResponses;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                            }
                          | {
                              readonly __typename: "RangeAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly questionType: AssessmentQuestionType;
                              readonly responses: AssessmentQuestionResponses;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                            }
                          | {
                              readonly __typename: "ResponsibilityAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly questionType: AssessmentQuestionType;
                              readonly responses: AssessmentQuestionResponses;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                            }
                          | {
                              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly startValue: number;
                              readonly endValue: number;
                              readonly labels: ReadonlyArray<string | null>;
                              readonly questionType: AssessmentQuestionType;
                              readonly responses: AssessmentQuestionResponses;
                              readonly labelDescriptions: ReadonlyArray<
                                string | null
                              >;
                              readonly comment: AssessmentQuestionComment;
                              readonly talentIndicator?: {
                                readonly __typename: "TalentIndicatorNode";
                                readonly id: number;
                                readonly name: string;
                                readonly customName?: string | null;
                                readonly talentIndicatorType: TalentIndicatorType;
                              } | null;
                            }
                          | {
                              readonly __typename: "TextAssessmentQuestionNode";
                              readonly id: number;
                              readonly title: string;
                              readonly description?: any | null;
                              readonly questionType: AssessmentQuestionType;
                              readonly responses: AssessmentQuestionResponses;
                              readonly comment: AssessmentQuestionComment;
                            };
                      } | null;
                    } | null>;
                  };
                } | null;
              } | null>;
            };
          } | null;
        } | null>;
      };
      readonly additionalQuestions: ReadonlyArray<
        | {
            readonly __typename: "CompetencyAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "IndividualGoalAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "MultiChoiceAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "NpsAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "OverallGoalAssessmentQuestionNode";
            readonly id: number;
            readonly title: string;
            readonly description?: any | null;
            readonly startValue: number;
            readonly endValue: number;
            readonly labels: ReadonlyArray<string | null>;
            readonly questionType: AssessmentQuestionType;
            readonly responses: AssessmentQuestionResponses;
            readonly labelDescriptions: ReadonlyArray<string | null>;
            readonly comment: AssessmentQuestionComment;
          }
        | {
            readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
            readonly id: number;
            readonly title: string;
            readonly description?: any | null;
            readonly startValue: number;
            readonly endValue: number;
            readonly labels: ReadonlyArray<string | null>;
            readonly questionType: AssessmentQuestionType;
            readonly responses: AssessmentQuestionResponses;
            readonly labelDescriptions: ReadonlyArray<string | null>;
            readonly comment: AssessmentQuestionComment;
          }
        | {
            readonly __typename: "RangeAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "ResponsibilityAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "TalentIndicatorAssessmentQuestionNode";
            readonly id: number;
          }
        | {
            readonly __typename: "TextAssessmentQuestionNode";
            readonly id: number;
          }
        | null
      >;
    } | null;
    readonly performanceReportRows?: {
      readonly __typename: "PerformanceReviewReportRowConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "PerformanceReviewReportRowEdge";
        readonly node?: {
          readonly __typename: "PerformanceReviewReportRowNode";
          readonly id: number;
          readonly targetAddedToProgramOn?: string | null;
          readonly position?: string | null;
          readonly calibrationStatus: ComplianceProgramCalibrationStatus;
          readonly canSuggestAnswer: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canCalibrateAnswer: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly user: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
            readonly organizationSpecificInfo?: {
              readonly __typename: "UserMemberNode";
              readonly startDate?: string | null;
            } | null;
            readonly primaryManager?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
            } | null;
            readonly teamsList: ReadonlyArray<{
              readonly __typename: "TeamNode";
              readonly id: number;
              readonly title: string;
            }>;
          };
          readonly roles: ReadonlyArray<{
            readonly __typename: "CareerTrackRoleNode";
            readonly id: number;
            readonly title: string;
            readonly level: number;
            readonly careerTrack: {
              readonly __typename: "CareerTrackNode";
              readonly id: number;
              readonly title: string;
            };
          }>;
          readonly assessment?: {
            readonly __typename: "AssessmentNode";
            readonly id: number;
            readonly state: AssessmentState;
            readonly roleAssessmentAvg?: number | null;
            readonly selfRoleAssessmentAvg?: number | null;
            readonly assessmentDeliveryState?: AssessmentDeliveryState | null;
            readonly responder?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly firstName: string;
              readonly avatar?: string | null;
            } | null;
            readonly target?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
              readonly organizationSpecificInfo?: {
                readonly __typename: "UserMemberNode";
                readonly startDate?: string | null;
              } | null;
              readonly primaryManager?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
              } | null;
              readonly teamsList: ReadonlyArray<{
                readonly __typename: "TeamNode";
                readonly id: number;
                readonly title: string;
              }>;
            } | null;
            readonly answers: ReadonlyArray<
              | {
                  readonly __typename: "CompetencyAssessmentAnswerNode";
                  readonly id: number;
                  readonly questionId: number;
                  readonly integerAnswer?: number | null;
                  readonly comment?: any | null;
                  readonly roleId: number;
                  readonly hasCalibrations: boolean;
                  readonly hasCalibrationSuggestions: boolean;
                }
              | {
                  readonly __typename: "CompetencyCriteriaAssessmentAnswerNode";
                  readonly id: number;
                  readonly questionId: number;
                  readonly integerAnswer?: number | null;
                  readonly comment?: any | null;
                  readonly roleId: number;
                  readonly hasCalibrations: boolean;
                  readonly hasCalibrationSuggestions: boolean;
                }
              | {
                  readonly __typename: "IndividualGoalAssessmentAnswerNode";
                  readonly id: number;
                  readonly questionId: number;
                  readonly integerAnswer?: number | null;
                  readonly comment?: any | null;
                  readonly hasCalibrations: boolean;
                  readonly hasCalibrationSuggestions: boolean;
                }
              | {
                  readonly __typename: "IndividualRecognitionCoreValueAssessmentAnswerNode";
                  readonly id: number;
                  readonly questionId: number;
                  readonly integerAnswer?: number | null;
                  readonly comment?: any | null;
                  readonly hasCalibrations: boolean;
                  readonly hasCalibrationSuggestions: boolean;
                }
              | {
                  readonly __typename: "MultiChoiceAssessmentAnswerNode";
                  readonly id: number;
                  readonly questionId: number;
                  readonly choices: ReadonlyArray<number | null>;
                  readonly comment?: any | null;
                  readonly hasCalibrations: boolean;
                  readonly hasCalibrationSuggestions: boolean;
                }
              | {
                  readonly __typename: "NpsAssessmentAnswerNode";
                  readonly id: number;
                  readonly questionId: number;
                  readonly integerAnswer?: number | null;
                  readonly comment?: any | null;
                  readonly hasCalibrations: boolean;
                  readonly hasCalibrationSuggestions: boolean;
                }
              | {
                  readonly __typename: "OverallGoalAssessmentAnswerNode";
                  readonly id: number;
                  readonly questionId: number;
                  readonly integerAnswer?: number | null;
                  readonly comment?: any | null;
                  readonly hasCalibrations: boolean;
                  readonly hasCalibrationSuggestions: boolean;
                }
              | {
                  readonly __typename: "OverallRecognitionCoreValueAssessmentAnswerNode";
                  readonly id: number;
                  readonly questionId: number;
                  readonly integerAnswer?: number | null;
                  readonly comment?: any | null;
                  readonly hasCalibrations: boolean;
                  readonly hasCalibrationSuggestions: boolean;
                }
              | {
                  readonly __typename: "RangeAssessmentAnswerNode";
                  readonly id: number;
                  readonly questionId: number;
                  readonly integerAnswer?: number | null;
                  readonly comment?: any | null;
                  readonly hasCalibrations: boolean;
                  readonly hasCalibrationSuggestions: boolean;
                }
              | {
                  readonly __typename: "ResponsibilityAssessmentAnswerNode";
                  readonly id: number;
                  readonly questionId: number;
                  readonly integerAnswer?: number | null;
                  readonly comment?: any | null;
                  readonly roleId: number;
                  readonly hasCalibrations: boolean;
                  readonly hasCalibrationSuggestions: boolean;
                }
              | {
                  readonly __typename: "TalentIndicatorAssessmentAnswerNode";
                  readonly id: number;
                  readonly questionId: number;
                  readonly integerAnswer?: number | null;
                  readonly comment?: any | null;
                  readonly hasCalibrations: boolean;
                  readonly hasCalibrationSuggestions: boolean;
                }
              | {
                  readonly __typename: "TextAssessmentAnswerNode";
                  readonly id: number;
                  readonly questionId: number;
                  readonly textAnswer?: any | null;
                  readonly comment?: any | null;
                  readonly hasCalibrations: boolean;
                  readonly hasCalibrationSuggestions: boolean;
                }
              | null
            >;
            readonly assessmentDelivery?: {
              readonly __typename: "AssessmentDeliveryNode";
              readonly id: number;
              readonly state: AssessmentDeliveryState;
              readonly deliveryDatetime?: string | null;
              readonly canUpdate?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              } | null;
              readonly canRead?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              } | null;
            } | null;
            readonly template: {
              readonly __typename: "AssessmentTemplateNode";
              readonly id: number;
              readonly organization: {
                readonly __typename: "OrganizationNode";
                readonly id: number;
              };
            };
          } | null;
        } | null;
      } | null>;
    };
    readonly managerEffectivenessReport?: {
      readonly __typename: "ManagerEffectivenessReportConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "ManagerEffectivenessReportEdge";
        readonly node?: {
          readonly __typename: "ManagerEffectivenessReportRowNode";
          readonly manager: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
            readonly directReports: {
              readonly __typename: "UserNodeConnection";
              readonly totalCount: number;
            };
            readonly organizationSpecificInfo?: {
              readonly __typename: "UserMemberNode";
              readonly startDate?: string | null;
            } | null;
            readonly primaryManager?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
            } | null;
            readonly teamsList: ReadonlyArray<{
              readonly __typename: "TeamNode";
              readonly id: number;
              readonly title: string;
            }>;
          };
          readonly assessments: {
            readonly __typename: "AssessmentNodeConnection";
            readonly totalCount: number;
          };
          readonly assessmentDelivery?: {
            readonly __typename: "AssessmentDeliveryNode";
            readonly id: number;
          } | null;
          readonly questions: {
            readonly __typename: "ManagerEffectivenessReportQuestionConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "ManagerEffectivenessReportQuestionEdge";
              readonly node?: {
                readonly __typename: "ManagerEffectivenessReportQuestionNode";
                readonly avgAnswer?: number | null;
                readonly question:
                  | {
                      readonly __typename: "CompetencyAssessmentQuestionNode";
                      readonly id: number;
                    }
                  | {
                      readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                      readonly id: number;
                    }
                  | {
                      readonly __typename: "IndividualGoalAssessmentQuestionNode";
                      readonly id: number;
                    }
                  | {
                      readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                      readonly id: number;
                    }
                  | {
                      readonly __typename: "MultiChoiceAssessmentQuestionNode";
                      readonly id: number;
                    }
                  | {
                      readonly __typename: "NpsAssessmentQuestionNode";
                      readonly id: number;
                    }
                  | {
                      readonly __typename: "OverallGoalAssessmentQuestionNode";
                      readonly id: number;
                    }
                  | {
                      readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                      readonly id: number;
                    }
                  | {
                      readonly __typename: "RangeAssessmentQuestionNode";
                      readonly id: number;
                    }
                  | {
                      readonly __typename: "ResponsibilityAssessmentQuestionNode";
                      readonly id: number;
                    }
                  | {
                      readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                      readonly id: number;
                    }
                  | {
                      readonly __typename: "TextAssessmentQuestionNode";
                      readonly id: number;
                    };
              } | null;
            } | null>;
          };
        } | null;
      } | null>;
    };
  } | null;
};

export type GetComplianceProgramReportingViewsQueryVariables = Exact<{
  complianceProgramId: Scalars["Int"]["input"];
  assessmentType: AssessmentType;
}>;

export type GetComplianceProgramReportingViewsQuery = {
  readonly __typename: "Query";
  readonly complianceProgramReportingViews: {
    readonly __typename: "ComplianceProgramReportingViewNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "ComplianceProgramReportingViewNodeEdge";
      readonly node?: {
        readonly __typename: "ComplianceProgramReportingViewNode";
        readonly id: number;
        readonly name?: string | null;
        readonly viewOptions: any;
      } | null;
    } | null>;
  };
};

export type GetManagersOfUsersQueryVariables = Exact<{
  userIds: ReadonlyArray<Scalars["Int"]["input"]> | Scalars["Int"]["input"];
}>;

export type GetManagersOfUsersQuery = {
  readonly __typename: "Query";
  readonly users: {
    readonly __typename: "UserNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "UserNodeEdge";
      readonly node?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly managersList: ReadonlyArray<{
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        }>;
      } | null;
    } | null>;
  };
};

export type GetPerformanceAssessmentChartLabelsQueryVariables = Exact<{
  questionIds:
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetPerformanceAssessmentChartLabelsQuery = {
  readonly __typename: "Query";
  readonly performanceAssessmentChartLabels: {
    readonly __typename: "PerformanceAssessmentChartLabelNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "PerformanceAssessmentChartLabelNodeEdge";
      readonly node?: {
        readonly __typename: "PerformanceAssessmentChartLabelNode";
        readonly id: number;
        readonly label: string;
        readonly questionOneIntegerAnswer: number;
        readonly questionTwoIntegerAnswer?: number | null;
        readonly questionOne:
          | {
              readonly __typename: "CompetencyAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "IndividualGoalAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "MultiChoiceAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "NpsAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "OverallGoalAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "RangeAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "ResponsibilityAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "TextAssessmentQuestionNode";
              readonly id: number;
            };
        readonly questionTwo?:
          | {
              readonly __typename: "CompetencyAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "IndividualGoalAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "MultiChoiceAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "NpsAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "OverallGoalAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "RangeAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "ResponsibilityAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "TalentIndicatorAssessmentQuestionNode";
              readonly id: number;
            }
          | {
              readonly __typename: "TextAssessmentQuestionNode";
              readonly id: number;
            }
          | null;
      } | null;
    } | null>;
  };
};

export type GetTalentIndicatorTrendsQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
  talentIndicatorId: Scalars["Int"]["input"];
  teamIds?: InputMaybe<
    ReadonlyArray<Scalars["Int"]["input"]> | Scalars["Int"]["input"]
  >;
  managerIds?: InputMaybe<
    ReadonlyArray<Scalars["Int"]["input"]> | Scalars["Int"]["input"]
  >;
  reportType: TrendReportType;
  groupBy?: InputMaybe<TrendReportGroupBy>;
  startDate?: InputMaybe<Scalars["Date"]["input"]>;
  endDate?: InputMaybe<Scalars["Date"]["input"]>;
}>;

export type GetTalentIndicatorTrendsQuery = {
  readonly __typename: "Query";
  readonly trendReport: ReadonlyArray<{
    readonly __typename: "ReportingChartNode";
    readonly name: string;
    readonly data: ReadonlyArray<{
      readonly __typename: "ReportingChartDataNode";
      readonly key: string;
      readonly value: number;
      readonly count: number;
    } | null>;
  } | null>;
};

export type GetUserAssessmentDeliveriesQueryVariables = Exact<{
  targetId: Scalars["Int"]["input"];
  excludedProgramIds?: InputMaybe<
    ReadonlyArray<Scalars["Int"]["input"]> | Scalars["Int"]["input"]
  >;
}>;

export type GetUserAssessmentDeliveriesQuery = {
  readonly __typename: "Query";
  readonly assessmentDeliveries: {
    readonly __typename: "AssessmentDeliveryNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "AssessmentDeliveryNodeEdge";
      readonly node?: {
        readonly __typename: "AssessmentDeliveryNode";
        readonly id: number;
        readonly complianceProgram?: {
          readonly __typename: "ComplianceProgramNode";
          readonly id: number;
          readonly title: string;
          readonly startDate?: string | null;
          readonly dueDate?: string | null;
        } | null;
      } | null;
    } | null>;
  };
};

type PerformanceAssessmentChartLabelQuestion_CompetencyAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "CompetencyAssessmentQuestionNode";
    readonly id: number;
  };

type PerformanceAssessmentChartLabelQuestion_CompetencyCriteriaAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
    readonly id: number;
  };

type PerformanceAssessmentChartLabelQuestion_IndividualGoalAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "IndividualGoalAssessmentQuestionNode";
    readonly id: number;
  };

type PerformanceAssessmentChartLabelQuestion_IndividualRecognitionCoreValueAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
    readonly id: number;
  };

type PerformanceAssessmentChartLabelQuestion_MultiChoiceAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "MultiChoiceAssessmentQuestionNode";
    readonly id: number;
  };

type PerformanceAssessmentChartLabelQuestion_NpsAssessmentQuestionNode_Fragment =
  { readonly __typename: "NpsAssessmentQuestionNode"; readonly id: number };

type PerformanceAssessmentChartLabelQuestion_OverallGoalAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "OverallGoalAssessmentQuestionNode";
    readonly id: number;
  };

type PerformanceAssessmentChartLabelQuestion_OverallRecognitionCoreValueAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
    readonly id: number;
  };

type PerformanceAssessmentChartLabelQuestion_RangeAssessmentQuestionNode_Fragment =
  { readonly __typename: "RangeAssessmentQuestionNode"; readonly id: number };

type PerformanceAssessmentChartLabelQuestion_ResponsibilityAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "ResponsibilityAssessmentQuestionNode";
    readonly id: number;
  };

type PerformanceAssessmentChartLabelQuestion_TalentIndicatorAssessmentQuestionNode_Fragment =
  {
    readonly __typename: "TalentIndicatorAssessmentQuestionNode";
    readonly id: number;
  };

type PerformanceAssessmentChartLabelQuestion_TextAssessmentQuestionNode_Fragment =
  { readonly __typename: "TextAssessmentQuestionNode"; readonly id: number };

export type PerformanceAssessmentChartLabelQuestionFragment =
  | PerformanceAssessmentChartLabelQuestion_CompetencyAssessmentQuestionNode_Fragment
  | PerformanceAssessmentChartLabelQuestion_CompetencyCriteriaAssessmentQuestionNode_Fragment
  | PerformanceAssessmentChartLabelQuestion_IndividualGoalAssessmentQuestionNode_Fragment
  | PerformanceAssessmentChartLabelQuestion_IndividualRecognitionCoreValueAssessmentQuestionNode_Fragment
  | PerformanceAssessmentChartLabelQuestion_MultiChoiceAssessmentQuestionNode_Fragment
  | PerformanceAssessmentChartLabelQuestion_NpsAssessmentQuestionNode_Fragment
  | PerformanceAssessmentChartLabelQuestion_OverallGoalAssessmentQuestionNode_Fragment
  | PerformanceAssessmentChartLabelQuestion_OverallRecognitionCoreValueAssessmentQuestionNode_Fragment
  | PerformanceAssessmentChartLabelQuestion_RangeAssessmentQuestionNode_Fragment
  | PerformanceAssessmentChartLabelQuestion_ResponsibilityAssessmentQuestionNode_Fragment
  | PerformanceAssessmentChartLabelQuestion_TalentIndicatorAssessmentQuestionNode_Fragment
  | PerformanceAssessmentChartLabelQuestion_TextAssessmentQuestionNode_Fragment;

export type UpdateAssessmentAnswerMutationVariables = Exact<{
  complianceProgramId: Scalars["Int"]["input"];
  templateId: Scalars["Int"]["input"];
  questionId: Scalars["Int"]["input"];
  targetId: Scalars["Int"]["input"];
  answerId?: InputMaybe<Scalars["Int"]["input"]>;
  integerAnswer?: InputMaybe<Scalars["Int"]["input"]>;
  comment: Scalars["String"]["input"];
  isSuggestion: Scalars["Boolean"]["input"];
  isPrecalibration: Scalars["Boolean"]["input"];
}>;

export type UpdateAssessmentAnswerMutation = {
  readonly __typename: "Mutation";
  readonly createAssessmentAnswerCalibration: {
    readonly __typename: "CreateAssessmentAnswerCalibration";
    readonly answer?:
      | {
          readonly __typename: "CompetencyAssessmentAnswerNode";
          readonly id: number;
        }
      | {
          readonly __typename: "CompetencyCriteriaAssessmentAnswerNode";
          readonly id: number;
        }
      | {
          readonly __typename: "IndividualGoalAssessmentAnswerNode";
          readonly id: number;
        }
      | {
          readonly __typename: "IndividualRecognitionCoreValueAssessmentAnswerNode";
          readonly id: number;
        }
      | {
          readonly __typename: "MultiChoiceAssessmentAnswerNode";
          readonly id: number;
        }
      | { readonly __typename: "NpsAssessmentAnswerNode"; readonly id: number }
      | {
          readonly __typename: "OverallGoalAssessmentAnswerNode";
          readonly id: number;
        }
      | {
          readonly __typename: "OverallRecognitionCoreValueAssessmentAnswerNode";
          readonly id: number;
        }
      | {
          readonly __typename: "RangeAssessmentAnswerNode";
          readonly hasCalibrations: boolean;
          readonly hasCalibrationSuggestions: boolean;
          readonly comment?: any | null;
          readonly integerAnswer?: number | null;
          readonly id: number;
        }
      | {
          readonly __typename: "ResponsibilityAssessmentAnswerNode";
          readonly id: number;
        }
      | {
          readonly __typename: "TalentIndicatorAssessmentAnswerNode";
          readonly hasCalibrations: boolean;
          readonly hasCalibrationSuggestions: boolean;
          readonly comment?: any | null;
          readonly integerAnswer?: number | null;
          readonly id: number;
        }
      | { readonly __typename: "TextAssessmentAnswerNode"; readonly id: number }
      | null;
    readonly answerCalibration:
      | {
          readonly __typename: "RangeAssessmentAnswerCalibrationNode";
          readonly integerAnswer?: number | null;
          readonly prevIntegerAnswer?: number | null;
          readonly id: number;
          readonly comment?: any | null;
          readonly created: string;
          readonly isSuggestion: boolean;
          readonly isPrecalibration: boolean;
          readonly answerId?: number | null;
          readonly creator?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
          readonly target?: {
            readonly __typename: "UserNode";
            readonly id: number;
          } | null;
          readonly question:
            | {
                readonly __typename: "CompetencyAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
              }
            | {
                readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
              }
            | {
                readonly __typename: "IndividualGoalAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
              }
            | {
                readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
              }
            | {
                readonly __typename: "MultiChoiceAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
              }
            | {
                readonly __typename: "NpsAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
              }
            | {
                readonly __typename: "OverallGoalAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
              }
            | {
                readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
              }
            | {
                readonly __typename: "RangeAssessmentQuestionNode";
                readonly labels: ReadonlyArray<string | null>;
                readonly startValue: number;
                readonly endValue: number;
                readonly id: number;
                readonly title: string;
              }
            | {
                readonly __typename: "ResponsibilityAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
              }
            | {
                readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                readonly labels: ReadonlyArray<string | null>;
                readonly startValue: number;
                readonly endValue: number;
                readonly id: number;
                readonly title: string;
              }
            | {
                readonly __typename: "TextAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
              };
        }
      | {
          readonly __typename: "TalentIndicatorAssessmentAnswerCalibrationNode";
          readonly integerAnswer?: number | null;
          readonly prevIntegerAnswer?: number | null;
          readonly id: number;
          readonly comment?: any | null;
          readonly created: string;
          readonly isSuggestion: boolean;
          readonly isPrecalibration: boolean;
          readonly answerId?: number | null;
          readonly creator?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
          readonly target?: {
            readonly __typename: "UserNode";
            readonly id: number;
          } | null;
          readonly question:
            | {
                readonly __typename: "CompetencyAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
              }
            | {
                readonly __typename: "CompetencyCriteriaAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
              }
            | {
                readonly __typename: "IndividualGoalAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
              }
            | {
                readonly __typename: "IndividualRecognitionCoreValueAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
              }
            | {
                readonly __typename: "MultiChoiceAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
              }
            | {
                readonly __typename: "NpsAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
              }
            | {
                readonly __typename: "OverallGoalAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
              }
            | {
                readonly __typename: "OverallRecognitionCoreValueAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
              }
            | {
                readonly __typename: "RangeAssessmentQuestionNode";
                readonly labels: ReadonlyArray<string | null>;
                readonly startValue: number;
                readonly endValue: number;
                readonly id: number;
                readonly title: string;
              }
            | {
                readonly __typename: "ResponsibilityAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
              }
            | {
                readonly __typename: "TalentIndicatorAssessmentQuestionNode";
                readonly labels: ReadonlyArray<string | null>;
                readonly startValue: number;
                readonly endValue: number;
                readonly id: number;
                readonly title: string;
              }
            | {
                readonly __typename: "TextAssessmentQuestionNode";
                readonly id: number;
                readonly title: string;
              };
        };
  };
};

export type UpdateCalibrationStatusMutationVariables = Exact<{
  complianceProgramId: Scalars["Int"]["input"];
  targetId: Scalars["Int"]["input"];
  status: ComplianceProgramCalibrationStatus;
}>;

export type UpdateCalibrationStatusMutation = {
  readonly __typename: "Mutation";
  readonly updateComplianceProgramCalibrationStatus?: {
    readonly __typename: "UpdateComplianceProgramCalibrationStatusMutation";
    readonly reportRow: {
      readonly __typename: "PerformanceReviewReportRowNode";
      readonly id: number;
      readonly calibrationStatus: ComplianceProgramCalibrationStatus;
    };
  } | null;
};

export type SetAgendaAsTemplateMutationVariables = Exact<{
  meetingId: Scalars["Int"]["input"];
}>;

export type SetAgendaAsTemplateMutation = {
  readonly __typename: "Mutation";
  readonly setMeetingAgendaAsTemplate?: {
    readonly __typename: "SetMeetingAgendaAsTemplateMutation";
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
    } | null;
  } | null;
};

export type AddTopicToMeetingMutationMutationVariables = Exact<{
  topicId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  includesIndividualNotes?: InputMaybe<Scalars["Boolean"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  discussionNotes?: InputMaybe<Scalars["JSONString"]["input"]>;
  assignee?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type AddTopicToMeetingMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateTopic?: {
    readonly __typename: "CreateOrUpdateTopicMutation";
    readonly topic?: {
      readonly __typename: "TopicNode";
      readonly id: number;
      readonly clientId?: number | null;
      readonly title: string;
      readonly description?: string | null;
      readonly discussionNotes?: any | null;
      readonly created: string;
      readonly state?: TopicState | null;
      readonly eventChannelName?: string | null;
      readonly includesIndividualNotes: boolean;
      readonly includesIndividualNotesForCurrentUser: boolean;
      readonly includesSharedNotes: boolean;
      readonly isMandatory: boolean;
      readonly notesRequirement: NotesRequirement;
      readonly individualNotes?: {
        readonly __typename: "IndividualNoteNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "IndividualNoteNodeEdge";
          readonly node?: {
            readonly __typename: "IndividualNoteNode";
            readonly id: number;
            readonly created: string;
            readonly hidden: boolean;
            readonly enabled: boolean;
            readonly notes?: any | null;
            readonly creator: {
              readonly __typename: "UserNode";
              readonly id: number;
            };
          } | null;
        } | null>;
      } | null;
      readonly creator?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
      } | null;
      readonly assignee?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly avatar?: string | null;
        readonly name: string;
      } | null;
      readonly previousTopic?: {
        readonly __typename: "TopicNode";
        readonly id: number;
        readonly discussionNotes?: any | null;
      } | null;
      readonly linkedTemplateTopic?: {
        readonly __typename: "TopicNode";
        readonly id: number;
        readonly title: string;
        readonly discussionNotes?: any | null;
        readonly defaultSubjectNotes?: any | null;
        readonly defaultFacilitatorNotes?: any | null;
        readonly topicTemplate?: {
          readonly __typename: "TopicTemplateNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null;
      readonly canUpdate: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
      };
      readonly canDelete: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
      };
      readonly copiedFrom?: {
        readonly __typename: "TopicNode";
        readonly id: number;
        readonly title: string;
        readonly meeting?: {
          readonly __typename: "MeetingNode";
          readonly id: number;
          readonly title?: string | null;
          readonly startDatetime?: string | null;
          readonly meetingGroupId: number;
        } | null;
      } | null;
    } | null;
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
      readonly topics?: {
        readonly __typename: "TopicNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "TopicNodeEdge";
          readonly node?: {
            readonly __typename: "TopicNode";
            readonly id: number;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type SuggestedTemplateCategoryFragmentFragment = {
  readonly __typename: "TemplateCategoryNode";
  readonly id: number;
  readonly title: string;
};

export type SuggestedTemplateTopicsFragmentFragment = {
  readonly __typename: "TopicNode";
  readonly id: number;
  readonly title: string;
  readonly isMandatory: boolean;
  readonly description?: string | null;
  readonly discussionNotes?: any | null;
  readonly includesIndividualNotes: boolean;
};

export type SuggestedTopicTemplateFragmentFragment = {
  readonly __typename: "TopicTemplateNode";
  readonly id: number;
  readonly title: string;
  readonly allowAdminVisibility: boolean;
  readonly allowOrgVisibility: boolean;
  readonly allowManagementTreeVisibility: boolean;
  readonly categories?: {
    readonly __typename: "TemplateCategoryNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "TemplateCategoryNodeEdge";
      readonly node?: {
        readonly __typename: "TemplateCategoryNode";
        readonly id: number;
        readonly title: string;
      } | null;
    } | null>;
  } | null;
  readonly topics?: {
    readonly __typename: "TopicNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "TopicNodeEdge";
      readonly node?: {
        readonly __typename: "TopicNode";
        readonly id: number;
        readonly title: string;
        readonly isMandatory: boolean;
        readonly description?: string | null;
        readonly discussionNotes?: any | null;
        readonly includesIndividualNotes: boolean;
      } | null;
    } | null>;
  } | null;
};

export type GetGlobalTemplatesQueryQueryVariables = Exact<{
  meetingId: Scalars["Int"]["input"];
}>;

export type GetGlobalTemplatesQueryQuery = {
  readonly __typename: "Query";
  readonly topicTemplates?: {
    readonly __typename: "TopicTemplateNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "TopicTemplateNodeEdge";
      readonly node?: {
        readonly __typename: "TopicTemplateNode";
        readonly id: number;
        readonly title: string;
        readonly allowAdminVisibility: boolean;
        readonly allowOrgVisibility: boolean;
        readonly allowManagementTreeVisibility: boolean;
        readonly categories?: {
          readonly __typename: "TemplateCategoryNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "TemplateCategoryNodeEdge";
            readonly node?: {
              readonly __typename: "TemplateCategoryNode";
              readonly id: number;
              readonly title: string;
            } | null;
          } | null>;
        } | null;
        readonly topics?: {
          readonly __typename: "TopicNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "TopicNodeEdge";
            readonly node?: {
              readonly __typename: "TopicNode";
              readonly id: number;
              readonly title: string;
              readonly isMandatory: boolean;
              readonly description?: string | null;
              readonly discussionNotes?: any | null;
              readonly includesIndividualNotes: boolean;
            } | null;
          } | null>;
        } | null;
      } | null;
    } | null>;
  } | null;
  readonly meeting?: {
    readonly __typename: "MeetingNode";
    readonly id: number;
    readonly suggestedTemplates?: {
      readonly __typename: "TopicTemplateNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "TopicTemplateNodeEdge";
        readonly node?: {
          readonly __typename: "TopicTemplateNode";
          readonly id: number;
          readonly title: string;
          readonly allowAdminVisibility: boolean;
          readonly allowOrgVisibility: boolean;
          readonly allowManagementTreeVisibility: boolean;
          readonly categories?: {
            readonly __typename: "TemplateCategoryNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "TemplateCategoryNodeEdge";
              readonly node?: {
                readonly __typename: "TemplateCategoryNode";
                readonly id: number;
                readonly title: string;
              } | null;
            } | null>;
          } | null;
          readonly topics?: {
            readonly __typename: "TopicNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "TopicNodeEdge";
              readonly node?: {
                readonly __typename: "TopicNode";
                readonly id: number;
                readonly title: string;
                readonly isMandatory: boolean;
                readonly description?: string | null;
                readonly discussionNotes?: any | null;
                readonly includesIndividualNotes: boolean;
              } | null;
            } | null>;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetPastTopicsQueryQueryVariables = Exact<{
  meetingGroupId: Scalars["Int"]["input"];
  search?: InputMaybe<Scalars["String"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetPastTopicsQueryQuery = {
  readonly __typename: "Query";
  readonly topics?: {
    readonly __typename: "TopicNodeConnection";
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly hasNextPage: boolean;
      readonly endCursor?: string | null;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "TopicNodeEdge";
      readonly node?: {
        readonly __typename: "TopicNode";
        readonly id: number;
        readonly title: string;
        readonly discussionNotes?: any | null;
        readonly isMandatory: boolean;
        readonly meeting?: {
          readonly __typename: "MeetingNode";
          readonly id: number;
          readonly title?: string | null;
          readonly startDatetime?: string | null;
          readonly meetingGroupId: number;
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type AddTemplateToMeetingMutationMutationVariables = Exact<{
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  meetingGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  topicTemplateId: Scalars["Int"]["input"];
  setAsSeriesTemplate: Scalars["Boolean"]["input"];
  allowAdminVisibility?: InputMaybe<Scalars["Boolean"]["input"]>;
  allowOrgVisibility?: InputMaybe<Scalars["Boolean"]["input"]>;
  allowManagementTreeVisibility?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type AddTemplateToMeetingMutationMutation = {
  readonly __typename: "Mutation";
  readonly addTemplateToMeeting?: {
    readonly __typename: "AddTemplateToMeetingMutation";
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
      readonly topics?: {
        readonly __typename: "TopicNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "TopicNodeEdge";
          readonly node?: {
            readonly __typename: "TopicNode";
            readonly id: number;
            readonly title: string;
            readonly description?: string | null;
            readonly discussionNotes?: any | null;
            readonly includesSharedNotes: boolean;
            readonly created: string;
            readonly state?: TopicState | null;
            readonly eventChannelName?: string | null;
            readonly isMandatory: boolean;
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
            } | null;
            readonly assignee?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly avatar?: string | null;
              readonly name: string;
            } | null;
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly previousTopic?: {
              readonly __typename: "TopicNode";
              readonly id: number;
              readonly discussionNotes?: any | null;
            } | null;
          } | null;
        } | null>;
      } | null;
    } | null;
    readonly meetingGroup?: {
      readonly __typename: "MeetingGroupNode";
      readonly id: number;
      readonly allowAdminVisibility: boolean;
      readonly allowOrgVisibility: boolean;
      readonly allowManagementTreeVisibility: boolean;
      readonly templateSeries?: {
        readonly __typename: "TemplateSeriesNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "TemplateSeriesNodeEdge";
          readonly node?: {
            readonly __typename: "TemplateSeriesNode";
            readonly id: number;
            readonly topicTemplates?: {
              readonly __typename: "TemplateSeriesToTopicTemplatesNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "TemplateSeriesToTopicTemplatesNodeEdge";
                readonly node?: {
                  readonly __typename: "TemplateSeriesToTopicTemplatesNode";
                  readonly id: number;
                  readonly topicTemplate?: {
                    readonly __typename: "TopicTemplateNode";
                    readonly id: number;
                    readonly title: string;
                    readonly description: string;
                    readonly publicTemplate: boolean;
                    readonly topics?: {
                      readonly __typename: "TopicNodeConnection";
                      readonly edges: ReadonlyArray<{
                        readonly __typename: "TopicNodeEdge";
                        readonly node?: {
                          readonly __typename: "TopicNode";
                          readonly id: number;
                          readonly title: string;
                          readonly description?: string | null;
                          readonly includesIndividualNotes: boolean;
                        } | null;
                      } | null>;
                    } | null;
                  } | null;
                } | null;
              } | null>;
            } | null;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type CreateOrUpdateTemplateCategoryMutationMutationVariables = Exact<{
  title: Scalars["String"]["input"];
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  topicTemplateCategoryId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type CreateOrUpdateTemplateCategoryMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateTopicTemplateCategory?: {
    readonly __typename: "CreateOrUpdateTopicTemplateCategoryMutation";
    readonly topicTemplateCategory?: {
      readonly __typename: "TemplateCategoryNode";
      readonly id: number;
      readonly title: string;
      readonly ordinal?: number | null;
    } | null;
  } | null;
};

export type CreateOrUpdateTopicTemplateMutationMutationVariables = Exact<{
  title: Scalars["String"]["input"];
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  topicTemplateId?: InputMaybe<Scalars["Int"]["input"]>;
  oneononeTemplate?: InputMaybe<Scalars["Boolean"]["input"]>;
  categories?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  publicTemplate: Scalars["Boolean"]["input"];
  allowAdminVisibility: Scalars["Boolean"]["input"];
  allowOrgVisibility: Scalars["Boolean"]["input"];
  allowManagementTreeVisibility: Scalars["Boolean"]["input"];
  finalizePermissions?: InputMaybe<FinalizePermissions>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  managerInstructions?: InputMaybe<Scalars["String"]["input"]>;
  reportInstructions?: InputMaybe<Scalars["String"]["input"]>;
  topics?: InputMaybe<
    | ReadonlyArray<InputMaybe<TemplateTopicInput>>
    | InputMaybe<TemplateTopicInput>
  >;
}>;

export type CreateOrUpdateTopicTemplateMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateTopicTemplate?: {
    readonly __typename: "CreateOrUpdateTopicTemplateMutation";
    readonly topicTemplate?: {
      readonly __typename: "TopicTemplateNode";
      readonly id: number;
      readonly title: string;
      readonly description: string;
      readonly globalTemplate: boolean;
      readonly publicTemplate: boolean;
      readonly oneononeTemplate: boolean;
      readonly finalizePermissions: FinalizePermissions;
      readonly managerInstructions: string;
      readonly reportInstructions: string;
      readonly allowAdminVisibility: boolean;
      readonly allowOrgVisibility: boolean;
      readonly allowManagementTreeVisibility: boolean;
      readonly organization?: {
        readonly __typename: "OrganizationNode";
        readonly id: number;
      } | null;
      readonly canDelete: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
        readonly reason: string;
      };
      readonly canUpdate: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
        readonly reason: string;
      };
      readonly creator?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      } | null;
      readonly categoriesList: ReadonlyArray<{
        readonly __typename: "TemplateCategoryNode";
        readonly id: number;
        readonly title: string;
        readonly ordinal?: number | null;
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
        readonly canUpdate?: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        } | null;
        readonly canDelete?: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        } | null;
      } | null>;
      readonly topicsList: ReadonlyArray<{
        readonly __typename: "TopicNode";
        readonly id: number;
        readonly title: string;
        readonly description?: string | null;
        readonly discussionNotes?: any | null;
        readonly defaultSubjectNotes?: any | null;
        readonly defaultFacilitatorNotes?: any | null;
        readonly includesIndividualNotes: boolean;
        readonly includesSharedNotes: boolean;
        readonly isMandatory: boolean;
        readonly notesRequirement: NotesRequirement;
      } | null>;
    } | null;
  } | null;
};

export type DeleteTopicTemplateCategoryMutationMutationVariables = Exact<{
  topicTemplateCategoryId: Scalars["Int"]["input"];
}>;

export type DeleteTopicTemplateCategoryMutationMutation = {
  readonly __typename: "Mutation";
  readonly deleteTopicTemplateCategory?: {
    readonly __typename: "DeleteTopicTemplateCategoryMutation";
    readonly ok?: boolean | null;
  } | null;
};

export type DeleteTopicTemplateMutationMutationVariables = Exact<{
  topicTemplateId: Scalars["Int"]["input"];
}>;

export type DeleteTopicTemplateMutationMutation = {
  readonly __typename: "Mutation";
  readonly deleteTopicTemplate?: {
    readonly __typename: "DeleteTopicTemplateMutation";
    readonly topicTemplate?: {
      readonly __typename: "TopicTemplateNode";
      readonly id: number;
    } | null;
  } | null;
};

export type GetTopicTemplateCategoryQueryVariables = Exact<{
  categoryId: Scalars["Int"]["input"];
}>;

export type GetTopicTemplateCategoryQuery = {
  readonly __typename: "Query";
  readonly topicTemplateCategory?: {
    readonly __typename: "TemplateCategoryNode";
    readonly id: number;
    readonly title: string;
    readonly ordinal?: number | null;
    readonly canUpdate?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    } | null;
    readonly canDelete?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    } | null;
  } | null;
};

export type GetTopicTemplateQueryVariables = Exact<{
  templateId: Scalars["Int"]["input"];
}>;

export type GetTopicTemplateQuery = {
  readonly __typename: "Query";
  readonly topicTemplate?: {
    readonly __typename: "TopicTemplateNode";
    readonly id: number;
    readonly title: string;
    readonly description: string;
    readonly globalTemplate: boolean;
    readonly publicTemplate: boolean;
    readonly oneononeTemplate: boolean;
    readonly finalizePermissions: FinalizePermissions;
    readonly managerInstructions: string;
    readonly reportInstructions: string;
    readonly allowAdminVisibility: boolean;
    readonly allowOrgVisibility: boolean;
    readonly allowManagementTreeVisibility: boolean;
    readonly organization?: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
    } | null;
    readonly canDelete: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    };
    readonly canUpdate: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    };
    readonly creator?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly avatar?: string | null;
    } | null;
    readonly categoriesList: ReadonlyArray<{
      readonly __typename: "TemplateCategoryNode";
      readonly id: number;
      readonly title: string;
      readonly ordinal?: number | null;
      readonly organization?: {
        readonly __typename: "OrganizationNode";
        readonly id: number;
      } | null;
      readonly canUpdate?: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
      } | null;
      readonly canDelete?: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
      } | null;
    } | null>;
    readonly topicsList: ReadonlyArray<{
      readonly __typename: "TopicNode";
      readonly id: number;
      readonly title: string;
      readonly description?: string | null;
      readonly discussionNotes?: any | null;
      readonly defaultSubjectNotes?: any | null;
      readonly defaultFacilitatorNotes?: any | null;
      readonly includesIndividualNotes: boolean;
      readonly includesSharedNotes: boolean;
      readonly isMandatory: boolean;
      readonly notesRequirement: NotesRequirement;
    } | null>;
  } | null;
};

export type GetTopicTemplateToEditQueryQueryVariables = Exact<{
  templateId: Scalars["Int"]["input"];
  hasTemplateId: Scalars["Boolean"]["input"];
}>;

export type GetTopicTemplateToEditQueryQuery = {
  readonly __typename: "Query";
  readonly topicTemplate?: {
    readonly __typename: "TopicTemplateNode";
    readonly canUpdateRequirements: boolean;
    readonly id: number;
    readonly title: string;
    readonly description: string;
    readonly globalTemplate: boolean;
    readonly publicTemplate: boolean;
    readonly oneononeTemplate: boolean;
    readonly finalizePermissions: FinalizePermissions;
    readonly managerInstructions: string;
    readonly reportInstructions: string;
    readonly allowAdminVisibility: boolean;
    readonly allowOrgVisibility: boolean;
    readonly allowManagementTreeVisibility: boolean;
    readonly organization?: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
    } | null;
    readonly canDelete: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    };
    readonly canUpdate: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    };
    readonly creator?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly avatar?: string | null;
    } | null;
    readonly categoriesList: ReadonlyArray<{
      readonly __typename: "TemplateCategoryNode";
      readonly id: number;
      readonly title: string;
      readonly ordinal?: number | null;
      readonly organization?: {
        readonly __typename: "OrganizationNode";
        readonly id: number;
      } | null;
      readonly canUpdate?: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
      } | null;
      readonly canDelete?: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
      } | null;
    } | null>;
    readonly topicsList: ReadonlyArray<{
      readonly __typename: "TopicNode";
      readonly id: number;
      readonly title: string;
      readonly description?: string | null;
      readonly discussionNotes?: any | null;
      readonly defaultSubjectNotes?: any | null;
      readonly defaultFacilitatorNotes?: any | null;
      readonly includesIndividualNotes: boolean;
      readonly includesSharedNotes: boolean;
      readonly isMandatory: boolean;
      readonly notesRequirement: NotesRequirement;
    } | null>;
  } | null;
  readonly topicTemplateCategories: {
    readonly __typename: "TemplateCategoryNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "TemplateCategoryNodeEdge";
      readonly node?: {
        readonly __typename: "TemplateCategoryNode";
        readonly id: number;
        readonly title: string;
        readonly ordinal?: number | null;
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
        readonly canUpdate?: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        } | null;
        readonly canDelete?: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        } | null;
      } | null;
    } | null>;
  };
};

export type GetTopicTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type GetTopicTemplatesQuery = {
  readonly __typename: "Query";
  readonly topicTemplates?: {
    readonly __typename: "TopicTemplateNodeConnection";
    readonly totalCount: number;
    readonly edges: ReadonlyArray<{
      readonly __typename: "TopicTemplateNodeEdge";
      readonly node?: {
        readonly __typename: "TopicTemplateNode";
        readonly id: number;
        readonly title: string;
        readonly description: string;
        readonly globalTemplate: boolean;
        readonly publicTemplate: boolean;
        readonly oneononeTemplate: boolean;
        readonly finalizePermissions: FinalizePermissions;
        readonly managerInstructions: string;
        readonly reportInstructions: string;
        readonly allowAdminVisibility: boolean;
        readonly allowOrgVisibility: boolean;
        readonly allowManagementTreeVisibility: boolean;
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
          readonly reason: string;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
          readonly reason: string;
        };
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly categoriesList: ReadonlyArray<{
          readonly __typename: "TemplateCategoryNode";
          readonly id: number;
          readonly title: string;
          readonly ordinal?: number | null;
          readonly organization?: {
            readonly __typename: "OrganizationNode";
            readonly id: number;
          } | null;
          readonly canUpdate?: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          } | null;
          readonly canDelete?: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          } | null;
        } | null>;
        readonly topicsList: ReadonlyArray<{
          readonly __typename: "TopicNode";
          readonly id: number;
          readonly title: string;
          readonly description?: string | null;
          readonly discussionNotes?: any | null;
          readonly defaultSubjectNotes?: any | null;
          readonly defaultFacilitatorNotes?: any | null;
          readonly includesIndividualNotes: boolean;
          readonly includesSharedNotes: boolean;
          readonly isMandatory: boolean;
          readonly notesRequirement: NotesRequirement;
        } | null>;
      } | null;
    } | null>;
  } | null;
  readonly topicTemplateCategories: {
    readonly __typename: "TemplateCategoryNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "TemplateCategoryNodeEdge";
      readonly node?: {
        readonly __typename: "TemplateCategoryNode";
        readonly id: number;
        readonly title: string;
        readonly ordinal?: number | null;
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
        readonly canUpdate?: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        } | null;
        readonly canDelete?: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        } | null;
      } | null;
    } | null>;
  };
};

export type TopicTemplateCategoryFragmentFragment = {
  readonly __typename: "TemplateCategoryNode";
  readonly id: number;
  readonly title: string;
  readonly ordinal?: number | null;
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
  readonly canUpdate?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  } | null;
  readonly canDelete?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  } | null;
};

export type TemplateAppTopicFragment = {
  readonly __typename: "TopicNode";
  readonly id: number;
  readonly title: string;
  readonly description?: string | null;
  readonly discussionNotes?: any | null;
  readonly defaultSubjectNotes?: any | null;
  readonly defaultFacilitatorNotes?: any | null;
  readonly includesIndividualNotes: boolean;
  readonly includesSharedNotes: boolean;
  readonly isMandatory: boolean;
  readonly notesRequirement: NotesRequirement;
};

export type TopicTemplateFragmentFragment = {
  readonly __typename: "TopicTemplateNode";
  readonly id: number;
  readonly title: string;
  readonly description: string;
  readonly globalTemplate: boolean;
  readonly publicTemplate: boolean;
  readonly oneononeTemplate: boolean;
  readonly finalizePermissions: FinalizePermissions;
  readonly managerInstructions: string;
  readonly reportInstructions: string;
  readonly allowAdminVisibility: boolean;
  readonly allowOrgVisibility: boolean;
  readonly allowManagementTreeVisibility: boolean;
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  };
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
    readonly reason: string;
  };
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
  readonly categoriesList: ReadonlyArray<{
    readonly __typename: "TemplateCategoryNode";
    readonly id: number;
    readonly title: string;
    readonly ordinal?: number | null;
    readonly organization?: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
    } | null;
    readonly canUpdate?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    } | null;
    readonly canDelete?: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    } | null;
  } | null>;
  readonly topicsList: ReadonlyArray<{
    readonly __typename: "TopicNode";
    readonly id: number;
    readonly title: string;
    readonly description?: string | null;
    readonly discussionNotes?: any | null;
    readonly defaultSubjectNotes?: any | null;
    readonly defaultFacilitatorNotes?: any | null;
    readonly includesIndividualNotes: boolean;
    readonly includesSharedNotes: boolean;
    readonly isMandatory: boolean;
    readonly notesRequirement: NotesRequirement;
  } | null>;
};

export type UpdateTopicAssigneeMutationMutationVariables = Exact<{
  topicId?: InputMaybe<Scalars["Int"]["input"]>;
  assignee?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type UpdateTopicAssigneeMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateTopic?: {
    readonly __typename: "CreateOrUpdateTopicMutation";
    readonly topic?: {
      readonly __typename: "TopicNode";
      readonly id: number;
      readonly assignee?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      } | null;
    } | null;
  } | null;
};

export type ToggleTopicStateMutationMutationVariables = Exact<{
  topicId: Scalars["Int"]["input"];
  state: TopicState;
}>;

export type ToggleTopicStateMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateTopic?: {
    readonly __typename: "CreateOrUpdateTopicMutation";
    readonly topic?: {
      readonly __typename: "TopicNode";
      readonly id: number;
      readonly state?: TopicState | null;
    } | null;
  } | null;
};

export type CopyTopicToMeetingMutationMutationVariables = Exact<{
  topicIds:
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>;
  meetingId: Scalars["Int"]["input"];
}>;

export type CopyTopicToMeetingMutationMutation = {
  readonly __typename: "Mutation";
  readonly copyTopicsToMeeting?: {
    readonly __typename: "CopyTopicsToMeetingMutation";
    readonly copiedTopics?: ReadonlyArray<{
      readonly __typename: "TopicNode";
      readonly id: number;
      readonly clientId?: number | null;
      readonly title: string;
      readonly description?: string | null;
      readonly discussionNotes?: any | null;
      readonly created: string;
      readonly state?: TopicState | null;
      readonly eventChannelName?: string | null;
      readonly includesIndividualNotes: boolean;
      readonly includesIndividualNotesForCurrentUser: boolean;
      readonly includesSharedNotes: boolean;
      readonly isMandatory: boolean;
      readonly notesRequirement: NotesRequirement;
      readonly individualNotes?: {
        readonly __typename: "IndividualNoteNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "IndividualNoteNodeEdge";
          readonly node?: {
            readonly __typename: "IndividualNoteNode";
            readonly id: number;
            readonly created: string;
            readonly hidden: boolean;
            readonly enabled: boolean;
            readonly notes?: any | null;
            readonly creator: {
              readonly __typename: "UserNode";
              readonly id: number;
            };
          } | null;
        } | null>;
      } | null;
      readonly creator?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
      } | null;
      readonly assignee?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly avatar?: string | null;
        readonly name: string;
      } | null;
      readonly previousTopic?: {
        readonly __typename: "TopicNode";
        readonly id: number;
        readonly discussionNotes?: any | null;
      } | null;
      readonly linkedTemplateTopic?: {
        readonly __typename: "TopicNode";
        readonly id: number;
        readonly title: string;
        readonly discussionNotes?: any | null;
        readonly defaultSubjectNotes?: any | null;
        readonly defaultFacilitatorNotes?: any | null;
        readonly topicTemplate?: {
          readonly __typename: "TopicTemplateNode";
          readonly id: number;
          readonly title: string;
        } | null;
      } | null;
      readonly canUpdate: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
      };
      readonly canDelete: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
      };
      readonly copiedFrom?: {
        readonly __typename: "TopicNode";
        readonly id: number;
        readonly title: string;
        readonly meeting?: {
          readonly __typename: "MeetingNode";
          readonly id: number;
          readonly title?: string | null;
          readonly startDatetime?: string | null;
          readonly meetingGroupId: number;
        } | null;
      } | null;
    } | null> | null;
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
      readonly topics?: {
        readonly __typename: "TopicNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "TopicNodeEdge";
          readonly node?: {
            readonly __typename: "TopicNode";
            readonly id: number;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type DeleteTopicMutationMutationVariables = Exact<{
  topicId: Scalars["Int"]["input"];
}>;

export type DeleteTopicMutationMutation = {
  readonly __typename: "Mutation";
  readonly deleteTopic?: {
    readonly __typename: "DeleteTopicMutation";
    readonly ok?: boolean | null;
  } | null;
};

export type GetTopicMeetingsQueryVariables = Exact<{
  topicId: Scalars["Int"]["input"];
  meetingGroupId: Scalars["Int"]["input"];
  startDatetime: Scalars["DateTime"]["input"];
  excludeIds:
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetTopicMeetingsQuery = {
  readonly __typename: "Query";
  readonly topic?: {
    readonly __typename: "TopicNode";
    readonly id: number;
  } | null;
  readonly meetingGroup?: {
    readonly __typename: "MeetingGroupNode";
    readonly id: number;
    readonly meetings?: {
      readonly __typename: "MeetingNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "MeetingNodeEdge";
        readonly node?: {
          readonly __typename: "MeetingNode";
          readonly id: number;
          readonly title?: string | null;
          readonly startDatetime?: string | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type UpdateTopicSharedOrIndividualNotesMutationMutationVariables =
  Exact<{
    topicId?: InputMaybe<Scalars["Int"]["input"]>;
    includesIndividualNotes?: InputMaybe<Scalars["Boolean"]["input"]>;
    includesSharedNotes?: InputMaybe<Scalars["Boolean"]["input"]>;
  }>;

export type UpdateTopicSharedOrIndividualNotesMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateTopic?: {
    readonly __typename: "CreateOrUpdateTopicMutation";
    readonly topic?: {
      readonly __typename: "TopicNode";
      readonly id: number;
      readonly includesIndividualNotes: boolean;
      readonly includesSharedNotes: boolean;
    } | null;
  } | null;
};

export type GetRelatedTopicArtifactsQueryVariables = Exact<{
  topicId: Scalars["Int"]["input"];
  meetingGroupId: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetRelatedTopicArtifactsQuery = {
  readonly __typename: "Query";
  readonly topic?: {
    readonly __typename: "TopicNode";
    readonly id: number;
    readonly artifacts?: {
      readonly __typename: "ArtifactConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "ArtifactEdge";
        readonly node?:
          | {
              readonly __typename: "ActionItemArtifactNode";
              readonly isComplete?: boolean | null;
              readonly dueDate?: string | null;
              readonly id: number;
              readonly artifactType: ArtifactType;
              readonly title?: string | null;
              readonly assignee?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly canDelete: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
            }
          | {
              readonly __typename: "AsanaTaskArtifactNode";
              readonly id: number;
              readonly artifactType: ArtifactType;
              readonly title?: string | null;
              readonly canDelete: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
            }
          | {
              readonly __typename: "DecisionArtifactNode";
              readonly decision: string;
              readonly decisionState?: DecisionState | null;
              readonly isDraft?: boolean | null;
              readonly id: number;
              readonly artifactType: ArtifactType;
              readonly title?: string | null;
              readonly canDelete: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
            }
          | {
              readonly __typename: "DocumentArtifactNode";
              readonly id: number;
              readonly artifactType: ArtifactType;
              readonly title?: string | null;
              readonly canDelete: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
            }
          | {
              readonly __typename: "FeedbackArtifactNode";
              readonly id: number;
              readonly artifactType: ArtifactType;
              readonly title?: string | null;
              readonly canDelete: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
            }
          | {
              readonly __typename: "GithubIssuesArtifactNode";
              readonly id: number;
              readonly artifactType: ArtifactType;
              readonly title?: string | null;
              readonly canDelete: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
            }
          | {
              readonly __typename: "GoalArtifactNode";
              readonly id: number;
              readonly artifactType: ArtifactType;
              readonly title?: string | null;
              readonly startValue: number;
              readonly currentValue: number;
              readonly targetValue: number;
              readonly progress: number;
              readonly progressType: GoalProgressType;
              readonly dueDate?: string | null;
              readonly startDate?: string | null;
              readonly state: GoalState;
              readonly status: GoalStatus;
              readonly scope: GoalScope;
              readonly goalVisibility: GoalVisibility;
              readonly created: string;
              readonly parentGoalId?: number | null;
              readonly ownerCount?: number | null;
              readonly contributorCount?: number | null;
              readonly isStale: boolean;
              readonly updated?: string | null;
              readonly canDelete: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
              readonly firstOwner?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly avatar?: string | null;
                readonly name: string;
              } | null;
              readonly canUpdate: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
              readonly canRead: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
              readonly creator?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            }
          | {
              readonly __typename: "KPIArtifactNode";
              readonly id: number;
              readonly artifactType: ArtifactType;
              readonly title?: string | null;
              readonly canDelete: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
            }
          | {
              readonly __typename: "RatingArtifactNode";
              readonly id: number;
              readonly artifactType: ArtifactType;
              readonly title?: string | null;
              readonly canDelete: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
            }
          | {
              readonly __typename: "RecognitionArtifactNode";
              readonly id: number;
              readonly artifactType: ArtifactType;
              readonly title?: string | null;
              readonly canDelete: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              };
            }
          | null;
      } | null>;
    } | null;
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
      readonly meetingGroupId: number;
      readonly startDatetime?: string | null;
    } | null;
    readonly relatedTopics?: {
      readonly __typename: "TopicNodeConnection";
      readonly totalCount: number;
      readonly pageInfo: {
        readonly __typename: "PageInfo";
        readonly hasNextPage: boolean;
        readonly endCursor?: string | null;
      };
      readonly edges: ReadonlyArray<{
        readonly __typename: "TopicNodeEdge";
        readonly node?: {
          readonly __typename: "TopicNode";
          readonly id: number;
          readonly title: string;
          readonly meeting?: {
            readonly __typename: "MeetingNode";
            readonly id: number;
            readonly meetingGroupId: number;
            readonly startDatetime?: string | null;
          } | null;
          readonly artifacts?: {
            readonly __typename: "ArtifactConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "ArtifactEdge";
              readonly node?:
                | {
                    readonly __typename: "ActionItemArtifactNode";
                    readonly isComplete?: boolean | null;
                    readonly id: number;
                    readonly artifactType: ArtifactType;
                    readonly title?: string | null;
                    readonly created: string;
                    readonly updated?: string | null;
                    readonly assignee?: {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    } | null;
                    readonly canDelete: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                    };
                    readonly creator?: {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    } | null;
                  }
                | {
                    readonly __typename: "AsanaTaskArtifactNode";
                    readonly id: number;
                    readonly artifactType: ArtifactType;
                    readonly title?: string | null;
                    readonly created: string;
                    readonly updated?: string | null;
                    readonly canDelete: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                    };
                    readonly creator?: {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    } | null;
                  }
                | {
                    readonly __typename: "DecisionArtifactNode";
                    readonly decision: string;
                    readonly decisionState?: DecisionState | null;
                    readonly isDraft?: boolean | null;
                    readonly id: number;
                    readonly artifactType: ArtifactType;
                    readonly title?: string | null;
                    readonly created: string;
                    readonly updated?: string | null;
                    readonly canDelete: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                    };
                    readonly creator?: {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    } | null;
                  }
                | {
                    readonly __typename: "DocumentArtifactNode";
                    readonly id: number;
                    readonly artifactType: ArtifactType;
                    readonly title?: string | null;
                    readonly created: string;
                    readonly updated?: string | null;
                    readonly canDelete: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                    };
                    readonly creator?: {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    } | null;
                  }
                | {
                    readonly __typename: "FeedbackArtifactNode";
                    readonly id: number;
                    readonly artifactType: ArtifactType;
                    readonly title?: string | null;
                    readonly created: string;
                    readonly updated?: string | null;
                    readonly canDelete: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                    };
                    readonly creator?: {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    } | null;
                  }
                | {
                    readonly __typename: "GithubIssuesArtifactNode";
                    readonly id: number;
                    readonly artifactType: ArtifactType;
                    readonly title?: string | null;
                    readonly created: string;
                    readonly updated?: string | null;
                    readonly canDelete: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                    };
                    readonly creator?: {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    } | null;
                  }
                | {
                    readonly __typename: "GoalArtifactNode";
                    readonly id: number;
                    readonly artifactType: ArtifactType;
                    readonly title?: string | null;
                    readonly created: string;
                    readonly updated?: string | null;
                    readonly startValue: number;
                    readonly currentValue: number;
                    readonly targetValue: number;
                    readonly progress: number;
                    readonly progressType: GoalProgressType;
                    readonly dueDate?: string | null;
                    readonly startDate?: string | null;
                    readonly state: GoalState;
                    readonly status: GoalStatus;
                    readonly scope: GoalScope;
                    readonly goalVisibility: GoalVisibility;
                    readonly parentGoalId?: number | null;
                    readonly ownerCount?: number | null;
                    readonly contributorCount?: number | null;
                    readonly isStale: boolean;
                    readonly canDelete: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                    };
                    readonly creator?: {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    } | null;
                    readonly firstOwner?: {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly avatar?: string | null;
                      readonly name: string;
                    } | null;
                    readonly canUpdate: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                    };
                    readonly canRead: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                    };
                  }
                | {
                    readonly __typename: "KPIArtifactNode";
                    readonly id: number;
                    readonly artifactType: ArtifactType;
                    readonly title?: string | null;
                    readonly created: string;
                    readonly updated?: string | null;
                    readonly canDelete: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                    };
                    readonly creator?: {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    } | null;
                  }
                | {
                    readonly __typename: "RatingArtifactNode";
                    readonly id: number;
                    readonly artifactType: ArtifactType;
                    readonly title?: string | null;
                    readonly created: string;
                    readonly updated?: string | null;
                    readonly canDelete: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                    };
                    readonly creator?: {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    } | null;
                  }
                | {
                    readonly __typename: "RecognitionArtifactNode";
                    readonly id: number;
                    readonly artifactType: ArtifactType;
                    readonly title?: string | null;
                    readonly created: string;
                    readonly updated?: string | null;
                    readonly recipients?: {
                      readonly __typename: "UserNodeConnection";
                      readonly totalCount: number;
                      readonly edges: ReadonlyArray<{
                        readonly __typename: "UserNodeEdge";
                        readonly node?: {
                          readonly __typename: "UserNode";
                          readonly id: number;
                          readonly name: string;
                          readonly avatar?: string | null;
                        } | null;
                      } | null>;
                    } | null;
                    readonly canDelete: {
                      readonly __typename: "PermissionNode";
                      readonly permission: boolean;
                    };
                    readonly creator?: {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    } | null;
                  }
                | null;
            } | null>;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetRelatedTopicsQueryVariables = Exact<{
  topicId: Scalars["Int"]["input"];
  meetingGroupId: Scalars["Int"]["input"];
}>;

export type GetRelatedTopicsQuery = {
  readonly __typename: "Query";
  readonly topic?: {
    readonly __typename: "TopicNode";
    readonly id: number;
    readonly relatedTopics?: {
      readonly __typename: "TopicNodeConnection";
      readonly totalCount: number;
      readonly edges: ReadonlyArray<{
        readonly __typename: "TopicNodeEdge";
        readonly node?: {
          readonly __typename: "TopicNode";
          readonly id: number;
          readonly meeting?: {
            readonly __typename: "MeetingNode";
            readonly id: number;
            readonly startDatetime?: string | null;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type TopicSidebarTopicNodeFragment = {
  readonly __typename: "TopicNode";
  readonly discussionNotes?: any | null;
  readonly includesIndividualNotes: boolean;
  readonly includesIndividualNotesForCurrentUser: boolean;
  readonly includesSharedNotes: boolean;
  readonly notesRequirement: NotesRequirement;
  readonly id: number;
  readonly title: string;
  readonly description?: string | null;
  readonly created: string;
  readonly state?: TopicState | null;
  readonly eventChannelName?: string | null;
  readonly isMandatory: boolean;
  readonly individualNotes?: {
    readonly __typename: "IndividualNoteNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "IndividualNoteNodeEdge";
      readonly node?: {
        readonly __typename: "IndividualNoteNode";
        readonly id: number;
        readonly created: string;
        readonly hidden: boolean;
        readonly enabled: boolean;
        readonly notes?: any | null;
        readonly creator: {
          readonly __typename: "UserNode";
          readonly id: number;
        };
      } | null;
    } | null>;
  } | null;
  readonly meeting?: {
    readonly __typename: "MeetingNode";
    readonly id: number;
    readonly title?: string | null;
    readonly startDatetime?: string | null;
    readonly websocketToken?: string | null;
    readonly organization?: {
      readonly __typename: "OrganizationNode";
      readonly id: number;
    } | null;
    readonly meetingGroup?: {
      readonly __typename: "MeetingGroupNode";
      readonly id: number;
      readonly isFormalOneonone: boolean;
    } | null;
    readonly participants?: {
      readonly __typename: "MeetingParticipantConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "MeetingParticipantEdge";
        readonly node?: {
          readonly __typename: "MeetingParticipantNode";
          readonly id?: string | null;
          readonly status?: AttendeeStatus | null;
          readonly user?: {
            readonly __typename: "BasicUserNode";
            readonly id: number;
            readonly name: string;
            readonly firstName: string;
            readonly lastName: string;
            readonly avatar?: string | null;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
  } | null;
  readonly assignee?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly avatar?: string | null;
    readonly name: string;
  } | null;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly previousTopic?: {
    readonly __typename: "TopicNode";
    readonly id: number;
    readonly discussionNotes?: any | null;
  } | null;
};

export type GetTopicSidebarQueryVariables = Exact<{
  topicId: Scalars["Int"]["input"];
}>;

export type GetTopicSidebarQuery = {
  readonly __typename: "Query";
  readonly topic?: {
    readonly __typename: "TopicNode";
    readonly discussionNotes?: any | null;
    readonly includesIndividualNotes: boolean;
    readonly includesIndividualNotesForCurrentUser: boolean;
    readonly includesSharedNotes: boolean;
    readonly notesRequirement: NotesRequirement;
    readonly id: number;
    readonly title: string;
    readonly description?: string | null;
    readonly created: string;
    readonly state?: TopicState | null;
    readonly eventChannelName?: string | null;
    readonly isMandatory: boolean;
    readonly individualNotes?: {
      readonly __typename: "IndividualNoteNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "IndividualNoteNodeEdge";
        readonly node?: {
          readonly __typename: "IndividualNoteNode";
          readonly id: number;
          readonly notes?: any | null;
          readonly enabled: boolean;
          readonly hidden: boolean;
          readonly created: string;
          readonly creator: {
            readonly __typename: "UserNode";
            readonly id: number;
          };
        } | null;
      } | null>;
    } | null;
    readonly meeting?: {
      readonly __typename: "MeetingNode";
      readonly id: number;
      readonly title?: string | null;
      readonly startDatetime?: string | null;
      readonly websocketToken?: string | null;
      readonly startDate?: string | null;
      readonly endDatetime?: string | null;
      readonly externalUrl?: string | null;
      readonly videoConferenceType?: OnlineVideoConference | null;
      readonly videoConferenceUrl?: string | null;
      readonly allowExternalViewers?: boolean | null;
      readonly writableSharingUrl?: string | null;
      readonly hasPreviousMeetings?: boolean | null;
      readonly ignored: boolean;
      readonly finalizedAt?: string | null;
      readonly isFinalized: boolean;
      readonly meetingGroupId: number;
      readonly isSubmitted: boolean;
      readonly hasIncompleteMandatoryTopics: boolean;
      readonly transcriptionStatus?: boolean | null;
      readonly created: string;
      readonly draft: boolean;
      readonly isRecurring: boolean;
      readonly hasExternalParticipants?: boolean | null;
      readonly isManagerAndReportOneonone: boolean;
      readonly hasBotInMeeting: boolean;
      readonly botIsRecording: boolean;
      readonly botIsWaitingToJoinMeeting: boolean;
      readonly organization?: {
        readonly __typename: "OrganizationNode";
        readonly id: number;
        readonly name: string;
        readonly effectivePricingTier?: PricingTier | null;
        readonly enableMeetingSummarization: boolean;
        readonly domains?: ReadonlyArray<string | null> | null;
        readonly enableMeetingBot: boolean;
      } | null;
      readonly meetingGroup?: {
        readonly __typename: "MeetingGroupNode";
        readonly id: number;
        readonly isFormalOneonone: boolean;
        readonly title: string;
        readonly hasTemplate?: boolean | null;
        readonly allowAdminVisibility: boolean;
        readonly allowOrgVisibility: boolean;
        readonly allowManagementTreeVisibility: boolean;
        readonly detectedOneononeBannerDismissed: boolean;
        readonly meetingBotSetting?: MeetingBotSetting | null;
        readonly addTranscriptionBotToMeetingsByDefault: boolean;
        readonly transcribeMeetingsByDefault?: boolean | null;
        readonly canUpdate?: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        } | null;
        readonly facilitator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
          readonly name: string;
        } | null;
        readonly syncCredentials?: {
          readonly __typename: "UserSyncCredentialsNode";
          readonly id: number;
          readonly hasCalendarWriteCredentials?: boolean | null;
          readonly provider?: SyncCredentialsTypeEnum | null;
        } | null;
        readonly topicTemplate?: {
          readonly __typename: "TopicTemplateNode";
          readonly id: number;
          readonly title: string;
          readonly globalTemplate: boolean;
          readonly publicTemplate: boolean;
          readonly meetingTemplate: boolean;
          readonly finalizePermissions: FinalizePermissions;
          readonly organization?: {
            readonly __typename: "OrganizationNode";
            readonly id: number;
          } | null;
        } | null;
      } | null;
      readonly participants?: {
        readonly __typename: "MeetingParticipantConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "MeetingParticipantEdge";
          readonly node?: {
            readonly __typename: "MeetingParticipantNode";
            readonly id?: string | null;
            readonly status?: AttendeeStatus | null;
            readonly participantEmail?: string | null;
            readonly role?: AttendeeRole | null;
            readonly user?: {
              readonly __typename: "BasicUserNode";
              readonly id: number;
              readonly name: string;
              readonly firstName: string;
              readonly lastName: string;
              readonly avatar?: string | null;
              readonly email: string;
              readonly status?: UserStatus | null;
            } | null;
          } | null;
        } | null>;
      } | null;
      readonly previousMeeting?: {
        readonly __typename: "MeetingNode";
        readonly id: number;
        readonly startDate?: string | null;
        readonly startDatetime?: string | null;
      } | null;
      readonly subject?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly isInCurrentUserReportingTree: boolean;
        readonly managersList: ReadonlyArray<{
          readonly __typename: "UserNode";
          readonly id: number;
        }>;
      } | null;
      readonly canFinalize: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
      };
      readonly canDelete?: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
      } | null;
      readonly canUpdate?: {
        readonly __typename: "PermissionNode";
        readonly permission: boolean;
      } | null;
      readonly finalizedBy?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      } | null;
      readonly organizer?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
      } | null;
      readonly creator?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly firstName: string;
        readonly lastName: string;
        readonly avatar?: string | null;
      } | null;
      readonly transcript?: {
        readonly __typename: "MeetingTranscriptNode";
        readonly id: number;
      } | null;
      readonly topics?: {
        readonly __typename: "TopicNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "TopicNodeEdge";
          readonly node?: {
            readonly __typename: "TopicNode";
            readonly id: number;
            readonly clientId?: number | null;
            readonly title: string;
            readonly description?: string | null;
            readonly discussionNotes?: any | null;
            readonly created: string;
            readonly state?: TopicState | null;
            readonly eventChannelName?: string | null;
            readonly includesIndividualNotes: boolean;
            readonly includesIndividualNotesForCurrentUser: boolean;
            readonly includesSharedNotes: boolean;
            readonly isMandatory: boolean;
            readonly notesRequirement: NotesRequirement;
            readonly individualNotes?: {
              readonly __typename: "IndividualNoteNodeConnection";
              readonly edges: ReadonlyArray<{
                readonly __typename: "IndividualNoteNodeEdge";
                readonly node?: {
                  readonly __typename: "IndividualNoteNode";
                  readonly id: number;
                  readonly created: string;
                  readonly hidden: boolean;
                  readonly enabled: boolean;
                  readonly notes?: any | null;
                  readonly creator: {
                    readonly __typename: "UserNode";
                    readonly id: number;
                  };
                } | null;
              } | null>;
            } | null;
            readonly creator?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
            } | null;
            readonly assignee?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly avatar?: string | null;
              readonly name: string;
            } | null;
            readonly previousTopic?: {
              readonly __typename: "TopicNode";
              readonly id: number;
              readonly discussionNotes?: any | null;
            } | null;
            readonly linkedTemplateTopic?: {
              readonly __typename: "TopicNode";
              readonly id: number;
              readonly title: string;
              readonly discussionNotes?: any | null;
              readonly defaultSubjectNotes?: any | null;
              readonly defaultFacilitatorNotes?: any | null;
              readonly topicTemplate?: {
                readonly __typename: "TopicTemplateNode";
                readonly id: number;
                readonly title: string;
              } | null;
            } | null;
            readonly canUpdate: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly canDelete: {
              readonly __typename: "PermissionNode";
              readonly permission: boolean;
            };
            readonly copiedFrom?: {
              readonly __typename: "TopicNode";
              readonly id: number;
              readonly title: string;
              readonly meeting?: {
                readonly __typename: "MeetingNode";
                readonly id: number;
                readonly title?: string | null;
                readonly startDatetime?: string | null;
                readonly meetingGroupId: number;
              } | null;
            } | null;
          } | null;
        } | null>;
      } | null;
      readonly assessmentDeliveriesMatching1on1Template: {
        readonly __typename: "AssessmentDeliveryNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "AssessmentDeliveryNodeEdge";
          readonly node?: {
            readonly __typename: "AssessmentDeliveryNode";
            readonly id: number;
            readonly target?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
            } | null;
            readonly complianceProgram?: {
              readonly __typename: "ComplianceProgramNode";
              readonly id: number;
              readonly title: string;
              readonly requiredTopicTemplates: {
                readonly __typename: "TopicTemplateNodeConnection";
                readonly edges: ReadonlyArray<{
                  readonly __typename: "TopicTemplateNodeEdge";
                  readonly node?: {
                    readonly __typename: "TopicTemplateNode";
                    readonly id: number;
                    readonly title: string;
                  } | null;
                } | null>;
              };
            } | null;
          } | null;
        } | null>;
      };
      readonly botParticipationDetails: {
        readonly __typename: "BotParticipationDetailsNode";
        readonly willBotJoin: boolean;
        readonly reason: MeetingBotJoinReason;
        readonly joinBecauseOfParticipants: ReadonlyArray<{
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
        }>;
      };
    } | null;
    readonly creator?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
    } | null;
    readonly assignee?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly avatar?: string | null;
      readonly name: string;
    } | null;
    readonly canDelete: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    };
    readonly canUpdate: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
    };
    readonly previousTopic?: {
      readonly __typename: "TopicNode";
      readonly id: number;
      readonly discussionNotes?: any | null;
    } | null;
  } | null;
};

export type UpdateTopicTitleDescriptionMutationMutationVariables = Exact<{
  topicId: Scalars["Int"]["input"];
  title?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type UpdateTopicTitleDescriptionMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateTopic?: {
    readonly __typename: "CreateOrUpdateTopicMutation";
    readonly topic?: {
      readonly __typename: "TopicNode";
      readonly id: number;
      readonly title: string;
      readonly description?: string | null;
    } | null;
  } | null;
};

export type SaveUserUiPreferenceMutationMutationVariables = Exact<{
  userId: Scalars["Int"]["input"];
  uiPreferenceCache?: InputMaybe<Scalars["JSONString"]["input"]>;
}>;

export type SaveUserUiPreferenceMutationMutation = {
  readonly __typename: "Mutation";
  readonly updateUser?: {
    readonly __typename: "UpdateUserMutation";
    readonly user?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly uiPreferenceCache?: any | null;
    } | null;
  } | null;
};

export type GetMyWorkHistoryQueryVariables = Exact<{
  userId: Scalars["Int"]["input"];
  organizationId: Scalars["Int"]["input"];
  start: Scalars["Date"]["input"];
  end: Scalars["Date"]["input"];
  forceDateFilter?: InputMaybe<Scalars["Boolean"]["input"]>;
  generateIfMissing?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type GetMyWorkHistoryQuery = {
  readonly __typename: "Query";
  readonly workHistory?: {
    readonly __typename: "WorkHistorySummaryNode";
    readonly id: number;
    readonly summary: string;
    readonly modifiedSummary?: string | null;
    readonly meetingCount: number;
    readonly meetingTimeHours: number;
    readonly created: string;
    readonly summaryStartDate: string;
    readonly summaryEndDate: string;
    readonly externalEventData: any;
    readonly externalEventDataSummaries: any;
    readonly subject?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly avatar?: string | null;
    } | null;
    readonly collaborators: {
      readonly __typename: "WorkHistoryCollaborationConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "WorkHistoryCollaborationEdge";
        readonly node?: {
          readonly __typename: "WorkHistoryCollaborationNode";
          readonly collaborationCount: number;
          readonly user?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
        } | null;
      } | null>;
    };
    readonly sections: {
      readonly __typename: "WorkHistorySummarySectionNodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "WorkHistorySummarySectionNodeEdge";
        readonly node?: {
          readonly __typename: "WorkHistorySummarySectionNode";
          readonly id: number;
          readonly title: string;
          readonly modifiedTitle?: string | null;
          readonly content: string;
          readonly modifiedContent?: string | null;
          readonly hidden: boolean;
        } | null;
      } | null>;
    };
  } | null;
};

export type MyWorkHistoryItemFragmentFragment = {
  readonly __typename: "WorkHistorySummaryNode";
  readonly id: number;
  readonly summary: string;
  readonly modifiedSummary?: string | null;
  readonly meetingCount: number;
  readonly meetingTimeHours: number;
  readonly created: string;
  readonly summaryStartDate: string;
  readonly summaryEndDate: string;
  readonly externalEventData: any;
  readonly externalEventDataSummaries: any;
  readonly subject?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
  readonly collaborators: {
    readonly __typename: "WorkHistoryCollaborationConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "WorkHistoryCollaborationEdge";
      readonly node?: {
        readonly __typename: "WorkHistoryCollaborationNode";
        readonly collaborationCount: number;
        readonly user?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null;
    } | null>;
  };
  readonly sections: {
    readonly __typename: "WorkHistorySummarySectionNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "WorkHistorySummarySectionNodeEdge";
      readonly node?: {
        readonly __typename: "WorkHistorySummarySectionNode";
        readonly id: number;
        readonly title: string;
        readonly modifiedTitle?: string | null;
        readonly content: string;
        readonly modifiedContent?: string | null;
        readonly hidden: boolean;
      } | null;
    } | null>;
  };
};

export type UpdateMyWorkHistoryMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
  data: WorkHistorySummaryInput;
}>;

export type UpdateMyWorkHistoryMutation = {
  readonly __typename: "Mutation";
  readonly updateWorkHistory?: {
    readonly __typename: "UpdateWorkHistoryMutation";
    readonly workHistorySummary?: {
      readonly __typename: "WorkHistorySummaryNode";
      readonly id: number;
      readonly summary: string;
      readonly modifiedSummary?: string | null;
      readonly meetingCount: number;
      readonly meetingTimeHours: number;
      readonly created: string;
      readonly summaryStartDate: string;
      readonly summaryEndDate: string;
      readonly externalEventData: any;
      readonly externalEventDataSummaries: any;
      readonly subject?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      } | null;
      readonly collaborators: {
        readonly __typename: "WorkHistoryCollaborationConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "WorkHistoryCollaborationEdge";
          readonly node?: {
            readonly __typename: "WorkHistoryCollaborationNode";
            readonly collaborationCount: number;
            readonly user?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          } | null;
        } | null>;
      };
      readonly sections: {
        readonly __typename: "WorkHistorySummarySectionNodeConnection";
        readonly edges: ReadonlyArray<{
          readonly __typename: "WorkHistorySummarySectionNodeEdge";
          readonly node?: {
            readonly __typename: "WorkHistorySummarySectionNode";
            readonly id: number;
            readonly title: string;
            readonly modifiedTitle?: string | null;
            readonly content: string;
            readonly modifiedContent?: string | null;
            readonly hidden: boolean;
          } | null;
        } | null>;
      };
    } | null;
  } | null;
};

export type UpdateTopicQueryVariables = Exact<{
  topicId: Scalars["Int"]["input"];
}>;

export type UpdateTopicQuery = {
  readonly __typename: "Query";
  readonly topic?: {
    readonly __typename: "TopicNode";
    readonly clientId?: number | null;
    readonly id: number;
  } | null;
};

export type GetUserRolesQueryQueryVariables = Exact<{
  userIds: ReadonlyArray<Scalars["Int"]["input"]> | Scalars["Int"]["input"];
}>;

export type GetUserRolesQueryQuery = {
  readonly __typename: "Query";
  readonly users: {
    readonly __typename: "UserNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "UserNodeEdge";
      readonly node?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly currentRoles: ReadonlyArray<{
          readonly __typename: "CareerTrackRoleNode";
          readonly id: number;
          readonly title: string;
        }>;
      } | null;
    } | null>;
  };
};

export type GetHubspotStagesQueryQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetHubspotStagesQueryQuery = {
  readonly __typename: "Query";
  readonly hubspotPipelineStages?: {
    readonly __typename: "HubspotStageConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "HubspotStageEdge";
      readonly node?: {
        readonly __typename: "HubspotStageNode";
        readonly id: number;
        readonly stageName?: string | null;
        readonly pipelineName?: string | null;
      } | null;
    } | null>;
  } | null;
};

export type GetOrganizationLocationsQueryQueryVariables = Exact<{
  organizationId: Scalars["Int"]["input"];
}>;

export type GetOrganizationLocationsQueryQuery = {
  readonly __typename: "Query";
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
    readonly availableLocations: ReadonlyArray<string | null>;
  } | null;
};

export type UserComboboxTeamOptionFragment = {
  readonly __typename: "TeamNode";
  readonly id: number;
  readonly title: string;
};

export type UserComboboxUserOptionFragment = {
  readonly __typename: "UserNode";
  readonly id: number;
  readonly name: string;
  readonly firstName: string;
  readonly email: string;
  readonly avatar?: string | null;
  readonly activeAssessmentNominationCount?: number;
  readonly membershipStatus?: AccountToOrganizationMembershipStatus | null;
};

export type GetUserComboboxOptionsQueryQueryVariables = Exact<{
  userId: Scalars["Int"]["input"];
  hasUserId: Scalars["Boolean"]["input"];
  teamId: Scalars["Int"]["input"];
  hasTeamId: Scalars["Boolean"]["input"];
  search?: InputMaybe<Scalars["String"]["input"]>;
  limitUser: Scalars["Int"]["input"];
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeUserIds?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  excludeTeamIds?: InputMaybe<
    | ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  showActiveAssessmentNominationCount: Scalars["Boolean"]["input"];
  includeDeactivated?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type GetUserComboboxOptionsQueryQuery = {
  readonly __typename: "Query";
  readonly users: {
    readonly __typename: "UserNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "UserNodeEdge";
      readonly node?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly firstName: string;
        readonly email: string;
        readonly avatar?: string | null;
        readonly activeAssessmentNominationCount?: number;
        readonly membershipStatus?: AccountToOrganizationMembershipStatus | null;
      } | null;
    } | null>;
  };
  readonly teams: {
    readonly __typename: "TeamNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "TeamNodeEdge";
      readonly node?: {
        readonly __typename: "TeamNode";
        readonly id: number;
        readonly title: string;
      } | null;
    } | null>;
  };
  readonly team?: {
    readonly __typename: "TeamNode";
    readonly id: number;
    readonly title: string;
  } | null;
  readonly user?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly firstName: string;
    readonly email: string;
    readonly avatar?: string | null;
    readonly activeAssessmentNominationCount?: number;
    readonly membershipStatus?: AccountToOrganizationMembershipStatus | null;
  } | null;
};

type WysiwygArtifactFragment_ActionItemArtifactNode_Fragment = {
  readonly __typename: "ActionItemArtifactNode";
  readonly isComplete?: boolean | null;
  readonly actionItemState?: number | null;
  readonly dueDate?: string | null;
  readonly id: number;
  readonly uuid?: string | null;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly websocketToken?: string | null;
  readonly description?: any | null;
  readonly assignee?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly avatar?: string | null;
    readonly name: string;
  } | null;
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canRead: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
};

type WysiwygArtifactFragment_AsanaTaskArtifactNode_Fragment = {
  readonly __typename: "AsanaTaskArtifactNode";
  readonly id: number;
  readonly uuid?: string | null;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly websocketToken?: string | null;
  readonly description?: any | null;
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canRead: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
};

type WysiwygArtifactFragment_DecisionArtifactNode_Fragment = {
  readonly __typename: "DecisionArtifactNode";
  readonly decision: string;
  readonly decisionState?: DecisionState | null;
  readonly isDraft?: boolean | null;
  readonly id: number;
  readonly uuid?: string | null;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly websocketToken?: string | null;
  readonly description?: any | null;
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canRead: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
};

type WysiwygArtifactFragment_DocumentArtifactNode_Fragment = {
  readonly __typename: "DocumentArtifactNode";
  readonly documentVisibility?: DocumentVisibility | null;
  readonly id: number;
  readonly uuid?: string | null;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly websocketToken?: string | null;
  readonly description?: any | null;
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canRead: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
};

type WysiwygArtifactFragment_FeedbackArtifactNode_Fragment = {
  readonly __typename: "FeedbackArtifactNode";
  readonly id: number;
  readonly uuid?: string | null;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly websocketToken?: string | null;
  readonly description?: any | null;
  readonly sender: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
  };
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canRead: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
};

type WysiwygArtifactFragment_GithubIssuesArtifactNode_Fragment = {
  readonly __typename: "GithubIssuesArtifactNode";
  readonly id: number;
  readonly uuid?: string | null;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly websocketToken?: string | null;
  readonly description?: any | null;
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canRead: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
};

type WysiwygArtifactFragment_GoalArtifactNode_Fragment = {
  readonly __typename: "GoalArtifactNode";
  readonly currentUserIsOwner?: boolean | null;
  readonly id: number;
  readonly uuid?: string | null;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly websocketToken?: string | null;
  readonly description?: any | null;
  readonly startValue: number;
  readonly currentValue: number;
  readonly targetValue: number;
  readonly progress: number;
  readonly progressType: GoalProgressType;
  readonly dueDate?: string | null;
  readonly startDate?: string | null;
  readonly state: GoalState;
  readonly status: GoalStatus;
  readonly scope: GoalScope;
  readonly goalVisibility: GoalVisibility;
  readonly created: string;
  readonly parentGoalId?: number | null;
  readonly ownerCount?: number | null;
  readonly contributorCount?: number | null;
  readonly isStale: boolean;
  readonly updated?: string | null;
  readonly activities: {
    readonly __typename: "ArtifactActivityNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "ArtifactActivityNodeEdge";
      readonly node?: {
        readonly __typename: "ArtifactActivityNode";
        readonly id: number;
        readonly created: string;
        readonly activityType: ArtifactActivityType;
        readonly canDelete?: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
          readonly reason: string;
        } | null;
        readonly canUpdate?: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
          readonly reason: string;
        } | null;
        readonly actor?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly changedFields?: ReadonlyArray<{
          readonly __typename: "ArtifactChangedFieldNode";
          readonly fieldName?: string | null;
          readonly previousValue?: string | null;
          readonly newValue?: string | null;
          readonly changedFields?: ReadonlyArray<{
            readonly __typename: "ArtifactChangedFieldNode";
            readonly newValue?: string | null;
            readonly previousValue?: string | null;
            readonly fieldName?: string | null;
          } | null> | null;
          readonly newValueObject?:
            | {
                readonly __typename: "BaseArtifactNode";
                readonly id: number;
                readonly title: string;
                readonly artifactType: ArtifactType;
              }
            | {
                readonly __typename: "CareerTrackRoleNode";
                readonly id: number;
                readonly title: string;
              }
            | {
                readonly __typename: "CommentNode";
                readonly id: number;
                readonly comment?: any | null;
                readonly deleted?: boolean | null;
                readonly creator?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly name: string;
                  readonly avatar?: string | null;
                } | null;
              }
            | {
                readonly __typename: "CompetencyNode";
                readonly id: number;
                readonly title: string;
              }
            | {
                readonly __typename: "KeyResultNode";
                readonly id: number;
                readonly title: string;
              }
            | {
                readonly __typename: "TopicNode";
                readonly id: number;
                readonly title: string;
                readonly meeting?: {
                  readonly __typename: "MeetingNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly meetingGroupId: number;
                } | null;
              }
            | {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              }
            | null;
          readonly previousValueObject?:
            | {
                readonly __typename: "BaseArtifactNode";
                readonly id: number;
                readonly title: string;
                readonly artifactType: ArtifactType;
              }
            | {
                readonly __typename: "CareerTrackRoleNode";
                readonly id: number;
                readonly title: string;
              }
            | { readonly __typename: "CommentNode" }
            | {
                readonly __typename: "CompetencyNode";
                readonly id: number;
                readonly title: string;
              }
            | {
                readonly __typename: "KeyResultNode";
                readonly id: number;
                readonly title: string;
              }
            | {
                readonly __typename: "TopicNode";
                readonly id: number;
                readonly title: string;
                readonly meeting?: {
                  readonly __typename: "MeetingNode";
                  readonly id: number;
                  readonly title?: string | null;
                  readonly meetingGroupId: number;
                } | null;
              }
            | {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              }
            | null;
        } | null> | null;
      } | null;
    } | null>;
  };
  readonly keyResults: {
    readonly __typename: "KeyResultNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "KeyResultNodeEdge";
      readonly node?: {
        readonly __typename: "KeyResultNode";
        readonly id: number;
        readonly title: string;
        readonly startValue: number;
        readonly currentValue: number;
        readonly targetValue: number;
        readonly progressType: GoalProgressType;
        readonly kpi?: {
          readonly __typename: "KPINode";
          readonly id: number;
          readonly title: string;
          readonly currentMeasurement?: {
            readonly __typename: "KPIMeasurementNode";
            readonly id: number;
            readonly measurement: number;
          } | null;
        } | null;
        readonly canUpdate?: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        } | null;
        readonly assignee?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
          readonly email: string;
        } | null;
      } | null;
    } | null>;
  };
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canRead: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly firstOwner?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly avatar?: string | null;
    readonly name: string;
  } | null;
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
};

type WysiwygArtifactFragment_KpiArtifactNode_Fragment = {
  readonly __typename: "KPIArtifactNode";
  readonly id: number;
  readonly uuid?: string | null;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly websocketToken?: string | null;
  readonly description?: any | null;
  readonly measurement?: {
    readonly __typename: "KPIMeasurementNode";
    readonly id: number;
    readonly kpi?: {
      readonly __typename: "KPINode";
      readonly id: number;
      readonly title: string;
    } | null;
  } | null;
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canRead: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
};

type WysiwygArtifactFragment_RatingArtifactNode_Fragment = {
  readonly __typename: "RatingArtifactNode";
  readonly canAnswer?: boolean | null;
  readonly canViewAnswers?: boolean | null;
  readonly id: number;
  readonly uuid?: string | null;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly websocketToken?: string | null;
  readonly description?: any | null;
  readonly answers?: {
    readonly __typename: "RatingAnswerNodeConnection";
    readonly totalCount?: number | null;
    readonly edges: ReadonlyArray<{
      readonly __typename: "RatingAnswerNodeEdge";
      readonly node?: {
        readonly __typename: "RatingAnswerNode";
        readonly id: number;
        readonly integerAnswer: number;
        readonly creator: {
          readonly __typename: "UserNode";
          readonly id: number;
        };
      } | null;
    } | null>;
  } | null;
  readonly rating?: {
    readonly __typename: "RatingNode";
    readonly id: number;
    readonly title: string;
    readonly description: any;
    readonly startValue: number;
    readonly endValue: number;
    readonly labels: ReadonlyArray<string | null>;
  } | null;
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canRead: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
};

type WysiwygArtifactFragment_RecognitionArtifactNode_Fragment = {
  readonly __typename: "RecognitionArtifactNode";
  readonly id: number;
  readonly uuid?: string | null;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly websocketToken?: string | null;
  readonly description?: any | null;
  readonly created: string;
  readonly organization?: {
    readonly __typename: "OrganizationNode";
    readonly id: number;
  } | null;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canRead: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
  readonly recipients?: {
    readonly __typename: "UserNodeConnection";
    readonly totalCount: number;
    readonly edges: ReadonlyArray<{
      readonly __typename: "UserNodeEdge";
      readonly node?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      } | null;
    } | null>;
  } | null;
  readonly recognitionCoreValue?: {
    readonly __typename: "RecognitionCoreValueNode";
    readonly id: number;
    readonly title: string;
    readonly description: string;
    readonly emoji?: string | null;
    readonly image?: string | null;
  } | null;
};

export type WysiwygArtifactFragmentFragment =
  | WysiwygArtifactFragment_ActionItemArtifactNode_Fragment
  | WysiwygArtifactFragment_AsanaTaskArtifactNode_Fragment
  | WysiwygArtifactFragment_DecisionArtifactNode_Fragment
  | WysiwygArtifactFragment_DocumentArtifactNode_Fragment
  | WysiwygArtifactFragment_FeedbackArtifactNode_Fragment
  | WysiwygArtifactFragment_GithubIssuesArtifactNode_Fragment
  | WysiwygArtifactFragment_GoalArtifactNode_Fragment
  | WysiwygArtifactFragment_KpiArtifactNode_Fragment
  | WysiwygArtifactFragment_RatingArtifactNode_Fragment
  | WysiwygArtifactFragment_RecognitionArtifactNode_Fragment;

export type AssociateArtifactWithTopicOrArtifactMutationMutationVariables =
  Exact<{
    artifactId: Scalars["Int"]["input"];
    topicId?: InputMaybe<Scalars["Int"]["input"]>;
    otherArtifactId?: InputMaybe<Scalars["Int"]["input"]>;
  }>;

export type AssociateArtifactWithTopicOrArtifactMutationMutation = {
  readonly __typename: "Mutation";
  readonly associateArtifactWithTopicOrArtifact?: {
    readonly __typename: "AssociateArtifactWithTopicOrArtifactMutation";
    readonly artifact?:
      | { readonly __typename: "ActionItemArtifactNode"; readonly id: number }
      | { readonly __typename: "AsanaTaskArtifactNode"; readonly id: number }
      | { readonly __typename: "DecisionArtifactNode"; readonly id: number }
      | { readonly __typename: "DocumentArtifactNode"; readonly id: number }
      | { readonly __typename: "FeedbackArtifactNode"; readonly id: number }
      | { readonly __typename: "GithubIssuesArtifactNode"; readonly id: number }
      | { readonly __typename: "GoalArtifactNode"; readonly id: number }
      | { readonly __typename: "KPIArtifactNode"; readonly id: number }
      | { readonly __typename: "RatingArtifactNode"; readonly id: number }
      | { readonly __typename: "RecognitionArtifactNode"; readonly id: number }
      | null;
  } | null;
};

export type CreateAsanaArtifactMutationMutationVariables = Exact<{
  additionalFields?: InputMaybe<AdditionalArtifactInput>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  relatedTopicId?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  relatedArtifactId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type CreateAsanaArtifactMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateArtifact?: {
    readonly __typename: "CreateOrUpdateArtifactMutation";
    readonly artifact?:
      | { readonly __typename: "ActionItemArtifactNode" }
      | {
          readonly __typename: "AsanaTaskArtifactNode";
          readonly id: number;
          readonly title?: string | null;
          readonly isSynced?: boolean | null;
          readonly completedAt?: string | null;
          readonly dueDate?: string | null;
          readonly assignee?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
          } | null;
        }
      | { readonly __typename: "DecisionArtifactNode" }
      | { readonly __typename: "DocumentArtifactNode" }
      | { readonly __typename: "FeedbackArtifactNode" }
      | { readonly __typename: "GithubIssuesArtifactNode" }
      | { readonly __typename: "GoalArtifactNode" }
      | { readonly __typename: "KPIArtifactNode" }
      | { readonly __typename: "RatingArtifactNode" }
      | { readonly __typename: "RecognitionArtifactNode" }
      | null;
  } | null;
};

export type UpdateArtifactMutationMutationVariables = Exact<{
  additionalFields?: InputMaybe<AdditionalArtifactInput>;
  artifactId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactType?: InputMaybe<ArtifactType>;
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  relatedTopicId?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  relatedArtifactId?: InputMaybe<Scalars["Int"]["input"]>;
  uuid?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type UpdateArtifactMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateArtifact?: {
    readonly __typename: "CreateOrUpdateArtifactMutation";
    readonly artifact?:
      | {
          readonly __typename: "ActionItemArtifactNode";
          readonly isComplete?: boolean | null;
          readonly actionItemState?: number | null;
          readonly dueDate?: string | null;
          readonly id: number;
          readonly uuid?: string | null;
          readonly title?: string | null;
          readonly artifactType: ArtifactType;
          readonly websocketToken?: string | null;
          readonly description?: any | null;
          readonly assignee?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly avatar?: string | null;
            readonly name: string;
          } | null;
          readonly organization?: {
            readonly __typename: "OrganizationNode";
            readonly id: number;
          } | null;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canUpdate: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canRead: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
        }
      | {
          readonly __typename: "AsanaTaskArtifactNode";
          readonly id: number;
          readonly uuid?: string | null;
          readonly title?: string | null;
          readonly artifactType: ArtifactType;
          readonly websocketToken?: string | null;
          readonly description?: any | null;
          readonly organization?: {
            readonly __typename: "OrganizationNode";
            readonly id: number;
          } | null;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canUpdate: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canRead: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
        }
      | {
          readonly __typename: "DecisionArtifactNode";
          readonly decision: string;
          readonly decisionState?: DecisionState | null;
          readonly isDraft?: boolean | null;
          readonly id: number;
          readonly uuid?: string | null;
          readonly title?: string | null;
          readonly artifactType: ArtifactType;
          readonly websocketToken?: string | null;
          readonly description?: any | null;
          readonly organization?: {
            readonly __typename: "OrganizationNode";
            readonly id: number;
          } | null;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canUpdate: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canRead: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
        }
      | {
          readonly __typename: "DocumentArtifactNode";
          readonly documentVisibility?: DocumentVisibility | null;
          readonly id: number;
          readonly uuid?: string | null;
          readonly title?: string | null;
          readonly artifactType: ArtifactType;
          readonly websocketToken?: string | null;
          readonly description?: any | null;
          readonly organization?: {
            readonly __typename: "OrganizationNode";
            readonly id: number;
          } | null;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canUpdate: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canRead: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
        }
      | {
          readonly __typename: "FeedbackArtifactNode";
          readonly id: number;
          readonly uuid?: string | null;
          readonly title?: string | null;
          readonly artifactType: ArtifactType;
          readonly websocketToken?: string | null;
          readonly description?: any | null;
          readonly sender: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
          };
          readonly organization?: {
            readonly __typename: "OrganizationNode";
            readonly id: number;
          } | null;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canUpdate: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canRead: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
        }
      | {
          readonly __typename: "GithubIssuesArtifactNode";
          readonly id: number;
          readonly uuid?: string | null;
          readonly title?: string | null;
          readonly artifactType: ArtifactType;
          readonly websocketToken?: string | null;
          readonly description?: any | null;
          readonly organization?: {
            readonly __typename: "OrganizationNode";
            readonly id: number;
          } | null;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canUpdate: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canRead: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
        }
      | {
          readonly __typename: "GoalArtifactNode";
          readonly currentUserIsOwner?: boolean | null;
          readonly id: number;
          readonly uuid?: string | null;
          readonly title?: string | null;
          readonly artifactType: ArtifactType;
          readonly websocketToken?: string | null;
          readonly description?: any | null;
          readonly startValue: number;
          readonly currentValue: number;
          readonly targetValue: number;
          readonly progress: number;
          readonly progressType: GoalProgressType;
          readonly dueDate?: string | null;
          readonly startDate?: string | null;
          readonly state: GoalState;
          readonly status: GoalStatus;
          readonly scope: GoalScope;
          readonly goalVisibility: GoalVisibility;
          readonly created: string;
          readonly parentGoalId?: number | null;
          readonly ownerCount?: number | null;
          readonly contributorCount?: number | null;
          readonly isStale: boolean;
          readonly updated?: string | null;
          readonly activities: {
            readonly __typename: "ArtifactActivityNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "ArtifactActivityNodeEdge";
              readonly node?: {
                readonly __typename: "ArtifactActivityNode";
                readonly id: number;
                readonly created: string;
                readonly activityType: ArtifactActivityType;
                readonly canDelete?: {
                  readonly __typename: "PermissionNode";
                  readonly permission: boolean;
                  readonly reason: string;
                } | null;
                readonly canUpdate?: {
                  readonly __typename: "PermissionNode";
                  readonly permission: boolean;
                  readonly reason: string;
                } | null;
                readonly actor?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly name: string;
                  readonly avatar?: string | null;
                } | null;
                readonly changedFields?: ReadonlyArray<{
                  readonly __typename: "ArtifactChangedFieldNode";
                  readonly fieldName?: string | null;
                  readonly previousValue?: string | null;
                  readonly newValue?: string | null;
                  readonly changedFields?: ReadonlyArray<{
                    readonly __typename: "ArtifactChangedFieldNode";
                    readonly newValue?: string | null;
                    readonly previousValue?: string | null;
                    readonly fieldName?: string | null;
                  } | null> | null;
                  readonly newValueObject?:
                    | {
                        readonly __typename: "BaseArtifactNode";
                        readonly id: number;
                        readonly title: string;
                        readonly artifactType: ArtifactType;
                      }
                    | {
                        readonly __typename: "CareerTrackRoleNode";
                        readonly id: number;
                        readonly title: string;
                      }
                    | {
                        readonly __typename: "CommentNode";
                        readonly id: number;
                        readonly comment?: any | null;
                        readonly deleted?: boolean | null;
                        readonly creator?: {
                          readonly __typename: "UserNode";
                          readonly id: number;
                          readonly name: string;
                          readonly avatar?: string | null;
                        } | null;
                      }
                    | {
                        readonly __typename: "CompetencyNode";
                        readonly id: number;
                        readonly title: string;
                      }
                    | {
                        readonly __typename: "KeyResultNode";
                        readonly id: number;
                        readonly title: string;
                      }
                    | {
                        readonly __typename: "TopicNode";
                        readonly id: number;
                        readonly title: string;
                        readonly meeting?: {
                          readonly __typename: "MeetingNode";
                          readonly id: number;
                          readonly title?: string | null;
                          readonly meetingGroupId: number;
                        } | null;
                      }
                    | {
                        readonly __typename: "UserNode";
                        readonly id: number;
                        readonly name: string;
                        readonly avatar?: string | null;
                      }
                    | null;
                  readonly previousValueObject?:
                    | {
                        readonly __typename: "BaseArtifactNode";
                        readonly id: number;
                        readonly title: string;
                        readonly artifactType: ArtifactType;
                      }
                    | {
                        readonly __typename: "CareerTrackRoleNode";
                        readonly id: number;
                        readonly title: string;
                      }
                    | { readonly __typename: "CommentNode" }
                    | {
                        readonly __typename: "CompetencyNode";
                        readonly id: number;
                        readonly title: string;
                      }
                    | {
                        readonly __typename: "KeyResultNode";
                        readonly id: number;
                        readonly title: string;
                      }
                    | {
                        readonly __typename: "TopicNode";
                        readonly id: number;
                        readonly title: string;
                        readonly meeting?: {
                          readonly __typename: "MeetingNode";
                          readonly id: number;
                          readonly title?: string | null;
                          readonly meetingGroupId: number;
                        } | null;
                      }
                    | {
                        readonly __typename: "UserNode";
                        readonly id: number;
                        readonly name: string;
                        readonly avatar?: string | null;
                      }
                    | null;
                } | null> | null;
              } | null;
            } | null>;
          };
          readonly keyResults: {
            readonly __typename: "KeyResultNodeConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "KeyResultNodeEdge";
              readonly node?: {
                readonly __typename: "KeyResultNode";
                readonly id: number;
                readonly title: string;
                readonly startValue: number;
                readonly currentValue: number;
                readonly targetValue: number;
                readonly progressType: GoalProgressType;
                readonly kpi?: {
                  readonly __typename: "KPINode";
                  readonly id: number;
                  readonly title: string;
                  readonly currentMeasurement?: {
                    readonly __typename: "KPIMeasurementNode";
                    readonly id: number;
                    readonly measurement: number;
                  } | null;
                } | null;
                readonly canUpdate?: {
                  readonly __typename: "PermissionNode";
                  readonly permission: boolean;
                } | null;
                readonly assignee?: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                  readonly name: string;
                  readonly avatar?: string | null;
                  readonly email: string;
                } | null;
              } | null;
            } | null>;
          };
          readonly organization?: {
            readonly __typename: "OrganizationNode";
            readonly id: number;
          } | null;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canUpdate: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canRead: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly firstOwner?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly avatar?: string | null;
            readonly name: string;
          } | null;
          readonly creator?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
        }
      | {
          readonly __typename: "KPIArtifactNode";
          readonly id: number;
          readonly uuid?: string | null;
          readonly title?: string | null;
          readonly artifactType: ArtifactType;
          readonly websocketToken?: string | null;
          readonly description?: any | null;
          readonly measurement?: {
            readonly __typename: "KPIMeasurementNode";
            readonly id: number;
            readonly kpi?: {
              readonly __typename: "KPINode";
              readonly id: number;
              readonly title: string;
            } | null;
          } | null;
          readonly organization?: {
            readonly __typename: "OrganizationNode";
            readonly id: number;
          } | null;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canUpdate: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canRead: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
        }
      | {
          readonly __typename: "RatingArtifactNode";
          readonly canAnswer?: boolean | null;
          readonly canViewAnswers?: boolean | null;
          readonly id: number;
          readonly uuid?: string | null;
          readonly title?: string | null;
          readonly artifactType: ArtifactType;
          readonly websocketToken?: string | null;
          readonly description?: any | null;
          readonly answers?: {
            readonly __typename: "RatingAnswerNodeConnection";
            readonly totalCount?: number | null;
            readonly edges: ReadonlyArray<{
              readonly __typename: "RatingAnswerNodeEdge";
              readonly node?: {
                readonly __typename: "RatingAnswerNode";
                readonly id: number;
                readonly integerAnswer: number;
                readonly creator: {
                  readonly __typename: "UserNode";
                  readonly id: number;
                };
              } | null;
            } | null>;
          } | null;
          readonly rating?: {
            readonly __typename: "RatingNode";
            readonly id: number;
            readonly title: string;
            readonly description: any;
            readonly startValue: number;
            readonly endValue: number;
            readonly labels: ReadonlyArray<string | null>;
          } | null;
          readonly organization?: {
            readonly __typename: "OrganizationNode";
            readonly id: number;
          } | null;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canUpdate: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canRead: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
        }
      | {
          readonly __typename: "RecognitionArtifactNode";
          readonly id: number;
          readonly uuid?: string | null;
          readonly title?: string | null;
          readonly artifactType: ArtifactType;
          readonly websocketToken?: string | null;
          readonly description?: any | null;
          readonly created: string;
          readonly organization?: {
            readonly __typename: "OrganizationNode";
            readonly id: number;
          } | null;
          readonly canDelete: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canUpdate: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly canRead: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
          };
          readonly creator?: {
            readonly __typename: "UserNode";
            readonly id: number;
            readonly name: string;
            readonly avatar?: string | null;
          } | null;
          readonly recipients?: {
            readonly __typename: "UserNodeConnection";
            readonly totalCount: number;
            readonly edges: ReadonlyArray<{
              readonly __typename: "UserNodeEdge";
              readonly node?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
            } | null>;
          } | null;
          readonly recognitionCoreValue?: {
            readonly __typename: "RecognitionCoreValueNode";
            readonly id: number;
            readonly title: string;
            readonly description: string;
            readonly emoji?: string | null;
            readonly image?: string | null;
          } | null;
        }
      | null;
  } | null;
};

export type AsanaArtifactFragmentFragment = {
  readonly __typename: "AsanaTaskArtifactNode";
  readonly id: number;
  readonly title?: string | null;
  readonly isSynced?: boolean | null;
  readonly completedAt?: string | null;
  readonly dueDate?: string | null;
  readonly assignee?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
  } | null;
};

export type GetAsanaArtifactQueryQueryVariables = Exact<{
  id: Scalars["Int"]["input"];
}>;

export type GetAsanaArtifactQueryQuery = {
  readonly __typename: "Query";
  readonly artifact:
    | { readonly __typename: "ActionItemArtifactNode" }
    | {
        readonly __typename: "AsanaTaskArtifactNode";
        readonly id: number;
        readonly title?: string | null;
        readonly isSynced?: boolean | null;
        readonly completedAt?: string | null;
        readonly dueDate?: string | null;
        readonly assignee?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
        } | null;
      }
    | { readonly __typename: "DecisionArtifactNode" }
    | { readonly __typename: "DocumentArtifactNode" }
    | { readonly __typename: "FeedbackArtifactNode" }
    | { readonly __typename: "GithubIssuesArtifactNode" }
    | { readonly __typename: "GoalArtifactNode" }
    | { readonly __typename: "KPIArtifactNode" }
    | { readonly __typename: "RatingArtifactNode" }
    | { readonly __typename: "RecognitionArtifactNode" };
};

export type GetEmbedKpiGroupQueryQueryVariables = Exact<{
  kpiGroupId: Scalars["Int"]["input"];
  teamId: Scalars["Int"]["input"];
  hasTeamId: Scalars["Boolean"]["input"];
  summaryPeriod?: InputMaybe<KpiSummaryPeriod>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetEmbedKpiGroupQueryQuery = {
  readonly __typename: "Query";
  readonly kpiGroup?: {
    readonly __typename: "KPIGroupNode";
    readonly id: number;
    readonly title: string;
    readonly kpis?: {
      readonly __typename: "KPINodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "KPINodeEdge";
        readonly node?: {
          readonly __typename: "KPINode";
          readonly id: number;
          readonly title: string;
          readonly created: string;
          readonly targetType: KpiTargetType;
          readonly targetValue?: number | null;
          readonly targetCondition: KpiTargetCondition;
          readonly defaultSummaryPeriod: KpiSummaryPeriod;
          readonly canUpdate: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
            readonly reason: string;
          };
          readonly currentMeasurement?: {
            readonly __typename: "KPIMeasurementNode";
            readonly id: number;
            readonly measurement: number;
          } | null;
          readonly summarizedMeasurements: {
            readonly __typename: "SummarizedMeasurementsConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "SummarizedMeasurementsEdge";
              readonly node?: {
                readonly __typename: "SummarizedMeasurements";
                readonly aggregateMeasurementId?: string | null;
                readonly aggregateMeasurement?: number | null;
                readonly date?: string | null;
              } | null;
            } | null>;
          };
        } | null;
      } | null>;
    } | null;
  } | null;
  readonly team?: {
    readonly __typename: "TeamNode";
    readonly id: number;
    readonly title: string;
    readonly kpis?: {
      readonly __typename: "KPINodeConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "KPINodeEdge";
        readonly node?: {
          readonly __typename: "KPINode";
          readonly id: number;
          readonly title: string;
          readonly created: string;
          readonly targetType: KpiTargetType;
          readonly targetValue?: number | null;
          readonly targetCondition: KpiTargetCondition;
          readonly defaultSummaryPeriod: KpiSummaryPeriod;
          readonly canUpdate: {
            readonly __typename: "PermissionNode";
            readonly permission: boolean;
            readonly reason: string;
          };
          readonly currentMeasurement?: {
            readonly __typename: "KPIMeasurementNode";
            readonly id: number;
            readonly measurement: number;
          } | null;
          readonly summarizedMeasurements: {
            readonly __typename: "SummarizedMeasurementsConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "SummarizedMeasurementsEdge";
              readonly node?: {
                readonly __typename: "SummarizedMeasurements";
                readonly aggregateMeasurementId?: string | null;
                readonly aggregateMeasurement?: number | null;
                readonly date?: string | null;
              } | null;
            } | null>;
          };
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetEmbedKpiQueryQueryVariables = Exact<{
  kpiId: Scalars["Int"]["input"];
  summaryPeriod?: InputMaybe<KpiSummaryPeriod>;
  summaryMethod?: InputMaybe<KpiSummaryMethod>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetEmbedKpiQueryQuery = {
  readonly __typename: "Query";
  readonly kpi?: {
    readonly __typename: "KPINode";
    readonly id: number;
    readonly title: string;
    readonly created: string;
    readonly targetType: KpiTargetType;
    readonly targetValue?: number | null;
    readonly targetCondition: KpiTargetCondition;
    readonly defaultSummaryPeriod: KpiSummaryPeriod;
    readonly canUpdate: {
      readonly __typename: "PermissionNode";
      readonly permission: boolean;
      readonly reason: string;
    };
    readonly currentMeasurement?: {
      readonly __typename: "KPIMeasurementNode";
      readonly id: number;
      readonly measurement: number;
    } | null;
    readonly summarizedMeasurements: {
      readonly __typename: "SummarizedMeasurementsConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "SummarizedMeasurementsEdge";
        readonly node?: {
          readonly __typename: "SummarizedMeasurements";
          readonly aggregateMeasurementId?: string | null;
          readonly aggregateMeasurement?: number | null;
          readonly date?: string | null;
        } | null;
      } | null>;
    };
  } | null;
};

export type GetKpiGroupsQueryQueryVariables = Exact<{ [key: string]: never }>;

export type GetKpiGroupsQueryQuery = {
  readonly __typename: "Query";
  readonly kpiGroups?: {
    readonly __typename: "KPIGroupNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "KPIGroupNodeEdge";
      readonly node?: {
        readonly __typename: "KPIGroupNode";
        readonly id: number;
        readonly title: string;
        readonly kpis?: {
          readonly __typename: "KPINodeConnection";
          readonly totalCount: number;
        } | null;
      } | null;
    } | null>;
  } | null;
  readonly teams: {
    readonly __typename: "TeamNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "TeamNodeEdge";
      readonly node?: {
        readonly __typename: "TeamNode";
        readonly id: number;
        readonly title: string;
        readonly kpis?: {
          readonly __typename: "KPINodeConnection";
          readonly totalCount: number;
        } | null;
      } | null;
    } | null>;
  };
};

export type GetKpIsQueryQueryVariables = Exact<{ [key: string]: never }>;

export type GetKpIsQueryQuery = {
  readonly __typename: "Query";
  readonly kpis?: {
    readonly __typename: "KPINodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "KPINodeEdge";
      readonly node?: {
        readonly __typename: "KPINode";
        readonly id: number;
        readonly title: string;
        readonly description?: any | null;
      } | null;
    } | null>;
  } | null;
};

export type GetRatingsQueryQueryVariables = Exact<{ [key: string]: never }>;

export type GetRatingsQueryQuery = {
  readonly __typename: "Query";
  readonly ratings?: {
    readonly __typename: "RatingNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "RatingNodeEdge";
      readonly node?: {
        readonly __typename: "RatingNode";
        readonly id: number;
        readonly title: string;
      } | null;
    } | null>;
  } | null;
};

export type GetWysiwygArtifactQueryQueryVariables = Exact<{
  artifactId: Scalars["Int"]["input"];
}>;

export type GetWysiwygArtifactQueryQuery = {
  readonly __typename: "Query";
  readonly artifact:
    | {
        readonly __typename: "ActionItemArtifactNode";
        readonly isComplete?: boolean | null;
        readonly actionItemState?: number | null;
        readonly dueDate?: string | null;
        readonly id: number;
        readonly uuid?: string | null;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly websocketToken?: string | null;
        readonly description?: any | null;
        readonly assignee?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly avatar?: string | null;
          readonly name: string;
        } | null;
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canRead: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "AsanaTaskArtifactNode";
        readonly id: number;
        readonly uuid?: string | null;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly websocketToken?: string | null;
        readonly description?: any | null;
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canRead: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "DecisionArtifactNode";
        readonly decision: string;
        readonly decisionState?: DecisionState | null;
        readonly isDraft?: boolean | null;
        readonly id: number;
        readonly uuid?: string | null;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly websocketToken?: string | null;
        readonly description?: any | null;
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canRead: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "DocumentArtifactNode";
        readonly documentVisibility?: DocumentVisibility | null;
        readonly id: number;
        readonly uuid?: string | null;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly websocketToken?: string | null;
        readonly description?: any | null;
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canRead: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "FeedbackArtifactNode";
        readonly id: number;
        readonly uuid?: string | null;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly websocketToken?: string | null;
        readonly description?: any | null;
        readonly sender: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
        };
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canRead: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "GithubIssuesArtifactNode";
        readonly id: number;
        readonly uuid?: string | null;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly websocketToken?: string | null;
        readonly description?: any | null;
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canRead: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "GoalArtifactNode";
        readonly currentUserIsOwner?: boolean | null;
        readonly id: number;
        readonly uuid?: string | null;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly websocketToken?: string | null;
        readonly description?: any | null;
        readonly startValue: number;
        readonly currentValue: number;
        readonly targetValue: number;
        readonly progress: number;
        readonly progressType: GoalProgressType;
        readonly dueDate?: string | null;
        readonly startDate?: string | null;
        readonly state: GoalState;
        readonly status: GoalStatus;
        readonly scope: GoalScope;
        readonly goalVisibility: GoalVisibility;
        readonly created: string;
        readonly parentGoalId?: number | null;
        readonly ownerCount?: number | null;
        readonly contributorCount?: number | null;
        readonly isStale: boolean;
        readonly updated?: string | null;
        readonly activities: {
          readonly __typename: "ArtifactActivityNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "ArtifactActivityNodeEdge";
            readonly node?: {
              readonly __typename: "ArtifactActivityNode";
              readonly id: number;
              readonly created: string;
              readonly activityType: ArtifactActivityType;
              readonly canDelete?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
                readonly reason: string;
              } | null;
              readonly canUpdate?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
                readonly reason: string;
              } | null;
              readonly actor?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
              } | null;
              readonly changedFields?: ReadonlyArray<{
                readonly __typename: "ArtifactChangedFieldNode";
                readonly fieldName?: string | null;
                readonly previousValue?: string | null;
                readonly newValue?: string | null;
                readonly changedFields?: ReadonlyArray<{
                  readonly __typename: "ArtifactChangedFieldNode";
                  readonly newValue?: string | null;
                  readonly previousValue?: string | null;
                  readonly fieldName?: string | null;
                } | null> | null;
                readonly newValueObject?:
                  | {
                      readonly __typename: "BaseArtifactNode";
                      readonly id: number;
                      readonly title: string;
                      readonly artifactType: ArtifactType;
                    }
                  | {
                      readonly __typename: "CareerTrackRoleNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "CommentNode";
                      readonly id: number;
                      readonly comment?: any | null;
                      readonly deleted?: boolean | null;
                      readonly creator?: {
                        readonly __typename: "UserNode";
                        readonly id: number;
                        readonly name: string;
                        readonly avatar?: string | null;
                      } | null;
                    }
                  | {
                      readonly __typename: "CompetencyNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "KeyResultNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "TopicNode";
                      readonly id: number;
                      readonly title: string;
                      readonly meeting?: {
                        readonly __typename: "MeetingNode";
                        readonly id: number;
                        readonly title?: string | null;
                        readonly meetingGroupId: number;
                      } | null;
                    }
                  | {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    }
                  | null;
                readonly previousValueObject?:
                  | {
                      readonly __typename: "BaseArtifactNode";
                      readonly id: number;
                      readonly title: string;
                      readonly artifactType: ArtifactType;
                    }
                  | {
                      readonly __typename: "CareerTrackRoleNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | { readonly __typename: "CommentNode" }
                  | {
                      readonly __typename: "CompetencyNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "KeyResultNode";
                      readonly id: number;
                      readonly title: string;
                    }
                  | {
                      readonly __typename: "TopicNode";
                      readonly id: number;
                      readonly title: string;
                      readonly meeting?: {
                        readonly __typename: "MeetingNode";
                        readonly id: number;
                        readonly title?: string | null;
                        readonly meetingGroupId: number;
                      } | null;
                    }
                  | {
                      readonly __typename: "UserNode";
                      readonly id: number;
                      readonly name: string;
                      readonly avatar?: string | null;
                    }
                  | null;
              } | null> | null;
            } | null;
          } | null>;
        };
        readonly keyResults: {
          readonly __typename: "KeyResultNodeConnection";
          readonly edges: ReadonlyArray<{
            readonly __typename: "KeyResultNodeEdge";
            readonly node?: {
              readonly __typename: "KeyResultNode";
              readonly id: number;
              readonly title: string;
              readonly startValue: number;
              readonly currentValue: number;
              readonly targetValue: number;
              readonly progressType: GoalProgressType;
              readonly kpi?: {
                readonly __typename: "KPINode";
                readonly id: number;
                readonly title: string;
                readonly currentMeasurement?: {
                  readonly __typename: "KPIMeasurementNode";
                  readonly id: number;
                  readonly measurement: number;
                } | null;
              } | null;
              readonly canUpdate?: {
                readonly __typename: "PermissionNode";
                readonly permission: boolean;
              } | null;
              readonly assignee?: {
                readonly __typename: "UserNode";
                readonly id: number;
                readonly name: string;
                readonly avatar?: string | null;
                readonly email: string;
              } | null;
            } | null;
          } | null>;
        };
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canRead: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly firstOwner?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly avatar?: string | null;
          readonly name: string;
        } | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      }
    | {
        readonly __typename: "KPIArtifactNode";
        readonly id: number;
        readonly uuid?: string | null;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly websocketToken?: string | null;
        readonly description?: any | null;
        readonly measurement?: {
          readonly __typename: "KPIMeasurementNode";
          readonly id: number;
          readonly kpi?: {
            readonly __typename: "KPINode";
            readonly id: number;
            readonly title: string;
          } | null;
        } | null;
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canRead: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "RatingArtifactNode";
        readonly canAnswer?: boolean | null;
        readonly canViewAnswers?: boolean | null;
        readonly id: number;
        readonly uuid?: string | null;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly websocketToken?: string | null;
        readonly description?: any | null;
        readonly answers?: {
          readonly __typename: "RatingAnswerNodeConnection";
          readonly totalCount?: number | null;
          readonly edges: ReadonlyArray<{
            readonly __typename: "RatingAnswerNodeEdge";
            readonly node?: {
              readonly __typename: "RatingAnswerNode";
              readonly id: number;
              readonly integerAnswer: number;
              readonly creator: {
                readonly __typename: "UserNode";
                readonly id: number;
              };
            } | null;
          } | null>;
        } | null;
        readonly rating?: {
          readonly __typename: "RatingNode";
          readonly id: number;
          readonly title: string;
          readonly description: any;
          readonly startValue: number;
          readonly endValue: number;
          readonly labels: ReadonlyArray<string | null>;
        } | null;
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canRead: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
      }
    | {
        readonly __typename: "RecognitionArtifactNode";
        readonly id: number;
        readonly uuid?: string | null;
        readonly title?: string | null;
        readonly artifactType: ArtifactType;
        readonly websocketToken?: string | null;
        readonly description?: any | null;
        readonly created: string;
        readonly organization?: {
          readonly __typename: "OrganizationNode";
          readonly id: number;
        } | null;
        readonly canDelete: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canUpdate: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly canRead: {
          readonly __typename: "PermissionNode";
          readonly permission: boolean;
        };
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
        readonly recipients?: {
          readonly __typename: "UserNodeConnection";
          readonly totalCount: number;
          readonly edges: ReadonlyArray<{
            readonly __typename: "UserNodeEdge";
            readonly node?: {
              readonly __typename: "UserNode";
              readonly id: number;
              readonly name: string;
              readonly avatar?: string | null;
            } | null;
          } | null>;
        } | null;
        readonly recognitionCoreValue?: {
          readonly __typename: "RecognitionCoreValueNode";
          readonly id: number;
          readonly title: string;
          readonly description: string;
          readonly emoji?: string | null;
          readonly image?: string | null;
        } | null;
      };
};

export type CreateNoteCommentMutationMutationVariables = Exact<{
  uuid: Scalars["String"]["input"];
  comment: Scalars["String"]["input"];
  topicId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type CreateNoteCommentMutationMutation = {
  readonly __typename: "Mutation";
  readonly createOrUpdateComment?: {
    readonly __typename: "CreateOrUpdateCommentMutation";
    readonly comment?: {
      readonly __typename: "CommentNode";
      readonly id: number;
      readonly created: string;
      readonly comment?: any | null;
      readonly creator?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      } | null;
    } | null;
  } | null;
};

export type GetInlineCommentsQueryQueryVariables = Exact<{
  uuid: Scalars["String"]["input"];
}>;

export type GetInlineCommentsQueryQuery = {
  readonly __typename: "Query";
  readonly me?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly avatar?: string | null;
    readonly name: string;
  } | null;
  readonly comments?: {
    readonly __typename: "CommentNodeConnection";
    readonly totalCount: number;
    readonly edges: ReadonlyArray<{
      readonly __typename: "CommentNodeEdge";
      readonly node?: {
        readonly __typename: "CommentNode";
        readonly id: number;
        readonly created: string;
        readonly comment?: any | null;
        readonly creator?: {
          readonly __typename: "UserNode";
          readonly id: number;
          readonly name: string;
          readonly avatar?: string | null;
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type GetMeetingEmbedQueryQueryVariables = Exact<{
  meetingId: Scalars["Int"]["input"];
}>;

export type GetMeetingEmbedQueryQuery = {
  readonly __typename: "Query";
  readonly meeting?: {
    readonly __typename: "MeetingNode";
    readonly id: number;
    readonly title?: string | null;
    readonly startDatetime?: string | null;
    readonly meetingGroupId: number;
  } | null;
};

export type GetUrlPreviewQueryVariables = Exact<{
  url: Scalars["String"]["input"];
  forceRefresh?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type GetUrlPreviewQuery = {
  readonly __typename: "Query";
  readonly urlToInfoCard:
    | {
        readonly __typename: "ClickupTaskNode";
        readonly id: number;
        readonly title: string;
        readonly url: string;
        readonly providerName?: string | null;
        readonly closedAt?: string | null;
        readonly assignees: ReadonlyArray<{
          readonly __typename: "ExternalProfileNode";
          readonly username?: string | null;
          readonly url?: string | null;
        } | null>;
      }
    | {
        readonly __typename: "GithubIssueNode";
        readonly isMerged?: boolean | null;
        readonly status?: InfoTaskStatus | null;
        readonly id: number;
        readonly title: string;
        readonly url: string;
        readonly providerName?: string | null;
        readonly closedAt?: string | null;
        readonly assignees: ReadonlyArray<{
          readonly __typename: "ExternalProfileNode";
          readonly username?: string | null;
          readonly url?: string | null;
        } | null>;
      }
    | {
        readonly __typename: "HubspotDealNode";
        readonly amount?: number | null;
        readonly closedWon?: boolean | null;
        readonly stageName?: string | null;
        readonly id: number;
        readonly title: string;
        readonly url: string;
        readonly providerName?: string | null;
        readonly closedAt?: string | null;
        readonly assignees: ReadonlyArray<{
          readonly __typename: "ExternalProfileNode";
          readonly username?: string | null;
          readonly url?: string | null;
        } | null>;
      }
    | {
        readonly __typename: "JiraIssueNode";
        readonly id: number;
        readonly title: string;
        readonly url: string;
        readonly providerName?: string | null;
        readonly closedAt?: string | null;
        readonly assignees: ReadonlyArray<{
          readonly __typename: "ExternalProfileNode";
          readonly username?: string | null;
          readonly url?: string | null;
        } | null>;
      }
    | {
        readonly __typename: "LinearIssueNode";
        readonly id: number;
        readonly title: string;
        readonly url: string;
        readonly providerName?: string | null;
        readonly closedAt?: string | null;
        readonly assignees: ReadonlyArray<{
          readonly __typename: "ExternalProfileNode";
          readonly username?: string | null;
          readonly url?: string | null;
        } | null>;
      }
    | {
        readonly __typename: "LinearProjectNode";
        readonly id: number;
        readonly title: string;
        readonly url: string;
        readonly providerName?: string | null;
        readonly closedAt?: string | null;
        readonly lead?: {
          readonly __typename: "ExternalProfileNode";
          readonly username?: string | null;
          readonly url?: string | null;
        } | null;
        readonly assignees: ReadonlyArray<{
          readonly __typename: "ExternalProfileNode";
          readonly username?: string | null;
          readonly url?: string | null;
        } | null>;
      }
    | {
        readonly __typename: "MergeCollectionNode";
        readonly collectionType?: string | null;
        readonly integrationName?: string | null;
        readonly displayId?: string | null;
        readonly created: string;
        readonly status?: InfoTaskStatus | null;
        readonly id: number;
        readonly title: string;
        readonly url: string;
        readonly providerName?: string | null;
        readonly closedAt?: string | null;
        readonly assignees: ReadonlyArray<{
          readonly __typename: "ExternalProfileNode";
          readonly username?: string | null;
          readonly url?: string | null;
        } | null>;
      }
    | {
        readonly __typename: "MergeOpportunityNode";
        readonly integrationName?: string | null;
        readonly displayId?: string | null;
        readonly stage?: string | null;
        readonly amount?: number | null;
        readonly owner?: string | null;
        readonly created: string;
        readonly status?: InfoTaskStatus | null;
        readonly id: number;
        readonly title: string;
        readonly url: string;
        readonly providerName?: string | null;
        readonly closedAt?: string | null;
        readonly assignees: ReadonlyArray<{
          readonly __typename: "ExternalProfileNode";
          readonly username?: string | null;
          readonly url?: string | null;
        } | null>;
      }
    | {
        readonly __typename: "MergeTicketNode";
        readonly integrationName?: string | null;
        readonly displayId?: string | null;
        readonly created: string;
        readonly status?: InfoTaskStatus | null;
        readonly id: number;
        readonly title: string;
        readonly url: string;
        readonly providerName?: string | null;
        readonly closedAt?: string | null;
        readonly assignees: ReadonlyArray<{
          readonly __typename: "ExternalProfileNode";
          readonly username?: string | null;
          readonly url?: string | null;
        } | null>;
      }
    | {
        readonly __typename: "SalesforceOpportunityNode";
        readonly amount?: number | null;
        readonly id: number;
        readonly title: string;
        readonly url: string;
        readonly providerName?: string | null;
        readonly closedAt?: string | null;
        readonly assignees: ReadonlyArray<{
          readonly __typename: "ExternalProfileNode";
          readonly username?: string | null;
          readonly url?: string | null;
        } | null>;
      }
    | {
        readonly __typename: "YouTrackIssueNode";
        readonly id: number;
        readonly title: string;
        readonly url: string;
        readonly providerName?: string | null;
        readonly closedAt?: string | null;
        readonly assignees: ReadonlyArray<{
          readonly __typename: "ExternalProfileNode";
          readonly username?: string | null;
          readonly url?: string | null;
        } | null>;
      }
    | {
        readonly __typename: "YouTrackProjectNode";
        readonly id: number;
        readonly title: string;
        readonly url: string;
        readonly providerName?: string | null;
        readonly closedAt?: string | null;
        readonly leader?: {
          readonly __typename: "ExternalProfileNode";
          readonly username?: string | null;
          readonly url?: string | null;
        } | null;
        readonly assignees: ReadonlyArray<{
          readonly __typename: "ExternalProfileNode";
          readonly username?: string | null;
          readonly url?: string | null;
        } | null>;
      };
};

export type PrepareFileUploadMutationMutationVariables = Exact<{
  filename: Scalars["String"]["input"];
  contentType: Scalars["String"]["input"];
  topicId?: InputMaybe<Scalars["Int"]["input"]>;
  artifactId?: InputMaybe<Scalars["Int"]["input"]>;
  recognitionCoreValueId?: InputMaybe<Scalars["Int"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type PrepareFileUploadMutationMutation = {
  readonly __typename: "Mutation";
  readonly prepareFileUpload?: {
    readonly __typename: "PrepareFileUploadMutation";
    readonly fileUploadUrl?: string | null;
    readonly fileViewingUrl?: string | null;
  } | null;
};

export type GetCachedMeetingGroupSuggestionsQueryQueryVariables = Exact<{
  meetingGroupId: Scalars["Int"]["input"];
  flowId?: InputMaybe<Scalars["Int"]["input"]>;
  hasMeeting: Scalars["Boolean"]["input"];
  participantSearch?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetCachedMeetingGroupSuggestionsQueryQuery = {
  readonly __typename: "Query";
  readonly meetingGroup?: {
    readonly __typename: "MeetingGroupNode";
    readonly id: number;
    readonly facilitator?: {
      readonly __typename: "UserNode";
      readonly id: number;
      readonly name: string;
      readonly firstName: string;
      readonly lastName: string;
      readonly avatar?: string | null;
    } | null;
    readonly participants: {
      readonly __typename: "MeetingParticipantConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "MeetingParticipantEdge";
        readonly node?: {
          readonly __typename: "MeetingParticipantNode";
          readonly id?: string | null;
          readonly user?: {
            readonly __typename: "BasicUserNode";
            readonly id: number;
            readonly name: string;
            readonly firstName: string;
            readonly lastName: string;
            readonly avatar?: string | null;
          } | null;
        } | null;
      } | null>;
    };
  } | null;
};

export type GetCachedMeetingSuggestionsQueryQueryVariables = Exact<{
  meetingId?: InputMaybe<Scalars["Int"]["input"]>;
  participantSearch?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetCachedMeetingSuggestionsQueryQuery = {
  readonly __typename: "Query";
  readonly meeting?: {
    readonly __typename: "MeetingNode";
    readonly id: number;
    readonly participants?: {
      readonly __typename: "MeetingParticipantConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "MeetingParticipantEdge";
        readonly node?: {
          readonly __typename: "MeetingParticipantNode";
          readonly id?: string | null;
          readonly status?: AttendeeStatus | null;
          readonly participantEmail?: string | null;
          readonly role?: AttendeeRole | null;
          readonly user?: {
            readonly __typename: "BasicUserNode";
            readonly id: number;
            readonly name: string;
            readonly firstName: string;
            readonly lastName: string;
            readonly avatar?: string | null;
            readonly email: string;
            readonly status?: UserStatus | null;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type SearchAtMentionsQueryQueryVariables = Exact<{
  limit: Scalars["Int"]["input"];
  search: Scalars["String"]["input"];
  onlyUsers: Scalars["Boolean"]["input"];
}>;

export type SearchAtMentionsQueryQuery = {
  readonly __typename: "Query";
  readonly users: {
    readonly __typename: "UserNodeConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "UserNodeEdge";
      readonly node?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      } | null;
    } | null>;
  };
  readonly artifacts?: {
    readonly __typename: "ArtifactConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "ArtifactEdge";
      readonly node?:
        | {
            readonly __typename: "ActionItemArtifactNode";
            readonly isComplete?: boolean | null;
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
            readonly assignee?: {
              readonly __typename: "UserNode";
              readonly id: number;
            } | null;
          }
        | {
            readonly __typename: "AsanaTaskArtifactNode";
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
          }
        | {
            readonly __typename: "DecisionArtifactNode";
            readonly decision: string;
            readonly decisionState?: DecisionState | null;
            readonly isDraft?: boolean | null;
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
          }
        | {
            readonly __typename: "DocumentArtifactNode";
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
          }
        | {
            readonly __typename: "FeedbackArtifactNode";
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
          }
        | {
            readonly __typename: "GithubIssuesArtifactNode";
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
          }
        | {
            readonly __typename: "GoalArtifactNode";
            readonly progress: number;
            readonly goalVisibility: GoalVisibility;
            readonly scope: GoalScope;
            readonly state: GoalState;
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
          }
        | {
            readonly __typename: "KPIArtifactNode";
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
          }
        | {
            readonly __typename: "RatingArtifactNode";
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
          }
        | {
            readonly __typename: "RecognitionArtifactNode";
            readonly id: number;
            readonly title?: string | null;
            readonly artifactType: ArtifactType;
          }
        | null;
    } | null>;
  } | null;
};

type ArtifactAssigneeFragment_ActionItemArtifactNode_Fragment = {
  readonly __typename: "ActionItemArtifactNode";
  readonly id: number;
  readonly artifactType: ArtifactType;
  readonly assignee?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
};

type ArtifactAssigneeFragment_AsanaTaskArtifactNode_Fragment = {
  readonly __typename: "AsanaTaskArtifactNode";
  readonly id: number;
  readonly artifactType: ArtifactType;
};

type ArtifactAssigneeFragment_DecisionArtifactNode_Fragment = {
  readonly __typename: "DecisionArtifactNode";
  readonly id: number;
  readonly artifactType: ArtifactType;
};

type ArtifactAssigneeFragment_DocumentArtifactNode_Fragment = {
  readonly __typename: "DocumentArtifactNode";
  readonly id: number;
  readonly artifactType: ArtifactType;
};

type ArtifactAssigneeFragment_FeedbackArtifactNode_Fragment = {
  readonly __typename: "FeedbackArtifactNode";
  readonly id: number;
  readonly artifactType: ArtifactType;
};

type ArtifactAssigneeFragment_GithubIssuesArtifactNode_Fragment = {
  readonly __typename: "GithubIssuesArtifactNode";
  readonly id: number;
  readonly artifactType: ArtifactType;
};

type ArtifactAssigneeFragment_GoalArtifactNode_Fragment = {
  readonly __typename: "GoalArtifactNode";
  readonly id: number;
  readonly artifactType: ArtifactType;
};

type ArtifactAssigneeFragment_KpiArtifactNode_Fragment = {
  readonly __typename: "KPIArtifactNode";
  readonly id: number;
  readonly artifactType: ArtifactType;
};

type ArtifactAssigneeFragment_RatingArtifactNode_Fragment = {
  readonly __typename: "RatingArtifactNode";
  readonly id: number;
  readonly artifactType: ArtifactType;
};

type ArtifactAssigneeFragment_RecognitionArtifactNode_Fragment = {
  readonly __typename: "RecognitionArtifactNode";
  readonly id: number;
  readonly artifactType: ArtifactType;
};

export type ArtifactAssigneeFragmentFragment =
  | ArtifactAssigneeFragment_ActionItemArtifactNode_Fragment
  | ArtifactAssigneeFragment_AsanaTaskArtifactNode_Fragment
  | ArtifactAssigneeFragment_DecisionArtifactNode_Fragment
  | ArtifactAssigneeFragment_DocumentArtifactNode_Fragment
  | ArtifactAssigneeFragment_FeedbackArtifactNode_Fragment
  | ArtifactAssigneeFragment_GithubIssuesArtifactNode_Fragment
  | ArtifactAssigneeFragment_GoalArtifactNode_Fragment
  | ArtifactAssigneeFragment_KpiArtifactNode_Fragment
  | ArtifactAssigneeFragment_RatingArtifactNode_Fragment
  | ArtifactAssigneeFragment_RecognitionArtifactNode_Fragment;

type ArtifactMentionFragment_ActionItemArtifactNode_Fragment = {
  readonly __typename: "ActionItemArtifactNode";
  readonly isComplete?: boolean | null;
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
  readonly assignee?: {
    readonly __typename: "UserNode";
    readonly id: number;
  } | null;
};

type ArtifactMentionFragment_AsanaTaskArtifactNode_Fragment = {
  readonly __typename: "AsanaTaskArtifactNode";
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
};

type ArtifactMentionFragment_DecisionArtifactNode_Fragment = {
  readonly __typename: "DecisionArtifactNode";
  readonly decision: string;
  readonly decisionState?: DecisionState | null;
  readonly isDraft?: boolean | null;
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
};

type ArtifactMentionFragment_DocumentArtifactNode_Fragment = {
  readonly __typename: "DocumentArtifactNode";
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
};

type ArtifactMentionFragment_FeedbackArtifactNode_Fragment = {
  readonly __typename: "FeedbackArtifactNode";
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
};

type ArtifactMentionFragment_GithubIssuesArtifactNode_Fragment = {
  readonly __typename: "GithubIssuesArtifactNode";
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
};

type ArtifactMentionFragment_GoalArtifactNode_Fragment = {
  readonly __typename: "GoalArtifactNode";
  readonly progress: number;
  readonly goalVisibility: GoalVisibility;
  readonly scope: GoalScope;
  readonly state: GoalState;
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
};

type ArtifactMentionFragment_KpiArtifactNode_Fragment = {
  readonly __typename: "KPIArtifactNode";
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
};

type ArtifactMentionFragment_RatingArtifactNode_Fragment = {
  readonly __typename: "RatingArtifactNode";
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
};

type ArtifactMentionFragment_RecognitionArtifactNode_Fragment = {
  readonly __typename: "RecognitionArtifactNode";
  readonly id: number;
  readonly title?: string | null;
  readonly artifactType: ArtifactType;
};

export type ArtifactMentionFragmentFragment =
  | ArtifactMentionFragment_ActionItemArtifactNode_Fragment
  | ArtifactMentionFragment_AsanaTaskArtifactNode_Fragment
  | ArtifactMentionFragment_DecisionArtifactNode_Fragment
  | ArtifactMentionFragment_DocumentArtifactNode_Fragment
  | ArtifactMentionFragment_FeedbackArtifactNode_Fragment
  | ArtifactMentionFragment_GithubIssuesArtifactNode_Fragment
  | ArtifactMentionFragment_GoalArtifactNode_Fragment
  | ArtifactMentionFragment_KpiArtifactNode_Fragment
  | ArtifactMentionFragment_RatingArtifactNode_Fragment
  | ArtifactMentionFragment_RecognitionArtifactNode_Fragment;

export type CommonFeedbackArtifactFragmentFragment = {
  readonly __typename: "FeedbackArtifactNode";
  readonly id: number;
  readonly artifactType: ArtifactType;
  readonly title?: string | null;
  readonly recipientsCanView: boolean;
  readonly recipientsManagersCanView: boolean;
  readonly adminsCanView: boolean;
  readonly creatorCanView: boolean;
  readonly feedbackState: FeedbackState;
  readonly message?: any | null;
  readonly created: string;
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
  readonly feedbackRecipients: {
    readonly __typename: "UserNodeConnection";
    readonly totalCount: number;
    readonly edges: ReadonlyArray<{
      readonly __typename: "UserNodeEdge";
      readonly node?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly avatar?: string | null;
        readonly name: string;
      } | null;
    } | null>;
  };
  readonly sender: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly avatar?: string | null;
    readonly name: string;
  };
};

export type CommonGoalArtifactFragmentFragment = {
  readonly __typename: "GoalArtifactNode";
  readonly id: number;
  readonly artifactType: ArtifactType;
  readonly startValue: number;
  readonly currentValue: number;
  readonly targetValue: number;
  readonly progress: number;
  readonly progressType: GoalProgressType;
  readonly dueDate?: string | null;
  readonly startDate?: string | null;
  readonly state: GoalState;
  readonly status: GoalStatus;
  readonly scope: GoalScope;
  readonly goalVisibility: GoalVisibility;
  readonly created: string;
  readonly parentGoalId?: number | null;
  readonly ownerCount?: number | null;
  readonly contributorCount?: number | null;
  readonly isStale: boolean;
  readonly title?: string | null;
  readonly updated?: string | null;
  readonly firstOwner?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly avatar?: string | null;
    readonly name: string;
  } | null;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canRead: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
};

export type CommonRecognitionArtifactFragmentFragment = {
  readonly __typename: "RecognitionArtifactNode";
  readonly id: number;
  readonly artifactType: ArtifactType;
  readonly title?: string | null;
  readonly created: string;
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
  } | null;
  readonly recipients?: {
    readonly __typename: "UserNodeConnection";
    readonly totalCount: number;
    readonly edges: ReadonlyArray<{
      readonly __typename: "UserNodeEdge";
      readonly node?: {
        readonly __typename: "UserNode";
        readonly id: number;
        readonly name: string;
        readonly avatar?: string | null;
      } | null;
    } | null>;
  } | null;
  readonly recognitionCoreValue?: {
    readonly __typename: "RecognitionCoreValueNode";
    readonly id: number;
    readonly title: string;
    readonly description: string;
    readonly emoji?: string | null;
    readonly image?: string | null;
  } | null;
};

export type TopicDataFragmentFragment = {
  readonly __typename: "TopicNode";
  readonly id: number;
  readonly title: string;
  readonly description?: string | null;
  readonly discussionNotes?: any | null;
  readonly includesSharedNotes: boolean;
  readonly created: string;
  readonly state?: TopicState | null;
  readonly eventChannelName?: string | null;
  readonly isMandatory: boolean;
  readonly creator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
  } | null;
  readonly assignee?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly avatar?: string | null;
    readonly name: string;
  } | null;
  readonly canDelete: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly canUpdate: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  };
  readonly previousTopic?: {
    readonly __typename: "TopicNode";
    readonly id: number;
    readonly discussionNotes?: any | null;
  } | null;
};

export type GetUserQueryQueryVariables = Exact<{
  userId: Scalars["Int"]["input"];
}>;

export type GetUserQueryQuery = {
  readonly __typename: "Query";
  readonly user?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly firstName: string;
    readonly email: string;
    readonly avatar?: string | null;
  } | null;
};

export type KeyResultFragmentFragment = {
  readonly __typename: "KeyResultNode";
  readonly id: number;
  readonly title: string;
  readonly startValue: number;
  readonly currentValue: number;
  readonly targetValue: number;
  readonly progressType: GoalProgressType;
  readonly kpi?: {
    readonly __typename: "KPINode";
    readonly id: number;
    readonly title: string;
    readonly currentMeasurement?: {
      readonly __typename: "KPIMeasurementNode";
      readonly id: number;
      readonly measurement: number;
    } | null;
  } | null;
  readonly canUpdate?: {
    readonly __typename: "PermissionNode";
    readonly permission: boolean;
  } | null;
  readonly assignee?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly avatar?: string | null;
    readonly email: string;
  } | null;
};

export type MeetingGroupParticipantsFragmentFragment = {
  readonly __typename: "MeetingGroupNode";
  readonly facilitator?: {
    readonly __typename: "UserNode";
    readonly id: number;
    readonly name: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly avatar?: string | null;
  } | null;
  readonly participants: {
    readonly __typename: "MeetingParticipantConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "MeetingParticipantEdge";
      readonly node?: {
        readonly __typename: "MeetingParticipantNode";
        readonly id?: string | null;
        readonly user?: {
          readonly __typename: "BasicUserNode";
          readonly id: number;
          readonly name: string;
          readonly firstName: string;
          readonly lastName: string;
          readonly avatar?: string | null;
        } | null;
      } | null;
    } | null>;
  };
};

export type MeetingTranscriptFragmentFragment = {
  readonly __typename: "MeetingNode";
  readonly hasTranscript?: boolean | null;
  readonly notesSummary?: string | null;
  readonly transcript?: {
    readonly __typename: "MeetingTranscriptNode";
    readonly id: number;
    readonly summary?: string | null;
    readonly longSummary?: string | null;
    readonly highlights?: string | null;
    readonly videoRecording?: string | null;
    readonly recallVideoRecording?: string | null;
    readonly canSaveVideoRecording?: boolean | null;
    readonly videoRecordingAvailableUntil?: string | null;
    readonly orderedTranscriptData?: ReadonlyArray<{
      readonly __typename: "MeetingTranscriptMessageNode";
      readonly text: string;
      readonly speaker?: string | null;
      readonly created?: number | null;
      readonly startTimestamp?: number | null;
      readonly messageId?: string | null;
    } | null> | null;
    readonly highlightList?: {
      readonly __typename: "TranscriptHighlightConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "TranscriptHighlightEdge";
        readonly node?: {
          readonly __typename: "TranscriptHighlightNode";
          readonly id?: string | null;
          readonly highlight?: string | null;
        } | null;
      } | null>;
    } | null;
    readonly highlightCategories?: {
      readonly __typename: "TranscriptHighlightCategoryConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "TranscriptHighlightCategoryEdge";
        readonly node?: {
          readonly __typename: "TranscriptHighlightCategoryNode";
          readonly id?: string | null;
          readonly categoryTitle?: string | null;
          readonly highlights?: {
            readonly __typename: "TranscriptHighlightConnection";
            readonly edges: ReadonlyArray<{
              readonly __typename: "TranscriptHighlightEdge";
              readonly node?: {
                readonly __typename: "TranscriptHighlightNode";
                readonly id?: string | null;
                readonly highlight?: string | null;
              } | null;
            } | null>;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type UserMentionFragmentFragment = {
  readonly __typename: "UserNode";
  readonly id: number;
  readonly name: string;
  readonly avatar?: string | null;
};
